// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"yVOyt":[function(require,module,exports,__globalThis) {
require("e2f3df1d3120631").register(require("9cf9c3bbd7fbbcd9").getBundleURL('h7kXA'), JSON.parse("[\"h7kXA\",\"index.497a8f84.js\",\"aUU8f\",\"html2canvas.c8cced58.js\",\"1MiJN\",\"purify.56e69fe7.js\",\"hQYtH\",\"index.es.079da136.js\",\"aB0MP\",\"index.82b30b53.css\"]"));

},{"e2f3df1d3120631":"fyJL2","9cf9c3bbd7fbbcd9":"c7Tr5"}],"fyJL2":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"g0GKl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _globalsCss = require("./globals.css");
var _styleguideCss = require("./styleguide.css");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
(0, _reactDomDefault.default).render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {}), document.getElementById("app"));

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","./globals.css":"fK2YX","./styleguide.css":"8Y7Ec","./App":"er1Lr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"b8T3j":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"fK2YX":[function() {},{}],"8Y7Ec":[function() {},{}],"er1Lr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _appCss = require("./App.css");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _connexion = require("./components/Connexion");
var _connexionDefault = parcelHelpers.interopDefault(_connexion);
var _informationalModel = require("./components/InformationalModel");
var _informationalModelDefault = parcelHelpers.interopDefault(_informationalModel);
var _home = require("./components/Home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _functionalView1 = require("./components/FunctionalView1");
var _functionalView1Default = parcelHelpers.interopDefault(_functionalView1);
var _aquisition = require("./components/Aquisition");
var _aquisitionDefault = parcelHelpers.interopDefault(_aquisition);
var _physicalModel1 = require("./components/PhysicalModel1");
var _physicalModel1Default = parcelHelpers.interopDefault(_physicalModel1);
var _existingCase = require("./components/ExistingCase");
var _existingCaseDefault = parcelHelpers.interopDefault(_existingCase);
var _decisionalModel1 = require("./components/DecisionalModel1");
var _decisionalModel1Default = parcelHelpers.interopDefault(_decisionalModel1);
var _processView1 = require("./components/ProcessView1");
var _processView1Default = parcelHelpers.interopDefault(_processView1);
var _informationalModel1 = require("./components/InformationalModel1");
var _informationalModel1Default = parcelHelpers.interopDefault(_informationalModel1);
var _environmental1 = require("./components/Environmental1");
var _environmental1Default = parcelHelpers.interopDefault(_environmental1);
var _measuringForm = require("./components/MeasuringForm");
var _measuringFormDefault = parcelHelpers.interopDefault(_measuringForm);
var _leanVSM1 = require("./components/LeanVSM1");
var _leanVSM1Default = parcelHelpers.interopDefault(_leanVSM1);
var _x5S1 = require("./components/X5S1");
var _x5S1Default = parcelHelpers.interopDefault(_x5S1);
var _analysis = require("./components/Analysis");
var _analysisDefault = parcelHelpers.interopDefault(_analysis);
var _visualManagement1 = require("./components/VisualManagement1");
var _visualManagement1Default = parcelHelpers.interopDefault(_visualManagement1);
var _functionalView = require("./components/FunctionalView");
var _functionalViewDefault = parcelHelpers.interopDefault(_functionalView);
var _objectives = require("./components/Objectives");
var _objectivesDefault = parcelHelpers.interopDefault(_objectives);
var _physicalModel = require("./components/PhysicalModel");
var _physicalModelDefault = parcelHelpers.interopDefault(_physicalModel);
var _decisionalModel = require("./components/DecisionalModel");
var _decisionalModelDefault = parcelHelpers.interopDefault(_decisionalModel);
var _processView = require("./components/ProcessView");
var _processViewDefault = parcelHelpers.interopDefault(_processView);
var _smed2 = require("./components/SMED2");
var _smed2Default = parcelHelpers.interopDefault(_smed2);
var _smed3 = require("./components/SMED3");
var _smed3Default = parcelHelpers.interopDefault(_smed3);
var _visualManagement2 = require("./components/VisualManagement2");
var _visualManagement2Default = parcelHelpers.interopDefault(_visualManagement2);
var _kaizen3 = require("./components/Kaizen3");
var _kaizen3Default = parcelHelpers.interopDefault(_kaizen3);
var _visualManagement3 = require("./components/VisualManagement3");
var _visualManagement3Default = parcelHelpers.interopDefault(_visualManagement3);
var _curPerformances = require("./components/CurPerformances");
var _curPerformancesDefault = parcelHelpers.interopDefault(_curPerformances);
var _inscription = require("./components/Inscription");
var _inscriptionDefault = parcelHelpers.interopDefault(_inscription);
var _clientConsommateur2 = require("./components/ClientConsommateur2");
var _clientConsommateur2Default = parcelHelpers.interopDefault(_clientConsommateur2);
var _social1 = require("./components/Social1");
var _social1Default = parcelHelpers.interopDefault(_social1);
var _modernization1 = require("./components/Modernization1");
var _modernization1Default = parcelHelpers.interopDefault(_modernization1);
var _clientConsommateur1 = require("./components/ClientConsommateur1");
var _clientConsommateur1Default = parcelHelpers.interopDefault(_clientConsommateur1);
var _leadTime1 = require("./components/LeadTime1");
var _leadTime1Default = parcelHelpers.interopDefault(_leadTime1);
var _cost1 = require("./components/Cost1");
var _cost1Default = parcelHelpers.interopDefault(_cost1);
var _quality1 = require("./components/Quality1");
var _quality1Default = parcelHelpers.interopDefault(_quality1);
var _quality7 = require("./components/Quality7");
var _quality7Default = parcelHelpers.interopDefault(_quality7);
var _environmental2 = require("./components/Environmental2");
var _environmental2Default = parcelHelpers.interopDefault(_environmental2);
var _environmental3 = require("./components/Environmental3");
var _environmental3Default = parcelHelpers.interopDefault(_environmental3);
var _social2 = require("./components/Social2");
var _social2Default = parcelHelpers.interopDefault(_social2);
var _modernization2 = require("./components/Modernization2");
var _modernization2Default = parcelHelpers.interopDefault(_modernization2);
var _cost2 = require("./components/Cost2");
var _cost2Default = parcelHelpers.interopDefault(_cost2);
var _leadTime2 = require("./components/LeadTime2");
var _leadTime2Default = parcelHelpers.interopDefault(_leadTime2);
var _quality6 = require("./components/Quality6");
var _quality6Default = parcelHelpers.interopDefault(_quality6);
var _informationalModel3 = require("./components/InformationalModel3");
var _informationalModel3Default = parcelHelpers.interopDefault(_informationalModel3);
var _informationalModel2 = require("./components/InformationalModel2");
var _informationalModel2Default = parcelHelpers.interopDefault(_informationalModel2);
var _processView2 = require("./components/ProcessView2");
var _processView2Default = parcelHelpers.interopDefault(_processView2);
var _quality2 = require("./components/Quality2");
var _quality2Default = parcelHelpers.interopDefault(_quality2);
var _processView3 = require("./components/ProcessView3");
var _processView3Default = parcelHelpers.interopDefault(_processView3);
var _decisionalView2 = require("./components/DecisionalView2");
var _decisionalView2Default = parcelHelpers.interopDefault(_decisionalView2);
var _physicalModel2 = require("./components/PhysicalModel2");
var _physicalModel2Default = parcelHelpers.interopDefault(_physicalModel2);
var _decisionalView3 = require("./components/DecisionalView3");
var _decisionalView3Default = parcelHelpers.interopDefault(_decisionalView3);
var _quality5 = require("./components/Quality5");
var _quality5Default = parcelHelpers.interopDefault(_quality5);
var _physicalModel3 = require("./components/PhysicalModel3");
var _physicalModel3Default = parcelHelpers.interopDefault(_physicalModel3);
var _functionnalView2 = require("./components/FunctionnalView2");
var _functionnalView2Default = parcelHelpers.interopDefault(_functionnalView2);
var _functionnalView3 = require("./components/FunctionnalView3");
var _functionnalView3Default = parcelHelpers.interopDefault(_functionnalView3);
var _functionnalView4 = require("./components/FunctionnalView4");
var _functionnalView4Default = parcelHelpers.interopDefault(_functionnalView4);
var _loadingPage = require("./components/LoadingPage");
var _loadingPageDefault = parcelHelpers.interopDefault(_loadingPage);
var _kaizen1 = require("./components/Kaizen1");
var _kaizen1Default = parcelHelpers.interopDefault(_kaizen1);
var _existingSystems = require("./components/ExistingSystems");
var _existingSystemsDefault = parcelHelpers.interopDefault(_existingSystems);
var _kanban1 = require("./components/Kanban1");
var _kanban1Default = parcelHelpers.interopDefault(_kanban1);
var _leanVSM = require("./components/LeanVSM");
var _leanVSMDefault = parcelHelpers.interopDefault(_leanVSM);
var _smed1 = require("./components/SMED1");
var _smed1Default = parcelHelpers.interopDefault(_smed1);
var _x5S = require("./components/X5S");
var _x5SDefault = parcelHelpers.interopDefault(_x5S);
var _kaizen12 = require("./components/Kaizen12");
var _kaizen12Default = parcelHelpers.interopDefault(_kaizen12);
var _quality4 = require("./components/Quality4");
var _quality4Default = parcelHelpers.interopDefault(_quality4);
var _kaizen = require("./components/Kaizen");
var _kaizenDefault = parcelHelpers.interopDefault(_kaizen);
var _smed = require("./components/SMED");
var _smedDefault = parcelHelpers.interopDefault(_smed);
var _visualManagement = require("./components/VisualManagement");
var _visualManagementDefault = parcelHelpers.interopDefault(_visualManagement);
var _kanban = require("./components/Kanban");
var _kanbanDefault = parcelHelpers.interopDefault(_kanban);
var _kaizen2 = require("./components/Kaizen2");
var _kaizen2Default = parcelHelpers.interopDefault(_kaizen2);
var _kanban3 = require("./components/Kanban3");
var _kanban3Default = parcelHelpers.interopDefault(_kanban3);
var _mesureDePerformancesFutures = require("./components/MesureDePerformancesFutures");
var _mesureDePerformancesFuturesDefault = parcelHelpers.interopDefault(_mesureDePerformancesFutures);
var _x5S2 = require("./components/X5s2");
var _x5S2Default = parcelHelpers.interopDefault(_x5S2);
var _kanban2 = require("./components/Kanban2");
var _kanban2Default = parcelHelpers.interopDefault(_kanban2);
var _x5S3 = require("./components/X5s3");
var _x5S3Default = parcelHelpers.interopDefault(_x5S3);
var _leanVSM3 = require("./components/LeanVSM3");
var _leanVSM3Default = parcelHelpers.interopDefault(_leanVSM3);
var _leanVSM2 = require("./components/LeanVSM2");
var _leanVSM2Default = parcelHelpers.interopDefault(_leanVSM2);
var _kaizen11 = require("./components/Kaizen11");
var _kaizen11Default = parcelHelpers.interopDefault(_kaizen11);
var _quality3 = require("./components/Quality3");
var _quality3Default = parcelHelpers.interopDefault(_quality3);
var _leanVSM4 = require("./components/LeanVSM4");
var _leanVSM4Default = parcelHelpers.interopDefault(_leanVSM4);
var _mesureDePerformancesFutures1 = require("./components/MesureDePerformancesFutures1");
var _mesureDePerformancesFutures1Default = parcelHelpers.interopDefault(_mesureDePerformancesFutures1);
var _existingSystems2 = require("./components/ExistingSystems2");
var _existingSystems2Default = parcelHelpers.interopDefault(_existingSystems2);
var _environmental5 = require("./components/Environmental5");
var _environmental5Default = parcelHelpers.interopDefault(_environmental5);
var _social3 = require("./components/Social3");
var _social3Default = parcelHelpers.interopDefault(_social3);
var _environmental4 = require("./components/Environmental4");
var _environmental4Default = parcelHelpers.interopDefault(_environmental4);
var _modernization3 = require("./components/Modernization3");
var _modernization3Default = parcelHelpers.interopDefault(_modernization3);
var _social4 = require("./components/Social4");
var _social4Default = parcelHelpers.interopDefault(_social4);
var _social6 = require("./components/Social6");
var _social6Default = parcelHelpers.interopDefault(_social6);
var _social5 = require("./components/Social5");
var _social5Default = parcelHelpers.interopDefault(_social5);
var _modernization4 = require("./components/Modernization4");
var _modernization4Default = parcelHelpers.interopDefault(_modernization4);
var _quality8 = require("./components/Quality8");
var _quality8Default = parcelHelpers.interopDefault(_quality8);
var _clientConsommateur3 = require("./components/ClientConsommateur3");
var _clientConsommateur3Default = parcelHelpers.interopDefault(_clientConsommateur3);
var _references = require("./components/References");
var _referencesDefault = parcelHelpers.interopDefault(_references);
var _curPerformance = require("./components/CurPerformance");
var _curPerformanceDefault = parcelHelpers.interopDefault(_curPerformance);
var _leadTime = require("./components/LeadTime");
var _leadTimeDefault = parcelHelpers.interopDefault(_leadTime);
var _cost = require("./components/Cost");
var _costDefault = parcelHelpers.interopDefault(_cost);
var _modernization = require("./components/Modernization");
var _modernizationDefault = parcelHelpers.interopDefault(_modernization);
var _login = require("./components/Login/Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _analysis1 = require("./components/Analysis1/Analysis");
var _analysisDefault1 = parcelHelpers.interopDefault(_analysis1);
function App() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/:path(|login)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/analysis1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analysisDefault1.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/connexion",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connexionDefault.default), {
                        ...connexionData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/informational-model",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _informationalModelDefault.default), {
                        ...informationalModelData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/home",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeDefault.default), {
                        ...homeData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/functional-view-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionalView1Default.default), {
                        ...functionalView1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/aquisition",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aquisitionDefault.default), {
                        ...aquisitionData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/physical-model-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _physicalModel1Default.default), {
                        ...physicalModel1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/existing-case",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _existingCaseDefault.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        existingCase: "Existing Case",
                        frame11622Props: existingCaseData.frame11622Props
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/decisional-model-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decisionalModel1Default.default), {
                        ...decisionalModel1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/process-view-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _processView1Default.default), {
                        ...processView1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/informational-model-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _informationalModel1Default.default), {
                        ...informationalModel1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/environmental-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental1Default.default), {
                        ...environmental1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/measuring-form",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measuringFormDefault.default), {
                        ...measuringFormData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lean-vsm-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM1Default.default), {
                        ...leanVSM1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/5s-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5S1Default.default), {
                        ...x5S1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/analysis",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analysisDefault.default), {
                        ...analysisData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/visual-management-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagement1Default.default), {
                        ...visualManagement1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/functional-view",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionalViewDefault.default), {
                        ...functionalViewData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/objectives",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _objectivesDefault.default), {
                        ...objectivesData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/physical-model",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _physicalModelDefault.default), {
                        ...physicalModelData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/decisional-model",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decisionalModelDefault.default), {
                        ...decisionalModelData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/process-view",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _processViewDefault.default), {
                        ...processViewData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/smed-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smed2Default.default), {
                        ...sMED2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/smed-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smed3Default.default), {
                        ...sMED3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/visual-management-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagement2Default.default), {
                        ...visualManagement2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kaizen-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen3Default.default), {
                        ...kaizen3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/visual-management-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagement3Default.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                        goOnToTheNextStep: "Go on to the next Step",
                        navItems2Props: visualManagement3Data.navItems2Props,
                        navItems3Props: visualManagement3Data.navItems3Props,
                        toggleProps: visualManagement3Data.toggleProps
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/cur-performances",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _curPerformancesDefault.default), {
                        ...curPerformancesData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/inscription",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inscriptionDefault.default), {
                        ...inscriptionData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/client-consommateur-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur2Default.default), {
                        ...clientConsommateur2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/social-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social1Default.default), {
                        ...social1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/modernization-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization1Default.default), {
                        ...modernization1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/client-consommateur-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur1Default.default), {
                        ...clientConsommateur1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lead-time-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTime1Default.default), {
                        ...leadTime1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/cost-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cost1Default.default), {
                        ...cost1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality1Default.default), {
                        ...quality1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-7",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality7Default.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        clientConsommateur: "Client/Consommateur",
                        navItems3Props: quality7Data.navItems3Props,
                        frame111Props: quality7Data.frame111Props,
                        toggleProps: quality7Data.toggleProps
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/environmental-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental2Default.default), {
                        ...environmental2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/environmental-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental3Default.default), {
                        ...environmental3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/social-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social2Default.default), {
                        ...social2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/modernization-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization2Default.default), {
                        ...modernization2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/cost-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cost2Default.default), {
                        ...cost2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lead-time-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTime2Default.default), {
                        ...leadTime2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-6",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality6Default.default), {
                        ...quality6Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/informational-model-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _informationalModel3Default.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                        navItems2Props: informationalModel3Data.navItems2Props,
                        navItems3Props: informationalModel3Data.navItems3Props,
                        toggleProps: informationalModel3Data.toggleProps
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/informational-model-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _informationalModel2Default.default), {
                        ...informationalModel2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/process-view-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _processView2Default.default), {
                        ...processView2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality2Default.default), {
                        ...quality2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/process-view-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _processView3Default.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                        informationalModel: "Informational Model",
                        navItems2Props: processView3Data.navItems2Props,
                        navItems3Props: processView3Data.navItems3Props,
                        toggleProps: processView3Data.toggleProps
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/decisional-view-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decisionalView2Default.default), {
                        ...decisionalView2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/physical-model-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _physicalModel2Default.default), {
                        ...physicalModel2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/decisional-view-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _decisionalView3Default.default), {
                        ...decisionalView3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-5",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality5Default.default), {
                        ...quality5Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/physical-model-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _physicalModel3Default.default), {
                        ...physicalModel3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/functionnal-view-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionnalView2Default.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                        navItems2Props: functionnalView2Data.navItems2Props,
                        navItems3Props: functionnalView2Data.navItems3Props,
                        frame922Props: functionnalView2Data.frame922Props,
                        frame93Props: functionnalView2Data.frame93Props,
                        toggleProps: functionnalView2Data.toggleProps
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/functionnal-view-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionnalView3Default.default), {
                        ...functionnalView3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/functionnal-view-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionnalView4Default.default), {
                        ...functionnalView4Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/loading-page",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingPageDefault.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        inViewOfTheAnswe: "IN VIEW OF THE ANSWERS TO THE PREVIOUS QUESTIONNAIRES, WE PROPOSE TO MAKE THE FOLLOWING MODELS",
                        navItems3Props: loadingPageData.navItems3Props,
                        frame112Props: loadingPageData.frame112Props
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kaizen-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen1Default.default), {
                        ...kaizen1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/existing-systems-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _existingSystemsDefault.default), {
                        ...existingSystemsData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kanban-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanban1Default.default), {
                        ...kanban1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lean-vsm",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSMDefault.default), {
                        ...leanVSMData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/smed-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smed1Default.default), {
                        ...sMED1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/5s",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5SDefault.default), {
                        ...x5SData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kaizen1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen12Default.default), {
                        ...kaizen12Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality4Default.default), {
                        ...quality4Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kaizen",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizenDefault.default), {
                        ...kaizenData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/smed",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smedDefault.default), {
                        ...sMEDData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/visual-management",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visualManagementDefault.default), {
                        ...visualManagementData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kanban",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanbanDefault.default), {
                        ...kanbanData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kaizen-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen2Default.default), {
                        ...kaizen2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kanban-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanban3Default.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
                        kaizen: "Kaizen",
                        navItems3Props: kanban3Data.navItems3Props,
                        frame101Props: kanban3Data.frame101Props,
                        frame102Props: kanban3Data.frame102Props,
                        toggleProps: kanban3Data.toggleProps
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/mesure-de-performances-futures",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mesureDePerformancesFuturesDefault.default), {
                        ...mesureDePerformancesFuturesData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/5s-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5S2Default.default), {
                        ...x5s2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kanban-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kanban2Default.default), {
                        ...kanban2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/5s-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _x5S3Default.default), {
                        ...x5s3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lean-vsm-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM3Default.default), {
                        ...leanVSM3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lean-vsm-2",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM2Default.default), {
                        ...leanVSM2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/kaizen1-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kaizen11Default.default), {
                        ...kaizen11Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality3Default.default), {
                        ...quality3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lean-vsm-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leanVSM4Default.default), {
                        ...leanVSM4Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/mesure-de-performances-futures-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mesureDePerformancesFutures1Default.default), {
                        ...mesureDePerformancesFutures1Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/existing-systems",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _existingSystems2Default.default), {
                        ...existingSystems2Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/environmental-5",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental5Default.default), {
                        ...environmental5Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/social-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social3Default.default), {
                        ...social3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/environmental-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _environmental4Default.default), {
                        ...environmental4Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/modernization-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization3Default.default), {
                        ...modernization3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/social-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social4Default.default), {
                        ...social4Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/social-6",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social6Default.default), {
                        ...social6Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/social-5",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social5Default.default), {
                        ...social5Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/modernization-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernization4Default.default), {
                        ...modernization4Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/quality-8",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quality8Default.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        navItems3Props: quality8Data.navItems3Props,
                        frame111Props: quality8Data.frame111Props,
                        toggleProps: quality8Data.toggleProps
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/client-consommateur-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientConsommateur3Default.default), {
                        ...clientConsommateur3Data
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/references",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _referencesDefault.default), {
                        ...referencesData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/cur-performance",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _curPerformanceDefault.default), {
                        x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
                        resultPropositions: "Result & Propositions",
                        place: "Back",
                        formalismesEnFonct: "FORMALISMES  EN FONCTION DES PROBL\xc8MES TROUV\xc9S",
                        navItems3Props: curPerformanceData.navItems3Props,
                        frame11332Props: curPerformanceData.frame11332Props
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/lead-time",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leadTimeDefault.default), {
                        ...leadTimeData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/cost",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _costDefault.default), {
                        ...costData
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/modernization",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modernizationDefault.default), {
                        ...modernizationData
                    })
                })
            ]
        })
    });
}
exports.default = App;
const connexionData = {
    polygon3: "/img/polygon-3@2x.png",
    aerialViewContainerCargoShipSea1: "/img/aerial-view-container-cargo-ship-sea-1.png",
    subtract: "/img/subtract.png",
    polygon1: "/img/polygon-1@2x.png",
    polygon2: "/img/polygon-2@2x.png",
    login1: "login",
    login2: "If you din\u2019t have an account",
    frame126: "/img/1200px-logo-icam---20081@2x.png"
};
const frame116221Data = {
    children: "Decisional Model"
};
const frame117221Data = {
    children: "Process view"
};
const frame11361Data = {
    children: "Informational model"
};
const navItems452Data = {
    frame1162Props: frame116221Data,
    frame1172Props: frame117221Data,
    frame1136Props: frame11361Data
};
const tableHeader1Data = {
    children: ""
};
const tableHeader2Data = {
    children: "Company",
    className: "table-header-4"
};
const tableNumberBase41Data = {
    bottomLine: "/img/bottom-line-3@2x.png",
    leftLine: "/img/left-line-3@2x.png",
    rightLine: "/img/right-line-3@2x.png",
    className: ""
};
const tableNumberPrimaryKey21Data = {
    tableNumberBase4Props: tableNumberBase41Data
};
const key3Data = {
    className: "key-2"
};
const tableNumberBase51Data = {
    type: "property1:string",
    bottomLine: "/img/bottom-line-4@2x.png",
    leftLine: "/img/left-line-4@2x.png",
    rightLine: "/img/right-line-4@2x.png",
    className: "",
    keyProps: key3Data
};
const tableTextBase21Data = {
    tableNumberBase5Props: tableNumberBase51Data
};
const key4Data = {
    className: "key-3"
};
const tableNumberBase61Data = {
    bottomLine: "/img/bottom-line-5@2x.png",
    leftLine: "/img/left-line-5@2x.png",
    rightLine: "/img/right-line-5@2x.png",
    className: "",
    keyProps: key4Data
};
const tableNumberBaseNull21Data = {
    tableNumberBase6Props: tableNumberBase61Data
};
const tableTextBaseNull21Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull21Data
};
const crewMember1Data = {
    tableHeaderProps: tableHeader2Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey21Data,
    tableTextBase2Props: tableTextBase21Data,
    tableTextBaseNull2Props: tableTextBaseNull21Data
};
const tableHeader3Data = {
    children: "Insurances",
    className: "table-header-5"
};
const tableNumberBase42Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey22Data = {
    tableNumberBase4Props: tableNumberBase42Data
};
const key5Data = {
    className: "key-4"
};
const tableNumberBase71Data = {
    keyProps: key5Data
};
const tableTextBase31Data = {
    tableNumberBase7Props: tableNumberBase71Data
};
const key6Data = {
    className: "key-5"
};
const tableNumberBase62Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key6Data
};
const tableNumberBaseNull22Data = {
    tableNumberBase6Props: tableNumberBase62Data
};
const tableTextBaseNull22Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull22Data
};
const crewMember21Data = {
    tableHeaderProps: tableHeader3Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey22Data,
    tableTextBase3Props: tableTextBase31Data,
    tableTextBaseNull2Props: tableTextBaseNull22Data
};
const tableHeader4Data = {
    children: "Cars",
    className: "table-header-6"
};
const tableNumberBase43Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey23Data = {
    tableNumberBase4Props: tableNumberBase43Data
};
const key7Data = {
    className: "key-6"
};
const tableNumberBase52Data = {
    type: "registrationplate:string",
    bottomLine: "/img/bottom-line-10@2x.png",
    leftLine: "/img/left-line-10@2x.png",
    rightLine: "/img/right-line-10@2x.png",
    className: "table-number-base-10",
    keyProps: key7Data
};
const tableTextBase22Data = {
    className: "table-text-base-4",
    tableNumberBase5Props: tableNumberBase52Data
};
const key8Data = {
    className: "key-7"
};
const tableNumberBase81Data = {
    keyProps: key8Data
};
const tableNumberBaseNull31Data = {
    tableNumberBase8Props: tableNumberBase81Data
};
const tableTextBaseNull31Data = {
    tableNumberBaseNull3Props: tableNumberBaseNull31Data
};
const crewMember31Data = {
    tableHeaderProps: tableHeader4Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey23Data,
    tableTextBase2Props: tableTextBase22Data,
    tableTextBaseNull3Props: tableTextBaseNull31Data
};
const tableHeader5Data = {
    children: "Employees",
    className: "table-header-7"
};
const tableNumberBase44Data = {
    bottomLine: "/img/bottom-line-12@2x.png",
    leftLine: "/img/left-line-12@2x.png",
    rightLine: "/img/right-line-12@2x.png",
    className: ""
};
const tableNumberPrimaryKey24Data = {
    tableNumberBase4Props: tableNumberBase44Data
};
const key9Data = {
    className: "key-8"
};
const tableNumberBase53Data = {
    type: "name:string",
    bottomLine: "/img/bottom-line-13@2x.png",
    leftLine: "/img/left-line-13@2x.png",
    rightLine: "/img/right-line-13@2x.png",
    className: "table-number-base-8-2",
    keyProps: key9Data
};
const tableTextBase23Data = {
    tableNumberBase5Props: tableNumberBase53Data
};
const key10Data = {
    className: "key-9"
};
const tableNumberBase63Data = {
    bottomLine: "/img/bottom-line-14@2x.png",
    leftLine: "/img/left-line-14@2x.png",
    rightLine: "/img/right-line-14@2x.png",
    className: "",
    keyProps: key10Data
};
const tableNumberBaseNull23Data = {
    tableNumberBase6Props: tableNumberBase63Data
};
const tableTextBaseNull23Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull23Data
};
const crewMember41Data = {
    tableHeaderProps: tableHeader5Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey24Data,
    tableTextBase2Props: tableTextBase23Data,
    tableTextBaseNull2Props: tableTextBaseNull23Data
};
const tableHeader6Data = {
    children: "Bonus",
    className: "table-header"
};
const tableNumberBase45Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey25Data = {
    tableNumberBase4Props: tableNumberBase45Data
};
const key11Data = {
    className: "key-10"
};
const tableNumberBase54Data = {
    type: "amount:int32",
    bottomLine: "/img/bottom-line-1@2x.png",
    leftLine: "/img/left-line-1@2x.png",
    rightLine: "/img/right-line-1@2x.png",
    className: "table-number-base-8",
    keyProps: key11Data
};
const tableTextBase24Data = {
    className: "table-text-base-5",
    tableNumberBase5Props: tableNumberBase54Data
};
const key12Data = {
    className: "key-11"
};
const tableNumberBase64Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key12Data
};
const tableNumberBaseNull24Data = {
    tableNumberBase6Props: tableNumberBase64Data
};
const tableTextBaseNull24Data = {
    className: "table-text-base-null-4",
    tableNumberBaseNull2Props: tableNumberBaseNull24Data
};
const crewMember51Data = {
    tableHeaderProps: tableHeader6Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey25Data,
    tableTextBase2Props: tableTextBase24Data,
    tableTextBaseNull2Props: tableTextBaseNull24Data
};
const informationalModelData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow7: "/img/arrow-1-2@2x.png",
    arrow8: "/img/arrow-2-2@2x.png",
    line31: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    arrow1: "/img/arrow-1-12@2x.png",
    arrow2: "/img/arrow-2-7@2x.png",
    line32: "/img/line-3-2.png",
    arrow5: "/img/arrow-5-5@2x.png",
    arrow6: "/img/arrow-5-5@2x.png",
    modeling: "Modeling",
    nextStep: "Next Step",
    navItems452Props: navItems452Data,
    tableHeaderProps: tableHeader1Data,
    crewMemberProps: crewMember1Data,
    crewMember2Props: crewMember21Data,
    crewMember3Props: crewMember31Data,
    crewMember4Props: crewMember41Data,
    crewMember5Props: crewMember51Data
};
const headerMenuDefault1Data = {
    children: "Get Started ->"
};
const frame117222Data = {
    children: "Existing Case"
};
const frame116222Data = {
    children: "Reference Cases"
};
const frame11Data = {
    src: "/img/unsplash-ym--msbz0ro.png"
};
const frame13Data = {
    src: "/img/unsplash-ym--msbz0ro-2.png",
    className: "frame-6-1"
};
const frame14Data = {
    src: "/img/unsplash-ym--msbz0ro-1.png",
    className: "frame-5-2"
};
const homeData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    takeYourCompanyToTheNextLevel: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Take your",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Company to the",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "next level"
        ]
    }),
    discoverFromDiffer: "Discover from differentes cases the ideal form of your company\u2019s Supply Chain.",
    newCase: "NEW CASE",
    existingCase: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "EXISTING",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " CASE"
        ]
    }),
    referenceCase: "REFERENCE CASE",
    headerMenuDefaultProps: headerMenuDefault1Data,
    frame11722Props: frame117222Data,
    frame11622Props: frame116222Data,
    frame11Props: frame11Data,
    frame12Props: frame13Data,
    frame13Props: frame14Data
};
const frame116223Data = {
    children: "Decisional Model"
};
const frame117223Data = {
    children: "Process view"
};
const frame1181Data = {
    children: "Informational model"
};
const navItems41Data = {
    frame1162Props: frame116223Data,
    frame1172Props: frame117223Data,
    frame118Props: frame1181Data
};
const functionalView1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    aquisition: "Aquisition",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Controllers",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Input",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Resources",
    arrow8: "/img/arrow-8@2x.png",
    label6: "Constrains",
    label7: "Output",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label8: "Resources",
    arrow9: "/img/arrow-9@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    navItems4Props: navItems41Data
};
const frame117224Data = {
    children: "Existing Case"
};
const frame116224Data = {
    children: "Reference Cases"
};
const frame113224Data = {
    className: ""
};
const navItems31Data = {
    frame1172Props: frame117224Data,
    frame1162Props: frame116224Data,
    frame1132Props: frame113224Data
};
const aquisitionData = {
    ellipse116: "/img/polygon-3@2x.png",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    companyName: "Company Name",
    inputType1: "text",
    inputPlaceholder1: "Tap here",
    companySize: "Company Size",
    inputType2: "number",
    inputPlaceholder2: "Tap here",
    activitySector: "Activity sector",
    inputType3: "text",
    inputPlaceholder3: "Tap here",
    measuringForm: "Measuring Form",
    navItems3Props: navItems31Data
};
const frame116225Data = {
    children: "Decisional Model"
};
const frame117225Data = {
    children: "Process view"
};
const frame1182Data = {
    children: "Informational model"
};
const physicalModel1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    aquisition: "Aquisition",
    functionalView: "Functional view",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Cut",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Wood",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Assembling",
    label6: "Tables",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label7: "Machines",
    arrow8: "/img/arrow-8@2x.png",
    label8: "Workers",
    arrow9: "/img/arrow-9@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11622Props: frame116225Data,
    frame11722Props: frame117225Data,
    frame118Props: frame1182Data
};
const frame116226Data = {
    children: "Reference Cases"
};
const existingCaseData = {
    frame11622Props: frame116226Data
};
const frame117226Data = {
    children: "Process view"
};
const frame1183Data = {
    children: "Informational model"
};
const decisionalModel1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    aquisition: "Aquisition",
    functionalView: "Functional view",
    arrow3: "/img/arrow-1@2x.png",
    arrow4: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11722Props: frame117226Data,
    frame118Props: frame1183Data
};
const frame116227Data = {
    children: "Decisional Model"
};
const frame1184Data = {
    children: "Informational model"
};
const processView1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    aquisition: "Aquisition",
    functionalView: "Functional view",
    arrow1: "/img/arrow-1-2@2x.png",
    arrow2: "/img/arrow-2-2@2x.png",
    rectangle7: "/img/rectangle-7@2x.png",
    line3: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnFlexsimB: "CLICK ON \u201CFLEXSIM\u201D BUTTON TO OPEN VMWARE HORIZON",
    overlapGroup1: "/img/rectangle-4@2x.png",
    cut: "Cut",
    label3: "Design",
    rectangle5: "/img/rectangle-5@2x.png",
    manufacturing: "Manufacturing",
    arrow6: "/img/arrow-6-2@2x.png",
    arrow11: "/img/arrow-11@2x.png",
    label4: "Machine",
    arrow8: "/img/arrow-8-2@2x.png",
    label5: "Human",
    arrow9: "/img/arrow-9-2@2x.png",
    flexsim: "Flexsim",
    rectangle6: "/img/rectangle-6@2x.png",
    assembly: "Assembly",
    arrow10: "/img/arrow-10@2x.png",
    xcontinue: "Continue",
    frame11622Props: frame116227Data,
    frame118Props: frame1184Data
};
const frame116228Data = {
    children: "Decisional Model"
};
const frame117227Data = {
    children: "Process view"
};
const frame11362Data = {
    children: "Informational model"
};
const tableHeader7Data = {
    children: ""
};
const tableHeader8Data = {
    children: "Company",
    className: "table-header-1-1"
};
const tableNumberBase46Data = {
    bottomLine: "/img/bottom-line-3@2x.png",
    leftLine: "/img/left-line-3@2x.png",
    rightLine: "/img/right-line-3@2x.png",
    className: "table-number-base-7-1"
};
const tableNumberPrimaryKey26Data = {
    tableNumberBase4Props: tableNumberBase46Data
};
const key15Data = {
    className: "key-14"
};
const tableNumberBase55Data = {
    type: "property1:string",
    bottomLine: "/img/bottom-line-4@2x.png",
    leftLine: "/img/left-line-4@2x.png",
    rightLine: "/img/right-line-4@2x.png",
    className: "table-number-base-9-1",
    keyProps: key15Data
};
const tableTextBase25Data = {
    tableNumberBase5Props: tableNumberBase55Data
};
const key16Data = {
    className: "key-15"
};
const tableNumberBase65Data = {
    bottomLine: "/img/bottom-line-5@2x.png",
    leftLine: "/img/left-line-5@2x.png",
    rightLine: "/img/right-line-5@2x.png",
    className: "table-number-base-13",
    keyProps: key16Data
};
const tableNumberBaseNull25Data = {
    tableNumberBase6Props: tableNumberBase65Data
};
const tableTextBaseNull25Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull25Data
};
const crewMember6Data = {
    tableHeaderProps: tableHeader8Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey26Data,
    tableTextBase2Props: tableTextBase25Data,
    tableTextBaseNull2Props: tableTextBaseNull25Data
};
const tableHeader9Data = {
    children: "Insurances",
    className: "table-header-1-2"
};
const tableNumberBase47Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey27Data = {
    tableNumberBase4Props: tableNumberBase47Data
};
const key17Data = {
    className: "key-16"
};
const tableNumberBase72Data = {
    keyProps: key17Data
};
const tableTextBase32Data = {
    tableNumberBase7Props: tableNumberBase72Data
};
const key18Data = {
    className: "key-17"
};
const tableNumberBase66Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key18Data
};
const tableNumberBaseNull26Data = {
    tableNumberBase6Props: tableNumberBase66Data
};
const tableTextBaseNull26Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull26Data
};
const crewMember22Data = {
    tableHeaderProps: tableHeader9Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey27Data,
    tableTextBase3Props: tableTextBase32Data,
    tableTextBaseNull2Props: tableTextBaseNull26Data
};
const tableHeader10Data = {
    children: "Cars",
    className: "table-header-1-3"
};
const tableNumberBase48Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: "table-number-base-7-2"
};
const tableNumberPrimaryKey28Data = {
    tableNumberBase4Props: tableNumberBase48Data
};
const key19Data = {
    className: "key-18"
};
const tableNumberBase56Data = {
    type: "registrationplate:string",
    bottomLine: "/img/bottom-line-10@2x.png",
    leftLine: "/img/left-line-10@2x.png",
    rightLine: "/img/right-line-10@2x.png",
    className: "table-number-base-11",
    keyProps: key19Data
};
const tableTextBase26Data = {
    className: "table-text-base-6",
    tableNumberBase5Props: tableNumberBase56Data
};
const key20Data = {
    className: "key-19"
};
const tableNumberBase82Data = {
    keyProps: key20Data
};
const tableNumberBaseNull32Data = {
    tableNumberBase8Props: tableNumberBase82Data
};
const tableTextBaseNull32Data = {
    tableNumberBaseNull3Props: tableNumberBaseNull32Data
};
const crewMember32Data = {
    tableHeaderProps: tableHeader10Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey28Data,
    tableTextBase2Props: tableTextBase26Data,
    tableTextBaseNull3Props: tableTextBaseNull32Data
};
const tableHeader11Data = {
    children: "Employees",
    className: "table-header-1-4"
};
const tableNumberBase49Data = {
    bottomLine: "/img/bottom-line-12@2x.png",
    leftLine: "/img/left-line-12@2x.png",
    rightLine: "/img/right-line-12@2x.png",
    className: "table-number-base-7"
};
const tableNumberPrimaryKey29Data = {
    tableNumberBase4Props: tableNumberBase49Data
};
const key21Data = {
    className: "key-20"
};
const tableNumberBase57Data = {
    type: "name:string",
    bottomLine: "/img/bottom-line-13@2x.png",
    leftLine: "/img/left-line-13@2x.png",
    rightLine: "/img/right-line-13@2x.png",
    className: "table-number-base-9-2",
    keyProps: key21Data
};
const tableTextBase27Data = {
    tableNumberBase5Props: tableNumberBase57Data
};
const key22Data = {
    className: "key-21"
};
const tableNumberBase67Data = {
    bottomLine: "/img/bottom-line-14@2x.png",
    leftLine: "/img/left-line-14@2x.png",
    rightLine: "/img/right-line-14@2x.png",
    className: "",
    keyProps: key22Data
};
const tableNumberBaseNull27Data = {
    tableNumberBase6Props: tableNumberBase67Data
};
const tableTextBaseNull27Data = {
    tableNumberBaseNull2Props: tableNumberBaseNull27Data
};
const crewMember42Data = {
    tableHeaderProps: tableHeader11Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey29Data,
    tableTextBase2Props: tableTextBase27Data,
    tableTextBaseNull2Props: tableTextBaseNull27Data
};
const tableHeader12Data = {
    children: "Bonus",
    className: "table-header-1"
};
const tableNumberBase410Data = {
    bottomLine: "/img/bottom-line@2x.png",
    leftLine: "/img/left-line@2x.png",
    rightLine: "/img/right-line@2x.png",
    className: ""
};
const tableNumberPrimaryKey210Data = {
    tableNumberBase4Props: tableNumberBase410Data
};
const key23Data = {
    className: "key-22"
};
const tableNumberBase58Data = {
    type: "amount:int32",
    bottomLine: "/img/bottom-line-1@2x.png",
    leftLine: "/img/left-line-1@2x.png",
    rightLine: "/img/right-line-1@2x.png",
    className: "table-number-base-9",
    keyProps: key23Data
};
const tableTextBase28Data = {
    className: "table-text-base-7",
    tableNumberBase5Props: tableNumberBase58Data
};
const key24Data = {
    className: "key-23"
};
const tableNumberBase68Data = {
    bottomLine: "/img/bottom-line-2@2x.png",
    leftLine: "/img/left-line-2@2x.png",
    rightLine: "/img/right-line-2@2x.png",
    className: "",
    keyProps: key24Data
};
const tableNumberBaseNull28Data = {
    tableNumberBase6Props: tableNumberBase68Data
};
const tableTextBaseNull28Data = {
    className: "table-text-base-null-5",
    tableNumberBaseNull2Props: tableNumberBaseNull28Data
};
const crewMember52Data = {
    tableHeaderProps: tableHeader12Data,
    tableNumberPrimaryKey2Props: tableNumberPrimaryKey210Data,
    tableTextBase2Props: tableTextBase28Data,
    tableTextBaseNull2Props: tableTextBaseNull28Data
};
const informationalModel1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    aquisition: "Aquisition",
    functionalView: "Functional view",
    arrow7: "/img/arrow-1-2@2x.png",
    arrow8: "/img/arrow-2-2@2x.png",
    line31: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    arrow1: "/img/arrow-1-7@2x.png",
    arrow2: "/img/arrow-2-7@2x.png",
    line32: "/img/line-3-2.png",
    arrow5: "/img/arrow-5-5@2x.png",
    arrow6: "/img/arrow-5-5@2x.png",
    modeling: "Modeling",
    goOnToTheNextPage: "Next",
    frame11622Props: frame116228Data,
    frame11722Props: frame117227Data,
    frame1136Props: frame11362Data,
    tableHeaderProps: tableHeader7Data,
    crewMemberProps: crewMember6Data,
    crewMember2Props: crewMember22Data,
    crewMember3Props: crewMember32Data,
    crewMember4Props: crewMember42Data,
    crewMember5Props: crewMember52Data
};
const frame117228Data = {
    children: "Existing Case"
};
const frame116229Data = {
    children: "Reference Cases"
};
const frame1132210Data = {
    className: "frame-113-14"
};
const navItems32Data = {
    className: "nav-items-3-2",
    frame1172Props: frame117228Data,
    frame1162Props: frame116229Data,
    frame1132Props: frame1132210Data
};
const buttonSecondary1Data = {
    children: "D\xe9marche Environnementale 1",
    className: ""
};
const toggle1Data = {
    buttonSecondaryProps: buttonSecondary1Data
};
const ouinon1Data = {
    yes: "Yes",
    place: "No"
};
const frame1361Data = {
    ouinonProps: ouinon1Data
};
const group901Data = {
    children: "Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?"
};
const ouinon2Data = {
    yes: "Yes",
    place: "No"
};
const frame1362Data = {
    ouinonProps: ouinon2Data
};
const group902Data = {
    children: "Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?"
};
const ouinon3Data = {
    yes: "Yes",
    place: "No"
};
const frame1363Data = {
    className: "frame-138",
    ouinonProps: ouinon3Data
};
const buttonSecondary2Data = {
    children: "D\xe9marche Environnementale 2",
    className: ""
};
const toggle2Data = {
    className: "toggle-33",
    buttonSecondaryProps: buttonSecondary2Data
};
const ouinon4Data = {
    yes: "Yes",
    place: "No"
};
const frame1364Data = {
    ouinonProps: ouinon4Data
};
const ouinon5Data = {
    yes: "Yes",
    place: "No"
};
const frame1365Data = {
    ouinonProps: ouinon5Data
};
const ouinon6Data = {
    yes: "Yes",
    place: "No"
};
const frame1366Data = {
    ouinonProps: ouinon6Data
};
const buttonSecondary3Data = {
    children: "1/5",
    className: "button-secondary-52"
};
const toggle3Data = {
    className: "x15",
    buttonSecondaryProps: buttonSecondary3Data
};
const environmental1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1-19@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS ON THE FORM",
    grezVousLesRisqu: "G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?",
    inputType1: "text",
    inputPlaceholder1: "En moyenne dans quelle p\xe9rim\xe8tre vous approvisionnez vous?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous le tonnage du transport des produits de vos fournisseurs externes?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous le tonnage du transport des produits de vos fournisseurs externes?",
    navItems3Props: navItems32Data,
    toggle1Props: toggle1Data,
    frame1361Props: frame1361Data,
    group901Props: group901Data,
    frame1362Props: frame1362Data,
    group902Props: group902Data,
    frame1363Props: frame1363Data,
    toggle2Props: toggle2Data,
    frame1364Props: frame1364Data,
    frame1365Props: frame1365Data,
    frame1366Props: frame1366Data,
    toggle3Props: toggle3Data
};
const frame117229Data = {
    children: "Existing Case"
};
const frame1162210Data = {
    children: "Reference Cases"
};
const frame1132211Data = {
    className: ""
};
const navItems33Data = {
    className: "nav-items-3-3",
    frame1172Props: frame117229Data,
    frame1162Props: frame1162210Data,
    frame1132Props: frame1132211Data
};
const measuringFormData = {
    ellipse116: "/img/polygon-3@2x.png",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    criteriaMeasurementForm: "CRITERIA MEASUREMENT FORM",
    environnementCriteria1: "Environnement criteria",
    environnementCriteria2: "Environnement criteria",
    x4LeadTimeCriteria: "4. Lead time criteria",
    x2SocialCriteria: "2. Social Criteria",
    x5CostCriteria: "5. Cost criteria",
    x3ModernizationCriteria: "3. Modernization criteria",
    x6QualityCriteria: "6. Quality criteria",
    navItems3Props: navItems33Data
};
const frame1185Data = {
    children: "Visual management",
    className: "frame-113-23"
};
const headerMenuDefault321Data = {
    inputPlaceholder: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Definition de",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " la famille",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " de produits"
        ]
    })
};
const headerMenuDefault322Data = {
    inputPlaceholder: "VSM Actuel",
    className: "menu-item-default-14"
};
const menuItemDefaultData = {
    headerMenuDefault3Props: headerMenuDefault322Data
};
const headerMenuDefault323Data = {
    inputPlaceholder: "Analysis",
    className: "menu-item-default-15"
};
const headerMenuDefault324Data = {
    inputPlaceholder: "VSM Futur",
    className: "menu-item-default-16"
};
const headerMenuDefault325Data = {
    inputPlaceholder: "Plan d\u2019action",
    className: "menu-item-default-17"
};
const leanVSM1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    leanVsm: "Lean VSM",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    rectangle6: "/img/rectangle-7@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    arrow3: "/img/arrow-3-4@2x.png",
    modeling: "Modeling",
    arrow4: "/img/arrow-4-4@2x.png",
    arrow6: "/img/arrow-4-4@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    xcontinue: "Continue",
    frame118Props: frame1185Data,
    headerMenuDefault321Props: headerMenuDefault321Data,
    menuItemDefaultProps: menuItemDefaultData,
    headerMenuDefault322Props: headerMenuDefault323Data,
    headerMenuDefault323Props: headerMenuDefault324Data,
    headerMenuDefault324Props: headerMenuDefault325Data
};
const frame1186Data = {
    children: "Visual management",
    className: "frame-113-26"
};
const x5S1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    rectangle6: "/img/rectangle-7@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    seiri: "SEIRI",
    arrow7: "/img/arrow-7-6@2x.png",
    inputType1: "text",
    inputPlaceholder1: "ELIMINER",
    arrow3: "/img/arrow-3-4@2x.png",
    seiton: "SEITON",
    arrow8: "/img/arrow-8-8@2x.png",
    inputType2: "text",
    inputPlaceholder2: "RANGER",
    modeling: "Modeling",
    arrow4: "/img/arrow-4-4@2x.png",
    seison: "SEISON",
    arrow9: "/img/arrow-7-6@2x.png",
    inputType3: "text",
    inputPlaceholder3: "NETTOYER",
    arrow6: "/img/arrow-4-4@2x.png",
    seiketsu: "SEIKETSU",
    shitsuke: "SHITSUKE",
    arrow10: "/img/arrow-8-8@2x.png",
    arrow11: "/img/arrow-8-8@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    inputType4: "text",
    inputPlaceholder4: "STANDARDISER",
    inputType5: "text",
    inputPlaceholder5: "RESPECTER",
    xcontinue: "Continue",
    frame118Props: frame1186Data
};
const frame1172210Data = {
    children: "Existing Case"
};
const frame1162211Data = {
    children: "Reference Cases"
};
const frame1132214Data = {
    className: ""
};
const navItems34Data = {
    className: "nav-items-3-4",
    frame1172Props: frame1172210Data,
    frame1162Props: frame1162211Data,
    frame1132Props: frame1132214Data
};
const frame113324Data = {
    className: "frame-113-3"
};
const headerMenuDefault21Data = {
    children: "Results & Objectives",
    className: ""
};
const frame2321Data = {
    headerMenuDefault2Props: headerMenuDefault21Data
};
const frame222Data = {
    children: "Continue"
};
const analysisData = {
    analysis: "Analysis",
    label: "Design",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    place: "Back",
    formalismesEnFonct: "FORMALISMES EN FONCTION DES PROBL\xc8MES TROUV\xc9S",
    navItems3Props: navItems34Data,
    frame11332Props: frame113324Data,
    frame232Props: frame2321Data,
    frame222Props: frame222Data
};
const frame11363Data = {
    children: "Visual management",
    className: "frame-113-5"
};
const buttonSecondary4Data = {
    children: "Analysis",
    className: "button-secondary-53"
};
const toggle4Data = {
    className: "finish",
    buttonSecondaryProps: buttonSecondary4Data
};
const visualManagement1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    inputType1: "text",
    inputPlaceholder1: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Connaissances",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Competences"
        ]
    }),
    inputType2: "text",
    inputPlaceholder2: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Collaborateurs",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Equipes"
        ]
    }),
    inputType3: "text",
    inputPlaceholder3: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Strategies",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Projets"
        ]
    }),
    inputType4: "text",
    inputPlaceholder4: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Idees",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Informations"
        ]
    }),
    inputType5: "text",
    inputPlaceholder5: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Temps ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Priorites"
        ]
    }),
    arrow11: "/img/arrow-11-1@2x.png",
    arrow16: "/img/arrow-16@2x.png",
    arrow13: "/img/arrow-13@2x.png",
    arrow14: "/img/arrow-14@2x.png",
    inputType6: "text",
    inputPlaceholder6: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Mieux",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " Manager"
        ]
    }),
    arrow12: "/img/arrow-12@2x.png",
    arrow15: "/img/arrow-15@2x.png",
    inputType7: "text",
    inputPlaceholder7: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Problemes",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Decision"
        ]
    }),
    modeling: "Modeling",
    frame1136Props: frame11363Data,
    toggleProps: toggle4Data
};
const frame1162212Data = {
    children: "Decisional Model"
};
const frame1172211Data = {
    children: "Process view"
};
const frame1187Data = {
    children: "Informational model"
};
const navItems42Data = {
    className: "nav-items-4-2",
    frame1162Props: frame1162212Data,
    frame1172Props: frame1172211Data,
    frame118Props: frame1187Data
};
const functionalViewData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Controllers",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Input",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Resources",
    arrow8: "/img/arrow-8@2x.png",
    modeling: "Modeling",
    label6: "Constrains",
    label7: "Output",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label8: "Resources",
    arrow9: "/img/arrow-9-3@2x.png",
    xcontinue: "Continue",
    navItems4Props: navItems42Data
};
const frame1172212Data = {
    children: "Existing Case"
};
const frame1162213Data = {
    children: "Reference Cases"
};
const frame1132217Data = {
    className: ""
};
const navItems35Data = {
    className: "nav-items-3-5",
    frame1172Props: frame1172212Data,
    frame1162Props: frame1162213Data,
    frame1132Props: frame1132217Data
};
const frame113327Data = {
    className: "frame-113-6"
};
const navItems222Data = {
    frame11332Props: frame113327Data
};
const pricing31Data = {
    cost: "Cost"
};
const pricing32Data = {
    cost: "Modernization",
    className: "pricing-8"
};
const pricing33Data = {
    cost: "Social",
    className: "pricing-5"
};
const pricing34Data = {
    cost: "Client/Consumer",
    className: "pricing-7"
};
const objectivesData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    place1: "Back",
    notesAtteindre: "NOTES \xc0 ATTEINDRE",
    place2: "Quality",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    line211: "/img/line-21@2x.png",
    leadTime: "Lead Time",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-5@2x.png",
    environment: "Environment",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-5@2x.png",
    xcontinue: "Continue",
    navItems3Props: navItems35Data,
    navItems22Props: navItems222Data,
    pricing31Props: pricing31Data,
    pricing32Props: pricing32Data,
    pricing33Props: pricing33Data,
    pricing34Props: pricing34Data
};
const frame1162214Data = {
    children: "Decisional Model"
};
const frame1172213Data = {
    children: "Process view"
};
const frame1188Data = {
    children: "Informational model"
};
const navItems422Data = {
    frame1162Props: frame1162214Data,
    frame1172Props: frame1172213Data,
    frame118Props: frame1188Data
};
const physicalModelData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    label3: "Cut",
    arrow5: "/img/arrow-5@2x.png",
    label4: "Wood",
    arrow6: "/img/arrow-6@2x.png",
    label5: "Machines",
    arrow8: "/img/arrow-8@2x.png",
    modeling: "Modeling",
    label6: "Assembling",
    label7: "Tables",
    arrow3: "/img/arrow-3@2x.png",
    arrow4: "/img/arrow-4@2x.png",
    arrow7: "/img/arrow-7@2x.png",
    label8: "Workers",
    arrow9: "/img/arrow-9-3@2x.png",
    xcontinue: "Continue",
    navItems42Props: navItems422Data
};
const frame1172214Data = {
    children: "Process view"
};
const frame1189Data = {
    children: "Informational model"
};
const navItems43Data = {
    frame1172Props: frame1172214Data,
    frame118Props: frame1189Data
};
const decisionalModelData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow3: "/img/arrow-1@2x.png",
    arrow4: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    modeling: "Modeling",
    xcontinue: "Continue",
    navItems43Props: navItems43Data
};
const frame1162215Data = {
    children: "Decisional Model"
};
const frame11810Data = {
    children: "Informational model"
};
const navItems44Data = {
    frame1162Props: frame1162215Data,
    frame118Props: frame11810Data
};
const processViewData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    arrow1: "/img/arrow-1-2@2x.png",
    arrow2: "/img/arrow-2-2@2x.png",
    rectangle7: "/img/rectangle-7@2x.png",
    line3: "/img/line-3@2x.png",
    line4: "/img/line-4@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnFlexsimB: "CLICK ON \u201CFLEXSIM\u201D BUTTON TO OPEN VMWARE HORIZON",
    overlapGroup2: "/img/rectangle-4@2x.png",
    cut: "Cut",
    label3: "Design",
    rectangle5: "/img/rectangle-5@2x.png",
    manufacturing: "Manufacturing",
    arrow6: "/img/arrow-6-2@2x.png",
    arrow11: "/img/arrow-11@2x.png",
    label4: "Machine",
    arrow8: "/img/arrow-8-2@2x.png",
    label5: "Human",
    arrow9: "/img/arrow-9-2@2x.png",
    spanText1: "F",
    spanText2: "lexsim",
    rectangle6: "/img/rectangle-6@2x.png",
    assembly: "Assembly",
    arrow10: "/img/arrow-10@2x.png",
    xcontinue: "Continue",
    navItems44Props: navItems44Data
};
const frame114322Data = {
    className: "frame-114-87"
};
const frame11527Data = {
    className: "frame-115-105"
};
const headerMenuDefault22Data = {
    children: "Existing case"
};
const frame1132221Data = {
    className: "frame-113-29"
};
const frame11445Data = {
    className: "frame-114-98"
};
const headerMenuDefault23Data = {
    children: "Results & Objectives",
    className: ""
};
const frame2322Data = {
    headerMenuDefault2Props: headerMenuDefault23Data
};
const buttonSecondary5Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-27"
};
const toggle5Data = {
    className: "toggle-7",
    buttonSecondaryProps: buttonSecondary5Data
};
const group1021Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group1022Data = {
    line24: "/img/line-24-1.png",
    className: ""
};
const group1023Data = {
    line24: "/img/line-24-12.png",
    className: ""
};
const group1024Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group1025Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1011Data = {
    toggleProps: toggle5Data,
    group1021Props: group1021Data,
    group1022Props: group1022Data,
    group1023Props: group1023Data,
    group1024Props: group1024Data,
    group1025Props: group1025Data
};
const buttonSecondary6Data = {
    children: "1/2",
    className: "button-secondary-27"
};
const toggle6Data = {
    className: "toggle-34",
    buttonSecondaryProps: buttonSecondary6Data
};
const buttonSecondary7Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-27"
};
const toggle7Data = {
    className: "toggle-7",
    buttonSecondaryProps: buttonSecondary7Data
};
const group1026Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group1027Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group1028Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group1029Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group10210Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1021Data = {
    toggleProps: toggle7Data,
    group1021Props: group1026Data,
    group1022Props: group1027Data,
    group1023Props: group1028Data,
    group1024Props: group1029Data,
    group1025Props: group10210Data
};
const frame117323Data = {
    className: "frame-116-157"
};
const sMED2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    label1: "Reference case",
    aquisition: "Aquisition",
    analysis: "Analysis",
    label2: "Design",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    frame11432Props: frame114322Data,
    frame1152Props: frame11527Data,
    headerMenuDefault2Props: headerMenuDefault22Data,
    frame11322Props: frame1132221Data,
    frame1144Props: frame11445Data,
    frame232Props: frame2322Data,
    frame101Props: frame1011Data,
    toggleProps: toggle6Data,
    frame102Props: frame1021Data,
    frame11732Props: frame117323Data
};
const navItems23Data = {
    className: "nav-items-2-4"
};
const frame1172215Data = {
    children: "Existing Case"
};
const frame1162216Data = {
    children: "Reference Cases"
};
const frame1132222Data = {
    className: ""
};
const navItems36Data = {
    className: "nav-items-3-6",
    frame1172Props: frame1172215Data,
    frame1162Props: frame1162216Data,
    frame1132Props: frame1132222Data
};
const buttonSecondary8Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-28"
};
const toggle8Data = {
    className: "toggle-8",
    buttonSecondaryProps: buttonSecondary8Data
};
const group10211Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group10212Data = {
    line24: "/img/line-24-1.png",
    className: ""
};
const group10213Data = {
    line24: "/img/line-24-12.png",
    className: ""
};
const group10214Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group10215Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1012Data = {
    className: "frame-97",
    toggleProps: toggle8Data,
    group1021Props: group10211Data,
    group1022Props: group10212Data,
    group1023Props: group10213Data,
    group1024Props: group10214Data,
    group1025Props: group10215Data
};
const buttonSecondary9Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-28"
};
const toggle9Data = {
    className: "toggle-8",
    buttonSecondaryProps: buttonSecondary9Data
};
const group10216Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10217Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10218Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10219Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group10220Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1022Data = {
    className: "frame-98",
    toggleProps: toggle9Data,
    group1021Props: group10216Data,
    group1022Props: group10217Data,
    group1023Props: group10218Data,
    group1024Props: group10219Data,
    group1025Props: group10220Data
};
const buttonSecondary10Data = {
    children: "2/2",
    className: "button-secondary-28"
};
const toggle10Data = {
    className: "toggle-35",
    buttonSecondaryProps: buttonSecondary10Data
};
const sMED3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    visualManagement: "Visual Management",
    navItems2Props: navItems23Data,
    navItems3Props: navItems36Data,
    frame101Props: frame1012Data,
    frame102Props: frame1022Data,
    toggleProps: toggle10Data
};
const navItems24Data = {
    className: "nav-items-2-5"
};
const frame1172216Data = {
    children: "Existing Case"
};
const frame1162217Data = {
    children: "Reference Cases"
};
const frame1132223Data = {
    className: ""
};
const navItems37Data = {
    className: "nav-items-3-7",
    frame1172Props: frame1172216Data,
    frame1162Props: frame1162217Data,
    frame1132Props: frame1132223Data
};
const buttonSecondary11Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-29"
};
const toggle11Data = {
    className: "toggle-9",
    buttonSecondaryProps: buttonSecondary11Data
};
const group10221Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group10222Data = {
    line24: "/img/line-24-1.png",
    className: ""
};
const group10223Data = {
    line24: "/img/line-24-2.png",
    className: ""
};
const group10224Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group10225Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1013Data = {
    toggleProps: toggle11Data,
    group1021Props: group10221Data,
    group1022Props: group10222Data,
    group1023Props: group10223Data,
    group1024Props: group10224Data,
    group1025Props: group10225Data
};
const buttonSecondary12Data = {
    children: "1/2",
    className: "button-secondary-29"
};
const toggle12Data = {
    className: "toggle-36",
    buttonSecondaryProps: buttonSecondary12Data
};
const buttonSecondary13Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-29"
};
const toggle13Data = {
    className: "toggle-9",
    buttonSecondaryProps: buttonSecondary13Data
};
const group10226Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10227Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10228Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10229Data = {
    line24: "/img/line-24-8.png",
    className: ""
};
const group10230Data = {
    line24: "/img/line-24-9.png",
    className: ""
};
const frame1023Data = {
    toggleProps: toggle13Data,
    group1021Props: group10226Data,
    group1022Props: group10227Data,
    group1023Props: group10228Data,
    group1024Props: group10229Data,
    group1025Props: group10230Data
};
const frame117324Data = {
    className: "frame-117-75"
};
const visualManagement2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems24Data,
    navItems3Props: navItems37Data,
    frame101Props: frame1013Data,
    toggleProps: toggle12Data,
    frame102Props: frame1023Data,
    frame11732Props: frame117324Data
};
const navItems25Data = {
    className: "nav-items-2-6"
};
const frame1172217Data = {
    children: "Existing Case"
};
const frame1162218Data = {
    children: "Reference Cases"
};
const frame1132224Data = {
    className: ""
};
const navItems38Data = {
    className: "nav-items-3-8",
    frame1172Props: frame1172217Data,
    frame1162Props: frame1162218Data,
    frame1132Props: frame1132224Data
};
const buttonSecondary14Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-30"
};
const toggle14Data = {
    className: "toggle-10",
    buttonSecondaryProps: buttonSecondary14Data
};
const group10231Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group10232Data = {
    line24: "/img/line-24-1.png",
    className: "group-3-2"
};
const group10233Data = {
    line24: "/img/line-24-32.png",
    className: "group-3-3"
};
const group10234Data = {
    line24: "/img/line-24-3.png",
    className: "group-3-4"
};
const group10235Data = {
    line24: "/img/line-24-4.png",
    className: "group-3-5"
};
const frame1014Data = {
    className: "frame-97-1",
    toggleProps: toggle14Data,
    group1021Props: group10231Data,
    group1022Props: group10232Data,
    group1023Props: group10233Data,
    group1024Props: group10234Data,
    group1025Props: group10235Data
};
const buttonSecondary15Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-30"
};
const toggle15Data = {
    className: "toggle-10",
    buttonSecondaryProps: buttonSecondary15Data
};
const group10236Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10237Data = {
    line24: "/img/line-24-6.png",
    className: "group-3-6"
};
const group10238Data = {
    line24: "/img/line-24-7.png",
    className: "group-3-7"
};
const group10239Data = {
    line24: "/img/line-24-18.png",
    className: "group-3-8"
};
const group10240Data = {
    line24: "/img/line-24-19.png",
    className: "group-3"
};
const frame1024Data = {
    className: "frame-98-1",
    toggleProps: toggle15Data,
    group1021Props: group10236Data,
    group1022Props: group10237Data,
    group1023Props: group10238Data,
    group1024Props: group10239Data,
    group1025Props: group10240Data
};
const buttonSecondary16Data = {
    children: "2/2",
    className: "button-secondary-30"
};
const toggle16Data = {
    className: "toggle-37",
    buttonSecondaryProps: buttonSecondary16Data
};
const kaizen3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    smed: "SMED",
    navItems2Props: navItems25Data,
    navItems3Props: navItems38Data,
    frame101Props: frame1014Data,
    frame102Props: frame1024Data,
    toggleProps: toggle16Data
};
const navItems26Data = {
    className: "nav-items-2-7"
};
const frame1172218Data = {
    children: "Existing Case"
};
const frame1162219Data = {
    children: "Reference Cases"
};
const frame1132225Data = {
    className: ""
};
const navItems39Data = {
    className: "nav-items-3-9",
    frame1172Props: frame1172218Data,
    frame1162Props: frame1162219Data,
    frame1132Props: frame1132225Data
};
const buttonSecondary17Data = {
    children: "2/2",
    className: "button-secondary-54"
};
const toggle17Data = {
    className: "toggle-38",
    buttonSecondaryProps: buttonSecondary17Data
};
const visualManagement3Data = {
    navItems2Props: navItems26Data,
    navItems3Props: navItems39Data,
    toggleProps: toggle17Data
};
const frame1133211Data = {
    className: "frame-113-10"
};
const navItems223Data = {
    className: "nav-items-2-21",
    frame11332Props: frame1133211Data
};
const frame114212Data = {
    className: "frame-114-100"
};
const frame1132226Data = {
    className: "frame-113-34"
};
const pricing35Data = {
    cost: "Cost"
};
const pricing36Data = {
    cost: "Modernization",
    className: "pricing-8-1"
};
const pricing37Data = {
    cost: "Social",
    className: "pricing-5-1"
};
const pricing38Data = {
    cost: "Client/Consumer",
    className: "pricing-7-1"
};
const curPerformancesData = {
    label1: "Existing case",
    label2: "Reference case",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    place1: "Back",
    place2: "Quality",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    line211: "/img/line-21@2x.png",
    leadTime: "Lead Time",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-5@2x.png",
    environment: "Environment",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-5@2x.png",
    propositions: "Propositions",
    navItems22Props: navItems223Data,
    frame1142Props: frame114212Data,
    frame11322Props: frame1132226Data,
    pricing31Props: pricing35Data,
    pricing32Props: pricing36Data,
    pricing33Props: pricing37Data,
    pricing34Props: pricing38Data
};
const frame942Data = {
    className: "frame-94-1"
};
const frame952Data = {
    className: "frame-95-1"
};
const inscriptionData = {
    aerialViewContainerCargoShipSea1: "/img/aerial-view-container-cargo-ship-sea-1.png",
    subtract: "/img/subtract.png",
    polygon1: "/img/polygon-1-1@2x.png",
    polygon2: "/img/polygon-2@2x.png",
    login: "Sign in",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---20081@2x.png",
    polygon3: "/img/polygon-3@2x.png",
    frame94Props: frame942Data,
    frame95Props: frame952Data
};
const frame1172219Data = {
    children: "Existing Case"
};
const frame1162220Data = {
    children: "Reference Cases"
};
const frame1132227Data = {
    className: ""
};
const navItems310Data = {
    className: "nav-items-3-10",
    frame1172Props: frame1172219Data,
    frame1162Props: frame1162220Data,
    frame1132Props: frame1132227Data
};
const buttonSecondary18Data = {
    children: "After-sales service and dispute resolution 1",
    className: ""
};
const toggle18Data = {
    className: "toggle-39",
    buttonSecondaryProps: buttonSecondary18Data
};
const ouinon7Data = {
    yes: "Yes",
    place: "No"
};
const frame1367Data = {
    ouinonProps: ouinon7Data
};
const ouinon8Data = {
    yes: "Yes",
    place: "No"
};
const frame1368Data = {
    ouinonProps: ouinon8Data
};
const ouinon9Data = {
    yes: "Yes",
    place: "No"
};
const frame1369Data = {
    ouinonProps: ouinon9Data
};
const ouinon10Data = {
    yes: "Yes",
    place: "No"
};
const frame13610Data = {
    ouinonProps: ouinon10Data
};
const buttonSecondary19Data = {
    children: "After-sales service and dispute resolution 2",
    className: "button-secondary-56"
};
const toggle19Data = {
    className: "toggle-40",
    buttonSecondaryProps: buttonSecondary19Data
};
const ouinon11Data = {
    yes: "Yes",
    place: "No"
};
const frame13611Data = {
    ouinonProps: ouinon11Data
};
const ouinon12Data = {
    yes: "Yes",
    place: "No"
};
const frame13612Data = {
    ouinonProps: ouinon12Data
};
const ouinon13Data = {
    yes: "Yes",
    place: "No"
};
const frame13613Data = {
    ouinonProps: ouinon13Data
};
const ouinon14Data = {
    yes: "Yes",
    place: "No"
};
const frame13614Data = {
    ouinonProps: ouinon14Data
};
const buttonSecondary20Data = {
    children: "2/2",
    className: "button-secondary-57"
};
const toggle20Data = {
    className: "toggle-41",
    buttonSecondaryProps: buttonSecondary20Data
};
const clientConsommateur2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    next: "Next",
    navItems3Props: navItems310Data,
    toggle1Props: toggle18Data,
    frame1361Props: frame1367Data,
    frame1362Props: frame1368Data,
    frame1363Props: frame1369Data,
    frame1364Props: frame13610Data,
    toggle2Props: toggle19Data,
    frame1365Props: frame13611Data,
    frame1366Props: frame13612Data,
    frame1367Props: frame13613Data,
    frame1368Props: frame13614Data,
    toggle3Props: toggle20Data
};
const frame1172220Data = {
    children: "Existing Case"
};
const frame1162221Data = {
    children: "Reference Cases"
};
const frame1132228Data = {
    className: "frame-113-36"
};
const navItems311Data = {
    className: "nav-items-3-11",
    frame1172Props: frame1172220Data,
    frame1162Props: frame1162221Data,
    frame1132Props: frame1132228Data
};
const frame11311Data = {
    className: "frame-113-47"
};
const frame11719Data = {
    className: "frame-117-89"
};
const buttonSecondary21Data = {
    children: "Emploi/Relation Employeur- employ\xe9 1",
    className: ""
};
const toggle21Data = {
    className: "toggle",
    buttonSecondaryProps: buttonSecondary21Data
};
const ouinon15Data = {
    yes: "Yes",
    place: "No"
};
const frame13615Data = {
    ouinonProps: ouinon15Data
};
const ouinon16Data = {
    yes: "Yes",
    place: "No"
};
const frame13616Data = {
    ouinonProps: ouinon16Data
};
const ouinon17Data = {
    yes: "Yes",
    place: "No"
};
const frame13617Data = {
    ouinonProps: ouinon17Data
};
const buttonSecondary22Data = {
    children: "Emploi/Relation Employeur- employ\xe9 2",
    className: ""
};
const toggle22Data = {
    className: "toggle",
    buttonSecondaryProps: buttonSecondary22Data
};
const ouinon18Data = {
    yes: "Yes",
    place: "No"
};
const frame13618Data = {
    ouinonProps: ouinon18Data
};
const ouinon19Data = {
    yes: "Yes",
    place: "No"
};
const frame13619Data = {
    className: "frame-153",
    ouinonProps: ouinon19Data
};
const frame1331Data = {
    frame136Props: frame13619Data
};
const frame1441Data = {
    frame133Props: frame1331Data
};
const ouinon20Data = {
    yes: "Yes",
    place: "No"
};
const frame13620Data = {
    ouinonProps: ouinon20Data
};
const ouinon21Data = {
    yes: "Yes",
    place: "No"
};
const frame13621Data = {
    ouinonProps: ouinon21Data
};
const buttonSecondary23Data = {
    children: "1/6",
    className: "button-secondary-58"
};
const toggle23Data = {
    className: "toggle-42",
    buttonSecondaryProps: buttonSecondary23Data
};
const social1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1-43@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems311Data,
    frame113Props: frame11311Data,
    frame117Props: frame11719Data,
    toggle1Props: toggle21Data,
    frame1361Props: frame13615Data,
    frame1362Props: frame13616Data,
    frame1363Props: frame13617Data,
    toggle2Props: toggle22Data,
    frame1364Props: frame13618Data,
    frame144Props: frame1441Data,
    frame1365Props: frame13620Data,
    frame1366Props: frame13621Data,
    toggle3Props: toggle23Data
};
const navItems28Data = {
    className: "nav-items-2-9"
};
const frame1172221Data = {
    children: "Existing Case"
};
const frame1162222Data = {
    children: "Reference Cases"
};
const frame1132229Data = {
    className: ""
};
const navItems312Data = {
    className: "nav-items-3-12",
    frame1172Props: frame1172221Data,
    frame1162Props: frame1162222Data,
    frame1132Props: frame1132229Data
};
const buttonSecondary24Data = {
    children: "Artificial Intellignece (AI) 1",
    className: ""
};
const toggle24Data = {
    className: "toggle-1",
    buttonSecondaryProps: buttonSecondary24Data
};
const ouinon22Data = {
    yes: "Yes",
    place: "No"
};
const frame13622Data = {
    ouinonProps: ouinon22Data
};
const ouinon23Data = {
    yes: "Yes",
    place: "No"
};
const frame13623Data = {
    ouinonProps: ouinon23Data
};
const ouinon24Data = {
    yes: "Yes",
    place: "No"
};
const frame13624Data = {
    ouinonProps: ouinon24Data
};
const ouinon25Data = {
    yes: "Yes",
    place: "No"
};
const frame13625Data = {
    ouinonProps: ouinon25Data
};
const buttonSecondary25Data = {
    children: "Artificial Intellignece (AI) 2",
    className: ""
};
const toggle25Data = {
    className: "toggle-1",
    buttonSecondaryProps: buttonSecondary25Data
};
const ouinon26Data = {
    yes: "Yes",
    place: "No"
};
const frame13626Data = {
    ouinonProps: ouinon26Data
};
const ouinon27Data = {
    yes: "Yes",
    place: "No"
};
const frame13627Data = {
    className: "frame-153-1",
    ouinonProps: ouinon27Data
};
const frame1332Data = {
    frame136Props: frame13627Data
};
const frame1442Data = {
    frame133Props: frame1332Data
};
const ouinon28Data = {
    yes: "Yes",
    place: "No"
};
const frame13628Data = {
    ouinonProps: ouinon28Data
};
const buttonSecondary26Data = {
    children: "1/4",
    className: "button-secondary-59"
};
const toggle26Data = {
    className: "toggle-43",
    buttonSecondaryProps: buttonSecondary26Data
};
const modernization1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems2Props: navItems28Data,
    navItems3Props: navItems312Data,
    toggle1Props: toggle24Data,
    frame1361Props: frame13622Data,
    frame1362Props: frame13623Data,
    frame1363Props: frame13624Data,
    frame1364Props: frame13625Data,
    toggle2Props: toggle25Data,
    frame1365Props: frame13626Data,
    frame144Props: frame1442Data,
    frame1366Props: frame13628Data,
    toggle3Props: toggle26Data
};
const frame1172222Data = {
    children: "Existing Case"
};
const frame1162223Data = {
    children: "Reference Cases"
};
const frame1132230Data = {
    className: ""
};
const navItems313Data = {
    className: "nav-items-3-13",
    frame1172Props: frame1172222Data,
    frame1162Props: frame1162223Data,
    frame1132Props: frame1132230Data
};
const buttonSecondary27Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Fair information and contract practices",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "and contracts"
        ]
    }),
    className: "button-secondary-60"
};
const toggle27Data = {
    className: "toggle-44",
    buttonSecondaryProps: buttonSecondary27Data
};
const ouinon29Data = {
    yes: "Yes",
    place: "No"
};
const frame13629Data = {
    ouinonProps: ouinon29Data
};
const ouinon30Data = {
    yes: "Yes",
    place: "No"
};
const frame13630Data = {
    ouinonProps: ouinon30Data
};
const ouinon31Data = {
    yes: "Yes",
    place: "No"
};
const frame13631Data = {
    ouinonProps: ouinon31Data
};
const buttonSecondary28Data = {
    children: "Protection of the health and safety of customers/consumers",
    className: "button-secondary-61"
};
const toggle28Data = {
    className: "toggle-45",
    buttonSecondaryProps: buttonSecondary28Data
};
const ouinon32Data = {
    yes: "Yes",
    place: "No"
};
const frame13632Data = {
    ouinonProps: ouinon32Data
};
const ouinon33Data = {
    yes: "Yes",
    place: "No"
};
const frame13633Data = {
    ouinonProps: ouinon33Data
};
const ouinon34Data = {
    yes: "Yes",
    place: "No"
};
const frame13634Data = {
    ouinonProps: ouinon34Data
};
const buttonSecondary29Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Customer / consumer data protection",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "consumers"
        ]
    }),
    className: "button-secondary-62"
};
const toggle29Data = {
    className: "toggle-46",
    buttonSecondaryProps: buttonSecondary29Data
};
const ouinon35Data = {
    yes: "Yes",
    place: "No"
};
const frame13635Data = {
    ouinonProps: ouinon35Data
};
const ouinon36Data = {
    yes: "Yes",
    place: "No"
};
const frame13636Data = {
    className: "frame-153-2",
    ouinonProps: ouinon36Data
};
const frame1333Data = {
    frame136Props: frame13636Data
};
const frame1443Data = {
    frame133Props: frame1333Data
};
const ouinon37Data = {
    yes: "Yes",
    place: "No"
};
const frame13637Data = {
    ouinonProps: ouinon37Data
};
const buttonSecondary30Data = {
    children: "1/2",
    className: "button-secondary-63"
};
const toggle30Data = {
    className: "toggle-47",
    buttonSecondaryProps: buttonSecondary30Data
};
const clientConsommateur1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems313Data,
    toggle1Props: toggle27Data,
    frame1361Props: frame13629Data,
    frame1362Props: frame13630Data,
    frame1363Props: frame13631Data,
    toggle2Props: toggle28Data,
    frame1364Props: frame13632Data,
    frame1365Props: frame13633Data,
    frame1366Props: frame13634Data,
    toggle3Props: toggle29Data,
    frame1367Props: frame13635Data,
    frame144Props: frame1443Data,
    frame1368Props: frame13637Data,
    toggle4Props: toggle30Data
};
const frame1172223Data = {
    children: "Existing Case"
};
const frame1162224Data = {
    children: "Reference Cases"
};
const frame1132231Data = {
    className: ""
};
const navItems314Data = {
    className: "nav-items-3-14",
    frame1172Props: frame1172223Data,
    frame1162Props: frame1162224Data,
    frame1132Props: frame1132231Data
};
const buttonSecondary31Data = {
    children: "Procurement 1",
    className: ""
};
const toggle31Data = {
    className: "toggle-48",
    buttonSecondaryProps: buttonSecondary31Data
};
const frame422Data = {
    className: ""
};
const frame432Data = {
    className: ""
};
const ouinon210Data = {
    frame42Props: frame422Data,
    frame43Props: frame432Data
};
const frame423Data = {
    className: ""
};
const frame433Data = {
    className: ""
};
const ouinon211Data = {
    className: "ouinon-49",
    frame42Props: frame423Data,
    frame43Props: frame433Data
};
const buttonSecondary32Data = {
    children: "Procurement 2",
    className: ""
};
const toggle32Data = {
    className: "toggle-49",
    buttonSecondaryProps: buttonSecondary32Data
};
const frame424Data = {
    className: "frame-4-53-1"
};
const frame434Data = {
    className: "frame-4-61-1"
};
const ouinon212Data = {
    className: "ouinon-46",
    frame42Props: frame424Data,
    frame43Props: frame434Data
};
const frame425Data = {
    className: "frame-4-53"
};
const frame435Data = {
    className: "frame-4-61"
};
const ouinon213Data = {
    className: "ouinon-46",
    frame42Props: frame425Data,
    frame43Props: frame435Data
};
const buttonSecondary33Data = {
    children: "Procurement 3",
    className: ""
};
const toggle33Data = {
    className: "toggle-50",
    buttonSecondaryProps: buttonSecondary33Data
};
const ouinon38Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22-1"
};
const ouinon39Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22-2"
};
const ouinon40Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22-3"
};
const ouinon41Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-22"
};
const buttonSecondary34Data = {
    children: "1/2",
    className: "button-secondary-64"
};
const toggle34Data = {
    className: "toggle-51",
    buttonSecondaryProps: buttonSecondary34Data
};
const leadTime1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems314Data,
    toggle1Props: toggle31Data,
    ouinon21Props: ouinon210Data,
    ouinon22Props: ouinon211Data,
    toggle2Props: toggle32Data,
    ouinon23Props: ouinon212Data,
    ouinon24Props: ouinon213Data,
    toggle3Props: toggle33Data,
    ouinon1Props: ouinon38Data,
    ouinon2Props: ouinon39Data,
    ouinon3Props: ouinon40Data,
    ouinon4Props: ouinon41Data,
    toggle4Props: toggle34Data
};
const navItems211Data = {
    className: "nav-items-2-12"
};
const frame1172224Data = {
    children: "Existing Case"
};
const frame1162225Data = {
    children: "Reference Cases"
};
const frame1132232Data = {
    className: ""
};
const navItems315Data = {
    className: "nav-items-3-15",
    frame1172Props: frame1172224Data,
    frame1162Props: frame1162225Data,
    frame1132Props: frame1132232Data
};
const buttonSecondary35Data = {
    children: "Stock  1",
    className: ""
};
const toggle35Data = {
    className: "toggle-52",
    buttonSecondaryProps: buttonSecondary35Data
};
const ouinon42Data = {
    yes: "Yes",
    place: "No"
};
const frame13638Data = {
    ouinonProps: ouinon42Data
};
const ouinon43Data = {
    yes: "Yes",
    place: "No"
};
const frame13639Data = {
    ouinonProps: ouinon43Data
};
const ouinon44Data = {
    yes: "Yes",
    place: "No"
};
const frame13640Data = {
    ouinonProps: ouinon44Data
};
const ouinon45Data = {
    yes: "Yes",
    place: "No"
};
const frame13641Data = {
    ouinonProps: ouinon45Data
};
const buttonSecondary36Data = {
    children: "Stock 2",
    className: ""
};
const toggle36Data = {
    className: "toggle-53",
    buttonSecondaryProps: buttonSecondary36Data
};
const ouinon46Data = {
    yes: "Yes",
    place: "No"
};
const frame13642Data = {
    ouinonProps: ouinon46Data
};
const ouinon47Data = {
    yes: "Yes",
    place: "No"
};
const frame13643Data = {
    ouinonProps: ouinon47Data
};
const ouinon48Data = {
    yes: "Yes",
    place: "No"
};
const frame13644Data = {
    ouinonProps: ouinon48Data
};
const ouinon49Data = {
    yes: "Yes",
    place: "No"
};
const frame13645Data = {
    ouinonProps: ouinon49Data
};
const buttonSecondary37Data = {
    children: "Market",
    className: ""
};
const toggle37Data = {
    className: "toggle-54",
    buttonSecondaryProps: buttonSecondary37Data
};
const ouinon50Data = {
    yes: "Yes",
    place: "No"
};
const frame13646Data = {
    ouinonProps: ouinon50Data
};
const ouinon51Data = {
    yes: "Yes",
    place: "No"
};
const frame13647Data = {
    className: "frame-153-3",
    ouinonProps: ouinon51Data
};
const frame1334Data = {
    frame136Props: frame13647Data
};
const frame1444Data = {
    frame133Props: frame1334Data
};
const ouinon52Data = {
    yes: "Yes",
    place: "No"
};
const frame13648Data = {
    ouinonProps: ouinon52Data
};
const ouinon53Data = {
    yes: "Yes",
    place: "No"
};
const frame13649Data = {
    ouinonProps: ouinon53Data
};
const ouinon54Data = {
    yes: "Yes",
    place: "No"
};
const frame13650Data = {
    ouinonProps: ouinon54Data
};
const buttonSecondary38Data = {
    children: "1/2",
    className: "button-secondary-65"
};
const toggle38Data = {
    className: "toggle-55",
    buttonSecondaryProps: buttonSecondary38Data
};
const cost1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType9: "text",
    inputPlaceholder9: "Connaissez vous votre bilan carbone?",
    inputType10: "text",
    inputPlaceholder10: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType11: "text",
    inputPlaceholder11: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType12: "text",
    inputPlaceholder12: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType13: "text",
    inputPlaceholder13: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems2Props: navItems211Data,
    navItems3Props: navItems315Data,
    toggle1Props: toggle35Data,
    frame1361Props: frame13638Data,
    frame1362Props: frame13639Data,
    frame1363Props: frame13640Data,
    frame1364Props: frame13641Data,
    toggle2Props: toggle36Data,
    frame1365Props: frame13642Data,
    frame1366Props: frame13643Data,
    frame1367Props: frame13644Data,
    frame1368Props: frame13645Data,
    toggle3Props: toggle37Data,
    frame1369Props: frame13646Data,
    frame144Props: frame1444Data,
    frame13610Props: frame13648Data,
    frame13611Props: frame13649Data,
    frame13612Props: frame13650Data,
    toggle4Props: toggle38Data
};
const navItems212Data = {
    className: "nav-items-2-13"
};
const frame1172225Data = {
    children: "Existing Case"
};
const frame1162226Data = {
    children: "Reference Cases"
};
const frame1132233Data = {
    className: ""
};
const navItems316Data = {
    className: "nav-items-3-16",
    frame1172Props: frame1172225Data,
    frame1162Props: frame1162226Data,
    frame1132Props: frame1132233Data
};
const buttonSecondary39Data = {
    children: "Customer Requirements 1",
    className: ""
};
const toggle39Data = {
    className: "toggle-56",
    buttonSecondaryProps: buttonSecondary39Data
};
const ouinon55Data = {
    yes: "Yes",
    place: "No"
};
const frame13651Data = {
    ouinonProps: ouinon55Data
};
const ouinon56Data = {
    yes: "Yes",
    place: "No"
};
const frame13652Data = {
    ouinonProps: ouinon56Data
};
const ouinon57Data = {
    yes: "Yes",
    place: "No"
};
const frame13653Data = {
    ouinonProps: ouinon57Data
};
const buttonSecondary40Data = {
    children: "Customer Requirements 2",
    className: ""
};
const toggle40Data = {
    className: "toggle-57",
    buttonSecondaryProps: buttonSecondary40Data
};
const ouinon58Data = {
    yes: "Yes",
    place: "No"
};
const frame13654Data = {
    ouinonProps: ouinon58Data
};
const ouinon59Data = {
    yes: "Yes",
    place: "No"
};
const frame13655Data = {
    ouinonProps: ouinon59Data
};
const ouinon60Data = {
    yes: "Yes",
    place: "No"
};
const frame13656Data = {
    ouinonProps: ouinon60Data
};
const buttonSecondary41Data = {
    children: "Customer Requirements 3",
    className: ""
};
const toggle41Data = {
    className: "toggle-58",
    buttonSecondaryProps: buttonSecondary41Data
};
const ouinon61Data = {
    yes: "Yes",
    place: "No"
};
const frame13657Data = {
    ouinonProps: ouinon61Data
};
const ouinon62Data = {
    yes: "Yes",
    place: "No"
};
const frame13658Data = {
    className: "frame-153-4",
    ouinonProps: ouinon62Data
};
const frame1335Data = {
    frame136Props: frame13658Data
};
const frame1445Data = {
    frame133Props: frame1335Data
};
const ouinon63Data = {
    yes: "Yes",
    place: "No"
};
const frame13659Data = {
    ouinonProps: ouinon63Data
};
const buttonSecondary42Data = {
    children: "1/7",
    className: "button-secondary-66"
};
const toggle42Data = {
    className: "toggle-59",
    buttonSecondaryProps: buttonSecondary42Data
};
const quality1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems2Props: navItems212Data,
    navItems3Props: navItems316Data,
    toggle1Props: toggle39Data,
    frame1361Props: frame13651Data,
    frame1362Props: frame13652Data,
    frame1363Props: frame13653Data,
    toggle2Props: toggle40Data,
    frame1364Props: frame13654Data,
    frame1365Props: frame13655Data,
    frame1366Props: frame13656Data,
    toggle3Props: toggle41Data,
    frame1367Props: frame13657Data,
    frame144Props: frame1445Data,
    frame1368Props: frame13659Data,
    toggle4Props: toggle42Data
};
const frame1172226Data = {
    children: "Existing Case"
};
const frame1162227Data = {
    children: "Reference Cases"
};
const frame1132234Data = {
    className: ""
};
const navItems317Data = {
    className: "nav-items-3-17",
    frame1172Props: frame1172226Data,
    frame1162Props: frame1162227Data,
    frame1132Props: frame1132234Data
};
const buttonSecondary43Data = {
    children: "External Providers 1",
    className: ""
};
const toggle43Data = {
    className: "toggle-28",
    buttonSecondaryProps: buttonSecondary43Data
};
const ouinon64Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-1"
};
const ouinon65Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-2"
};
const ouinon66Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-3"
};
const buttonSecondary44Data = {
    children: "External Providers 2",
    className: ""
};
const toggle44Data = {
    className: "toggle-28",
    buttonSecondaryProps: buttonSecondary44Data
};
const ouinon67Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-4"
};
const ouinon68Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-29"
};
const buttonSecondary45Data = {
    children: "Process Approach",
    className: ""
};
const toggle45Data = {
    className: "toggle-60",
    buttonSecondaryProps: buttonSecondary45Data
};
const ouinon69Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-5"
};
const ouinon70Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-6"
};
const ouinon71Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24-7"
};
const ouinon72Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-24"
};
const frame1111Data = {
    toggle1Props: toggle43Data,
    ouinon1Props: ouinon64Data,
    ouinon2Props: ouinon65Data,
    ouinon3Props: ouinon66Data,
    toggle2Props: toggle44Data,
    ouinon4Props: ouinon67Data,
    ouinon5Props: ouinon68Data,
    toggle3Props: toggle45Data,
    ouinon6Props: ouinon69Data,
    ouinon7Props: ouinon70Data,
    ouinon8Props: ouinon71Data,
    ouinon9Props: ouinon72Data
};
const buttonSecondary46Data = {
    children: "7/7",
    className: "button-secondary-67"
};
const toggle46Data = {
    className: "toggle-61",
    buttonSecondaryProps: buttonSecondary46Data
};
const quality7Data = {
    navItems3Props: navItems317Data,
    frame111Props: frame1111Data,
    toggleProps: toggle46Data
};
const frame1172227Data = {
    children: "Existing Case"
};
const frame1162228Data = {
    children: "Reference Cases"
};
const frame1132235Data = {
    className: ""
};
const navItems318Data = {
    className: "nav-items-3-18",
    frame1172Props: frame1172227Data,
    frame1162Props: frame1162228Data,
    frame1132Props: frame1132235Data
};
const buttonSecondary47Data = {
    children: "Pollution de l'eau et des Sols",
    className: ""
};
const toggle47Data = {
    className: "toggle-2",
    buttonSecondaryProps: buttonSecondary47Data
};
const ouinon73Data = {
    yes: "Yes",
    place: "No"
};
const frame13660Data = {
    className: "frame-136",
    ouinonProps: ouinon73Data
};
const frame1336Data = {
    className: "frame-133-2",
    frame136Props: frame13660Data
};
const ouinon74Data = {
    yes: "Yes",
    place: "No"
};
const frame13661Data = {
    className: "frame-130",
    ouinonProps: ouinon74Data
};
const ouinon75Data = {
    yes: "Yes",
    place: "No"
};
const frame13662Data = {
    className: "frame-133",
    ouinonProps: ouinon75Data
};
const ouinon76Data = {
    yes: "Yes",
    place: "No"
};
const frame13663Data = {
    className: "frame-134",
    ouinonProps: ouinon76Data
};
const ouinon77Data = {
    yes: "Yes",
    place: "No"
};
const frame13664Data = {
    className: "frame-133-1",
    ouinonProps: ouinon77Data
};
const buttonSecondary48Data = {
    children: "Pollution de l'air",
    className: ""
};
const toggle48Data = {
    className: "toggle-2",
    buttonSecondaryProps: buttonSecondary48Data
};
const ouinon78Data = {
    yes: "Yes",
    place: "No"
};
const frame13665Data = {
    className: "frame-130-1",
    ouinonProps: ouinon78Data
};
const ouinon79Data = {
    yes: "Yes",
    place: "No"
};
const frame13666Data = {
    className: "frame-130-2",
    ouinonProps: ouinon79Data
};
const ouinon80Data = {
    yes: "Yes",
    place: "No"
};
const frame13667Data = {
    className: "frame-130-3",
    ouinonProps: ouinon80Data
};
const ouinon81Data = {
    yes: "Yes",
    place: "No"
};
const frame13668Data = {
    className: "frame-131",
    ouinonProps: ouinon81Data
};
const ouinon82Data = {
    yes: "Yes",
    place: "No"
};
const frame13669Data = {
    className: "frame-132",
    ouinonProps: ouinon82Data
};
const buttonSecondary49Data = {
    children: "2/5",
    className: "button-secondary-68"
};
const toggle49Data = {
    className: "x25",
    buttonSecondaryProps: buttonSecondary49Data
};
const environmental2Data = {
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType10: "text",
    inputPlaceholder10: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType11: "text",
    inputPlaceholder11: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems318Data,
    toggle1Props: toggle47Data,
    frame133Props: frame1336Data,
    frame1361Props: frame13661Data,
    frame1362Props: frame13662Data,
    frame1363Props: frame13663Data,
    frame1364Props: frame13664Data,
    toggle2Props: toggle48Data,
    frame1365Props: frame13665Data,
    frame1366Props: frame13666Data,
    frame1367Props: frame13667Data,
    frame1368Props: frame13668Data,
    frame1369Props: frame13669Data,
    toggle3Props: toggle49Data
};
const frame1172228Data = {
    children: "Existing Case"
};
const frame1162229Data = {
    children: "Reference Cases"
};
const frame1132236Data = {
    className: ""
};
const navItems319Data = {
    className: "nav-items-3-19",
    frame1172Props: frame1172228Data,
    frame1162Props: frame1162229Data,
    frame1132Props: frame1132236Data
};
const buttonSecondary50Data = {
    children: "Energie",
    className: ""
};
const toggle50Data = {
    className: "toggle-62",
    buttonSecondaryProps: buttonSecondary50Data
};
const ouinon83Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-30"
};
const ouinon84Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-20"
};
const ouinon85Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-20"
};
const buttonSecondary51Data = {
    children: "Biodiversit\xe9",
    className: ""
};
const toggle51Data = {
    className: "toggle-63",
    buttonSecondaryProps: buttonSecondary51Data
};
const ouinon86Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-21"
};
const ouinon87Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-31"
};
const ouinon88Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-21"
};
const buttonSecondary52Data = {
    children: "3/5",
    className: "button-secondary-69"
};
const toggle52Data = {
    className: "toggle-64",
    buttonSecondaryProps: buttonSecondary52Data
};
const environmental3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems319Data,
    toggle1Props: toggle50Data,
    ouinon1Props: ouinon83Data,
    ouinon2Props: ouinon84Data,
    ouinon3Props: ouinon85Data,
    toggle2Props: toggle51Data,
    ouinon4Props: ouinon86Data,
    ouinon5Props: ouinon87Data,
    ouinon6Props: ouinon88Data,
    toggle3Props: toggle52Data
};
const frame1172229Data = {
    children: "Existing Case"
};
const frame1162230Data = {
    children: "Reference Cases"
};
const frame1132237Data = {
    className: ""
};
const navItems320Data = {
    className: "nav-items-3-20",
    frame1172Props: frame1172229Data,
    frame1162Props: frame1162230Data,
    frame1132Props: frame1132237Data
};
const buttonSecondary53Data = {
    children: "Emploi/Relation Employeur- employ\xe9 3",
    className: ""
};
const toggle53Data = {
    className: "toggle-65",
    buttonSecondaryProps: buttonSecondary53Data
};
const ouinon89Data = {
    yes: "Yes",
    place: "No"
};
const frame13670Data = {
    ouinonProps: ouinon89Data
};
const ouinon90Data = {
    yes: "Yes",
    place: "No"
};
const frame13671Data = {
    ouinonProps: ouinon90Data
};
const ouinon91Data = {
    yes: "Yes",
    place: "No"
};
const frame13672Data = {
    ouinonProps: ouinon91Data
};
const buttonSecondary54Data = {
    children: "2/6",
    className: "button-secondary-71"
};
const toggle54Data = {
    className: "toggle-66",
    buttonSecondaryProps: buttonSecondary54Data
};
const social2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems320Data,
    toggle1Props: toggle53Data,
    frame1361Props: frame13670Data,
    frame1362Props: frame13671Data,
    frame1363Props: frame13672Data,
    toggle2Props: toggle54Data
};
const frame1172230Data = {
    children: "Existing Case"
};
const frame1162231Data = {
    children: "Reference Cases"
};
const frame1132238Data = {
    className: ""
};
const navItems321Data = {
    className: "nav-items-3-21",
    frame1172Props: frame1172230Data,
    frame1162Props: frame1162231Data,
    frame1132Props: frame1132238Data
};
const buttonSecondary55Data = {
    children: "Big data and cloud computing 1",
    className: ""
};
const toggle55Data = {
    className: "toggle-3",
    buttonSecondaryProps: buttonSecondary55Data
};
const ouinon92Data = {
    yes: "Yes",
    place: "No"
};
const frame13673Data = {
    ouinonProps: ouinon92Data
};
const ouinon93Data = {
    yes: "Yes",
    place: "No"
};
const frame13674Data = {
    ouinonProps: ouinon93Data
};
const ouinon94Data = {
    yes: "Yes",
    place: "No"
};
const frame13675Data = {
    ouinonProps: ouinon94Data
};
const buttonSecondary56Data = {
    children: "Big data and cloud computing 2",
    className: ""
};
const toggle56Data = {
    className: "toggle-3",
    buttonSecondaryProps: buttonSecondary56Data
};
const ouinon95Data = {
    yes: "Yes",
    place: "No"
};
const frame13676Data = {
    ouinonProps: ouinon95Data
};
const ouinon96Data = {
    yes: "Yes",
    place: "No"
};
const frame13677Data = {
    className: "frame-153-5",
    ouinonProps: ouinon96Data
};
const frame1337Data = {
    frame136Props: frame13677Data
};
const frame1446Data = {
    frame133Props: frame1337Data
};
const ouinon97Data = {
    yes: "Yes",
    place: "No"
};
const frame13678Data = {
    ouinonProps: ouinon97Data
};
const ouinon98Data = {
    yes: "Yes",
    place: "No"
};
const frame13679Data = {
    ouinonProps: ouinon98Data
};
const buttonSecondary57Data = {
    children: "2/4",
    className: "button-secondary-72"
};
const toggle57Data = {
    className: "toggle-67",
    buttonSecondaryProps: buttonSecondary57Data
};
const modernization2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    next: "Next",
    navItems3Props: navItems321Data,
    toggle1Props: toggle55Data,
    frame1361Props: frame13673Data,
    frame1362Props: frame13674Data,
    frame1363Props: frame13675Data,
    toggle2Props: toggle56Data,
    frame1364Props: frame13676Data,
    frame144Props: frame1446Data,
    frame1365Props: frame13678Data,
    frame1366Props: frame13679Data,
    toggle3Props: toggle57Data
};
const frame1172231Data = {
    children: "Existing Case"
};
const frame1162232Data = {
    children: "Reference Cases"
};
const frame1132239Data = {
    className: ""
};
const navItems322Data = {
    className: "nav-items-3-22",
    frame1172Props: frame1172231Data,
    frame1162Props: frame1162232Data,
    frame1132Props: frame1132239Data
};
const buttonSecondary58Data = {
    children: "Resources",
    className: ""
};
const toggle58Data = {
    className: "toggle-68",
    buttonSecondaryProps: buttonSecondary58Data
};
const ouinon99Data = {
    yes: "Yes",
    place: "No"
};
const frame13680Data = {
    ouinonProps: ouinon99Data
};
const ouinon100Data = {
    yes: "Yes",
    place: "No"
};
const frame13681Data = {
    ouinonProps: ouinon100Data
};
const ouinon101Data = {
    yes: "Yes",
    place: "No"
};
const frame13682Data = {
    ouinonProps: ouinon101Data
};
const ouinon102Data = {
    yes: "Yes",
    place: "No"
};
const frame13683Data = {
    ouinonProps: ouinon102Data
};
const ouinon103Data = {
    yes: "Yes",
    place: "No"
};
const frame13684Data = {
    ouinonProps: ouinon103Data
};
const buttonSecondary59Data = {
    children: "Product 1",
    className: ""
};
const toggle59Data = {
    className: "toggle-69",
    buttonSecondaryProps: buttonSecondary59Data
};
const ouinon104Data = {
    yes: "Yes",
    place: "No"
};
const frame13685Data = {
    ouinonProps: ouinon104Data
};
const ouinon105Data = {
    yes: "Yes",
    place: "No"
};
const frame13686Data = {
    ouinonProps: ouinon105Data
};
const ouinon106Data = {
    yes: "Yes",
    place: "No"
};
const frame13687Data = {
    ouinonProps: ouinon106Data
};
const ouinon107Data = {
    yes: "Yes",
    place: "No"
};
const frame13688Data = {
    ouinonProps: ouinon107Data
};
const buttonSecondary60Data = {
    children: "2/2",
    className: "button-secondary-73"
};
const toggle60Data = {
    className: "toggle-70",
    buttonSecondaryProps: buttonSecondary60Data
};
const cost2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    qualityCriteria: "Quality  criteria",
    navItems3Props: navItems322Data,
    toggle1Props: toggle58Data,
    frame1361Props: frame13680Data,
    frame1362Props: frame13681Data,
    frame1363Props: frame13682Data,
    frame1364Props: frame13683Data,
    frame1365Props: frame13684Data,
    toggle2Props: toggle59Data,
    frame1366Props: frame13685Data,
    frame1367Props: frame13686Data,
    frame1368Props: frame13687Data,
    frame1369Props: frame13688Data,
    toggle3Props: toggle60Data
};
const frame1172232Data = {
    children: "Existing Case"
};
const frame1162233Data = {
    children: "Reference Cases"
};
const frame1132240Data = {
    className: ""
};
const navItems323Data = {
    className: "nav-items-3-23",
    frame1172Props: frame1172232Data,
    frame1162Props: frame1162233Data,
    frame1132Props: frame1132240Data
};
const buttonSecondary61Data = {
    children: "Manufacturing",
    className: ""
};
const toggle61Data = {
    className: "toggle-71",
    buttonSecondaryProps: buttonSecondary61Data
};
const ouinon108Data = {
    yes: "Yes",
    place: "No"
};
const frame13689Data = {
    ouinonProps: ouinon108Data
};
const ouinon109Data = {
    yes: "Yes",
    place: "No"
};
const frame13690Data = {
    ouinonProps: ouinon109Data
};
const ouinon110Data = {
    yes: "Yes",
    place: "No"
};
const frame13691Data = {
    ouinonProps: ouinon110Data
};
const buttonSecondary62Data = {
    children: "Storage",
    className: ""
};
const toggle62Data = {
    className: "toggle-72",
    buttonSecondaryProps: buttonSecondary62Data
};
const ouinon111Data = {
    yes: "Yes",
    place: "No"
};
const frame13692Data = {
    ouinonProps: ouinon111Data
};
const ouinon112Data = {
    yes: "Yes",
    place: "No"
};
const frame13693Data = {
    ouinonProps: ouinon112Data
};
const ouinon113Data = {
    yes: "Yes",
    place: "No"
};
const frame13694Data = {
    ouinonProps: ouinon113Data
};
const buttonSecondary63Data = {
    children: "Delivery",
    className: ""
};
const toggle63Data = {
    className: "toggle-73",
    buttonSecondaryProps: buttonSecondary63Data
};
const ouinon114Data = {
    yes: "Yes",
    place: "No"
};
const frame13695Data = {
    ouinonProps: ouinon114Data
};
const ouinon115Data = {
    yes: "Yes",
    place: "No"
};
const frame13696Data = {
    className: "frame-153-6",
    ouinonProps: ouinon115Data
};
const frame1338Data = {
    frame136Props: frame13696Data
};
const frame1447Data = {
    frame133Props: frame1338Data
};
const ouinon116Data = {
    yes: "Yes",
    place: "No"
};
const frame13697Data = {
    ouinonProps: ouinon116Data
};
const ouinon117Data = {
    yes: "Yes",
    place: "No"
};
const frame13698Data = {
    className: "frame-146",
    ouinonProps: ouinon117Data
};
const buttonSecondary64Data = {
    children: "2/2",
    className: "button-secondary-74"
};
const toggle64Data = {
    className: "toggle-74",
    buttonSecondaryProps: buttonSecondary64Data
};
const leadTime2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType10: "text",
    inputPlaceholder10: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    costCriteria: "Cost criteria",
    navItems3Props: navItems323Data,
    toggle1Props: toggle61Data,
    frame1361Props: frame13689Data,
    frame1362Props: frame13690Data,
    frame1363Props: frame13691Data,
    toggle2Props: toggle62Data,
    frame1364Props: frame13692Data,
    frame1365Props: frame13693Data,
    frame1366Props: frame13694Data,
    toggle3Props: toggle63Data,
    frame1367Props: frame13695Data,
    frame144Props: frame1447Data,
    frame1368Props: frame13697Data,
    frame1369Props: frame13698Data,
    toggle4Props: toggle64Data
};
const frame1172233Data = {
    children: "Existing Case"
};
const frame1162234Data = {
    children: "Reference Cases"
};
const frame1132241Data = {
    className: ""
};
const navItems324Data = {
    className: "nav-items-3-24",
    frame1172Props: frame1172233Data,
    frame1162Props: frame1162234Data,
    frame1132Props: frame1132241Data
};
const buttonSecondary65Data = {
    children: "Traceability",
    className: ""
};
const toggle65Data = {
    className: "toggle-75",
    buttonSecondaryProps: buttonSecondary65Data
};
const ouinon118Data = {
    yes: "Yes",
    place: "No"
};
const frame13699Data = {
    ouinonProps: ouinon118Data
};
const ouinon119Data = {
    yes: "Yes",
    place: "No"
};
const frame136100Data = {
    ouinonProps: ouinon119Data
};
const ouinon120Data = {
    yes: "Yes",
    place: "No"
};
const frame136101Data = {
    ouinonProps: ouinon120Data
};
const ouinon121Data = {
    yes: "Yes",
    place: "No"
};
const frame136102Data = {
    ouinonProps: ouinon121Data
};
const buttonSecondary66Data = {
    children: "Improvement 1",
    className: ""
};
const toggle66Data = {
    className: "toggle-76",
    buttonSecondaryProps: buttonSecondary66Data
};
const ouinon122Data = {
    yes: "Yes",
    place: "No"
};
const frame136103Data = {
    ouinonProps: ouinon122Data
};
const ouinon123Data = {
    yes: "Yes",
    place: "No"
};
const frame136104Data = {
    ouinonProps: ouinon123Data
};
const ouinon124Data = {
    yes: "Yes",
    place: "No"
};
const frame136105Data = {
    ouinonProps: ouinon124Data
};
const ouinon125Data = {
    yes: "Yes",
    place: "No"
};
const frame136106Data = {
    ouinonProps: ouinon125Data
};
const buttonSecondary67Data = {
    children: "Improvement 2",
    className: "button-secondary-75"
};
const toggle67Data = {
    className: "toggle-77",
    buttonSecondaryProps: buttonSecondary67Data
};
const ouinon126Data = {
    yes: "Yes",
    place: "No"
};
const frame136107Data = {
    ouinonProps: ouinon126Data
};
const ouinon127Data = {
    yes: "Yes",
    place: "No"
};
const frame136108Data = {
    ouinonProps: ouinon127Data
};
const ouinon128Data = {
    yes: "Yes",
    place: "No"
};
const frame136109Data = {
    ouinonProps: ouinon128Data
};
const buttonSecondary68Data = {
    children: "6/7",
    className: "button-secondary-76"
};
const toggle68Data = {
    className: "toggle-78",
    buttonSecondaryProps: buttonSecondary68Data
};
const quality6Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType8: "text",
    inputPlaceholder8: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType10: "text",
    inputPlaceholder10: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType11: "text",
    inputPlaceholder11: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems324Data,
    toggle1Props: toggle65Data,
    frame1361Props: frame13699Data,
    frame1362Props: frame136100Data,
    frame1363Props: frame136101Data,
    frame1364Props: frame136102Data,
    toggle2Props: toggle66Data,
    frame1365Props: frame136103Data,
    frame1366Props: frame136104Data,
    frame1367Props: frame136105Data,
    frame1368Props: frame136106Data,
    toggle3Props: toggle67Data,
    frame1369Props: frame136107Data,
    frame13610Props: frame136108Data,
    frame13611Props: frame136109Data,
    toggle4Props: toggle68Data
};
const navItems221Data = {
    className: "nav-items-2-22"
};
const frame1172234Data = {
    children: "Existing Case"
};
const frame1162235Data = {
    children: "Reference Cases"
};
const frame1132242Data = {
    className: ""
};
const navItems325Data = {
    className: "nav-items-3-25",
    frame1172Props: frame1172234Data,
    frame1162Props: frame1162235Data,
    frame1132Props: frame1132242Data
};
const buttonSecondary69Data = {
    children: "2/2",
    className: "button-secondary-77"
};
const toggle69Data = {
    className: "toggle-79",
    buttonSecondaryProps: buttonSecondary69Data
};
const informationalModel3Data = {
    navItems2Props: navItems221Data,
    navItems3Props: navItems325Data,
    toggleProps: toggle69Data
};
const frame1172235Data = {
    children: "Existing Case"
};
const frame1162236Data = {
    children: "Reference Cases"
};
const frame1132243Data = {
    className: ""
};
const navItems326Data = {
    className: "nav-items-3-26",
    frame1172Props: frame1172235Data,
    frame1162Props: frame1162236Data,
    frame1132Props: frame1132243Data
};
const buttonSecondary70Data = {
    children: "1/2",
    className: "button-secondary-31"
};
const toggle70Data = {
    className: "toggle-80",
    buttonSecondaryProps: buttonSecondary70Data
};
const buttonSecondary71Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-31"
};
const toggle71Data = {
    className: "toggle-11",
    buttonSecondaryProps: buttonSecondary71Data
};
const group10241Data = {
    line24: "/img/line-24-80.png"
};
const group10242Data = {
    line24: "/img/line-24-81.png"
};
const group10243Data = {
    line24: "/img/line-24-42.png"
};
const group10244Data = {
    line24: "/img/line-24-83.png"
};
const group10245Data = {
    line24: "/img/line-24-84.png"
};
const buttonSecondary72Data = {
    children: "Career evolution",
    className: "button-secondary-31"
};
const toggle72Data = {
    className: "toggle-11",
    buttonSecondaryProps: buttonSecondary72Data
};
const group10246Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10247Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10248Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10249Data = {
    line24: "/img/line-24-8.png",
    className: ""
};
const group10250Data = {
    line24: "/img/line-24-9.png",
    className: ""
};
const frame971Data = {
    toggleProps: toggle72Data,
    group1021Props: group10246Data,
    group1022Props: group10247Data,
    group1023Props: group10248Data,
    group1024Props: group10249Data,
    group1025Props: group10250Data
};
const frame1173216Data = {
    className: "frame-113-49"
};
const informationalModel2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
    inputType2: "text",
    inputPlaceholder2: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
    inputType3: "text",
    inputPlaceholder3: "Garantissez vous l\u2019\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
    inputType4: "text",
    inputPlaceholder4: "Quel management utilisez vous?",
    inputType5: "text",
    inputPlaceholder5: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
    navItems3Props: navItems326Data,
    toggle1Props: toggle70Data,
    toggle2Props: toggle71Data,
    group1021Props: group10241Data,
    group1022Props: group10242Data,
    group1023Props: group10243Data,
    group1024Props: group10244Data,
    group1025Props: group10245Data,
    frame97Props: frame971Data,
    frame11732Props: frame1173216Data
};
const navItems225Data = {
    className: "nav-items-2-24"
};
const frame1172236Data = {
    children: "Existing Case"
};
const frame1162237Data = {
    children: "Reference Cases"
};
const frame1132244Data = {
    className: ""
};
const navItems327Data = {
    className: "nav-items-3-27",
    frame1172Props: frame1172236Data,
    frame1162Props: frame1162237Data,
    frame1132Props: frame1132244Data
};
const buttonSecondary73Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-32"
};
const toggle73Data = {
    className: "toggle-12",
    buttonSecondaryProps: buttonSecondary73Data
};
const group10251Data = {
    line24: "/img/line-24-80.png"
};
const group10252Data = {
    line24: "/img/line-24-81.png"
};
const group10253Data = {
    line24: "/img/line-24-82.png",
    className: ""
};
const group10254Data = {
    line24: "/img/line-24-83.png",
    className: ""
};
const group10255Data = {
    line24: "/img/line-24-84.png",
    className: ""
};
const frame961Data = {
    toggleProps: toggle73Data,
    group1021Props: group10251Data,
    group1022Props: group10252Data,
    group1023Props: group10253Data,
    group1024Props: group10254Data,
    group1025Props: group10255Data
};
const buttonSecondary74Data = {
    children: "Career evolution",
    className: "button-secondary-32"
};
const toggle74Data = {
    className: "toggle-12",
    buttonSecondaryProps: buttonSecondary74Data
};
const group10256Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10257Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10258Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group10259Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group10260Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame972Data = {
    className: "frame-97-5",
    toggleProps: toggle74Data,
    group1021Props: group10256Data,
    group1022Props: group10257Data,
    group1023Props: group10258Data,
    group1024Props: group10259Data,
    group1025Props: group10260Data
};
const frame1173217Data = {
    className: "frame-113-50"
};
const buttonSecondary75Data = {
    children: "1/2",
    className: "button-secondary-32"
};
const toggle75Data = {
    className: "toggle-81",
    buttonSecondaryProps: buttonSecondary75Data
};
const processView2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems225Data,
    navItems3Props: navItems327Data,
    frame96Props: frame961Data,
    frame97Props: frame972Data,
    frame11732Props: frame1173217Data,
    toggleProps: toggle75Data
};
const frame1172237Data = {
    children: "Existing Case"
};
const frame1162238Data = {
    children: "Reference Cases"
};
const frame1132245Data = {
    className: ""
};
const navItems328Data = {
    className: "nav-items-3-28",
    frame1172Props: frame1172237Data,
    frame1162Props: frame1162238Data,
    frame1132Props: frame1132245Data
};
const buttonSecondary76Data = {
    children: "Customer Satisfaction 1",
    className: ""
};
const toggle76Data = {
    className: "toggle-82",
    buttonSecondaryProps: buttonSecondary76Data
};
const ouinon129Data = {
    yes: "Yes",
    place: "No"
};
const frame136110Data = {
    ouinonProps: ouinon129Data
};
const ouinon130Data = {
    yes: "Yes",
    place: "No"
};
const frame136111Data = {
    ouinonProps: ouinon130Data
};
const ouinon131Data = {
    yes: "Yes",
    place: "No"
};
const frame136112Data = {
    ouinonProps: ouinon131Data
};
const buttonSecondary77Data = {
    children: "Customer Satisfaction 2",
    className: ""
};
const toggle77Data = {
    className: "toggle-83",
    buttonSecondaryProps: buttonSecondary77Data
};
const ouinon132Data = {
    yes: "Yes",
    place: "No"
};
const frame136113Data = {
    ouinonProps: ouinon132Data
};
const ouinon133Data = {
    yes: "Yes",
    place: "No"
};
const frame136114Data = {
    ouinonProps: ouinon133Data
};
const ouinon134Data = {
    yes: "Yes",
    place: "No"
};
const frame136115Data = {
    ouinonProps: ouinon134Data
};
const buttonSecondary78Data = {
    children: "Communication with employees",
    className: "button-secondary-78"
};
const toggle78Data = {
    className: "toggle-84",
    buttonSecondaryProps: buttonSecondary78Data
};
const ouinon135Data = {
    yes: "Yes",
    place: "No"
};
const frame136116Data = {
    ouinonProps: ouinon135Data
};
const buttonSecondary79Data = {
    children: "2/7",
    className: "button-secondary-79"
};
const toggle79Data = {
    className: "toggle-85",
    buttonSecondaryProps: buttonSecondary79Data
};
const quality2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems328Data,
    toggle1Props: toggle76Data,
    frame1361Props: frame136110Data,
    frame1362Props: frame136111Data,
    frame1363Props: frame136112Data,
    toggle2Props: toggle77Data,
    frame1364Props: frame136113Data,
    frame1365Props: frame136114Data,
    frame1366Props: frame136115Data,
    toggle3Props: toggle78Data,
    frame1367Props: frame136116Data,
    toggle4Props: toggle79Data
};
const navItems227Data = {
    className: "nav-items-2-26"
};
const frame1172238Data = {
    children: "Existing Case"
};
const frame1162239Data = {
    children: "Reference Cases"
};
const frame1132246Data = {
    className: ""
};
const navItems329Data = {
    className: "nav-items-3-29",
    frame1172Props: frame1172238Data,
    frame1162Props: frame1162239Data,
    frame1132Props: frame1132246Data
};
const buttonSecondary80Data = {
    children: "2/2",
    className: "button-secondary-80"
};
const toggle80Data = {
    className: "toggle-86",
    buttonSecondaryProps: buttonSecondary80Data
};
const processView3Data = {
    navItems2Props: navItems227Data,
    navItems3Props: navItems329Data,
    toggleProps: toggle80Data
};
const navItems228Data = {
    className: "nav-items-2-27"
};
const frame1172239Data = {
    children: "Existing Case"
};
const frame1162240Data = {
    children: "Reference Cases"
};
const frame1132247Data = {
    className: ""
};
const navItems330Data = {
    className: "nav-items-3-30",
    frame1172Props: frame1172239Data,
    frame1162Props: frame1162240Data,
    frame1132Props: frame1132247Data
};
const frame1173219Data = {
    className: "frame-113-52"
};
const buttonSecondary81Data = {
    children: "1/2",
    className: "button-secondary-33"
};
const toggle81Data = {
    className: "toggle-87",
    buttonSecondaryProps: buttonSecondary81Data
};
const buttonSecondary82Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-33"
};
const toggle82Data = {
    className: "toggle-13",
    buttonSecondaryProps: buttonSecondary82Data
};
const group10261Data = {
    line24: "/img/line-24-80.png"
};
const group10262Data = {
    line24: "/img/line-24-81.png"
};
const group10263Data = {
    line24: "/img/line-24-62.png",
    className: "group-6-2"
};
const group10264Data = {
    line24: "/img/line-24-83.png",
    className: "group-6-3"
};
const group10265Data = {
    line24: "/img/line-24-84.png",
    className: "group-6-4"
};
const frame962Data = {
    className: "frame-94-2",
    toggleProps: toggle82Data,
    group1021Props: group10261Data,
    group1022Props: group10262Data,
    group1023Props: group10263Data,
    group1024Props: group10264Data,
    group1025Props: group10265Data
};
const buttonSecondary83Data = {
    children: "Career evolution",
    className: "button-secondary-33"
};
const toggle83Data = {
    className: "toggle-13",
    buttonSecondaryProps: buttonSecondary83Data
};
const group10266Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10267Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10268Data = {
    line24: "/img/line-24-7.png",
    className: "group-6-5"
};
const group10269Data = {
    line24: "/img/line-24-18.png",
    className: "group-6-6"
};
const group10270Data = {
    line24: "/img/line-24-19.png",
    className: "group-6"
};
const frame973Data = {
    className: "frame-95-4",
    toggleProps: toggle83Data,
    group1021Props: group10266Data,
    group1022Props: group10267Data,
    group1023Props: group10268Data,
    group1024Props: group10269Data,
    group1025Props: group10270Data
};
const decisionalView2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems228Data,
    navItems3Props: navItems330Data,
    frame11732Props: frame1173219Data,
    toggleProps: toggle81Data,
    frame96Props: frame962Data,
    frame97Props: frame973Data
};
const navItems229Data = {
    className: "nav-items-2-28"
};
const frame1172240Data = {
    children: "Existing Case"
};
const frame1162241Data = {
    children: "Reference Cases"
};
const frame1132248Data = {
    className: ""
};
const navItems331Data = {
    className: "nav-items-3-31",
    frame1172Props: frame1172240Data,
    frame1162Props: frame1162241Data,
    frame1132Props: frame1132248Data
};
const buttonSecondary84Data = {
    children: "1/2",
    className: "button-secondary-34"
};
const toggle84Data = {
    className: "toggle-88",
    buttonSecondaryProps: buttonSecondary84Data
};
const buttonSecondary85Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-34"
};
const toggle85Data = {
    className: "toggle-14",
    buttonSecondaryProps: buttonSecondary85Data
};
const group10271Data = {
    line24: "/img/line-24-80.png",
    className: "group-7-1"
};
const group10272Data = {
    line24: "/img/line-24-81.png",
    className: "group-7-2"
};
const group10273Data = {
    line24: "/img/line-24-42.png",
    className: "group-7-3"
};
const group10274Data = {
    line24: "/img/line-24-83.png",
    className: "group-7-4"
};
const group10275Data = {
    line24: "/img/line-24-84.png",
    className: "group-7-5"
};
const frame921Data = {
    toggleProps: toggle85Data,
    group1021Props: group10271Data,
    group1022Props: group10272Data,
    group1023Props: group10273Data,
    group1024Props: group10274Data,
    group1025Props: group10275Data
};
const frame1173220Data = {
    className: "frame-113-53"
};
const buttonSecondary86Data = {
    children: "Career evolution",
    className: "button-secondary-34"
};
const toggle86Data = {
    className: "toggle-14",
    buttonSecondaryProps: buttonSecondary86Data
};
const group10276Data = {
    line24: "/img/line-24-5.png",
    className: "group-7-6"
};
const group10277Data = {
    line24: "/img/line-24-6.png",
    className: "group-7-7"
};
const group10278Data = {
    line24: "/img/line-24-7.png",
    className: "group-7-8"
};
const group10279Data = {
    line24: "/img/line-24-18.png",
    className: "group-7-9"
};
const group10280Data = {
    line24: "/img/line-24-19.png",
    className: "group-7"
};
const frame974Data = {
    className: "frame-93",
    toggleProps: toggle86Data,
    group1021Props: group10276Data,
    group1022Props: group10277Data,
    group1023Props: group10278Data,
    group1024Props: group10279Data,
    group1025Props: group10280Data
};
const physicalModel2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems229Data,
    navItems3Props: navItems331Data,
    toggleProps: toggle84Data,
    frame92Props: frame921Data,
    frame11732Props: frame1173220Data,
    frame97Props: frame974Data
};
const navItems230Data = {
    className: "nav-items-2-29"
};
const frame1172241Data = {
    children: "Existing Case"
};
const frame1162242Data = {
    children: "Reference Cases"
};
const frame1132249Data = {
    className: ""
};
const navItems332Data = {
    className: "nav-items-3-32",
    frame1172Props: frame1172241Data,
    frame1162Props: frame1162242Data,
    frame1132Props: frame1132249Data
};
const buttonSecondary87Data = {
    children: "2/2",
    className: "button-secondary-35"
};
const toggle87Data = {
    className: "toggle-89",
    buttonSecondaryProps: buttonSecondary87Data
};
const buttonSecondary88Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-35"
};
const toggle88Data = {
    className: "toggle-15",
    buttonSecondaryProps: buttonSecondary88Data
};
const group10281Data = {
    line24: "/img/line-24-80.png",
    className: "group-8-1"
};
const group10282Data = {
    line24: "/img/line-24-81.png",
    className: "group-8-2"
};
const group10283Data = {
    line24: "/img/line-24-62.png",
    className: "group-8-3"
};
const group10284Data = {
    line24: "/img/line-24-83.png",
    className: "group-8-4"
};
const group10285Data = {
    line24: "/img/line-24-84.png",
    className: "group-8-5"
};
const frame922Data = {
    className: "frame-92-1",
    toggleProps: toggle88Data,
    group1021Props: group10281Data,
    group1022Props: group10282Data,
    group1023Props: group10283Data,
    group1024Props: group10284Data,
    group1025Props: group10285Data
};
const buttonSecondary89Data = {
    children: "Career evolution",
    className: "button-secondary-35"
};
const toggle89Data = {
    className: "toggle-15",
    buttonSecondaryProps: buttonSecondary89Data
};
const group10286Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group10287Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group10288Data = {
    line24: "/img/line-24-7.png",
    className: "group-8-6"
};
const group10289Data = {
    line24: "/img/line-24-18.png",
    className: "group-8-7"
};
const group10290Data = {
    line24: "/img/line-24-19.png",
    className: "group-8"
};
const frame931Data = {
    toggleProps: toggle89Data,
    group1021Props: group10286Data,
    group1022Props: group10287Data,
    group1023Props: group10288Data,
    group1024Props: group10289Data,
    group1025Props: group10290Data
};
const decisionalView3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    procesView: "Proces view",
    navItems2Props: navItems230Data,
    navItems3Props: navItems332Data,
    toggleProps: toggle87Data,
    frame92Props: frame922Data,
    frame93Props: frame931Data
};
const frame1172242Data = {
    children: "Existing Case"
};
const frame1162243Data = {
    children: "Reference Cases"
};
const frame1132250Data = {
    className: ""
};
const navItems333Data = {
    className: "nav-items-3-33",
    frame1172Props: frame1172242Data,
    frame1162Props: frame1162243Data,
    frame1132Props: frame1132250Data
};
const buttonSecondary90Data = {
    children: "Internal Audit 1",
    className: ""
};
const toggle90Data = {
    className: "toggle-29",
    buttonSecondaryProps: buttonSecondary90Data
};
const ouinon136Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-1"
};
const ouinon137Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-2"
};
const ouinon138Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-3"
};
const buttonSecondary91Data = {
    children: "Internal Audit 2",
    className: ""
};
const toggle91Data = {
    className: "toggle-29",
    buttonSecondaryProps: buttonSecondary91Data
};
const ouinon139Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-4"
};
const ouinon140Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28-5"
};
const ouinon141Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-28"
};
const buttonSecondary92Data = {
    children: "5/7",
    className: "button-secondary-81"
};
const toggle92Data = {
    className: "toggle-90",
    buttonSecondaryProps: buttonSecondary92Data
};
const quality5Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre bilan carbone?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems333Data,
    toggle1Props: toggle90Data,
    ouinon1Props: ouinon136Data,
    ouinon2Props: ouinon137Data,
    ouinon3Props: ouinon138Data,
    toggle2Props: toggle91Data,
    ouinon4Props: ouinon139Data,
    ouinon5Props: ouinon140Data,
    ouinon6Props: ouinon141Data,
    toggle3Props: toggle92Data
};
const navItems232Data = {
    className: "nav-items-2-31"
};
const frame1172243Data = {
    children: "Existing Case"
};
const frame1162244Data = {
    children: "Reference Cases"
};
const frame1132251Data = {
    className: ""
};
const navItems334Data = {
    className: "nav-items-3-34",
    frame1172Props: frame1172243Data,
    frame1162Props: frame1162244Data,
    frame1132Props: frame1132251Data
};
const buttonSecondary93Data = {
    children: "2/2",
    className: "button-secondary-36"
};
const toggle93Data = {
    className: "toggle-91",
    buttonSecondaryProps: buttonSecondary93Data
};
const buttonSecondary94Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-36"
};
const toggle94Data = {
    className: "toggle-16",
    buttonSecondaryProps: buttonSecondary94Data
};
const group10291Data = {
    line24: "/img/line-24-80.png",
    className: "group-10-1"
};
const group10292Data = {
    line24: "/img/line-24-81.png",
    className: "group-10-2"
};
const group10293Data = {
    line24: "/img/line-24-42.png",
    className: "group-10-3"
};
const group10294Data = {
    line24: "/img/line-24-83.png",
    className: "group-10-4"
};
const group10295Data = {
    line24: "/img/line-24-84.png",
    className: "group-10-5"
};
const frame923Data = {
    className: "frame-85",
    toggleProps: toggle94Data,
    group1021Props: group10291Data,
    group1022Props: group10292Data,
    group1023Props: group10293Data,
    group1024Props: group10294Data,
    group1025Props: group10295Data
};
const buttonSecondary95Data = {
    children: "Career evolution",
    className: "button-secondary-36"
};
const toggle95Data = {
    className: "toggle-16",
    buttonSecondaryProps: buttonSecondary95Data
};
const group10296Data = {
    line24: "/img/line-24-5.png",
    className: "group-10-6"
};
const group10297Data = {
    line24: "/img/line-24-6.png",
    className: "group-10-7"
};
const group10298Data = {
    line24: "/img/line-24-7.png",
    className: "group-10-8"
};
const group10299Data = {
    line24: "/img/line-24-18.png",
    className: "group-10-9"
};
const group102100Data = {
    line24: "/img/line-24-19.png",
    className: "group-10"
};
const frame932Data = {
    className: "frame-86",
    toggleProps: toggle95Data,
    group1021Props: group10296Data,
    group1022Props: group10297Data,
    group1023Props: group10298Data,
    group1024Props: group10299Data,
    group1025Props: group102100Data
};
const physicalModel3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    decisionalView: "Decisional View",
    navItems2Props: navItems232Data,
    navItems3Props: navItems334Data,
    toggleProps: toggle93Data,
    frame92Props: frame923Data,
    frame93Props: frame932Data
};
const navItems233Data = {
    className: "nav-items-2-32"
};
const frame1172244Data = {
    children: "Existing Case"
};
const frame1162245Data = {
    children: "Reference Cases"
};
const frame1132252Data = {
    className: ""
};
const navItems335Data = {
    className: "nav-items-3-35",
    frame1172Props: frame1172244Data,
    frame1162Props: frame1162245Data,
    frame1132Props: frame1132252Data
};
const buttonSecondary96Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-37"
};
const toggle96Data = {
    className: "toggle-17",
    buttonSecondaryProps: buttonSecondary96Data
};
const group102101Data = {
    line24: "/img/line-24-80.png",
    className: "group-11-1"
};
const group102102Data = {
    line24: "/img/line-24-81.png",
    className: "group-11-2"
};
const group102103Data = {
    line24: "/img/line-24-62.png",
    className: ""
};
const group102104Data = {
    line24: "/img/line-24-83.png",
    className: ""
};
const group102105Data = {
    line24: "/img/line-24-84.png",
    className: ""
};
const frame9222Data = {
    toggleProps: toggle96Data,
    group1021Props: group102101Data,
    group1022Props: group102102Data,
    group1023Props: group102103Data,
    group1024Props: group102104Data,
    group1025Props: group102105Data
};
const buttonSecondary97Data = {
    children: "Career evolution",
    className: "button-secondary-37"
};
const toggle97Data = {
    className: "toggle-17",
    buttonSecondaryProps: buttonSecondary97Data
};
const group102106Data = {
    line24: "/img/line-24-5.png",
    className: "group-11-3"
};
const group102107Data = {
    line24: "/img/line-24-6.png",
    className: "group-11-4"
};
const group102108Data = {
    line24: "/img/line-24-7.png",
    className: "group-11"
};
const group102109Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102110Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame933Data = {
    className: "frame-93-2",
    toggleProps: toggle97Data,
    group1021Props: group102106Data,
    group1022Props: group102107Data,
    group1023Props: group102108Data,
    group1024Props: group102109Data,
    group1025Props: group102110Data
};
const buttonSecondary98Data = {
    children: "1/3",
    className: "button-secondary-37"
};
const toggle98Data = {
    className: "toggle-92",
    buttonSecondaryProps: buttonSecondary98Data
};
const functionnalView2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems233Data,
    navItems3Props: navItems335Data,
    frame922Props: frame9222Data,
    frame93Props: frame933Data,
    toggleProps: toggle98Data
};
const navItems234Data = {
    className: "nav-items-2-33"
};
const frame1172245Data = {
    children: "Existing Case"
};
const frame1162246Data = {
    children: "Reference Cases"
};
const frame1132253Data = {
    className: ""
};
const navItems336Data = {
    className: "nav-items-3-36",
    frame1172Props: frame1172245Data,
    frame1162Props: frame1162246Data,
    frame1132Props: frame1132253Data
};
const buttonSecondary99Data = {
    children: "Strength of proposal and employee autonomy",
    className: "button-secondary-38"
};
const toggle99Data = {
    className: "toggle-18",
    buttonSecondaryProps: buttonSecondary99Data
};
const group102111Data = {
    line24: "/img/line-24-80.png",
    className: "group-12-1"
};
const group102112Data = {
    line24: "/img/line-24-81.png",
    className: "group-12-2"
};
const group102113Data = {
    line24: "/img/line-24-82.png",
    className: "group-12-3"
};
const group102114Data = {
    line24: "/img/line-24-83.png",
    className: "group-12-4"
};
const group102115Data = {
    line24: "/img/line-24-84.png",
    className: "group-12-5"
};
const frame9223Data = {
    className: "frame-85-1",
    toggleProps: toggle99Data,
    group1021Props: group102111Data,
    group1022Props: group102112Data,
    group1023Props: group102113Data,
    group1024Props: group102114Data,
    group1025Props: group102115Data
};
const buttonSecondary100Data = {
    children: "Career evolution",
    className: "button-secondary-38"
};
const toggle100Data = {
    className: "toggle-18",
    buttonSecondaryProps: buttonSecondary100Data
};
const group102116Data = {
    line24: "/img/line-24-5.png",
    className: "group-12-6"
};
const group102117Data = {
    line24: "/img/line-24-6.png",
    className: "group-12"
};
const group102118Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group102119Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102120Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame934Data = {
    className: "frame-86-1",
    toggleProps: toggle100Data,
    group1021Props: group102116Data,
    group1022Props: group102117Data,
    group1023Props: group102118Data,
    group1024Props: group102119Data,
    group1025Props: group102120Data
};
const frame1173223Data = {
    className: "frame-113-56"
};
const buttonSecondary101Data = {
    children: "2/3",
    className: "button-secondary-38"
};
const toggle101Data = {
    className: "toggle-93",
    buttonSecondaryProps: buttonSecondary101Data
};
const functionnalView3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems234Data,
    navItems3Props: navItems336Data,
    frame922Props: frame9223Data,
    frame93Props: frame934Data,
    frame11732Props: frame1173223Data,
    toggleProps: toggle101Data
};
const frame1172246Data = {
    children: "Existing Case"
};
const frame1162247Data = {
    children: "Reference Cases"
};
const frame1132254Data = {
    className: ""
};
const navItems337Data = {
    className: "nav-items-3-37",
    frame1172Props: frame1172246Data,
    frame1162Props: frame1162247Data,
    frame1132Props: frame1132254Data
};
const buttonSecondary102Data = {
    children: "Recycling",
    className: "button-secondary-39"
};
const toggle102Data = {
    className: "toggle-94",
    buttonSecondaryProps: buttonSecondary102Data
};
const group102121Data = {
    line24: "/img/line-24-120.png",
    className: "group-13-1"
};
const group102122Data = {
    line24: "/img/line-24-121.png",
    className: "group-13"
};
const group102123Data = {
    line24: "/img/line-24-122.png"
};
const group102124Data = {
    line24: "/img/line-24-123.png"
};
const buttonSecondary103Data = {
    children: "3/3",
    className: "button-secondary-39"
};
const toggle103Data = {
    className: "toggle-95",
    buttonSecondaryProps: buttonSecondary103Data
};
const functionnalView4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "En moyenne dans quelle p\xe9rim\xe8tre vous approvisionnez vous?",
    physicalModel: "Physical Model",
    navItems3Props: navItems337Data,
    toggle1Props: toggle102Data,
    group1021Props: group102121Data,
    group1022Props: group102122Data,
    group1023Props: group102123Data,
    group1024Props: group102124Data,
    toggle2Props: toggle103Data
};
const frame1172247Data = {
    children: "Existing Case"
};
const frame1162248Data = {
    children: "Reference Cases"
};
const frame1132255Data = {
    className: ""
};
const navItems338Data = {
    className: "nav-items-3-38",
    frame1172Props: frame1172247Data,
    frame1162Props: frame1162248Data,
    frame1132Props: frame1132255Data
};
const frame1121Data = {
    children: "Click here"
};
const loadingPageData = {
    navItems3Props: navItems338Data,
    frame112Props: frame1121Data
};
const frame11811Data = {
    children: "Visual management",
    className: "frame-113-27"
};
const headerMenuDefault3Data = {
    children: "Requirements",
    className: "menu-item-default-1"
};
const headerMenuDefault4Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Define,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Prepare,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Document"
        ]
    }),
    className: "menu-item-default-2"
};
const headerMenuDefault5Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Measure, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Compare"
        ]
    }),
    className: "menu-item-default-3"
};
const headerMenuDefault6Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Evaluate,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Correct"
        ]
    }),
    className: "menu-item-default-4"
};
const headerMenuDefault7Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Execute, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Code"
        ]
    }),
    className: "menu-item-default-5"
};
const headerMenuDefault8Data = {
    children: "Satisfaction",
    className: "menu-item-default-6"
};
const kaizen1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    overlapGroup11: "/img/arrow-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    overlapGroup4: "/img/arrow-2@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line4: "/img/line-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    label2: "Zoom",
    overlapGroup8: "/img/text-format@2x.png",
    textFormat: "/img/text-format@2x.png",
    label3: "Text",
    label4: "Text",
    overlapGroup17: "/img/line-1.png",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    inputType1: "text",
    inputPlaceholder1: "INPUT",
    arrow5: "/img/arrow-5-6@2x.png",
    arrow1: "/img/arrow-1-8@2x.png",
    inputType2: "text",
    inputPlaceholder2: "PLAN",
    arrow3: "/img/arrow-3-7@2x.png",
    arrow7: "/img/arrow-5-6@2x.png",
    inputType3: "text",
    inputPlaceholder3: "ACT",
    inputType4: "text",
    inputPlaceholder4: "DO",
    inputType5: "text",
    inputPlaceholder5: "CHECK",
    arrow4: "/img/arrow-4-7@2x.png",
    arrow6: "/img/arrow-5-6@2x.png",
    modeling: "Modeling",
    arrow2: "/img/arrow-2-8@2x.png",
    arrow8: "/img/arrow-5-6@2x.png",
    xcontinue: "Continue",
    inputType6: "text",
    inputPlaceholder6: "OUTPUT",
    frame118Props: frame11811Data,
    headerMenuDefault1Props: headerMenuDefault3Data,
    headerMenuDefault2Props: headerMenuDefault4Data,
    headerMenuDefault3Props: headerMenuDefault5Data,
    headerMenuDefault4Props: headerMenuDefault6Data,
    headerMenuDefault5Props: headerMenuDefault7Data,
    headerMenuDefault6Props: headerMenuDefault8Data
};
const frame1172248Data = {
    children: "Existing Case"
};
const frame1162249Data = {
    children: "Reference Cases"
};
const frame1132257Data = {
    className: ""
};
const navItems339Data = {
    className: "nav-items-3-39",
    frame1172Props: frame1172248Data,
    frame1162Props: frame1162249Data,
    frame1132Props: frame1132257Data
};
const buttonSecondary104Data = {
    children: "Functionnal View",
    className: "button-secondary-82"
};
const toggle104Data = {
    className: "toggle-96",
    buttonSecondaryProps: buttonSecondary104Data
};
const buttonSecondary105Data = {
    children: "3. Decisional View",
    className: "button-secondary-83"
};
const toggle105Data = {
    className: "toggle-97",
    buttonSecondaryProps: buttonSecondary105Data
};
const buttonSecondary106Data = {
    children: "2. Physical Model",
    className: "button-secondary-41"
};
const toggle106Data = {
    className: "toggle-31",
    buttonSecondaryProps: buttonSecondary106Data
};
const buttonSecondary107Data = {
    children: "4. Process view",
    className: "button-secondary-84"
};
const toggle107Data = {
    className: "toggle-98",
    buttonSecondaryProps: buttonSecondary107Data
};
const buttonSecondary108Data = {
    children: "5. Informational Model",
    className: "button-secondary-40"
};
const toggle108Data = {
    className: "toggle-99",
    buttonSecondaryProps: buttonSecondary108Data
};
const buttonSecondary109Data = {
    children: "Lean VSM",
    className: "button-secondary-40"
};
const toggle109Data = {
    className: "toggle-100",
    buttonSecondaryProps: buttonSecondary109Data
};
const buttonSecondary110Data = {
    children: "4. Kaizen",
    className: "button-secondary-40"
};
const toggle110Data = {
    className: "toggle-101",
    buttonSecondaryProps: buttonSecondary110Data
};
const buttonSecondary111Data = {
    children: "2. 5S",
    className: "button-secondary-40"
};
const toggle111Data = {
    className: "toggle-102",
    buttonSecondaryProps: buttonSecondary111Data
};
const buttonSecondary112Data = {
    children: "5. SMED",
    className: "button-secondary-40"
};
const toggle112Data = {
    className: "toggle-103",
    buttonSecondaryProps: buttonSecondary112Data
};
const buttonSecondary113Data = {
    children: "3. Kanban",
    className: "button-secondary-40"
};
const toggle113Data = {
    className: "toggle-104",
    buttonSecondaryProps: buttonSecondary113Data
};
const buttonSecondary114Data = {
    children: "6. Visual Management",
    className: "button-secondary-41"
};
const toggle114Data = {
    className: "toggle-31",
    buttonSecondaryProps: buttonSecondary114Data
};
const existingSystemsData = {
    ellipse116: "/img/polygon-3@2x.png",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    existingSystems: "EXISTING SYSTEMS",
    graiMethodologyModels: "GRAI METHODOLOGY MODELS",
    x2SupplementaryModels: "2.   SUPPLEMENTARY MODELS",
    navItems3Props: navItems339Data,
    toggle1Props: toggle104Data,
    toggle2Props: toggle105Data,
    toggle3Props: toggle106Data,
    toggle4Props: toggle107Data,
    toggle5Props: toggle108Data,
    toggle6Props: toggle109Data,
    toggle7Props: toggle110Data,
    toggle8Props: toggle111Data,
    toggle9Props: toggle112Data,
    toggle10Props: toggle113Data,
    toggle11Props: toggle114Data
};
const frame11354Data = {
    className: "frame-113-54"
};
const frame11812Data = {
    children: "Visual management"
};
const kanban1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    rectangle23: "/img/rectangle-23@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line22: "/img/line-22.png",
    place1: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    place2: "PLAN",
    arrow11: "/img/arrow-11-6.png",
    line4: "/img/line-4-4.png",
    inputType1: "text",
    inputPlaceholder1: "URGENCE",
    inputType2: "text",
    inputPlaceholder2: "A FAIRE",
    inputType3: "text",
    inputPlaceholder3: "TERMINE",
    inputType4: "text",
    inputPlaceholder4: "EN ATTENTE",
    inputType5: "text",
    inputPlaceholder5: "EN COURS",
    line3: "/img/line-3-5.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame1135Props: frame11354Data,
    frame118Props: frame11812Data
};
const frame11813Data = {
    children: "Visual management",
    className: "frame-113-30"
};
const headerMenuDefault42Data = {
    children: "Analysis"
};
const headerMenuDefault43Data = {
    children: "VSM Futur",
    className: "menu-item-default-24"
};
const headerMenuDefault44Data = {
    children: "Action Plan",
    className: "menu-item-default-25"
};
const headerMenuDefault45Data = {
    children: "Current VSM",
    className: "menu-item-default-23"
};
const headerMenuDefault46Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Definition de",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " la famille",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " de produits"
        ]
    }),
    className: "menu-item-default-26"
};
const leanVSMData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow4: "/img/arrow-4-4@2x.png",
    arrow6: "/img/arrow-4-4@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    xcontinue: "Continue",
    arrow1: "/img/arrow-1@2x.png",
    arrow2: "/img/arrow-2@2x.png",
    rectangle6: "/img/rectangle-7@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    arrow3: "/img/arrow-3-4@2x.png",
    modeling: "Modeling",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    frame118Props: frame11813Data,
    headerMenuDefault41Props: headerMenuDefault42Data,
    headerMenuDefault42Props: headerMenuDefault43Data,
    headerMenuDefault43Props: headerMenuDefault44Data,
    headerMenuDefault44Props: headerMenuDefault45Data,
    headerMenuDefault45Props: headerMenuDefault46Data
};
const frame11814Data = {
    children: "Visual management",
    className: "frame-113-31"
};
const sMED1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    label3: "FIN D\u2019USINAGE SERIE A",
    arrow5: "/img/arrow-5-6@2x.png",
    label4: "DEBUT D\u2019USINAGE SERIE B",
    arrow15: "/img/arrow-15-1@2x.png",
    arrow12: "/img/arrow-12-2@2x.png",
    arrow13: "/img/arrow-13-1@2x.png",
    dernierePieceBonneSerieA: "DERNIERE PIECE BONNE SERIE A",
    changementOutillage: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "CHANGEMENT",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " OUTILLAGE"
        ]
    }),
    reglage: "REGLAGE",
    inputType1: "text",
    inputPlaceholder1: "NETTOYAGE",
    arrow18: "/img/arrow-18@2x.png",
    arrow17: "/img/arrow-17@2x.png",
    arrow16: "/img/arrow-16-1@2x.png",
    inputType2: "text",
    inputPlaceholder2: "PREMIERE PIECE BONNE SERIE B",
    arrow14: "/img/arrow-15-1@2x.png",
    arrow11: "/img/arrow-11-5@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame118Props: frame11814Data
};
const frame11815Data = {
    children: "Visual management",
    className: "frame-113-32"
};
const x5SData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow12: "/img/arrow-1@2x.png",
    arrow13: "/img/arrow-2@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line23: "/img/line-22.png",
    place: "Back",
    seiri: "SEIRI",
    arrow7: "/img/arrow-7-7@2x.png",
    disposal: "DISPOSAL",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    arrow3: "/img/arrow-3-4@2x.png",
    seiton: "SEITON",
    arrow8: "/img/arrow-8-8@2x.png",
    putAway: "PUT AWAY",
    modeling: "Modeling",
    arrow4: "/img/arrow-4-4@2x.png",
    seison: "SEISON",
    arrow9: "/img/arrow-7-7@2x.png",
    clean: "CLEAN",
    arrow6: "/img/arrow-4-4@2x.png",
    seiketsu: "SEIKETSU",
    shitsuke: "SHITSUKE",
    arrow10: "/img/arrow-8-8@2x.png",
    arrow11: "/img/arrow-8-8@2x.png",
    arrow5: "/img/arrow-5-3@2x.png",
    rectangle7: "/img/rectangle-7-1@2x.png",
    standardize: "STANDARDIZE",
    respect: "RESPECT",
    xcontinue: "Continue",
    frame118Props: frame11815Data
};
const frame1133217Data = {
    className: "frame-113-16"
};
const frame1132262Data = {
    className: "frame-113-70"
};
const frame11816Data = {
    children: "Visual management",
    className: "frame-113-33"
};
const frame81Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "5",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "MISE EN ACTION DES CONTRE-MESURES"
        ]
    })
};
const frame821Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "4",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATION DES CONTRE-MESURES"
        ]
    })
};
const frame91Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "3",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "ETUDE DES CAUSES"
        ]
    })
};
const kaizen12Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    label1: "Design",
    leanVsm: "Lean VSM",
    label2: "CONTINUOUS IMPROVEMENT PROCESS",
    overlapGroup8: "/img/arrow-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    overlapGroup5: "/img/arrow-2@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line4: "/img/line-2@2x.png",
    line2: "/img/line-2@2x.png",
    label3: "Zoom",
    label4: "Zoom",
    overlapGroup9: "/img/text-format@2x.png",
    textFormat: "/img/text-format@2x.png",
    label5: "Text",
    label6: "Text",
    overlapGroup4: "/img/line-1.png",
    line1: "/img/line-1.png",
    place: "Back",
    x1IdentificatonDuProblemeATraiter: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "1",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATON DU PROBLEME A TRAITER"
        ]
    }),
    x2EtudeDeLaSituation: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "2 ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "ETUDE DE LA SITUATION"
        ]
    }),
    arrow6: "/img/arrow-6-11@2x.png",
    x6AuditDesContreMesures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "6",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "AUDIT DES CONTRE-MESURES"
        ]
    }),
    arrow16: "/img/arrow-16-5@2x.png",
    arrow13: "/img/arrow-6-11@2x.png",
    arrow14: "/img/arrow-14-5@2x.png",
    arrow15: "/img/arrow-15-2@2x.png",
    arrow17: "/img/arrow-17-1@2x.png",
    x7StandardisationDesBonnesMesures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "7",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STANDARDISATION DES BONNES MESURES"
        ]
    }),
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11332Props: frame1133217Data,
    frame11322Props: frame1132262Data,
    frame118Props: frame11816Data,
    frame8Props: frame81Data,
    frame82Props: frame821Data,
    frame9Props: frame91Data
};
const frame1172249Data = {
    children: "Existing Case"
};
const frame1162250Data = {
    children: "Reference Cases"
};
const frame1132263Data = {
    className: ""
};
const navItems340Data = {
    className: "nav-items-3-40",
    frame1172Props: frame1172249Data,
    frame1162Props: frame1162250Data,
    frame1132Props: frame1132263Data
};
const buttonSecondary115Data = {
    children: "Staff involvement 1",
    className: ""
};
const toggle115Data = {
    className: "toggle-105",
    buttonSecondaryProps: buttonSecondary115Data
};
const ouinon142Data = {
    yes: "Yes",
    place: "No"
};
const frame136117Data = {
    ouinonProps: ouinon142Data
};
const ouinon143Data = {
    yes: "Yes",
    place: "No"
};
const frame136118Data = {
    ouinonProps: ouinon143Data
};
const ouinon144Data = {
    yes: "Yes",
    place: "No"
};
const frame136119Data = {
    ouinonProps: ouinon144Data
};
const ouinon145Data = {
    yes: "Yes",
    place: "No"
};
const frame136120Data = {
    ouinonProps: ouinon145Data
};
const buttonSecondary116Data = {
    children: "Staff involvement 2",
    className: ""
};
const toggle116Data = {
    className: "toggle-106",
    buttonSecondaryProps: buttonSecondary116Data
};
const ouinon146Data = {
    yes: "Yes",
    place: "No"
};
const frame136121Data = {
    ouinonProps: ouinon146Data
};
const ouinon147Data = {
    yes: "Yes",
    place: "No"
};
const frame136122Data = {
    ouinonProps: ouinon147Data
};
const buttonSecondary117Data = {
    children: "4/7",
    className: "button-secondary-85"
};
const toggle117Data = {
    className: "toggle-107",
    buttonSecondaryProps: buttonSecondary117Data
};
const quality4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems340Data,
    toggle1Props: toggle115Data,
    frame1361Props: frame136117Data,
    frame1362Props: frame136118Data,
    frame1363Props: frame136119Data,
    frame1364Props: frame136120Data,
    toggle2Props: toggle116Data,
    frame1365Props: frame136121Data,
    frame1366Props: frame136122Data,
    toggle3Props: toggle117Data
};
const frame11817Data = {
    children: "Visual management",
    className: "frame-113-35"
};
const headerMenuDefault9Data = {
    children: "Requirements",
    className: "menu-item-default-7"
};
const headerMenuDefault10Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Define,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Prepare,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Document"
        ]
    }),
    className: "menu-item-default-8"
};
const headerMenuDefault11Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Evaluate,",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Correct"
        ]
    }),
    className: "menu-item-default-9"
};
const headerMenuDefault12Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Execute, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Code"
        ]
    }),
    className: "menu-item-default-10"
};
const headerMenuDefault13Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Measure, ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Compare"
        ]
    }),
    className: "menu-item-default-11"
};
const headerMenuDefault14Data = {
    children: "Satisfaction",
    className: "menu-item-default-12"
};
const kaizenData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow12: "/img/arrow-1@2x.png",
    arrow13: "/img/arrow-2@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line23: "/img/line-22.png",
    place1: "Back",
    input: "INPUT",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    arrow5: "/img/arrow-5-6@2x.png",
    arrow1: "/img/arrow-1-8@2x.png",
    place2: "PLAN",
    arrow3: "/img/arrow-3-7@2x.png",
    arrow7: "/img/arrow-5-6@2x.png",
    act: "ACT",
    xdo: "DO",
    arrow4: "/img/arrow-4-7@2x.png",
    arrow6: "/img/arrow-5-6@2x.png",
    check: "CHECK",
    arrow2: "/img/arrow-2-8@2x.png",
    arrow8: "/img/arrow-5-6@2x.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    output: "OUTPUT",
    frame118Props: frame11817Data,
    headerMenuDefault1Props: headerMenuDefault9Data,
    headerMenuDefault2Props: headerMenuDefault10Data,
    headerMenuDefault3Props: headerMenuDefault11Data,
    headerMenuDefault4Props: headerMenuDefault12Data,
    headerMenuDefault5Props: headerMenuDefault13Data,
    headerMenuDefault6Props: headerMenuDefault14Data
};
const frame11818Data = {
    children: "Visual management",
    className: "frame-113-37"
};
const frame62Data = {
    className: "frame-6-11"
};
const sMEDData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow121: "/img/arrow-1@2x.png",
    arrow131: "/img/arrow-2@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line23: "/img/line-22.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    label3: "FIN D\u2019USINAGE SERIE A",
    arrow5: "/img/arrow-5-6@2x.png",
    label4: "DEBUT D\u2019USINAGE SERIE B",
    arrow15: "/img/arrow-15-3@2x.png",
    arrow122: "/img/arrow-12-4@2x.png",
    arrow132: "/img/arrow-13-3@2x.png",
    dernierePieceBonneSerieA: "DERNIERE PIECE BONNE SERIE A",
    changementOutillage: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "CHANGEMENT",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " OUTILLAGE"
        ]
    }),
    reglage: "REGLAGE",
    nettoyage: "NETTOYAGE",
    arrow18: "/img/arrow-18@2x.png",
    arrow17: "/img/arrow-17@2x.png",
    arrow16: "/img/arrow-16-1@2x.png",
    premierePieceBonneSerieB: "PREMIERE PIECE BONNE SERIE B",
    arrow14: "/img/arrow-15-3@2x.png",
    modeling: "Modeling",
    arrow11: "/img/arrow-11-8@2x.png",
    xcontinue: "Continue",
    frame118Props: frame11818Data,
    frame6Props: frame62Data
};
const frame11364Data = {
    children: "Visual management",
    className: "frame-113-7"
};
const visualManagementData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line2: "/img/line-2@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format@2x.png",
    label2: "Text",
    line1: "/img/line-1.png",
    place: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    connaissancesCompetences: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Connaissances",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Competences"
        ]
    }),
    collaborateursEquipes: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Collaborateurs",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Equipes"
        ]
    }),
    strategiesProjets: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Strategies",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Projets"
        ]
    }),
    ideesInformations: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Idees",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Informations"
        ]
    }),
    tempsPriorites: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Temps ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Priorites"
        ]
    }),
    arrow11: "/img/arrow-11-10@2x.png",
    arrow16: "/img/arrow-16-4@2x.png",
    arrow13: "/img/arrow-13@2x.png",
    arrow14: "/img/arrow-14@2x.png",
    mieuxManager: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Mieux",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            " Manager"
        ]
    }),
    arrow12: "/img/arrow-12@2x.png",
    arrow15: "/img/arrow-15@2x.png",
    problemesDecision: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "Problemes",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Decision"
        ]
    }),
    modeling: "Modeling",
    analyzeTheFuturPerformances: "Analyze the futur performances",
    frame1136Props: frame11364Data
};
const frame11819Data = {
    children: "Visual management",
    className: "frame-113-38"
};
const kanbanData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    leanVsm: "Lean VSM",
    arrow9: "/img/arrow-1@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    rectangle23: "/img/rectangle-23@2x.png",
    line2: "/img/line-2-14@2x.png",
    label1: "Zoom",
    textFormat: "/img/text-format-15@2x.png",
    label2: "Text",
    line22: "/img/line-22.png",
    place1: "Back",
    clickOnModeling: "CLICK ON \u201CMODELING\u201D BUTTON TO CREATE YOUR DIAGRAM",
    place2: "PLAN",
    arrow11: "/img/arrow-11-12.png",
    line4: "/img/line-4-4.png",
    urgence: "URGENCE",
    aFaire: "A FAIRE",
    termine: "TERMINE",
    enAttente: "EN ATTENTE",
    enCours: "EN COURS",
    line3: "/img/line-3-5.png",
    modeling: "Modeling",
    xcontinue: "Continue",
    frame118Props: frame11819Data
};
const navItems239Data = {
    className: "nav-items-2-38"
};
const frame1172250Data = {
    children: "Existing Case"
};
const frame1162251Data = {
    children: "Reference Cases"
};
const frame1132268Data = {
    className: ""
};
const navItems341Data = {
    className: "nav-items-3-41",
    frame1172Props: frame1172250Data,
    frame1162Props: frame1162251Data,
    frame1132Props: frame1132268Data
};
const buttonSecondary118Data = {
    children: "1/2",
    className: "button-secondary-42"
};
const toggle118Data = {
    className: "toggle-108",
    buttonSecondaryProps: buttonSecondary118Data
};
const buttonSecondary119Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-42"
};
const toggle119Data = {
    className: "toggle-19",
    buttonSecondaryProps: buttonSecondary119Data
};
const group102125Data = {
    line24: "/img/line-24.png",
    className: ""
};
const group102126Data = {
    line24: "/img/line-24-1.png",
    className: "group-14-2"
};
const group102127Data = {
    line24: "/img/line-24-32.png",
    className: "group-14-3"
};
const group102128Data = {
    line24: "/img/line-24-3.png",
    className: "group-14-4"
};
const group102129Data = {
    line24: "/img/line-24-4.png",
    className: "group-14-5"
};
const frame1015Data = {
    className: "frame-99",
    toggleProps: toggle119Data,
    group1021Props: group102125Data,
    group1022Props: group102126Data,
    group1023Props: group102127Data,
    group1024Props: group102128Data,
    group1025Props: group102129Data
};
const buttonSecondary120Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-42"
};
const toggle120Data = {
    className: "toggle-19",
    buttonSecondaryProps: buttonSecondary120Data
};
const group102130Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group102131Data = {
    line24: "/img/line-24-6.png",
    className: "group-14-6"
};
const group102132Data = {
    line24: "/img/line-24-7.png",
    className: "group-14-7"
};
const group102133Data = {
    line24: "/img/line-24-18.png",
    className: "group-14-8"
};
const group102134Data = {
    line24: "/img/line-24-19.png",
    className: "group-14"
};
const frame1025Data = {
    className: "frame-100",
    toggleProps: toggle120Data,
    group1021Props: group102130Data,
    group1022Props: group102131Data,
    group1023Props: group102132Data,
    group1024Props: group102133Data,
    group1025Props: group102134Data
};
const frame1173225Data = {
    className: "frame-116-158"
};
const kaizen2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems239Data,
    navItems3Props: navItems341Data,
    toggleProps: toggle118Data,
    frame101Props: frame1015Data,
    frame102Props: frame1025Data,
    frame11732Props: frame1173225Data
};
const frame1172251Data = {
    children: "Existing Case"
};
const frame1162252Data = {
    children: "Reference Cases"
};
const frame1132269Data = {
    className: ""
};
const navItems342Data = {
    className: "nav-items-3-42",
    frame1172Props: frame1172251Data,
    frame1162Props: frame1162252Data,
    frame1132Props: frame1132269Data
};
const buttonSecondary121Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-43"
};
const toggle121Data = {
    className: "toggle-20",
    buttonSecondaryProps: buttonSecondary121Data
};
const group102135Data = {
    line24: "/img/line-24.png",
    className: "group-15-1"
};
const group102136Data = {
    line24: "/img/line-24-1.png",
    className: "group-15-2"
};
const group102137Data = {
    line24: "/img/line-24-2.png",
    className: "group-15-3"
};
const group102138Data = {
    line24: "/img/line-24-3.png",
    className: "group-15-4"
};
const group102139Data = {
    line24: "/img/line-24-4.png",
    className: "group-15-5"
};
const frame1016Data = {
    className: "frame-95-2",
    toggleProps: toggle121Data,
    group1021Props: group102135Data,
    group1022Props: group102136Data,
    group1023Props: group102137Data,
    group1024Props: group102138Data,
    group1025Props: group102139Data
};
const buttonSecondary122Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-43"
};
const toggle122Data = {
    className: "toggle-20",
    buttonSecondaryProps: buttonSecondary122Data
};
const group102140Data = {
    line24: "/img/line-24-5.png",
    className: "group-15-6"
};
const group102141Data = {
    line24: "/img/line-24-6.png",
    className: "group-15-7"
};
const group102142Data = {
    line24: "/img/line-24-7.png",
    className: "group-15-8"
};
const group102143Data = {
    line24: "/img/line-24-18.png",
    className: "group-15-9"
};
const group102144Data = {
    line24: "/img/line-24-19.png",
    className: "group-15"
};
const frame1026Data = {
    className: "frame-96",
    toggleProps: toggle122Data,
    group1021Props: group102140Data,
    group1022Props: group102141Data,
    group1023Props: group102142Data,
    group1024Props: group102143Data,
    group1025Props: group102144Data
};
const buttonSecondary123Data = {
    children: "2/2",
    className: "button-secondary-43"
};
const toggle123Data = {
    className: "toggle-109",
    buttonSecondaryProps: buttonSecondary123Data
};
const kanban3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    kaizen: "Kaizen",
    navItems3Props: navItems342Data,
    frame101Props: frame1016Data,
    frame102Props: frame1026Data,
    toggleProps: toggle123Data
};
const headerMenuDefault52Data = {
    children: "Aquisition"
};
const headerMenuDefault24Data = {
    children: "Modeling",
    className: "menu-item-default-21"
};
const headerMenuDefault25Data = {
    children: "Analysis",
    className: "menu-item-default-22"
};
const headerMenuDefault26Data = {
    children: "Results & Objectives",
    className: "menu-item-default-19-1"
};
const frame2323Data = {
    headerMenuDefault2Props: headerMenuDefault26Data
};
const pricing39Data = {
    cost: "Cost"
};
const pricing310Data = {
    cost: "Modernization",
    className: "pricing-8-2"
};
const pricing311Data = {
    cost: "Social",
    className: "pricing-5-2"
};
const pricing312Data = {
    cost: "Client/Consumer",
    className: "pricing-7-2"
};
const mesureDePerformancesFuturesData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    label1: "Design",
    label2: "Future performances",
    notesAtteintesPourChaqueCritre: "NOTES ATTEINTES POUR CHAQUE CRIT\xc8RE",
    place: "Quality",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    line211: "/img/line-21@2x.png",
    leadTime: "Lead Time",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-5@2x.png",
    environment: "Environment",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-5@2x.png",
    xcontinue: "Continue",
    headerMenuDefault5Props: headerMenuDefault52Data,
    headerMenuDefault21Props: headerMenuDefault24Data,
    headerMenuDefault22Props: headerMenuDefault25Data,
    frame232Props: frame2323Data,
    pricing31Props: pricing39Data,
    pricing32Props: pricing310Data,
    pricing33Props: pricing311Data,
    pricing34Props: pricing312Data
};
const navItems241Data = {
    className: "nav-items-2-40"
};
const frame1172252Data = {
    children: "Existing Case"
};
const frame1162253Data = {
    children: "Reference Cases"
};
const frame1132271Data = {
    className: ""
};
const navItems343Data = {
    className: "nav-items-3-43",
    frame1172Props: frame1172252Data,
    frame1162Props: frame1162253Data,
    frame1132Props: frame1132271Data
};
const buttonSecondary124Data = {
    children: "1/2",
    className: "button-secondary-86"
};
const toggle124Data = {
    className: "toggle-110",
    buttonSecondaryProps: buttonSecondary124Data
};
const buttonSecondary125Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-44"
};
const toggle125Data = {
    className: "toggle-21",
    buttonSecondaryProps: buttonSecondary125Data
};
const group102145Data = {
    line24: "/img/line-24.png",
    className: "group-16-1"
};
const group102146Data = {
    line24: "/img/line-24-1.png",
    className: "group-16-2"
};
const group102147Data = {
    line24: "/img/line-24-32.png",
    className: "group-16-3"
};
const group102148Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group102149Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1017Data = {
    className: "frame-97-2",
    toggleProps: toggle125Data,
    group1021Props: group102145Data,
    group1022Props: group102146Data,
    group1023Props: group102147Data,
    group1024Props: group102148Data,
    group1025Props: group102149Data
};
const buttonSecondary126Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-44"
};
const toggle126Data = {
    className: "toggle-21",
    buttonSecondaryProps: buttonSecondary126Data
};
const group102150Data = {
    line24: "/img/line-24-5.png",
    className: "group-16-4"
};
const group102151Data = {
    line24: "/img/line-24-6.png",
    className: "group-16-5"
};
const group102152Data = {
    line24: "/img/line-24-7.png",
    className: "group-16"
};
const group102153Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102154Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1027Data = {
    className: "frame-98-2",
    toggleProps: toggle126Data,
    group1021Props: group102150Data,
    group1022Props: group102151Data,
    group1023Props: group102152Data,
    group1024Props: group102153Data,
    group1025Props: group102154Data
};
const frame1173226Data = {
    className: "frame-116-159"
};
const x5s2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems241Data,
    navItems3Props: navItems343Data,
    toggleProps: toggle124Data,
    frame101Props: frame1017Data,
    frame102Props: frame1027Data,
    frame11732Props: frame1173226Data
};
const navItems242Data = {
    className: "nav-items-2-41"
};
const frame1172253Data = {
    children: "Existing Case"
};
const frame1162254Data = {
    children: "Reference Cases"
};
const frame1132272Data = {
    className: ""
};
const navItems344Data = {
    className: "nav-items-3-44",
    frame1172Props: frame1172253Data,
    frame1162Props: frame1162254Data,
    frame1132Props: frame1132272Data
};
const buttonSecondary127Data = {
    children: "1/2",
    className: "button-secondary-45"
};
const toggle127Data = {
    className: "toggle-111",
    buttonSecondaryProps: buttonSecondary127Data
};
const buttonSecondary128Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-45"
};
const toggle128Data = {
    className: "toggle-22",
    buttonSecondaryProps: buttonSecondary128Data
};
const group102155Data = {
    line24: "/img/line-24.png",
    className: "group-17-1"
};
const group102156Data = {
    line24: "/img/line-24-1.png",
    className: "group-17-2"
};
const group102157Data = {
    line24: "/img/line-24-2.png",
    className: "group-17-3"
};
const group102158Data = {
    line24: "/img/line-24-3.png",
    className: "group-17-4"
};
const group102159Data = {
    line24: "/img/line-24-4.png",
    className: "group-17-5"
};
const frame1018Data = {
    className: "frame-97-3",
    toggleProps: toggle128Data,
    group1021Props: group102155Data,
    group1022Props: group102156Data,
    group1023Props: group102157Data,
    group1024Props: group102158Data,
    group1025Props: group102159Data
};
const buttonSecondary129Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-45"
};
const toggle129Data = {
    className: "toggle-22",
    buttonSecondaryProps: buttonSecondary129Data
};
const group102160Data = {
    line24: "/img/line-24-5.png",
    className: "group-17-6"
};
const group102161Data = {
    line24: "/img/line-24-6.png",
    className: "group-17-7"
};
const group102162Data = {
    line24: "/img/line-24-7.png",
    className: "group-17-8"
};
const group102163Data = {
    line24: "/img/line-24-18.png",
    className: "group-17-9"
};
const group102164Data = {
    line24: "/img/line-24-19.png",
    className: "group-17"
};
const frame1028Data = {
    className: "frame-98-3",
    toggleProps: toggle129Data,
    group1021Props: group102160Data,
    group1022Props: group102161Data,
    group1023Props: group102162Data,
    group1024Props: group102163Data,
    group1025Props: group102164Data
};
const frame1173227Data = {
    className: "frame-116-160"
};
const kanban2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    navItems2Props: navItems242Data,
    navItems3Props: navItems344Data,
    toggleProps: toggle127Data,
    frame101Props: frame1018Data,
    frame102Props: frame1028Data,
    frame11732Props: frame1173227Data
};
const navItems243Data = {
    className: "nav-items-2-42"
};
const frame1172254Data = {
    children: "Existing Case"
};
const frame1162255Data = {
    children: "Reference Cases"
};
const frame1132273Data = {
    className: ""
};
const navItems345Data = {
    className: "nav-items-3-45",
    frame1172Props: frame1172254Data,
    frame1162Props: frame1162255Data,
    frame1132Props: frame1132273Data
};
const buttonSecondary130Data = {
    children: "2/2",
    className: "button-secondary-46"
};
const toggle130Data = {
    className: "toggle-112",
    buttonSecondaryProps: buttonSecondary130Data
};
const buttonSecondary131Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-46"
};
const toggle131Data = {
    className: "toggle-23",
    buttonSecondaryProps: buttonSecondary131Data
};
const group102165Data = {
    line24: "/img/line-24.png",
    className: "group-18-1"
};
const group102166Data = {
    line24: "/img/line-24-1.png",
    className: "group-18-2"
};
const group102167Data = {
    line24: "/img/line-24-32.png",
    className: "group-18-3"
};
const group102168Data = {
    line24: "/img/line-24-3.png",
    className: ""
};
const group102169Data = {
    line24: "/img/line-24-4.png",
    className: ""
};
const frame1019Data = {
    className: "frame-95-3",
    toggleProps: toggle131Data,
    group1021Props: group102165Data,
    group1022Props: group102166Data,
    group1023Props: group102167Data,
    group1024Props: group102168Data,
    group1025Props: group102169Data
};
const buttonSecondary132Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-46"
};
const toggle132Data = {
    className: "toggle-23",
    buttonSecondaryProps: buttonSecondary132Data
};
const group102170Data = {
    line24: "/img/line-24-5.png",
    className: "group-18-4"
};
const group102171Data = {
    line24: "/img/line-24-6.png",
    className: "group-18-5"
};
const group102172Data = {
    line24: "/img/line-24-7.png",
    className: "group-18"
};
const group102173Data = {
    line24: "/img/line-24-18.png",
    className: ""
};
const group102174Data = {
    line24: "/img/line-24-19.png",
    className: ""
};
const frame1029Data = {
    className: "frame-96-1",
    toggleProps: toggle132Data,
    group1021Props: group102170Data,
    group1022Props: group102171Data,
    group1023Props: group102172Data,
    group1024Props: group102173Data,
    group1025Props: group102174Data
};
const x5s3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    kanban: "Kanban",
    navItems2Props: navItems243Data,
    navItems3Props: navItems345Data,
    toggleProps: toggle130Data,
    frame101Props: frame1019Data,
    frame102Props: frame1029Data
};
const frame1172255Data = {
    children: "Existing Case"
};
const frame1162256Data = {
    children: "Reference Cases"
};
const frame1132274Data = {
    className: ""
};
const navItems346Data = {
    className: "nav-items-3-46",
    frame1172Props: frame1172255Data,
    frame1162Props: frame1162256Data,
    frame1132Props: frame1132274Data
};
const buttonSecondary133Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-47"
};
const toggle133Data = {
    className: "toggle-24",
    buttonSecondaryProps: buttonSecondary133Data
};
const group102175Data = {
    line24: "/img/line-24-80.png"
};
const group102176Data = {
    line24: "/img/line-24-81.png"
};
const group102177Data = {
    line24: "/img/line-24-82.png"
};
const group102178Data = {
    line24: "/img/line-24-83.png"
};
const group102179Data = {
    line24: "/img/line-24-84.png"
};
const buttonSecondary134Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-47"
};
const toggle134Data = {
    className: "toggle-24",
    buttonSecondaryProps: buttonSecondary134Data
};
const group102180Data = {
    line24: "/img/line-24-5.png"
};
const group102181Data = {
    line24: "/img/line-24-6.png"
};
const group102182Data = {
    line24: "/img/line-24-7.png"
};
const group102183Data = {
    line24: "/img/line-24-8.png"
};
const group102184Data = {
    line24: "/img/line-24-9.png"
};
const frame1173228Data = {
    className: "frame-116-161"
};
const buttonSecondary135Data = {
    children: "2/3",
    className: "button-secondary-47"
};
const toggle135Data = {
    className: "toggle-113",
    buttonSecondaryProps: buttonSecondary135Data
};
const leanVSM3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "A quelle fr\xe9quence renouvelez vous votre stock?",
    inputType2: "text",
    inputPlaceholder2: "combien de temps en moyenne un article effectue dans votre magazin?",
    inputType3: "text",
    inputPlaceholder3: "Vous arrive-t-il d\u2019avoir des ruptures de stock? Si oui, \xe0 quelle fr\xe9quence?",
    inputType4: "text",
    inputPlaceholder4: "Avez vous mis en place de mesures d\u2019am\xe9lioration?",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    inputType6: "text",
    inputPlaceholder6: "Dans quel rayon se situe vos clients?",
    inputType7: "text",
    inputPlaceholder7: "A quelle fr\xe9quence effectuez vous des livraisons?",
    inputType8: "text",
    inputPlaceholder8: "Quel est votre taux de service?",
    inputType9: "text",
    inputPlaceholder9: "Quel est votre taux de retard?",
    inputType10: "text",
    inputPlaceholder10: "*************************************",
    navItems3Props: navItems346Data,
    toggle1Props: toggle133Data,
    group1021Props: group102175Data,
    group1022Props: group102176Data,
    group1023Props: group102177Data,
    group1024Props: group102178Data,
    group1025Props: group102179Data,
    toggle2Props: toggle134Data,
    group1026Props: group102180Data,
    group1027Props: group102181Data,
    group1028Props: group102182Data,
    group1029Props: group102183Data,
    group10210Props: group102184Data,
    frame11732Props: frame1173228Data,
    toggle3Props: toggle135Data
};
const navItems245Data = {
    className: "nav-items-2-44"
};
const frame1172256Data = {
    children: "Existing Case"
};
const frame1162257Data = {
    children: "Reference Cases"
};
const frame1132275Data = {
    className: ""
};
const navItems347Data = {
    className: "nav-items-3-47",
    frame1172Props: frame1172256Data,
    frame1162Props: frame1162257Data,
    frame1132Props: frame1132275Data
};
const buttonSecondary136Data = {
    children: "Storage time",
    className: "button-secondary-48"
};
const toggle136Data = {
    className: "toggle-25",
    buttonSecondaryProps: buttonSecondary136Data
};
const group102185Data = {
    line24: "/img/line-24-80.png"
};
const group102186Data = {
    line24: "/img/line-24-81.png"
};
const group102187Data = {
    line24: "/img/line-24-82.png"
};
const group102188Data = {
    line24: "/img/line-24-83.png"
};
const group102189Data = {
    line24: "/img/line-24-84.png"
};
const buttonSecondary137Data = {
    children: "1/3",
    className: "button-secondary-48"
};
const toggle137Data = {
    className: "toggle-114",
    buttonSecondaryProps: buttonSecondary137Data
};
const buttonSecondary138Data = {
    children: "Delivery time",
    className: "button-secondary-48"
};
const toggle138Data = {
    className: "toggle-25",
    buttonSecondaryProps: buttonSecondary138Data
};
const group102190Data = {
    line24: "/img/line-24-5.png"
};
const group102191Data = {
    line24: "/img/line-24-6.png"
};
const group102192Data = {
    line24: "/img/line-24-7.png"
};
const group102193Data = {
    line24: "/img/line-24-8.png"
};
const group102194Data = {
    line24: "/img/line-24-9.png"
};
const frame1173229Data = {
    className: "frame-116-162"
};
const leanVSM2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "A quelle fr\xe9quence renouvelez vous votre stock?",
    inputType2: "text",
    inputPlaceholder2: "combien de temps en moyenne un article effectue dans votre magazin?",
    inputType3: "text",
    inputPlaceholder3: "Vous arrive-t-il d\u2019avoir des ruptures de stock? Si oui, \xe0 quelle fr\xe9quence?",
    inputType4: "text",
    inputPlaceholder4: "Avez vous mis en place de mesures d\u2019am\xe9lioration?",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    inputType6: "text",
    inputPlaceholder6: "Dans quel rayon se situe vos clients?",
    inputType7: "text",
    inputPlaceholder7: "A quelle fr\xe9quence effectuez vous des livraisons?",
    inputType8: "text",
    inputPlaceholder8: "Quel est votre taux de service?",
    inputType9: "text",
    inputPlaceholder9: "Quel est votre taux de retard?",
    inputType10: "text",
    inputPlaceholder10: "*************************************",
    navItems2Props: navItems245Data,
    navItems3Props: navItems347Data,
    toggle1Props: toggle136Data,
    group1021Props: group102185Data,
    group1022Props: group102186Data,
    group1023Props: group102187Data,
    group1024Props: group102188Data,
    group1025Props: group102189Data,
    toggle2Props: toggle137Data,
    toggle3Props: toggle138Data,
    group1026Props: group102190Data,
    group1027Props: group102191Data,
    group1028Props: group102192Data,
    group1029Props: group102193Data,
    group10210Props: group102194Data,
    frame11732Props: frame1173229Data
};
const frame1133223Data = {
    className: "frame-113-22"
};
const frame1132276Data = {
    className: "frame-113-84"
};
const frame11820Data = {
    children: "Visual management",
    className: "frame-113-39"
};
const frame83Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "5",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IMPLEMENTATION OF COUNTERMEASURES"
        ]
    })
};
const frame822Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "4",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATION OF COUNTERMEASURES"
        ]
    })
};
const frame98Data = {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "3",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STUDY OF THE CAUSES"
        ]
    })
};
const kaizen11Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    label1: "Design",
    overlapGroup11: "/img/arrow-1@2x.png",
    arrow9: "/img/arrow-1@2x.png",
    overlapGroup3: "/img/arrow-2@2x.png",
    arrow10: "/img/arrow-2@2x.png",
    line4: "/img/line-2@2x.png",
    line2: "/img/line-2@2x.png",
    label2: "Zoom",
    label3: "Zoom",
    overlapGroup2: "/img/text-format@2x.png",
    textFormat: "/img/text-format@2x.png",
    label4: "Text",
    label5: "Text",
    overlapGroup4: "/img/line-1.png",
    line1: "/img/line-1.png",
    place: "Back",
    label6: "CONTINUOUS IMPROVEMENT PROCESS",
    x1IdentificationOf: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "1",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "IDENTIFICATION OF THE PROBLEM TO BE TREATED"
        ]
    }),
    x2StudyOfTheSituation: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "2 ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STUDY OF THE SITUATION"
        ]
    }),
    arrow6: "/img/arrow-6-11@2x.png",
    x6AuditOfCountermeasures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "6",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "AUDIT OF COUNTERMEASURES"
        ]
    }),
    arrow16: "/img/arrow-16-2@2x.png",
    arrow13: "/img/arrow-6-11@2x.png",
    arrow14: "/img/arrow-14-2@2x.png",
    arrow15: "/img/arrow-15-2@2x.png",
    arrow17: "/img/arrow-17-1@2x.png",
    x7StandardizationOfGoodMeasures: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            "7",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "STANDARDIZATION OF GOOD MEASURES"
        ]
    }),
    modeling: "Modeling",
    xcontinue: "Continue",
    frame11332Props: frame1133223Data,
    frame11322Props: frame1132276Data,
    frame118Props: frame11820Data,
    frame8Props: frame83Data,
    frame82Props: frame822Data,
    frame9Props: frame98Data
};
const frame1172257Data = {
    children: "Existing Case"
};
const frame1162258Data = {
    children: "Reference Cases"
};
const frame1132277Data = {
    className: ""
};
const navItems348Data = {
    className: "nav-items-3-48",
    frame1172Props: frame1172257Data,
    frame1162Props: frame1162258Data,
    frame1132Props: frame1132277Data
};
const buttonSecondary139Data = {
    children: "Leadership 1",
    className: ""
};
const toggle139Data = {
    className: "toggle-115",
    buttonSecondaryProps: buttonSecondary139Data
};
const ouinon148Data = {
    yes: "Yes",
    place: "No"
};
const frame136123Data = {
    ouinonProps: ouinon148Data
};
const ouinon149Data = {
    yes: "Yes",
    place: "No"
};
const frame136124Data = {
    ouinonProps: ouinon149Data
};
const ouinon150Data = {
    yes: "Yes",
    place: "No"
};
const frame136125Data = {
    ouinonProps: ouinon150Data
};
const ouinon151Data = {
    yes: "Yes",
    place: "No"
};
const frame136126Data = {
    ouinonProps: ouinon151Data
};
const buttonSecondary140Data = {
    children: "Leadership 2",
    className: ""
};
const toggle140Data = {
    className: "toggle-116",
    buttonSecondaryProps: buttonSecondary140Data
};
const ouinon152Data = {
    yes: "Yes",
    place: "No"
};
const frame136127Data = {
    ouinonProps: ouinon152Data
};
const ouinon153Data = {
    yes: "Yes",
    place: "No"
};
const frame136128Data = {
    ouinonProps: ouinon153Data
};
const ouinon154Data = {
    yes: "Yes",
    place: "No"
};
const frame136129Data = {
    ouinonProps: ouinon154Data
};
const buttonSecondary141Data = {
    children: "3/7",
    className: "button-secondary-87"
};
const toggle141Data = {
    className: "toggle-117",
    buttonSecondaryProps: buttonSecondary141Data
};
const quality3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    next: "Next",
    navItems3Props: navItems348Data,
    toggle1Props: toggle139Data,
    frame1361Props: frame136123Data,
    frame1362Props: frame136124Data,
    frame1363Props: frame136125Data,
    frame1364Props: frame136126Data,
    toggle2Props: toggle140Data,
    frame1365Props: frame136127Data,
    frame1366Props: frame136128Data,
    frame1367Props: frame136129Data,
    toggle3Props: toggle141Data
};
const navItems247Data = {
    className: "nav-items-2-46"
};
const frame1172258Data = {
    children: "Existing Case"
};
const frame1162259Data = {
    children: "Reference Cases"
};
const frame1132278Data = {
    className: ""
};
const navItems349Data = {
    className: "nav-items-3-49",
    frame1172Props: frame1172258Data,
    frame1162Props: frame1162259Data,
    frame1132Props: frame1132278Data
};
const buttonSecondary142Data = {
    children: "3/3",
    className: "button-secondary-49"
};
const toggle142Data = {
    className: "toggle-118",
    buttonSecondaryProps: buttonSecondary142Data
};
const buttonSecondary143Data = {
    children: "ISO 50001 Norm",
    className: "button-secondary-49"
};
const toggle143Data = {
    className: "toggle-26",
    buttonSecondaryProps: buttonSecondary143Data
};
const group102195Data = {
    line24: "/img/line-24-80.png",
    className: "group-21-1"
};
const group102196Data = {
    line24: "/img/line-24-81.png",
    className: "group-21-2"
};
const group102197Data = {
    line24: "/img/line-24-82.png",
    className: "group-21-3"
};
const group102198Data = {
    line24: "/img/line-24-83.png",
    className: "group-21-4"
};
const group102199Data = {
    line24: "/img/line-24-84.png",
    className: "group-21"
};
const buttonSecondary144Data = {
    children: "ISO 14001 Norm",
    className: "button-secondary-49"
};
const toggle144Data = {
    className: "toggle-26",
    buttonSecondaryProps: buttonSecondary144Data
};
const group102200Data = {
    line24: "/img/line-24-5.png",
    className: ""
};
const group102201Data = {
    line24: "/img/line-24-6.png",
    className: ""
};
const group102202Data = {
    line24: "/img/line-24-7.png",
    className: ""
};
const group102203Data = {
    line24: "/img/line-24-8.png",
    className: ""
};
const group102204Data = {
    line24: "/img/line-24-9.png",
    className: ""
};
const frame10210Data = {
    className: "frame-96-2",
    toggleProps: toggle144Data,
    group1021Props: group102200Data,
    group1022Props: group102201Data,
    group1023Props: group102202Data,
    group1024Props: group102203Data,
    group1025Props: group102204Data
};
const leanVSM4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "A quelle fr\xe9quence renouvelez vous votre stock?",
    inputType2: "text",
    inputPlaceholder2: "combien de temps en moyenne un article effectue dans votre magazin?",
    inputType3: "text",
    inputPlaceholder3: "Vous arrive-t-il d\u2019avoir des ruptures de stock? Si oui, \xe0 quelle fr\xe9quence?",
    inputType4: "text",
    inputPlaceholder4: "Avez vous mis en place de mesures d\u2019am\xe9lioration?",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    x5S: "5S",
    navItems2Props: navItems247Data,
    navItems3Props: navItems349Data,
    toggle1Props: toggle142Data,
    toggle2Props: toggle143Data,
    group1021Props: group102195Data,
    group1022Props: group102196Data,
    group1023Props: group102197Data,
    group1024Props: group102198Data,
    group1025Props: group102199Data,
    frame102Props: frame10210Data
};
const headerMenuDefault53Data = {
    children: "Aquisition"
};
const headerMenuDefault54Data = {
    children: "Modeling",
    className: "menu-item-default-32"
};
const headerMenuDefault55Data = {
    children: "Analysis",
    className: "menu-item-default-33"
};
const headerMenuDefault27Data = {
    children: "Results & Objectives",
    className: "menu-item-default-19-1"
};
const frame2324Data = {
    headerMenuDefault2Props: headerMenuDefault27Data
};
const frame72Data = {
    className: "frame-7-10"
};
const mesureDePerformancesFutures1Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    design: "Design",
    label1: "Design",
    label2: "Future performances",
    finish: "Finish",
    headerMenuDefault51Props: headerMenuDefault53Data,
    headerMenuDefault52Props: headerMenuDefault54Data,
    headerMenuDefault53Props: headerMenuDefault55Data,
    frame232Props: frame2324Data,
    frame7Props: frame72Data
};
const frame1172259Data = {
    children: "Existing Case"
};
const frame1162260Data = {
    children: "Reference Cases"
};
const frame1132280Data = {
    className: ""
};
const navItems350Data = {
    className: "nav-items-3-50",
    frame1172Props: frame1172259Data,
    frame1162Props: frame1162260Data,
    frame1132Props: frame1132280Data
};
const frame1122Data = {
    children: "3. Kanban",
    className: "frame-114-112"
};
const existingSystems2Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    existingSystems: "EXISTING SYSTEMS",
    x2SupplementaryModels: "2.   SUPPLEMENTARY MODELS",
    leanVsm: "Lean VSM",
    x4Kaizen: "4. Kaizen",
    x25S: "2. 5S",
    x5Smed: "5. SMED",
    x6VisualManagement: "6. Visual Management",
    ellipse116: "/img/polygon-3@2x.png",
    navItems3Props: navItems350Data,
    frame112Props: frame1122Data
};
const frame1172260Data = {
    children: "Existing Case"
};
const frame1162261Data = {
    children: "Reference Cases"
};
const frame1132281Data = {
    className: ""
};
const navItems351Data = {
    className: "nav-items-3-51",
    frame1172Props: frame1172260Data,
    frame1162Props: frame1162261Data,
    frame1132Props: frame1132281Data
};
const buttonSecondary145Data = {
    children: "Changement Climamtique",
    className: ""
};
const toggle145Data = {
    className: "toggle-119",
    buttonSecondaryProps: buttonSecondary145Data
};
const ouinon155Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-32"
};
const ouinon156Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-33"
};
const buttonSecondary146Data = {
    children: "Autre nuisance",
    className: ""
};
const toggle146Data = {
    className: "toggle-120",
    buttonSecondaryProps: buttonSecondary146Data
};
const ouinon157Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-34"
};
const ouinon158Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-35"
};
const ouinon159Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-36"
};
const buttonSecondary147Data = {
    children: "5/5",
    className: "button-secondary-88"
};
const toggle147Data = {
    className: "toggle-121",
    buttonSecondaryProps: buttonSecondary147Data
};
const environmental5Data = {
    x1200PxLogo_Icam__20082: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    socialCriteria: "Social Criteria",
    navItems3Props: navItems351Data,
    toggle1Props: toggle145Data,
    ouinon1Props: ouinon155Data,
    ouinon2Props: ouinon156Data,
    toggle2Props: toggle146Data,
    ouinon3Props: ouinon157Data,
    ouinon4Props: ouinon158Data,
    ouinon5Props: ouinon159Data,
    toggle3Props: toggle147Data
};
const frame1172261Data = {
    children: "Existing Case"
};
const frame1162262Data = {
    children: "Reference Cases"
};
const frame1132282Data = {
    className: ""
};
const navItems352Data = {
    className: "nav-items-3-52",
    frame1172Props: frame1172261Data,
    frame1162Props: frame1162262Data,
    frame1132Props: frame1132282Data
};
const buttonSecondary148Data = {
    children: "Conditions de travail et qualit\xe9 de vie au travail 1",
    className: ""
};
const toggle148Data = {
    className: "toggle-4",
    buttonSecondaryProps: buttonSecondary148Data
};
const ouinon160Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-37"
};
const ouinon161Data = {
    yes: "Yes",
    place: "No",
    className: "ouinon-38"
};
const buttonSecondary149Data = {
    children: "Conditions de travail et qualit\xe9 de vie au travail 2",
    className: ""
};
const toggle149Data = {
    className: "toggle-4",
    buttonSecondaryProps: buttonSecondary149Data
};
const ouinon162Data = {
    yes: "Yes",
    place: "No"
};
const frame136130Data = {
    ouinonProps: ouinon162Data
};
const ouinon163Data = {
    yes: "Yes",
    place: "No"
};
const frame136131Data = {
    ouinonProps: ouinon163Data
};
const ouinon164Data = {
    yes: "Yes",
    place: "No"
};
const frame136132Data = {
    ouinonProps: ouinon164Data
};
const buttonSecondary150Data = {
    children: "3/6",
    className: "button-secondary-89"
};
const toggle150Data = {
    className: "toggle-122",
    buttonSecondaryProps: buttonSecondary150Data
};
const social3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    navItems3Props: navItems352Data,
    toggle1Props: toggle148Data,
    ouinon1Props: ouinon160Data,
    ouinon2Props: ouinon161Data,
    toggle2Props: toggle149Data,
    frame1361Props: frame136130Data,
    frame1362Props: frame136131Data,
    frame1363Props: frame136132Data,
    toggle3Props: toggle150Data
};
const frame1172262Data = {
    children: "Existing Case"
};
const frame1162263Data = {
    children: "Reference Cases"
};
const frame1132283Data = {
    className: ""
};
const navItems353Data = {
    className: "nav-items-3-53",
    frame1172Props: frame1172262Data,
    frame1162Props: frame1162263Data,
    frame1132Props: frame1132283Data
};
const buttonSecondary151Data = {
    children: "Economie Circulaire 1",
    className: ""
};
const toggle151Data = {
    className: "toggle-123",
    buttonSecondaryProps: buttonSecondary151Data
};
const frame426Data = {
    className: ""
};
const frame436Data = {
    className: ""
};
const ouinon214Data = {
    className: "ouinon-50",
    frame42Props: frame426Data,
    frame43Props: frame436Data
};
const frame427Data = {
    className: ""
};
const frame437Data = {
    className: ""
};
const ouinon215Data = {
    className: "ouinon-51",
    frame42Props: frame427Data,
    frame43Props: frame437Data
};
const buttonSecondary152Data = {
    children: "Economie Circulaire 2",
    className: ""
};
const toggle152Data = {
    className: "toggle-124",
    buttonSecondaryProps: buttonSecondary152Data
};
const frame428Data = {
    className: "frame-4-55-1"
};
const frame438Data = {
    className: "frame-4-63-1"
};
const ouinon216Data = {
    className: "ouinon-52",
    frame42Props: frame428Data,
    frame43Props: frame438Data
};
const frame429Data = {
    className: "frame-4-55"
};
const frame439Data = {
    className: "frame-4-63"
};
const ouinon217Data = {
    className: "ouinon-53",
    frame42Props: frame429Data,
    frame43Props: frame439Data
};
const buttonSecondary153Data = {
    children: "Economie Circulaire 3",
    className: ""
};
const toggle153Data = {
    className: "toggle-125",
    buttonSecondaryProps: buttonSecondary153Data
};
const ouinon165Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-39"
};
const ouinon166Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-40"
};
const ouinon167Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-41"
};
const buttonSecondary154Data = {
    children: "4/5",
    className: "button-secondary-90"
};
const toggle154Data = {
    className: "toggle-126",
    buttonSecondaryProps: buttonSecondary154Data
};
const environmental4Data = {
    x1200PxLogo_Icam__20082: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems353Data,
    toggle1Props: toggle151Data,
    ouinon21Props: ouinon214Data,
    ouinon22Props: ouinon215Data,
    toggle2Props: toggle152Data,
    ouinon23Props: ouinon216Data,
    ouinon24Props: ouinon217Data,
    toggle3Props: toggle153Data,
    ouinon1Props: ouinon165Data,
    ouinon2Props: ouinon166Data,
    ouinon3Props: ouinon167Data,
    toggle4Props: toggle154Data
};
const frame1172263Data = {
    children: "Existing Case"
};
const frame1162264Data = {
    children: "Reference Cases"
};
const frame1132284Data = {
    className: ""
};
const navItems354Data = {
    className: "nav-items-3-54",
    frame1172Props: frame1172263Data,
    frame1162Props: frame1162264Data,
    frame1132Props: frame1132284Data
};
const buttonSecondary155Data = {
    children: "Cyber-physical system (CPS) 1",
    className: ""
};
const toggle155Data = {
    className: "toggle-5",
    buttonSecondaryProps: buttonSecondary155Data
};
const ouinon168Data = {
    yes: "Yes",
    place: "No"
};
const frame136133Data = {
    ouinonProps: ouinon168Data
};
const ouinon169Data = {
    yes: "Yes",
    place: "No"
};
const frame136134Data = {
    ouinonProps: ouinon169Data
};
const buttonSecondary156Data = {
    children: "Cyber-physical system (CPS) 2",
    className: ""
};
const toggle156Data = {
    className: "toggle-5",
    buttonSecondaryProps: buttonSecondary156Data
};
const ouinon170Data = {
    yes: "Yes",
    place: "No"
};
const frame136135Data = {
    ouinonProps: ouinon170Data
};
const ouinon171Data = {
    yes: "Yes",
    place: "No"
};
const frame136136Data = {
    className: "frame-153-7",
    ouinonProps: ouinon171Data
};
const frame1339Data = {
    frame136Props: frame136136Data
};
const frame1448Data = {
    frame133Props: frame1339Data
};
const buttonSecondary157Data = {
    children: "3/4",
    className: "button-secondary-91"
};
const toggle157Data = {
    className: "toggle-127",
    buttonSecondaryProps: buttonSecondary157Data
};
const modernization3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre bilan carbone?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    navItems3Props: navItems354Data,
    toggle1Props: toggle155Data,
    frame1361Props: frame136133Data,
    frame1362Props: frame136134Data,
    toggle2Props: toggle156Data,
    frame1363Props: frame136135Data,
    frame144Props: frame1448Data,
    toggle3Props: toggle157Data
};
const frame1172264Data = {
    children: "Existing Case"
};
const frame1162265Data = {
    children: "Reference Cases"
};
const frame1132285Data = {
    className: ""
};
const navItems355Data = {
    className: "nav-items-3-55",
    frame1172Props: frame1172264Data,
    frame1162Props: frame1162265Data,
    frame1132Props: frame1132285Data
};
const buttonSecondary158Data = {
    children: "Dialogue Social 1",
    className: ""
};
const toggle158Data = {
    className: "toggle-128",
    buttonSecondaryProps: buttonSecondary158Data
};
const frame4210Data = {
    className: ""
};
const frame4310Data = {
    className: ""
};
const ouinon218Data = {
    frame42Props: frame4210Data,
    frame43Props: frame4310Data
};
const frame4211Data = {
    className: ""
};
const frame4311Data = {
    className: ""
};
const ouinon219Data = {
    className: "ouinon-55",
    frame42Props: frame4211Data,
    frame43Props: frame4311Data
};
const frame4212Data = {
    className: ""
};
const frame4312Data = {
    className: ""
};
const ouinon220Data = {
    className: "ouinon-56",
    frame42Props: frame4212Data,
    frame43Props: frame4312Data
};
const buttonSecondary159Data = {
    children: "Dialogue Social 2",
    className: ""
};
const toggle159Data = {
    className: "toggle-129",
    buttonSecondaryProps: buttonSecondary159Data
};
const frame4213Data = {
    className: "frame-4-57-1"
};
const frame4313Data = {
    className: "frame-4-65-1"
};
const ouinon221Data = {
    className: "ouinon-47",
    frame42Props: frame4213Data,
    frame43Props: frame4313Data
};
const frame4214Data = {
    className: "frame-4-57"
};
const frame4314Data = {
    className: "frame-4-65"
};
const ouinon222Data = {
    className: "ouinon-47",
    frame42Props: frame4214Data,
    frame43Props: frame4314Data
};
const buttonSecondary160Data = {
    children: "Dialogue Social 3",
    className: ""
};
const toggle160Data = {
    className: "toggle-130",
    buttonSecondaryProps: buttonSecondary160Data
};
const ouinon172Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-23-1"
};
const ouinon173Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-23-2"
};
const ouinon174Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-23"
};
const buttonSecondary161Data = {
    children: "4/6",
    className: "button-secondary-92"
};
const toggle161Data = {
    className: "toggle-131",
    buttonSecondaryProps: buttonSecondary161Data
};
const social4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems355Data,
    toggle1Props: toggle158Data,
    ouinon21Props: ouinon218Data,
    ouinon22Props: ouinon219Data,
    ouinon23Props: ouinon220Data,
    toggle2Props: toggle159Data,
    ouinon24Props: ouinon221Data,
    ouinon25Props: ouinon222Data,
    toggle3Props: toggle160Data,
    ouinon1Props: ouinon172Data,
    ouinon2Props: ouinon173Data,
    ouinon3Props: ouinon174Data,
    toggle4Props: toggle161Data
};
const frame1172265Data = {
    children: "Existing Case"
};
const frame1162266Data = {
    children: "Reference Cases"
};
const frame1132286Data = {
    className: ""
};
const navItems356Data = {
    className: "nav-items-3-56",
    frame1172Props: frame1172265Data,
    frame1162Props: frame1162266Data,
    frame1132Props: frame1132286Data
};
const buttonSecondary162Data = {
    children: "D\xe9veloppement du capital humain 1",
    className: ""
};
const toggle162Data = {
    className: "toggle-132",
    buttonSecondaryProps: buttonSecondary162Data
};
const frame4215Data = {
    className: "frame-4-59-1"
};
const frame4315Data = {
    className: "frame-4-67-1"
};
const ouinon223Data = {
    className: "ouinon-57",
    frame42Props: frame4215Data,
    frame43Props: frame4315Data
};
const frame4216Data = {
    className: "frame-4-59-2"
};
const frame4316Data = {
    className: "frame-4-67-2"
};
const ouinon224Data = {
    className: "ouinon-58",
    frame42Props: frame4216Data,
    frame43Props: frame4316Data
};
const frame4217Data = {
    className: "frame-4-59"
};
const frame4317Data = {
    className: "frame-4-67"
};
const ouinon225Data = {
    className: "ouinon-59",
    frame42Props: frame4217Data,
    frame43Props: frame4317Data
};
const buttonSecondary163Data = {
    children: "D\xe9veloppement du capital humain 2",
    className: ""
};
const toggle163Data = {
    className: "toggle-133",
    buttonSecondaryProps: buttonSecondary163Data
};
const ouinon175Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-25-1"
};
const ouinon176Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-25-2"
};
const ouinon177Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-25"
};
const buttonSecondary164Data = {
    children: "D\xe9veloppement du capital humain 3",
    className: ""
};
const toggle164Data = {
    className: "toggle-134",
    buttonSecondaryProps: buttonSecondary164Data
};
const ouinon178Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-42"
};
const buttonSecondary165Data = {
    children: "6/6",
    className: "button-secondary-93"
};
const toggle165Data = {
    className: "toggle-135",
    buttonSecondaryProps: buttonSecondary165Data
};
const social6Data = {
    x1200PxLogo_Icam__20081: "",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    modernizationCriteria: "Modernization criteria",
    navItems3Props: navItems356Data,
    toggle1Props: toggle162Data,
    ouinon21Props: ouinon223Data,
    ouinon22Props: ouinon224Data,
    ouinon23Props: ouinon225Data,
    toggle2Props: toggle163Data,
    ouinon1Props: ouinon175Data,
    ouinon2Props: ouinon176Data,
    ouinon3Props: ouinon177Data,
    toggle3Props: toggle164Data,
    ouinon4Props: ouinon178Data,
    toggle4Props: toggle165Data
};
const frame1172266Data = {
    children: "Existing Case"
};
const frame1162267Data = {
    children: "Reference Cases"
};
const frame1132287Data = {
    className: ""
};
const navItems357Data = {
    className: "nav-items-3-57",
    frame1172Props: frame1172266Data,
    frame1162Props: frame1162267Data,
    frame1132Props: frame1132287Data
};
const buttonSecondary166Data = {
    children: "Sant\xe9 et S\xe9curit\xe9 au travail 1",
    className: ""
};
const toggle166Data = {
    className: "toggle-136",
    buttonSecondaryProps: buttonSecondary166Data
};
const frame4218Data = {
    className: "frame-4-58-1"
};
const frame4318Data = {
    className: "frame-4-66-1"
};
const ouinon226Data = {
    className: "ouinon-60",
    frame42Props: frame4218Data,
    frame43Props: frame4318Data
};
const frame4219Data = {
    className: "frame-4-58-2"
};
const frame4319Data = {
    className: "frame-4-66-2"
};
const ouinon227Data = {
    className: "ouinon-61",
    frame42Props: frame4219Data,
    frame43Props: frame4319Data
};
const frame4220Data = {
    className: "frame-4-58-3"
};
const frame4320Data = {
    className: "frame-4-66-3"
};
const ouinon228Data = {
    className: "ouinon-62",
    frame42Props: frame4220Data,
    frame43Props: frame4320Data
};
const frame4221Data = {
    className: "frame-4-58"
};
const frame4321Data = {
    className: "frame-4-66"
};
const ouinon229Data = {
    className: "ouinon-63",
    frame42Props: frame4221Data,
    frame43Props: frame4321Data
};
const buttonSecondary167Data = {
    children: "Sant\xe9 et S\xe9curit\xe9 au travail 2",
    className: ""
};
const toggle167Data = {
    className: "toggle-137",
    buttonSecondaryProps: buttonSecondary167Data
};
const ouinon179Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-26-1"
};
const ouinon180Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-26-2"
};
const ouinon181Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-26"
};
const buttonSecondary168Data = {
    children: "Sant\xe9 et S\xe9curit\xe9 au travail 3",
    className: ""
};
const toggle168Data = {
    className: "toggle-138",
    buttonSecondaryProps: buttonSecondary168Data
};
const ouinon182Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-43"
};
const buttonSecondary169Data = {
    children: "5/6",
    className: "button-secondary-94"
};
const toggle169Data = {
    className: "toggle-139",
    buttonSecondaryProps: buttonSecondary169Data
};
const social5Data = {
    x1200PxLogo_Icam__20081: "",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre bilan carbone?",
    inputType6: "text",
    inputPlaceholder6: "Connaissez vous votre bilan carbone?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    navItems3Props: navItems357Data,
    toggle1Props: toggle166Data,
    ouinon21Props: ouinon226Data,
    ouinon22Props: ouinon227Data,
    ouinon23Props: ouinon228Data,
    ouinon24Props: ouinon229Data,
    toggle2Props: toggle167Data,
    ouinon1Props: ouinon179Data,
    ouinon2Props: ouinon180Data,
    ouinon3Props: ouinon181Data,
    toggle3Props: toggle168Data,
    ouinon4Props: ouinon182Data,
    toggle4Props: toggle169Data
};
const frame1172267Data = {
    children: "Existing Case"
};
const frame1162268Data = {
    children: "Reference Cases"
};
const frame1132288Data = {
    className: ""
};
const navItems358Data = {
    className: "nav-items-3-58",
    frame1172Props: frame1172267Data,
    frame1162Props: frame1162268Data,
    frame1132Props: frame1132288Data
};
const buttonSecondary170Data = {
    children: "Information and Communication Technoly (ICT)",
    className: ""
};
const toggle170Data = {
    className: "toggle-6",
    buttonSecondaryProps: buttonSecondary170Data
};
const ouinon183Data = {
    yes: "Yes",
    place: "No"
};
const frame136137Data = {
    ouinonProps: ouinon183Data
};
const ouinon184Data = {
    yes: "Yes",
    place: "No"
};
const frame136138Data = {
    ouinonProps: ouinon184Data
};
const ouinon185Data = {
    yes: "Yes",
    place: "No"
};
const frame136139Data = {
    ouinonProps: ouinon185Data
};
const ouinon186Data = {
    yes: "Yes",
    place: "No"
};
const frame136140Data = {
    ouinonProps: ouinon186Data
};
const ouinon187Data = {
    yes: "Yes",
    place: "No"
};
const frame136141Data = {
    ouinonProps: ouinon187Data
};
const ouinon188Data = {
    yes: "Yes",
    place: "No"
};
const frame136142Data = {
    ouinonProps: ouinon188Data
};
const ouinon189Data = {
    yes: "Yes",
    place: "No"
};
const frame136143Data = {
    ouinonProps: ouinon189Data
};
const buttonSecondary171Data = {
    children: "Human machine interaction (HMI)",
    className: ""
};
const toggle171Data = {
    className: "toggle-6",
    buttonSecondaryProps: buttonSecondary171Data
};
const ouinon190Data = {
    yes: "Yes",
    place: "No"
};
const frame136144Data = {
    ouinonProps: ouinon190Data
};
const buttonSecondary172Data = {
    children: "4/4",
    className: "button-secondary-95"
};
const toggle172Data = {
    className: "toggle-140",
    buttonSecondaryProps: buttonSecondary172Data
};
const modernization4Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType5: "text",
    inputPlaceholder5: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre bilan carbone?",
    leadTimeCriteria: "Lead time criteria",
    navItems3Props: navItems358Data,
    toggle1Props: toggle170Data,
    frame1361Props: frame136137Data,
    frame1362Props: frame136138Data,
    frame1363Props: frame136139Data,
    frame1364Props: frame136140Data,
    frame1365Props: frame136141Data,
    frame1366Props: frame136142Data,
    frame1367Props: frame136143Data,
    toggle2Props: toggle171Data,
    frame1368Props: frame136144Data,
    toggle3Props: toggle172Data
};
const frame1172268Data = {
    children: "Existing Case"
};
const frame1162269Data = {
    children: "Reference Cases"
};
const frame1132289Data = {
    className: ""
};
const navItems359Data = {
    className: "nav-items-3-59",
    frame1172Props: frame1172268Data,
    frame1162Props: frame1162269Data,
    frame1132Props: frame1132289Data
};
const buttonSecondary173Data = {
    children: "External Providers 1",
    className: ""
};
const toggle173Data = {
    className: "toggle-30",
    buttonSecondaryProps: buttonSecondary173Data
};
const ouinon191Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-1"
};
const ouinon192Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-2"
};
const ouinon193Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-3"
};
const buttonSecondary174Data = {
    children: "External Providers 2",
    className: ""
};
const toggle174Data = {
    className: "toggle-30",
    buttonSecondaryProps: buttonSecondary174Data
};
const ouinon194Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-4"
};
const ouinon195Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-44"
};
const buttonSecondary175Data = {
    children: "Process Approach",
    className: ""
};
const toggle175Data = {
    className: "toggle-141",
    buttonSecondaryProps: buttonSecondary175Data
};
const ouinon196Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-5"
};
const ouinon197Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-6"
};
const ouinon198Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27-7"
};
const ouinon199Data = {
    place: "Yes",
    yes: "No",
    className: "ouinon-27"
};
const frame1112Data = {
    toggle1Props: toggle173Data,
    ouinon1Props: ouinon191Data,
    ouinon2Props: ouinon192Data,
    ouinon3Props: ouinon193Data,
    toggle2Props: toggle174Data,
    ouinon4Props: ouinon194Data,
    ouinon5Props: ouinon195Data,
    toggle3Props: toggle175Data,
    ouinon6Props: ouinon196Data,
    ouinon7Props: ouinon197Data,
    ouinon8Props: ouinon198Data,
    ouinon9Props: ouinon199Data
};
const buttonSecondary176Data = {
    children: "8/8",
    className: "button-secondary-96"
};
const toggle176Data = {
    className: "toggle-142",
    buttonSecondaryProps: buttonSecondary176Data
};
const quality8Data = {
    navItems3Props: navItems359Data,
    frame111Props: frame1112Data,
    toggleProps: toggle176Data
};
const navItems258Data = {
    className: "nav-items-2-57"
};
const frame1172269Data = {
    children: "Existing Case"
};
const frame1162270Data = {
    children: "Reference Cases"
};
const frame1132290Data = {
    className: ""
};
const navItems360Data = {
    className: "nav-items-3-60",
    frame1172Props: frame1172269Data,
    frame1162Props: frame1162270Data,
    frame1132Props: frame1132290Data
};
const buttonSecondary177Data = {
    children: "Customer Requirements 1",
    className: ""
};
const toggle177Data = {
    className: "toggle-143",
    buttonSecondaryProps: buttonSecondary177Data
};
const ouinon200Data = {
    yes: "Yes",
    place: "No"
};
const frame136145Data = {
    ouinonProps: ouinon200Data
};
const ouinon201Data = {
    yes: "Yes",
    place: "No"
};
const frame136146Data = {
    ouinonProps: ouinon201Data
};
const ouinon202Data = {
    yes: "Yes",
    place: "No"
};
const frame136147Data = {
    ouinonProps: ouinon202Data
};
const buttonSecondary178Data = {
    children: "Customer Requirements 2",
    className: ""
};
const toggle178Data = {
    className: "toggle-144",
    buttonSecondaryProps: buttonSecondary178Data
};
const ouinon203Data = {
    yes: "Yes",
    place: "No"
};
const frame136148Data = {
    ouinonProps: ouinon203Data
};
const ouinon204Data = {
    yes: "Yes",
    place: "No"
};
const frame136149Data = {
    ouinonProps: ouinon204Data
};
const ouinon205Data = {
    yes: "Yes",
    place: "No"
};
const frame136150Data = {
    ouinonProps: ouinon205Data
};
const buttonSecondary179Data = {
    children: "Customer Requirements 3",
    className: ""
};
const toggle179Data = {
    className: "toggle-145",
    buttonSecondaryProps: buttonSecondary179Data
};
const ouinon206Data = {
    yes: "Yes",
    place: "No"
};
const frame136151Data = {
    ouinonProps: ouinon206Data
};
const ouinon207Data = {
    yes: "Yes",
    place: "No"
};
const frame136152Data = {
    className: "frame-153-8",
    ouinonProps: ouinon207Data
};
const frame13310Data = {
    frame136Props: frame136152Data
};
const frame1449Data = {
    frame133Props: frame13310Data
};
const ouinon208Data = {
    yes: "Yes",
    place: "No"
};
const frame136153Data = {
    ouinonProps: ouinon208Data
};
const buttonSecondary180Data = {
    children: "1/8",
    className: "button-secondary-97"
};
const toggle180Data = {
    className: "toggle-146",
    buttonSecondaryProps: buttonSecondary180Data
};
const clientConsommateur3Data = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    inputType1: "text",
    inputPlaceholder1: "Connaissez vous votre bilan carbone?",
    inputType2: "text",
    inputPlaceholder2: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType3: "text",
    inputPlaceholder3: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType4: "text",
    inputPlaceholder4: "Connaissez vous votre bilan carbone?",
    inputType5: "text",
    inputPlaceholder5: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType6: "text",
    inputPlaceholder6: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    inputType7: "text",
    inputPlaceholder7: "Connaissez vous votre bilan carbone?",
    inputType8: "text",
    inputPlaceholder8: "Connaissez vous votre tonnage de carbone rejet\xe9?",
    inputType9: "text",
    inputPlaceholder9: "De quel type de chauffage sont \xe9quip\xe9s vos b\xe2timents?",
    goOnToTheNextStep: "Go on to the next step",
    navItems2Props: navItems258Data,
    navItems3Props: navItems360Data,
    toggle1Props: toggle177Data,
    frame1361Props: frame136145Data,
    frame1362Props: frame136146Data,
    frame1363Props: frame136147Data,
    toggle2Props: toggle178Data,
    frame1364Props: frame136148Data,
    frame1365Props: frame136149Data,
    frame1366Props: frame136150Data,
    toggle3Props: toggle179Data,
    frame1367Props: frame136151Data,
    frame144Props: frame1449Data,
    frame1368Props: frame136153Data,
    toggle4Props: toggle180Data
};
const frame1133225Data = {
    className: "frame-113-24"
};
const frame11778Data = {
    className: "frame-117-142"
};
const frame114264Data = {
    className: "frame-114-152"
};
const frame1132291Data = {
    className: "frame-113-99"
};
const referencesData = {
    resultsPropositions: "Results & Propositions",
    label1: "Existing case",
    label2: "Reference case",
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    inputType1: "text",
    inputPlaceholder1: "      /25",
    tracbility: "Tracbility",
    place1: "Quality",
    vector371: "/img/vector-37@2x.png",
    vector372: "/img/vector-37-1@2x.png",
    vector38: "/img/vector-37-1@2x.png",
    product: "Product",
    validation: "Validation",
    iso9001Isf: "ISO 9001 (ISF)",
    vector373: "/img/vector-37-1@2x.png",
    processValidation: "Process Validation",
    line211: "/img/line-21@2x.png",
    cost: "Cost",
    inputType2: "text",
    inputPlaceholder2: "      /25",
    line212: "/img/line-21-1@2x.png",
    vector374: "/img/vector-37-3@2x.png",
    vector375: "/img/vector-37-4@2x.png",
    vector376: "/img/vector-37-5@2x.png",
    vector377: "/img/vector-37-6@2x.png",
    transportCost: "Transport cost",
    manufacturingCost: "Manufacturing cost",
    deliveryCost: "Delivery cost",
    exportCost: "Export cost",
    modernisation: "Modernisation",
    inputType3: "text",
    inputPlaceholder3: "      /25",
    line213: "/img/line-21-1@2x.png",
    vector378: "/img/vector-37-3@2x.png",
    vector379: "/img/vector-37-4@2x.png",
    vector3710: "/img/vector-37-5@2x.png",
    vector3711: "/img/vector-37-6@2x.png",
    supplyChain40: "Supply chain 4.0",
    informationSystem: "Information system",
    ergonomics: "Ergonomics",
    newTechnologiesAiRoboticsEtc: "New technologies (AI, robotics, etc.)",
    leadTime: "Lead Time",
    inputType4: "text",
    inputPlaceholder4: "      /25",
    line214: "/img/line-21-3@2x.png",
    vector3712: "/img/vector-37-11@2x.png",
    vector3713: "/img/vector-37-12@2x.png",
    vector3714: "/img/vector-37-13@2x.png",
    manufacturingTime: "Manufacturing time",
    deliveryTime: "Delivery time",
    storageTime: "Storage time",
    place2: "Back",
    propositions: "Propositions",
    frame11332Props: frame1133225Data,
    frame117Props: frame11778Data,
    frame1142Props: frame114264Data,
    frame11322Props: frame1132291Data
};
const frame1172270Data = {
    children: "Existing Case"
};
const frame1162271Data = {
    children: "Reference Cases"
};
const frame1132292Data = {
    className: ""
};
const navItems361Data = {
    className: "nav-items-3-61",
    frame1172Props: frame1172270Data,
    frame1162Props: frame1162271Data,
    frame1132Props: frame1132292Data
};
const frame1133226Data = {
    className: "frame-113-25"
};
const curPerformanceData = {
    navItems3Props: navItems361Data,
    frame11332Props: frame1133226Data
};
const headerMenuDefault62Data = {
    children: "New Case"
};
const headerMenuDefault56Data = {
    children: "Existing Case",
    className: "menu-item-default-27-1"
};
const headerMenuDefault57Data = {
    children: "Reference Case",
    className: "menu-item-default-27-2"
};
const headerMenuDefault15Data = {
    children: "Logout"
};
const headerMenuDefault58Data = {
    children: "Modeling",
    className: "menu-item-default-34"
};
const headerMenuDefault59Data = {
    children: "Analysis",
    className: "menu-item-default-27"
};
const headerMenuDefault63Data = {
    children: "Results & Objectives",
    className: "menu-item-default-38"
};
const buttonSecondary181Data = {
    children: "1/2",
    className: "button-secondary-50"
};
const toggle181Data = {
    className: "toggle-147",
    buttonSecondaryProps: buttonSecondary181Data
};
const buttonSecondary182Data = {
    children: "Next",
    className: "button-secondary-50"
};
const toggle182Data = {
    className: "toggle-148",
    buttonSecondaryProps: buttonSecondary182Data
};
const leadTimeData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    label1: "Home",
    label2: "Design",
    headerMenuDefault61Props: headerMenuDefault62Data,
    headerMenuDefault51Props: headerMenuDefault56Data,
    headerMenuDefault52Props: headerMenuDefault57Data,
    headerMenuDefaultProps: headerMenuDefault15Data,
    headerMenuDefault53Props: headerMenuDefault58Data,
    headerMenuDefault54Props: headerMenuDefault59Data,
    headerMenuDefault62Props: headerMenuDefault63Data,
    toggle1Props: toggle181Data,
    toggle2Props: toggle182Data
};
const headerMenuDefault64Data = {
    children: "New Case"
};
const headerMenuDefault510Data = {
    children: "Existing Case",
    className: "menu-item-default-28-1"
};
const headerMenuDefault511Data = {
    children: "Reference Case",
    className: "menu-item-default-28-2"
};
const headerMenuDefault16Data = {
    children: "Logout"
};
const headerMenuDefault512Data = {
    children: "Modeling",
    className: "menu-item-default-35"
};
const headerMenuDefault513Data = {
    children: "Analysis",
    className: "menu-item-default-28"
};
const headerMenuDefault65Data = {
    children: "Results & Objectives",
    className: "menu-item-default-40"
};
const buttonSecondary183Data = {
    children: "1/2",
    className: "button-secondary-98"
};
const toggle183Data = {
    className: "toggle-149",
    buttonSecondaryProps: buttonSecondary183Data
};
const buttonSecondary184Data = {
    children: "Next",
    className: "button-secondary-99"
};
const toggle184Data = {
    className: "toggle-150",
    buttonSecondaryProps: buttonSecondary184Data
};
const costData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    label1: "Home",
    label2: "Design",
    headerMenuDefault61Props: headerMenuDefault64Data,
    headerMenuDefault51Props: headerMenuDefault510Data,
    headerMenuDefault52Props: headerMenuDefault511Data,
    headerMenuDefaultProps: headerMenuDefault16Data,
    headerMenuDefault53Props: headerMenuDefault512Data,
    headerMenuDefault54Props: headerMenuDefault513Data,
    headerMenuDefault62Props: headerMenuDefault65Data,
    toggle1Props: toggle183Data,
    toggle2Props: toggle184Data
};
const avatarsData = {
    ellipse83: "/img/ellipse-83-3@2x.png",
    ellipse81: "/img/ellipse-81@2x.png"
};
const buttonSecondary185Data = {
    children: "2/2",
    className: "button-secondary-51"
};
const toggle185Data = {
    className: "toggle-151",
    buttonSecondaryProps: buttonSecondary185Data
};
const headerMenuDefault66Data = {
    children: "New Case"
};
const headerMenuDefault514Data = {
    children: "Existing Case",
    className: "menu-item-default-29-1"
};
const headerMenuDefault515Data = {
    children: "Reference Case",
    className: "menu-item-default-29-2"
};
const headerMenuDefault17Data = {
    children: "Logout"
};
const headerMenuDefault516Data = {
    children: "Modeling",
    className: "menu-item-default-36"
};
const headerMenuDefault517Data = {
    children: "Analysis",
    className: "menu-item-default-29"
};
const headerMenuDefault67Data = {
    children: "Results & Objectives",
    className: "menu-item-default-42"
};
const buttonSecondary186Data = {
    children: "Information System",
    className: "button-secondary-51"
};
const toggle186Data = {
    className: "toggle-27",
    buttonSecondaryProps: buttonSecondary186Data
};
const group102205Data = {
    line24: "/img/line-24-39.png"
};
const group102206Data = {
    line24: "/img/line-24-40.png"
};
const group102207Data = {
    line24: "/img/line-24-75.png"
};
const group102208Data = {
    line24: "/img/line-24-42.png"
};
const group102209Data = {
    line24: "/img/line-24-43.png"
};
const buttonSecondary187Data = {
    children: "New Technologies (IA, Robotics)",
    className: "button-secondary-51"
};
const toggle187Data = {
    className: "toggle-27",
    buttonSecondaryProps: buttonSecondary187Data
};
const group102210Data = {
    line24: "/img/line-24-10.png",
    className: "group-22-2"
};
const group102211Data = {
    line24: "/img/line-24-16.png",
    className: "group-22-3"
};
const group102212Data = {
    line24: "/img/line-24-17.png",
    className: "group-22-4"
};
const group102213Data = {
    line24: "/img/line-24-81.png",
    className: "group-22-5"
};
const group102214Data = {
    line24: "/img/line-24-48.png",
    className: "group-22"
};
const buttonSecondary188Data = {
    children: "Lead time criteria",
    className: "button-secondary-100"
};
const toggle188Data = {
    className: "toggle-152",
    buttonSecondaryProps: buttonSecondary188Data
};
const modernizationData = {
    x1200PxLogo_Icam__20081: "/img/1200px-logo-icam---2008-1@2x.png",
    admin: "ADMIN",
    pleaseAnswerTheFollowingQuestions: "PLEASE ANSWER THE FOLLOWING QUESTIONS",
    label1: "Home",
    label2: "Design",
    inputType1: "text",
    inputPlaceholder1: "Utilisez vous une ERP?",
    inputType2: "text",
    inputPlaceholder2: "Utilisez vous  cette ERP pour passer les commandes?",
    inputType3: "text",
    inputPlaceholder3: "Quel canal utilisez vous pour communiquer dans l\u2019entreprise? ",
    inputType4: "text",
    inputPlaceholder4: "*******************************************",
    inputType5: "text",
    inputPlaceholder5: "*******************************************",
    inputType6: "text",
    inputPlaceholder6: "Utilisez vous des robots?",
    inputType7: "text",
    inputPlaceholder7: "utilisez des RPA?",
    inputType8: "text",
    inputPlaceholder8: "Mod\xe9lisez vous vos processus 3D pour une meilleure visibilit\xe9?",
    inputType9: "text",
    inputPlaceholder9: "***********************************************",
    inputType10: "text",
    inputPlaceholder10: "*************************************",
    avatarsProps: avatarsData,
    toggle1Props: toggle185Data,
    headerMenuDefault61Props: headerMenuDefault66Data,
    headerMenuDefault51Props: headerMenuDefault514Data,
    headerMenuDefault52Props: headerMenuDefault515Data,
    headerMenuDefaultProps: headerMenuDefault17Data,
    headerMenuDefault53Props: headerMenuDefault516Data,
    headerMenuDefault54Props: headerMenuDefault517Data,
    headerMenuDefault62Props: headerMenuDefault67Data,
    toggle2Props: toggle186Data,
    group1021Props: group102205Data,
    group1022Props: group102206Data,
    group1023Props: group102207Data,
    group1024Props: group102208Data,
    group1025Props: group102209Data,
    toggle3Props: toggle187Data,
    group1026Props: group102210Data,
    group1027Props: group102211Data,
    group1028Props: group102212Data,
    group1029Props: group102213Data,
    group10210Props: group102214Data,
    toggle4Props: toggle188Data
};

},{"react/jsx-runtime":"gaGEj","./App.css":"eruV5","react":"6uln9","react-router-dom":"5fzqq","./components/Connexion":"jwSyG","./components/InformationalModel":"61p26","./components/Home":"2U4kJ","./components/FunctionalView1":"2d45G","./components/Aquisition":"8nwJV","./components/PhysicalModel1":"iPEb3","./components/ExistingCase":"1PmAk","./components/DecisionalModel1":"6DPHO","./components/ProcessView1":"7NTJs","./components/InformationalModel1":"kNnw4","./components/Environmental1":"eHkL6","./components/MeasuringForm":"5hCsc","./components/LeanVSM1":"dxE9M","./components/X5S1":"iTPpq","./components/Analysis":"49Q6K","./components/VisualManagement1":"kVnIF","./components/FunctionalView":"iPZtN","./components/Objectives":"6Bm4A","./components/PhysicalModel":"dZsWI","./components/DecisionalModel":"i4Eaq","./components/ProcessView":"eAqxD","./components/SMED2":"fUL0s","./components/SMED3":"is08s","./components/VisualManagement2":"4GnDj","./components/Kaizen3":"eZr1N","./components/VisualManagement3":"kItiI","./components/CurPerformances":"cW6a1","./components/Inscription":"2DKHi","./components/ClientConsommateur2":"3ZD9U","./components/Social1":"6hRKs","./components/Modernization1":"91YvI","./components/ClientConsommateur1":"hwfHw","./components/LeadTime1":"5CGgc","./components/Cost1":"cvZJK","./components/Quality1":"gtWhX","./components/Quality7":"lF3Z1","./components/Environmental2":"ex2EC","./components/Environmental3":"fuBbu","./components/Social2":"5G3JX","./components/Modernization2":"eMELU","./components/Cost2":"7QKHV","./components/LeadTime2":"zBsDr","./components/Quality6":"cQ4XY","./components/InformationalModel3":"5bGvI","./components/InformationalModel2":"cTZ96","./components/ProcessView2":"5Rluw","./components/Quality2":"83Ssi","./components/ProcessView3":"hz86Z","./components/DecisionalView2":"4uf0w","./components/PhysicalModel2":"i2zVv","./components/DecisionalView3":"eVo5s","./components/Quality5":"3sFO7","./components/PhysicalModel3":"34aN5","./components/FunctionnalView2":"b42NM","./components/FunctionnalView3":"iFO9V","./components/FunctionnalView4":"1oQKb","./components/LoadingPage":"iBxK1","./components/Kaizen1":"3WCWa","./components/ExistingSystems":"dW5Jc","./components/Kanban1":"juQJU","./components/LeanVSM":"duzIw","./components/SMED1":"5dids","./components/X5S":"iG3Lu","./components/Kaizen12":"9uODK","./components/Quality4":"jKbL3","./components/Kaizen":"7OkZe","./components/SMED":"8xDMK","./components/VisualManagement":"hmjNi","./components/Kanban":"4GVOG","./components/Kaizen2":"e9OxE","./components/Kanban3":"b3JmF","./components/MesureDePerformancesFutures":"iD3FV","./components/X5s2":"aH9TA","./components/Kanban2":"2Vyda","./components/X5s3":"fjDfn","./components/LeanVSM3":"9Engt","./components/LeanVSM2":"aX9n9","./components/Kaizen11":"enZ2x","./components/Quality3":"1NFJv","./components/LeanVSM4":"gMqKM","./components/MesureDePerformancesFutures1":"1N3Vo","./components/ExistingSystems2":"59mst","./components/Environmental5":"jhgCb","./components/Social3":"hem2r","./components/Environmental4":"hDixB","./components/Modernization3":"cX9bz","./components/Social4":"kzbDB","./components/Social6":"hHc62","./components/Social5":"5NgzO","./components/Modernization4":"b543i","./components/Quality8":"dwIXU","./components/ClientConsommateur3":"iVOas","./components/References":"fG7lc","./components/CurPerformance":"RTx19","./components/LeadTime":"lO3Td","./components/Cost":"3LKzF","./components/Modernization":"13Zmq","./components/Login/Login":"jvLqO","./components/Analysis1/Analysis":"dw0u4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eruV5":[function() {},{}],"5fzqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"i3TiW","@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","history":"grwqf","prop-types":"6FKs7","tiny-warning":"328jC","@babel/runtime/helpers/esm/extends":"fW5l8","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3TiW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global$1, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","prop-types":"6FKs7","history":"grwqf","tiny-warning":"328jC","tiny-invariant":"dPEnp","@babel/runtime/helpers/esm/extends":"fW5l8","path-to-regexp":"ejAzl","react-is":"aUAsc","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9IZpV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"hT6Yn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hT6Yn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"6FKs7":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"7ziwC"}],"7ziwC":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4Cml4"}],"4Cml4":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"grwqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"fW5l8","resolve-pathname":"0395z","value-equal":"1MFfb","tiny-warning":"328jC","tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fW5l8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0395z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1MFfb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"328jC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPEnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ejAzl":[function(require,module,exports,__globalThis) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + escapeString(delimiter) + ']+?';
    return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"grrgb"}],"grrgb":[function(require,module,exports,__globalThis) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],"aUAsc":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1Qg5l"}],"1Qg5l":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"5R6Zx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bvdc":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"aUAsc"}],"jwSyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame94 = require("../Frame94");
var _frame94Default = parcelHelpers.interopDefault(_frame94);
var _frame95 = require("../Frame95");
var _frame95Default = parcelHelpers.interopDefault(_frame95);
var _connexionCss = require("./Connexion.css");
function Connexion(props) {
    const { polygon3, aerialViewContainerCargoShipSea1, subtract, polygon1, polygon2, login1, login2, frame126 } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
            className: "connexion screen",
            name: "form3",
            action: "form3",
            method: "post",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "polygon-3",
                        src: polygon3,
                        alt: "Polygon 3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-129",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "aerial-view-container-cargo-ship-sea-1",
                            src: aerialViewContainerCargoShipSea1,
                            alt: "aerial-view-container-cargo-ship-sea 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "ellipse-1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "ellipse-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        className: "subtract",
                        src: subtract,
                        alt: "Subtract"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-127",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "polygon-1",
                            src: polygon1,
                            alt: "Polygon 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-128",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "polygon-2",
                            src: polygon2,
                            alt: "Polygon 2"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "javascript:SubmitForm('form3')",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-88",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "javascript:SubmitForm('form3')",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: "/home",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "login valign-text-middle inter-extra-bold-bone-13px",
                                            children: login1
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overlap-group1",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "javascript:SubmitForm('form3')",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-2"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/inscription",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "login valign-text-middle inter-extra-bold-bone-13px",
                                    children: login2
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-126",
                        style: {
                            backgroundImage: `url(${frame126})`
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame94Default.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame95Default.default), {})
                ]
            })
        })
    });
}
exports.default = Connexion;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame94":"6KgLy","../Frame95":"cfzHi","./Connexion.css":"8xfel","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6KgLy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame94Css = require("./Frame94.css");
function Frame94(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-94 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "username subtitel",
                children: "Username"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group2",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-4361"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: "tap-here subtitel",
                        name: "taphere",
                        placeholder: "Tap here",
                        type: "text",
                        required: true
                    })
                ]
            })
        ]
    });
}
exports.default = Frame94;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame94.css":"lEglG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lEglG":[function() {},{}],"cfzHi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame95Css = require("./Frame95.css");
function Frame95(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-95 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "password subtitel",
                children: "Password"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-4362"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        className: "tap-here-2 subtitel",
                        name: "taphere",
                        placeholder: "Tap here",
                        type: "password",
                        required: true
                    })
                ]
            })
        ]
    });
}
exports.default = Frame95;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame95.css":"kjSf4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kjSf4":[function() {},{}],"8xfel":[function() {},{}],"61p26":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _navItems452 = require("../NavItems452");
var _navItems452Default = parcelHelpers.interopDefault(_navItems452);
var _tableHeader = require("../TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableNumberPrimaryKey = require("../TableNumberPrimaryKey");
var _tableNumberPrimaryKeyDefault = parcelHelpers.interopDefault(_tableNumberPrimaryKey);
var _tableTextBase = require("../TableTextBase");
var _tableTextBaseDefault = parcelHelpers.interopDefault(_tableTextBase);
var _tableTextBaseNull = require("../TableTextBaseNull");
var _tableTextBaseNullDefault = parcelHelpers.interopDefault(_tableTextBaseNull);
var _crewMember = require("../CrewMember");
var _crewMemberDefault = parcelHelpers.interopDefault(_crewMember);
var _crewMember2 = require("../CrewMember2");
var _crewMember2Default = parcelHelpers.interopDefault(_crewMember2);
var _crewMember3 = require("../CrewMember3");
var _crewMember3Default = parcelHelpers.interopDefault(_crewMember3);
var _crewMember4 = require("../CrewMember4");
var _crewMember4Default = parcelHelpers.interopDefault(_crewMember4);
var _crewMember5 = require("../CrewMember5");
var _crewMember5Default = parcelHelpers.interopDefault(_crewMember5);
var _informationalModelCss = require("./InformationalModel.css");
function InformationalModel(props) {
    const { x1200PxLogo_Icam__20081, design, arrow7, arrow8, line31, line4, line2, label1, textFormat, label2, line1, place, clickOnModeling, arrow1, arrow2, line32, arrow5, arrow6, modeling, nextStep, navItems452Props, tableHeaderProps, crewMemberProps, crewMember2Props, crewMember3Props, crewMember4Props, crewMember5Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "informational-model screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems452Default.default), {
                            frame1162Props: navItems452Props.frame1162Props,
                            frame1172Props: navItems452Props.frame1172Props,
                            frame1136Props: navItems452Props.frame1136Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-7",
                                            src: arrow7,
                                            alt: "Arrow 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-8",
                                            src: arrow8,
                                            alt: "Arrow 8"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "crew-member",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "table-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderDefault.default), {
                                                    children: tableHeaderProps.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberPrimaryKeyDefault.default), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "table-text-base-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseNullDefault.default), {})
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-3",
                                            src: line31,
                                            alt: "Line 3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-4",
                                            src: line4,
                                            alt: "Line 4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group14",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-1",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1",
                                    src: line1,
                                    alt: "Line 1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/process-view",
                                                    className: "align-self-flex-end",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-10",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "click-on-modeling valign-text-middle bevan-normal-white-20px",
                                                    children: clickOnModeling
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group16",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group13",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-6"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMemberDefault.default), {
                                                            tableHeaderProps: crewMemberProps.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMemberProps.tableNumberPrimaryKey2Props,
                                                            tableTextBase2Props: crewMemberProps.tableTextBase2Props,
                                                            tableTextBaseNull2Props: crewMemberProps.tableTextBaseNull2Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember2Default.default), {
                                                            tableHeaderProps: crewMember2Props.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMember2Props.tableNumberPrimaryKey2Props,
                                                            tableTextBase3Props: crewMember2Props.tableTextBase3Props,
                                                            tableTextBaseNull2Props: crewMember2Props.tableTextBaseNull2Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember3Default.default), {
                                                            tableHeaderProps: crewMember3Props.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMember3Props.tableNumberPrimaryKey2Props,
                                                            tableTextBase2Props: crewMember3Props.tableTextBase2Props,
                                                            tableTextBaseNull3Props: crewMember3Props.tableTextBaseNull3Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember4Default.default), {
                                                            tableHeaderProps: crewMember4Props.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMember4Props.tableNumberPrimaryKey2Props,
                                                            tableTextBase2Props: crewMember4Props.tableTextBase2Props,
                                                            tableTextBaseNull2Props: crewMember4Props.tableTextBaseNull2Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-1",
                                                            src: arrow1,
                                                            alt: "Arrow 1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-2",
                                                            src: arrow2,
                                                            alt: "Arrow 2"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-3-1",
                                                            src: line32,
                                                            alt: "Line 3"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember5Default.default), {
                                                    tableHeaderProps: crewMember5Props.tableHeaderProps,
                                                    tableNumberPrimaryKey2Props: crewMember5Props.tableNumberPrimaryKey2Props,
                                                    tableTextBase2Props: crewMember5Props.tableTextBase2Props,
                                                    tableTextBaseNull2Props: crewMember5Props.tableTextBaseNull2Props
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-5",
                                                    src: arrow5,
                                                    alt: "Arrow 5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-6",
                                                    src: arrow6,
                                                    alt: "Arrow 6"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    href: "https://app.diagrams.net/",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-11",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/lean-vsm",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-9",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "next-step valign-text-middle inter-bold-mineral-green-18px",
                                                            children: nextStep
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = InformationalModel;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../NavItems452":"8OzdE","../TableHeader":"i6j7M","../TableNumberPrimaryKey":"dI82u","../TableTextBase":"caprm","../TableTextBaseNull":"h1gug","../CrewMember":"kG8zd","../CrewMember2":"hVQkj","../CrewMember3":"gl6Ge","../CrewMember4":"7hGvH","../CrewMember5":"bG5RL","./InformationalModel.css":"k8c6D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5fizG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11332Css = require("./Frame11332.css");
function Frame11332(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-113 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "aquisition valign-text-middle inter-medium-star-dust-18px",
            children: "Aquisition"
        })
    });
}
exports.default = Frame11332;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11332.css":"NRlUM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"NRlUM":[function() {},{}],"7sM2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame114Css = require("./Frame114.css");
var _reactRouterDom = require("react-router-dom");
function Frame114() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/functional-view-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-114",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "modeling-1 valign-text-middle inter-medium-star-dust-18px",
                children: "Modeling"
            })
        })
    });
}
exports.default = Frame114;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame114.css":"6uq72","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6uq72":[function() {},{}],"dirkn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame115Css = require("./Frame115.css");
var _reactRouterDom = require("react-router-dom");
function Frame115() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/analysis",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-115",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "analysis valign-text-middle inter-medium-star-dust-18px",
                children: "Analysis"
            })
        })
    });
}
exports.default = Frame115;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame115.css":"15Jvl","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"15Jvl":[function() {},{}],"1obhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame116Css = require("./Frame116.css");
var _reactRouterDom = require("react-router-dom");
function Frame116() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/cur-performances",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-116",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "result-objectives valign-text-middle inter-medium-star-dust-18px",
                children: "Result & Objectives"
            })
        })
    });
}
exports.default = Frame116;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame116.css":"9xH7u","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9xH7u":[function() {},{}],"lrJXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11322Css = require("./Frame11322.css");
var _reactRouterDom = require("react-router-dom");
function Frame11322(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/connexion",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-113-2 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "logout valign-text-middle inter-medium-rum-swizzle-18px",
                children: "Logout"
            })
        })
    });
}
exports.default = Frame11322;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11322.css":"2k6TS","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2k6TS":[function() {},{}],"8OzdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11452 = require("../Frame11452");
var _frame11452Default = parcelHelpers.interopDefault(_frame11452);
var _frame11632 = require("../Frame11632");
var _frame11632Default = parcelHelpers.interopDefault(_frame11632);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame1136 = require("../Frame1136");
var _frame1136Default = parcelHelpers.interopDefault(_frame1136);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _navItems452Css = require("./NavItems452.css");
function NavItems452(props) {
    const { frame1162Props, frame1172Props, frame1136Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "nav-items-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11452Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11632Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                children: frame1162Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                children: frame1172Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1136Default.default), {
                children: frame1136Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
        ]
    });
}
exports.default = NavItems452;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame11452":"8qLPx","../Frame11632":"1Rc4t","../Frame11622":"6kTsO","../Frame11722":"k9cYz","../Frame1136":"8aQ7W","../Frame11342":"2AuVF","./NavItems452.css":"laxUB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qLPx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11452Css = require("./Frame11452.css");
function Frame11452() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-114-82",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "functional-view valign-text-middle inter-medium-star-dust-18px",
            children: "Functional view"
        })
    });
}
exports.default = Frame11452;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11452.css":"lLYed","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lLYed":[function() {},{}],"1Rc4t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11632Css = require("./Frame11632.css");
function Frame11632() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-116-84",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "physical-model valign-text-middle inter-medium-star-dust-18px",
            children: "Physical Model"
        })
    });
}
exports.default = Frame11632;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11632.css":"eVUXt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eVUXt":[function() {},{}],"6kTsO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11622Css = require("./Frame11622.css");
function Frame11622(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-115-88",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "decisional-model valign-text-middle inter-medium-star-dust-18px",
            children: children
        })
    });
}
exports.default = Frame11622;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11622.css":"hMQCu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hMQCu":[function() {},{}],"k9cYz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11722Css = require("./Frame11722.css");
function Frame11722(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-117-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "process-view valign-text-middle inter-medium-star-dust-18px",
            children: children
        })
    });
}
exports.default = Frame11722;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11722.css":"72PXF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"72PXF":[function() {},{}],"8aQ7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1136Css = require("./Frame1136.css");
function Frame1136(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-118 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "informational-model-1 valign-text-middle inter-medium-white-18px",
            children: children
        })
    });
}
exports.default = Frame1136;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1136.css":"5cfy1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cfy1":[function() {},{}],"2AuVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11342Css = require("./Frame11342.css");
function Frame11342() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-113-8",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "cur-performance valign-text-middle inter-medium-star-dust-18px",
            children: "Cur. Performance"
        })
    });
}
exports.default = Frame11342;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11342.css":"febub","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"febub":[function() {},{}],"laxUB":[function() {},{}],"i6j7M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableHeaderCss = require("./TableHeader.css");
function TableHeader(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `table-header-2 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "table-name-2 valign-text-middle worksans-semi-bold-white-16px",
            children: children
        })
    });
}
exports.default = TableHeader;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./TableHeader.css":"kOIpO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kOIpO":[function() {},{}],"dI82u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase = require("../TableNumberBase");
var _tableNumberBaseDefault = parcelHelpers.interopDefault(_tableNumberBase);
var _tableNumberPrimaryKeyCss = require("./TableNumberPrimaryKey.css");
function TableNumberPrimaryKey() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-primary-key",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBaseDefault.default), {})
    });
}
exports.default = TableNumberPrimaryKey;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase":"dbMLj","./TableNumberPrimaryKey.css":"2eEIw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dbMLj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBaseCss = require("./TableNumberBase.css");
function TableNumberBase() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-2",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "field",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "null valign-text-middle ibmplexmono-normal-black-14px hidden",
                        children: "NULL"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line",
                            src: "/img/bottom-line-15@2x.png",
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line",
                            src: "/img/left-line-15@2x.png",
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line",
                            src: "/img/right-line-15@2x.png",
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./TableNumberBase.css":"899kH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"899kH":[function() {},{}],"2eEIw":[function() {},{}],"caprm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase2 = require("../TableNumberBase2");
var _tableNumberBase2Default = parcelHelpers.interopDefault(_tableNumberBase2);
var _tableTextBaseCss = require("./TableTextBase.css");
function TableTextBase() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-text-base",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBase2Default.default), {})
    });
}
exports.default = TableTextBase;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase2":"kXf8S","./TableTextBase.css":"1HxhE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXf8S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _key = require("../Key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _tableNumberBase2Css = require("./TableNumberBase2.css");
function TableNumberBase2() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-4",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "null-2 valign-text-middle ibmplexmono-normal-black-14px hidden",
                            children: "NULL"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyDefault.default), {})
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line-2",
                            src: "/img/bottom-line-16@2x.png",
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line-2",
                            src: "/img/left-line-16@2x.png",
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line-2",
                            src: "/img/right-line-16@2x.png",
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Key":"5LEXw","./TableNumberBase2.css":"bKYPH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5LEXw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _keyCss = require("./Key.css");
function Key(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `key hidden ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "field-extra valign-text-middle ibmplexmono-semi-bold-black-10px",
            children: "PK"
        })
    });
}
exports.default = Key;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Key.css":"3yuBm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yuBm":[function() {},{}],"bKYPH":[function() {},{}],"1HxhE":[function() {},{}],"h1gug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBaseNull = require("../TableNumberBaseNull");
var _tableNumberBaseNullDefault = parcelHelpers.interopDefault(_tableNumberBaseNull);
var _tableTextBaseNullCss = require("./TableTextBaseNull.css");
function TableTextBaseNull() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-text-base-null",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBaseNullDefault.default), {})
    });
}
exports.default = TableTextBaseNull;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBaseNull":"alQoJ","./TableTextBaseNull.css":"cjAae","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"alQoJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase3 = require("../TableNumberBase3");
var _tableNumberBase3Default = parcelHelpers.interopDefault(_tableNumberBase3);
var _tableNumberBaseNullCss = require("./TableNumberBaseNull.css");
function TableNumberBaseNull() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base-null",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBase3Default.default), {})
    });
}
exports.default = TableNumberBaseNull;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase3":"23MlG","./TableNumberBaseNull.css":"9Lbvp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"23MlG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _key = require("../Key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _tableNumberBase3Css = require("./TableNumberBase3.css");
function TableNumberBase3() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-6",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "field-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line-4",
                            src: "/img/bottom-line-17@2x.png",
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line-4",
                            src: "/img/left-line-17@2x.png",
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line-4",
                            src: "/img/right-line-17@2x.png",
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Key":"5LEXw","./TableNumberBase3.css":"4j27b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4j27b":[function() {},{}],"9Lbvp":[function() {},{}],"cjAae":[function() {},{}],"kG8zd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableHeader = require("../TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableNumberPrimaryKey2 = require("../TableNumberPrimaryKey2");
var _tableNumberPrimaryKey2Default = parcelHelpers.interopDefault(_tableNumberPrimaryKey2);
var _tableTextBase2 = require("../TableTextBase2");
var _tableTextBase2Default = parcelHelpers.interopDefault(_tableTextBase2);
var _tableTextBaseNull2 = require("../TableTextBaseNull2");
var _tableTextBaseNull2Default = parcelHelpers.interopDefault(_tableTextBaseNull2);
var _crewMemberCss = require("./CrewMember.css");
function CrewMember(props) {
    const { tableHeaderProps, tableNumberPrimaryKey2Props, tableTextBase2Props, tableTextBaseNull2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "crew-member-1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-container-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderDefault.default), {
                        className: tableHeaderProps.className,
                        children: tableHeaderProps.children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberPrimaryKey2Default.default), {
                        tableNumberBase4Props: tableNumberPrimaryKey2Props.tableNumberBase4Props
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-text-base-container-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBase2Default.default), {
                        tableNumberBase5Props: tableTextBase2Props.tableNumberBase5Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseNull2Default.default), {
                        tableNumberBaseNull2Props: tableTextBaseNull2Props.tableNumberBaseNull2Props
                    })
                ]
            })
        ]
    });
}
exports.default = CrewMember;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableHeader":"i6j7M","../TableNumberPrimaryKey2":"lGkLR","../TableTextBase2":"Asoi7","../TableTextBaseNull2":"ehqCR","./CrewMember.css":"k6wHh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGkLR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase4 = require("../TableNumberBase4");
var _tableNumberBase4Default = parcelHelpers.interopDefault(_tableNumberBase4);
var _tableNumberPrimaryKey2Css = require("./TableNumberPrimaryKey2.css");
function TableNumberPrimaryKey2(props) {
    const { tableNumberBase4Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-primary-key-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBase4Default.default), {
            bottomLine: tableNumberBase4Props.bottomLine,
            leftLine: tableNumberBase4Props.leftLine,
            rightLine: tableNumberBase4Props.rightLine,
            className: tableNumberBase4Props.className
        })
    });
}
exports.default = TableNumberPrimaryKey2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase4":"cW4XF","./TableNumberPrimaryKey2.css":"4fHUs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cW4XF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase4Css = require("./TableNumberBase4.css");
function TableNumberBase4(props) {
    const { bottomLine, leftLine, rightLine, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `table-number-base-6-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-8",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "type valign-text-middle ibmplexmono-normal-mineral-green-14px",
                            children: "properties"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "null-4 valign-text-middle ibmplexmono-normal-black-14px hidden",
                            children: "NULL"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line-6",
                            src: bottomLine,
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line-6",
                            src: leftLine,
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line-6",
                            src: rightLine,
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./TableNumberBase4.css":"j7ylV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j7ylV":[function() {},{}],"4fHUs":[function() {},{}],"Asoi7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase5 = require("../TableNumberBase5");
var _tableNumberBase5Default = parcelHelpers.interopDefault(_tableNumberBase5);
var _tableTextBase2Css = require("./TableTextBase2.css");
function TableTextBase2(props) {
    const { className, tableNumberBase5Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `table-text-base-2-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBase5Default.default), {
            type: tableNumberBase5Props.type,
            bottomLine: tableNumberBase5Props.bottomLine,
            leftLine: tableNumberBase5Props.leftLine,
            rightLine: tableNumberBase5Props.rightLine,
            className: tableNumberBase5Props.className,
            keyProps: tableNumberBase5Props.keyProps
        })
    });
}
exports.default = TableTextBase2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase5":"2ijXv","./TableTextBase2.css":"chAHn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ijXv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _key = require("../Key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _tableNumberBase5Css = require("./TableNumberBase5.css");
function TableNumberBase5(props) {
    const { type, bottomLine, leftLine, rightLine, className, keyProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `table-number-base-8-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-10",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "type-4 valign-text-middle ibmplexmono-normal-chilean-fire-14px",
                            children: type
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "null-6 valign-text-middle ibmplexmono-normal-black-14px hidden",
                            children: "NULL"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyDefault.default), {
                            className: keyProps.className
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line-8",
                            src: bottomLine,
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line-8",
                            src: leftLine,
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line-8",
                            src: rightLine,
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase5;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Key":"5LEXw","./TableNumberBase5.css":"3NCYK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3NCYK":[function() {},{}],"chAHn":[function() {},{}],"ehqCR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBaseNull2 = require("../TableNumberBaseNull2");
var _tableNumberBaseNull2Default = parcelHelpers.interopDefault(_tableNumberBaseNull2);
var _tableTextBaseNull2Css = require("./TableTextBaseNull2.css");
function TableTextBaseNull2(props) {
    const { className, tableNumberBaseNull2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `table-text-base-null-2 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBaseNull2Default.default), {
            tableNumberBase6Props: tableNumberBaseNull2Props.tableNumberBase6Props
        })
    });
}
exports.default = TableTextBaseNull2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBaseNull2":"5EouR","./TableTextBaseNull2.css":"fj2Cv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EouR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase6 = require("../TableNumberBase6");
var _tableNumberBase6Default = parcelHelpers.interopDefault(_tableNumberBase6);
var _tableNumberBaseNull2Css = require("./TableNumberBaseNull2.css");
function TableNumberBaseNull2(props) {
    const { tableNumberBase6Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base-null-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBase6Default.default), {
            bottomLine: tableNumberBase6Props.bottomLine,
            leftLine: tableNumberBase6Props.leftLine,
            rightLine: tableNumberBase6Props.rightLine,
            className: tableNumberBase6Props.className,
            keyProps: tableNumberBase6Props.keyProps
        })
    });
}
exports.default = TableNumberBaseNull2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase6":"1DcCE","./TableNumberBaseNull2.css":"4n6cv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1DcCE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _key = require("../Key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _tableNumberBase6Css = require("./TableNumberBase6.css");
function TableNumberBase6(props) {
    const { bottomLine, leftLine, rightLine, className, keyProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `table-number-base-12-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-11",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field-10",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "type-2 valign-text-middle ibmplexmono-normal-mineral-green-14px",
                            children: "methods"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyDefault.default), {
                            className: keyProps.className
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container-10",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line-10",
                            src: bottomLine,
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line-10",
                            src: leftLine,
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line-10",
                            src: rightLine,
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase6;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Key":"5LEXw","./TableNumberBase6.css":"h6xvy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6xvy":[function() {},{}],"4n6cv":[function() {},{}],"fj2Cv":[function() {},{}],"k6wHh":[function() {},{}],"hVQkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableHeader = require("../TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableNumberPrimaryKey2 = require("../TableNumberPrimaryKey2");
var _tableNumberPrimaryKey2Default = parcelHelpers.interopDefault(_tableNumberPrimaryKey2);
var _tableTextBase3 = require("../TableTextBase3");
var _tableTextBase3Default = parcelHelpers.interopDefault(_tableTextBase3);
var _tableTextBaseNull2 = require("../TableTextBaseNull2");
var _tableTextBaseNull2Default = parcelHelpers.interopDefault(_tableTextBaseNull2);
var _crewMember2Css = require("./CrewMember2.css");
function CrewMember2(props) {
    const { tableHeaderProps, tableNumberPrimaryKey2Props, tableTextBase3Props, tableTextBaseNull2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "crew-member-3",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-container-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderDefault.default), {
                        className: tableHeaderProps.className,
                        children: tableHeaderProps.children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberPrimaryKey2Default.default), {
                        tableNumberBase4Props: tableNumberPrimaryKey2Props.tableNumberBase4Props
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-text-base-container-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBase3Default.default), {
                        tableNumberBase7Props: tableTextBase3Props.tableNumberBase7Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseNull2Default.default), {
                        tableNumberBaseNull2Props: tableTextBaseNull2Props.tableNumberBaseNull2Props
                    })
                ]
            })
        ]
    });
}
exports.default = CrewMember2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableHeader":"i6j7M","../TableNumberPrimaryKey2":"lGkLR","../TableTextBase3":"eXcR5","../TableTextBaseNull2":"ehqCR","./CrewMember2.css":"g8inP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eXcR5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase7 = require("../TableNumberBase7");
var _tableNumberBase7Default = parcelHelpers.interopDefault(_tableNumberBase7);
var _tableTextBase3Css = require("./TableTextBase3.css");
function TableTextBase3(props) {
    const { tableNumberBase7Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-text-base-8",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBase7Default.default), {
            keyProps: tableNumberBase7Props.keyProps
        })
    });
}
exports.default = TableTextBase3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase7":"d0n9x","./TableTextBase3.css":"lLUGN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d0n9x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _key = require("../Key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _tableNumberBase7Css = require("./TableNumberBase7.css");
function TableNumberBase7(props) {
    const { keyProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base-14",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-13",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "name valign-text-middle ibmplexmono-normal-black-10px"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "type-5 valign-text-middle ibmplexmono-normal-chilean-fire-14px",
                            children: "period:datetime"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "null-8 valign-text-middle ibmplexmono-normal-black-14px hidden",
                            children: "NULL"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyDefault.default), {
                            className: keyProps.className
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line-12",
                            src: "/img/bottom-line-1@2x.png",
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line-12",
                            src: "/img/left-line-1@2x.png",
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line-12",
                            src: "/img/right-line-1@2x.png",
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase7;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Key":"5LEXw","./TableNumberBase7.css":"1g8JG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1g8JG":[function() {},{}],"lLUGN":[function() {},{}],"g8inP":[function() {},{}],"gl6Ge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableHeader = require("../TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableNumberPrimaryKey2 = require("../TableNumberPrimaryKey2");
var _tableNumberPrimaryKey2Default = parcelHelpers.interopDefault(_tableNumberPrimaryKey2);
var _tableTextBase2 = require("../TableTextBase2");
var _tableTextBase2Default = parcelHelpers.interopDefault(_tableTextBase2);
var _tableTextBaseNull3 = require("../TableTextBaseNull3");
var _tableTextBaseNull3Default = parcelHelpers.interopDefault(_tableTextBaseNull3);
var _crewMember3Css = require("./CrewMember3.css");
function CrewMember3(props) {
    const { tableHeaderProps, tableNumberPrimaryKey2Props, tableTextBase2Props, tableTextBaseNull3Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "crew-member-5",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-container-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderDefault.default), {
                        className: tableHeaderProps.className,
                        children: tableHeaderProps.children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberPrimaryKey2Default.default), {
                        tableNumberBase4Props: tableNumberPrimaryKey2Props.tableNumberBase4Props
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBase2Default.default), {
                className: tableTextBase2Props.className,
                tableNumberBase5Props: tableTextBase2Props.tableNumberBase5Props
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseNull3Default.default), {
                tableNumberBaseNull3Props: tableTextBaseNull3Props.tableNumberBaseNull3Props
            })
        ]
    });
}
exports.default = CrewMember3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableHeader":"i6j7M","../TableNumberPrimaryKey2":"lGkLR","../TableTextBase2":"Asoi7","../TableTextBaseNull3":"4dbPS","./CrewMember3.css":"bmkLA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4dbPS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBaseNull3 = require("../TableNumberBaseNull3");
var _tableNumberBaseNull3Default = parcelHelpers.interopDefault(_tableNumberBaseNull3);
var _tableTextBaseNull3Css = require("./TableTextBaseNull3.css");
function TableTextBaseNull3(props) {
    const { tableNumberBaseNull3Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-text-base-null-6",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBaseNull3Default.default), {
            tableNumberBase8Props: tableNumberBaseNull3Props.tableNumberBase8Props
        })
    });
}
exports.default = TableTextBaseNull3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBaseNull3":"8Bobm","./TableTextBaseNull3.css":"an4uh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Bobm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableNumberBase8 = require("../TableNumberBase8");
var _tableNumberBase8Default = parcelHelpers.interopDefault(_tableNumberBase8);
var _tableNumberBaseNull3Css = require("./TableNumberBaseNull3.css");
function TableNumberBaseNull3(props) {
    const { tableNumberBase8Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base-null-4",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberBase8Default.default), {
            keyProps: tableNumberBase8Props.keyProps
        })
    });
}
exports.default = TableNumberBaseNull3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableNumberBase8":"7wnHY","./TableNumberBaseNull3.css":"4qTaf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7wnHY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _key = require("../Key");
var _keyDefault = parcelHelpers.interopDefault(_key);
var _tableNumberBase8Css = require("./TableNumberBase8.css");
function TableNumberBase8(props) {
    const { keyProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "table-number-base-16",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group1-16",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "field-14",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "type-8 valign-text-middle ibmplexmono-normal-mineral-green-14px",
                            children: "methods"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "null-10 valign-text-middle ibmplexmono-normal-black-14px"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyDefault.default), {
                            className: keyProps.className
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "line-container-14",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "bottom-line-14",
                            src: "/img/bottom-line-2@2x.png",
                            alt: "Bottom Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "left-line-14",
                            src: "/img/left-line-2@2x.png",
                            alt: "Left Line"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "right-line-14",
                            src: "/img/right-line-2@2x.png",
                            alt: "Right Line"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = TableNumberBase8;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Key":"5LEXw","./TableNumberBase8.css":"YlkfQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"YlkfQ":[function() {},{}],"4qTaf":[function() {},{}],"an4uh":[function() {},{}],"bmkLA":[function() {},{}],"7hGvH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableHeader = require("../TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableNumberPrimaryKey2 = require("../TableNumberPrimaryKey2");
var _tableNumberPrimaryKey2Default = parcelHelpers.interopDefault(_tableNumberPrimaryKey2);
var _tableTextBase2 = require("../TableTextBase2");
var _tableTextBase2Default = parcelHelpers.interopDefault(_tableTextBase2);
var _tableTextBaseNull2 = require("../TableTextBaseNull2");
var _tableTextBaseNull2Default = parcelHelpers.interopDefault(_tableTextBaseNull2);
var _crewMember4Css = require("./CrewMember4.css");
function CrewMember4(props) {
    const { tableHeaderProps, tableNumberPrimaryKey2Props, tableTextBase2Props, tableTextBaseNull2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "crew-member-7",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-container-7",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderDefault.default), {
                        className: tableHeaderProps.className,
                        children: tableHeaderProps.children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberPrimaryKey2Default.default), {
                        tableNumberBase4Props: tableNumberPrimaryKey2Props.tableNumberBase4Props
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-text-base-container-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBase2Default.default), {
                        tableNumberBase5Props: tableTextBase2Props.tableNumberBase5Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseNull2Default.default), {
                        tableNumberBaseNull2Props: tableTextBaseNull2Props.tableNumberBaseNull2Props
                    })
                ]
            })
        ]
    });
}
exports.default = CrewMember4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableHeader":"i6j7M","../TableNumberPrimaryKey2":"lGkLR","../TableTextBase2":"Asoi7","../TableTextBaseNull2":"ehqCR","./CrewMember4.css":"64VKT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"64VKT":[function() {},{}],"bG5RL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableHeader = require("../TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableNumberPrimaryKey2 = require("../TableNumberPrimaryKey2");
var _tableNumberPrimaryKey2Default = parcelHelpers.interopDefault(_tableNumberPrimaryKey2);
var _tableTextBase2 = require("../TableTextBase2");
var _tableTextBase2Default = parcelHelpers.interopDefault(_tableTextBase2);
var _tableTextBaseNull2 = require("../TableTextBaseNull2");
var _tableTextBaseNull2Default = parcelHelpers.interopDefault(_tableTextBaseNull2);
var _crewMember5Css = require("./CrewMember5.css");
function CrewMember5(props) {
    const { tableHeaderProps, tableNumberPrimaryKey2Props, tableTextBase2Props, tableTextBaseNull2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "crew-member-9",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "table-container-9",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderDefault.default), {
                        className: tableHeaderProps.className,
                        children: tableHeaderProps.children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberPrimaryKey2Default.default), {
                        tableNumberBase4Props: tableNumberPrimaryKey2Props.tableNumberBase4Props
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBase2Default.default), {
                className: tableTextBase2Props.className,
                tableNumberBase5Props: tableTextBase2Props.tableNumberBase5Props
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseNull2Default.default), {
                className: tableTextBaseNull2Props.className,
                tableNumberBaseNull2Props: tableTextBaseNull2Props.tableNumberBaseNull2Props
            })
        ]
    });
}
exports.default = CrewMember5;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../TableHeader":"i6j7M","../TableNumberPrimaryKey2":"lGkLR","../TableTextBase2":"Asoi7","../TableTextBaseNull2":"ehqCR","./CrewMember5.css":"cB7Zx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cB7Zx":[function() {},{}],"k8c6D":[function() {},{}],"2U4kJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _frame11432 = require("../Frame11432");
var _frame11432Default = parcelHelpers.interopDefault(_frame11432);
var _frame11532 = require("../Frame11532");
var _frame11532Default = parcelHelpers.interopDefault(_frame11532);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1 = require("../Frame1");
var _frame1Default = parcelHelpers.interopDefault(_frame1);
var _frame12 = require("../Frame12");
var _frame12Default = parcelHelpers.interopDefault(_frame12);
var _homeCss = require("./Home.css");
function Home(props) {
    const { x1200PxLogo_Icam__20081, takeYourCompanyToTheNextLevel, discoverFromDiffer, newCase, existingCase, referenceCase, headerMenuDefaultProps, frame11722Props, frame11622Props, frame11Props, frame12Props, frame13Props } = props;
    const handleNavigation = (path)=>{
        window.location.href = path; // Utilisation de window.location.href pour rediriger
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("form", {
            className: "home screen",
            name: "form5",
            action: "form5",
            method: "post",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-row-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-col-2",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-1",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1",
                                onClick: ()=>handleNavigation("/home")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-group2-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "take-your-company-to-the-next-level valign-text-middle",
                                        children: takeYourCompanyToTheNextLevel
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "discover-from-differ",
                                        children: discoverFromDiffer
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-2-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                    children: headerMenuDefaultProps.children
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-col-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "nav-items-3",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11432Default.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11532Default.default), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                                        children: frame11722Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                                        children: frame11622Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-group-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group1-18",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-3",
                                                onClick: ()=>handleNavigation("/aquisition"),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1Default.default), {
                                                    src: frame11Props.src
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "new-case valign-text-middle poppins-medium-mine-shaft-24px",
                                                onClick: ()=>handleNavigation("/aquisition"),
                                                children: newCase
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group4-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-79",
                                                onClick: ()=>handleNavigation("/existing-case"),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame12Default.default), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "group-80",
                                                onClick: ()=>handleNavigation("/existing-case"),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1Default.default), {
                                                    src: frame12Props.src,
                                                    className: frame12Props.className
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "existing-case-62 valign-text-middle poppins-medium-mine-shaft-24px",
                                                onClick: ()=>handleNavigation("/existing-case"),
                                                children: existingCase
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group3-1",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-3-1",
                                                onClick: ()=>handleNavigation("/cur-performances"),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1Default.default), {
                                                    src: frame13Props.src,
                                                    className: frame13Props.className
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reference-case valign-text-middle poppins-medium-mine-shaft-24px",
                                                onClick: ()=>handleNavigation("/cur-performances"),
                                                children: referenceCase
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
exports.default = Home;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../HeaderMenuDefault":"9P7JS","../Frame11432":"docuM","../Frame11532":"gxslB","../Frame11722":"k9cYz","../Frame11622":"6kTsO","../Frame11322":"lrJXI","../Frame1":"76iwe","../Frame12":"96Lsn","./Home.css":"jDspG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9P7JS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefaultCss = require("./HeaderMenuDefault.css");
function HeaderMenuDefault(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-4 inter-medium-cultured-pearl-14px",
            children: children
        })
    });
}
exports.default = HeaderMenuDefault;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./HeaderMenuDefault.css":"8XyW3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8XyW3":[function() {},{}],"docuM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11432Css = require("./Frame11432.css");
function Frame11432(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-114-86 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "place-1 valign-text-middle inter-medium-sonic-silver-18px",
            children: "Home"
        })
    });
}
exports.default = Frame11432;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11432.css":"cxVbY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cxVbY":[function() {},{}],"gxslB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11532Css = require("./Frame11532.css");
function Frame11532() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-115-96",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "new-case-1 valign-text-middle inter-medium-star-dust-18px",
            children: "New case"
        })
    });
}
exports.default = Frame11532;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11532.css":"hZ8U1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZ8U1":[function() {},{}],"76iwe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1Css = require("./Frame1.css");
function Frame1(props) {
    const { src, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-5-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            className: "unsplashym-m-sbz0ro",
            src: src,
            alt: "unsplash:ym--mSBZ0ro"
        })
    });
}
exports.default = Frame1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1.css":"80Db5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"80Db5":[function() {},{}],"96Lsn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame12Css = require("./Frame12.css");
function Frame12() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        href: "#rectangle-2",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-6-2"
        })
    });
}
exports.default = Frame12;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame12.css":"f4Ean","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4Ean":[function() {},{}],"jDspG":[function() {},{}],"2d45G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _navItems4 = require("../NavItems4");
var _navItems4Default = parcelHelpers.interopDefault(_navItems4);
var _frame522 = require("../Frame522");
var _frame522Default = parcelHelpers.interopDefault(_frame522);
var _frame4 = require("../Frame4");
var _frame4Default = parcelHelpers.interopDefault(_frame4);
var _functionalView1Css = require("./FunctionalView1.css");
function FunctionalView1(props) {
    const { x1200PxLogo_Icam__20081, aquisition, arrow1, arrow2, line2, label1, textFormat, label2, line1, place, clickOnModeling, label3, arrow5, label4, arrow6, label5, arrow8, label6, label7, arrow3, arrow4, arrow7, label8, arrow9, modeling, xcontinue, navItems4Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "functional-view-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-2",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-113-21",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "aquisition-26 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: aquisition
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems4Default.default), {
                            frame1162Props: navItems4Props.frame1162Props,
                            frame1172Props: navItems4Props.frame1172Props,
                            frame118Props: navItems4Props.frame118Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-row-6",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "flex-col-5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex-row-8",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: "/visual-management-3",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-11-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "place-3 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                children: place
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "click-on-modeling-1 valign-text-middle bevan-normal-white-20px",
                                        children: clickOnModeling
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "flex-row-9",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-container-1 inter-medium-rum-swizzle-18-1px",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-10",
                                                        children: label3
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "arrow-5-1",
                                                        src: arrow5,
                                                        alt: "Arrow 5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group4-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-11",
                                                        children: label4
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame522Default.default), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "arrow-6-1",
                                                        src: arrow6,
                                                        alt: "Arrow 6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group5",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-12",
                                                        children: label5
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "arrow-8-1",
                                                        src: arrow8,
                                                        alt: "Arrow 8"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "overlap-group-container-2",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group1-19",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-13 inter-medium-rum-swizzle-18-1px",
                                                        children: label6
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-14 inter-medium-rum-swizzle-18-1px",
                                                        children: label7
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame4Default.default), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "arrow-3",
                                                        src: arrow3,
                                                        alt: "Arrow 3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "arrow-4",
                                                        src: arrow4,
                                                        alt: "Arrow 4"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "arrow-7-1",
                                                        src: arrow7,
                                                        alt: "Arrow 7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "overlap-group3-2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-15 inter-medium-rum-swizzle-18-1px",
                                                        children: label8
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "arrow-9",
                                                        src: arrow9,
                                                        alt: "Arrow 9"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "frame-container-1",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                            href: "https://app.diagrams.net/",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "modeling-83 valign-text-middle inter-bold-mineral-green-18px",
                                                children: modeling
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: "/physical-model-1",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "continue valign-text-middle inter-bold-mineral-green-18px",
                                                children: xcontinue
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
exports.default = FunctionalView1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../NavItems4":"dsZMd","../Frame522":"9WZl7","../Frame4":"7kdJt","./FunctionalView1.css":"HueWj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Qy2K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame117Css = require("./Frame117.css");
var _reactRouterDom = require("react-router-dom");
function Frame117(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/functional-view",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-117-71 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "design-1 valign-text-middle inter-medium-star-dust-18px",
                children: "Design"
            })
        })
    });
}
exports.default = Frame117;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame117.css":"776a2","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"776a2":[function() {},{}],"dsZMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11632 = require("../Frame11632");
var _frame11632Default = parcelHelpers.interopDefault(_frame11632);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _navItems4Css = require("./NavItems4.css");
function NavItems4(props) {
    const { className, frame1162Props, frame1172Props, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `nav-items-4-1 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-114-88",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "functional-view-4 valign-text-middle inter-medium-white-18px",
                    children: "Functional view"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11632Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                children: frame1162Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                children: frame1172Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                children: frame118Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
        ]
    });
}
exports.default = NavItems4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame11632":"1Rc4t","../Frame11622":"6kTsO","../Frame11722":"k9cYz","../Frame118":"kfDbB","../Frame11342":"2AuVF","./NavItems4.css":"9NZ6l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfDbB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame118Css = require("./Frame118.css");
var _reactRouterDom = require("react-router-dom");
function Frame118(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-118-2 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "informational-model-3 valign-text-middle inter-medium-star-dust-18px",
            children: children
        })
    });
}
exports.default = Frame118;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame118.css":"dm7aC","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dm7aC":[function() {},{}],"9NZ6l":[function() {},{}],"9WZl7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame522Css = require("./Frame522.css");
function Frame522() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-5-3",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "manufacturing valign-text-middle inter-bold-mineral-green-18px",
            children: "Manufacturing"
        })
    });
}
exports.default = Frame522;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame522.css":"cwgSK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cwgSK":[function() {},{}],"7kdJt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame4Css = require("./Frame4.css");
function Frame4() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-4-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "processing valign-text-middle inter-bold-mineral-green-18px",
            children: "Processing"
        })
    });
}
exports.default = Frame4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame4.css":"c3s6b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c3s6b":[function() {},{}],"HueWj":[function() {},{}],"8nwJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "company_name", ()=>company_name);
parcelHelpers.export(exports, "company_size", ()=>company_size);
parcelHelpers.export(exports, "activity_sector", ()=>activity_sector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _aquisitionCss = require("./Aquisition.css");
let company_name = "";
let company_size = 0;
let activity_sector = "";
function Aquisition(props) {
    const { ellipse116, x1200PxLogo_Icam__20081, companyName, inputType1, inputPlaceholder1, companySize, inputType2, inputPlaceholder2, activitySector, inputType3, inputPlaceholder3, measuringForm, navItems3Props } = props;
    const [companyNameValue, setCompanyNameValue] = (0, _react.useState)("");
    const [companySizeValue, setCompanySizeValue] = (0, _react.useState)("");
    const [activitySectorValue, setActivitySectorValue] = (0, _react.useState)("");
    function updateDataFromInput() {
        company_name = companyNameValue;
        company_size = companySizeValue;
        activity_sector = activitySectorValue;
        const currentDate = Date.now();
        const data = {
            company_name: company_name,
            company_size: company_size,
            activity_sector: activitySector,
            date_added: currentDate
        };
        fetch("https://api.scgreenoptimizer.fr/api/save-enterprises", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error("Error saving data to MongoDB");
            console.log("Data saved successfully");
        }).catch((error)=>{
            console.error(error);
        });
    }
    function navigateToHome() {
        window.location.href = "/home";
    }
    function navigateToMeasuringForm() {
        window.location.href = "/measuring-form";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "aquisition-27 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "ellipse-116",
                    src: ellipse116,
                    alt: "Ellipse 116"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group3-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    onClick: navigateToHome,
                                    className: "x1200px-logo_icam_-_2008-1-3",
                                    src: x1200PxLogo_Icam__20081,
                                    alt: "1200px-Logo_ICAM_-_2008 1",
                                    style: {
                                        cursor: "pointer"
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "group-89",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-92",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-4360"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "company-name subtitel",
                                            children: companyName
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "tap-here-4 subtitel",
                                            name: "taphere",
                                            placeholder: "Tap Here",
                                            type: "text",
                                            value: companyNameValue,
                                            onChange: (e)=>setCompanyNameValue(e.target.value),
                                            required: true
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-group2-3",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group-91",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "group-93",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "overlap-group-4",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "rectangle-4360-1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "company-size subtitel",
                                                children: companySize
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                className: "tap-here-5 subtitel",
                                                name: "taphere",
                                                placeholder: inputPlaceholder2,
                                                type: "number",
                                                value: companySizeValue,
                                                onChange: (e)=>setCompanySizeValue(e.target.value),
                                                required: true
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "group-94",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "overlap-group-3",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-4360"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "activity-sector subtitel",
                                            children: activitySector
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "tap-here-6 subtitel",
                                            name: "taphere",
                                            placeholder: inputPlaceholder3,
                                            type: "text",
                                            value: activitySectorValue,
                                            onChange: (e)=>setActivitySectorValue(e.target.value),
                                            required: true
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: updateDataFromInput,
                    className: "frame-105",
                    children: "Save data"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: navigateToMeasuringForm,
                    className: "frame-105",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "measuring-form valign-text-middle inter-bold-mineral-green-18px",
                        children: measuringForm
                    })
                })
            ]
        })
    });
}
exports.default = Aquisition;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../NavItems3":"51Bj2","../NavItems2":"54ILo","./Aquisition.css":"8d0BW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51Bj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1142 = require("../Frame1142");
var _frame1142Default = parcelHelpers.interopDefault(_frame1142);
var _frame1152 = require("../Frame1152");
var _frame1152Default = parcelHelpers.interopDefault(_frame1152);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _navItems3Css = require("./NavItems3.css");
function NavItems3(props) {
    const { className, frame1172Props, frame1162Props, frame1132Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `nav-items-3-1 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1142Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1152Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                children: frame1172Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                children: frame1162Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                className: frame1132Props.className
            })
        ]
    });
}
exports.default = NavItems3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame1142":"g5Omc","../Frame1152":"2eMbg","../Frame11722":"k9cYz","../Frame11622":"6kTsO","../Frame11322":"lrJXI","./NavItems3.css":"4Wwbm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5Omc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1142Css = require("./Frame1142.css");
var _reactRouterDom = require("react-router-dom");
function Frame1142(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/home",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-114-90 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "place-4 valign-text-middle inter-medium-star-dust-18px",
                children: "Home"
            })
        })
    });
}
exports.default = Frame1142;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1142.css":"8wc06","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wc06":[function() {},{}],"2eMbg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1152Css = require("./Frame1152.css");
var _reactRouterDom = require("react-router-dom");
function Frame1152(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/aquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-115-100 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "new-case-5 valign-text-middle inter-medium-sonic-silver-18px",
                children: "New case"
            })
        })
    });
}
exports.default = Frame1152;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1152.css":"h2uPx","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h2uPx":[function() {},{}],"4Wwbm":[function() {},{}],"54ILo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _navItems2Css = require("./NavItems2.css");
function NavItems2(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `nav-items-2-2 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame113Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
        ]
    });
}
exports.default = NavItems2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame113":"4Bjb1","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","./NavItems2.css":"d0tTZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Bjb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame113Css = require("./Frame113.css");
var _reactRouterDom = require("react-router-dom");
function Frame113(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/aquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `frame-113-28 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "aquisition-28 valign-text-middle inter-medium-white-18px",
                children: "Aquisition"
            })
        })
    });
}
exports.default = Frame113;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame113.css":"6VJzl","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6VJzl":[function() {},{}],"d0tTZ":[function() {},{}],"8d0BW":[function() {},{}],"iPEb3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1163 = require("../Frame1163");
var _frame1163Default = parcelHelpers.interopDefault(_frame1163);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _frame522 = require("../Frame522");
var _frame522Default = parcelHelpers.interopDefault(_frame522);
var _frame4 = require("../Frame4");
var _frame4Default = parcelHelpers.interopDefault(_frame4);
var _physicalModel1Css = require("./PhysicalModel1.css");
function PhysicalModel1(props) {
    const { x1200PxLogo_Icam__20081, aquisition, functionalView, arrow1, arrow2, line2, label1, textFormat, label2, line1, place, clickOnModeling, label3, arrow5, label4, arrow6, label5, label6, arrow3, arrow4, arrow7, label7, arrow8, label8, arrow9, modeling, xcontinue, frame11622Props, frame11722Props, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "physical-model-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group4-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-11",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-4",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-113-40",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "aquisition-86 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: aquisition
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-4-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/functional-view-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-114-91",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "functional-view-6 valign-text-middle inter-medium-star-dust-18px",
                                            children: functionalView
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1163Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                                    children: frame11622Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                                    children: frame11722Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                    children: frame118Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-13",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-6 inter-medium-rum-swizzle-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-1-2",
                                                    src: arrow1,
                                                    alt: "Arrow 1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-2-2",
                                                    src: arrow2,
                                                    alt: "Arrow 2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-3-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-4-3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group6-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-2",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-16",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-2",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-17",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-14",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-1-2",
                                            src: line1,
                                            alt: "Line 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/functional-view-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-11-2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-68 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-7",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "click-on-modeling-2 valign-text-middle bevan-normal-white-20px",
                                    children: clickOnModeling
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-3 inter-medium-rum-swizzle-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-20",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-18",
                                                            children: label3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-5-2",
                                                            src: arrow5,
                                                            alt: "Arrow 5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group2-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-19",
                                                            children: label4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame522Default.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-2",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-6",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-20 inter-medium-rum-swizzle-18-1px",
                                                    children: label5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-21 inter-medium-rum-swizzle-18-1px",
                                                    children: label6
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame4Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-3-1",
                                                    src: arrow3,
                                                    alt: "Arrow 3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-4-1",
                                                    src: arrow4,
                                                    alt: "Arrow 4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-7-2",
                                                    src: arrow7,
                                                    alt: "Arrow 7"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-4 inter-medium-rum-swizzle-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group5-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-22",
                                                            children: label7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-8-2",
                                                            src: arrow8,
                                                            alt: "Arrow 8"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group3-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-23",
                                                            children: label8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-9-1",
                                                            src: arrow9,
                                                            alt: "Arrow 9"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-105-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-84 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/decisional-model-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-2",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-1 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = PhysicalModel1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame1163":"2keeU","../Frame11622":"6kTsO","../Frame11722":"k9cYz","../Frame118":"kfDbB","../Frame11342":"2AuVF","../Frame522":"9WZl7","../Frame4":"7kdJt","./PhysicalModel1.css":"jAwVw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2keeU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1163Css = require("./Frame1163.css");
function Frame1163() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-116-155",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "physical-model-8 valign-text-middle inter-medium-white-18px",
            children: "Physical Model"
        })
    });
}
exports.default = Frame1163;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1163.css":"djFkp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"djFkp":[function() {},{}],"jAwVw":[function() {},{}],"1PmAk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame1142 = require("../Frame1142");
var _frame1142Default = parcelHelpers.interopDefault(_frame1142);
var _frame11532 = require("../Frame11532");
var _frame11532Default = parcelHelpers.interopDefault(_frame11532);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _existingCaseCss = require("./ExistingCase.css");
function ExistingCase(props) {
    const { x1200PxLogo_Icam__20081, existingCase, frame11622Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "existing-case-63 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-7",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-5",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "nav-items-3-62",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1142Default.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11532Default.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-117-72",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "existing-case-64 valign-text-middle inter-medium-sonic-silver-18px",
                                    children: existingCase
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                                children: frame11622Props.children
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                        ]
                    })
                ]
            })
        })
    });
}
exports.default = ExistingCase;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame1142":"g5Omc","../Frame11532":"gxslB","../Frame11622":"6kTsO","../Frame11322":"lrJXI","./ExistingCase.css":"jxqRr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jxqRr":[function() {},{}],"6DPHO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame11632 = require("../Frame11632");
var _frame11632Default = parcelHelpers.interopDefault(_frame11632);
var _frame1155 = require("../Frame1155");
var _frame1155Default = parcelHelpers.interopDefault(_frame1155);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _decisionalModel1Css = require("./DecisionalModel1.css");
function DecisionalModel1(props) {
    const { x1200PxLogo_Icam__20081, aquisition, functionalView, arrow3, arrow4, line2, label1, textFormat, label2, line1, place, clickOnModeling, modeling, xcontinue, frame11722Props, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "decisional-model-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-21",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-16",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-6",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-113-41",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "aquisition-87 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: aquisition
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-4-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/functional-view-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-114-92",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "functional-view-7 valign-text-middle inter-medium-star-dust-18px",
                                            children: functionalView
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11632Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1155Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                                    children: frame11722Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                    children: frame118Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-17",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-9 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-3-2",
                                            src: arrow3,
                                            alt: "Arrow 3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-4-2",
                                            src: arrow4,
                                            alt: "Arrow 4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-85-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-5-7"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-3",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-3"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-24",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-3",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-25",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-18",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-19",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-1-3",
                                            src: line1,
                                            alt: "Line 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/physical-model-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-11-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-69 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-10",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-3 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-12",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-85 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/process-view-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-2 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = DecisionalModel1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame11632":"1Rc4t","../Frame1155":"f5HL2","../Frame11722":"k9cYz","../Frame118":"kfDbB","../Frame11342":"2AuVF","./DecisionalModel1.css":"8KvQr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5HL2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1155Css = require("./Frame1155.css");
function Frame1155() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-115-102",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "decisional-model-8 valign-text-middle inter-medium-white-18px",
            children: "Decisional Model"
        })
    });
}
exports.default = Frame1155;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1155.css":"jE1ZM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jE1ZM":[function() {},{}],"8KvQr":[function() {},{}],"7NTJs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame11632 = require("../Frame11632");
var _frame11632Default = parcelHelpers.interopDefault(_frame11632);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame1173 = require("../Frame1173");
var _frame1173Default = parcelHelpers.interopDefault(_frame1173);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _processView1Css = require("./ProcessView1.css");
function ProcessView1(props) {
    const { x1200PxLogo_Icam__20081, aquisition, functionalView, arrow1, arrow2, rectangle7, line3, line4, line2, label1, textFormat, label2, line1, place, clickOnFlexsimB, overlapGroup1, cut, label3, rectangle5, manufacturing, arrow6, arrow11, label4, arrow8, label5, arrow9, flexsim, rectangle6, assembly, arrow10, xcontinue, frame11622Props, frame118Props } = props;
    // Define state variables for form inputs
    const [error, setError] = (0, _react.useState)("");
    // Define function to handle form submission
    const launchFlexsim = async (e)=>{
        e.preventDefault();
        try {
            const response = await fetch("https://api.scgreenoptimizer.fr/open-VMWarehorizon");
            const responseData = await response.json();
            console.log(responseData);
            // If successful login, open VMware Horizon View Client
            window.open("C:\\Program Files\\VMware\\VMware Horizon View Client\\vmware-view.exe");
        } catch (error) {
            setError(error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "process-view-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group4-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-20",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-7",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-10",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-113-42",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "aquisition-88 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: aquisition
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-4-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/functional-view-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-114-93",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "functional-view-8 valign-text-middle inter-medium-star-dust-18px",
                                            children: functionalView
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11632Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                                    children: frame11622Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1173Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                    children: frame118Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-21",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-22",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-11 inter-medium-rum-swizzle-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-1-3",
                                                    src: arrow1,
                                                    alt: "Arrow 1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-2-3",
                                                    src: arrow2,
                                                    alt: "Arrow 2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "rectangle-7",
                                            src: rectangle7,
                                            alt: "Rectangle 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-23",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-85-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-3-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-3-2",
                                                            src: line3,
                                                            alt: "Line 3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-4-1",
                                                            src: line4,
                                                            alt: "Line 4"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-4-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-9",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-4",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-4"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-26",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-4",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-27",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-4",
                                    src: line1,
                                    alt: "Line 1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-24",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/decisional-model-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-11-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-70 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-flexsim-b valign-text-middle bevan-normal-white-20px",
                                            children: clickOnFlexsimB
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-25",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-13",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-26",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group1-22",
                                                            style: {
                                                                backgroundImage: `url(${overlapGroup1})`
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "cut valign-text-middle inter-bold-mineral-green-18px",
                                                                children: cut
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-col-14",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group2-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "label-28 inter-medium-rum-swizzle-18-1px",
                                                                            children: label3
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "rectangle-5",
                                                                            src: rectangle5,
                                                                            alt: "Rectangle 5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "manufacturing-4 valign-text-middle inter-bold-mineral-green-18px",
                                                                            children: manufacturing
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-6-3",
                                                                            src: arrow6,
                                                                            alt: "Arrow 6"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-11",
                                                                            src: arrow11,
                                                                            alt: "Arrow 11"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-container-5 inter-medium-rum-swizzle-18-1px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-group5-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "label-29",
                                                                                    children: label4
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    className: "arrow-8-3",
                                                                                    src: arrow8,
                                                                                    alt: "Arrow 8"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-group7",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "label-30",
                                                                                    children: label5
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    className: "arrow-9-2",
                                                                                    src: arrow9,
                                                                                    alt: "Arrow 9"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "frame-9-4",
                                                    onClick: launchFlexsim,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flexsim valign-text-middle inter-bold-mineral-green-18px",
                                                        children: flexsim
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-15",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group3-5",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "rectangle-6",
                                                            src: rectangle6,
                                                            alt: "Rectangle 6"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "assembly valign-text-middle inter-bold-mineral-green-18px",
                                                            children: assembly
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-10",
                                                            src: arrow10,
                                                            alt: "Arrow 10"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/informational-model-1",
                                                    className: "align-self-flex-end",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-4",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-3 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ProcessView1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame11632":"1Rc4t","../Frame11622":"6kTsO","../Frame1173":"8QIm8","../Frame118":"kfDbB","../Frame11342":"2AuVF","./ProcessView1.css":"dBR5B","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8QIm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1173Css = require("./Frame1173.css");
function Frame1173() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-117-73",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "process-view-8 valign-text-middle inter-medium-white-18px",
            children: "Process view"
        })
    });
}
exports.default = Frame1173;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1173.css":"fA44h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fA44h":[function() {},{}],"dBR5B":[function() {},{}],"kNnw4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame11632 = require("../Frame11632");
var _frame11632Default = parcelHelpers.interopDefault(_frame11632);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame1136 = require("../Frame1136");
var _frame1136Default = parcelHelpers.interopDefault(_frame1136);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _tableHeader = require("../TableHeader");
var _tableHeaderDefault = parcelHelpers.interopDefault(_tableHeader);
var _tableNumberPrimaryKey = require("../TableNumberPrimaryKey");
var _tableNumberPrimaryKeyDefault = parcelHelpers.interopDefault(_tableNumberPrimaryKey);
var _tableTextBase = require("../TableTextBase");
var _tableTextBaseDefault = parcelHelpers.interopDefault(_tableTextBase);
var _tableTextBaseNull = require("../TableTextBaseNull");
var _tableTextBaseNullDefault = parcelHelpers.interopDefault(_tableTextBaseNull);
var _crewMember = require("../CrewMember");
var _crewMemberDefault = parcelHelpers.interopDefault(_crewMember);
var _crewMember2 = require("../CrewMember2");
var _crewMember2Default = parcelHelpers.interopDefault(_crewMember2);
var _crewMember3 = require("../CrewMember3");
var _crewMember3Default = parcelHelpers.interopDefault(_crewMember3);
var _crewMember4 = require("../CrewMember4");
var _crewMember4Default = parcelHelpers.interopDefault(_crewMember4);
var _crewMember5 = require("../CrewMember5");
var _crewMember5Default = parcelHelpers.interopDefault(_crewMember5);
var _informationalModel1Css = require("./InformationalModel1.css");
function InformationalModel1(props) {
    const { x1200PxLogo_Icam__20081, aquisition, functionalView, arrow7, arrow8, line31, line4, line2, label1, textFormat, label2, line1, place, clickOnModeling, arrow1, arrow2, line32, arrow5, arrow6, modeling, goOnToTheNextPage, frame11622Props, frame11722Props, frame1136Props, tableHeaderProps, crewMemberProps, crewMember2Props, crewMember3Props, crewMember4Props, crewMember5Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "informational-model-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-27",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-8",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-11",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-113-43",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "aquisition-89 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: aquisition
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-4-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/functional-view-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-114-94",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "functional-view-9 valign-text-middle inter-medium-star-dust-18px",
                                            children: functionalView
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11632Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                                    children: frame11622Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                                    children: frame11722Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1136Default.default), {
                                    children: frame1136Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-28",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-16 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-7-3",
                                            src: arrow7,
                                            alt: "Arrow 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-8-4",
                                            src: arrow8,
                                            alt: "Arrow 8"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "crew-member-11",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "table-container-11",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeaderDefault.default), {
                                                    children: tableHeaderProps.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableNumberPrimaryKeyDefault.default), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "table-text-base-container-7",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableTextBaseNullDefault.default), {})
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-5-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-3-3",
                                            src: line31,
                                            alt: "Line 3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-4-2",
                                            src: line4,
                                            alt: "Line 4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group12-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-5",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-31",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-5",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-32",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-29",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-5",
                                    src: line1,
                                    alt: "Line 1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-17",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-30",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/process-view-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-11-5",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-71 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "click-on-modeling-4 valign-text-middle bevan-normal-white-20px",
                                                    children: clickOnModeling
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group16-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group13-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-7-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMemberDefault.default), {
                                                            tableHeaderProps: crewMemberProps.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMemberProps.tableNumberPrimaryKey2Props,
                                                            tableTextBase2Props: crewMemberProps.tableTextBase2Props,
                                                            tableTextBaseNull2Props: crewMemberProps.tableTextBaseNull2Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember2Default.default), {
                                                            tableHeaderProps: crewMember2Props.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMember2Props.tableNumberPrimaryKey2Props,
                                                            tableTextBase3Props: crewMember2Props.tableTextBase3Props,
                                                            tableTextBaseNull2Props: crewMember2Props.tableTextBaseNull2Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember3Default.default), {
                                                            tableHeaderProps: crewMember3Props.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMember3Props.tableNumberPrimaryKey2Props,
                                                            tableTextBase2Props: crewMember3Props.tableTextBase2Props,
                                                            tableTextBaseNull3Props: crewMember3Props.tableTextBaseNull3Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember4Default.default), {
                                                            tableHeaderProps: crewMember4Props.tableHeaderProps,
                                                            tableNumberPrimaryKey2Props: crewMember4Props.tableNumberPrimaryKey2Props,
                                                            tableTextBase2Props: crewMember4Props.tableTextBase2Props,
                                                            tableTextBaseNull2Props: crewMember4Props.tableTextBaseNull2Props
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-1-4",
                                                            src: arrow1,
                                                            alt: "Arrow 1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-2-4",
                                                            src: arrow2,
                                                            alt: "Arrow 2"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-3-4",
                                                            src: line32,
                                                            alt: "Line 3"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crewMember5Default.default), {
                                                    tableHeaderProps: crewMember5Props.tableHeaderProps,
                                                    tableNumberPrimaryKey2Props: crewMember5Props.tableNumberPrimaryKey2Props,
                                                    tableTextBase2Props: crewMember5Props.tableTextBase2Props,
                                                    tableTextBaseNull2Props: crewMember5Props.tableTextBaseNull2Props
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-5-3",
                                                    src: arrow5,
                                                    alt: "Arrow 5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-6-4",
                                                    src: arrow6,
                                                    alt: "Arrow 6"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-4",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-12-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-86 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/lean-vsm-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-113-44",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "go-on-to-the-next-page valign-text-middle inter-bold-mineral-green-18px",
                                                            children: goOnToTheNextPage
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = InformationalModel1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame11632":"1Rc4t","../Frame11622":"6kTsO","../Frame11722":"k9cYz","../Frame1136":"8aQ7W","../Frame11342":"2AuVF","../TableHeader":"i6j7M","../TableNumberPrimaryKey":"dI82u","../TableTextBase":"caprm","../TableTextBaseNull":"h1gug","../CrewMember":"kG8zd","../CrewMember2":"hVQkj","../CrewMember3":"gl6Ge","../CrewMember4":"7hGvH","../CrewMember5":"bG5RL","./InformationalModel1.css":"3arLb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3arLb":[function() {},{}],"eHkL6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData1", ()=>e_allData1);
parcelHelpers.export(exports, "yes_Count1", ()=>yes_Count1);
parcelHelpers.export(exports, "e_final", ()=>e_final);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _environmental1Css = require("./Environmental1.css");
let e_allData1 = [];
let yes_Count1 = 0;
let e_final = 0;
function Environmental1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType3, inputPlaceholder3, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count1++;
            setYesCount1((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        setErrorMessage(""); // Clear any previous error messages
        e_allData1 = e_allData1.concat(data); // Concatène les nouvelles données à allData
        console.log(e_allData1);
        console.log(yes_Count1);
        history.push("/environmental-2");
        return e_allData1;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-10",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-9",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-14",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame113Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "please-answer-the-following-questions valign-text-middle bevan-normal-white-20px",
                    children: pleaseAnswerTheFollowingQuestions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count1,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "dmarche-environnemental",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dmarche-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "promouvez-vous-la-re subtitel",
                                            htmlFor: "promouvezvouslaresponsabilit\xe9environnementaleauseindevotreentreprise",
                                            children: "G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["G\xe9rez vous les risques et impacts de votre activit\xe9 sur l'environnement?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "promouvez-vous-la-re subtitel",
                                            htmlFor: "your-vousdesemploy\xe9sdeladirectionaffect\xe9sauxenjeuxli\xe9s\xe0lenvironnement-id",
                                            children: "Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des objectifs environnementaux planifi\xe9s et r\xe9alis\xe9s ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-des-employ-1 subtitel",
                                            htmlFor: "avez-vousdesemploy\xe9sayantdesresponsabilit\xe9sd\xe9finiesenlienaveclenvironnement",
                                            children: "Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Quel est le pourcentage d\u2019objectifs r\xe9alis\xe9s sur les objectifs planifi\xe9s?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dmarche-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "promouvez-vous-la-re subtitel",
                                            htmlFor: "promouvezvouslaresponsabilit\xe9environnementaleauseindevotreentreprise",
                                            children: "Promouvez vous la responsabilit\xe9 environnementale au sein de votre entreprise?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Promouvez vous la responsabilit\xe9 environnementale au sein de votre entreprise?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Promouvez vous la responsabilit\xe9 environnementale au sein de votre entreprise?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Promouvez vous la responsabilit\xe9 environnementale au sein de votre entreprise?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Promouvez vous la responsabilit\xe9 environnementale au sein de votre entreprise?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Promouvez vous la responsabilit\xe9 environnementale au sein de votre entreprise?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Promouvez vous la responsabilit\xe9 environnementale au sein de votre entreprise?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-des-employ subtitel ",
                                            htmlFor: "avez-vousdesemploy\xe9sdeladirectionaffect\xe9sauxenjeuxli\xe9s\xe0lenvironnement",
                                            children: "Avez-vous des employ\xe9s de la direction affect\xe9s aux enjeux li\xe9s \xe0 l'environnement"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des employ\xe9s de la direction affect\xe9s aux enjeux li\xe9s \xe0 l'environnement", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Avez-vous des employ\xe9s de la direction affect\xe9s aux enjeux li\xe9s \xe0 l'environnement"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des employ\xe9s de la direction affect\xe9s aux enjeux li\xe9s \xe0 l'environnement"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des employ\xe9s de la direction affect\xe9s aux enjeux li\xe9s \xe0 l'environnement", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Avez-vous des employ\xe9s de la direction affect\xe9s aux enjeux li\xe9s \xe0 l'environnement"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des employ\xe9s de la direction affect\xe9s aux enjeux li\xe9s \xe0 l'environnement"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-des-employ-1 subtitel",
                                            htmlFor: "avez-vousdesemploy\xe9sayantdesresponsabilit\xe9sd\xe9finiesenlienaveclenvironnement",
                                            placeholder: inputPlaceholder3,
                                            type: inputType3,
                                            children: "Avez-vous des employ\xe9s ayant des responsabilit\xe9s d\xe9finies en lien avec l'environnement ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des employ\xe9s ayant des responsabilit\xe9s d\xe9finies en lien avec l'environnement ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Avez-vous des employ\xe9s ayant des responsabilit\xe9s d\xe9finies en lien avec l'environnement ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des employ\xe9s ayant des responsabilit\xe9s d\xe9finies en lien avec l'environnement ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des employ\xe9s ayant des responsabilit\xe9s d\xe9finies en lien avec l'environnement ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Avez-vous des employ\xe9s ayant des responsabilit\xe9s d\xe9finies en lien avec l'environnement ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des employ\xe9s ayant des responsabilit\xe9s d\xe9finies en lien avec l'environnement ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-31",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-69",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../Frame113":"4Bjb1","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Toggle":"8ZCQM","./Environmental1.css":"gkMJx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ZCQM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _buttonSecondary = require("../ButtonSecondary");
var _buttonSecondaryDefault = parcelHelpers.interopDefault(_buttonSecondary);
var _toggleCss = require("./Toggle.css");
function Toggle(props) {
    const { className, buttonSecondaryProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `toggle-32 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonSecondaryDefault.default), {
            className: buttonSecondaryProps.className,
            children: buttonSecondaryProps.children
        })
    });
}
exports.default = Toggle;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../ButtonSecondary":"2tCcH","./Toggle.css":"5mR1c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2tCcH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonSecondaryCss = require("./ButtonSecondary.css");
function ButtonSecondary(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `button-secondary-101 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-88 inter-bold-mineral-green-16px",
            children: children
        })
    });
}
exports.default = ButtonSecondary;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./ButtonSecondary.css":"i3Pd0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3Pd0":[function() {},{}],"5mR1c":[function() {},{}],"gkMJx":[function() {},{}],"5hCsc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _measuringFormCss = require("./MeasuringForm.css");
function MeasuringForm(props) {
    const { ellipse116, x1200PxLogo_Icam__20081, criteriaMeasurementForm, environnementCriteria1, environnementCriteria2, x4LeadTimeCriteria, x2SocialCriteria, x5CostCriteria, x3ModernizationCriteria, x6QualityCriteria, navItems3Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "measuring-form-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "ellipse-116-1",
                    src: ellipse116,
                    alt: "Ellipse 116"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-10",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "criteria-measurement-form valign-text-middle bevan-normal-white-20px",
                    children: criteriaMeasurementForm
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-row-32",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-container-5",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/environmental-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-10-1",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "x-criteria valign-text-middle inter-bold-mineral-green-18px",
                                    children: environnementCriteria1
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
exports.default = MeasuringForm;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","./MeasuringForm.css":"6YO7c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YO7c":[function() {},{}],"dxE9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _headerMenuDefault32 = require("../HeaderMenuDefault32");
var _headerMenuDefault32Default = parcelHelpers.interopDefault(_headerMenuDefault32);
var _menuItemDefault = require("../MenuItemDefault");
var _menuItemDefaultDefault = parcelHelpers.interopDefault(_menuItemDefault);
var _leanVSM1Css = require("./LeanVSM1.css");
function LeanVSM1(props) {
    const { x1200PxLogo_Icam__20081, leanVsm, arrow1, arrow2, rectangle6, line2, label1, textFormat, label2, line1, place, clickOnModeling, arrow3, modeling, arrow4, arrow6, arrow5, rectangle7, xcontinue, frame118Props, headerMenuDefault321Props, menuItemDefaultProps, headerMenuDefault322Props, headerMenuDefault323Props, headerMenuDefault324Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-11",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-63",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-113-45",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "lean-vsm valign-text-middle inter-medium-white-18px",
                                                children: leanVsm
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-33",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-18 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-1-5",
                                            src: arrow1,
                                            alt: "Arrow 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-2-5",
                                            src: arrow2,
                                            alt: "Arrow 2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-88"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "rectangle-6-1",
                                    src: rectangle6,
                                    alt: "Rectangle 6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group3-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-6",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-37",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-6",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-94",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-34",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-6",
                                    src: line1,
                                    alt: "Line 1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-19",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-35",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/informational-model-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-11-6",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-72 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "click-on-modeling-5 valign-text-middle bevan-normal-white-20px",
                                                    children: clickOnModeling
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-36",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group5-3",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault32Default.default), {
                                                        inputPlaceholder: headerMenuDefault321Props.inputPlaceholder
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-3-3",
                                                    src: arrow3,
                                                    alt: "Arrow 3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-20",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group4-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefaultDefault.default), {
                                                                headerMenuDefault3Props: menuItemDefaultProps.headerMenuDefault3Props
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-12-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-87 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-4-3",
                                                    src: arrow4,
                                                    alt: "Arrow 4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group2-6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault32Default.default), {
                                                        inputPlaceholder: headerMenuDefault322Props.inputPlaceholder,
                                                        className: headerMenuDefault322Props.className
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-6-5",
                                                    src: arrow6,
                                                    alt: "Arrow 6"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-21",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group1-24",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "rectangle-5-1"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-5-4",
                                                                    src: arrow5,
                                                                    alt: "Arrow 5"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "rectangle-7-1",
                                                                    src: rectangle7,
                                                                    alt: "Rectangle 7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault32Default.default), {
                                                                    inputPlaceholder: headerMenuDefault323Props.inputPlaceholder,
                                                                    className: headerMenuDefault323Props.className
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault32Default.default), {
                                                                    inputPlaceholder: headerMenuDefault324Props.inputPlaceholder,
                                                                    className: headerMenuDefault324Props.className
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                            to: "/5s-1",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-2-5",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "continue-4 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: xcontinue
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeanVSM1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame1144":"cyPUr","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","../HeaderMenuDefault32":"gXQ4p","../MenuItemDefault":"fegta","./LeanVSM1.css":"cp9nA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cyPUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1144Css = require("./Frame1144.css");
function Frame1144(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-114-95 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "modeling-88 valign-text-middle inter-medium-sonic-silver-18px",
            children: "Modeling"
        })
    });
}
exports.default = Frame1144;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1144.css":"iq0em","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iq0em":[function() {},{}],"ebdMs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1146Css = require("./Frame1146.css");
function Frame1146() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-114-96",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x5-s valign-text-middle inter-medium-star-dust-18px",
            children: "5S"
        })
    });
}
exports.default = Frame1146;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1146.css":"9PAYw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9PAYw":[function() {},{}],"2tJ8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1154Css = require("./Frame1154.css");
function Frame1154() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-115-104",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kaizen valign-text-middle inter-medium-star-dust-18px",
            children: "Kaizen"
        })
    });
}
exports.default = Frame1154;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1154.css":"6cZAg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cZAg":[function() {},{}],"9Ds6S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1164Css = require("./Frame1164.css");
function Frame1164() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-116-163",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "smed valign-text-middle inter-medium-star-dust-18px",
            children: "SMED"
        })
    });
}
exports.default = Frame1164;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1164.css":"kS7FS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kS7FS":[function() {},{}],"1OJFF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11742Css = require("./Frame11742.css");
var _reactRouterDom = require("react-router-dom");
function Frame11742() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/kanban-1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "frame-117-76",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "kanban valign-text-middle inter-medium-star-dust-18px",
                children: "Kanban"
            })
        })
    });
}
exports.default = Frame11742;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11742.css":"1Hyys","react-router-dom":"5fzqq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Hyys":[function() {},{}],"gXQ4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault32Css = require("./HeaderMenuDefault32.css");
function HeaderMenuDefault32(props) {
    const { inputPlaceholder, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default-13 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
            className: "label-95 inter-medium-dark-fern-14px",
            name: "label",
            placeholder: inputPlaceholder,
            type: "text"
        })
    });
}
exports.default = HeaderMenuDefault32;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./HeaderMenuDefault32.css":"9kzrx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9kzrx":[function() {},{}],"fegta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault32 = require("../HeaderMenuDefault32");
var _headerMenuDefault32Default = parcelHelpers.interopDefault(_headerMenuDefault32);
var _menuItemDefaultCss = require("./MenuItemDefault.css");
function MenuItemDefault(props) {
    const { headerMenuDefault3Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "menu-item-default-18",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault32Default.default), {
            inputPlaceholder: headerMenuDefault3Props.inputPlaceholder,
            className: headerMenuDefault3Props.className
        })
    });
}
exports.default = MenuItemDefault;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../HeaderMenuDefault32":"gXQ4p","./MenuItemDefault.css":"lrvva","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrvva":[function() {},{}],"cp9nA":[function() {},{}],"iTPpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1135 = require("../Frame1135");
var _frame1135Default = parcelHelpers.interopDefault(_frame1135);
var _frame1147 = require("../Frame1147");
var _frame1147Default = parcelHelpers.interopDefault(_frame1147);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _x5S1Css = require("./X5S1.css");
function X5S1(props) {
    const { x1200PxLogo_Icam__20081, arrow1, arrow2, rectangle6, line2, label1, textFormat, label2, line1, place, clickOnModeling, seiri, arrow7, inputType1, inputPlaceholder1, arrow3, seiton, arrow8, inputType2, inputPlaceholder2, modeling, arrow4, seison, arrow9, inputType3, inputPlaceholder3, arrow6, seiketsu, shitsuke, arrow10, arrow11, arrow5, rectangle7, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, xcontinue, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group4-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-12",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-16",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-64",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1135Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1147Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-37",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-22 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-1-7",
                                            src: arrow1,
                                            alt: "Arrow 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-2-6",
                                            src: arrow2,
                                            alt: "Arrow 2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-88-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-4"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "rectangle-6-2",
                                    src: rectangle6,
                                    alt: "Rectangle 6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-12",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-7",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-96",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-7",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-97",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-38",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-7",
                                    src: line1,
                                    alt: "Line 1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-23",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-39",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/lean-vsm-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-11-7",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-73 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "click-on-modeling-6 valign-text-middle bevan-normal-white-20px",
                                                    children: clickOnModeling
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-40",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-24",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "seiri inter-medium-white-18-1px",
                                                            children: seiri
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-7-4",
                                                            src: arrow7,
                                                            alt: "Arrow 7"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group2-7",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-87"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ellipse-89"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    className: "disposal inter-medium-dark-fern-18-1px",
                                                                    name: "disposal",
                                                                    placeholder: inputPlaceholder1,
                                                                    type: inputType1
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-3-4",
                                                    src: arrow3,
                                                    alt: "Arrow 3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-25",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "seiton inter-medium-white-18-1px",
                                                            children: seiton
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-8-5",
                                                            src: arrow8,
                                                            alt: "Arrow 8"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group5-4",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                className: "put-away inter-medium-dark-fern-18-1px",
                                                                name: "putaway",
                                                                placeholder: inputPlaceholder2,
                                                                type: inputType2
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-12-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-96 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-4-4",
                                                    src: arrow4,
                                                    alt: "Arrow 4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-26",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "seison inter-medium-white-18-1px",
                                                            children: seison
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-9-3",
                                                            src: arrow9,
                                                            alt: "Arrow 9"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group3-7",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                className: "c-lean inter-medium-dark-fern-18-1px",
                                                                name: "clean",
                                                                placeholder: inputPlaceholder3,
                                                                type: inputType3
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-6-6",
                                                    src: arrow6,
                                                    alt: "Arrow 6"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-27",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-row-41 inter-medium-white-18-1px",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "seiketsu",
                                                                    children: seiketsu
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "shitsuke",
                                                                    children: shitsuke
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "arrow-container-8",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-1-6",
                                                                    src: arrow10,
                                                                    alt: "Arrow 10"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-1-6",
                                                                    src: arrow11,
                                                                    alt: "Arrow 11"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group1-25",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "rectangle-5-2"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-5-5",
                                                                    src: arrow5,
                                                                    alt: "Arrow 5"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "rectangle-7-2",
                                                                    src: rectangle7,
                                                                    alt: "Rectangle 7"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    className: "standardize inter-medium-dark-fern-18-1px",
                                                                    name: "standardize",
                                                                    placeholder: inputPlaceholder4,
                                                                    type: inputType4
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    className: "respect inter-medium-dark-fern-18-1px",
                                                                    name: "respect",
                                                                    placeholder: inputPlaceholder5,
                                                                    type: inputType5
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                            to: "/kaizen-1",
                                                            className: "align-self-flex-start",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-2-6",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "continue-5 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: xcontinue
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = X5S1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame1144":"cyPUr","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame1135":"4zAdk","../Frame1147":"lq7t9","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","./X5S1.css":"37FV0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4zAdk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1135Css = require("./Frame1135.css");
function Frame1135(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-113-46 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "lean-vsm-2 valign-text-middle inter-medium-star-dust-18px",
            children: "Lean VSM"
        })
    });
}
exports.default = Frame1135;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1135.css":"aFiyv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aFiyv":[function() {},{}],"lq7t9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1147Css = require("./Frame1147.css");
function Frame1147() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-114-110",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x5-s-12 valign-text-middle inter-medium-white-18px",
            children: "5S"
        })
    });
}
exports.default = Frame1147;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1147.css":"aFKnf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aFKnf":[function() {},{}],"37FV0":[function() {},{}],"49Q6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame232 = require("../Frame232");
var _frame232Default = parcelHelpers.interopDefault(_frame232);
var _frame222 = require("../Frame222");
var _frame222Default = parcelHelpers.interopDefault(_frame222);
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _analysisCss = require("./Analysis.css");
function Analysis(props) {
    const [result, setResult] = (0, _react.useState)(null);
    const { analysis, label, x1200PxLogo_Icam__20081, place, formalismesEnFonct, navItems3Props, frame11332Props, frame232Props, frame222Props, toggleProps } = props;
    // Fonction d'inférence pour récupérer les résultats
    function inference() {
        fetch("https://api.scgreenoptimizer.fr/inferences", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response)=>response.json()).then((data)=>{
            console.log("API Response:", data); // Log de la réponse de l'API
            // Vérification de la structure de la réponse
            if (data && data.errors && Array.isArray(data.errors)) {
                const responseData = data.errors; // Accéder directement à 'errors'
                setResult(responseData);
                alert("Successful Analysis");
            } else {
                console.error("Expected an array of errors but got:", data);
                alert("Failed: Response is not an array of errors.");
            }
        }).catch((error)=>{
            console.error(error);
            alert("Failed to perform analysis");
        });
    }
    // Fonction pour générer et sauvegarder le PDF
    function saveAsPDF() {
        // Vérification de si result est un tableau et contient des erreurs
        if (!result || !Array.isArray(result) || result.length === 0) {
            alert("No results or errors to save!");
            return;
        }
        const pdf = new (0, _jspdfDefault.default)();
        const pageWidth = pdf.internal.pageSize.width;
        const pageHeight = pdf.internal.pageSize.height;
        let currentVerticalPosition = 20;
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(18);
        pdf.text("Rapport d'Erreurs d'Analyse", pageWidth / 2, currentVerticalPosition, {
            align: "center"
        });
        currentVerticalPosition += 20;
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.5);
        pdf.line(10, currentVerticalPosition, pageWidth - 10, currentVerticalPosition);
        currentVerticalPosition += 10;
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(12);
        // Ajouter les erreurs dans le PDF directement à partir de 'result'
        if (Array.isArray(result) && result.length > 0) {
            console.log("Filtered Errors:", result); // Affichage dans la console pour vérifier les erreurs
            // Ajouter les erreurs dans le PDF
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(14);
            pdf.text("Liste des erreurs :", 10, currentVerticalPosition);
            currentVerticalPosition += 10;
            // Ajouter les erreurs une par une dans le PDF
            result.forEach((error, index)=>{
                pdf.setFont("helvetica", "normal");
                pdf.setFontSize(12);
                pdf.text(`${index + 1}. ${error}`, 10, currentVerticalPosition);
                currentVerticalPosition += 8; // Espace entre les erreurs
            });
            currentVerticalPosition += 15;
        } else {
            alert("No errors found in the API response.");
            return;
        }
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.5);
        pdf.line(10, currentVerticalPosition, pageWidth - 10, currentVerticalPosition);
        currentVerticalPosition += 10;
        const currentDate = new Date().toLocaleDateString();
        pdf.setFont("helvetica", "italic");
        pdf.setFontSize(10);
        const footerText = `Generated on: ${currentDate}`;
        pdf.text(footerText, pageWidth - 10 - pdf.getTextWidth(footerText), pageHeight - 10, {
            align: "right"
        });
        pdf.save(`analysis_errors_${currentDate}.pdf`);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "analysis-88 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-13",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                        className: navItems3Props.className,
                        frame1172Props: navItems3Props.frame1172Props,
                        frame1162Props: navItems3Props.frame1162Props,
                        frame1132Props: navItems3Props.frame1132Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "nav-items-2-17",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                className: frame11332Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/analysis",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-115-115",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "analysis-89 valign-text-middle inter-medium-white-18px",
                                        children: analysis
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame232Default.default), {
                                headerMenuDefault2Props: frame232Props.headerMenuDefault2Props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "label-98 inter-medium-star-dust-18-1px",
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-13",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/functional-view",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame222Default.default), {
                            children: frame222Props.children
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/visual-management-1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-5-9",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "place-74 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                children: place
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "formalismes-en-fonct valign-text-middle",
                        children: [
                            formalismesEnFonct,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "bu",
                                onClick: inference,
                                children: "Analysis"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "bu",
                                onClick: saveAsPDF,
                                children: "Save Errors as PDF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "body",
                        children: result && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "result-groups",
                            children: result.reduce((acc, item)=>{
                                const documentIndex = item.DocumentIndex;
                                const existingItem = acc.find((groupedItem)=>groupedItem.documentIndex === documentIndex);
                                if (existingItem) existingItem.results.push(item);
                                else acc.push({
                                    documentIndex,
                                    results: [
                                        item
                                    ]
                                });
                                return acc;
                            }, []).map((group, groupIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "result-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                            children: [
                                                "Document ",
                                                group.documentIndex + 1,
                                                " Results"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "scrollable-container",
                                            children: group.results.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "result-item",
                                                    children: [
                                                        item.Element && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        "Analysis: ",
                                                                        item.Analysis
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                    children: [
                                                                        "Element Info: Row ",
                                                                        item.Element.row,
                                                                        ", Column",
                                                                        " ",
                                                                        item.Element.column,
                                                                        ", Heading ",
                                                                        item.Element.heading,
                                                                        ", Document",
                                                                        " ",
                                                                        item.Element.doc
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        !item.Element && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            children: item.Analysis
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                }, groupIndex))
                        })
                    })
                ]
            })
        })
    });
}
exports.default = Analysis;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame232":"ki771","../Frame222":"4OTDD","jspdf":"cU8oN","./Analysis.css":"17Su0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ki771":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault2 = require("../HeaderMenuDefault2");
var _headerMenuDefault2Default = parcelHelpers.interopDefault(_headerMenuDefault2);
var _frame232Css = require("./Frame232.css");
function Frame232(props) {
    const { headerMenuDefault2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-2-7",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
            className: headerMenuDefault2Props.className,
            children: headerMenuDefault2Props.children
        })
    });
}
exports.default = Frame232;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../HeaderMenuDefault2":"8KBHC","./Frame232.css":"hpV1k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8KBHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault2Css = require("./HeaderMenuDefault2.css");
function HeaderMenuDefault2(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default-20 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-100 inter-medium-star-dust-14px",
            children: children
        })
    });
}
exports.default = HeaderMenuDefault2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","./HeaderMenuDefault2.css":"f4tq1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4tq1":[function() {},{}],"hpV1k":[function() {},{}],"4OTDD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame222Css = require("./Frame222.css");
function Frame222(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-2-11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "continue-6 valign-text-middle inter-bold-mineral-green-18px",
            children: children
        })
    });
}
exports.default = Frame222;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame222.css":"2pcoa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pcoa":[function() {},{}],"cU8oN":[function(require,module,exports,__globalThis) {
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.2 Built on 2024-09-17T13:29:57.859Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AcroForm", ()=>St);
parcelHelpers.export(exports, "AcroFormAppearance", ()=>At);
parcelHelpers.export(exports, "AcroFormButton", ()=>mt);
parcelHelpers.export(exports, "AcroFormCheckBox", ()=>wt);
parcelHelpers.export(exports, "AcroFormChoiceField", ()=>ft);
parcelHelpers.export(exports, "AcroFormComboBox", ()=>pt);
parcelHelpers.export(exports, "AcroFormEditBox", ()=>gt);
parcelHelpers.export(exports, "AcroFormListBox", ()=>dt);
parcelHelpers.export(exports, "AcroFormPasswordField", ()=>Lt);
parcelHelpers.export(exports, "AcroFormPushButton", ()=>vt);
parcelHelpers.export(exports, "AcroFormRadioButton", ()=>bt);
parcelHelpers.export(exports, "AcroFormTextField", ()=>Nt);
parcelHelpers.export(exports, "GState", ()=>j);
parcelHelpers.export(exports, "ShadingPattern", ()=>B);
parcelHelpers.export(exports, "TilingPattern", ()=>M);
parcelHelpers.export(exports, "jsPDF", ()=>E);
var _typeof = require("@babel/runtime/helpers/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _fflate = require("fflate");
var global = arguments[3];
var n = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this;
}();
function i() {
    n.console && "function" == typeof n.console.log && n.console.log.apply(n.console, arguments);
}
var a = {
    log: i,
    warn: function(t) {
        n.console && ("function" == typeof n.console.warn ? n.console.warn.apply(n.console, arguments) : i.call(null, arguments));
    },
    error: function(t) {
        n.console && ("function" == typeof n.console.error ? n.console.error.apply(n.console, arguments) : i(t));
    }
};
function o(t, e, r) {
    var n = new XMLHttpRequest;
    n.open("GET", t), n.responseType = "blob", n.onload = function() {
        l(n.response, e, r);
    }, n.onerror = function() {
        a.error("could not download file");
    }, n.send();
}
function s(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
}
function c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var u, h, l = n.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, _typeofDefault.default)(window)) || window !== n ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, r) {
    var i = n.URL || n.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? s(a.href) ? o(t, e, r) : c(a, a.target = "_blank") : c(a)) : (a.href = i.createObjectURL(t), setTimeout(function() {
        i.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, r, n) {
    if (r = r || e.name || "download", "string" == typeof e) {
        if (s(e)) o(e, r, n);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, r) {
        return void 0 === r ? r = {
            autoBom: !1
        } : "object" !== (0, _typeofDefault.default)(r) && (a.warn("Deprecated: Expected third argument to be a object"), r = {
            autoBom: !r
        }), r.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, n), r);
} : function(e, r, i, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return o(e, r, i);
    var s = "application/octet-stream" === e.type, c = /constructor/i.test(n.HTMLElement) || n.safari, u = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((u || s && c) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, _typeofDefault.default)(FileReader))) {
        var h = new FileReader;
        h.onloadend = function() {
            var t = h.result;
            t = u ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, h.readAsDataURL(e);
    } else {
        var l = n.URL || n.webkitURL, f = l.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            l.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function f(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6));
    t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var r = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], n = 0; n < r.length; n++){
        var i = r[n].re, a = r[n].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), r = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == r.length && (r = "0" + r), "#" + t + e + r;
    };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function d(t, e) {
    var r = t[0], n = t[1], i = t[2], a = t[3];
    r = g(r, n, i, a, e[0], 7, -680876936), a = g(a, r, n, i, e[1], 12, -389564586), i = g(i, a, r, n, e[2], 17, 606105819), n = g(n, i, a, r, e[3], 22, -1044525330), r = g(r, n, i, a, e[4], 7, -176418897), a = g(a, r, n, i, e[5], 12, 1200080426), i = g(i, a, r, n, e[6], 17, -1473231341), n = g(n, i, a, r, e[7], 22, -45705983), r = g(r, n, i, a, e[8], 7, 1770035416), a = g(a, r, n, i, e[9], 12, -1958414417), i = g(i, a, r, n, e[10], 17, -42063), n = g(n, i, a, r, e[11], 22, -1990404162), r = g(r, n, i, a, e[12], 7, 1804603682), a = g(a, r, n, i, e[13], 12, -40341101), i = g(i, a, r, n, e[14], 17, -1502002290), r = m(r, n = g(n, i, a, r, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = m(a, r, n, i, e[6], 9, -1069501632), i = m(i, a, r, n, e[11], 14, 643717713), n = m(n, i, a, r, e[0], 20, -373897302), r = m(r, n, i, a, e[5], 5, -701558691), a = m(a, r, n, i, e[10], 9, 38016083), i = m(i, a, r, n, e[15], 14, -660478335), n = m(n, i, a, r, e[4], 20, -405537848), r = m(r, n, i, a, e[9], 5, 568446438), a = m(a, r, n, i, e[14], 9, -1019803690), i = m(i, a, r, n, e[3], 14, -187363961), n = m(n, i, a, r, e[8], 20, 1163531501), r = m(r, n, i, a, e[13], 5, -1444681467), a = m(a, r, n, i, e[2], 9, -51403784), i = m(i, a, r, n, e[7], 14, 1735328473), r = v(r, n = m(n, i, a, r, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = v(a, r, n, i, e[8], 11, -2022574463), i = v(i, a, r, n, e[11], 16, 1839030562), n = v(n, i, a, r, e[14], 23, -35309556), r = v(r, n, i, a, e[1], 4, -1530992060), a = v(a, r, n, i, e[4], 11, 1272893353), i = v(i, a, r, n, e[7], 16, -155497632), n = v(n, i, a, r, e[10], 23, -1094730640), r = v(r, n, i, a, e[13], 4, 681279174), a = v(a, r, n, i, e[0], 11, -358537222), i = v(i, a, r, n, e[3], 16, -722521979), n = v(n, i, a, r, e[6], 23, 76029189), r = v(r, n, i, a, e[9], 4, -640364487), a = v(a, r, n, i, e[12], 11, -421815835), i = v(i, a, r, n, e[15], 16, 530742520), r = b(r, n = v(n, i, a, r, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = b(a, r, n, i, e[7], 10, 1126891415), i = b(i, a, r, n, e[14], 15, -1416354905), n = b(n, i, a, r, e[5], 21, -57434055), r = b(r, n, i, a, e[12], 6, 1700485571), a = b(a, r, n, i, e[3], 10, -1894986606), i = b(i, a, r, n, e[10], 15, -1051523), n = b(n, i, a, r, e[1], 21, -2054922799), r = b(r, n, i, a, e[8], 6, 1873313359), a = b(a, r, n, i, e[15], 10, -30611744), i = b(i, a, r, n, e[6], 15, -1560198380), n = b(n, i, a, r, e[13], 21, 1309151649), r = b(r, n, i, a, e[4], 6, -145523070), a = b(a, r, n, i, e[11], 10, -1120210379), i = b(i, a, r, n, e[2], 15, 718787259), n = b(n, i, a, r, e[9], 21, -343485551), t[0] = _(r, t[0]), t[1] = _(n, t[1]), t[2] = _(i, t[2]), t[3] = _(a, t[3]);
}
function p(t, e, r, n, i, a) {
    return e = _(_(e, t), _(n, a)), _(e << i | e >>> 32 - i, r);
}
function g(t, e, r, n, i, a, o) {
    return p(e & r | ~e & n, t, e, i, a, o);
}
function m(t, e, r, n, i, a, o) {
    return p(e & n | r & ~n, t, e, i, a, o);
}
function v(t, e, r, n, i, a, o) {
    return p(e ^ r ^ n, t, e, i, a, o);
}
function b(t, e, r, n, i, a, o) {
    return p(r ^ (e | ~n), t, e, i, a, o);
}
function y(t) {
    var e, r = t.length, n = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)d(n, w(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for(d(n, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * r, d(n, i), n;
}
function w(t) {
    var e, r = [];
    for(e = 0; e < 64; e += 4)r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return r;
}
u = n.atob.bind(n), h = n.btoa.bind(n);
var N = "0123456789abcdef".split("");
function L(t) {
    for(var e = "", r = 0; r < 4; r++)e += N[t >> 8 * r + 4 & 15] + N[t >> 8 * r & 15];
    return e;
}
function A(t) {
    return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function x(t) {
    return y(t).map(A).join("");
}
var S = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = L(t[e]);
    return t.join("");
}(y("hello"));
function _(t, e) {
    if (S) {
        var r = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function P(t, e) {
    var r, n, i, a;
    if (t !== r) {
        for(var o = (i = t, a = 1 + (256 / t.length >> 0), new Array(a + 1).join(i)), s = [], c = 0; c < 256; c++)s[c] = c;
        var u = 0;
        for(c = 0; c < 256; c++){
            var h = s[c];
            u = (u + h + o.charCodeAt(c)) % 256, s[c] = s[u], s[u] = h;
        }
        r = t, n = s;
    } else s = n;
    var l = e.length, f = 0, d = 0, p = "";
    for(c = 0; c < l; c++)d = (d + (h = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = h, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(c) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var k = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function I(t, e, r, n) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== k.perm) throw new Error("Invalid permission: " + t);
        i += k[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (r + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = x(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = P(this.encryptionKey, this.padding);
}
function F(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", r = t.length, n = 0; n < r; n++){
        var i = t.charCodeAt(n);
        if (i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126) e += "#" + ("0" + i.toString(16)).slice(-2);
        else e += t[n];
    }
    return e;
}
function C(e) {
    if ("object" !== (0, _typeofDefault.default)(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r = {};
    this.subscribe = function(t, e, n) {
        if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        r.hasOwnProperty(t) || (r[t] = {});
        var i = Math.random().toString(35);
        return r[t][i] = [
            e,
            !!n
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in r)if (r[e][t]) return delete r[e][t], 0 === Object.keys(r[e]).length && delete r[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (r.hasOwnProperty(t)) {
            var i = Array.prototype.slice.call(arguments, 1), o = [];
            for(var s in r[t]){
                var c = r[t][s];
                try {
                    c[0].apply(e, i);
                } catch (t) {
                    n.console && a.error("jsPDF PubSub Error", t.message, t);
                }
                c[1] && o.push(s);
            }
            o.length && o.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return r;
    };
}
function j(t) {
    if (!(this instanceof j)) return new j(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var r in t)t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    this.id = "", this.objectNumber = -1;
}
function O(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function B(t, e, r, n, i) {
    if (!(this instanceof B)) return new B(t, e, r, n, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = r, O.call(this, n, i);
}
function M(t, e, r, n, i) {
    if (!(this instanceof M)) return new M(t, e, r, n, i);
    this.boundingBox = t, this.xStep = e, this.yStep = r, this.stream = "", this.cloneIndex = 0, O.call(this, n, i);
}
function E(e) {
    var r, i = "string" == typeof arguments[0] ? arguments[0] : "p", o = arguments[1], s = arguments[2], c = arguments[3], u = [], d = 1, p = 16, g = "S", m = null;
    "object" === (0, _typeofDefault.default)(e = e || {}) && (i = e.orientation, o = e.unit || o, s = e.format || s, c = e.compress || e.compressPdf || c, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), d = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (r = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), u = e.filters || (!0 === c ? [
        "FlateEncode"
    ] : u), o = o || "mm", i = ("" + (i || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = C;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var A = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var x = {
        COMPAT: "compat",
        ADVANCED: "advanced"
    }, S = x.COMPAT;
    function _() {
        this.saveGraphicsState(), lt(new Vt(_t, 0, 0, -_t, 0, Rr() * _t).toString() + " cm"), this.setFontSize(this.getFontSize() / _t), g = "n", S = x.ADVANCED;
    }
    function P() {
        this.restoreGraphicsState(), g = "S", S = x.COMPAT;
    }
    var k = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = S === x.COMPAT;
        return e && _.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = S === x.ADVANCED;
        return e && P.call(this), "function" != typeof t || (t(this), e && _.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return S === x.ADVANCED;
    };
    var O, q = function(t) {
        if (S !== x.ADVANCED) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var n = r || e;
        if (isNaN(t) || isNaN(n)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(n).replace(/0+$/, "");
    };
    O = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var R = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, T = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return S === x.COMPAT ? t * _t : S === x.ADVANCED ? t : void 0;
    }, z = function(t) {
        return S === x.COMPAT ? Rr() - t : S === x.ADVANCED ? t : void 0;
    }, H = function(t) {
        return U(z(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (Ye = new I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), r = e < 0 ? "+" : "-", n = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            r,
            Q(n),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), r = parseInt(t.substr(6, 2), 10) - 1, n = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, r, n, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, rt = [], nt = [], it = 0, at = [], ot = [], st = !1, ct = nt, ut = function() {
        et = 0, it = 0, nt = [], rt = [], at = [], Qt = Kt(), te = Kt();
    };
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ct = t;
    };
    var ht = function(t) {
        st || (ct = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ct = nt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ct.push(t), ct;
    }, ft = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, dt = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r); e--;)n[e] = t.charCodeAt(e);
        return r;
    }, pt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return pt;
    };
    var gt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return gt = S === x.ADVANCED ? t / _t : t, this;
    };
    var mt, vt = y.__private__.getFontSize = y.getFontSize = function() {
        return S === x.COMPAT ? gt : gt * _t;
    }, bt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return bt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return bt;
    };
    var yt, wt = y.__private__.setZoomMode = function(t) {
        var e = [
            void 0,
            null,
            "fullwidth",
            "fullheight",
            "fullpage",
            "original"
        ];
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) mt = t;
        else if (isNaN(t)) {
            if (-1 === e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            mt = t;
        } else mt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return mt;
    };
    var Nt, Lt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        yt = t;
    };
    y.__private__.getPageMode = function() {
        return yt;
    };
    var At = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        Nt = t;
    };
    y.__private__.getLayoutMode = function() {
        return Nt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, r) {
        return wt(t), At(e), Lt(r), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var St, _t, Pt, kt, It, Ft = {}, Ct = {}, jt = [], Ot = {}, Bt = {}, Mt = {}, Et = {}, qt = null, Dt = 0, Rt = [], Tt = new C(y), Ut = e.hotfixes || [], zt = {}, Ht = {}, Wt = [], Vt = function t(e, r, n, i, a, o) {
        if (!(this instanceof t)) return new t(e, r, n, i, a, o);
        isNaN(e) && (e = 1), isNaN(r) && (r = 0), isNaN(n) && (n = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            r,
            n,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Vt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Vt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Vt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Vt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Vt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(O).join(t);
    }, Vt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, r = t.sx * this.shy + t.shy * this.sy, n = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Vt(e, r, n, i, a, o);
    }, Vt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * r + (e /= o) * n;
        r -= t * s, n -= e * s;
        var c = Math.sqrt(r * r + n * n);
        return s /= c, t * (n /= c) < e * (r /= c) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Vt(o, 0, 0, c, 0, 0),
            translate: new Vt(1, 0, 0, 1, i, a),
            rotate: new Vt(t, e, -e, t, 0, 0),
            skew: new Vt(1, 0, s, 1, 0, 0)
        };
    }, Vt.prototype.toString = function(t) {
        return this.join(" ");
    }, Vt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = 1 / (t * n - e * r), s = n * o, c = -e * o, u = -r * o, h = t * o;
        return new Vt(s, c, u, h, -s * i - u * a, -c * i - h * a);
    }, Vt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, r = t.x * this.shy + t.y * this.sy + this.ty;
        return new Cr(e, r);
    }, Vt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), r = this.applyToPoint(new Cr(t.x + t.w, t.y + t.h));
        return new jr(e.x, e.y, r.x - e.x, r.y - e.y);
    }, Vt.prototype.clone = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty;
        return new Vt(t, e, r, n, i, a);
    }, y.Matrix = Vt;
    var Gt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Yt = new Vt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Yt;
    var Jt = function(t, e) {
        if (!Bt[t]) {
            var r = (e instanceof B ? "Sh" : "P") + (Object.keys(Ot).length + 1).toString(10);
            e.id = r, Bt[t] = r, Ot[r] = e, Tt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = B, y.TilingPattern = M, y.addShadingPattern = function(t, e) {
        return q("addShadingPattern()"), Jt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        q("beginTilingPattern()"), Br(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        q("endTilingPattern()"), e.stream = ot[$].join("\n"), Jt(t, e), Tt.publish("endTilingPattern", e), Wt.pop().restore();
    };
    var Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, rt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, rt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) {
            if (5 === e.length && ("k" === e[4] || "K" === e[4])) e = [
                (1 - e[0]) * (1 - e[3]),
                (1 - e[1]) * (1 - e[3]),
                (1 - e[2]) * (1 - e[3]),
                "r"
            ];
        } else {
            var r = parseFloat(e[0]);
            e = [
                r,
                r,
                r,
                "r"
            ];
        }
        for(var n = "#", i = 0; i < 3; i++)n += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return n;
    }, re = y.__private__.encodeColorString = function(e) {
        var r;
        "string" == typeof e && (e = {
            ch1: e
        });
        var n = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
            var c = new f(n);
            if (c.ok) n = c.toHex();
            else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
            var u = parseInt(n.substr(1), 16);
            n = u >> 16 & 255, i = u >> 8 & 255, a = 255 & u;
        }
        if (void 0 === i || void 0 === o && n === i && i === a) {
            if ("string" == typeof n) r = n + " " + s[0];
            else switch(e.precision){
                case 2:
                    r = R(n / 255) + " " + s[0];
                    break;
                case 3:
                default:
                    r = T(n / 255) + " " + s[0];
            }
        } else if (void 0 === o || "object" === (0, _typeofDefault.default)(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return r = [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            if ("string" == typeof n) r = [
                n,
                i,
                a,
                s[1]
            ].join(" ");
            else switch(e.precision){
                case 2:
                    r = [
                        R(n / 255),
                        R(i / 255),
                        R(a / 255),
                        s[1]
                    ].join(" ");
                    break;
                default:
                case 3:
                    r = [
                        T(n / 255),
                        T(i / 255),
                        T(a / 255),
                        s[1]
                    ].join(" ");
            }
        } else if ("string" == typeof n) r = [
            n,
            i,
            a,
            o,
            s[2]
        ].join(" ");
        else switch(e.precision){
            case 2:
                r = [
                    R(n),
                    R(i),
                    R(a),
                    R(o),
                    s[2]
                ].join(" ");
                break;
            case 3:
            default:
                r = [
                    T(n),
                    T(i),
                    T(a),
                    T(o),
                    s[2]
                ].join(" ");
        }
        return r;
    }, ne = y.__private__.getFilters = function() {
        return u;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", r = t.filters || ne(), n = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = Ye.encryptor(o, 0));
        var c = {};
        !0 === r && (r = [
            "FlateEncode"
        ]);
        var u = t.additionalKeyValues || [], h = (c = void 0 !== E.API.processDataByFilters ? E.API.processDataByFilters(e, r) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(n) ? n.join(" ") : n.toString());
        if (0 !== c.data.length && (u.push({
            key: "Length",
            value: c.data.length
        }), !0 === i && u.push({
            key: "Length1",
            value: a
        })), 0 != h.length) {
            if (h.split("/").length - 1 == 1) u.push({
                key: "Filter",
                value: h
            });
            else {
                u.push({
                    key: "Filter",
                    value: "[" + h + "]"
                });
                for(var l = 0; l < u.length; l += 1)if ("DecodeParms" === u[l].key) {
                    for(var f = [], d = 0; d < c.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(u[l].value), u[l].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < u.length; p++)lt("/" + u[p].key + " " + u[p].value);
        lt(">>"), 0 !== c.data.length && (lt("stream"), lt(s(c.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, r = t.data, n = t.objId, i = t.contentsObjId;
        Zt(n, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(O(t.mediaBox.bottomLeftX)) + " " + parseFloat(O(t.mediaBox.bottomLeftY)) + " " + O(t.mediaBox.topRightX) + " " + O(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + O(t.cropBox.bottomLeftX) + " " + O(t.cropBox.bottomLeftY) + " " + O(t.cropBox.topRightX) + " " + O(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + O(t.bleedBox.bottomLeftX) + " " + O(t.bleedBox.bottomLeftY) + " " + O(t.bleedBox.topRightX) + " " + O(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + O(t.trimBox.bottomLeftX) + " " + O(t.trimBox.bottomLeftY) + " " + O(t.trimBox.topRightX) + " " + O(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + O(t.artBox.bottomLeftX) + " " + O(t.artBox.bottomLeftY) + " " + O(t.artBox.topRightX) + " " + O(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Tt.publish("putPage", {
            objId: n,
            pageContext: Rt[e],
            pageNumber: e,
            page: r
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = r.join("\n");
        return S === x.ADVANCED && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: ne(),
            objectId: i
        }), lt("endobj"), n;
    }, oe = y.__private__.putPages = function() {
        var t, e, r = [];
        for(t = 1; t <= Dt; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Dt; t++)r.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var n = "/Kids [";
        for(e = 0; e < Dt; e++)n += r[e] + " 0 R ";
        lt(n + "]"), lt("/Count " + Dt), lt(">>"), lt("endobj"), Tt.publish("postPutPages");
    }, se = function(t) {
        Tt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + F(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ce = function() {
        for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                O(t.x),
                O(t.y),
                O(t.x + t.width),
                O(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var r = t.pages[1].join("\n");
        ie({
            data: r,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function() {
        for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
    }, le = function(t, e) {
        var r, n = [], i = 1 / (e - 1);
        for(r = 0; r < 1; r += i)n.push(r);
        if (n.push(1), 0 != t[0].offset) {
            var a = {
                offset: 0,
                color: t[0].color
            };
            t.unshift(a);
        }
        if (1 != t[t.length - 1].offset) {
            var o = {
                offset: 1,
                color: t[t.length - 1].color
            };
            t.push(o);
        }
        for(var s = "", c = 0, u = 0; u < n.length; u++){
            for(r = n[u]; r > t[c + 1].offset;)c++;
            var h = t[c].offset, l = (r - h) / (t[c + 1].offset - h), f = t[c].color, d = t[c + 1].color;
            s += tt(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) + tt(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) + tt(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
        }
        return s.trim();
    }, fe = function(t, e) {
        e || (e = 21);
        var r = Xt(), n = le(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: n,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: r
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + O(parseFloat(t.coords[0])) + " " + O(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) : a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) + " " + O(parseFloat(t.coords[4])) + " " + O(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + r + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, de = function(t, e) {
        var r = Kt(), n = Xt();
        e.push({
            resourcesOid: r,
            objectOid: n
        }), t.objectNumber = n;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(O).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: O(t.xStep)
        }), i.push({
            key: "YStep",
            value: O(t.yStep)
        }), i.push({
            key: "Resources",
            value: r + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, pe = function(t) {
        var e;
        for(e in Ot)Ot.hasOwnProperty(e) && (Ot[e] instanceof B ? fe(Ot[e]) : Ot[e] instanceof M && de(Ot[e], t));
    }, ge = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + R(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + R(t[e]));
        }
        lt(">>"), lt("endobj");
    }, me = function() {
        var t;
        for(t in Mt)Mt.hasOwnProperty(t) && ge(Mt[t]);
    }, ve = function() {
        for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
        Tt.publish("putXobjectDict"), lt(">>");
    }, be = function() {
        Ye.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + Ye.v), lt("/R " + Ye.r), lt("/U <" + Ye.toHexString(Ye.U) + ">"), lt("/O <" + Ye.toHexString(Ye.O) + ">"), lt("/P " + Ye.P), lt(">>"), lt("endobj");
    }, ye = function() {
        for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
        lt(">>");
    }, we = function() {
        if (Object.keys(Ot).length > 0) {
            for(var t in lt("/Shading <<"), Ot)Ot.hasOwnProperty(t) && Ot[t] instanceof B && Ot[t].objectNumber >= 0 && lt("/" + t + " " + Ot[t].objectNumber + " 0 R");
            Tt.publish("putShadingPatternDict"), lt(">>");
        }
    }, Ne = function(t) {
        if (Object.keys(Ot).length > 0) {
            for(var e in lt("/Pattern <<"), Ot)Ot.hasOwnProperty(e) && Ot[e] instanceof y.TilingPattern && Ot[e].objectNumber >= 0 && Ot[e].objectNumber < t && lt("/" + e + " " + Ot[e].objectNumber + " 0 R");
            Tt.publish("putTilingPatternDict"), lt(">>");
        }
    }, Le = function() {
        if (Object.keys(Mt).length > 0) {
            var t;
            for(t in lt("/ExtGState <<"), Mt)Mt.hasOwnProperty(t) && Mt[t].objectNumber >= 0 && lt("/" + t + " " + Mt[t].objectNumber + " 0 R");
            Tt.publish("putGStateDict"), lt(">>");
        }
    }, Ae = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ye(), we(), Ne(t.objectOid), Le(), ve(), lt(">>"), lt("endobj");
    }, xe = function() {
        var t = [];
        ce(), me(), he(), pe(t), Tt.publish("putResources"), t.forEach(Ae), Ae({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Tt.publish("postPutResources");
    }, Se = function() {
        Tt.publish("putAdditionalObjects");
        for(var t = 0; t < at.length; t++){
            var e = at[t];
            Zt(e.objId, !0), lt(e.content), lt("endobj");
        }
        Tt.publish("postPutAdditionalObjects");
    }, _e = function(t) {
        Ct[t.fontName] = Ct[t.fontName] || {}, Ct[t.fontName][t.fontStyle] = t.id;
    }, Pe = function(t, e, r, n, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: r,
            encoding: n,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Tt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, _e(a), a.id;
    }, ke = function(t) {
        for(var e = 0, r = pt.length; e < r; e++){
            var n = Pe.call(this, t[e][0], t[e][1], t[e][2], pt[e][3], !0);
            !1 === v && (b[n] = !0);
            var i = t[e][0].split("-");
            _e({
                id: n,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Tt.publish("addFonts", {
            fonts: Ft,
            dictionary: Ct
        });
    }, Ie = function(t) {
        return t.foo = function() {
            try {
                return t.apply(this, arguments);
            } catch (t) {
                var e = t.stack || "";
                ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                var r = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                if (!n.console) throw new Error(r);
                n.console.error(r, t), n.alert && alert(r);
            }
        }, t.foo.bar = t, t.foo;
    }, Fe = function(t, e) {
        var r, n, i, a, o, s, c, u, h;
        if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[St].metadata && Ft[St].metadata[i] && Ft[St].metadata[i].encoding && (a = Ft[St].metadata[i].encoding, !o && Ft[St].encoding && (o = Ft[St].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
            for(c = !1, s = [], r = 0, n = t.length; r < n; r++)(u = o[t.charCodeAt(r)]) ? s.push(String.fromCharCode(u)) : s.push(t[r]), s[r].charCodeAt(0) >> 8 && (c = !0);
            t = s.join("");
        }
        for(r = t.length; void 0 === c && 0 !== r;)t.charCodeAt(r - 1) >> 8 && (c = !0), r--;
        if (!c) return t;
        for(s = e.noBOM ? [] : [
            254,
            255
        ], r = 0, n = t.length; r < n; r++){
            if ((h = (u = t.charCodeAt(r)) >> 8) >> 8) throw new Error("Character at position " + r + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
            s.push(h), s.push(u - (h << 8));
        }
        return String.fromCharCode.apply(void 0, s);
    }, Ce = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return Fe(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, je = y.__private__.beginPage = function(t) {
        ot[++Dt] = [], Rt[Dt] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(d),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, Me(Dt), ht(ot[$]);
    }, Oe = function(t, e) {
        var r, n, o;
        switch(i = e || i, "string" == typeof t && (r = A(t.toLowerCase()), Array.isArray(r) && (n = r[0], o = r[1])), Array.isArray(t) && (n = t[0] * _t, o = t[1] * _t), isNaN(n) && (n = s[0], o = s[1]), (n > 14400 || o > 14400) && (a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), n = Math.min(14400, n), o = Math.min(14400, o)), s = [
            n,
            o
        ], i.substr(0, 1)){
            case "l":
                o > n && (s = [
                    o,
                    n
                ]);
                break;
            case "p":
                n > o && (s = [
                    o,
                    n
                ]);
        }
        je(s), pr(fr), lt(Lr), 0 !== kr && lt(kr + " J"), 0 !== Ir && lt(Ir + " j"), Tt.publish("addPage", {
            pageNumber: Dt
        });
    }, Be = function(t) {
        t > 0 && t <= Dt && (ot.splice(t, 1), Rt.splice(t, 1), Dt--, $ > Dt && ($ = Dt), this.setPage($));
    }, Me = function(t) {
        t > 0 && t <= Dt && ($ = t);
    }, Ee = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, qe = function(t, e, r) {
        var n, i = void 0;
        return r = r || {}, t = void 0 !== t ? t : Ft[St].fontName, e = void 0 !== e ? e : Ft[St].fontStyle, n = t.toLowerCase(), void 0 !== Ct[n] && void 0 !== Ct[n][e] ? i = Ct[n][e] : void 0 !== Ct[t] && void 0 !== Ct[t][e] ? i = Ct[t][e] : !1 === r.disableWarning && a.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || r.noFallback || null == (i = Ct.times[e]) && (i = Ct.times.normal), i;
    }, De = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var r in null !== m && (e = Ye.encryptor(t, 0)), lt("<<"), lt("/Producer (" + Ce(e("jsPDF " + E.version)) + ")"), xt)xt.hasOwnProperty(r) && xt[r] && lt("/" + r.substr(0, 1).toUpperCase() + r.substr(1) + " (" + Ce(e(xt[r])) + ")");
        lt("/CreationDate (" + Ce(e(W)) + ")"), lt(">>"), lt("endobj");
    }, Re = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), mt || (mt = "fullwidth"), mt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var r = "" + mt;
                "%" === r.substr(r.length - 1) && (mt = parseInt(mt) / 100), "number" == typeof mt && lt("/OpenAction [3 0 R /XYZ null null " + R(mt) + "]");
        }
        switch(Nt || (Nt = "continuous"), Nt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        yt && lt("/PageMode /" + yt), Tt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Te = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + Ye.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Ue = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, ze = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof rt[e] ? lt((t + rt[e]()).slice(-10) + " 00000 n ") : void 0 !== rt[e] ? lt((t + rt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, He = y.__private__.buildDocument = function() {
        ut(), ht(nt), Tt.publish("buildDocument"), Ue(), oe(), Se(), xe(), null !== m && be(), De(), Re();
        var t = it;
        return ze(), Te(), lt("startxref"), lt("" + t), lt("%%EOF"), ht(ot[$]), nt.join("\n");
    }, We = y.__private__.getBlob = function(t) {
        return new Blob([
            dt(t)
        ], {
            type: "application/pdf"
        });
    }, Ve = y.output = y.__private__.output = Ie(function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return He();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return dt(He());
            case "blob":
                return We(He());
            case "bloburi":
            case "bloburl":
                if (void 0 !== n.URL && "function" == typeof n.URL.createObjectURL) return n.URL && n.URL.createObjectURL(We(He())) || void 0;
                a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var r = "", i = He();
                try {
                    r = h(i);
                } catch (t) {
                    r = h(unescape(encodeURIComponent(i)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + r;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call(n)) {
                    var o = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (o = e.pdfObjectUrl, s = "");
                    var c = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + o + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", u = n.open();
                    return null !== u && u.document.write(c), u;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call(n)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', f = n.open();
                    if (null !== f) {
                        f.document.write(l);
                        var d = this;
                        f.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            f.document.title = e.filename, f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"));
                        };
                    }
                    return f;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call(n)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = n.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return n.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }), Ge = function(t) {
        return !0 === Array.isArray(Ut) && Ut.indexOf(t) > -1;
    };
    switch(o){
        case "pt":
            _t = 1;
            break;
        case "mm":
            _t = 72 / 25.4;
            break;
        case "cm":
            _t = 72 / 2.54;
            break;
        case "in":
            _t = 72;
            break;
        case "px":
            _t = 1 == Ge("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            _t = 12;
            break;
        case "ex":
            _t = 6;
            break;
        default:
            if ("number" != typeof o) throw new Error("Invalid unit: " + o);
            _t = o;
    }
    var Ye = null;
    K(), Y();
    var Je = function(t) {
        return null !== m ? Ye.encryptor(t, 0) : function(t) {
            return t;
        };
    }, Xe = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Ke = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Xe(e);
    }, Ze = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return Oe.apply(this, arguments), this;
    }, y.setPage = function() {
        return Me.apply(this, arguments), ht.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var r, n;
        if (t > e) {
            r = ot[t], n = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        } else if (t < e) {
            r = ot[t], n = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return Be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof r && ("string" == typeof n || Array.isArray(n))) {
            var m = n;
            n = r, r = e, e = m;
        }
        if (arguments[3] instanceof Vt == !1 ? (c = arguments[4], u = arguments[5], "object" === (0, _typeofDefault.default)(f = arguments[3]) && null !== f || ("string" == typeof c && (u = c, c = null), "string" == typeof f && (u = f, f = null), "number" == typeof f && (c = f, f = null), i = {
            flags: f,
            angle: c,
            align: u
        })) : (q("The transform parameter of text() with a Matrix value"), p = a), isNaN(r) || isNaN(n) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v = "", y = !1, w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : lr, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), Ce(t, f);
        }
        function A(t) {
            for(var e, r = t.concat(), n = [], i = r.length; i--;)"string" == typeof (e = r.shift()) ? n.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? n.push(e[0]) : n.push([
                e[0],
                e[1],
                e[2]
            ]);
            return n;
        }
        function _(t, e) {
            var r;
            if ("string" == typeof t) r = e(t)[0];
            else if (Array.isArray(t)) {
                for(var n, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (n = a.shift()) ? o.push(e(n)[0]) : Array.isArray(n) && "string" == typeof n[0] && (i = e(n[0], n[1], n[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                r = o;
            }
            return r;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var I = e.concat();
            s = [];
            for(var F, C = I.length; C--;)("string" != typeof (F = I.shift()) || Array.isArray(F) && "string" != typeof F[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var j = gt / g.internal.scaleFactor, B = j * (w - 1);
        switch(i.baseline){
            case "bottom":
                n -= B;
                break;
            case "top":
                n += j - B;
                break;
            case "hanging":
                n += j - 2 * B;
                break;
            case "middle":
                n += j / 2 - B;
        }
        if ((l = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, l) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, l));
        }, []))), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("preProcessText", o), e = o.text, c = (i = o.options).angle, p instanceof Vt == !1 && c && "number" == typeof c) {
            c *= Math.PI / 180, 0 === i.rotationDirection && (c = -c), S === x.ADVANCED && (c = -c);
            var M = Math.cos(c), E = Math.sin(c);
            p = new Vt(M, E, -E, M, 0, 0);
        } else c && c instanceof Vt && (p = c);
        S !== x.ADVANCED || p || (p = Yt), void 0 !== (h = i.charSpace || _r) && (v += O(U(h)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (v += O(100 * d) + " Tz\n");
        i.lang;
        var D = -1, R = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(R){
            case 0:
            case !1:
            case "fill":
                D = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                D = 1;
                break;
            case 2:
            case "fillThenStroke":
                D = 2;
                break;
            case 3:
            case "invisible":
                D = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                D = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                D = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                D = 6;
                break;
            case 7:
            case "addToPathForClipping":
                D = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== D ? v += D + " Tr\n" : -1 !== z && (v += "0 Tr\n"), -1 !== D && (T.usedRenderingMode = D), u = i.align || "left";
        var H, W = gt * w, V = g.internal.pageSize.getWidth(), G = Ft[St];
        h = i.charSpace || _r, l = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [], J = function(t) {
            return g.getStringUnitWidth(t, {
                font: G,
                charSpace: h,
                fontSize: gt,
                doKerning: !1
            }) * gt / N;
        };
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var X;
            s = A(e), "left" !== u && (H = s.map(J));
            var K, Z = 0;
            if ("right" === u) {
                r -= H[0], e = [], C = s.length;
                for(var $ = 0; $ < C; $++)0 === $ ? (K = br(r), X = yr(n)) : (K = U(Z - H[$]), X = -W), e.push([
                    s[$],
                    K,
                    X
                ]), Z = H[$];
            } else if ("center" === u) {
                r -= H[0] / 2, e = [], C = s.length;
                for(var Q = 0; Q < C; Q++)0 === Q ? (K = br(r), X = yr(n)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                    s[Q],
                    K,
                    X
                ]), Z = H[Q];
            } else if ("left" === u) {
                e = [], C = s.length;
                for(var tt = 0; tt < C; tt++)e.push(s[tt]);
            } else if ("justify" === u && "Identity-H" === G.encoding) {
                e = [], C = s.length, l = 0 !== l ? l : V;
                for(var et = 0, rt = 0; rt < C; rt++)if (X = 0 === rt ? yr(n) : -W, K = 0 === rt ? br(r) : et, rt < C - 1) {
                    var nt = U((l - H[rt]) / (s[rt].split(" ").length - 1)), it = s[rt].split(" ");
                    e.push([
                        it[0] + " ",
                        K,
                        X
                    ]), et = 0;
                    for(var at = 1; at < it.length; at++){
                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + nt;
                        at == it.length - 1 ? e.push([
                            it[at],
                            ot,
                            0
                        ]) : e.push([
                            it[at] + " ",
                            ot,
                            0
                        ]), et -= ot;
                    }
                } else e.push([
                    s[rt],
                    K,
                    X
                ]);
                e.push([
                    "",
                    et,
                    0
                ]);
            } else {
                if ("justify" !== u) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                e = [], C = s.length, l = 0 !== l ? l : V;
                for(rt = 0; rt < C; rt++)X = 0 === rt ? yr(n) : -W, K = 0 === rt ? br(r) : 0, rt < C - 1 ? Y.push(O(U((l - H[rt]) / (s[rt].split(" ").length - 1)))) : Y.push(0), e.push([
                    s[rt],
                    K,
                    X
                ]);
            }
        }
        var st = "boolean" == typeof i.R2L ? i.R2L : bt;
        !0 === st && (e = _(e, function(t, e, r) {
            return [
                t.split("").reverse().join(""),
                e,
                r
            ];
        })), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("postProcessText", o), e = o.text, y = o.mutex.isHex || !1;
        var ct = Ft[St].encoding;
        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = _(e, function(t, e, r) {
            return [
                L(t),
                e,
                r
            ];
        })), s = A(e), e = [];
        for(var ut, ht, ft, dt = 0, pt = 1, mt = Array.isArray(s[0]) ? pt : dt, vt = "", yt = function(t, e, r) {
            var n = "";
            return r instanceof Vt ? (r = "number" == typeof i.angle ? Gt(r, new Vt(1, 0, 0, 1, t, e)) : Gt(new Vt(1, 0, 0, 1, t, e), r), S === x.ADVANCED && (r = Gt(new Vt(1, 0, 0, -1, 0, 0), r)), n = r.join(" ") + " Tm\n") : n = O(t) + " " + O(e) + " Td\n", n;
        }, wt = 0; wt < s.length; wt++){
            switch(vt = "", mt){
                case pt:
                    ft = (y ? "<" : "(") + s[wt][0] + (y ? ">" : ")"), ut = parseFloat(s[wt][1]), ht = parseFloat(s[wt][2]);
                    break;
                case dt:
                    ft = (y ? "<" : "(") + s[wt] + (y ? ">" : ")"), ut = br(r), ht = yr(n);
            }
            void 0 !== Y && void 0 !== Y[wt] && (vt = Y[wt] + " Tw\n"), 0 === wt ? e.push(vt + yt(ut, ht, p) + ft) : mt === dt ? e.push(vt + ft) : mt === pt && e.push(vt + yt(ut, ht, p) + ft);
        }
        e = mt === dt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var Nt = "BT\n/";
        return Nt += St + " " + gt + " Tf\n", Nt += O(gt * w) + " TL\n", Nt += xr + "\n", Nt += v, Nt += e, lt(Nt += "ET"), b[St] = !0, g;
    };
    var $e = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return $e("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var Qe = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return Qe(t) && (g = t), this;
    };
    var tr = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, er = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return rr("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return rr("f*", t), this;
    }, y.fillStroke = function(t) {
        return rr("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return rr("B*", t), this;
    };
    var rr = function(e, r) {
        "object" === (0, _typeofDefault.default)(r) ? ar(r, e) : lt(e);
    }, nr = function(t) {
        null === t || S === x.ADVANCED && void 0 === t || (t = tr(t), lt(t));
    };
    function ir(t, e, r, n, i) {
        var a = new M(e || this.boundingBox, r || this.xStep, n || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Jt(o, a), a;
    }
    var ar = function(t, e) {
        var r = Bt[t.key], n = Ot[r];
        if (n instanceof B) lt("q"), lt(or(e)), n.gState && y.setGState(n.gState), lt(t.matrix.toString() + " cm"), lt("/" + r + " sh"), lt("Q");
        else if (n instanceof M) {
            var i = new Vt(1, 0, 0, -1, 0, Rr());
            t.matrix && (i = i.multiply(t.matrix || Yt), r = ir.call(n, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + r + " scn"), n.gState && y.setGState(n.gState), lt(e), lt("Q");
        }
    }, or = function(t) {
        switch(t){
            case "f":
            case "F":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
                return "W S";
            case "B*":
                return "W* S";
            case "S":
                return "W S";
            case "n":
                return "W n";
        }
    }, sr = y.moveTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " m"), this;
    }, cr = y.lineTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " l"), this;
    }, ur = y.curveTo = function(t, e, r, n, i, a) {
        return lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(H(n)),
            O(U(i)),
            O(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return S === x.COMPAT ? this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g, m, v;
        if ("number" == typeof t && (v = r, r = e, e = t, t = v), n = n || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(r) || !Array.isArray(t) || !Array.isArray(n) || !Qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(sr(e, r), o = n[0], s = n[1], u = t.length, g = e, m = r, c = 0; c < u; c++)2 === (h = t[c]).length ? (g = h[0] * o + g, m = h[1] * s + m, cr(g, m)) : (l = h[0] * o + g, f = h[1] * s + m, d = h[2] * o + g, p = h[3] * s + m, g = h[4] * o + g, m = h[5] * s + m, ur(l, f, d, p, g, m));
        return a && er(), nr(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var r = t[e], n = r.c;
            switch(r.op){
                case "m":
                    sr(n[0], n[1]);
                    break;
                case "l":
                    cr(n[0], n[1]);
                    break;
                case "c":
                    ur.apply(this, n);
                    break;
                case "h":
                    er();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return S === x.COMPAT && (n = -n), lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(U(n)),
            "re"
        ].join(" ")), nr(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                r - t,
                n - e
            ],
            [
                i - r,
                a - n
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * r), a = Math.min(a, .5 * n), this.lines([
            [
                r - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                n - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - r,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - n
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * r, o = 4 / 3 * (Math.SQRT2 - 1) * n;
        return sr(t + r, e), ur(t + r, e - o, t + a, e - n, t, e - n), ur(t - a, e - n, t - r, e - o, t - r, e), ur(t - r, e + o, t - a, e + n, t, e + n), ur(t + a, e + n, t + r, e + o, t + r, e), nr(i), this;
    }, y.__private__.circle = y.circle = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || !Qe(n)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, r, r, n);
    }, y.setFont = function(t, e, r) {
        return r && (e = k(e, r)), St = qe(t, e, {
            disableWarning: !1
        }), this;
    };
    var hr = y.__private__.getFont = y.getFont = function() {
        return Ft[qe.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, r = {};
        for(t in Ct)if (Ct.hasOwnProperty(t)) for(e in r[t] = [], Ct[t])Ct[t].hasOwnProperty(e) && r[t].push(e);
        return r;
    }, y.addFont = function(t, e, r, n, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (r = k(r, n)), i = i || "Identity-H", Pe.call(this, t, e, r, i);
    };
    var lr, fr = e.lineWidth || .200025, dr = y.__private__.getLineWidth = y.getLineWidth = function() {
        return fr;
    }, pr = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return fr = t, lt(O(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = E.API.setLineDash = E.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return O(U(t));
        }).join(" "), e = O(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var gr = y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    var mr = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (lr = t), this;
    }, vr = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return lr;
    };
    mr(e.lineHeight);
    var br = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, yr = y.__private__.getVerticalCoordinate = function(t) {
        return S === x.ADVANCED ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, wr = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return O(br(t));
    }, Nr = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return O(yr(t));
    }, Lr = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(Lr);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, r, n) {
        return Lr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "draw",
            precision: 2
        }), lt(Lr), this;
    };
    var Ar = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(Ar);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, r, n) {
        return Ar = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "fill",
            precision: 2
        }), lt(Ar), this;
    };
    var xr = e.textColor || "0 g", Sr = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(xr);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, r, n) {
        return xr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var _r = e.charSpace, Pr = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(_r || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return _r = t, this;
    };
    var kr = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return kr = e, lt(e + " J"), this;
    };
    var Ir = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return Ir = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(O(U(t)) + " M"), this;
    }, y.GState = j, y.setGState = function(t) {
        (t = "string" == typeof t ? Mt[Et[t]] : Fr(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var Fr = function(t, e) {
        if (!t || !Et[t]) {
            var r = !1;
            for(var n in Mt)if (Mt.hasOwnProperty(n) && Mt[n].equals(e)) {
                r = !0;
                break;
            }
            if (r) e = Mt[n];
            else {
                var i = "GS" + (Object.keys(Mt).length + 1).toString(10);
                Mt[i] = e, e.id = i;
            }
            return t && (Et[t] = e.id), Tt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return Fr(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: St,
            size: gt,
            color: xr
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = jt.pop();
        return St = t.key, gt = t.size, xr = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var Cr = function(t, e) {
        var r = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var n = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, jr = function(t, e, r, n) {
        Cr.call(this, t, e), this.type = "rect";
        var i = r || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = n || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, Or = function() {
        this.page = Dt, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = Pt, this.y = kt, this.matrix = It, this.width = qr($), this.height = Rr($), this.outputDestination = ct, this.id = "", this.objectNumber = -1;
    };
    Or.prototype.restore = function() {
        Dt = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, Pt = this.x, kt = this.y, It = this.matrix, Dr($, this.width), Tr($, this.height), ct = this.outputDestination;
    };
    var Br = function(t, e, r, n, i) {
        Wt.push(new Or), Dt = $ = 0, ot = [], Pt = t, kt = e, It = i, je([
            r,
            n
        ]);
    }, Mr = function(t) {
        if (Ht[t]) Wt.pop().restore();
        else {
            var e = new Or, r = "Xo" + (Object.keys(zt).length + 1).toString(10);
            e.id = r, Ht[t] = r, zt[r] = e, Tt.publish("addFormObject", e), Wt.pop().restore();
        }
    };
    for(var Er in y.beginFormObject = function(t, e, r, n, i) {
        return Br(t, e, r, n, i), this;
    }, y.endFormObject = function(t) {
        return Mr(t), this;
    }, y.doFormObject = function(t, e) {
        var r = zt[Ht[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + r.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ht[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? (l(We(He()), t), "function" == typeof l.unload && n.setTimeout && setTimeout(l.unload, 911), this) : new Promise(function(e, r) {
            try {
                var i = l(We(He()), t);
                "function" == typeof l.unload && n.setTimeout && setTimeout(l.unload, 911), e(i);
            } catch (t) {
                r(t.message);
            }
        });
    }, E.API)E.API.hasOwnProperty(Er) && ("events" === Er && E.API.events.length ? function(t, e) {
        var r, n, i;
        for(i = e.length - 1; -1 !== i; i--)r = e[i][0], n = e[i][1], t.subscribe.apply(t, [
            r
        ].concat("function" == typeof n ? [
            n
        ] : n));
    }(Tt, E.API.events) : y[Er] = E.API[Er]);
    var qr = y.getPageWidth = function(t) {
        return (Rt[t = t || $].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX) / _t;
    }, Dr = y.setPageWidth = function(t, e) {
        Rt[t].mediaBox.topRightX = e * _t + Rt[t].mediaBox.bottomLeftX;
    }, Rr = y.getPageHeight = function(t) {
        return (Rt[t = t || $].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY) / _t;
    }, Tr = y.setPageHeight = function(t, e) {
        Rt[t].mediaBox.topRightY = e * _t + Rt[t].mediaBox.bottomLeftY;
    };
    return y.internal = {
        pdfEscape: Ce,
        getStyle: tr,
        getFont: hr,
        getFontSize: vt,
        getCharSpace: Pr,
        getTextColor: Sr,
        getLineHeight: gr,
        getLineHeightFactor: vr,
        getLineWidth: dr,
        write: ft,
        getHorizontalCoordinate: br,
        getVerticalCoordinate: yr,
        getCoordinateString: wr,
        getVerticalCoordinateString: Nr,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: ne,
        putStream: ie,
        events: Tt,
        scaleFactor: _t,
        pageSize: {
            getWidth: function() {
                return qr($);
            },
            setWidth: function(t) {
                Dr($, t);
            },
            getHeight: function() {
                return Rr($);
            },
            setHeight: function(t) {
                Tr($, t);
            }
        },
        encryptionOptions: m,
        encryption: Ye,
        getEncryptor: Je,
        output: Ve,
        getNumberOfPages: Ee,
        pages: ot,
        out: lt,
        f2: R,
        f3: T,
        getPageInfo: Xe,
        getPageInfoByObjId: Ke,
        getCurrentPageInfo: Ze,
        getPDFVersion: N,
        Point: Cr,
        Rectangle: jr,
        Matrix: Vt,
        hasHotfix: Ge
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return qr($);
        },
        set: function(t) {
            Dr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return Rr($);
        },
        set: function(t) {
            Tr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), ke.call(y, pt), St = "F1", Oe(s, i), Tt.publish("initialized"), y;
}
I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, I.prototype.hexToBytes = function(t) {
    for(var e = [], r = 0; r < t.length; r += 2)e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
    return e.join("");
}, I.prototype.processOwnerPassword = function(t, e) {
    return P(x(e).substr(0, 5), t);
}, I.prototype.encryptor = function(t, e) {
    var r = x(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return P(r, t);
    };
}, j.prototype.equals = function(e) {
    var r, n = "id,objectNumber,equals";
    if (!e || (0, _typeofDefault.default)(e) !== (0, _typeofDefault.default)(this)) return !1;
    var i = 0;
    for(r in this)if (!(n.indexOf(r) >= 0)) {
        if (this.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
        if (this[r] !== e[r]) return !1;
        i++;
    }
    for(r in e)e.hasOwnProperty(r) && n.indexOf(r) < 0 && i--;
    return 0 === i;
}, E.API = {
    events: []
}, E.version = "2.5.2";
var q = E.API, D = 1, R = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, T = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, U = function(t) {
    return t.toFixed(2);
}, z = function(t) {
    return t.toFixed(5);
};
q.__acroform__ = {};
var H = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, W = function(t) {
    return t * D;
}, V = function(t) {
    var e = new ut, r = At.internal.getHeight(t) || 0, n = At.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number(U(n)),
        Number(U(r))
    ], e;
}, G = q.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t |= 1 << e;
}, Y = q.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t &= ~(1 << e);
}, J = q.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return 0 == (t & 1 << e) ? 0 : 1;
}, X = q.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return J(t, e - 1);
}, K = q.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return G(t, e - 1);
}, Z = q.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return Y(t, e - 1);
}, $ = q.__acroform__.calculateCoordinates = function(t, e) {
    var r = e.internal.getHorizontalCoordinate, n = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], c = {};
    return c.lowerLeft_X = r(i) || 0, c.lowerLeft_Y = n(a + s) || 0, c.upperRight_X = r(i + o) || 0, c.upperRight_Y = n(a) || 0, [
        Number(U(c.lowerLeft_X)),
        Number(U(c.lowerLeft_Y)),
        Number(U(c.upperRight_X)),
        Number(U(c.upperRight_Y))
    ];
}, Q = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], r = t._V || t.DV, n = tt(t, r), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + U(n.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(n.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = V(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, tt = function(t, e) {
    var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize, n = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = r, o = At.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = At.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var c = function(e, r, n) {
        if (e + 1 < i.length) {
            var a = r + " " + i[e + 1][0];
            return et(a, t, n).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var u, h, l = et("3", t, a).height, f = t.multiline ? o - a : (o - l) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + et(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((l + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = c(N, v, a), A = y >= i.length - 1;
                if (L && !A) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || A) {
                    if (A) g = N;
                    else if (t.multiline && (l + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((l + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var x = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        x += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        x += _[_.length - 1] + " ";
                        continue;
                    }
                }
                x += _[0] + " ";
            }
            switch(x = " " == x.substr(x.length - 1) ? x.substr(0, x.length - 1) : x, h = et(x, t, a).width, t.textAlign){
                case "right":
                    u = s - h - 2;
                    break;
                case "center":
                    u = (s - h) / 2;
                    break;
                case "left":
                default:
                    u = 2;
            }
            e += U(u) + " " + U(d) + " Td\n", e += "(" + R(x) + ") Tj\n", e += -U(u) + " 0 Td\n", d = -(a + 2), h = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return n.text = e, n.fontSize = a, n;
}, et = function(t, e, r) {
    var n = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: n,
        fontSize: parseFloat(r),
        charSpace: 0
    }) * parseFloat(r);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: n,
            fontSize: parseFloat(r),
            charSpace: 0
        }) * parseFloat(r) * 1.5,
        width: i
    };
}, rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, nt = function(t, e) {
    var r = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === r.type && t.object === r.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
}, it = function(e, r) {
    for(var n in e)if (e.hasOwnProperty(n)) {
        var i = n, a = e[n];
        r.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, _typeofDefault.default)(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
    }
}, at = function(e, r) {
    if (r.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if (lt.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify(rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new ht, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var r in e)if (e.hasOwnProperty(r)) {
                    var n = e[r];
                    n.objId = void 0, n.hasAnnotation && nt(n, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(r) {
            !function(e, r) {
                var n = !e;
                for(var i in e || (r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $(a.Rect, r)), r.internal.newObjectDeferredBegin(a.objId, !0), a.DA = At.createDefaultAppearanceStream(a), "object" === (0, _typeofDefault.default)(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var c = Q(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + c + ">>"
                        }), r.internal.acroformPlugin.xForms.push(c);
                    }
                    if (a.appearanceStreamContent) {
                        var u = "";
                        for(var h in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(h)) {
                            var l = a.appearanceStreamContent[h];
                            if (u += "/" + h + " ", u += "<<", Object.keys(l).length >= 1 || Array.isArray(l)) {
                                for(var i in l)if (l.hasOwnProperty(i)) {
                                    var f = l[i];
                                    "function" == typeof f && (f = f.call(r, a)), u += "/" + i + " " + f + " ", r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = l) && (f = f.call(r, a)), u += "/" + i + " " + f, r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                            u += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + u + ">>"
                        });
                    }
                    r.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), r.internal.out("endobj");
                }
                n && it(r.internal.acroformPlugin.xForms, r);
            }(r, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, ot = q.__acroform__.arrayToPdfArray = function(e, r, n) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, _typeofDefault.default)(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== r && n && (i = n.internal.getEncryptor(r)), a += "(" + R(i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a += "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
};
var st = function(t, e, r) {
    var n = function(t) {
        return t;
    };
    return void 0 !== e && r && (n = r.internal.getEncryptor(e)), (t = t || "").toString(), t = "(" + R(n(t)) + ")";
}, ct = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
ct.prototype.toString = function() {
    return this.objId + " 0 R";
}, ct.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, ct.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var r in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable) {
        var n = e[r], i = this[n];
        i && (Array.isArray(i) ? t.push({
            key: n,
            value: ot(i, this.objId, this.scope)
        }) : i instanceof ct ? (i.scope = this.scope, t.push({
            key: n,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: n,
            value: i
        }));
    }
    return t;
};
var ut = function() {
    ct.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
H(ut, ct);
var ht = function() {
    ct.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + R(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
H(ht, ct);
var lt = function t() {
    ct.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = K(e, 3) : this.F = Z(e, 3);
        }
    });
    var r = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            r = t;
        }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== n.length) return n;
        },
        set: function(t) {
            n = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[0]) ? 0 : n[0];
        },
        set: function(t) {
            n[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[1]) ? 0 : n[1];
        },
        set: function(t) {
            n[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[2]) ? 0 : n[2];
        },
        set: function(t) {
            n[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[3]) ? 0 : n[3];
        },
        set: function(t) {
            n[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + R(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var c = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return c;
        },
        set: function(t) {
            c = t;
        }
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === u ? 50 / D : u;
        },
        set: function(t) {
            u = t;
        }
    });
    var h = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return h;
        },
        set: function(t) {
            h = t;
        }
    });
    var l = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!l || this instanceof yt || this instanceof Nt)) return st(l, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), l = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof mt == !1 ? st(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof mt == !1 ? "(" === t.substr(0, 1) ? T(t.substr(1, t.length - 2)) : T(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof mt == !0 ? T(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof mt == !0 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof mt == !1 ? st(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof mt == !1 ? "(" === t.substr(0, 1) ? T(t.substr(1, t.length - 2)) : T(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof mt == !0 ? T(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof mt == !0 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 1) : this.Ff = Z(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 2) : this.Ff = Z(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 3) : this.Ff = Z(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                case "left":
                case 0:
                default:
                    m = 0;
            }
        }
    });
};
H(lt, ct);
var ft = function() {
    lt.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return ot(e, this.objId, this.scope);
        },
        set: function(t) {
            var r, n;
            n = [], "string" == typeof (r = t) && (n = function(t, e, r) {
                r || (r = 1);
                for(var n, i = []; n = e.exec(t);)i.push(n[r]);
                return i;
            }(r, /\((.*?)\)/g)), e = n;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, r) {
        for(r = r || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 18) : this.Ff = Z(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = K(this.Ff, 19) : this.Ff = Z(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = K(this.Ff, 20), e.sort()) : this.Ff = Z(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 22) : this.Ff = Z(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 23) : this.Ff = Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 27) : this.Ff = Z(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
H(ft, lt);
var dt = function() {
    ft.call(this), this.fontName = "helvetica", this.combo = !1;
};
H(dt, ft);
var pt = function() {
    dt.call(this), this.combo = !0;
};
H(pt, dt);
var gt = function() {
    pt.call(this), this.edit = !0;
};
H(gt, pt);
var mt = function() {
    lt.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 15) : this.Ff = Z(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 16) : this.Ff = Z(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 17) : this.Ff = Z(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 26) : this.Ff = Z(this.Ff, 26);
        }
    });
    var e, r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(r).length) {
                var e, n = [];
                for(e in n.push("<<"), r)n.push("/" + e + " (" + R(t(r[e])) + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, _typeofDefault.default)(e) && (r = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (r.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + t;
        }
    });
};
H(mt, lt);
var vt = function() {
    mt.call(this), this.pushButton = !0;
};
H(vt, mt);
var bt = function() {
    mt.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
H(bt, mt);
var yt = function() {
    var e, r;
    lt.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    });
    var n, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, r = [];
            for(e in r.push("<<"), i)r.push("/" + e + " (" + R(t(i[e])) + ")");
            return r.push(">>"), r.join("\n");
        },
        set: function(e) {
            "object" === (0, _typeofDefault.default)(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.substr(1, n.length - 1);
        },
        set: function(t) {
            n = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = At.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
H(yt, lt), bt.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var r = this.Kids[e];
        r.appearanceStreamContent = t.createAppearanceStream(r.optionName), r.caption = t.getCA();
    }
}, bt.prototype.createOption = function(t) {
    var e = new yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), xt.call(this.scope, e), e;
};
var wt = function() {
    mt.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = At.CheckBox.createAppearanceStream();
};
H(wt, mt);
var Nt = function() {
    lt.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 13) : this.Ff = Z(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 21) : this.Ff = Z(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 23) : this.Ff = Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 24) : this.Ff = Z(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 25) : this.Ff = Z(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 26) : this.Ff = Z(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
H(Nt, lt);
var Lt = function() {
    Nt.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean(X(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = K(this.Ff, 14) : this.Ff = Z(this.Ff, 14);
        }
    }), this.password = !0;
};
H(Lt, Nt);
var At = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: At.CheckBox.YesNormal
                },
                D: {
                    On: At.CheckBox.YesPushDown,
                    Off: At.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = V(t);
            e.scope = t.scope;
            var r = [], n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = tt(t, t.caption);
            return r.push("0.749023 g"), r.push("0 0 " + U(At.internal.getWidth(t)) + " " + U(At.internal.getHeight(t)) + " re"), r.push("f"), r.push("BMC"), r.push("q"), r.push("0 0 1 rg"), r.push("/" + n + " " + U(a.fontSize) + " Tf " + i), r.push("BT"), r.push(a.text), r.push("ET"), r.push("Q"), r.push("EMC"), e.stream = r.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = V(t);
            e.scope = t.scope;
            var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), i = [], a = At.internal.getHeight(t), o = At.internal.getWidth(t), s = tt(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + U(o) + " " + U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + U(o - 1) + " " + U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + r + " " + U(s.fontSize) + " Tf " + n), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = V(t);
            e.scope = t.scope;
            var r = [];
            return r.push("0.749023 g"), r.push("0 0 " + U(At.internal.getWidth(t)) + " " + U(At.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: At.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = At.RadioButton.Circle.YesNormal, e.D[t] = At.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [], n = At.internal.getWidth(t) <= At.internal.getHeight(t) ? At.internal.getWidth(t) / 4 : At.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = At.internal.Bezier_C, a = Number((n * i).toFixed(5));
                return r.push("q"), r.push("1 0 0 1 " + z(At.internal.getWidth(t) / 2) + " " + z(At.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"), r.push("-" + a + " " + n + " -" + n + " " + a + " -" + n + " 0 c"), r.push("-" + n + " -" + a + " -" + a + " -" + n + " 0 -" + n + " c"), r.push(a + " -" + n + " " + n + " -" + a + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [], n = At.internal.getWidth(t) <= At.internal.getHeight(t) ? At.internal.getWidth(t) / 4 : At.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * At.internal.Bezier_C).toFixed(5)), o = Number((n * At.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + z(At.internal.getWidth(t) / 2) + " " + z(At.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), r.push("0 g"), r.push("q"), r.push("1 0 0 1 " + z(At.internal.getWidth(t) / 2) + " " + z(At.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"), r.push("-" + o + " " + n + " -" + n + " " + o + " -" + n + " 0 c"), r.push("-" + n + " -" + o + " -" + o + " -" + n + " 0 -" + n + " c"), r.push(o + " -" + n + " " + n + " -" + o + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [], n = At.internal.getWidth(t) <= At.internal.getHeight(t) ? At.internal.getWidth(t) / 4 : At.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * At.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + z(At.internal.getWidth(t) / 2) + " " + z(At.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: At.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = At.RadioButton.Cross.YesNormal, e.D[t] = At.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [], n = At.internal.calculateCross(t);
                return r.push("q"), r.push("1 1 " + U(At.internal.getWidth(t) - 2) + " " + U(At.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push(U(n.x1.x) + " " + U(n.x1.y) + " m"), r.push(U(n.x2.x) + " " + U(n.x2.y) + " l"), r.push(U(n.x4.x) + " " + U(n.x4.y) + " m"), r.push(U(n.x3.x) + " " + U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = V(t);
                e.scope = t.scope;
                var r = At.internal.calculateCross(t), n = [];
                return n.push("0.749023 g"), n.push("0 0 " + U(At.internal.getWidth(t)) + " " + U(At.internal.getHeight(t)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + U(At.internal.getWidth(t) - 2) + " " + U(At.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push(U(r.x1.x) + " " + U(r.x1.y) + " m"), n.push(U(r.x2.x) + " " + U(r.x2.y) + " l"), n.push(U(r.x4.x) + " " + U(r.x4.y) + " m"), n.push(U(r.x3.x) + " " + U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = V(t);
                e.scope = t.scope;
                var r = [];
                return r.push("0.749023 g"), r.push("0 0 " + U(At.internal.getWidth(t)) + " " + U(At.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + r;
    }
};
At.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = At.internal.getWidth(t), r = At.internal.getHeight(t), n = Math.min(e, r);
        return {
            x1: {
                x: (e - n) / 2,
                y: (r - n) / 2 + n
            },
            x2: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2
            },
            x3: {
                x: (e - n) / 2,
                y: (r - n) / 2
            },
            x4: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2 + n
            }
        };
    }
}, At.internal.getWidth = function(e) {
    var r = 0;
    return "object" === (0, _typeofDefault.default)(e) && (r = W(e.Rect[2])), r;
}, At.internal.getHeight = function(e) {
    var r = 0;
    return "object" === (0, _typeofDefault.default)(e) && (r = W(e.Rect[3])), r;
};
var xt = q.addField = function(t) {
    if (at(this, t), !(t instanceof lt)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
q.AcroFormChoiceField = ft, q.AcroFormListBox = dt, q.AcroFormComboBox = pt, q.AcroFormEditBox = gt, q.AcroFormButton = mt, q.AcroFormPushButton = vt, q.AcroFormRadioButton = bt, q.AcroFormCheckBox = wt, q.AcroFormTextField = Nt, q.AcroFormPasswordField = Lt, q.AcroFormAppearance = At, q.AcroForm = {
    ChoiceField: ft,
    ListBox: dt,
    ComboBox: pt,
    EditBox: gt,
    Button: mt,
    PushButton: vt,
    RadioButton: bt,
    CheckBox: wt,
    TextField: Nt,
    PasswordField: Lt,
    Appearance: At
}, E.AcroForm = {
    ChoiceField: ft,
    ListBox: dt,
    ComboBox: pt,
    EditBox: gt,
    Button: mt,
    PushButton: vt,
    RadioButton: bt,
    CheckBox: wt,
    TextField: Nt,
    PasswordField: Lt,
    Appearance: At
};
var St = E.AcroForm;
function _t(t) {
    return t.reduce(function(t, e, r) {
        return t[e] = r, t;
    }, {});
}
!function(e) {
    e.__addimage__ = {};
    var r = "UNKNOWN", n = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, i = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var i, a, o, s, c, u = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (x(t)) for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        else for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        return u === r && e !== r && (u = e), u;
    }, a = function t(e) {
        for(var r = this.internal.write, n = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === b.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === b.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency)) {
            for(var o = "", s = 0, c = e.transparency.length; s < c; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var u = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (n({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: u,
            objectId: e.objectId
        }), r("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var h = "/Predictor " + e.predictor + " /Colors 1 /BitsPerComponent " + e.bitsPerComponent + " /Columns " + e.width, l = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: e.bitsPerComponent,
                decodeParameters: h,
                data: e.sMask
            };
            "filter" in e && (l.filter = e.filter), t.call(this, l);
        }
        if (e.colorSpace === b.INDEXED) {
            var f = this.internal.newObject();
            n({
                data: _(new Uint8Array(e.palette)),
                objectId: f
            }), r("endobj");
        }
    }, o = function() {
        var t = this.internal.collections.addImage_images;
        for(var e in t)a.call(this, t[e]);
    }, s = function() {
        var t, e = this.internal.collections.addImage_images, r = this.internal.write;
        for(var n in e)r("/I" + (t = e[n]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", s));
    }, h = function() {
        var t = this.internal.collections.addImage_images;
        return c.call(this), t;
    }, l = function() {
        return Object.keys(this.internal.collections.addImage_images).length;
    }, f = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, d = function(e) {
        return "object" === (0, _typeofDefault.default)(e) && 1 === e.nodeType;
    }, p = function(t, r) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var n = "" + t.getAttribute("src");
            if (0 === n.indexOf("data:image/")) return u(unescape(n).split("base64,").pop());
            var i = e.loadFile(n, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(r){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                case "JPEG":
                case "JPG":
                default:
                    a = "image/jpeg";
            }
            return u(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, g = function(t) {
        var e = this.internal.collections.addImage_images;
        if (e) {
            for(var r in e)if (t === e[r].alias) return e[r];
        }
    }, m = function(t, e, r) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * r.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * r.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * r.width / r.height), 0 === e && (e = t * r.height / r.width), [
            t,
            e
        ];
    }, v = function(t, e, r, n, i, a) {
        var o = m.call(this, r, n, i), s = this.internal.getCoordinateString, c = this.internal.getVerticalCoordinateString, u = h.call(this);
        if (r = o[0], n = o[1], u[i.index] = i, a) {
            a *= Math.PI / 180;
            var l = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(l),
                d(f),
                d(-1 * f),
                d(l),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, b = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var y = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, w = e.__addimage__.sHashCode = function(t) {
        var e, r, n = 0;
        if ("string" == typeof t) for(r = t.length, e = 0; e < r; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
        else if (x(t)) for(r = t.byteLength / 2, e = 0; e < r; e++)n = (n << 5) - n + t[e], n |= 0;
        return n;
    }, N = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, L = e.__addimage__.extractImageFromDataUrl = function(t) {
        var e = (t = t || "").split("base64,"), r = null;
        if (2 === e.length) {
            var n = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);
            Array.isArray(n) && (r = {
                mimeType: n[1],
                charset: n[2],
                data: e[1]
            });
        }
        return r;
    }, A = e.__addimage__.supportsArrayBuffer = function() {
        return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return A() && t instanceof ArrayBuffer;
    };
    var x = e.__addimage__.isArrayBufferView = function(t) {
        return A() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", r = x(t) ? t : new Uint8Array(t), n = 0; n < r.length; n += 8192)e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
        return e;
    };
    e.addImage = function() {
        var e, n, i, a, o, s, u, h, l;
        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], h = arguments[6], l = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], h = arguments[7], l = arguments[8]), "object" === (0, _typeofDefault.default)(e = arguments[0]) && !d(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, h = f.compression || h, l = f.rotation || f.angle || l;
        }
        var p = this.internal.getFilters();
        if (void 0 === h && -1 !== p.indexOf("FlateEncode") && (h = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, h);
        return v.call(this, i, a, o, s, g, l), this;
    };
    var P = function(t, n, a, o) {
        var s, c, u;
        if ("string" == typeof t && i(t) === r) {
            t = unescape(t);
            var h = k(t, !1);
            ("" !== h || void 0 !== (h = e.loadFile(t, !0))) && (t = h);
        }
        if (d(t) && (t = p(t, n)), n = i(t, n), !f(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (u = a) || 0 === u.length) && (a = function(t) {
            return "string" == typeof t || x(t) ? w(t) : x(t.data) ? w(t.data) : null;
        }(t)), (s = g.call(this, a)) || (A() && (t instanceof Uint8Array || "RGBA" === n || (c = t, t = S(t))), s = this["process" + n.toUpperCase()](t, l.call(this), a, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : y.NONE;
        }(o), c)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        var r;
        e = "boolean" != typeof e || e;
        var n, i = "";
        if ("string" == typeof t) {
            n = null !== (r = L(t)) ? r.data : t;
            try {
                i = u(n);
            } catch (t) {
                if (e) throw N(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return i;
    };
    e.getImageProperties = function(t) {
        var n, a, o = "";
        if (d(t) && (t = p(t)), "string" == typeof t && i(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), a = i(t), !f(a)) throw new Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
        if (!A() || t instanceof Uint8Array || (t = S(t)), !(n = this["process" + a.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = a, n;
    };
}(E.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    E.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var r, n, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), c = t.pageContext.annotations, u = !1, h = 0; h < c.length && !u; h++)switch((r = c[h]).type){
                case "link":
                    (e(r.options.url) || e(r.options.pageNumber)) && (u = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    u = !0;
            }
            if (0 != u) {
                this.internal.write("/Annots [");
                for(var l = 0; l < c.length; l++){
                    r = c[l];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(r.type){
                        case "reference":
                            this.internal.write(" " + r.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = r.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y) + "] ") + "/Contents (" + f(m(r.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + a(r.bounds.x + 30) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w + 30) + " " + o(r.bounds.y) + "] ") + " /Parent " + b, r.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y + r.bounds.h) + "] ";
                            var y = r.color || "#000000";
                            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + f(d(r.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (r.options.name) {
                                var w = this.annotations._nameMap[r.options.name];
                                r.options.pageNumber = w.page, r.options.top = w.y;
                            } else r.options.top || (r.options.top = 0);
                            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(r.options.url)) + ") >>";
                            else if (r.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + r.options.top + "]";
                                    break;
                                case "FitV":
                                    r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var N = o(r.options.top);
                                    r.options.left = r.options.left || 0, void 0 === r.options.zoom && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + N + " " + r.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, r, n, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + r),
                h: s(e + n)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, r, n) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== n.maxWidth) {
            a = n.maxWidth;
            var c = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * c);
        } else a = o, i = s;
        return this.text(t, e, r, n), r += .2 * s, "center" === n.align && (e -= o / 2), "right" === n.align && (e -= o), this.link(e, r - s, a, i, n), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}(E.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, r = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, n = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, c = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var u = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var h = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, l = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, n = r, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== n[t.charCodeAt(e)] ? (a++, "number" == typeof (n = n[t.charCodeAt(e)]) && (i += String.fromCharCode(n), n = r, a = 0), e === t.length - 1 && (n = r, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (n = r, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, r) {
        return o(t) ? !1 === a(t) ? -1 : !u(t) || !o(e) && !o(r) || !o(r) && s(e) || s(t) && !o(e) || s(t) && c(e) || s(t) && s(e) ? 0 : h(t) && o(e) && !s(e) && o(r) && u(r) ? 3 : s(t) || !o(r) ? 1 : 2 : -1;
    }, d = function(t) {
        var r = 0, n = 0, i = 0, a = "", s = "", c = "", u = (t = t || "").split("\\s+"), h = [];
        for(r = 0; r < u.length; r += 1){
            for(h.push(""), n = 0; n < u[r].length; n += 1)a = u[r][n], s = u[r][n - 1], c = u[r][n + 1], o(a) ? (i = f(a, s, c), h[r] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : h[r] += a;
            h[r] = l(h[r]);
        }
        return h.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, r = [];
        if (Array.isArray(e)) {
            var n = 0;
            for(r = [], n = 0; n < e.length; n += 1)Array.isArray(e[n]) ? r.push([
                d(e[n][0]),
                e[n][1],
                e[n][2]
            ]) : r.push([
                d(e[n])
            ]);
            t = r;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}(E.API), E.API.autoPrint = function(t) {
    var e;
    switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
        case "javascript":
            this.addJS("print({});");
            break;
        case "non-conform":
        default:
            this.internal.events.subscribe("postPutResources", function() {
                e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
            }), this.internal.events.subscribe("putCatalog", function() {
                this.internal.out("/OpenAction " + e + " 0 R");
            });
    }
    return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var r = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
            }
        });
        var n = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var r;
        if ("2d" !== (t = t || "2d")) return null;
        for(r in e)this.pdf.context2d.hasOwnProperty(r) && (this.pdf.context2d[r] = e[r]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}(E.API), function(e) {
    var r = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, n = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var r = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var n = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var r = (e = e || {}).fontSize || this.getFontSize(), n = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, c = 0, u = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var h = e.maxWidth;
        h > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, h) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(u.splitTextToSize(e, h));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var l = 0; l < t.length; l++)o < (c = this.getStringUnitWidth(t[l], {
            font: n
        }) * r) && (o = c);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * r * this.getLineHeightFactor() - r * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || r;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || r, c = this.internal.__cell__.tableHeaderRow, u = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, u && c && (this.printHeaderRow(t.lineNumber, !0), t.y += c[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === n ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, n, u, h, l) {
        if (i.call(this), !u) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], A = (l = l || {}).autoSize || !1, x = !1 !== l.printHeaders, S = l.css && void 0 !== l.css["font-size"] ? 16 * l.css["font-size"] : l.fontSize || 12, _ = l.margins || Object.assign({
            width: this.getPageWidth()
        }, r), P = "number" == typeof l.padding ? l.padding : 3, k = l.headerBackgroundColor || "#c8c8c8", I = l.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = x, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = I, this.setFontSize(S), null == h) v = m = Object.keys(u[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(h) && "object" === (0, _typeofDefault.default)(h[0])) for(m = h.map(function(t) {
            return t.name;
        }), v = h.map(function(t) {
            return t.prompt || t.name || "";
        }), b = h.map(function(t) {
            return t.align || "left";
        }), f = 0; f < h.length; f += 1)w[h[f].name] = h[f].width * (19.049976 / 25.4);
        else Array.isArray(h) && "string" == typeof h[0] && (v = m = h, b = m.map(function() {
            return "left";
        }));
        if (A || Array.isArray(h) && "string" == typeof h[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = u.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (x) {
            var F = {};
            for(f = 0; f < m.length; f += 1)F[m[f]] = {}, F[m[f]].text = v[f], F[m[f]].align = b[f];
            var C = c.call(this, F, w);
            L = m.map(function(t) {
                return new o(e, n, w[t], C, F[t].text, void 0, F[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var j = h.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < u.length; f += 1){
            "rowStart" in l && l.rowStart instanceof Function && l.rowStart({
                row: f,
                data: u[f]
            }, this);
            var O = c.call(this, u[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = u[f][m[p]];
                "cellStart" in l && l.cellStart instanceof Function && l.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, n, w[m[p]], O, B, f + 2, j[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = n, this;
    };
    var c = function(t, e) {
        var r = this.internal.__cell__.padding, n = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(n) {
            var i = t[n];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[n] - r - r);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * n / i + r + r;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var r;
        if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var c = [], u = 0; u < this.internal.__cell__.tableHeaderRow.length; u += 1){
            r = this.internal.__cell__.tableHeaderRow[u].clone(), e && (r.y = this.internal.__cell__.margins.top || 0, c.push(r)), r.lineNumber = t;
            var h = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, r), this.setTextColor(h);
        }
        c.length > 0 && this.setTableHeaderRow(c), this.setFont(void 0, "normal"), n = !1;
    };
}(E.API);
var Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], It = _t(kt), Ft = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], Ct = _t(Ft);
function jt(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), r = function(t) {
        return Pt[t = t || "normal"] ? t : "normal";
    }(t.style), n = function(t) {
        if (!t) return 400;
        if ("number" == typeof t) return t >= 100 && t <= 900 && t % 100 == 0 ? t : 400;
        if (/^\d00$/.test(t)) return parseInt(t);
        switch(t){
            case "bold":
                return 700;
            case "normal":
            default:
                return 400;
        }
    }(t.weight), i = function(t) {
        return "number" == typeof It[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: r,
        weight: n,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                r,
                n
            ].join(" ")
        }
    };
}
function Ot(t, e, r, n) {
    var i;
    for(i = r; i >= 0 && i < e.length; i += n)if (t[e[i]]) return t[e[i]];
    for(i = r; i >= 0 && i < e.length; i -= n)if (t[e[i]]) return t[e[i]];
}
var Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function Et(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function qt(t, e, r) {
    for(var n = (r = r || {}).defaultFontFamily || "times", i = Object.assign({}, Bt, r.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = jt(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
        o = t[a.family];
        break;
    }
    if (!(o = o || t[n])) throw new Error("Could not find a font-family for the rule '" + Et(a) + "' and default family '" + n + "'.");
    if (o = function(t, e) {
        if (e[t]) return e[t];
        var r = It[t], n = r <= It.normal ? -1 : 1, i = Ot(e, kt, r, n);
        if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
        return i;
    }(a.stretch, o), o = function(t, e) {
        if (e[t]) return e[t];
        for(var r = Pt[t], n = 0; n < r.length; ++n)if (e[r[n]]) return e[r[n]];
        throw new Error("Could not find a matching font-style for " + t);
    }(a.style, o), !(o = function(t, e) {
        if (e[t]) return e[t];
        if (400 === t && e[500]) return e[500];
        if (500 === t && e[400]) return e[400];
        var r = Ct[t], n = Ot(e, Ft, r, t < 400 ? -1 : 1);
        if (!n) throw new Error("Could not find a matching font-weight for value " + t);
        return n;
    }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + Et(a) + "'.");
    return o;
}
function Dt(t) {
    return t.trimLeft();
}
function Rt(t, e) {
    for(var r = 0; r < t.length;){
        if (t.charAt(r) === e) return [
            t.substring(0, r),
            t.substring(r + 1)
        ];
        r += 1;
    }
    return null;
}
function Tt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var Ut, zt, Ht, Wt = [
    "times"
];
!function(e) {
    var r, n, i, o, s, c, u, h, l, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new h, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new c, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new c, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), r = this.internal.f2, n = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, o = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, c = this.internal.Point, u = this.internal.Rectangle, h = this.internal.Matrix, l = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return l.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), l.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return l;
            },
            set: function(t) {
                t instanceof d && (l = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return l.path;
            },
            set: function(t) {
                l.path = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var h = null;
        function f(t, e) {
            if (null === h) {
                var r = function(t) {
                    var e = [];
                    return Object.keys(t).forEach(function(r) {
                        t[r].forEach(function(t) {
                            var n = null;
                            switch(t){
                                case "bold":
                                    n = {
                                        family: r,
                                        weight: "bold"
                                    };
                                    break;
                                case "italic":
                                    n = {
                                        family: r,
                                        style: "italic"
                                    };
                                    break;
                                case "bolditalic":
                                    n = {
                                        family: r,
                                        weight: "bold",
                                        style: "italic"
                                    };
                                    break;
                                case "":
                                case "normal":
                                    n = {
                                        family: r
                                    };
                            }
                            null !== n && (n.ref = {
                                name: r,
                                style: t
                            }, e.push(n));
                        });
                    }), e;
                }(t.getFontList());
                h = function(t) {
                    for(var e = {}, r = 0; r < t.length; ++r){
                        var n = jt(t[r]), i = n.family, a = n.stretch, o = n.style, s = n.weight;
                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = n;
                    }
                    return e;
                }(r.concat(e));
            }
            return h;
        }
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return p;
            },
            set: function(t) {
                h = null, p = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var r = e[1], n = (e[2], e[3]), i = e[4], a = (e[5], e[6]), o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, r, n = [], i = t.trim();
                        if ("" === i) return Wt;
                        if (i in Mt) return [
                            Mt[i]
                        ];
                        for(; "" !== i;){
                            switch(r = null, e = (i = Dt(i)).charAt(0)){
                                case '"':
                                case "'":
                                    r = Rt(i.substring(1), e);
                                    break;
                                default:
                                    r = Tt(i);
                            }
                            if (null === r) return Wt;
                            if (n.push(r[0]), "" !== (i = Dt(r[1])) && "," !== i.charAt(0)) return Wt;
                            i = i.replace(/^,/, "");
                        }
                        return n;
                    }(a);
                    if (this.fontFaces) {
                        var c = qt(f(this.pdf, this.fontFaces), s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: n,
                                style: r
                            };
                        }));
                        this.pdf.setFont(c.ref.name, c.ref.style);
                    } else {
                        var u = "";
                        ("bold" === n || parseInt(n, 10) >= 700 || "bold" === r) && (u = "bold"), "italic" === r && (u += "italic"), 0 === u.length && (u = "normal");
                        for(var h = "", l = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, d = 0; d < s.length; d++){
                            if (void 0 !== this.pdf.internal.getFont(s[d], u, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d];
                                break;
                            }
                            if ("bolditalic" === u && void 0 !== this.pdf.internal.getFont(s[d], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) h = s[d], u = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[d], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d], u = "normal";
                                break;
                            }
                        }
                        if ("" === h) {
                            for(var p = 0; p < s.length; p++)if (l[s[p]]) {
                                h = l[s[p]];
                                break;
                            }
                        }
                        h = "" === h ? "Times" : h, this.pdf.setFont(h, u);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        A.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        A.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw a.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "mt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(t, e);
    }, p.prototype.closePath = function() {
        var e = new c(0, 0), r = 0;
        for(r = this.path.length - 1; -1 !== r; r--)if ("begin" === this.path[r].type && "object" === (0, _typeofDefault.default)(this.path[r + 1]) && "number" == typeof this.path[r + 1].x) {
            e = new c(this.path[r + 1].x, this.path[r + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new c(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw a.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "lt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(r.x, r.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), A.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, r, n) {
        if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e)) throw a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new c(r, n)), o = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "qct",
            x1: o.x,
            y1: o.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new c(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, r, n, i, o) {
        if (isNaN(i) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new c(i, o)), u = this.ctx.transform.applyToPoint(new c(t, e)), h = this.ctx.transform.applyToPoint(new c(r, n));
        this.path.push({
            type: "bct",
            x1: u.x,
            y1: u.y,
            x2: h.x,
            y2: h.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new c(s.x, s.y);
    }, p.prototype.arc = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i)) throw a.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (o = Boolean(o), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new c(t, e));
            t = s.x, e = s.y;
            var u = this.ctx.transform.applyToPoint(new c(0, r)), h = this.ctx.transform.applyToPoint(new c(0, 0));
            r = Math.sqrt(Math.pow(u.x - h.x, 2) + Math.pow(u.y - h.y, 2));
        }
        Math.abs(i - n) >= 2 * Math.PI && (n = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: r,
            startAngle: n,
            endAngle: i,
            counterclockwise: o
        });
    }, p.prototype.arcTo = function(t, e, r, n, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw a.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + n), this.lineTo(t, e + n), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw a.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, n), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw a.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, r, n), this.stroke());
    }, p.prototype.clearRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw a.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, n));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var n = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = n;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, r, n, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, r = 0, n = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new f(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, r = t.substring(2, 3), r += r, n = t.substring(3, 4), n += n) : (e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7)), e = parseInt(e, 16), r = parseInt(r, 16), n = parseInt(n, 16);
            }
        }
        return {
            r: e,
            g: r,
            b: n,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw a.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (n = isNaN(n) ? void 0 : n, !m.call(this)) {
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.strokeText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw a.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            n = isNaN(n) ? void 0 : n;
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw a.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, r = this.pdf.internal.scaleFactor, n = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * n / e.internal.scaleFactor, o = function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        };
        return new o({
            width: i *= Math.round(96 * r / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw a.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var r = new h(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw a.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new h(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw a.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var r = new h(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.transform = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(o)) throw a.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new h(t, e, r, n, i, o);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, r, n, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 1 : n, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new h(t, e, r, n, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, r, n, i, a, o, s, c) {
        var l = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== n && void 0 !== s && (p = s / n, g = c / i, f = l.width / n * s / n, d = l.height / i * c / i), void 0 === a && (a = e, o = r, e = 0, r = 0), void 0 !== n && void 0 === s && (s = n, c = i), void 0 === n && void 0 === s && (s = l.width, c = l.height);
        for(var m, v = this.ctx.transform.decompose(), w = q(v.rotate.shx), A = new h, S = (A = (A = (A = A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a - e * p, o - r * g, n * f, i * d)), _ = y.call(this, S), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
        if (L(P), this.autoPaging) for(var I = P[0], F = P[P.length - 1], C = I; C < F + 1; C++){
            this.pdf.setPage(C);
            var j = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === C ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], E = 1 === C ? 0 : B + (C - 2) * M;
            if (0 !== this.ctx.clip_path.length) {
                var D = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = D;
            }
            var R = JSON.parse(JSON.stringify(S));
            R = N([
                R
            ], this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset)[0];
            var T = (C > I || C < F) && b.call(this);
            T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], j, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", R.x, R.y, R.w, R.h, null, null, w), T && this.pdf.restoreGraphicsState();
        }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function(t, e, r) {
        var n = [];
        e = e || this.pdf.internal.pageSize.width, r = r || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                n.push(Math.floor((t.y + i) / r) + 1);
                break;
            case "arc":
                n.push(Math.floor((t.y + i - t.radius) / r) + 1), n.push(Math.floor((t.y + i + t.radius) / r) + 1);
                break;
            case "qct":
                var a = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                n.push(Math.floor((a.y + i) / r) + 1), n.push(Math.floor((a.y + a.h + i) / r) + 1);
                break;
            case "bct":
                var o = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                n.push(Math.floor((o.y + i) / r) + 1), n.push(Math.floor((o.y + o.h + i) / r) + 1);
                break;
            case "rect":
                n.push(Math.floor((t.y + i) / r) + 1), n.push(Math.floor((t.y + t.h + i) / r) + 1);
        }
        for(var s = 0; s < n.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < n[s];)w.call(this);
        return n;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, r = this.font, n = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = r, this.lineCap = n, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, r) {
        for(var n = 0; n < t.length; n++)switch(t[n].type){
            case "bct":
                t[n].x2 += e, t[n].y2 += r;
            case "qct":
                t[n].x1 += e, t[n].y1 += r;
            case "mt":
            case "lt":
            case "arc":
            default:
                t[n].x += e, t[n].y += r;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, A = function(t, e) {
        for(var r, n, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, c = Math.abs(s * this.ctx.transform.scaleX), u = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), l = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < l.length; d++)if (void 0 !== l[d].x) for(var p = y.call(this, l[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
        if (L(f), this.autoPaging) for(var v = f[0], A = f[f.length - 1], S = v; S < A + 1; S++){
            this.pdf.setPage(S), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = c, this.lineJoin = u;
            var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], I = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], F = 1 === S ? 0 : k + (S - 2) * I;
            if (0 !== this.ctx.clip_path.length) {
                var C = this.path;
                r = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(r, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), x.call(this, t, !0), this.path = C;
            }
            if (n = JSON.parse(JSON.stringify(h)), this.path = N(n, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                var j = (S > v || S < A) && b.call(this);
                j && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, I, null).clip().discardPath()), x.call(this, t, e), j && this.pdf.restoreGraphicsState();
            }
            this.lineWidth = s;
        }
        else this.lineWidth = c, x.call(this, t, e), this.lineWidth = s;
        this.path = h;
    }, x = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var r, n, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var c = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (r = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], c > 0)) {
                            for(; c >= 0; c--)if (!0 !== i[c - 1].close && !0 !== i[c - 1].begin) {
                                i[c - 1].deltas.push(r), i[c - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        r = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "qct":
                        var u = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), h = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), l = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        r = [
                            u - a[o - 1].x,
                            h - a[o - 1].y,
                            l - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            n = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : j.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, A = i[b].start.y;
                O.call(this, i[b].deltas, L, A), g = !0;
            }
            n && k.call(this, n), e && I.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, r = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - r;
            case "top":
                return t + e - r;
            case "hanging":
                return t + e - 2 * r;
            case "middle":
                return t + e / 2 - r;
            case "ideographic":
                return t;
            case "alphabetic":
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, r, n, i, a, o, s, c) {
        for(var u = M.call(this, r, n, i, a), h = 0; h < u.length; h++){
            var l = u[h];
            0 === h && (c ? F.call(this, l.x1 + t, l.y1 + e) : j.call(this, l.x1 + t, l.y1 + e)), B.call(this, t, e, l.x2, l.y2, l.x3, l.y3, l.x4, l.y4);
        }
        s ? I.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, I = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, F = function(t, e) {
        this.pdf.internal.out(n(t) + " " + i(e) + " m");
    }, C = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            case "left":
            case "start":
            default:
                e = "left";
        }
        var r = this.pdf.getTextDimensions(t.text), n = S.call(this, t.y), i = _.call(this, n) - r.h, a = this.ctx.transform.applyToPoint(new c(t.x, n)), o = this.ctx.transform.decompose(), s = new h;
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for(var l, f, d, p = this.ctx.transform.applyToRectangle(new u(t.x, n, r.w, r.h)), g = s.applyToRectangle(new u(t.x, i, r.w, r.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for(var A = v[0], P = v[v.length - 1], k = A; k < P + 1; k++){
            this.pdf.setPage(k);
            var I = 1 === k ? this.posY + this.margin[0] : this.margin[0], F = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], C = this.pdf.internal.pageSize.height - this.margin[2], j = C - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : F + (k - 2) * j;
            if (0 !== this.ctx.clip_path.length) {
                var E = this.path;
                l = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(l, this.posX + this.margin[3], -1 * M + I), x.call(this, "fill", !0), this.path = E;
            }
            var q = N([
                JSON.parse(JSON.stringify(g))
            ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0];
            t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
            var D = "text" !== this.autoPaging;
            if (D || q.y + q.h <= C) {
                if (D || q.y >= I && q.x <= O) {
                    var R = D ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - q.x)[0], T = N([
                        JSON.parse(JSON.stringify(p))
                    ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0], U = D && (k > A || k < P) && b.call(this);
                    U && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, j, null).clip().discardPath()), this.pdf.text(R, T.x, T.y, {
                        angle: t.angle,
                        align: e,
                        renderingMode: t.renderingMode
                    }), U && this.pdf.restoreGraphicsState();
                }
            } else q.y < C && (this.ctx.prevPageLastElemOffset += C - q.y);
            t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        }
        else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
    }, j = function(t, e, r, a) {
        r = r || 0, a = a || 0, this.pdf.internal.out(n(t + r) + " " + i(e + a) + " l");
    }, O = function(t, e, r) {
        return this.pdf.lines(t, e, r, null, null);
    }, B = function(t, e, n, i, a, c, u, h) {
        this.pdf.internal.out([
            r(o(n + t)),
            r(s(i + e)),
            r(o(a + t)),
            r(s(c + e)),
            r(o(u + t)),
            r(s(h + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, r, n) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > r;)e -= i;
        var o = Math.abs(r - e);
        o < i && n && (o = i - o);
        for(var s = [], c = n ? -1 : 1, u = e; o > 1e-5;){
            var h = u + c * Math.min(o, a);
            s.push(E.call(this, t, u, h)), o -= Math.abs(h - u), u = h;
        }
        return s;
    }, E = function(t, e, r) {
        var n = (r - e) / 2, i = t * Math.cos(n), a = t * Math.sin(n), o = i, s = -a, c = o * o + s * s, u = c + o * i + s * a, h = 4 / 3 * (Math.sqrt(2 * c * u) - u) / (o * a - s * i), l = o - h * s, f = s + h * o, d = l, p = -f, g = n + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: l * m - f * v,
            y2: l * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(r),
            y4: t * Math.sin(r)
        };
    }, q = function(t) {
        return 180 * t / Math.PI;
    }, D = function(t, e, r, n, i, a) {
        var o = t + .5 * (r - t), s = e + .5 * (n - e), c = i + .5 * (r - i), h = a + .5 * (n - a), l = Math.min(t, i, o, c), f = Math.max(t, i, o, c), d = Math.min(e, a, s, h), p = Math.max(e, a, s, h);
        return new u(l, d, f - l, p - d);
    }, R = function(t, e, r, n, i, a, o, s) {
        var c, h, l, f, d, p, g, m, v, b, y, w, N, L, A = r - t, x = n - e, S = i - r, _ = a - n, P = o - i, k = s - a;
        for(h = 0; h < 41; h++)v = (g = (l = t + (c = h / 40) * A) + c * ((d = r + c * S) - l)) + c * (d + c * (i + c * P - d) - g), b = (m = (f = e + c * x) + c * ((p = n + c * _) - f)) + c * (p + c * (a + c * k - p) - m), 0 == h ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new u(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, r = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== r && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r);
        }
    };
}(E.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var r = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        for(/[^\x00-\xFF]/.test(t), r = [], n = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > n; n += 4)0 !== (a = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (o = (a = ((a = ((a = ((a = (a - (h = a % 85)) / 85) - (u = a % 85)) / 85) - (c = a % 85)) / 85) - (s = a % 85)) / 85) % 85, r.push(o + 33, s + 33, c + 33, u + 33, h + 33)) : r.push(122);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(r, e.length), String.fromCharCode.apply(String, r) + "~>";
    }, n = function(t) {
        var e, r, n, i, a, o = String, s = "length", c = 255, u = "charCodeAt", h = "slice", l = "replace";
        for(t[h](-2), t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"), n = [], i = 0, a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s]; a > i; i += 5)r = 52200625 * (t[u](i) - 33) + 614125 * (t[u](i + 1) - 33) + 7225 * (t[u](i + 2) - 33) + 85 * (t[u](i + 3) - 33) + (t[u](i + 4) - 33), n.push(c & r >> 24, c & r >> 16, c & r >> 8, c & r);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(n, e[s]), o.fromCharCode.apply(o, n);
    }, i = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var r = "", n = 0; n < t.length; n += 2)r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
        return r;
    }, a = function(t) {
        for(var r = new Uint8Array(t.length), n = t.length; n--;)r[n] = t.charCodeAt(n);
        return t = (r = (0, _fflate.zlibSync)(r)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var o = 0, s = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), o = 0; o < e.length; o += 1)switch(e[o]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                s = n(s), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                s = r(s), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                s = i(s), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                s = s.split("").map(function(t) {
                    return ("0" + t.charCodeAt().toString(16)).slice(-2);
                }).join("") + ">", c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                s = a(s), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[o] + '" is not implemented');
        }
        return {
            data: s,
            reverseChain: c.reverse().join(" ")
        };
    };
}(E.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, r) {
        return function(t, e, r) {
            e = !1 !== e, r = "function" == typeof r ? r : function() {};
            var n = void 0;
            try {
                n = function(t, e, r) {
                    var n = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, r = [], n = String.fromCharCode;
                        for(i = 0; i < e; i += 1)r.push(n(255 & t.charCodeAt(i)));
                        return r.join("");
                    };
                    if (n.open("GET", t, !e), n.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (n.onload = function() {
                        200 === n.status ? r(a(this.responseText)) : r(void 0);
                    }), n.send(null), e && 200 === n.status) return a(n.responseText);
                }(t, e, r);
            } catch (t) {}
            return n;
        }(t, e, r);
    }, t.loadImageFile = t.loadFile;
}(E.API), function(e) {
    function r() {
        return (n.html2canvas ? Promise.resolve(n.html2canvas) : require("e35ed7d1af132742")).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function i() {
        return (n.DOMPurify ? Promise.resolve(n.DOMPurify) : require("fd4d839f94e36dff")).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var r = (0, _typeofDefault.default)(e);
        return "undefined" === r ? "undefined" : "string" === r || e instanceof String ? "string" : "number" === r || e instanceof Number ? "number" : "function" === r || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === r ? "object" : "unknown";
    }, o = function(t, e) {
        var r = document.createElement(t);
        for(var n in e.className && (r.className = e.className), e.innerHTML && e.dompurify && (r.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)r.style[n] = e.style[n];
        return r;
    }, s = function t(e) {
        var r = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), n = t.convert(Promise.resolve(), r);
        return n = (n = n.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(t, e) {
        return t.__proto__ = e || s.prototype, t;
    }, s.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, s.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t)){
                case "string":
                    return this.then(i).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, s.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, s.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = function t(e, r) {
                for(var n = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== r && 1 === i.nodeType && "SCRIPT" === i.nodeName || n.appendChild(t(i, r));
                return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (n.width = e.width, n.height = e.height, n.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (n.value = e.value), n.addEventListener("load", function() {
                    n.scrollTop = e.scrollTop, n.scrollLeft = e.scrollLeft;
                }, !0)), n;
            }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, s.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = this.opt.jsPDF, r = this.opt.fontFaces, n = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: n,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = r, r) for(var a = 0; a < r.length; ++a){
                var o = r[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, s.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, s.prototype.output = function(t, e, r) {
        return "img" === (r = r || "pdf").toLowerCase() || "image" === r.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, s.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, s.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, s.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, s.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, s.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in s.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, s.prototype.get = function(t, e) {
        return this.then(function() {
            var r = t in s.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(r) : r;
        });
    }, s.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, s.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || E.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, s.prototype.setProgress = function(t, e, r, n) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != r && (this.progress.n = r), null != n && (this.progress.stack = n), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, s.prototype.updateProgress = function(t, e, r, n) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, r ? this.progress.n + r : null, n ? this.progress.stack.concat(n) : null);
    }, s.prototype.then = function(t, e) {
        var r = this;
        return this.thenCore(t, e, function(t, e) {
            return r.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return r.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return r.updateProgress(1), t;
            });
        });
    }, s.prototype.thenCore = function(t, e, r) {
        r = r || Promise.prototype.then;
        t && (t = t.bind(this)), e && (e = e.bind(this));
        var n = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? this : s.convert(Object.assign({}, this), Promise.prototype), i = r.call(n, t, e);
        return s.convert(i, this.__proto__);
    }, s.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, s.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, s.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return s.convert(e, this);
    }, s.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, s.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, E.getPageSize = function(e, r, n) {
        if ("object" === (0, _typeofDefault.default)(e)) {
            var i = e;
            e = i.orientation, r = i.unit || r, n = i.format || n;
        }
        r = r || "mm", n = n || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + n).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(r){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + r;
        }
        var c, u = 0, h = 0;
        if (s.hasOwnProperty(o)) u = s[o][1] / a, h = s[o][0] / a;
        else try {
            u = n[1], h = n[0];
        } catch (t) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === e || "portrait" === e) e = "p", h > u && (c = h, h = u, u = c);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", u > h && (c = h, h = u, u = c);
        }
        return {
            width: h,
            height: u,
            unit: r,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map(jt) : null;
        var r = new s(e);
        return e.worker ? r : r.from(t).doCallback();
    };
}(E.API), E.API.addJS = function(t) {
    return Ht = t, this.internal.events.subscribe("postPutResources", function() {
        Ut = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (Ut + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + Ht + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== Ut && void 0 !== zt && this.internal.out("/Names <</JavaScript " + Ut + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, r = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++){
                var a = n[i], o = r.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var c = this.internal.pages.length, u = [];
                for(i = 0; i < c; i++){
                    var h = t.internal.newObject();
                    u.push(h);
                    var l = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                t.internal.write("<< /Names [ ");
                for(i = 0; i < u.length; i++)t.internal.write("(page_" + (i + 1) + ")" + u[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, r) {
                var n = {
                    title: e,
                    options: r,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(n), n;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var r = 0; r < e.children.length; r++)this.genIds_r(e.children[r]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var r = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < e.children.length; n++){
                    var i = e.children[n];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), n > 0 && this.line("/Prev " + this.makeRef(e.children[n - 1])), n < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[n + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + r(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var r = 0; r < e.children.length; r++)t.count++, this.count_r(t, e.children[r]);
                return t.count;
            };
        }
    ]);
}(E.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, r, n, i, a, o) {
        var s, c = this.decode.DCT_DECODE, u = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, (s = function(t) {
                for(var r, n = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += n, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        r = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: r,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    n = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t)).numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            u = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: c,
                index: r,
                alias: n
            };
        }
        return u;
    };
}(E.API);
var Vt, Gt, Yt, Jt, Xt, Kt = function() {
    var t, e, i;
    function a(t) {
        var e, r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o = null;;){
            switch(e = this.readUInt32(), u = (function() {
                var t, e;
                for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                return e;
            }).call(this).join("")){
                case "IHDR":
                    this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                    break;
                case "acTL":
                    this.animation = {
                        numFrames: this.readUInt32(),
                        numPlays: this.readUInt32() || 1 / 0,
                        frames: []
                    };
                    break;
                case "PLTE":
                    this.palette = this.read(e);
                    break;
                case "fcTL":
                    o && this.animation.frames.push(o), this.pos += 4, o = {
                        width: this.readUInt32(),
                        height: this.readUInt32(),
                        xOffset: this.readUInt32(),
                        yOffset: this.readUInt32()
                    }, a = this.readUInt16(), i = this.readUInt16() || 100, o.delay = 1e3 * a / i, o.disposeOp = this.data[this.pos++], o.blendOp = this.data[this.pos++], o.data = [];
                    break;
                case "IDAT":
                case "fdAT":
                    for("fdAT" === u && (this.pos += 4, e -= 4), t = (null != o ? o.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : f > e; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    switch(this.transparency = {}, this.colorType){
                        case 3:
                            if (n = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > n) throw new Error("More transparent colors than palette size");
                            if ((h = n - this.transparency.indexed.length) > 0) for(d = 0; 0 <= h ? d < h : d > h; 0 <= h ? ++d : --d)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            this.transparency.grayscale = this.read(e)[0];
                            break;
                        case 2:
                            this.transparency.rgb = this.read(e);
                    }
                    break;
                case "tEXt":
                    s = (l = this.read(e)).indexOf(0), c = String.fromCharCode.apply(String, l.slice(0, s)), this.text[c] = String.fromCharCode.apply(String, l.slice(s + 1));
                    break;
                case "IEND":
                    return o && this.animation.frames.push(o), this.colors = (function() {
                        switch(this.colorType){
                            case 0:
                            case 3:
                            case 4:
                                return 1;
                            case 2:
                            case 6:
                                return 3;
                        }
                    }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, r = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * r, this.colorSpace = (function() {
                        switch(this.colors){
                            case 1:
                                return "DeviceGray";
                            case 3:
                                return "DeviceRGB";
                        }
                    }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                default:
                    this.pos += e;
            }
            if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    a.prototype.read = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e)r.push(this.data[this.pos++]);
        return r;
    }, a.prototype.readUInt32 = function() {
        return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.readUInt16 = function() {
        return this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.decodePixels = function(t) {
        var e = this.pixelBitlength / 8, n = new Uint8Array(this.width * this.height * e), i = 0, a = this;
        if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
        function o(r, o, s, c) {
            var u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F = Math.ceil((a.width - r) / s), C = Math.ceil((a.height - o) / c), j = a.width == F && a.height == C;
            for(L = e * F, w = j ? n : new Uint8Array(L * C), p = t.length, N = 0, h = 0; N < C && i < p;){
                switch(t[i++]){
                    case 0:
                        for(f = S = 0; S < L; f = S += 1)w[h++] = t[i++];
                        break;
                    case 1:
                        for(f = _ = 0; _ < L; f = _ += 1)u = t[i++], d = f < e ? 0 : w[h - e], w[h++] = (u + d) % 256;
                        break;
                    case 2:
                        for(f = P = 0; P < L; f = P += 1)u = t[i++], l = (f - f % e) / e, A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (A + u) % 256;
                        break;
                    case 3:
                        for(f = k = 0; k < L; f = k += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (u + Math.floor((d + A) / 2)) % 256;
                        break;
                    case 4:
                        for(f = I = 0; I < L; f = I += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], 0 === N ? A = x = 0 : (A = w[(N - 1) * L + l * e + f % e], x = l && w[(N - 1) * L + (l - 1) * e + f % e]), g = d + A - x, m = Math.abs(g - d), b = Math.abs(g - A), y = Math.abs(g - x), v = m <= b && m <= y ? d : b <= y ? A : x, w[h++] = (u + v) % 256;
                        break;
                    default:
                        throw new Error("Invalid filter algorithm: " + t[i - 1]);
                }
                if (!j) {
                    var O = ((o + N * c) * a.width + r) * e, B = N * L;
                    for(f = 0; f < F; f += 1){
                        for(var M = 0; M < e; M += 1)n[O++] = w[B++];
                        O += (s - 1) * e;
                    }
                }
                N++;
            }
        }
        return t = (0, _fflate.unzlibSync)(t), 1 == a.interlaceMethod ? (o(0, 0, 8, 8), o(4, 0, 8, 8), o(0, 4, 4, 8), o(2, 0, 4, 4), o(0, 2, 2, 4), o(1, 0, 2, 2), o(0, 1, 1, 2)) : o(0, 0, 1, 1), n;
    }, a.prototype.decodePalette = function() {
        var t, e, r, n, i, a, o, s, c;
        for(r = this.palette, a = this.transparency.indexed || [], i = new Uint8Array((a.length || 0) + r.length), n = 0, t = 0, e = o = 0, s = r.length; o < s; e = o += 3)i[n++] = r[e], i[n++] = r[e + 1], i[n++] = r[e + 2], i[n++] = null != (c = a[t++]) ? c : 255;
        return i;
    }, a.prototype.copyToImageData = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f;
        if (n = this.colors, h = null, r = this.hasAlphaChannel, this.palette.length && (h = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), n = 4, r = !0), u = (i = t.data || t).length, o = h || e, a = s = 0, 1 === n) for(; a < u;)c = h ? 4 * e[a / 4] : s, l = o[c++], i[a++] = l, i[a++] = l, i[a++] = l, i[a++] = r ? o[c++] : 255, s = c;
        else for(; a < u;)c = h ? 4 * e[a / 4] : s, i[a++] = o[c++], i[a++] = o[c++], i[a++] = o[c++], i[a++] = r ? o[c++] : 255, s = c;
    }, a.prototype.decode = function() {
        var t;
        return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
    };
    var o = function() {
        if ("[object Window]" === Object.prototype.toString.call(n)) {
            try {
                e = n.document.createElement("canvas"), i = e.getContext("2d");
            } catch (t) {
                return !1;
            }
            return !0;
        }
        return !1;
    };
    return o(), t = function(t) {
        var r;
        if (!0 === o()) return i.width = t.width, i.height = t.height, i.clearRect(0, 0, t.width, t.height), i.putImageData(t, 0, 0), (r = new Image).src = e.toDataURL(), r;
        throw new Error("This method requires a Browser with Canvas-capability.");
    }, a.prototype.decodeFrames = function(e) {
        var r, n, i, a, o, s, c, u;
        if (this.animation) {
            for(u = [], n = o = 0, s = (c = this.animation.frames).length; o < s; n = ++o)r = c[n], i = e.createImageData(r.width, r.height), a = this.decodePixels(new Uint8Array(r.data)), this.copyToImageData(i, a), r.imageData = i, u.push(r.image = t(i));
            return u;
        }
    }, a.prototype.renderFrame = function(t, e) {
        var r, n, i;
        return r = (n = this.animation.frames)[e], i = n[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === r.blendOp && t.clearRect(r.xOffset, r.yOffset, r.width, r.height), t.drawImage(r.image, r.xOffset, r.yOffset);
    }, a.prototype.animate = function(t) {
        var e, r, n, i, a, o, s = this;
        return r = 0, o = this.animation, i = o.numFrames, n = o.frames, a = o.numPlays, (e = function() {
            var o, c;
            if (o = r++ % i, c = n[o], s.renderFrame(t, o), i > 1 && r / i < a) return s.animation._timeout = setTimeout(e, c.delay);
        })();
    }, a.prototype.stopAnimation = function() {
        var t;
        return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
    }, a.prototype.render = function(t) {
        var e, r;
        return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (r = e.createImageData(this.width, this.height), this.copyToImageData(r, this.decodePixels()), e.putImageData(r, 0, 0));
    }, a;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ /**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */ function Zt(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | t[e++] << 8, n = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << (7 & i) + 1;
    t[e++];
    t[e++];
    var s = null, c = null;
    a && (s = e, c = o, e += 3 * o);
    var u = !0, h = [], l = 0, f = null, d = 0, p = null;
    for(this.width = r, this.height = n; u && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    l = t[e++] | t[e++] << 8, f = t[e++], 0 == (1 & g) && (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << (7 & w) + 1, A = s, x = c, S = !1;
            if (w >> 7) {
                S = !0;
                A = e, x = L, e += 3 * L;
            }
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            h.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: A,
                palette_size: x,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: l,
                disposal: d
            });
            break;
        case 59:
            u = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return h.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= h.length) throw new Error("Frame index out of range.");
        return h[t];
    }, this.decodeAndBlitFrameBGRA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = L, n[p++] = N, n[p++] = w, n[p++] = 255;
            }
            --l;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = w, n[p++] = N, n[p++] = L, n[p++] = 255;
            }
            --l;
        }
    };
}
function $t(t, e, r, n) {
    for(var i = t[e++], o = 1 << i, s = o + 1, c = s + 1, u = i + 1, h = (1 << u) - 1, l = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; l < 16 && 0 !== p;)f |= t[e++] << l, l += 8, 1 === p ? p = t[e++] : --p;
        if (l < u) break;
        var v = f & h;
        if (f >>= u, l -= u, v !== o) {
            if (v === s) break;
            for(var b = v < c ? v : m, y = 0, w = b; w > o;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > n) return void a.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = d += y;
            for(b !== v && (r[d++] = N), w = b; y--;)w = g[w], r[--L] = 255 & w, w >>= 8;
            null !== m && c < 4096 && (g[c++] = m << 8 | N, c >= h + 1 && u < 12 && (++u, h = h << 1 | 1)), m = v;
        } else c = s + 1, h = (1 << (u = i + 1)) - 1, m = null;
    }
    return d !== n && a.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function Qt(t) {
    var e, r, n, i, a, o = Math.floor, s = new Array(64), c = new Array(64), u = new Array(64), h = new Array(64), l = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), A = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], x = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], I = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], F = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], C = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function j(t, e) {
        for(var r = 0, n = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[n]] = [], i[e[n]][0] = r, i[e[n]][1] = a, n++, r++;
            r *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], r = t[1] - 1; r >= 0;)e & 1 << r && (m |= 1 << v), r--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function E(t, e, r, n, i) {
        for(var a, o = i[0], s = i[240], c = function(t, e) {
            var r, n, i, a, o, s, c, u, h, l, f = 0;
            for(h = 0; h < 8; ++h){
                r = t[f], n = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], c = t[f + 6];
                var p = r + (u = t[f + 7]), g = r - u, m = n + c, v = n - c, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, A = p - w, x = m + b, S = m - b;
                t[f] = L + x, t[f + 4] = L - x;
                var _ = .707106781 * (S + A);
                t[f + 2] = A + _, t[f + 6] = A - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, I = 1.306562965 * S + P, F = .707106781 * (x = y + v), C = g + F, j = g - F;
                t[f + 5] = j + k, t[f + 3] = j - k, t[f + 1] = C + I, t[f + 7] = C - I, f += 8;
            }
            for(f = 0, h = 0; h < 8; ++h){
                r = t[f], n = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], c = t[f + 48];
                var O = r + (u = t[f + 56]), B = r - u, M = n + c, E = n - c, q = i + s, D = i - s, R = a + o, T = a - o, U = O + R, z = O - R, H = M + q, W = M - q;
                t[f] = U + H, t[f + 32] = U - H;
                var V = .707106781 * (W + z);
                t[f + 16] = z + V, t[f + 48] = z - V;
                var G = .382683433 * ((U = T + D) - (W = E + B)), Y = .5411961 * U + G, J = 1.306562965 * W + G, X = .707106781 * (H = D + E), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(h = 0; h < 64; ++h)l = t[h] * e[h], d[h] = l > 0 ? l + .5 | 0 : l - .5 | 0;
            return d;
        }(t, e), u = 0; u < 64; ++u)p[A[u]] = c[u];
        var h = p[0] - r;
        r = p[0], 0 == h ? O(n[0]) : (O(n[f[a = 32767 + h]]), O(l[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), r;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(l[a]), v++;
        }
        return 63 != g && O(o), r;
    }
    function q(t) {
        (t = Math.min(Math.max(t, 1), 100), a != t) && (!function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], r = 0; r < 64; r++){
                var n = o((e[r] * t + 50) / 100);
                n = Math.min(Math.max(n, 1), 255), s[A[r]] = n;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var l = o((i[a] * t + 50) / 100);
                l = Math.min(Math.max(l, 1), 255), c[A[a]] = l;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)u[d] = 1 / (s[A[d]] * f[p] * f[g] * 8), h[d] = 1 / (c[A[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && q(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(c[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(x[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var r = 0; r < 16; r++)B(_[r + 1]);
            for(var n = 0; n <= 161; n++)B(P[n]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(I[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(F[o + 1]);
            for(var s = 0; s <= 161; s++)B(C[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, l = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, A, j, D, R, T, U, z = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(j = V * G + d, R = -1, T = 0, U = 0; U < 64; U++)D = j + (T = U >> 3) * V + (R = 4 * (7 & U)), G + T >= W && (D -= V * (G + 1 + T - W)), d + R >= V && (D -= d + R - V + 4), p = z[D++], N = z[D++], A = z[D++], b[U] = (L[p] + L[N + 256 >> 0] + L[A + 512 >> 0] >> 16) - 128, y[U] = (L[p + 768 >> 0] + L[N + 1024 >> 0] + L[A + 1280 >> 0] >> 16) - 128, w[U] = (L[p + 1280 >> 0] + L[N + 1536 >> 0] + L[A + 1792 >> 0] >> 16) - 128;
                o = E(b, u, o, e, n), l = E(y, h, l, r, i), f = E(w, h, f, r, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = j(x, S), r = j(k, I), n = j(_, P), i = j(F, C), function() {
        for(var t = 1, e = 2, r = 1; r <= 15; r++){
            for(var n = t; n < e; n++)f[32767 + n] = r, l[32767 + n] = [], l[32767 + n][1] = r, l[32767 + n][0] = n;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = r, l[32767 + i] = [], l[32767 + i][1] = r, l[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 >> 0] = 38470 * t, L[t + 512 >> 0] = 7471 * t + 32768, L[t + 768 >> 0] = -11059 * t, L[t + 1024 >> 0] = -21709 * t, L[t + 1280 >> 0] = 32768 * t + 8421375, L[t + 1536 >> 0] = -27439 * t, L[t + 1792 >> 0] = -5329 * t;
    }(), q(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function te(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function ee(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function r(t, e, r) {
        for(var n = 0; 4 > n; n++)if (t[e + n] != r.charCodeAt(n)) return !0;
        return !1;
    }
    function n(t, e, r, n, i) {
        for(var a = 0; a < i; a++)t[e + a] = r[n + a];
    }
    function i(t, e, r, n) {
        for(var i = 0; i < n; i++)t[e + i] = r;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var r = [], n = 0; n < t; n++)r.push(new e);
        return r;
    }
    function s(t, e) {
        var r = [];
        return function t(r, n, i) {
            for(var a = i[n], o = 0; o < a && (r.push(i.length > n + 1 ? [] : new e), !(i.length < n + 1)); o++)t(r[o], n + 1, i);
        }(r, 0, t), r;
    }
    var c = function() {
        var t = this;
        function c(t, e) {
            for(var r = 1 << e - 1 >>> 0; t & r;)r >>>= 1;
            return r ? (t & r - 1) + r : t;
        }
        function u(t, r, n, i, a) {
            e(!(i % n));
            do t[r + (i -= n)] = a;
            while (0 < i);
        }
        function h(t, r, n, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, r, n, i, o, s) {
                var h, f, d = r, p = 1 << n, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, h = 1; 15 > h; ++h){
                    if (g[h] > 1 << h) return 0;
                    m[h + 1] = m[h] + g[h];
                }
                for(f = 0; f < o; ++f)h = i[f], 0 < i[f] && (s[m[h]++] = f);
                if (1 == m[15]) return (i = new l).g = 0, i.value = s[0], u(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, A = 1 << n;
                for(f = 0, h = 1, o = 2; h <= n; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h])(i = new l).g = h, i.value = s[f++], u(t, d + w, o, A, i), w = c(w, h);
                }
                for(h = n + 1, o = 2; 15 >= h; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h]){
                        if (i = new l, (w & y) != b) {
                            for(d += A, v = 1 << (b = h) - n; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += A = 1 << (v = b - n), t[r + (b = w & y)].g = v + n, t[r + b].value = d - r - b;
                        }
                        i.g = h - n, i.value = s[f++], u(t, d + (w >> n), o, A, i), w = c(w, h);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, r, n, i, o, s);
        }
        function l() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, l), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Dr, f);
        }
        function p(t, r, n, i) {
            e(null != t), e(null != r), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = n, t.Jd = r, t.Yc = n + i, t.Zc = 4 <= i ? n + i - 4 + 1 : n, _(t);
        }
        function g(t, e) {
            for(var r = 0; 0 < e--;)r |= k(t, 128) << e;
            return r;
        }
        function m(t, e) {
            var r = g(t, e);
            return P(t) ? -r : r;
        }
        function v(t, r, n, i) {
            var a, o = 0;
            for(e(null != t), e(null != r), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += r[n + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = r, t.pa = n;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << Ur - 8 >>> 0, ++t.bb, t.u -= 8;
            A(t) && (t.h = 1, t.u = 0);
        }
        function y(t, r) {
            if (e(0 <= r), !t.h && r <= Tr) {
                var n = L(t) & Rr[r];
                return t.u += r, b(t), n;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & Ur - 1) >>> 0;
        }
        function A(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > Ur;
        }
        function x(t, e) {
            t.u = e, t.h = A(t);
        }
        function S(t) {
            t.u >= zr && (e(t.u >= zr), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var r = t.Ca;
            0 > t.b && _(t);
            var n = t.b, i = r * e >>> 8, a = (t.I >>> n > i) + 0;
            for(a ? (r -= i, t.I -= i + 1 << n >>> 0) : r = i + 1, n = r, i = 0; 256 <= n;)i += 8, n >>= 8;
            return n = 7 ^ i + Hr[n], t.b -= n, t.Ca = (r << n) - 1, a;
        }
        function I(t, e, r) {
            t[e + 0] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r >> 0 & 255;
        }
        function F(t, e) {
            return t[e + 0] << 0 | t[e + 1] << 8;
        }
        function C(t, e) {
            return F(t, e) | t[e + 2] << 16;
        }
        function j(t, e) {
            return F(t, e) | F(t, e + 2) << 16;
        }
        function O(t, r) {
            var n = 1 << r;
            return e(null != t), e(0 < r), t.X = a(n), null == t.X ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
        }
        function B(t, r) {
            e(null != t), e(null != r), e(t.Xa == r.Xa), n(r.X, 0, t.X, 0, 1 << r.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function E(t, r, n, i) {
            e(null != n), e(null != i);
            var a = n[0], o = i[0];
            return 0 == a && (a = (t * o + r / 2) / r), 0 == o && (o = (r * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (n[0] = a, i[0] = o, 1);
        }
        function q(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function D(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function R(e, r) {
            t[r] = function(r, n, i, a, o, s, c) {
                var u;
                for(u = 0; u < o; ++u){
                    var h = t[e](s[c + u - 1], i, a + u);
                    s[c + u] = D(r[n + u], h);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function U(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function z(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return z(t + (t - e + .5 >> 1));
        }
        function W(t, e, r) {
            return Math.abs(e - r) - Math.abs(t - r);
        }
        function V(t, e, r, n, i, a, o) {
            for(n = a[o - 1], r = 0; r < i; ++r)a[o + r] = n = D(t[e + r], n);
        }
        function G(t, e, r, n, i) {
            var a;
            for(a = 0; a < r; ++a){
                var o = t[e + a], s = o >> 8 & 255, c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
                n[i + a] = (4278255360 & o) + c >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = t >> 0 & 255, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, r, n, i, a) {
            var o;
            for(o = 0; o < n; ++o){
                var s = e[r + o], c = s >>> 8, u = s, h = 255 & (h = (h = s >>> 16) + ((t.jd << 24 >> 24) * (c << 24 >> 24) >>> 5));
                u = 255 & (u = (u = u + ((t.hd << 24 >> 24) * (c << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (h << 24 >> 24) >>> 5));
                i[a + o] = (4278255360 & s) + (h << 16) + u;
            }
        }
        function X(e, r, n, i, a) {
            t[r] = function(t, e, r, n, o, s, c, u, h) {
                for(n = c; n < u; ++n)for(c = 0; c < h; ++c)o[s++] = a(r[i(t[e++])]);
            }, t[e] = function(e, r, o, s, c, u, h) {
                var l = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > l) for(e = (1 << e.b) - 1, p = (1 << l) - 1; r < o; ++r){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[c++])), u[h++] = a(d[m & p]), m >>= l;
                }
                else t["VP8LMapColor" + n](s, c, d, p, u, h, r, o, f);
            };
        }
        function K(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255;
            }
        }
        function Z(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255, n[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = o >> 0 & 240 | o >> 28 & 15;
                n[i++] = a, n[i++] = o;
            }
        }
        function Q(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                n[i++] = a, n[i++] = o;
            }
        }
        function tt(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 0 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, r, i, a, o) {
            if (0 == o) for(r = e + r; e < r;)I(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else n(i, a, t, e, r);
        }
        function rt(e, r) {
            t[r][0] = t[e + "0"], t[r][1] = t[e + "1"], t[r][2] = t[e + "2"], t[r][3] = t[e + "3"], t[r][4] = t[e + "4"], t[r][5] = t[e + "5"], t[r][6] = t[e + "6"], t[r][7] = t[e + "7"], t[r][8] = t[e + "8"], t[r][9] = t[e + "9"], t[r][10] = t[e + "10"], t[r][11] = t[e + "11"], t[r][12] = t[e + "12"], t[r][13] = t[e + "13"], t[r][14] = t[e + "0"], t[r][15] = t[e + "0"];
        }
        function nt(t) {
            return t == Hn || t == Wn || t == Vn || t == Gn;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ct() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ut(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function ht(t, e) {
            var r = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = vi[e.ba.S], c = t.y, u = t.O, h = t.f, l = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(c, u, null, null, h, l, f, d, h, l, f, d, a, o, null, null, w) : (s(e.ec, e.fc, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w), ++r); b + 2 < y; b += 2)p = h, g = l, m = f, v = d, l += t.Rc, d += t.Rc, o += 2 * i.A, s(c, (u += 2 * t.fa) - t.fa, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w);
            return u += t.fa, t.j + y < t.o ? (n(e.ec, e.fc, c, u, w), n(e.cc, e.dc, h, l, N), n(e.Mc, e.Nc, f, d, N), r--) : 1 & y || s(c, u, null, null, h, l, f, d, h, l, f, d, a, o + i.A, null, null, w), r;
        }
        function lt(t, r, n) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = r.ba.S, c = s == Tn || s == Vn;
                r = r.ba.f.RGBA;
                var u = [
                    0
                ], h = t.ka;
                u[0] = t.T, t.Kb && (0 == h ? --u[0] : (--h, a[0] -= t.width), t.j + t.ka + t.T == t.o && (u[0] = t.o - t.j - h));
                var l = r.eb;
                h = r.fb + h * r.A;
                t = Sn(i, a[0], t.width, o, u, l, h + (c ? 0 : 3), r.A), e(n == u), t && nt(s) && An(l, h, c, o, u, r.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, r = e.ba.S, n = 11 > r, i = r == qn || r == Rn || r == Tn || r == Un || 12 == r || nt(r);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mr(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && nt(r) && br(), t.da) alert("todo:use_scaling");
            else {
                if (n) {
                    if (e.Ib = ut, t.Kb) {
                        if (r = t.U + 1 >> 1, e.memory = a(t.U + 2 * r), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + r, e.Ib = ht, br();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = lt, n && mr());
            }
            if (n && !Ci) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + _i >> Si, Mi[t] = -22014 * (t - 128) + _i, Bi[t] = -45773 * (t - 128), Oi[t] = 113618 * (t - 128) + _i >> Si;
                for(t = Pi; t < ki; ++t)e = 76283 * (t - 16) + _i >> Si, Ei[t - Pi] = Vt(e, 255), qi[t - Pi] = Vt(e + 8 >> 4, 15);
                Ci = 1;
            }
            return 1;
        }
        function dt(t) {
            var r = t.ma, n = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= n || 0 >= i ? 0 : (n = r.Ib(t, r), null != r.Jb && r.Jb(t, r, n), r.Dc += n, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, r, n) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, r[0] = y(t, 14) + 1, n[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var r = t - 2 >> 1;
            return (2 + (1 & t) << r) + y(e, r) + 1;
        }
        function vt(t, e) {
            var r;
            return 120 < e ? e - 120 : 1 <= (r = ((r = $n[e - 1]) >> 4) * t + (8 - (15 & r))) ? r : 1;
        }
        function bt(t, e, r) {
            var n = L(r), i = t[e += 255 & n].g - 8;
            return 0 < i && (x(r, r.u + 8), n = L(r), e += t[e].value, e += n & (1 << i) - 1), x(r, r.u + t[e].g), t[e].value;
        }
        function yt(t, r, n) {
            return n.g += t.g, n.value += t.value << r >>> 0, e(8 >= n.g), t.g;
        }
        function wt(t, r, n) {
            var i = t.xc;
            return e((r = 0 == i ? 0 : t.vc[t.md * (n >> i) + (r >> i)]) < t.Wb), t.Ya[r];
        }
        function Nt(t, r, i, a) {
            var o = t.ab, s = t.c * r, c = t.C;
            r = c + r;
            var u = i, h = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var l = t.gc[o], f = c, d = r, p = u, g = h, m = (h = a, u = i, l.Ea);
                switch(e(f < d), e(d <= l.nc), l.hc){
                    case 2:
                        Gr(p, g, (d - f) * m, h, u);
                        break;
                    case 0:
                        var v = f, b = d, y = h, w = u, N = (_ = l).Ea;
                        0 == v && (Wr(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, A = L - 1, x = q(N, _.b), S = _.K, _ = _.w + (v >> _.b) * x; v < b;){
                            var P = S, k = _, I = 1;
                            for(Vr(p, g, y, w - N, 1, y, w); I < N;){
                                var F = (I & ~A) + L;
                                F > N && (F = N), (0, Zr[P[k++] >> 8 & 15])(p, g + +I, y, w + I - N, F - I, y, w + I), I = F;
                            }
                            g += N, w += N, ++v & A || (_ += x);
                        }
                        d != l.nc && n(h, u - m, h, u + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = l.Ea) - (w = p & ~(y = (g = 1 << l.b) - 1)), v = q(p, l.b), L = l.K, l = l.w + (f >> l.b) * v; f < d;){
                            for(A = L, x = l, S = new T, _ = b + w, P = b + p; b < _;)Y(A[x++], S), $r(S, m, b, g, h, u), b += g, u += g;
                            b < P && (Y(A[x++], S), $r(S, m, b, N, h, u), b += N, u += N), ++f & y || (l += v);
                        }
                        break;
                    case 3:
                        if (p == h && g == u && 0 < l.b) {
                            for(b = h, p = m = u + (d - f) * m - (w = (d - f) * q(l.Ea, l.b)), g = h, y = u, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yr(l, f, d, h, m, h, u);
                        } else Yr(l, f, d, p, g, h, u);
                }
                u = a, h = i;
            }
            h != i && n(a, i, u, h, s);
        }
        function Lt(t, r) {
            var n = t.V, i = t.Ba + t.c * t.C, a = r - t.C;
            if (e(r <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, c = t.Ua, u = o.width;
                if (Nt(t, a, n, i), a = c = [
                    c
                ], e((n = t.C) < (i = r)), e(o.v < o.va), i > o.o && (i = o.o), n < o.j) {
                    var h = o.j - n;
                    n = o.j;
                    a[0] += h * u;
                }
                if (n >= i ? n = 0 : (a[0] += 4 * o.v, o.ka = n - o.j, o.U = o.va - o.v, o.T = i - n, n = 1), n) {
                    if (c = c[0], 11 > (n = t.ca).S) {
                        var l = n.f.RGBA, f = (i = n.S, a = o.U, o = o.T, h = l.eb, l.A), d = o;
                        for(l = l.fb + t.Ma * l.A; 0 < d--;){
                            var p = s, g = c, m = a, v = h, b = l;
                            switch(i){
                                case En:
                                    Qr(p, g, m, v, b);
                                    break;
                                case qn:
                                    tn(p, g, m, v, b);
                                    break;
                                case Hn:
                                    tn(p, g, m, v, b), An(v, b, 0, m, 1, 0);
                                    break;
                                case Dn:
                                    nn(p, g, m, v, b);
                                    break;
                                case Rn:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Wn:
                                    et(p, g, m, v, b, 1), An(v, b, 0, m, 1, 0);
                                    break;
                                case Tn:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Vn:
                                    et(p, g, m, v, b, 0), An(v, b, 1, m, 1, 0);
                                    break;
                                case Un:
                                    en(p, g, m, v, b);
                                    break;
                                case Gn:
                                    en(p, g, m, v, b), xn(v, b, m, 1, 0);
                                    break;
                                case zn:
                                    rn(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            c += u, l += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= n.height);
                }
            }
            t.C = r, e(t.C <= t.i);
        }
        function At(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var r = t.Ya[e].G, n = t.Ya[e].H;
                if (0 < r[1][n[1] + 0].g || 0 < r[2][n[2] + 0].g || 0 < r[3][n[3] + 0].g) return 0;
            }
            return 1;
        }
        function xt(t, r, n, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, c = t.rd;
                for(e(null != mi[t.Z]); r < n; ++r)mi[t.Z](s, c, i, a, i, a, o), s = i, c = a, a += o;
                t.qd = s, t.rd = c;
            }
        }
        function St(t, r) {
            var n = t.l.ma, i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
            i = t.C < i ? i : t.C;
            if (e(r <= t.l.o), r > i) {
                var a = t.l.width, o = n.ca, s = n.tb + a * i, c = t.V, u = t.Ba + t.c * i, h = t.gc;
                e(1 == t.ab), e(3 == h[0].hc), Xr(h[0], i, r, c, u, o, s), xt(n, i, r, o, s, a);
            }
            t.C = t.Ma = r;
        }
        function _t(t, r, n, i, a, o, s) {
            var c = t.$ / i, u = t.$ % i, h = t.m, l = t.s, f = n + t.$, d = f;
            a = n + i * a;
            var p = n + i * o, g = 280 + l.ua, m = t.Pb ? c : 16777216, v = 0 < l.ua ? l.Wa : null, b = l.wc, y = f < p ? wt(l, u, c) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (c >= m) {
                        var _ = f - n;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = c + ti;
                    }
                    if (u & b || (y = wt(l, u, c)), e(null != y), y.Qb && (r[f] = y.qb, w = !0), !w) {
                        if (S(h), y.jc) {
                            N = h, _ = r;
                            var P = f, k = y.pd[L(N) & Dr - 1];
                            e(y.jc), 256 > k.g ? (x(N, N.u + k.g), _[P] = k.value, N = 0) : (x(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], h);
                    }
                    if (h.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) r[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(h), w = bt(y.G[1], y.H[1], h), S(h), _ = bt(y.G[2], y.H[2], h), P = bt(y.G[3], y.H[3], h), h.h) break;
                                r[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++u >= i && (u = 0, ++c, null != s && c <= o && !(c % 16) && s(t, c), null != v)) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, h), _ = bt(y.G[4], y.H[4], h), S(h), _ = vt(i, _ = mt(_, h)), h.h) break;
                        if (f - n < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)r[f + P] = r[f + P - _];
                        for(f += N, u += N; u >= i;)u -= i, ++c, null != s && c <= o && !(c % 16) && s(t, c);
                        if (e(f <= a), u & b && (y = wt(l, u, c)), null != v) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), r[N] = _.X[w], w = !0;
                    }
                    w || e(h.h == A(h));
                }
                if (t.Pb && h.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (h.h) break t;
                    null != s && s(t, c > o ? o : c), t.a = 0, t.$ = f - n;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var r = t.Wa;
            null != r && (r.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new or;
            return null == e ? null : (e.a = 0, e.xb = gi, rt("Predictor", "VP8LPredictors"), rt("Predictor", "VP8LPredictors_C"), rt("PredictorAdd", "VP8LPredictorsAdd"), rt("PredictorAdd", "VP8LPredictorsAdd_C"), Gr = G, $r = J, Qr = K, tn = Z, en = $, rn = Q, nn = tt, t.VP8LMapColor32b = Jr, t.VP8LMapColor8b = Kr, e);
        }
        function It(t, r, n, s, c) {
            var u = 1, f = [
                t
            ], p = [
                r
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (n) for(; u && y(g, 1);){
                    var w = f, N = p, A = s, _ = 1, P = A.m, k = A.gc[A.ab], I = y(P, 2);
                    if (A.Oc & 1 << I) u = 0;
                    else {
                        switch(A.Oc |= 1 << I, k.hc = I, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++A.ab, e(4 >= A.ab), I){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = It(q(k.Ea, k.b), q(k.nc, k.b), 0, A, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var F, C = y(P, 8) + 1, j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                                if (w[0] = q(k.Ea, j), k.b = j, F = _ = It(C, 1, 0, A, k.K)) {
                                    var B, M = C, E = k, R = 1 << (8 >> E.b), T = a(R);
                                    if (null == T) F = 0;
                                    else {
                                        var U = E.K[0], z = E.w;
                                        for(T[0] = E.K[0][0], B = 1; B < 1 * M; ++B)T[B] = D(U[z + B], T[B - 1]);
                                        for(; B < 4 * R; ++B)T[B] = 0;
                                        E.K[0] = null, E.K[0] = T, F = 1;
                                    }
                                }
                                _ = F;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        u = _;
                    }
                }
                if (f = f[0], p = p[0], u && y(g, 1) && !(u = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = u) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = n, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, rt = 0, nt = Qn[K];
                    r: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = q(J, it), ot = q(X, it), st = at * ot;
                            if (!It(at, ot, 0, Y, tt)) break r;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ct = tt[W] >> 8 & 65535;
                                tt[W] = ct, ct >= et && (et = ct + 1);
                            }
                        }
                        if ($.h) break r;
                        for(V = 0; 5 > V; ++V){
                            var ut = Xn[V];
                            !V && 0 < K && (ut += 1 << K), rt < ut && (rt = ut);
                        }
                        var ht = o(et * nt, l), lt = et, ft = o(lt, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= lt), dt = ft;
                        var pt = a(rt);
                        if (null == dt || null == pt || null == ht) {
                            Y.a = 1;
                            break r;
                        }
                        var gt = ht;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ut = Xn[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ut += 1 << K);
                                n: {
                                    var At, xt = ut, St = Y, kt = pt, Ft = gt, Ct = G, jt = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, xt), Bt) {
                                        var Mt = y(Ot, 1) + 1, Et = y(Ot, 1), qt = y(Ot, 0 == Et ? 1 : 8);
                                        kt[qt] = 1, 2 == Mt && (kt[qt = y(Ot, 8)] = 1);
                                        var Dt = 1;
                                    } else {
                                        var Rt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var Ut = 0;
                                            break n;
                                        }
                                        for(At = 0; At < Tt; ++At)Rt[Zn[At]] = y(Ot, 3);
                                        var zt = void 0, Ht = void 0, Wt = St, Vt = Rt, Gt = xt, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, l);
                                        i: for(; h(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((zt = 2 + y(Xt, $t)) > Gt) break i;
                                            } else zt = Gt;
                                            for(Ht = 0; Ht < Gt && zt--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                x(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, re = te - 16, ne = Jn[re], ie = y(Xt, Yn[re]) + ne;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Dt = Jt;
                                    }
                                    (Dt = Dt && !Ot.h) && (jt = h(Ft, Ct, 8, kt, xt)), Dt && 0 != jt ? Ut = jt : (St.a = 3, Ut = 0);
                                }
                                if (0 == Ut) break r;
                                if (Nt && 1 == Kn[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += Ut, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ut; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ce, ue = mt;
                                for(ce = 0; ce < Dr; ++ce){
                                    var he = ce, le = ue.pd[he], fe = ue.G[0][ue.H[0] + he];
                                    256 <= fe.value ? (le.g = fe.g + 256, le.value = fe.value) : (le.g = 0, le.value = 0, he >>= yt(fe, 8, le), he >>= yt(ue.G[1][ue.H[1] + he], 16, le), he >>= yt(ue.G[2][ue.H[2] + he], 0, le), yt(ue.G[3][ue.H[3] + he], 24, le));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = ht, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(u = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, u = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = q(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, n) {
                    s.xb = pi;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, u = 0;
                    break t;
                }
                u = (u = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return u ? (null != c ? c[0] = v : (e(null == v), e(n)), s.$ = 0, n || Pt(m)) : Pt(m), u;
        }
        function Ft(t, r) {
            var n = t.c * t.i, i = n + r + 16 * r;
            return e(t.c <= r), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + n + r, 1);
        }
        function Ct(t, r) {
            var n = t.C, i = r - n, a = t.V, o = t.Ba + t.c * n;
            for(e(r <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, c = t.l.ma, u = t.l.width, h = u * s, l = c.ca, f = c.tb + u * n, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), _n(d, p, l, f, h), xt(c, n, n + s, l, f, u), i -= s, a += s * t.c, n += s;
            }
            e(n == r), t.C = t.Ma = r;
        }
        function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, r, n) {
                    for(var i = n[r], a = 0; a < i && (e.push(n.length > r + 1 ? [] : 0), !(n.length < r + 1)); a++)t(e[a], r + 1, n);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function Et() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function qt() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Dt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Rt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function Ut() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function zt() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Dt), this.Y = 0, this.ya = Array(new Ut), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new jt, this.Kc = new Ot, this.ed = new qt, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new zt, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new Et, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Rt), this.sb = 0, this.wa = Array(new Dt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Dt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
        }
        function Jt(t, e, r) {
            return 0 == t.a && (t.a = e, t.sc = r, t.cb = 0), 0;
        }
        function Xt(t, e, r) {
            return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, r) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == r) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var n = r.data, a = r.w, o = r.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = n[a + 0] | n[a + 1] << 8 | n[a + 2] << 16, c = t.Od;
            if (c.Rb = !(1 & s), c.td = s >> 1 & 7, c.yd = s >> 4 & 1, c.ub = s >> 5, 3 < c.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!c.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var u = t.Kc;
            if (c.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
                u.c = 16383 & (n[a + 4] << 8 | n[a + 3]), u.Td = n[a + 4] >> 6, u.i = 16383 & (n[a + 6] << 8 | n[a + 5]), u.Ud = n[a + 6] >> 6, a += 7, o -= 7, t.za = u.c + 15 >> 4, t.Ub = u.i + 15 >> 4, r.width = u.c, r.height = u.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (c.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, n, a, c.ub), a += c.ub, o -= c.ub, c.Rb && (u.Ld = P(s), u.Kd = P(s)), u = t.Qa;
            var h, l = t.Pa;
            if (e(null != s), e(null != u), u.Cb = P(s), u.Cb) {
                if (u.Bb = P(s), P(s)) {
                    for(u.Fb = P(s), h = 0; 4 > h; ++h)u.Zb[h] = P(s) ? m(s, 7) : 0;
                    for(h = 0; 4 > h; ++h)u.Lb[h] = P(s) ? m(s, 6) : 0;
                }
                if (u.Bb) for(h = 0; 3 > h; ++h)l.jb[h] = P(s) ? g(s, 8) : 255;
            } else u.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((u = t.ed).zd = P(s), u.Tb = g(s, 6), u.wb = g(s, 3), u.Pc = P(s), u.Pc && P(s)) {
                for(l = 0; 4 > l; ++l)P(s) && (u.vd[l] = m(s, 6));
                for(l = 0; 4 > l; ++l)P(s) && (u.od[l] = m(s, 6));
            }
            if (t.L = 0 == u.Tb ? 0 : u.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = h = a, a = h + f, u = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (l = t.Xb)) n = 7;
            else {
                for(h += 3 * l, u -= 3 * l, f = 0; f < l; ++f){
                    var d = n[o + 0] | n[o + 1] << 8 | n[o + 2] << 16;
                    d > u && (d = u), p(t.Jc[+f], n, h, d), h += d, u -= d, o += 3;
                }
                p(t.Jc[+l], n, h, u), n = h < a ? 0 : 5;
            }
            if (0 != n) return Jt(t, n, "cannot parse partitions");
            for(n = g(h = t.m, 7), o = P(h) ? m(h, 4) : 0, a = P(h) ? m(h, 4) : 0, u = P(h) ? m(h, 4) : 0, l = P(h) ? m(h, 4) : 0, h = P(h) ? m(h, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += n);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = n;
                }
                var b = t.pb[d];
                b.Sc[0] = ei[Vt(v + o, 127)], b.Sc[1] = ri[Vt(v + 0, 127)], b.Eb[0] = 2 * ei[Vt(v + a, 127)], b.Eb[1] = 101581 * ri[Vt(v + u, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ei[Vt(v + l, 117)], b.Qc[1] = ri[Vt(v + h, 127)], b.lc = v + h;
            }
            if (!c.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), c = t.Pa, n = 0; 4 > n; ++n){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(u = 0; 11 > u; ++u)l = k(s, ui[n][o][a][u]) ? g(s, 8) : si[n][o][a][u], c.Wc[n][o].Yb[a][u] = l;
                for(o = 0; 17 > o; ++o)c.Xc[n][o] = c.Wc[n][hi[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, r, n, i, a, o) {
            var s = e[i].Yb[r];
            for(r = 0; 16 > i; ++i){
                if (!k(t, s[r + 0])) return i;
                for(; !k(t, s[r + 1]);)if (s = e[++i].Yb[0], r = 0, 16 == i) return 16;
                var c = e[i + 1].Yb;
                if (k(t, s[r + 2])) {
                    var u = t, h = 0;
                    if (k(u, (f = s)[(l = r) + 3])) {
                        if (k(u, f[l + 6])) {
                            for(s = 0, l = 2 * (h = k(u, f[l + 8])) + (f = k(u, f[l + 9 + h])), h = 0, f = ii[l]; f[s]; ++s)h += h + k(u, f[s]);
                            h += 3 + (8 << l);
                        } else k(u, f[l + 7]) ? (h = 7 + 2 * k(u, 165), h += k(u, 145)) : h = 5 + k(u, 159);
                    } else h = k(u, f[l + 4]) ? 3 + k(u, f[l + 5]) : 2;
                    s = c[2];
                } else h = 1, s = c[1];
                c = o + ai[i], 0 > (u = t).b && _(u);
                var l, f = u.b, d = (l = u.Ca >> 1) - (u.I >> f) >> 31;
                --u.b, u.Ca += d, u.Ca |= 1, u.I -= (l + 1 & d) << f, a[c] = ((h ^ d) - d) * n[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, r) {
            if (null == t) return 0;
            if (null == r) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
            if (!t.cb && !Kt(t, r)) return 0;
            if (e(t.cb), null == r.ac || r.ac(r)) {
                r.ob && (t.L = 0);
                var s = Ri[t.L];
                if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - s >> 4, t.zb = r.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + s >> 4, t.Hb = r.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                    var c = t.ed;
                    for(s = 0; 4 > s; ++s){
                        var u;
                        if (t.Qa.Cb) {
                            var h = t.Qa.Lb[s];
                            t.Qa.Fb || (h += c.Tb);
                        } else h = c.Tb;
                        for(u = 0; 1 >= u; ++u){
                            var l = t.gd[s][u], f = h;
                            if (c.Pc && (f += c.vd[0], u && (f += c.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                var d = f;
                                0 < c.wb && (d = 4 < c.wb ? d >> 2 : d >> 1) > 9 - c.wb && (d = 9 - c.wb), 1 > d && (d = 1), l.dd = d, l.tc = 2 * f + d, l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                            } else l.tc = 0;
                            l.La = u;
                        }
                    }
                }
                s = 0;
            } else Jt(t, 6, "Frame setup failed"), s = t.a;
            if (s = 0 == s) {
                if (s) {
                    t.$c = 0, 0 < t.Aa || (t.Ic = Ui);
                    t: {
                        s = t.Ic;
                        c = 4 * (d = t.za);
                        var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                        if ((l = c + 832 + (u = 3 * (16 * s + Ri[t.L]) / 2 * p) + (h = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != l) s = 0;
                        else {
                            if (l > t.Vb) {
                                if (t.Vb = 0, t.Ec = a(l), t.Fc = 0, null == t.Ec) {
                                    s = Jt(t, 1, "no memory during frame initialization.");
                                    break t;
                                }
                                t.Vb = l;
                            }
                            l = t.Ec, f = t.Fc, t.Ac = l, t.Bc = f, f += c, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Rt), t.sb = 1, t.wa = m ? o(m, Dt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = l, t.pc = f, f += 832, t.ya = o(v, Ut), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = l, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += u, t.mb = h ? l : null, t.nb = h ? f : null, e(f + h <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, c), s = 1;
                        }
                    }
                    if (s) {
                        if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !Cn) {
                            for(s = -255; 255 >= s; ++s)Pn[255 + s] = 0 > s ? -s : s;
                            for(s = -1020; 1020 >= s; ++s)kn[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                            for(s = -112; 112 >= s; ++s)In[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                            for(s = -255; 510 >= s; ++s)Fn[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                            Cn = 1;
                        }
                        an = ue, on = ae, cn = oe, un = se, hn = ce, sn = ie, ln = Je, fn = Xe, dn = $e, pn = Qe, gn = Ke, mn = Ze, vn = tr, bn = er, yn = ze, wn = He, Nn = We, Ln = Ve, fi[0] = xe, fi[1] = le, fi[2] = Le, fi[3] = Ae, fi[4] = Se, fi[5] = Pe, fi[6] = _e, fi[7] = ke, fi[8] = Fe, fi[9] = Ie, li[0] = ve, li[1] = de, li[2] = pe, li[3] = ge, li[4] = be, li[5] = ye, li[6] = we, di[0] = Be, di[1] = fe, di[2] = Ce, di[3] = je, di[4] = Ee, di[5] = Me, di[6] = qe, s = 1;
                    } else s = 0;
                }
                s && (s = function(t, r) {
                    for(t.M = 0; t.M < t.Va; ++t.M){
                        var o, s = t.Jc[t.M & t.Xb], c = t.m, u = t;
                        for(o = 0; o < u.za; ++o){
                            var h = c, l = u, f = l.Ac, d = l.Bc + 4 * o, p = l.zc, g = l.ya[l.aa + o];
                            if (l.Qa.Bb ? g.$b = k(h, l.Pa.jb[0]) ? 2 + k(h, l.Pa.jb[2]) : k(h, l.Pa.jb[1]) : g.$b = 0, l.kc && (g.Ad = k(h, l.Bd)), g.Za = !k(h, 145) + 0, g.Za) {
                                var m = g.Ob, v = 0;
                                for(l = 0; 4 > l; ++l){
                                    var b, y = p[0 + l];
                                    for(b = 0; 4 > b; ++b){
                                        y = ci[f[d + b]][y];
                                        for(var w = oi[k(h, y[0])]; 0 < w;)w = oi[2 * w + k(h, y[w])];
                                        y = -w, f[d + b] = y;
                                    }
                                    n(m, v, f, d, 4), v += 4, p[0 + l] = y;
                                }
                            } else y = k(h, 156) ? k(h, 128) ? 1 : 3 : k(h, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                            g.Dd = k(h, 142) ? k(h, 114) ? k(h, 183) ? 1 : 3 : 2 : 0;
                        }
                        if (u.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                        for(; t.ja < t.za; ++t.ja){
                            if (u = s, h = (c = t).rb[c.sb - 1], f = c.rb[c.sb + c.ja], o = c.ya[c.aa + c.ja], d = c.kc ? o.Ad : 0) h.la = f.la = 0, o.Za || (h.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                            else {
                                var N, L;
                                h = f, f = u, d = c.Pa.Xc, p = c.ya[c.aa + c.ja], g = c.pb[p.$b];
                                if (l = p.ad, m = 0, v = c.rb[c.sb - 1], y = b = 0, i(l, m, 0, 384), p.Za) var A = 0, x = d[3];
                                else {
                                    w = a(16);
                                    var S = h.Na + v.Na;
                                    if (S = ni(f, d[1], S, g.Eb, 0, w, 0), h.Na = v.Na = (0 < S) + 0, 1 < S) an(w, 0, l, m);
                                    else {
                                        var _ = w[0] + 3 >> 3;
                                        for(w = 0; 256 > w; w += 16)l[m + w] = _;
                                    }
                                    A = 1, x = d[0];
                                }
                                var P = 15 & h.la, I = 15 & v.la;
                                for(w = 0; 4 > w; ++w){
                                    var F = 1 & I;
                                    for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (F = (S = ni(f, x, S = F + (1 & P), g.Sc, A, l, m)) > A) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                    P >>= 4, I = I >> 1 | F << 7, b = (b << 8 | L) >>> 0;
                                }
                                for(x = P, A = I >> 4, N = 0; 4 > N; N += 2){
                                    for(L = 0, P = h.la >> 4 + N, I = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                        for(F = 1 & I, _ = 0; 2 > _; ++_)S = F + (1 & P), P = P >> 1 | (F = 0 < (S = ni(f, d[2], S, g.Qc, 0, l, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                        P >>= 2, I = I >> 1 | F << 5;
                                    }
                                    y |= L << 4 * N, x |= P << 4 << N, A |= (240 & I) << N;
                                }
                                h.la = x, v.la = A, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                            }
                            if (0 < c.L && (c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za], c.wa[c.Y + c.ja].La |= !d), u.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                        }
                        if ($t(t), c = r, u = 1, o = (s = t).D, h = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) t: {
                            if (o.M = s.M, o.uc = h, Or(s, o), u = 1, o = (L = s.D).Nb, h = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - h + w, g = s.qa, l = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, I = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && Or(s, L), L.uc) for(F = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                A = L, x = F;
                                var C = (j = (U = S).D).Nb;
                                N = U.R;
                                var j = j.wa[j.Y + A], O = U.sa, B = U.ta + 16 * C * N + 16 * A, M = j.dd, E = j.tc;
                                if (0 != E) {
                                    if (e(3 <= E), 1 == U.L) 0 < A && wn(O, B, N, E + 4), j.La && Ln(O, B, N, E), 0 < x && yn(O, B, N, E + 4), j.La && Nn(O, B, N, E);
                                    else {
                                        var q = U.B, D = U.qa, R = U.ra + 8 * C * q + 8 * A, T = U.Ha, U = U.Ia + 8 * C * q + 8 * A;
                                        C = j.ld;
                                        0 < A && (fn(O, B, N, E + 4, M, C), pn(D, R, T, U, q, E + 4, M, C)), j.La && (mn(O, B, N, E, M, C), bn(D, R, T, U, q, E, M, C)), 0 < x && (ln(O, B, N, E + 4, M, C), dn(D, R, T, U, q, E + 4, M, C)), j.La && (gn(O, B, N, E, M, C), vn(D, R, T, U, q, E, M, C));
                                    }
                                }
                            }
                            if (s.ia && alert("todo:DitherRow"), null != c.put) {
                                if (L = 16 * P, P = 16 * (P + 1), I ? (c.y = s.sa, c.O = s.ta + w, c.f = s.qa, c.N = s.ra + _, c.ea = s.Ha, c.W = s.Ia + _) : (L -= y, c.y = d, c.O = p, c.f = g, c.N = l, c.ea = m, c.W = v), b || (P -= y), P > c.o && (P = c.o), c.F = null, c.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (c.J = lr(s, c, L, P - L), c.F = s.mb, null == c.F && 0 == c.F.length)) {
                                    u = Jt(s, 3, "Could not decode alpha data.");
                                    break t;
                                }
                                L < c.j && (y = c.j - L, L = c.j, e(!(1 & y)), c.O += s.R * y, c.N += s.B * (y >> 1), c.W += s.B * (y >> 1), null != c.F && (c.J += c.width * y)), L < P && (c.O += c.v, c.N += c.v >> 1, c.W += c.v >> 1, null != c.F && (c.J += c.v), c.ka = L - c.j, c.U = c.va - c.v, c.T = P - L, u = c.put(c));
                            }
                            o + 1 != s.Ic || b || (n(s.sa, s.ta - h, d, p + 16 * s.R, h), n(s.qa, s.ra - f, g, l + 8 * s.B, f), n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                        }
                        if (!u) return Jt(t, 6, "Output aborted.");
                    }
                    return 1;
                }(t, r)), null != r.bc && r.bc(r), s &= 1;
            }
            return s ? (t.cb = 0, s) : 0;
        }
        function te(t, e, r, n, i) {
            i = t[e + r + 32 * n] + (i >> 3), t[e + r + 32 * n] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function ee(t, e, r, n, i, a) {
            te(t, e, 0, r, n + i), te(t, e, 1, r, n + a), te(t, e, 2, r, n - a), te(t, e, 3, r, n - i);
        }
        function re(t) {
            return (20091 * t >> 16) + t;
        }
        function ne(t, e, r, n) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var c = t[e + 0] + t[e + 8], u = t[e + 0] - t[e + 8], h = (35468 * t[e + 4] >> 16) - re(t[e + 12]), l = re(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = c + l, s[o + 1] = u + h, s[o + 2] = u - h, s[o + 3] = c - l, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)c = (t = s[o + 0] + 4) + s[o + 8], u = t - s[o + 8], h = (35468 * s[o + 4] >> 16) - re(s[o + 12]), te(r, n, 0, 0, c + (l = re(s[o + 4]) + (35468 * s[o + 12] >> 16))), te(r, n, 1, 0, u + h), te(r, n, 2, 0, u - h), te(r, n, 3, 0, c - l), o++, n += 32;
        }
        function ie(t, e, r, n) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = re(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            ee(r, n, 0, i + o, t = re(t[e + 1]), s), ee(r, n, 1, i + a, t, s), ee(r, n, 2, i - a, t, s), ee(r, n, 3, i - o, t, s);
        }
        function ae(t, e, r, n, i) {
            ne(t, e, r, n), i && ne(t, e + 16, r, n + 4);
        }
        function oe(t, e, r, n) {
            on(t, e + 0, r, n, 1), on(t, e + 32, r, n + 128, 1);
        }
        function se(t, e, r, n) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)te(r, n, e, i, t);
        }
        function ce(t, e, r, n) {
            t[e + 0] && un(t, e + 0, r, n), t[e + 16] && un(t, e + 16, r, n + 4), t[e + 32] && un(t, e + 32, r, n + 128), t[e + 48] && un(t, e + 48, r, n + 128 + 4);
        }
        function ue(t, e, r, n) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], c = t[e + 4 + i] + t[e + 8 + i], u = t[e + 4 + i] - t[e + 8 + i], h = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + c, o[8 + i] = s - c, o[4 + i] = h + u, o[12 + i] = h - u;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], c = o[1 + 4 * i] + o[2 + 4 * i], u = o[1 + 4 * i] - o[2 + 4 * i], h = t - o[3 + 4 * i], r[n + 0] = s + c >> 3, r[n + 16] = h + u >> 3, r[n + 32] = s - c >> 3, r[n + 48] = h - u >> 3, n += 64;
        }
        function he(t, e, r) {
            var n, i = e - 32, a = Bn, o = 255 - t[i - 1];
            for(n = 0; n < r; ++n){
                var s, c = a, u = o + t[e - 1];
                for(s = 0; s < r; ++s)t[e + s] = c[u + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            he(t, e, 4);
        }
        function fe(t, e) {
            he(t, e, 8);
        }
        function de(t, e) {
            he(t, e, 16);
        }
        function pe(t, e) {
            var r;
            for(r = 0; 16 > r; ++r)n(t, e + 32 * r, t, e - 32, 16);
        }
        function ge(t, e) {
            var r;
            for(r = 16; 0 < r; --r)i(t, e, t[e - 1], 16), e += 32;
        }
        function me(t, e, r) {
            var n;
            for(n = 0; 16 > n; ++n)i(e, r + 32 * n, t, 16);
        }
        function ve(t, e) {
            var r, n = 16;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r] + t[e + r - 32];
            me(n >> 5, t, e);
        }
        function be(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r];
            me(n >> 4, t, e);
        }
        function ye(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e + r - 32];
            me(n >> 4, t, e);
        }
        function we(t, e) {
            me(128, t, e);
        }
        function Ne(t, e, r) {
            return t + 2 * e + r + 2 >> 2;
        }
        function Le(t, e) {
            var r, i = e - 32;
            i = new Uint8Array([
                Ne(t[i - 1], t[i + 0], t[i + 1]),
                Ne(t[i + 0], t[i + 1], t[i + 2]),
                Ne(t[i + 1], t[i + 2], t[i + 3]),
                Ne(t[i + 2], t[i + 3], t[i + 4])
            ]);
            for(r = 0; 4 > r; ++r)n(t, e + 32 * r, i, 0, i.length);
        }
        function Ae(t, e) {
            var r = t[e - 1], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            I(t, e + 0, 16843009 * Ne(t[e - 1 - 32], r, n)), I(t, e + 32, 16843009 * Ne(r, n, i)), I(t, e + 64, 16843009 * Ne(n, i, a)), I(t, e + 96, 16843009 * Ne(i, a, a));
        }
        function xe(t, e) {
            var r, n = 4;
            for(r = 0; 4 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            for(n >>= 3, r = 0; 4 > r; ++r)i(t, e + 32 * r, n, 4);
        }
        function Se(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 96] = Ne(n, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = Ne(r, n, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, r, n), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = Ne(o, a, r), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = Ne(c, s, o), t[e + 3 + 0] = Ne(u, c, s);
        }
        function _e(t, e) {
            var r = t[e + 1 - 32], n = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = Ne(t[e + 0 - 32], r, n), t[e + 1 + 0] = t[e + 0 + 32] = Ne(r, n, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(n, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, c);
        }
        function Pe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + c + 1 >> 1, t[e + 3 + 0] = c + u + 1 >> 1, t[e + 0 + 96] = Ne(i, n, r), t[e + 0 + 64] = Ne(n, r, a), t[e + 0 + 32] = t[e + 1 + 96] = Ne(r, a, o), t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, c), t[e + 3 + 32] = Ne(s, c, u);
        }
        function ke(t, e) {
            var r = t[e + 0 - 32], n = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], c = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = n + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = Ne(r, n, i), t[e + 1 + 32] = t[e + 0 + 96] = Ne(n, i, a), t[e + 2 + 32] = t[e + 1 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 3 + 64] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, u);
        }
        function Ie(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = n + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = Ne(r, n, i), t[e + 3 + 0] = t[e + 1 + 32] = Ne(n, i, a), t[e + 3 + 32] = t[e + 1 + 64] = Ne(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], c = t[e + 1 - 32], u = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = r + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = n + r + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + n + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = Ne(s, c, u), t[e + 2 + 0] = Ne(o, s, c), t[e + 1 + 0] = t[e + 3 + 32] = Ne(r, o, s), t[e + 1 + 32] = t[e + 3 + 64] = Ne(n, r, o), t[e + 1 + 64] = t[e + 3 + 96] = Ne(i, n, r), t[e + 1 + 96] = Ne(a, i, n);
        }
        function Ce(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)n(t, e + 32 * r, t, e - 32, 8);
        }
        function je(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)i(t, e, t[e - 1], 8), e += 32;
        }
        function Oe(t, e, r) {
            var n;
            for(n = 0; 8 > n; ++n)i(e, r + 32 * n, t, 8);
        }
        function Be(t, e) {
            var r, n = 8;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            Oe(n >> 4, t, e);
        }
        function Me(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32];
            Oe(n >> 3, t, e);
        }
        function Ee(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e - 1 + 32 * r];
            Oe(n >> 3, t, e);
        }
        function qe(t, e) {
            Oe(128, t, e);
        }
        function De(t, e, r) {
            var n = t[e - r], i = t[e + 0], a = 3 * (i - n) + jn[1020 + t[e - 2 * r] - t[e + r]], o = On[112 + (a + 4 >> 3)];
            t[e - r] = Bn[255 + n + On[112 + (a + 3 >> 3)]], t[e + 0] = Bn[255 + i - o];
        }
        function Re(t, e, r, n) {
            var i = t[e + 0], a = t[e + r];
            return Mn[255 + t[e - 2 * r] - t[e - r]] > n || Mn[255 + a - i] > n;
        }
        function Te(t, e, r, n) {
            return 4 * Mn[255 + t[e - r] - t[e + 0]] + Mn[255 + t[e - 2 * r] - t[e + r]] <= n;
        }
        function Ue(t, e, r, n, i) {
            var a = t[e - 3 * r], o = t[e - 2 * r], s = t[e - r], c = t[e + 0], u = t[e + r], h = t[e + 2 * r], l = t[e + 3 * r];
            return 4 * Mn[255 + s - c] + Mn[255 + o - u] > n ? 0 : Mn[255 + t[e - 4 * r] - a] <= i && Mn[255 + a - o] <= i && Mn[255 + o - s] <= i && Mn[255 + l - h] <= i && Mn[255 + h - u] <= i && Mn[255 + u - c] <= i;
        }
        function ze(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n, r, i) && De(t, e + n, r);
        }
        function He(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n * r, 1, i) && De(t, e + n * r, 1);
        }
        function We(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * r, r, n);
        }
        function Ve(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)He(t, e += 4, r, n);
        }
        function Ge(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - 2 * h], f = c[u - h], d = c[u + 0], p = c[u + h], g = c[u + 2 * h], m = 27 * (b = jn[1020 + 3 * (d - f) + jn[1020 + l - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        c[u - 3 * h] = Bn[255 + c[u - 3 * h] + b], c[u - 2 * h] = Bn[255 + l + v], c[u - h] = Bn[255 + f + m], c[u + 0] = Bn[255 + d - m], c[u + h] = Bn[255 + p - v], c[u + 2 * h] = Bn[255 + g - b];
                    }
                }
                e += n;
            }
        }
        function Ye(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - h], f = c[u + 0], d = c[u + h], p = On[112 + ((g = 3 * (f - l)) + 4 >> 3)], g = On[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        c[u - 2 * h] = Bn[255 + c[u - 2 * h] + m], c[u - h] = Bn[255 + l + g], c[u + 0] = Bn[255 + f - p], c[u + h] = Bn[255 + d - m];
                    }
                }
                e += n;
            }
        }
        function Je(t, e, r, n, i, a) {
            Ge(t, e, r, 1, 16, n, i, a);
        }
        function Xe(t, e, r, n, i, a) {
            Ge(t, e, 1, r, 16, n, i, a);
        }
        function Ke(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4 * r, r, 1, 16, n, i, a);
        }
        function Ze(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4, 1, r, 16, n, i, a);
        }
        function $e(t, e, r, n, i, a, o, s) {
            Ge(t, e, i, 1, 8, a, o, s), Ge(r, n, i, 1, 8, a, o, s);
        }
        function Qe(t, e, r, n, i, a, o, s) {
            Ge(t, e, 1, i, 8, a, o, s), Ge(r, n, 1, i, 8, a, o, s);
        }
        function tr(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4 * i, i, 1, 8, a, o, s), Ye(r, n + 4 * i, i, 1, 8, a, o, s);
        }
        function er(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4, 1, i, 8, a, o, s), Ye(r, n + 4, 1, i, 8, a, o, s);
        }
        function rr() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ct, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function nr() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function ir() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function ar() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new l;
        }
        function or() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ar, this.ab = 0, this.gc = o(4, ir), this.Oc = 0;
        }
        function sr() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function cr(t, e, r, n, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + r[n + e] & 255, t = i[a + e];
        }
        function ur(t, e, r, n, i, a, o) {
            var s;
            if (null == t) cr(null, null, r, n, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + r[n + s] & 255;
        }
        function hr(t, e, r, n, i, a, o) {
            if (null == t) cr(null, null, r, n, i, a, o);
            else {
                var s, c = t[e + 0], u = c, h = c;
                for(s = 0; s < o; ++s)u = h + (c = t[e + s]) - u, h = r[n + s] + (-256 & u ? 0 > u ? 0 : 255 : u) & 255, u = c, i[a + s] = h;
            }
        }
        function lr(t, r, i, o) {
            var s = r.width, c = r.o;
            if (e(null != t && null != r), 0 > i || 0 >= o || i + o > c) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var u;
                    if (t.ga = new sr, (u = null == t.ga) || (u = r.width * r.o, e(0 == t.Gb.length), t.Gb = a(u), t.Uc = 0, null == t.Gb ? u = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, u = 1), u = !u), !u) {
                        u = t.ga;
                        var h = t.Fa, l = t.P, f = t.qc, d = t.mb, p = t.nb, g = l + 1, m = f - 1, b = u.l;
                        if (e(null != h && null != d && null != r), mi[0] = null, mi[1] = cr, mi[2] = ur, mi[3] = hr, u.ca = d, u.tb = p, u.c = r.width, u.i = r.height, e(0 < u.c && 0 < u.i), 1 >= f) r = 0;
                        else if (u.$a = h[l + 0] >> 0 & 3, u.Z = h[l + 0] >> 2 & 3, u.Lc = h[l + 0] >> 4 & 3, l = h[l + 0] >> 6 & 3, 0 > u.$a || 1 < u.$a || 4 <= u.Z || 1 < u.Lc || l) r = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = u, b.width = r.width, b.height = r.height, b.Da = r.Da, b.v = r.v, b.va = r.va, b.j = r.j, b.o = r.o, u.$a) t: {
                            e(1 == u.$a), r = kt();
                            e: for(;;){
                                if (null == r) {
                                    r = 0;
                                    break t;
                                }
                                if (e(null != u), u.mc = r, r.c = u.c, r.i = u.i, r.l = u.l, r.l.ma = u, r.l.width = u.c, r.l.height = u.i, r.a = 0, v(r.m, h, g, m), !It(u.c, u.i, 1, r, null)) break e;
                                if (1 == r.ab && 3 == r.gc[0].hc && At(r.s) ? (u.ic = 1, h = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = a(h), r.Ba = 0, null == r.V ? (r.a = 1, r = 0) : r = 1) : (u.ic = 0, r = Ft(r, u.c)), !r) break e;
                                r = 1;
                                break t;
                            }
                            u.mc = null, r = 0;
                        }
                        else r = m >= u.c * u.i;
                        u = !r;
                    }
                    if (u) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = c - i;
                }
                e(null != t.ga), e(i + o <= c);
                t: {
                    if (r = (h = t.ga).c, c = h.l.o, 0 == h.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, l = t.P + 1 + i * r, f = t.mb, d = t.nb + i * r, e(l <= t.P + t.qc), 0 != h.Z) for(e(null != mi[h.Z]), u = 0; u < o; ++u)mi[h.Z](g, m, b, l, f, d, r), g = f, m = d, d += r, l += r;
                        else for(u = 0; u < o; ++u)n(f, d, b, l, r), g = f, m = d, d += r, l += r;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != h.mc), r = i + o, e(null != (u = h.mc)), e(r <= u.i), u.C >= r) r = 1;
                        else if (h.ic || mr(), h.ic) {
                            h = u.V, g = u.Ba, m = u.c;
                            var y = u.i, w = (b = 1, l = u.$ / m, f = u.$ % m, d = u.m, p = u.s, u.$), N = m * y, L = m * r, x = p.wc, _ = w < L ? wt(p, f, l) : null;
                            e(w <= N), e(r <= y), e(At(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & x || (_ = wt(p, f, l)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) h[g + w] = y, ++w, ++f >= m && (f = 0, ++l <= r && !(l % 16) && St(u, l));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)h[g + w + P] = h[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++l <= r && !(l % 16) && St(u, l);
                                        w < L && f & x && (_ = wt(p, f, l));
                                    }
                                    e(d.h == A(d));
                                }
                                St(u, l > r ? r : l);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, u.a = d.h ? 5 : 3) : u.$ = w, r = b;
                        } else r = _t(u, u.V, u.Ba, u.c, u.i, r, Ct);
                        if (!r) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= c && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fr(t, e, r, n, i, a) {
            for(; 0 < i--;){
                var o, s = t, c = e + (r ? 1 : 0), u = t, h = e + (r ? 0 : 3);
                for(o = 0; o < n; ++o){
                    var l = u[h + 4 * o];
                    255 != l && (l *= 32897, s[c + 4 * o + 0] = s[c + 4 * o + 0] * l >> 23, s[c + 4 * o + 1] = s[c + 4 * o + 1] * l >> 23, s[c + 4 * o + 2] = s[c + 4 * o + 2] * l >> 23);
                }
                e += a;
            }
        }
        function dr(t, e, r, n, i) {
            for(; 0 < n--;){
                var a;
                for(a = 0; a < r; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (u = t[e + 2 * a + 1]), c = 4369 * s, u = (240 & u | u >> 4) * c >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * c >> 16 & 240 | (15 & o | o << 4) * c >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & u | s;
                }
                e += i;
            }
        }
        function pr(t, e, r, n, i, a, o, s) {
            var c, u, h = 255;
            for(u = 0; u < i; ++u){
                for(c = 0; c < n; ++c){
                    var l = t[e + c];
                    a[o + 4 * c] = l, h &= l;
                }
                e += r, o += s;
            }
            return 255 != h;
        }
        function gr(t, e, r, n, i) {
            var a;
            for(a = 0; a < i; ++a)r[n + a] = t[e + a] >> 8;
        }
        function mr() {
            An = fr, xn = dr, Sn = pr, _n = gr;
        }
        function vr(r, n, i) {
            t[r] = function(t, r, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[c + 0] | u[h + 0] << 16, A = l[f + 0] | d[p + 0] << 16;
                e(null != t);
                var x = 3 * L + A + 131074 >> 2;
                for(n(t[r + 0], 255 & x, x >> 16, g, m), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + 0], 255 & x, x >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[c + w] | u[h + w] << 16, _ = l[f + w] | d[p + w] << 16, P = L + S + A + _ + 524296, k = P + 2 * (S + A) >> 3;
                    x = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, n(t[r + 2 * w - 1], 255 & x, x >> 16, g, m + (2 * w - 1) * i), n(t[r + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (x = P + A >> 1, L = k + _ >> 1, n(a[o + 2 * w - 1], 255 & x, x >> 16, v, b + (2 * w - 1) * i), n(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, A = _;
                }
                1 & y || (x = 3 * L + A + 131074 >> 2, n(t[r + y - 1], 255 & x, x >> 16, g, m + (y - 1) * i), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + y - 1], 255 & x, x >> 16, v, b + (y - 1) * i)));
            };
        }
        function br() {
            vi[En] = bi, vi[qn] = wi, vi[Dn] = yi, vi[Rn] = Ni, vi[Tn] = Li, vi[Un] = Ai, vi[zn] = xi, vi[Hn] = wi, vi[Wn] = Ni, vi[Vn] = Li, vi[Gn] = Ai;
        }
        function yr(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> Ii;
        }
        function wr(t, e) {
            return yr((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Nr(t, e, r) {
            return yr((19077 * t >> 8) - (6419 * e >> 8) - (13320 * r >> 8) + 8708);
        }
        function Lr(t, e) {
            return yr((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function Ar(t, e, r, n, i) {
            n[i + 0] = wr(t, r), n[i + 1] = Nr(t, e, r), n[i + 2] = Lr(t, e);
        }
        function xr(t, e, r, n, i) {
            n[i + 0] = Lr(t, e), n[i + 1] = Nr(t, e, r), n[i + 2] = wr(t, r);
        }
        function Sr(t, e, r, n, i) {
            var a = Nr(t, e, r);
            e = a << 3 & 224 | Lr(t, e) >> 3, n[i + 0] = 248 & wr(t, r) | a >> 5, n[i + 1] = e;
        }
        function _r(t, e, r, n, i) {
            var a = 240 & Lr(t, e) | 15;
            n[i + 0] = 240 & wr(t, r) | Nr(t, e, r) >> 4, n[i + 1] = a;
        }
        function Pr(t, e, r, n, i) {
            n[i + 0] = 255, Ar(t, e, r, n, i + 1);
        }
        function kr(t, e, r, n, i) {
            xr(t, e, r, n, i), n[i + 3] = 255;
        }
        function Ir(t, e, r, n, i) {
            Ar(t, e, r, n, i), n[i + 3] = 255;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Fr(e, r, n) {
            t[e] = function(t, e, i, a, o, s, c, u, h) {
                for(var l = u + (-2 & h) * n; u != l;)r(t[e + 0], i[a + 0], o[s + 0], c, u), r(t[e + 1], i[a + 0], o[s + 0], c, u + n), e += 2, ++a, ++s, u += 2 * n;
                1 & h && r(t[e + 0], i[a + 0], o[s + 0], c, u);
            };
        }
        function Cr(t, e, r) {
            return 0 == r ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : r;
        }
        function jr(t, e, r, n, i) {
            switch(t >>> 30){
                case 3:
                    on(e, r, n, i, 0);
                    break;
                case 2:
                    sn(e, r, n, i);
                    break;
                case 1:
                    un(e, r, n, i);
            }
        }
        function Or(t, e) {
            var r, a, o = e.M, s = e.Nb, c = t.oc, u = t.pc + 40, h = t.oc, l = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(r = 0; 16 > r; ++r)c[u + 32 * r - 1] = 129;
            for(r = 0; 8 > r; ++r)h[l + 32 * r - 1] = 129, f[d + 32 * r - 1] = 129;
            for(0 < o ? c[u - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129 : (i(c, u - 32 - 1, 127, 21), i(h, l - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(r = -1; 16 > r; ++r)n(c, u + 32 * r - 4, c, u + 32 * r + 12, 4);
                    for(r = -1; 8 > r; ++r)n(h, l + 32 * r - 4, h, l + 32 * r + 4, 4), n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (n(c, u - 32, g[m].y, 0, 16), n(h, l - 32, g[m].f, 0, 8), n(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = c, w = u - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : n(y, w, g[m + 1].y, 0, 4)), r = 0; 4 > r; r++)y[w + 128 + r] = y[w + 256 + r] = y[w + 384 + r] = y[w + 0 + r];
                    for(r = 0; 16 > r; ++r, b <<= 2)y = c, w = u + Di[r], fi[p.Ob[r]](y, w), jr(b, v, 16 * +r, y, w);
                } else if (y = Cr(a, o, p.Ob[0]), li[y](c, u), 0 != b) for(r = 0; 16 > r; ++r, b <<= 2)jr(b, v, 16 * +r, c, u + Di[r]);
                for(r = p.Gc, y = Cr(a, o, p.Dd), di[y](h, l), di[y](f, d), b = v, y = h, w = l, 255 & (p = r >> 0) && (170 & p ? cn(b, 256, y, w) : hn(b, 256, y, w)), p = f, b = d, 255 & (r >>= 8) && (170 & r ? cn(v, 320, p, b) : hn(v, 320, p, b)), o < t.Ub - 1 && (n(g[m].y, 0, c, u + 480, 16), n(g[m].f, 0, h, l + 224, 8), n(g[m].ea, 0, f, d + 224, 8)), r = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + r, b = t.Ha, y = t.Ia + 8 * a + r, r = 0; 16 > r; ++r)n(g, m + r * t.R, c, u + 32 * r, 16);
                for(r = 0; 8 > r; ++r)n(v, p + r * t.B, h, l + 32 * r, 8), n(b, y + r * t.B, f, d + 32 * r, 8);
            }
        }
        function Br(t, n, i, a, o, s, c, u, h) {
            var l = [
                0
            ], f = [
                0
            ], d = 0, p = null != h ? h.kd : 0, g = null != h ? h : new nr;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = n, g.ha = i, n = [
                n
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = n, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !r(t, m[0], "RIFF")) {
                    if (r(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = n, y = i;
                    var A = l, x = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!r(L, b[0], "VP8X")) {
                            if (10 != j(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = j(L, b[0] + 8), P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != A && (A[0] = P), null != x && (x[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != c && (c[0] = b), null != u && (u[0] = 0), c = l[0], m = f[0], d && b && null == h) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !r(t, n[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = n, w = i;
                        var k = g.gb;
                        A = g.na, x = g.P, S = g.Sa;
                        P = 22, e(null != _), e(null != w), L = y[0];
                        var I = w[0];
                        for(e(null != A), e(null != S), A[0] = null, x[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = I, 8 > I) {
                                y = 7;
                                break t;
                            }
                            var F = j(_, L + 4);
                            if (4294967286 < F) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + F + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (I[0] < O) {
                                y = 7;
                                break t;
                            }
                            r(_, L, "ALPH") || (A[0] = _, x[0] = L + 8, S[0] = F), L += O, I -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = n, w = i, A = g.gb[0], x = g.Ja, S = g.xa, _ = y[0], L = !r(k, _, "VP8 "), P = !r(k, _, "VP8L"), e(null != k), e(null != w), e(null != x), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = j(k, _ + 4), 12 <= A && k > A - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        x[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), x[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], n = n[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == u || b || (u[0] = g.xa ? 2 : 1), c = [
                    c
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    u = c, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], A = [
                        0
                    ], v(x = new N, t, n, i), gt(x, w, k, A) ? (null != u && (u[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = A[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    u = m, null == t || 10 > i || !Xt(t, n + 3, i - 3) ? t = 0 : (p = t[n + 0] | t[n + 1] << 8 | t[n + 2] << 16, b = 16383 & (t[n + 7] << 8 | t[n + 6]), t = 16383 & (t[n + 9] << 8 | t[n + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (c && (c[0] = b), u && (u[0] = t), t = 1));
                }
                if (!t) return 3;
                if (c = c[0], m = m[0], d && (l[0] != c || f[0] != m)) return 3;
                null != h && (h[0] = g, h.offset = n - h.w, e(4294967286 > n - h.w), e(h.offset == h.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == h ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = c), null != o && (o[0] = m), 0) : y;
        }
        function Mr(t, e, r) {
            var n = e.width, i = e.height, a = 0, o = 0, s = n, c = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, c = t.bd, a = t.v, o = t.j, 11 > r || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= c || a + s > n || o + c > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + c, e.U = s, e.T = c, e.da = null != t && 0 < t.da, e.da) {
                if (!E(s, c, r = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = r[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * n / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function Er(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function qr(t, e, r, n) {
            if (null == n || 0 >= t || 0 >= e) return 2;
            if (null != r) {
                if (r.Da) {
                    var i = r.cd, o = r.bd, s = -2 & r.v, c = -2 & r.j;
                    if (0 > s || 0 > c || 0 >= i || 0 >= o || s + i > t || c + o > e) return 2;
                    t = i, e = o;
                }
                if (r.da) {
                    if (!E(t, e, i = [
                        r.ib
                    ], o = [
                        r.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            n.width = t, n.height = e;
            t: {
                var u = n.width, h = n.height;
                if (t = n.S, 0 >= u || 0 >= h || !(t >= En && 13 > t)) t = 2;
                else {
                    if (0 >= n.Rd && null == n.sd) {
                        s = o = i = e = 0;
                        var l = (c = u * zi[t]) * h;
                        if (11 > t || (o = (h + 1) / 2 * (e = (u + 1) / 2), 12 == t && (s = (i = u) * h)), null == (h = a(l + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        n.sd = h, 11 > t ? ((u = n.f.RGBA).eb = h, u.fb = 0, u.A = c, u.size = l) : ((u = n.f.kb).y = h, u.O = 0, u.fa = c, u.Fd = l, u.f = h, u.N = 0 + l, u.Ab = e, u.Cd = o, u.ea = h, u.W = 0 + l + o, u.Db = e, u.Ed = o, 12 == t && (u.F = h, u.J = 0 + l + 2 * o), u.Tc = s, u.lb = i);
                    }
                    if (e = 1, i = n.S, o = n.width, s = n.height, i >= En && 13 > i) {
                        if (11 > i) t = n.f.RGBA, e &= (c = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= c >= o * zi[i], e &= null != t.eb;
                        else {
                            t = n.f.kb, c = (o + 1) / 2, l = (s + 1) / 2, u = Math.abs(t.fa);
                            h = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= u * (s - 1) + o <= t.Fd, e &= h * (l - 1) + c <= t.Cd, e = (e &= f * (l - 1) + c <= t.Ed) & u >= o & h >= c & f >= c, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != r && r.fd && (t = Er(n)), t;
        }
        var Dr = 64, Rr = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tr = 24, Ur = 32, zr = 8, Hr = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        R("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, r) {
            return e[r + 0];
        }, t.Predictor3 = function(t, e, r) {
            return e[r + 1];
        }, t.Predictor4 = function(t, e, r) {
            return e[r - 1];
        }, t.Predictor5 = function(t, e, r) {
            return U(U(t, e[r + 1]), e[r + 0]);
        }, t.Predictor6 = function(t, e, r) {
            return U(t, e[r - 1]);
        }, t.Predictor7 = function(t, e, r) {
            return U(t, e[r + 0]);
        }, t.Predictor8 = function(t, e, r) {
            return U(e[r - 1], e[r + 0]);
        }, t.Predictor9 = function(t, e, r) {
            return U(e[r + 0], e[r + 1]);
        }, t.Predictor10 = function(t, e, r) {
            return U(U(t, e[r - 1]), U(e[r + 0], e[r + 1]));
        }, t.Predictor11 = function(t, e, r) {
            var n = e[r + 0];
            return 0 >= W(n >> 24 & 255, t >> 24 & 255, (e = e[r - 1]) >> 24 & 255) + W(n >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(n >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & n, 255 & t, 255 & e) ? n : t;
        }, t.Predictor12 = function(t, e, r) {
            var n = e[r + 0];
            return (z((t >> 24 & 255) + (n >> 24 & 255) - ((e = e[r - 1]) >> 24 & 255)) << 24 | z((t >> 16 & 255) + (n >> 16 & 255) - (e >> 16 & 255)) << 16 | z((t >> 8 & 255) + (n >> 8 & 255) - (e >> 8 & 255)) << 8 | z((255 & t) + (255 & n) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, r) {
            var n = e[r - 1];
            return (H((t = U(t, e[r + 0])) >> 24 & 255, n >> 24 & 255) << 24 | H(t >> 16 & 255, n >> 16 & 255) << 16 | H(t >> 8 & 255, n >> 8 & 255) << 8 | H(t >> 0 & 255, n >> 0 & 255)) >>> 0;
        };
        var Wr = t.PredictorAdd0;
        t.PredictorAdd1 = V, R("Predictor2", "PredictorAdd2"), R("Predictor3", "PredictorAdd3"), R("Predictor4", "PredictorAdd4"), R("Predictor5", "PredictorAdd5"), R("Predictor6", "PredictorAdd6"), R("Predictor7", "PredictorAdd7"), R("Predictor8", "PredictorAdd8"), R("Predictor9", "PredictorAdd9"), R("Predictor10", "PredictorAdd10"), R("Predictor11", "PredictorAdd11"), R("Predictor12", "PredictorAdd12"), R("Predictor13", "PredictorAdd13");
        var Vr = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gr, Yr = t.ColorIndexInverseTransform, Jr = t.MapARGB, Xr = t.VP8LColorIndexInverseTransformAlpha, Kr = t.MapAlpha, Zr = t.VP8LPredictorsAdd = [];
        Zr.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var $r, Qr, tn, en, rn, nn, an, on, sn, cn, un, hn, ln, fn, dn, pn, gn, mn, vn, bn, yn, wn, Nn, Ln, An, xn, Sn, _n, Pn = a(511), kn = a(2041), In = a(225), Fn = a(767), Cn = 0, jn = kn, On = In, Bn = Fn, Mn = Pn, En = 0, qn = 1, Dn = 2, Rn = 3, Tn = 4, Un = 5, zn = 6, Hn = 7, Wn = 8, Vn = 9, Gn = 10, Yn = [
            2,
            3,
            7
        ], Jn = [
            3,
            3,
            11
        ], Xn = [
            280,
            256,
            256,
            256,
            40
        ], Kn = [
            0,
            1,
            1,
            1,
            0
        ], Zn = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], $n = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], Qn = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], ti = 8, ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ri = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ii = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ai = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], oi = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], si = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], ci = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], hi = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], fi = [], di = [], pi = 1, gi = 2, mi = [], vi = [];
        vr("UpsampleRgbLinePair", Ar, 3), vr("UpsampleBgrLinePair", xr, 3), vr("UpsampleRgbaLinePair", Ir, 4), vr("UpsampleBgraLinePair", kr, 4), vr("UpsampleArgbLinePair", Pr, 4), vr("UpsampleRgba4444LinePair", _r, 2), vr("UpsampleRgb565LinePair", Sr, 2);
        var bi = t.UpsampleRgbLinePair, yi = t.UpsampleBgrLinePair, wi = t.UpsampleRgbaLinePair, Ni = t.UpsampleBgraLinePair, Li = t.UpsampleArgbLinePair, Ai = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Si = 16, _i = 1 << Si - 1, Pi = -227, ki = 482, Ii = 6, Fi = (256 << Ii) - 1, Ci = 0, ji = a(256), Oi = a(256), Bi = a(256), Mi = a(256), Ei = a(ki - Pi), qi = a(ki - Pi);
        Fr("YuvToRgbRow", Ar, 3), Fr("YuvToBgrRow", xr, 3), Fr("YuvToRgbaRow", Ir, 4), Fr("YuvToBgraRow", kr, 4), Fr("YuvToArgbRow", Pr, 4), Fr("YuvToRgba4444Row", _r, 2), Fr("YuvToRgb565Row", Sr, 2);
        var Di = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Ti = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ui = 1;
        this.WebPDecodeRGBA = function(t, r, n, i, a) {
            var o = qn, s = new rr, c = new ot;
            s.ba = c, c.S = o, c.width = [
                c.width
            ], c.height = [
                c.height
            ];
            var u = c.width, h = c.height, l = new st;
            if (null == l || null == t) var f = 2;
            else e(null != l), f = Br(t, r, n, l.width, l.height, l.Pd, l.Qd, l.format, null);
            if (0 != f ? u = 0 : (null != u && (u[0] = l.width[0]), null != h && (h[0] = l.height[0]), u = 1), u) {
                c.width = c.width[0], c.height = c.height[0], null != i && (i[0] = c.width), null != a && (a[0] = c.height);
                t: {
                    if (i = new Gt, (a = new nr).data = t, a.w = r, a.ha = n, a.kd = 1, r = [
                        0
                    ], e(null != a), (0 == (t = Br(a.data, a.w, a.ha, null, null, null, r, null, a)) || 7 == t) && r[0] && (t = 4), 0 == (r = t)) {
                        if (e(null != s), i.data = a.data, i.w = a.w + a.offset, i.ha = a.ha - a.offset, i.put = dt, i.ac = ft, i.bc = pt, i.ma = s, a.xa) {
                            if (null == (t = kt())) {
                                s = 1;
                                break t;
                            }
                            if (function(t, r) {
                                var n = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == r) return t.a = 2, 0;
                                    if (t.l = r, t.a = 0, v(t.m, r.data, r.w, r.ha), !gt(t.m, n, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = gi, r.width = n[0], r.height = i[0], !It(n[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, i)) {
                                if (i = 0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    e: {
                                        i = t;
                                        r: for(;;){
                                            if (null == i) {
                                                i = 0;
                                                break e;
                                            }
                                            if (e(null != i.s.yc), e(null != i.s.Ya), e(0 < i.s.Wb), e(null != (n = i.l)), e(null != (a = n.ma)), 0 != i.xb) {
                                                if (i.ca = a.ba, i.tb = a.tb, e(null != i.ca), !Mr(a.Oa, n, Rn)) {
                                                    i.a = 2;
                                                    break r;
                                                }
                                                if (!Ft(i, n.width)) break r;
                                                if (n.da) break r;
                                                if ((n.da || nt(i.ca.S)) && mr(), 11 > i.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != i.ca.f.kb.F && mr()), i.Pb && 0 < i.s.ua && null == i.s.vb.X && !O(i.s.vb, i.s.Wa.Xa)) {
                                                    i.a = 1;
                                                    break r;
                                                }
                                                i.xb = 0;
                                            }
                                            if (!_t(i, i.V, i.Ba, i.c, i.i, n.o, Lt)) break r;
                                            a.Dc = i.Ma, i = 1;
                                            break e;
                                        }
                                        e(0 != i.a), i = 0;
                                    }
                                    i = !i;
                                }
                                i && (r = t.a);
                            } else r = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = a.na, t.P = a.P, t.qc = a.Sa, Kt(t, i)) {
                                if (0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    if (t.Aa = 0, n = s.Oa, e(null != (a = t)), null != n) {
                                        if (0 < (u = 0 > (u = n.Md) ? 0 : 100 < u ? 255 : 255 * u / 100)) {
                                            for(h = l = 0; 4 > h; ++h)12 > (f = a.pb[h]).lc && (f.ia = u * Ti[0 > f.lc ? 0 : f.lc] >> 3), l |= f.ia;
                                            l && (alert("todo:VP8InitRandom"), a.ia = 1);
                                        }
                                        a.Ga = n.Id, 100 < a.Ga ? a.Ga = 100 : 0 > a.Ga && (a.Ga = 0);
                                    }
                                    Qt(t, i) || (r = t.a);
                                }
                            } else r = t.a;
                        }
                        0 == r && null != s.Oa && s.Oa.fd && (r = Er(s.ba));
                    }
                    s = r;
                }
                o = 0 != s ? null : 11 > o ? c.f.RGBA.eb : c.f.kb.y;
            } else o = null;
            return o;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function u(t, e) {
        for(var r = "", n = 0; n < 4; n++)r += String.fromCharCode(t[e++]);
        return r;
    }
    function h(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function l(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new c;
    var f = [
        0
    ], d = [
        0
    ], p = [], g = new c, m = t, v = function(t, e) {
        var r = {}, n = 0, i = !1, a = 0, o = 0;
        if (r.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e, r, n) {
            for(var i = 0; i < n; i++)if (t[e + i] != r.charCodeAt(i)) return !0;
            return !1;
        }(t, e, "RIFF", 4)) {
            var s, c;
            l(t, e += 4);
            for(e += 8; e < t.length;){
                var f = u(t, e), d = l(t, e += 4);
                e += 4;
                var p = d + (1 & d);
                switch(f){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === r.frames[n] && (r.frames[n] = {});
                        (v = r.frames[n]).src_off = i ? o : e - 8, v.src_size = a + d + 8, n++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (v = r.header = {}).feature_flags = t[e];
                        var g = e + 4;
                        v.canvas_width = 1 + h(t, g);
                        g += 3;
                        v.canvas_height = 1 + h(t, g);
                        g += 3;
                        break;
                    case "ALPH":
                        i = !0, a = p + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (v = r.header).bgcolor = l(t, e);
                        g = e + 4;
                        v.loop_count = (s = t)[(c = g) + 0] << 0 | s[c + 1] << 8;
                        g += 2;
                        break;
                    case "ANMF":
                        var m, v;
                        (v = r.frames[n] = {}).offset_x = 2 * h(t, e), e += 3, v.offset_y = 2 * h(t, e), e += 3, v.width = 1 + h(t, e), e += 3, v.height = 1 + h(t, e), e += 3, v.duration = h(t, e), e += 3, m = t[e++], v.dispose = 1 & m, v.blend = m >> 1 & 1;
                }
                "ANMF" != f && (e += p);
            }
            return r;
        }
    }(m, 0);
    v.response = m, v.rgbaoutput = !0, v.dataurl = !1;
    var b = v.header ? v.header : null, y = v.frames ? v.frames : null;
    if (b) {
        b.loop_counter = b.loop_count, f = [
            b.canvas_height
        ], d = [
            b.canvas_width
        ];
        for(var w = 0; w < y.length && 0 != y[w].blend; w++);
    }
    var N = y[0], L = g.WebPDecodeRGBA(m, N.src_off, N.src_size, d, f);
    N.rgba = L, N.imgwidth = d[0], N.imgheight = f[0];
    for(var A = 0; A < d[0] * f[0] * 4; A++)p[A] = L[A];
    return this.width = d, this.height = f, this.data = p, this;
}
!function(t) {
    var r = function() {
        return "function" == typeof (0, _fflate.zlibSync);
    }, n = function(r, n, a, h) {
        var l = 4, f = s;
        switch(h){
            case t.image_compression.FAST:
                l = 1, f = o;
                break;
            case t.image_compression.MEDIUM:
                l = 6, f = c;
                break;
            case t.image_compression.SLOW:
                l = 9, f = u;
        }
        r = i(r, n, a, f);
        var d = (0, _fflate.zlibSync)(r, {
            level: l
        });
        return t.__addimage__.arrayBufferToBinaryString(d);
    }, i = function(t, e, r, n) {
        for(var i, a, o, s = t.length / e, c = new Uint8Array(t.length + s), u = l(), h = 0; h < s; h += 1){
            if (o = h * e, i = t.subarray(o, o + e), n) c.set(n(i, r, a), o + h);
            else {
                for(var d, p = u.length, g = []; d < p; d += 1)g[d] = u[d](i, r, a);
                var m = f(g.concat());
                c.set(g[m], o + h);
            }
            a = i;
        }
        return c;
    }, a = function(t) {
        var e = Array.apply([], t);
        return e.unshift(0), e;
    }, o = function(t, e) {
        var r, n = [], i = t.length;
        n[0] = 1;
        for(var a = 0; a < i; a += 1)r = t[a - e] || 0, n[a + 1] = t[a] - r + 256 & 255;
        return n;
    }, s = function(t, e, r) {
        var n, i = [], a = t.length;
        i[0] = 2;
        for(var o = 0; o < a; o += 1)n = r && r[o] || 0, i[o + 1] = t[o] - n + 256 & 255;
        return i;
    }, c = function(t, e, r) {
        var n, i, a = [], o = t.length;
        a[0] = 3;
        for(var s = 0; s < o; s += 1)n = t[s - e] || 0, i = r && r[s] || 0, a[s + 1] = t[s] + 256 - (n + i >>> 1) & 255;
        return a;
    }, u = function(t, e, r) {
        var n, i, a, o, s = [], c = t.length;
        s[0] = 4;
        for(var u = 0; u < c; u += 1)n = t[u - e] || 0, i = r && r[u] || 0, a = r && r[u - e] || 0, o = h(n, i, a), s[u + 1] = t[u] - o + 256 & 255;
        return s;
    }, h = function(t, e, r) {
        if (t === e && e === r) return t;
        var n = Math.abs(e - r), i = Math.abs(t - r), a = Math.abs(t + e - r - r);
        return n <= i && n <= a ? t : i <= a ? e : r;
    }, l = function() {
        return [
            a,
            o,
            s,
            c,
            u
        ];
    }, f = function(t) {
        var e = t.map(function(t) {
            return t.reduce(function(t, e) {
                return t + Math.abs(e);
            }, 0);
        });
        return e.indexOf(Math.min.apply(null, e));
    };
    t.processPNG = function(e, i, a, o) {
        var s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L = this.decode.FLATE_DECODE, A = "";
        if (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)), this.__addimage__.isArrayBufferView(e)) {
            if (e = (u = new Kt(e)).imgData, c = u.bits, s = u.colorSpace, l = u.colors, -1 !== [
                4,
                6
            ].indexOf(u.colorType)) {
                if (8 === u.bits) {
                    g = (p = 32 == u.pixelBitlength ? new Uint32Array(u.decodePixels().buffer) : 16 == u.pixelBitlength ? new Uint16Array(u.decodePixels().buffer) : new Uint8Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * u.colors), m = new Uint8Array(g);
                    var x, S = u.pixelBitlength - u.bits;
                    for(w = 0, N = 0; w < g; w++){
                        for(y = p[w], x = 0; x < S;)v[N++] = y >>> x & 255, x += u.bits;
                        m[w] = y >>> x & 255;
                    }
                }
                if (16 === u.bits) {
                    g = (p = new Uint32Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * (32 / u.pixelBitlength) * u.colors), m = new Uint8Array(g * (32 / u.pixelBitlength)), b = u.colors > 1, w = 0, N = 0;
                    for(var _ = 0; w < g;)y = p[w++], v[N++] = y >>> 0 & 255, b && (v[N++] = y >>> 16 & 255, y = p[w++], v[N++] = y >>> 0 & 255), m[_++] = y >>> 16 & 255;
                    c = 8;
                }
                o !== t.image_compression.NONE && r() ? (e = n(v, u.width * u.colors, u.colors, o), d = n(m, u.width, 1, o)) : (e = v, d = m, L = void 0);
            }
            if (3 === u.colorType && (s = this.color_spaces.INDEXED, f = u.palette, u.transparency.indexed)) {
                var P = u.transparency.indexed, k = 0;
                for(w = 0, g = P.length; w < g; ++w)k += P[w];
                if ((k /= 255) === g - 1 && -1 !== P.indexOf(0)) h = [
                    P.indexOf(0)
                ];
                else if (k !== g) {
                    for(p = u.decodePixels(), m = new Uint8Array(p.length), w = 0, g = p.length; w < g; w++)m[w] = P[p[w]];
                    d = n(m, u.width, 1);
                }
            }
            var I = function(e) {
                var r;
                switch(e){
                    case t.image_compression.FAST:
                        r = 11;
                        break;
                    case t.image_compression.MEDIUM:
                        r = 13;
                        break;
                    case t.image_compression.SLOW:
                        r = 14;
                        break;
                    default:
                        r = 12;
                }
                return r;
            }(o);
            return L === this.decode.FLATE_DECODE && (A = "/Predictor " + I + " "), A += "/Colors " + l + " /BitsPerComponent " + c + " /Columns " + u.width, (this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) && (e = this.__addimage__.arrayBufferToBinaryString(e)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), {
                alias: a,
                data: e,
                index: i,
                filter: L,
                decodeParameters: A,
                transparency: h,
                palette: f,
                sMask: d,
                predictor: I,
                width: u.width,
                height: u.height,
                bitsPerComponent: c,
                colorSpace: s
            };
        }
    };
}(E.API), function(t) {
    t.processGIF89A = function(e, r, n, i) {
        var a = new Zt(e), o = a.width, s = a.height, c = [];
        a.decodeAndBlitFrameRGBA(0, c);
        var u = {
            data: c,
            width: o,
            height: s
        }, h = new Qt(100).encode(u, 100);
        return t.processJPEG.call(this, h, r, n, i);
    }, t.processGIF87A = t.processGIF89A;
}(E.API), te.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: n,
                blue: r,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, te.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (t) {
        a.log("bit decode error:" + t);
    }
}, te.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), r = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var n = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var c = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== r && (this.pos += 4 - r);
    }
}, te.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 2 * i * 4, s = a >> 4, c = 15 & a, u = this.palette[s];
            if (this.data[o] = u.blue, this.data[o + 1] = u.green, this.data[o + 2] = u.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            u = this.palette[c], this.data[o + 4] = u.blue, this.data[o + 4 + 1] = u.green, this.data[o + 4 + 2] = u.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, te.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++){
            var i = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 4 * n;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, te.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, c = (a >> 10 & e) / e * 255 | 0, u = a >> 15 ? 255 : 0, h = n * this.width * 4 + 4 * i;
            this.data[h] = c, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = u;
        }
        this.pos += t;
    }
}, te.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = parseInt("111111", 2), n = this.height - 1; n >= 0; n--){
        for(var i = this.bottom_up ? n : this.height - 1 - n, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, c = (o >> 5 & r) / r * 255 | 0, u = (o >> 11) / e * 255 | 0, h = i * this.width * 4 + 4 * a;
            this.data[h] = u, this.data[h + 1] = c, this.data[h + 2] = s, this.data[h + 3] = 255;
        }
        this.pos += t;
    }
}, te.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
            var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * r;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = n, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, te.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
        var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * r;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = n, this.data[s + 3] = o;
    }
}, te.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, r, n, i) {
        var a = new te(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}(E.API), ee.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, r, n, i) {
        var a = new ee(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}(E.API), E.API.processRGBA = function(t, e, r) {
    for(var n = t.data, i = n.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, c = 0, u = 0; u < i; u += 4){
        var h = n[u], l = n[u + 1], f = n[u + 2], d = n[u + 3];
        a[s++] = h, a[s++] = l, a[s++] = f, o[c++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: r,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, E.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, Vt = E.API, Gt = Vt.getCharWidthsArray = function(e, r) {
    var n, i, a = (r = r || {}).font || this.internal.getFont(), o = r.fontSize || this.internal.getFontSize(), s = r.charSpace || this.internal.getCharSpace(), c = r.widths ? r.widths : a.metadata.Unicode.widths, u = c.fof ? c.fof : 1, h = r.kerning ? r.kerning : a.metadata.Unicode.kerning, l = h.fof ? h.fof : 1, f = !1 !== r.doKerning, d = 0, p = e.length, g = 0, m = c[0] || u, v = [];
    for(n = 0; n < p; n++)i = e.charCodeAt(n), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, _typeofDefault.default)(h[i]) && !isNaN(parseInt(h[i][g], 10)) ? h[i][g] / l : 0, v.push((c[i] || m) / u + d)), g = i;
    return v;
}, Yt = Vt.getStringUnitWidth = function(t, e) {
    var r = (e = e || {}).fontSize || this.internal.getFontSize(), n = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return Vt.processArabic && (t = Vt.processArabic(t)), "function" == typeof n.metadata.widthOfString ? n.metadata.widthOfString(t, r, i) / r : Gt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, Jt = function(t, e, r, n) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r;)s += e[a], a++;
    i.push(t.slice(0, a));
    var c = a;
    for(s = 0; a !== o;)s + e[a] > n && (i.push(t.slice(c, a)), s = 0, c = a), s += e[a], a++;
    return c !== a && i.push(t.slice(c, a)), i;
}, Xt = function(t, e, r) {
    r || (r = {});
    var n, i, a, o, s, c, u, h = [], l = [
        h
    ], f = r.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = Gt.apply(this, [
        " ",
        r
    ])[0];
    if (c = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0) {
        var v = Array(c).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, c = Yt.apply(this, [
            v,
            r
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (n = g[a], c && "\n" == n[0] && (n = n.substr(1), y = 1), f + d + (p = (i = Gt.apply(this, [
            n,
            r
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = Jt.apply(this, [
                    n,
                    i,
                    e - (f + d),
                    e
                ]), h.push(s.shift()), h = [
                    s.pop()
                ]; s.length;)l.push([
                    s.shift()
                ]);
                p = i.slice(n.length - (h[0] ? h[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else h = [
                n
            ];
            l.push(h), f = p + c, d = m;
        } else h.push(n), f += d + p, d = m;
    }
    return u = c ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, l.map(u);
}, Vt.splitTextToSize = function(t, e, r) {
    var n, i = (r = r || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle);
        return e.metadata.Unicode ? {
            widths: e.metadata.Unicode.widths || {
                0: 1
            },
            kerning: e.metadata.Unicode.kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, r);
    n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = r.textIndent ? 1 * r.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = r.lineIndent;
    var s, c, u = [];
    for(s = 0, c = n.length; s < c; s++)u = u.concat(Xt.apply(this, [
        n[s],
        o,
        a
    ]));
    return u;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var r = "klmnopqrstuvwxyz", n = {}, i = {}, a = 0; a < r.length; a++)n[r[a]] = "0123456789abcdef"[a], i["0123456789abcdef"[a]] = r[a];
    var o = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, s = e.__fontmetrics__.compress = function(e) {
        var r, n, a, c, u = [
            "{"
        ];
        for(var h in e){
            if (r = e[h], isNaN(parseInt(h, 10)) ? n = "'" + h + "'" : (h = parseInt(h, 10), n = (n = o(h).slice(2)).slice(0, -1) + i[n.slice(-1)]), "number" == typeof r) r < 0 ? (a = o(r).slice(3), c = "-") : (a = o(r).slice(2), c = ""), a = c + a.slice(0, -1) + i[a.slice(-1)];
            else {
                if ("object" !== (0, _typeofDefault.default)(r)) throw new Error("Don't know what to do with value type " + (0, _typeofDefault.default)(r) + ".");
                a = s(r);
            }
            u.push(n + a);
        }
        return u.push("}"), u.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, r, i, a, o = {}, s = 1, c = o, u = [], h = "", l = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (i = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (u.push([
            c,
            i
        ]), c = {}, i = void 0) : "}" == a ? ((r = u.pop())[0][r[1]] = c, i = void 0, c = r[0]) : "-" == a ? s = -1 : void 0 === i ? n.hasOwnProperty(a) ? (h += n[a], i = parseInt(h, 16) * s, s = 1, h = "") : h += a : n.hasOwnProperty(a) ? (l += n[a], c[i] = parseInt(l, 16) * s, s = 1, i = void 0, l = "") : l += a;
        return o;
    }, u = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: u,
            "Courier-Bold": u,
            "Courier-BoldOblique": u,
            "Courier-Oblique": u,
            Helvetica: u,
            "Helvetica-Bold": u,
            "Helvetica-BoldOblique": u,
            "Helvetica-Oblique": u,
            "Times-Roman": u,
            "Times-Bold": u,
            "Times-BoldItalic": u,
            "Times-Italic": u
        }
    }, l = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, r = l.Unicode[e.postScriptName];
            r && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = r.widths, e.metadata.Unicode.kerning = r.kerning);
            var n = h.Unicode[e.postScriptName];
            n && (e.metadata.Unicode.encoding = n, e.encoding = n.codePages[0]);
        }
    ]);
}(E.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    };
    t.API.events.push([
        "addFont",
        function(r) {
            var n = void 0, i = r.font, a = r.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (n = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(r, n) {
                    n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e(u(n)), r.metadata = t.API.TTFFont.open(n), r.metadata.Unicode = r.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, r.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, n);
            }
        }
    ]);
}(E), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    function e() {
        return (n.canvg ? Promise.resolve(n.canvg) : require("7ec43201f0dbcdb8")).catch(function(t) {
            return Promise.reject(new Error("Could not load canvg: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    E.API.addSvgAsImage = function(t, r, n, i, o, s, c, u) {
        if (isNaN(r) || isNaN(n)) throw a.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(i) || isNaN(o)) throw a.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = i, h.height = o;
        var l = h.getContext("2d");
        l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height);
        var f = {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0
        }, d = this;
        return e().then(function(e) {
            return e.fromString(l, t, f);
        }, function() {
            return Promise.reject(new Error("Could not load canvg."));
        }).then(function(t) {
            return t.render(f);
        }).then(function() {
            d.addImage(h.toDataURL("image/jpeg", 1), r, n, i, o, c, u);
        });
    };
}(), E.API.putTotalPages = function(t) {
    var e, r = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), r = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), r = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var n = 1; n <= this.internal.getNumberOfPages(); n++)for(var i = 0; i < this.internal.pages[n].length; i++)this.internal.pages[n][i] = this.internal.pages[n][i].replace(e, r);
    return this;
}, E.API.viewerPreferences = function(e, r) {
    var n;
    e = e || {}, r = r || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, c = Object.keys(s), u = [], h = 0, l = 0, f = 0;
    function d(t, e) {
        var r, n = !1;
        for(r = 0; r < t.length; r += 1)t[r] === e && (n = !0);
        return n;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === e || !0 === r) {
        var p = c.length;
        for(f = 0; f < p; f += 1)n[c[f]].value = n[c[f]].defaultValue, n[c[f]].explicitSet = !1;
    }
    if ("object" === (0, _typeofDefault.default)(e)) {
        for(a in e)if (o = e[a], d(c, a) && void 0 !== o) {
            if ("boolean" === n[a].type && "boolean" == typeof o) n[a].value = o;
            else if ("name" === n[a].type && d(n[a].valueSet, o)) n[a].value = o;
            else if ("integer" === n[a].type && Number.isInteger(o)) n[a].value = o;
            else if ("array" === n[a].type) {
                for(h = 0; h < o.length; h += 1)if (i = !0, 1 === o[h].length && "number" == typeof o[h][0]) u.push(String(o[h] - 1));
                else if (o[h].length > 1) {
                    for(l = 0; l < o[h].length; l += 1)"number" != typeof o[h][l] && (i = !1);
                    !0 === i && u.push([
                        o[h][0] - 1,
                        o[h][1] - 1
                    ].join(" "));
                }
                n[a].value = "[" + u.join(" ") + "]";
            } else n[a].value = n[a].defaultValue;
            n[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), r = unescape(encodeURIComponent(t)), n = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = r.length + n.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + r + n + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, r = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, n) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: n || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", r), this.internal.events.subscribe("postPutResources", e)), this;
    };
}(E.API), function(t) {
    var e = t.API, r = e.pdfEscape16 = function(t, e) {
        for(var r, n = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (r = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(r), e.metadata.toUnicode[r] = t.charCodeAt(o), -1 == n.indexOf(r) && (n.push(r), n.push([
                parseInt(e.metadata.widthOfGlyph(r), 10)
            ])), "0" == r) return a.join("");
            r = r.toString(16), a.push(i[4 - r.length], r);
        }
        return a.join("");
    }, n = function(t) {
        var e, r, n, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n = [], o = 0, s = (r = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = r[o], n.length >= 100 && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar", n = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), n.push("<" + e + "><" + i + ">"));
        return n.length && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar\n"), a += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "Identity-H" === r.encoding) {
                    for(var s = r.metadata.Unicode.widths, c = r.metadata.subset.encode(r.metadata.glyIdsUsed, 1), u = "", h = 0; h < c.length; h++)u += String.fromCharCode(c[h]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + F(r.fontName)), i("/FontFile2 " + l + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/Flags " + r.metadata.flags), i("/StemV " + r.metadata.stemV), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + F(r.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + r.encoding + ")"), i(">>"), i(">>"), i("endobj"), r.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + F(r.fontName)), i("/Encoding /" + r.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === r.encoding) {
                    for(var s = r.metadata.rawData, c = "", u = 0; u < s.length; u++)c += String.fromCharCode(s[u]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var l = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i("/StemV " + r.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + h + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/FontName /" + F(r.fontName)), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i(">>"), i("endobj"), r.objectNumber = a();
                    for(var d = 0; d < r.metadata.hmtx.widths.length; d++)r.metadata.hmtx.widths[d] = parseInt(r.metadata.hmtx.widths[d] * (1e3 / r.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + l + " 0 R/BaseFont/" + F(r.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + r.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(r.metadata.hmtx.widths) + ">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, n = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, c = s.pdfEscape, u = s.activeFontKey, h = s.fonts, l = u, f = "", d = 0, p = "", g = h[l].encoding;
        if ("Identity-H" !== h[l].encoding) return {
            text: n,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = n, l = u, Array.isArray(n) && (p = n[0]), d = 0; d < p.length; d += 1)h[l].metadata.hasOwnProperty("cmap") && (e = h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && h[l].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = c(f, l).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = r(f, h[l])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", r = [], n = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? r.push([
                    i(Object.assign({}, n, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : r.push(i(Object.assign({}, n, {
                    text: e[a]
                })).text);
                t.text = r;
            } else t.text = i(Object.assign({}, n, {
                text: e
            })).text;
        }
    ]);
}(E), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, r) {
        return e.call(this), this.internal.vFS[t] = r, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}(E.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var r, n, i, a, o, s, c, u = e, h = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], l = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), r = e >> 8, n = d[r];
            return void 0 !== n ? u[256 * n + (255 & e)] : 252 === r || 253 === r ? "AL" : g.test(r) ? "L" : 8 === r ? "R" : "N";
        }, y = function(t) {
            for(var e, r = 0; r < t.length; r++){
                if ("L" === (e = b(t.charAt(r)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var c, u, h, l, f = e[s];
            switch(f){
                case "L":
                case "R":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (c = o[s - 1]) && "AN" !== c || "EN" !== (u = e[s + 1]) && "AN" !== u ? f = "N" : m && (u = "AN"), f = u === c ? u : "N";
                    break;
                case "ES":
                    f = "EN" === (c = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(h = s + 1, l = e.length; h < l && "ET" === e[h];)h++;
                    f = h < l && "EN" === e[h] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(l = e.length, h = s + 1; h < l && "NSM" === e[h];)h++;
                        if (h < l) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (c = e[h], p && ("R" === c || "AL" === c)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (c = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, r = !0, f = v;
                    break;
                case "S":
                    n = !0, f = "N";
                    break;
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "BN":
                    f = "N";
            }
            return f;
        }, N = function(t, e, r) {
            var n = t.split("");
            return r && L(n, r, {
                hiLevel: v
            }), n.reverse(), e && e.reverse(), n.join("");
        }, L = function(t, e, i) {
            var a, o, s, c, u, d = -1, p = t.length, g = 0, y = [], N = v ? l : h, L = [];
            for(m = !1, r = !1, n = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (u = g, y[s] = w(t, L, y, s), a = 240 & (g = N[u][f[y[s]]]), g &= 15, e[s] = c = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = c;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= c;
            }
            n && function(t, e, r) {
                for(var n = 0; n < r; n++)if ("S" === t[n]) {
                    e[n] = v;
                    for(var i = n - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, A = function(t, e, n, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !r) return e.reverse(), void (n && n.reverse());
                for(var o, s, c, u, h = e.length, l = 0; l < h;){
                    if (i[l] >= t) {
                        for(c = l + 1; c < h && i[c] >= t;)c++;
                        for(u = l, s = c - 1; u < s; u++, s--)o = e[u], e[u] = e[s], e[s] = o, n && (o = n[u], n[u] = n[s], n[s] = o);
                        l = c;
                    }
                    l++;
                }
            }
        }, x = function(t, e, r) {
            var n = t.split(""), i = {
                hiLevel: v
            };
            return r || (r = []), L(n, r, i), function(t, e, r) {
                if (0 !== r.hiLevel && c) for(var n, i = 0; i < t.length; i++)1 === e[i] && (n = p.indexOf(t[i])) >= 0 && (t[i] = p[n + 1]);
            }(n, r, i), A(2, n, e, r, i), A(1, n, e, r, i), n.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, r) {
            if (function(t, e) {
                if (e) for(var r = 0; r < t.length; r++)e[r] = r;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, r);
                else if (!i && o && s) v = a ? 1 : 0, t = x(t, e, r), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = x(t, e, r)) : (v = 1, t = x(t, e, r), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = x(t, e, r), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var n = c;
                        a ? (v = 1, t = x(t, e, r), v = 0, c = !1, t = x(t, e, r), c = n) : (v = 0, t = x(t, e, r), t = N(t, e), v = 1, c = !1, t = x(t, e, r), c = n, t = N(t, e));
                    }
                } else v = 0, t = x(t, e, r);
            } else v = a ? 1 : 0, t = x(t, e, r);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, c = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], r = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text, n = (t.x, t.y, t.options || {}), i = (t.mutex, n.lang, []);
            if (n.isInputVisual = "boolean" != typeof n.isInputVisual || n.isInputVisual, r.setOptions(n), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    r.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    r.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = r.doBidiReorder(e);
            r.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}(E), E.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new ne(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new Le(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new ie(this.contents), this.head = new se(this), this.name = new pe(this), this.cmap = new ue(this), this.toUnicode = {}, this.hhea = new he(this), this.maxp = new ge(this), this.hmtx = new me(this), this.post = new fe(this), this.os2 = new le(this), this.loca = new Ne(this), this.glyf = new be(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, r, n, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, r, n, i;
            for(i = [], e = 0, r = (n = this.bbox).length; e < r; e++)t = n[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 0 != (32768 & (e = n >> 16)) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, r) {
        var n, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)n = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var r;
        return null == e && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
    }, t;
}();
var re, ne = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)r[e] = String.fromCharCode(this.readByte());
        return r.join("");
    }, t.prototype.writeString = function(t) {
        var e, r, n;
        for(n = [], e = 0, r = t.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e)n.push(this.writeByte(t.charCodeAt(e)));
        return n;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, r, n, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, r;
        return e = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, r;
        for(e = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, r, n, i;
        for(i = [], r = 0, n = t.length; r < n; r++)e = t[r], i.push(this.writeByte(e));
        return i;
    }, t;
}(), ie = function() {
    var t;
    function e(t) {
        var e, r, n;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, r = 0, n = this.tableCount; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), h = 16 * Math.floor(Math.log(f) / s), a = Math.floor(h / s), u = 16 * f - h, (n = new ne).writeInt(this.scalarType), n.writeShort(f), n.writeShort(h), n.writeShort(a), n.writeShort(u), i = 16 * f, c = n.pos + i, o = null, d = [], e)for(l = e[p], n.writeString(p), n.writeInt(t(l)), n.writeInt(c), n.writeInt(l.length), d = d.concat(l), "head" === p && (o = c), c += l.length; c % 4;)d.push(0), c++;
        return n.write(d), r = 2981146554 - t(n.data), n.pos = o + 8, n.writeUInt32(r), n.data;
    }, t = function(t) {
        var e, r, n, i;
        for(t = ve.call(t); t.length % 4;)t.push(0);
        for(n = new ne(t), r = 0, e = 0, i = t.length; e < i; e = e += 4)r += n.readUInt32();
        return 4294967295 & r;
    }, e;
}(), ae = {}.hasOwnProperty, oe = function(t, e) {
    for(var r in e)ae.call(e, r) && (t[r] = e[r]);
    function n() {
        this.constructor = t;
    }
    return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t;
};
re = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var se = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "head", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, e.prototype.encode = function(t) {
        var e;
        return (e = new ne).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, e;
}(), ce = function() {
    function t(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), h = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), l = f / 2, t.pos += 6, i = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), t.pos += 2, p = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), c = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), u = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), n = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= n ? e < n : e > n; s = 0 <= n ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], r = v = d = p[s]; d <= g ? v <= g : v >= g; r = d <= g ? ++v : --v)0 === u[s] ? a = r + c[s] : 0 !== (a = o[u[s] / 2 + (r - d) - (l - s)] || 0) && (a += c[s]), this.codeMap[r] = 65535 & a;
        }
        t.pos = h;
    }
    return t.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F, C, j, O, B, M, E, q, D, R, T, U, z, H, W, V, G, Y;
        switch(I = new ne, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, F = 0, B = a.length; F < B; F++)null == v[W = t[n = a[F]]] && (v[W] = ++p), i[n] = {
                    old: t[n],
                    new: v[t[n]]
                }, g[n] = v[t[n]];
                return I.writeUInt16(1), I.writeUInt16(0), I.writeUInt32(12), I.writeUInt16(0), I.writeUInt16(262), I.writeUInt16(0), I.write(g), {
                    charMap: i,
                    subtable: I.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], h = [], b = 0, v = {}, r = {}, m = c = null, C = 0, M = a.length; C < M; C++)null == v[w = t[n = a[C]]] && (v[w] = ++b), r[n] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - n, null != m && o === c || (m && h.push(m), P.push(n), c = o), m = n;
                for(m && h.push(m), h.push(65535), P.push(65535), S = 2 * (x = P.length), A = 2 * Math.pow(Math.log(x) / Math.LN2, 2), l = Math.log(A / 2) / Math.LN2, L = 2 * x - A, s = [], N = [], f = [], d = j = 0, E = P.length; j < E; d = ++j){
                    if (_ = P[d], u = h[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = r[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + x - d)), n = O = _; _ <= u ? O <= u : O >= u; n = _ <= u ? ++O : --O)f.push(r[n].new);
                    else s.push(k - _), N.push(0);
                }
                for(I.writeUInt16(3), I.writeUInt16(1), I.writeUInt32(12), I.writeUInt16(4), I.writeUInt16(16 + 8 * x + 2 * f.length), I.writeUInt16(0), I.writeUInt16(S), I.writeUInt16(A), I.writeUInt16(l), I.writeUInt16(L), z = 0, q = h.length; z < q; z++)n = h[z], I.writeUInt16(n);
                for(I.writeUInt16(0), H = 0, D = P.length; H < D; H++)n = P[H], I.writeUInt16(n);
                for(V = 0, R = s.length; V < R; V++)o = s[V], I.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], I.writeUInt16(y);
                for(Y = 0, U = f.length; Y < U; Y++)p = f[Y], I.writeUInt16(p);
                return {
                    charMap: r,
                    subtable: I.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), ue = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
        var e, r, n;
        for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = new ce(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, e.encode = function(t, e) {
        var r, n;
        return null == e && (e = "macroman"), r = ce.encode(t, e), (n = new ne).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
    }, e;
}(), he = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, e;
}(), le = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "OS/2", e.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, r;
            for(r = [], e = 0; e < 10; ++e)r.push(t.readByte());
            return r;
        }(), this.charRange = function() {
            var e, r;
            for(r = [], e = 0; e < 4; ++e)r.push(t.readInt());
            return r;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, r;
            for(r = [], e = 0; e < 2; e = ++e)r.push(t.readInt());
            return r;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, e;
}(), fe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "post", e.prototype.parse = function(t) {
        var e, r, n;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
                break;
            case 131072:
                var i;
                for(r = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], n = []; t.pos < this.offset + this.length;)e = t.readByte(), n.push(this.names.push(t.readString(e)));
                return n;
            case 151552:
                return r = t.readUInt16(), this.offsets = t.read(r);
            case 196608:
                break;
            case 262144:
                return this.map = (function() {
                    var e, r, n;
                    for(n = [], i = e = 0, r = this.file.maxp.numGlyphs; 0 <= r ? e < r : e > r; i = 0 <= r ? ++e : --e)n.push(t.readUInt32());
                    return n;
                }).call(this);
        }
    }, e;
}(), de = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, pe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "name", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s, c, u, h, l;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), r = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)r.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = u = 0, h = r.length; u < h; i = ++u)n = r[i], t.pos = n.offset, c = t.readString(n.length), a = new de(c, n), null == s[l = n.nameID] && (s[l] = []), s[n.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (t) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, e;
}(), ge = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, e;
}(), me = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "hmtx", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var r, i;
            for(i = [], e = r = 0; 0 <= n ? r < n : r > n; e = 0 <= n ? ++r : --r)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, r, n;
            for(n = [], t = 0, e = (r = this.metrics).length; t < e; t++)i = r[t], n.push(i.advance);
            return n;
        }).call(this), r = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= n ? a < n : a > n; e = 0 <= n ? ++a : --a)s.push(this.widths.push(r));
        return s;
    }, e.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, e;
}(), ve = [].slice, be = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "glyf", e.prototype.parse = function() {
        return this.cache = {};
    }, e.prototype.glyphFor = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, r = i.indexOf(t), 0 === (n = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + r, a = (o = new ne(e.read(n))).readShort(), c = o.readShort(), h = o.readShort(), s = o.readShort(), u = o.readShort(), this.cache[t] = -1 === a ? new we(o, c, h, s, u) : new ye(o, a, c, h, s, u), this.cache[t]));
    }, e.prototype.encode = function(t, e, r) {
        var n, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)n = t[e[o]], i.push(a.length), n && (a = a.concat(n.encode(r)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, e;
}(), ye = function() {
    function t(t, e, r, n, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), we = function() {
    function t(t, e, r, n, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, r;
        for(e = new ne(ve.call(this.raw.data)), t = 0, r = this.glyphIDs.length; t < r; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), Ne = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return oe(e, re), e.prototype.tag = "loca", e.prototype.parse = function(t) {
        var e, r;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 2)n.push(2 * t.readUInt16());
            return n;
        }).call(this) : (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 4)n.push(t.readUInt32());
            return n;
        }).call(this);
    }, e.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, e.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, e.prototype.encode = function(t, e) {
        for(var r = new Uint32Array(this.offsets.length), n = 0, i = 0, a = 0; a < r.length; ++a)if (r[a] = n, i < e.length && e[i] == a) {
            ++i, r[a] = n;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (n += s);
        }
        for(var c = new Array(4 * r.length), u = 0; u < r.length; ++u)c[4 * u + 3] = 255 & r[u], c[4 * u + 2] = (65280 & r[u]) >> 8, c[4 * u + 1] = (16711680 & r[u]) >> 16, c[4 * u] = (4278190080 & r[u]) >> 24;
        return c;
    }, e;
}(), Le = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, r, n, i;
        for(e in n = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)r = i[e], t[e] = n[r];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, r, n, i, a, o, s;
        for(n = {}, a = 0, o = t.length; a < o; a++)n[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], n)(null != (r = n[i]) ? r.compound : void 0) && e.push.apply(e, r.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))r = s[i], n[i] = r;
        return n;
    }, t.prototype.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m;
        for(n in r = ue.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = r.charMap)f[(s = m[n]).old] = s.new;
        for(d in l = r.maxGlyphID, a)d in f || (f[d] = l++);
        return u = function(t) {
            var e, r;
            for(e in r = {}, t)r[t[e]] = e;
            return r;
        }(f), h = Object.keys(u).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, r;
            for(r = [], t = 0, e = h.length; t < e; t++)o = h[t], r.push(u[o]);
            return r;
        }(), i = this.font.glyf.encode(a, p, f), c = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: c,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
E.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(r) {
        var n, i, a, o;
        if (Array.isArray(r)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = r.length; t < i; t++)n = r[t], a.push(e.convert(n));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof r) return "/" + r;
        if (null != r ? r.isString : void 0) return "(" + r + ")";
        if (r instanceof Date) return "(D:" + t(r.getUTCFullYear(), 4) + t(r.getUTCMonth(), 2) + t(r.getUTCDate(), 2) + t(r.getUTCHours(), 2) + t(r.getUTCMinutes(), 2) + t(r.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(r)) {
            for(i in a = [
                "<<"
            ], r)o = r[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + r;
    }, e;
}();
exports.default = E;

},{"@babel/runtime/helpers/typeof":"lM7hb","fflate":"kGKFz","e35ed7d1af132742":"1vgr6","fd4d839f94e36dff":"g3Kq1","7ec43201f0dbcdb8":"gCaBI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lM7hb":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kGKFz":[function(require,module,exports,__globalThis) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlateErrorCode", ()=>FlateErrorCode);
parcelHelpers.export(exports, "Deflate", ()=>Deflate);
parcelHelpers.export(exports, "AsyncDeflate", ()=>AsyncDeflate);
parcelHelpers.export(exports, "deflate", ()=>deflate);
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */ parcelHelpers.export(exports, "deflateSync", ()=>deflateSync);
parcelHelpers.export(exports, "Inflate", ()=>Inflate);
parcelHelpers.export(exports, "AsyncInflate", ()=>AsyncInflate);
parcelHelpers.export(exports, "inflate", ()=>inflate);
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "inflateSync", ()=>inflateSync);
parcelHelpers.export(exports, "Gzip", ()=>Gzip);
parcelHelpers.export(exports, "AsyncGzip", ()=>AsyncGzip);
parcelHelpers.export(exports, "gzip", ()=>gzip);
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */ parcelHelpers.export(exports, "gzipSync", ()=>gzipSync);
parcelHelpers.export(exports, "Gunzip", ()=>Gunzip);
parcelHelpers.export(exports, "AsyncGunzip", ()=>AsyncGunzip);
parcelHelpers.export(exports, "gunzip", ()=>gunzip);
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "gunzipSync", ()=>gunzipSync);
parcelHelpers.export(exports, "Zlib", ()=>Zlib);
parcelHelpers.export(exports, "AsyncZlib", ()=>AsyncZlib);
parcelHelpers.export(exports, "zlib", ()=>zlib);
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */ parcelHelpers.export(exports, "zlibSync", ()=>zlibSync);
parcelHelpers.export(exports, "Unzlib", ()=>Unzlib);
parcelHelpers.export(exports, "AsyncUnzlib", ()=>AsyncUnzlib);
parcelHelpers.export(exports, "unzlib", ()=>unzlib);
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "unzlibSync", ()=>unzlibSync);
// Default algorithm for compression (used because having a known output size allows faster decompression)
parcelHelpers.export(exports, "compress", ()=>gzip);
parcelHelpers.export(exports, "AsyncCompress", ()=>AsyncGzip);
parcelHelpers.export(exports, "compressSync", ()=>gzipSync);
parcelHelpers.export(exports, "Compress", ()=>Gzip);
parcelHelpers.export(exports, "Decompress", ()=>Decompress);
parcelHelpers.export(exports, "AsyncDecompress", ()=>AsyncDecompress);
parcelHelpers.export(exports, "decompress", ()=>decompress);
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */ parcelHelpers.export(exports, "decompressSync", ()=>decompressSync);
parcelHelpers.export(exports, "DecodeUTF8", ()=>DecodeUTF8);
parcelHelpers.export(exports, "EncodeUTF8", ()=>EncodeUTF8);
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */ parcelHelpers.export(exports, "strToU8", ()=>strToU8);
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */ parcelHelpers.export(exports, "strFromU8", ()=>strFromU8);
parcelHelpers.export(exports, "ZipPassThrough", ()=>ZipPassThrough);
parcelHelpers.export(exports, "ZipDeflate", ()=>ZipDeflate);
parcelHelpers.export(exports, "AsyncZipDeflate", ()=>AsyncZipDeflate);
parcelHelpers.export(exports, "Zip", ()=>Zip);
parcelHelpers.export(exports, "zip", ()=>zip);
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */ parcelHelpers.export(exports, "zipSync", ()=>zipSync);
parcelHelpers.export(exports, "UnzipPassThrough", ()=>UnzipPassThrough);
parcelHelpers.export(exports, "UnzipInflate", ()=>UnzipInflate);
parcelHelpers.export(exports, "AsyncUnzipInflate", ()=>AsyncUnzipInflate);
parcelHelpers.export(exports, "Unzip", ()=>Unzip);
parcelHelpers.export(exports, "unzip", ()=>unzip);
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */ parcelHelpers.export(exports, "unzipSync", ()=>unzipSync);
var ch2 = {};
var wk = function(c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array;
// fixed length extra bits
var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var clim = new u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var freb = function(eb, start) {
    var b = new u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b.b, revfd = _b.r;
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for(var i = 0; i < 32768; ++i){
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >> 8 | (x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[rev[v] >> rvb] = sv;
        }
    } else {
        co = new u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for(var i = 0; i < 144; ++i)flt[i] = 8;
for(var i = 144; i < 256; ++i)flt[i] = 9;
for(var i = 256; i < 280; ++i)flt[i] = 7;
for(var i = 280; i < 288; ++i)flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for(var i = 0; i < 32; ++i)fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new u8(v.subarray(s, e));
};
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var err = function(ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[clim[i]] = bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else err(1);
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) err(0);
                break;
            }
            if (!c) err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: et,
        l: 0
    };
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var ln = function(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = flm, ll = flt, dm = fdm, dl = fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) wbits(out, p, sym >> 23 & 31), p += fleb[len];
            var dst = sym & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) wbits16(out, p, sym >> 5 & 8191), p += fdeb[dst];
        } else wbits16(out, p, lm[sym]), p += ll[sym];
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new u16(32768), head = st.h || new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new i32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var ch = [];
// clone bufs
var cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var wrkr = function(fns, init, id, cb) {
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = wcln(fns[i], fnStr, td_1);
        ch[id] = {
            c: wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = mrg({}, ch[id].e);
    return wk(ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function() {
    return [
        u8,
        u16,
        i32,
        fleb,
        fdeb,
        clim,
        fl,
        fd,
        flrm,
        fdrm,
        rev,
        ec,
        hMap,
        max,
        bits,
        bits16,
        shft,
        slc,
        err,
        inflt,
        inflateSync,
        pbf,
        gopt
    ];
};
var bDflt = function() {
    return [
        u8,
        u16,
        i32,
        fleb,
        fdeb,
        clim,
        revfl,
        revfd,
        flm,
        flt,
        fdm,
        fdt,
        rev,
        deo,
        et,
        hMap,
        wbits,
        wbits16,
        hTree,
        ln,
        lc,
        clen,
        wfblk,
        wblk,
        shft,
        slc,
        dflt,
        dopt,
        deflateSync,
        pbf
    ];
};
// gzip extra
var gze = function() {
    return [
        gzh,
        gzhl,
        wbytes,
        crc,
        crct
    ];
};
// gunzip extra
var guze = function() {
    return [
        gzs,
        gzl
    ];
};
// zlib extra
var zle = function() {
    return [
        zlh,
        wbytes,
        adler
    ];
};
// unzlib extra
var zule = function() {
    return [
        zls
    ];
};
// post buf
var pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var gopt = function(o) {
    return o && {
        out: o.size && new u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var cbify = function(dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) err(5);
        if (t) strm.ondata(err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var b8 = function(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
};
// write bytes
var wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = adler();
        h.p(o.dictionary);
        wbytes(c, 2, h.d());
    }
};
// zlib start
var zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var Deflate = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata(dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.s.l) err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) err(5);
        if (this.s.l) err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var AsyncDeflate = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function() {
                return [
                    astrm,
                    Deflate
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function deflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt
    ], function(ev) {
        return pbf(deflateSync(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var Inflate = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new u8(32768);
        this.p = new u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = inflt(this.p, this.s, this.o);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var AsyncInflate = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        astrmify([
            bInflt,
            function() {
                return [
                    astrm,
                    Inflate
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Inflate(ev.data);
            onmessage = astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function inflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt
    ], function(ev) {
        return pbf(inflateSync(ev.data[0], gopt(ev.data[1])));
    }, 1, cb);
}
function inflateSync(data, opts) {
    return inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var Gzip = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, this.s);
        if (this.v) gzh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        Deflate.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var AsyncGzip = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function() {
                return [
                    astrm,
                    Deflate,
                    Gzip
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function gzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function() {
            return [
                gzipSync
            ];
        }
    ], function(ev) {
        return pbf(gzipSync(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function gzipSync(data, opts) {
    if (!opts) opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var Gunzip = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        Inflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new u8(0);
            this.push(new u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var AsyncGunzip = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        astrmify([
            bInflt,
            guze,
            function() {
                return [
                    astrm,
                    Inflate,
                    Gunzip
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Gunzip(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function gunzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function() {
            return [
                gunzipSync
            ];
        }
    ], function(ev) {
        return pbf(gunzipSync(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function gunzipSync(data, opts) {
    var st = gzs(data);
    if (st + 8 > data.length) err(6, 'invalid gzip data');
    return inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new u8(gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var Zlib = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) zlh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        Deflate.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var AsyncZlib = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function() {
                return [
                    astrm,
                    Deflate,
                    Zlib
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function zlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function() {
            return [
                zlibSync
            ];
        }
    ], function(ev) {
        return pbf(zlibSync(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function zlibSync(data, opts) {
    if (!opts) opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var Unzlib = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        Inflate.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray(zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var AsyncUnzlib = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        astrmify([
            bInflt,
            zule,
            function() {
                return [
                    astrm,
                    Inflate,
                    Unzlib
                ];
            }
        ], this, StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new Unzlib(ev.data);
            onmessage = astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function unzlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function() {
            return [
                unzlibSync
            ];
        }
    ], function(ev) {
        return pbf(unzlibSync(ev.data[0], gopt(ev.data[1])));
    }, 5, cb);
}
function unzlibSync(data, opts) {
    return inflt(data.subarray(zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var Decompress = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = StrmOpt.call(this, opts, cb) || {};
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var AsyncDecompress = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        Decompress.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function decompress(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
}
function decompressSync(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, opts) : unzlibSync(data, opts);
}
// flatten a directory structure
var fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new u8(0),
                op
            ];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, {
        stream: true
    });
    tds = 1;
} catch (e) {}
// decode UTF8
var dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var DecodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds) this.t = new TextDecoder();
        else this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var EncodeUTF8 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        if (this.d) err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te) return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if (td) return td.decode(dat);
    else {
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) err(8);
        return s;
    }
}
// deflate bit flag
var dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var slzh = function(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
};
// read zip header
var zh = function(d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [
        bs,
        b4(d, b + 24),
        b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        b2(d, b + 10),
        sc,
        su,
        fn,
        es + b2(d, b + 30) + b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var z64e = function(d, b) {
    for(; b2(d, b) != 1; b += 4 + b2(d, b + 2));
    return [
        b8(d, b + 12),
        b8(d, b + 4),
        b8(d, b + 20)
    ];
};
// extra field length
var exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) err(10);
    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        wbytes(d, b, +k);
        wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function(o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var ZipPassThrough = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var ZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var AsyncZipDeflate = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var Zip = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) err(5);
        // finishing or finished
        if (this.d & 2) this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function zip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl(err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, deflateSync(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function zipSync(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535) err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var UnzipPassThrough = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var UnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new Inflate(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var AsyncUnzipInflate = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new Inflate(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new AsyncInflate(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var Unzip = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) err(5);
        if (!this.p) err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) err(5);
                                if (!sc_1) file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata(err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push(et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function unzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        mt(function() {
            cb(a, b);
        });
    };
    mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd(err(13, 0, 1), null);
        return tAll;
    }
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = b4(data, e - 12);
            z = b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = b4(data, ze + 32);
                o = b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, inflateSync(infl, {
                            out: new u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push(inflate(infl, {
                        size: su
                    }, cbl));
                } else cbl(err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) err(13);
    var c = b2(data, e + 8);
    if (!c) return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = b4(data, e - 12);
        z = b4(data, ze) == 0x6064B50;
        if (z) {
            c = b4(data, ze + 32);
            o = b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), {
                out: new u8(su)
            });
            else err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1vgr6":[function(require,module,exports,__globalThis) {
module.exports = require("47944eb61a367e70")(require("146087aab7b8e29b").resolve("aUU8f")).then(()=>module.bundle.root('kzZ4E'));

},{"47944eb61a367e70":"hpx0h","146087aab7b8e29b":"fyJL2"}],"hpx0h":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"g3Kq1":[function(require,module,exports,__globalThis) {
module.exports = require("52ffd6f2cd1afd79")(require("2f382b33f63986c3").resolve("1MiJN")).then(()=>module.bundle.root('5cPaM'));

},{"52ffd6f2cd1afd79":"hpx0h","2f382b33f63986c3":"fyJL2"}],"gCaBI":[function(require,module,exports,__globalThis) {
module.exports = require("28cab5e4f980e4f0")(require("3df455e2c32a7ae").resolve("hQYtH")).then(()=>module.bundle.root('ahi2D'));

},{"28cab5e4f980e4f0":"hpx0h","3df455e2c32a7ae":"fyJL2"}],"17Su0":[function() {},{}],"kVnIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1135 = require("../Frame1135");
var _frame1135Default = parcelHelpers.interopDefault(_frame1135);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame1136 = require("../Frame1136");
var _frame1136Default = parcelHelpers.interopDefault(_frame1136);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _visualManagement1Css = require("./VisualManagement1.css");
function VisualManagement1(props) {
    const history = (0, _reactRouterDom.useHistory)();
    const { x1200PxLogo_Icam__20081, arrow9, arrow10, line2, label1, textFormat, label2, line1, place, clickOnModeling, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, arrow11, arrow16, arrow13, arrow14, inputType6, inputPlaceholder6, arrow12, arrow15, inputType7, inputPlaceholder7, modeling, frame1136Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-14",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-18",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-65",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1135Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1136Default.default), {
                                            className: frame1136Props.className,
                                            children: frame1136Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-42",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-28 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-9",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-9-4",
                                            src: arrow9,
                                            alt: "Arrow 9"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-10-1",
                                            src: arrow10,
                                            alt: "Arrow 10"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-85-4"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-9"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-5-10"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group1-26",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-8",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-8"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-101",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-8",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-102",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "line-1-8",
                            src: line1,
                            alt: "Line 1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-29",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-43",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/kanban-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-11-8",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-75 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-7 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group3-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group1-27",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-6-5",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                        className: "knowledge-skills inter-medium-dark-fern-18-1px",
                                                        name: "knowledgeskills",
                                                        placeholder: inputPlaceholder1,
                                                        type: inputType1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-7-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                        className: "collaborators-teams inter-medium-dark-fern-18-1px",
                                                        name: "collaboratorsteams",
                                                        placeholder: inputPlaceholder2,
                                                        type: inputType2
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-10-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                        className: "strategies-projects inter-medium-dark-fern-18-1px",
                                                        name: "strategiesprojects",
                                                        placeholder: inputPlaceholder3,
                                                        type: inputType3
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                        className: "ideas-information inter-medium-dark-fern-18-1px",
                                                        name: "ideasinformation",
                                                        placeholder: inputPlaceholder4,
                                                        type: inputType4
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-6-6",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                                className: "time-priorities inter-medium-dark-fern-18-1px",
                                                                name: "timepriorities",
                                                                placeholder: inputPlaceholder5,
                                                                type: inputType5
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-1",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13",
                                                            src: arrow13,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-87-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                            className: "better-management inter-medium-dark-fern-18-1px",
                                                            name: "bettermanagement",
                                                            placeholder: inputPlaceholder6,
                                                            type: inputType6
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-12",
                                                    src: arrow12,
                                                    alt: "Arrow 12"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-15",
                                                    src: arrow15,
                                                    alt: "Arrow 15"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-9-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                className: "problems-decision inter-medium-dark-fern-18-1px",
                                                name: "problemsdecision",
                                                placeholder: inputPlaceholder7,
                                                type: inputType7
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-44",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/existing-case",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-12-4",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    href: "https://app.diagrams.net/",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "modeling-97 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                        children: modeling
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/analysis",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                className: toggleProps.className,
                                                buttonSecondaryProps: toggleProps.buttonSecondaryProps
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = VisualManagement1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame1144":"cyPUr","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame1135":"4zAdk","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame1136":"8aQ7W","../Toggle":"8ZCQM","./VisualManagement1.css":"73f3D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73f3D":[function() {},{}],"iPZtN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _navItems4 = require("../NavItems4");
var _navItems4Default = parcelHelpers.interopDefault(_navItems4);
var _frame522 = require("../Frame522");
var _frame522Default = parcelHelpers.interopDefault(_frame522);
var _frame4 = require("../Frame4");
var _frame4Default = parcelHelpers.interopDefault(_frame4);
var _functionalViewCss = require("./FunctionalView.css");
function FunctionalView(props) {
    const { x1200PxLogo_Icam__20081, design, arrow1, arrow2, line2, label1, textFormat, label2, line1, place, clickOnModeling, label3, arrow5, label4, arrow6, label5, arrow8, modeling, label6, label7, arrow3, arrow4, arrow7, label8, arrow9, xcontinue, navItems4Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "functional-view-10 screen",
            name: "form6",
            action: "form6",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-9",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-45",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-15",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-19",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-88",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-74 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems4Default.default), {
                            className: navItems4Props.className,
                            frame1162Props: navItems4Props.frame1162Props,
                            frame1172Props: navItems4Props.frame1172Props,
                            frame118Props: navItems4Props.frame118Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-46",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-47",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-30 inter-medium-rum-swizzle-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-10",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-1-8",
                                                    src: arrow1,
                                                    alt: "Arrow 1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-2-7",
                                                    src: arrow2,
                                                    alt: "Arrow 2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-3-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-4-49"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group6-2",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-9",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-9"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-105",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-9",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-106",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-9",
                                    src: line1,
                                    alt: "Line 1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-31",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-48",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/objectives",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-6-7",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-76 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-8 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-49",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-32 inter-medium-rum-swizzle-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group3-9",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-107",
                                                            children: label3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-5-6",
                                                            src: arrow5,
                                                            alt: "Arrow 5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-28",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-108",
                                                            children: label4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame522Default.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-7",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group4-7",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-109",
                                                            children: label5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-8-6",
                                                            src: arrow8,
                                                            alt: "Arrow 8"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-10-3",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-98 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-33",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-15",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-110 inter-medium-rum-swizzle-18-1px",
                                                            children: label6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-111 inter-medium-rum-swizzle-18-1px",
                                                            children: label7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame4Default.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-3-5",
                                                            src: arrow3,
                                                            alt: "Arrow 3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-4-5",
                                                            src: arrow4,
                                                            alt: "Arrow 4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-7-5",
                                                            src: arrow7,
                                                            alt: "Arrow 7"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group5-5",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-112 inter-medium-rum-swizzle-18-1px",
                                                            children: label8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-9-5",
                                                            src: arrow9,
                                                            alt: "Arrow 9"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/physical-model",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-12",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-7 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = FunctionalView;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../NavItems4":"dsZMd","../Frame522":"9WZl7","../Frame4":"7kdJt","./FunctionalView.css":"hN0nm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hN0nm":[function() {},{}],"6Bm4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems22 = require("../NavItems22");
var _navItems22Default = parcelHelpers.interopDefault(_navItems22);
var _frame52 = require("../Frame52");
var _frame52Default = parcelHelpers.interopDefault(_frame52);
var _pricing3 = require("../Pricing3");
var _pricing3Default = parcelHelpers.interopDefault(_pricing3);
var _objectivesCss = require("./Objectives.css");
function Objectives(props) {
    const { x1200PxLogo_Icam__20081, place1, notesAtteindre, place2, inputType1, inputPlaceholder1, line211, leadTime, inputType2, inputPlaceholder2, line212, environment, inputType3, inputPlaceholder3, line213, xcontinue, navItems3Props, navItems22Props, pricing31Props, pricing32Props, pricing33Props, pricing34Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "objectives screen",
            name: "form7",
            action: "form7",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-34",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-16",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-16",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                            className: navItems3Props.className,
                                            frame1172Props: navItems3Props.frame1172Props,
                                            frame1162Props: navItems3Props.frame1162Props,
                                            frame1132Props: navItems3Props.frame1132Props
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems22Default.default), {
                                            frame11332Props: navItems22Props.frame11332Props
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-50",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame52Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/cur-performances",
                                    className: "align-self-flex-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-6-8",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "place-77 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: place1
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "notes-atteindre valign-text-middle bevan-normal-white-20px",
                                    children: notesAtteindre
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pricing-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "place-78 inter-bold-mineral-green-24px",
                                            children: place2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-1 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder1,
                                            type: inputType1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-1",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing31Props.cost
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "lead-time inter-bold-mineral-green-24px",
                                            children: leadTime
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-2 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder2,
                                            type: inputType2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21",
                                            src: line212,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing32Props.cost,
                                    className: pricing32Props.className
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-51",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing33Props.cost,
                            className: pricing33Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-35",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "environment inter-bold-mineral-green-24px",
                                            children: environment
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-3 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder3,
                                            type: inputType3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21",
                                            src: line213,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "javascript:SubmitForm('form7')",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-2-13",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "continue-8 valign-text-middle inter-bold-mineral-green-18px",
                                            children: xcontinue
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing34Props.cost,
                            className: pricing34Props.className
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Objectives;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems22":"jBvFI","../Frame52":"daWN4","../Pricing3":"apV5l","./Objectives.css":"akK6b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jBvFI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _navItems22Css = require("./NavItems22.css");
function NavItems22(props) {
    const { className, frame11332Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `nav-items-2-20 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                className: frame11332Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-116-175",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "result-objectives-84 valign-text-middle inter-medium-white-18px",
                    children: "Result & Objectives"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
        ]
    });
}
exports.default = NavItems22;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame117":"1Qy2K","./NavItems22.css":"lNGhg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lNGhg":[function() {},{}],"daWN4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame52Css = require("./Frame52.css");
function Frame52() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-5-11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "place-79 valign-text-middle inter-bold-tropical-rain-forest-18px",
            children: "Back"
        })
    });
}
exports.default = Frame52;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame52.css":"6qRgD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qRgD":[function() {},{}],"apV5l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pricing3Css = require("./Pricing3.css");
function Pricing3(props) {
    const { cost, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `pricing-3 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "cost inter-bold-rum-swizzle-24px",
                children: cost
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "x25-4 inter-bold-rum-swizzle-56px",
                htmlFor: "25",
                children: "/25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: "line-21-2",
                src: "/img/line-21-1@2x.png",
                alt: "Line 21"
            })
        ]
    });
}
exports.default = Pricing3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Pricing3.css":"3ByTj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ByTj":[function() {},{}],"akK6b":[function() {},{}],"dZsWI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _navItems42 = require("../NavItems42");
var _navItems42Default = parcelHelpers.interopDefault(_navItems42);
var _frame522 = require("../Frame522");
var _frame522Default = parcelHelpers.interopDefault(_frame522);
var _frame4 = require("../Frame4");
var _frame4Default = parcelHelpers.interopDefault(_frame4);
var _physicalModelCss = require("./PhysicalModel.css");
function PhysicalModel(props) {
    const { x1200PxLogo_Icam__20081, design, arrow1, arrow2, line2, label1, textFormat, label2, line1, place, clickOnModeling, label3, arrow5, label4, arrow6, label5, arrow8, modeling, label6, label7, arrow3, arrow4, arrow7, label8, arrow9, xcontinue, navItems42Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "physical-model-10 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group4-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-52",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-17",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-23",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-90",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-75 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems42Default.default), {
                            frame1162Props: navItems42Props.frame1162Props,
                            frame1172Props: navItems42Props.frame1172Props,
                            frame118Props: navItems42Props.frame118Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-53",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-54",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-36 inter-medium-rum-swizzle-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-11",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-1-9",
                                                    src: arrow1,
                                                    alt: "Arrow 1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-2-8",
                                                    src: arrow2,
                                                    alt: "Arrow 2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-6"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-3-6"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-4-50"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group2-10",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-10",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-10"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-113",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-10",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-114",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-10",
                                    src: line1,
                                    alt: "Line 1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-37",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-55",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/functional-view",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-7-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-229 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-9 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-56",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-38 inter-medium-rum-swizzle-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group6-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-115",
                                                            children: label3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-5-7",
                                                            src: arrow5,
                                                            alt: "Arrow 5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-17",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-116",
                                                            children: label4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame522Default.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-8",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group3-10",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-117",
                                                            children: label5
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-8-7",
                                                            src: arrow8,
                                                            alt: "Arrow 8"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-9-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-105-1",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                            href: "https://app.diagrams.net/",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "modeling-84 valign-text-middle inter-bold-mineral-green-18px",
                                                                children: modeling
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-39",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-29",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-118 inter-medium-rum-swizzle-18-1px",
                                                            children: label6
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-119 inter-medium-rum-swizzle-18-1px",
                                                            children: label7
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame4Default.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-3-6",
                                                            src: arrow3,
                                                            alt: "Arrow 3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-4-6",
                                                            src: arrow4,
                                                            alt: "Arrow 4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-7-6",
                                                            src: arrow7,
                                                            alt: "Arrow 7"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group5-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-120 inter-medium-rum-swizzle-18-1px",
                                                            children: label8
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-9-6",
                                                            src: arrow9,
                                                            alt: "Arrow 9"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/decisional-model",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-14",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-9 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = PhysicalModel;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../NavItems42":"jMxSu","../Frame522":"9WZl7","../Frame4":"7kdJt","./PhysicalModel.css":"1rxl6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jMxSu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11452 = require("../Frame11452");
var _frame11452Default = parcelHelpers.interopDefault(_frame11452);
var _frame1163 = require("../Frame1163");
var _frame1163Default = parcelHelpers.interopDefault(_frame1163);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _navItems42Css = require("./NavItems42.css");
function NavItems42(props) {
    const { frame1162Props, frame1172Props, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "nav-items-4-7",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11452Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1163Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                children: frame1162Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                children: frame1172Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                children: frame118Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
        ]
    });
}
exports.default = NavItems42;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame11452":"8qLPx","../Frame1163":"2keeU","../Frame11622":"6kTsO","../Frame11722":"k9cYz","../Frame118":"kfDbB","../Frame11342":"2AuVF","./NavItems42.css":"hB1OR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hB1OR":[function() {},{}],"1rxl6":[function() {},{}],"i4Eaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _navItems43 = require("../NavItems43");
var _navItems43Default = parcelHelpers.interopDefault(_navItems43);
var _decisionalModelCss = require("./DecisionalModel.css");
function DecisionalModel(props) {
    const { x1200PxLogo_Icam__20081, design, arrow3, arrow4, line2, label1, textFormat, label2, line1, place, clickOnModeling, modeling, xcontinue, navItems43Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "decisional-model-10 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-18",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-57",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-18",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-25",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-91",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-76 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems43Default.default), {
                            frame1172Props: navItems43Props.frame1172Props,
                            frame118Props: navItems43Props.frame118Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-58",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-40 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-12",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-3-7",
                                            src: arrow3,
                                            alt: "Arrow 3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-4-7",
                                            src: arrow4,
                                            alt: "Arrow 4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-85-7"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-7"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-5-12"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group1-30",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-11",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-11"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-121",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-11",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-122",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-59",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-60",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-1-11",
                                            src: line1,
                                            alt: "Line 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/physical-model",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-8-3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-230 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-41",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-10 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-8",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    href: "https://app.diagrams.net/",
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-9-3",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-100 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/process-view",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-15",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-10 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = DecisionalModel;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../NavItems43":"lz16J","./DecisionalModel.css":"4FXem","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lz16J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11452 = require("../Frame11452");
var _frame11452Default = parcelHelpers.interopDefault(_frame11452);
var _frame11632 = require("../Frame11632");
var _frame11632Default = parcelHelpers.interopDefault(_frame11632);
var _frame1155 = require("../Frame1155");
var _frame1155Default = parcelHelpers.interopDefault(_frame1155);
var _frame11722 = require("../Frame11722");
var _frame11722Default = parcelHelpers.interopDefault(_frame11722);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _navItems43Css = require("./NavItems43.css");
function NavItems43(props) {
    const { frame1172Props, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "nav-items-4-8",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11452Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11632Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1155Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11722Default.default), {
                children: frame1172Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                children: frame118Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
        ]
    });
}
exports.default = NavItems43;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame11452":"8qLPx","../Frame11632":"1Rc4t","../Frame1155":"f5HL2","../Frame11722":"k9cYz","../Frame118":"kfDbB","../Frame11342":"2AuVF","./NavItems43.css":"bynnX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bynnX":[function() {},{}],"4FXem":[function() {},{}],"eAqxD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _navItems44 = require("../NavItems44");
var _navItems44Default = parcelHelpers.interopDefault(_navItems44);
var _processViewCss = require("./ProcessView.css");
function ProcessView(props) {
    const { x1200PxLogo_Icam__20081, design, arrow1, arrow2, rectangle7, line3, line4, line2, label1, textFormat, label2, line1, place, clickOnFlexsimB, overlapGroup2, cut, label3, rectangle5, manufacturing, arrow6, arrow11, label4, arrow8, label5, arrow9, spanText1, spanText2, rectangle6, assembly, arrow10, xcontinue, navItems44Props } = props;
    // Define state variables for form inputs
    const [error, setError] = (0, _react.useState)("");
    // Define function to handle form submission
    const launchFlexsim = async (e)=>{
        e.preventDefault();
        try {
            const response = await fetch("https://api.scgreenoptimizer.fr/open-VMWarehorizon");
            const responseData = await response.json();
            console.log(responseData);
            // If successful login, open VMware Horizon View Client
            window.open("C:\\Program Files\\VMware\\VMware Horizon View Client\\vmware-view.exe");
        } catch (error) {
            setError(error.message);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "process-view-10 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-19",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-61",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-19",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-30",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-92",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-77 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems44Default.default), {
                            frame1162Props: navItems44Props.frame1162Props,
                            frame118Props: navItems44Props.frame118Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-62",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-63",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-42 inter-medium-rum-swizzle-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-13",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-1-10",
                                                    src: arrow1,
                                                    alt: "Arrow 1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-2-9",
                                                    src: arrow2,
                                                    alt: "Arrow 2"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "rectangle-7-3",
                                            src: rectangle7,
                                            alt: "Rectangle 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-64",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-85-8"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "frame-3-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-3-5",
                                                            src: line3,
                                                            alt: "Line 3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-4-3",
                                                            src: line4,
                                                            alt: "Line 4"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-4-51"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group3-11",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-12",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-12"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-123",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-12",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-124",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-12",
                                    src: line1,
                                    alt: "Line 1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/decisional-model",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-8-4",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "place-248 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: place
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "click-on-flexsim-b-1 valign-text-middle bevan-normal-white-20px",
                                    children: clickOnFlexsimB
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-65",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-43",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-66",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group2-11",
                                                            style: {
                                                                backgroundImage: `url(${overlapGroup2})`
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "cut-1 valign-text-middle inter-bold-mineral-green-18px",
                                                                children: cut
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-col-44",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group1-31",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "label-125 inter-medium-rum-swizzle-18-1px",
                                                                            children: label3
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "rectangle-5-3",
                                                                            src: rectangle5,
                                                                            alt: "Rectangle 5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "manufacturing-5 valign-text-middle inter-bold-mineral-green-18px",
                                                                            children: manufacturing
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-6-9",
                                                                            src: arrow6,
                                                                            alt: "Arrow 6"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-11-2",
                                                                            src: arrow11,
                                                                            alt: "Arrow 11"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-container-6 inter-medium-rum-swizzle-18-1px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-group4-9",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "label-126",
                                                                                    children: label4
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    className: "arrow-8-8",
                                                                                    src: arrow8,
                                                                                    alt: "Arrow 8"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-group7-1",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "label-127",
                                                                                    children: label5
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    className: "arrow-9-7",
                                                                                    src: arrow9,
                                                                                    alt: "Arrow 9"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "frame-9-4",
                                                    onClick: launchFlexsim,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flexsim-1 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "flexsim valign-text-middle inter-bold-mineral-green-18px",
                                                            children: "Flexsim"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-45",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group5-7",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "rectangle-6-3",
                                                            src: rectangle6,
                                                            alt: "Rectangle 6"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "assembly-1 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: assembly
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-10-2",
                                                            src: arrow10,
                                                            alt: "Arrow 10"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/informational-model",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-16",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-11 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ProcessView;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../NavItems44":"5CJPh","./ProcessView.css":"5e0sC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5CJPh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11452 = require("../Frame11452");
var _frame11452Default = parcelHelpers.interopDefault(_frame11452);
var _frame11632 = require("../Frame11632");
var _frame11632Default = parcelHelpers.interopDefault(_frame11632);
var _frame11622 = require("../Frame11622");
var _frame11622Default = parcelHelpers.interopDefault(_frame11622);
var _frame1173 = require("../Frame1173");
var _frame1173Default = parcelHelpers.interopDefault(_frame1173);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame11342 = require("../Frame11342");
var _frame11342Default = parcelHelpers.interopDefault(_frame11342);
var _navItems44Css = require("./NavItems44.css");
function NavItems44(props) {
    const { frame1162Props, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "nav-items-4-9",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11452Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11632Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11622Default.default), {
                children: frame1162Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1173Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                children: frame118Props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11342Default.default), {})
        ]
    });
}
exports.default = NavItems44;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame11452":"8qLPx","../Frame11632":"1Rc4t","../Frame11622":"6kTsO","../Frame1173":"8QIm8","../Frame118":"kfDbB","../Frame11342":"2AuVF","./NavItems44.css":"1yNX1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1yNX1":[function() {},{}],"5e0sC":[function() {},{}],"fUL0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11432 = require("../Frame11432");
var _frame11432Default = parcelHelpers.interopDefault(_frame11432);
var _frame1152 = require("../Frame1152");
var _frame1152Default = parcelHelpers.interopDefault(_frame1152);
var _headerMenuDefault2 = require("../HeaderMenuDefault2");
var _headerMenuDefault2Default = parcelHelpers.interopDefault(_headerMenuDefault2);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame232 = require("../Frame232");
var _frame232Default = parcelHelpers.interopDefault(_frame232);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _smed2Css = require("./SMED2.css");
function SMED2(props) {
    const { x1200PxLogo_Icam__20081, label1, aquisition, analysis, label2, pleaseAnswerTheFollowingQuestions, frame11432Props, frame1152Props, headerMenuDefault2Props, frame11322Props, frame1144Props, frame232Props, frame101Props, toggleProps, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-46",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-20",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-20",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-3-66",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11432Default.default), {
                                                    className: frame11432Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1152Default.default), {
                                                    className: frame1152Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/existing-case",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-17",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
                                                            children: headerMenuDefault2Props.children
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/cur-performances",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-128 inter-medium-sonic-silver-18-1px",
                                                        children: label1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                                    className: frame11322Props.className
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-2-34",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-113-48",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "aquisition-90 valign-text-middle inter-medium-rum-swizzle-18px",
                                                        children: aquisition
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {
                                                    className: frame1144Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-115-116",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "analysis-90 valign-text-middle inter-medium-sonic-silver-18px",
                                                        children: analysis
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame232Default.default), {
                                                    headerMenuDefault2Props: frame232Props.headerMenuDefault2Props
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/functional-view",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-128 inter-medium-sonic-silver-18-1px",
                                                        children: label2
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-1 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-67",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-47",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggleProps.className,
                                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = SMED2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11432":"docuM","../Frame1152":"2eMbg","../HeaderMenuDefault2":"8KBHC","../Frame11322":"lrJXI","../Frame1144":"cyPUr","../Frame232":"ki771","../Frame101":"b9rYD","../Toggle":"8ZCQM","../Frame102":"lji9Q","../Frame11732":"h8i4O","./SMED2.css":"4v5AJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9rYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame101Css = require("./Frame101.css");
function Frame101(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-101 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "a-quelle-frquence-re subtitel",
                name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                placeholder: "A quelle fr\xe9quence renouvelez vous votre stock?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "combien-de-temps-en subtitel",
                name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                placeholder: "combien de temps en moyenne un article effectue dans votre magazin?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vous subtitel",
                name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                placeholder: "Vous arrive-t-il d\u2019avoir des ruptures de stock? Si oui, \xe0 quelle fr\xe9quence?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vous subtitel",
                name: "avezvousmisenplacedemesuresdam\xe9lioration",
                placeholder: "Avez vous mis en place de mesures d\u2019am\xe9lioration?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x subtitel",
                name: "*******************************************",
                placeholder: "*******************************************",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame101;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Group102":"3ieGn","./Frame101.css":"fRiDS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ieGn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _group102Css = require("./Group102.css");
function Group102(props) {
    const { line24, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `group-23 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "tap-here-7 subtitel",
                name: "taphere",
                placeholder: "tap here",
                type: "text",
                required: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                className: "line-24",
                src: line24,
                alt: "Line 24"
            })
        ]
    });
}
exports.default = Group102;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Group102.css":"5fBcn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5fBcn":[function() {},{}],"fRiDS":[function() {},{}],"lji9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame102Css = require("./Frame102.css");
function Frame102(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-102 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "dans-quel-rayon-se-situe-vos-clients subtitel",
                name: "dansquelrayonsesituevosclients",
                placeholder: "Dans quel rayon se situe vos clients?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel subtitel",
                name: "aquellefr\xe9quenceeffectuezvousdeslivraisons",
                placeholder: "A quelle fr\xe9quence effectuez vous des livraisons?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel subtitel",
                name: "quelestvotretauxdeservice",
                placeholder: "Quel est votre taux de service?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel-est-votre-taux-de-retard subtitel",
                name: "quelestvotretauxderetard",
                placeholder: "Quel est votre taux de retard?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-9 subtitel",
                name: "*************************************",
                placeholder: "*************************************",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame102;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Group102":"3ieGn","./Frame102.css":"jjbCT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jjbCT":[function() {},{}],"h8i4O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame11732Css = require("./Frame11732.css");
function Frame11732(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-112 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "next valign-text-middle inter-bold-mineral-green-18px",
            children: "Next"
        })
    });
}
exports.default = Frame11732;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame11732.css":"7fyCF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7fyCF":[function() {},{}],"4v5AJ":[function() {},{}],"is08s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _smed3Css = require("./SMED3.css");
function SMED3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, visualManagement, navItems2Props, navItems3Props, frame101Props, frame102Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-21",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-21",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-2 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-68",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-117-93",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "visual-management-14 valign-text-middle inter-bold-mineral-green-18px",
                                children: visualManagement
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = SMED3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Frame101":"b9rYD","../Frame102":"lji9Q","../Toggle":"8ZCQM","./SMED3.css":"cgPCX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cgPCX":[function() {},{}],"4GnDj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _visualManagement2Css = require("./VisualManagement2.css");
function VisualManagement2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame101Props, toggleProps, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-22",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-9"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-22",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-3 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-69",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-48",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggleProps.className,
                                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = VisualManagement2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Frame101":"b9rYD","../Toggle":"8ZCQM","../Frame102":"lji9Q","../Frame11732":"h8i4O","./VisualManagement2.css":"1LoLg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LoLg":[function() {},{}],"eZr1N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _kaizen3Css = require("./Kaizen3.css");
function Kaizen3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, smed, navItems2Props, navItems3Props, frame101Props, frame102Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-10"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-23",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-4 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-70",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-117-94",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "smed-12 valign-text-middle inter-bold-mineral-green-18px",
                                children: smed
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Frame101":"b9rYD","../Frame102":"lji9Q","../Toggle":"8ZCQM","./Kaizen3.css":"1EKVQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1EKVQ":[function() {},{}],"kItiI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _visualManagement3Css = require("./VisualManagement3.css");
function VisualManagement3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, goOnToTheNextStep, navItems2Props, navItems3Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-11"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-24",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-5 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-71",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/functional-view-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-116-177",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "go-on-to-the-next-step valign-text-middle inter-bold-mineral-green-18px",
                                    children: goOnToTheNextStep
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = VisualManagement3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","./VisualManagement3.css":"kjld3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kjld3":[function() {},{}],"cW6a1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems22 = require("../NavItems22");
var _navItems22Default = parcelHelpers.interopDefault(_navItems22);
var _frame1142 = require("../Frame1142");
var _frame1142Default = parcelHelpers.interopDefault(_frame1142);
var _frame11532 = require("../Frame11532");
var _frame11532Default = parcelHelpers.interopDefault(_frame11532);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _pricing3 = require("../Pricing3");
var _pricing3Default = parcelHelpers.interopDefault(_pricing3);
var _curPerformancesCss = require("./CurPerformances.css");
var _social5 = require("../Social5");
var _social6 = require("../Social6");
var _aquisition = require("../Aquisition");
var _environmental5 = require("../Environmental5");
var _modernization4 = require("../Modernization4");
var _leadTime2 = require("../LeadTime2");
var _cost2 = require("../Cost2");
var _quality6 = require("../Quality6");
var _clientConsommateur2 = require("../ClientConsommateur2");
function CurPerformances(props) {
    const { label1, label2, x1200PxLogo_Icam__20081, place1, place2, line211, leadTime, className, environment, navItems22Props, frame1142Props, frame11322Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "cur-performances screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-49",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group1-32",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-25",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-2-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems22Default.default), {
                                            className: navItems22Props.className,
                                            frame11332Props: navItems22Props.frame11332Props
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-3-67",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1142Default.default), {
                                                    className: frame1142Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11532Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/existing-case",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-129 inter-medium-star-dust-18-1px",
                                                        children: label1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/cur-performances",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-129 inter-medium-sonic-silver-18-1px",
                                                        children: label2
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                                    className: frame11322Props.className
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/home",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "x1200px-logo_icam_-_2008-1-25",
                                                src: x1200PxLogo_Icam__20081,
                                                alt: "1200px-Logo_ICAM_-_2008 1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-3-5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/client-consommateur-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-5-13",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "place-249 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: place1
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                className: "cost inter-bold-rum-swizzle-24px",
                                children: [
                                    " ",
                                    "Audited Enterprise: ",
                                    (0, _aquisition.company_name)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pricing-container-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-1-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "place-250 inter-bold-mineral-green-24px",
                                            children: place2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "x25-16 inter-bold-mineral-green-56px",
                                            htmlFor: "25",
                                            children: [
                                                (0, _quality6.q_sum),
                                                "/81"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-6",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `pricing-3 ${className || ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "cost inter-bold-rum-swizzle-24px",
                                            children: "Cost"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "x25-4 inter-bold-rum-swizzle-56px",
                                            htmlFor: "25",
                                            children: [
                                                (0, _cost2.c_sum),
                                                "/22"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-2",
                                            src: "/img/line-21-1@2x.png",
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-2-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "lead-time-1 inter-bold-mineral-green-24px",
                                            children: leadTime
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "x25-17 inter-bold-mineral-green-56px",
                                            htmlFor: "25",
                                            children: [
                                                (0, _leadTime2.l_sum),
                                                "/18"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-6",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `pricing-3 ${className || ""}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "cost inter-bold-rum-swizzle-24px",
                                            children: "Modernization"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "x25-4 inter-bold-rum-swizzle-56px",
                                            htmlFor: "25",
                                            children: [
                                                (0, _modernization4.m_sum),
                                                "/26"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-2",
                                            src: "/img/line-21-1@2x.png",
                                            alt: "Line 21"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-72",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `pricing-3 ${className || ""}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "cost inter-bold-rum-swizzle-24px",
                                    children: "Social"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: "x25-4 inter-bold-rum-swizzle-56px",
                                    htmlFor: "25",
                                    children: [
                                        (0, _social6.s_sum),
                                        "/36"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-2",
                                    src: "/img/line-21-1@2x.png",
                                    alt: "Line 21"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-50",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-6-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "environment-1 inter-bold-mineral-green-24px",
                                            children: environment
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "x25-18 inter-bold-mineral-green-56px",
                                            htmlFor: "25",
                                            children: [
                                                (0, _environmental5.e_sum),
                                                "/63"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-6",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/existing-systems",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-2-18",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "propositions valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: "Systems step"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `pricing-3 ${className || ""}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "cost inter-bold-rum-swizzle-24px",
                                    children: "Client/Consommateur"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: "x25-4 inter-bold-rum-swizzle-56px",
                                    htmlFor: "25",
                                    children: [
                                        (0, _clientConsommateur2.cc_sum),
                                        "/17"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-2",
                                    src: "/img/line-21-1@2x.png",
                                    alt: "Line 21"
                                })
                            ]
                        })
                    ]
                }),
                console.log((0, _social6.s_sum))
            ]
        })
    });
}
exports.default = CurPerformances;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems22":"jBvFI","../Frame1142":"g5Omc","../Frame11532":"gxslB","../Frame11322":"lrJXI","../Pricing3":"apV5l","./CurPerformances.css":"8B5hh","../Social5":"5NgzO","../Social6":"hHc62","../Aquisition":"8nwJV","../Environmental5":"jhgCb","../Modernization4":"b543i","../LeadTime2":"zBsDr","../Cost2":"7QKHV","../Quality6":"cQ4XY","../ClientConsommateur2":"3ZD9U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8B5hh":[function() {},{}],"5NgzO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData5", ()=>s_allData5);
parcelHelpers.export(exports, "yes_Count5", ()=>yes_Count5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social5Css = require("./Social5.css");
let s_allData5 = [];
let yes_Count5 = 0;
function Social5(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount5, setYesCount5] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count5++;
            setYesCount5((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
            //return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        s_allData5 = s_allData5.concat(data); // Concatène les nouvelles données à allData
        console.log(s_allData5);
        // console.log(yesCount5);
        console.log(yes_Count5);
        history.push("/social-6");
        return s_allData5;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "social-5 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-83",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-27",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-49",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count5,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "sant-et-scurit-au-travail",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "sant-et-scurit-au-travail-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-107-4",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-104",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle1Props.className,
                                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-promote-the-e subtitel",
                                                    htmlFor: "doyoupromotetheemployabilityofemployeesbyanticipatingtheevolutionofskills",
                                                    children: "Do you promote the employability of employees by anticipating the evolution of skills?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you promote the employability of employees by anticipating the evolution of skills?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you promote the employability of employees by anticipating the evolution of skills?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you promote the employability of employees by anticipating the evolution of skills?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you promote the employability of employees by anticipating the evolution of skills?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you promote the employability of employees by anticipating the evolution of skills?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you promote the employability of employees by anticipating the evolution of skills?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-carry-out-a-b subtitel",
                                                    htmlFor: "doyoucarryoutabusinessneedsanalysis",
                                                    children: "Do you carry out a business needs analysis?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you carry out a business needs analysis?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you carry out a business needs analysis?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you carry out a business needs analysis?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you carry out a business needs analysis?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you carry out a business needs analysis?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you carry out a business needs analysis?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-make-an-inven subtitel",
                                                    htmlFor: "doyoumakeaninventoryoftheskillsneeded",
                                                    children: "Do you make an inventory of the skills needed?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you make an inventory of the skills needed?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you make an inventory of the skills needed?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you make an inventory of the skills needed?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you make an inventory of the skills needed?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you make an inventory of the skills needed?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you make an inventory of the skills needed?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-provide-training-for-employees subtitel",
                                                    htmlFor: "doyouprovidetrainingforemployees",
                                                    children: "Do you provide training for employees?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you provide training for employees?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you provide training for employees?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you provide training for employees?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you provide training for employees?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you provide training for employees?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you provide training for employees?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "sant-et-scurit-au-travail-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-listen-to-emp subtitel",
                                            htmlFor: "doyoulistentoemployeesexpectationsinordertocontributetotheirdevelopmentatworkandtheircareerpath",
                                            children: "Do you listen to employees' expectations in order to contribute to their development at work and their career path?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you listen to employees' expectations in order to contribute to their development at work and their career path?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you listen to employees' expectations in order to contribute to their development at work and their career path?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you listen to employees' expectations in order to contribute to their development at work and their career path?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you listen to employees' expectations in order to contribute to their development at work and their career path?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you listen to employees' expectations in order to contribute to their development at work and their career path?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you listen to employees' expectations in order to contribute to their development at work and their career path?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-offer-employe subtitel",
                                            htmlFor: "doyouofferemployeesevaluationandreflectioninterviewsontheircareerpath",
                                            children: "Do you offer employees evaluation and reflection interviews on their career path?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you offer employees evaluation and reflection interviews on their career path?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you offer employees evaluation and reflection interviews on their career path?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you offer employees evaluation and reflection interviews on their career path?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you offer employees evaluation and reflection interviews on their career path?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you offer employees evaluation and reflection interviews on their career path?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you offer employees evaluation and reflection interviews on their career path?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-offer-employe-1 subtitel",
                                            htmlFor: "doyouofferemployeesanindividualinterviewduringtheyear",
                                            children: "Do you offer employees an individual interview during the year?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you offer employees an individual interview during the year?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you offer employees an individual interview during the year?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you offer employees an individual interview during the year?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you offer employees an individual interview during the year?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you offer employees an individual interview during the year?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you offer employees an individual interview during the year?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "sant-et-scurit-au-travail-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-ensure-that-e subtitel",
                                            htmlFor: "doyouensurethatemployeesdevelopmentisbasedonprinciplesofequityandnon-discrimination",
                                            children: "Do you ensure that employees' development is based on principles of equity and non-discrimination?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you ensure that employees' development is based on principles of equity and non-discrimination?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you ensure that employees' development is based on principles of equity and non-discrimination?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you ensure that employees' development is based on principles of equity and non-discrimination?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you ensure that employees' development is based on principles of equity and non-discrimination?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you ensure that employees' development is based on principles of equity and non-discrimination?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you ensure that employees' development is based on principles of equity and non-discrimination?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-150",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social5;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Social5.css":"f1Afh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f1Afh":[function() {},{}],"hHc62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_sum", ()=>s_sum);
parcelHelpers.export(exports, "yes_Count6", ()=>yes_Count6);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social6Css = require("./Social6.css");
var _social1 = require("../Social1");
var _social2 = require("../Social2");
var _social3 = require("../Social3");
var _social4 = require("../Social4");
var _social5 = require("../Social5");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
let s_sum = 0;
let yes_Count6 = 0;
function Social6(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount6, setYesCount6] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, modernizationCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    let s_yesCount6 = 0;
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count6++;
            setYesCount6((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let s_allData6 = [];
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
            //return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        s_allData6 = s_allData6.concat(data); // Concatenate the new data to s_allData6
        const s_allData = (0, _social1.s_allData1).concat((0, _social2.s_allData2), (0, _social3.s_allData3), (0, _social4.s_allData4), (0, _social5.s_allData5), s_allData6); // Update allData
        s_sum = (0, _social1.yes_Count1) + (0, _social2.yes_Count2) + (0, _social3.yes_Count3) + (0, _social5.yes_Count5) + yes_Count6;
        console.log(s_allData6);
        console.log(s_allData);
        console.log(s_sum);
        generatePdf(s_allData); // Call the generatePdf function with the updated array
        // connect();
        history.push("/modernization-1");
    }
    function generatePdf(s_allData) {
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 20;
        const pageHeight = doc.internal.pageSize.height - 40;
        let y = 20;
        // Parcourir les données dans allData et ajouter chaque question et réponse au document PDF
        s_allData.forEach((data, index)=>{
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `R\xe9ponse: ${data.answer}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + lineHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // // Ajouter la question et la réponse au document PDF
            // doc.text(question, 10, y);
            // y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
            // Séparer la question sur plusieurs lignes si elle est trop longue
            const splitQuestion = doc.splitTextToSize(question, doc.internal.pageSize.width - 20);
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
        });
        fetch("https://api.scgreenoptimizer.fr/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(s_allData)
        }).then((response)=>{
            if (!response.ok) throw new Error("Error saving data to MongoDB");
            history.push("/modernization-1");
        }).catch((error)=>{
            console.error(error);
        // Gérer l'erreur
        });
        // Enregistrer le document PDF
        doc.save("Social Criteria.pdf");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "social-6 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-group-82",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "nav-items-container-48",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                className: navItems3Props.className,
                                frame1172Props: navItems3Props.frame1172Props,
                                frame1162Props: navItems3Props.frame1162Props,
                                frame1132Props: navItems3Props.frame1132Props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count6,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "developpement-et-capital-humain-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "developpement-et-capital-humain-1-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-107-3",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-103",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle1Props.className,
                                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-maintain-a-hi subtitel",
                                                    htmlFor: "doyoumaintainahighlevelofsafetyandphysicalmentalandsocialwell-beingofworkersthenotionofworkerencompassesallpopulationsofemployedworkers_companyemployeessecondedworkersself-employedworkerstemporaryworkerstraineesapprentices",
                                                    children: "Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you maintain a high level of safety and physical, mental and social well-being of workers (the notion of worker encompasses all populations of employed workers: company employees, seconded workers, self-employed workers, temporary workers, trainees, apprentices...)?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "are-staff-trained-in subtitel",
                                                    htmlFor: "arestafftrainedinoccupationalhealthandsafety",
                                                    children: "Are staff trained in occupational health and safety?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Are staff trained in occupational health and safety?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Are staff trained in occupational health and safety?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Are staff trained in occupational health and safety?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Are staff trained in occupational health and safety?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Are staff trained in occupational health and safety?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Are staff trained in occupational health and safety?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "is-there-a-budget-for-health-and-safety subtitel",
                                                    htmlFor: "isthereabudgetforhealthandsafety",
                                                    children: "Is there a budget for health and safety?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Is there a budget for health and safety?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Is there a budget for health and safety?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Is there a budget for health and safety?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Is there a budget for health and safety?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Is there a budget for health and safety?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Is there a budget for health and safety?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "developpement-et-capital-humain-2-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-prevent-and-p subtitel",
                                            htmlFor: "doyoupreventandprotectemployeesfromnegativehealtheffectsresultingfromworkingconditions",
                                            children: "Do you prevent and protect employees from negative health effects resulting from working conditions?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you prevent and protect employees from negative health effects resulting from working conditions?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you prevent and protect employees from negative health effects resulting from working conditions?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you prevent and protect employees from negative health effects resulting from working conditions?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "developpement-et-capital-humain-2-item subtitel",
                                            htmlFor: "arejobdescriptionsprovidedtopreventionworkersgoodpracticesetc",
                                            children: "Are job descriptions provided to prevention workers (good practices, etc.)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are job descriptions provided to prevention workers (good practices, etc.)?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are job descriptions provided to prevention workers (good practices, etc.)?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are job descriptions provided to prevention workers (good practices, etc.)?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "developpement-et-capital-humain-2-item subtitel",
                                            htmlFor: "percentageofthenumberofdangeroussituationsdealtwithoutofthenumberofdangeroussituationsdetected",
                                            children: "Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Percentage of the number of dangerous situations dealt with out of the number of dangerous situations detected"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "developpement-et-capital-humain-3-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-work-e subtitel",
                                            htmlFor: "doyouhaveaworkenvironmentthatisadaptedtothephysiologicalandpsychologicalneedsofworkers",
                                            children: "Do you have a work environment that is adapted to the physiological and psychological needs of workers?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a work environment that is adapted to the physiological and psychological needs of workers?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a work environment that is adapted to the physiological and psychological needs of workers?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a work environment that is adapted to the physiological and psychological needs of workers?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-149",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-8",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "modernization-criteria valign-text-middle inter-bold-mineral-green-18px",
                                children: modernizationCriteria
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social6;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Social6.css":"3A72U","../Social1":"6hRKs","../Social2":"5G3JX","../Social3":"hem2r","../Social4":"kzbDB","../Social5":"5NgzO","jspdf":"cU8oN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3A72U":[function() {},{}],"6hRKs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData1", ()=>s_allData1);
parcelHelpers.export(exports, "s_final", ()=>s_final);
parcelHelpers.export(exports, "yes_Count1", ()=>yes_Count1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame113 = require("../Frame113");
var _frame113Default = parcelHelpers.interopDefault(_frame113);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social1Css = require("./Social1.css");
let s_allData1 = [];
let s_final = 0;
let yes_Count1 = 0;
function Social1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems3Props, frame113Props, frame117Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count1++;
            setYesCount1((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        s_allData1 = s_allData1.concat(data); // Concatène les nouvelles données à allData
        console.log(s_allData1);
        console.log(yes_Count1);
        history.push("/social-2");
        return s_allData1;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "social-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-27",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-27",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-35",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame113Default.default), {
                                            className: frame113Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {
                                            className: frame117Props.className
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "please-answer-the-following-questions-6 valign-text-middle bevan-normal-white-20px",
                    children: pleaseAnswerTheFollowingQuestions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count1,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-limit-any-typ subtitel",
                                            htmlFor: "doyoulimitanytypeofdiscriminationbetweenemployeesinordertoensureequalopportunitiesandequaltreatmentespeciallyformenandwomen",
                                            children: "Limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Limit any type of discrimination between employees, in order to ensure equal opportunities and equal treatment, especially for men and women?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-percen subtitel",
                                            htmlFor: "doyouhaveapercentageofincidentsofdiscriminationthathavebeenremedied",
                                            children: "Do you have a percentage of incidents of discrimination that have been remedied?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a percentage of incidents of discrimination that have been remedied?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a percentage of incidents of discrimination that have been remedied?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a percentage of incidents of discrimination that have been remedied?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "what-is-it subtitel",
                                            htmlFor: "whatisit",
                                            children: "Which one is it?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Which one is it?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Which one is it?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Which one is it?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Which one is it?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Which one is it?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Which one is it?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-promote-stabi subtitel",
                                            htmlFor: "doyoupromotestabilityofemploymentandthereforeofemploymentcontractsdoesthisobjectivealsoincludeanticipatingsituationsthatmayaffectemploymentinthecompany",
                                            children: "Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-prefer-to-hir subtitel",
                                            name: "doyouprefertohirepermanentemployees",
                                            children: "Do you prefer to hire permanent employees?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you prefer to hire permanent employees?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you prefer to hire permanent employees?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you prefer to hire permanent employees?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you prefer to hire permanent employees?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you prefer to hire permanent employees?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you prefer to hire permanent employees?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-turnover subtitel",
                                            name: "doyouhaveturnover",
                                            children: "Do you have turnover?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have turnover?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have turnover?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have turnover?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have turnover?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have turnover?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have turnover?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "what-is-your-turnover-rate-over-a-year subtitel",
                                            name: "whatisyourturnoverrateoverayear",
                                            children: "What is your turnover rate over the year?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("What is your turnover rate over the year?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["What is your turnover rate over the year?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["What is your turnover rate over the year?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("What is your turnover rate over the year?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["What is your turnover rate over the year?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["What is your turnover rate over the year?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-74",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../Frame113":"4Bjb1","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Toggle":"8ZCQM","./Social1.css":"6uCkj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6uCkj":[function() {},{}],"5G3JX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData2", ()=>s_allData2);
parcelHelpers.export(exports, "yes_Count2", ()=>yes_Count2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social2Css = require("./Social2.css");
let s_allData2 = [];
let yes_Count2 = 0;
function Social2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count2++;
            setYesCount2((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
            //return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        s_allData2 = s_allData2.concat(data); // Concatène les nouvelles données à allData
        console.log(s_allData2);
        console.log(yes_Count2);
        history.push("/social-3");
        return s_allData2;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "social-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-36",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-35",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-14",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count2,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploi-relation-employeur-employ-3-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle1Props.className,
                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question",
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "do-you-comply-with-t subtitel",
                                    htmlFor: "doyoucomplywiththefundamentalprinciplesoftheinternationallabourorganisationandreinforcethelawsregulationsandcollectiveagreementsinforceinthecountry",
                                    children: "Do you comply with the fundamental principles of the International Labour Organisation and reinforce the laws, regulations and collective agreements in force in the country?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ouinon-45 ouinon-1-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: ()=>clicked("Do you comply with the fundamental principles of the International Labour Organisation and reinforce the laws, regulations and collective agreements in force in the country?", "Yes"),
                                            type: "button",
                                            value: "Yes",
                                            className: `frame-4-5 ${selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation and reinforce the laws, regulations and collective agreements in force in the country?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation and reinforce the laws, regulations and collective agreements in force in the country?"] === "No"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: ()=>clicked("Do you comply with the fundamental principles of the International Labour Organisation and reinforce the laws, regulations and collective agreements in force in the country?", "No"),
                                            type: "button",
                                            value: "No",
                                            className: `frame-4-6 ${selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation and reinforce the laws, regulations and collective agreements in force in the country?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Do you comply with the fundamental principles of the International Labour Organisation and reinforce the laws, regulations and collective agreements in force in the country?"] === "Yes"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question",
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "have-you-conducted-e subtitel",
                                    htmlFor: "haveyouconductedemployeesurveysonthecollectiveagreement",
                                    children: "Have you conducted employee surveys on the collective agreement?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ouinon-45 ouinon-1-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: ()=>clicked("Have you conducted employee surveys on the collective agreement?", "Yes"),
                                            type: "button",
                                            value: "Yes",
                                            className: `frame-4-5 ${selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "No"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: ()=>clicked("Have you conducted employee surveys on the collective agreement?", "No"),
                                            type: "button",
                                            value: "No",
                                            className: `frame-4-6 ${selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Have you conducted employee surveys on the collective agreement?"] === "Yes"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            className: "question",
                            style: {
                                textAlign: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "does-the-work-perfor subtitel",
                                    htmlFor: "doestheworkperformedrespectthelegalframeworkofthestatutesinvolvedintheemploymentcontract",
                                    children: "Does the work performed respect the legal framework of the statutes involved in the employment contract?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ouinon-45 ouinon-1-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: ()=>clicked("Does the work performed respect the legal framework of the statutes involved in the employment contract?", "Yes"),
                                            type: "button",
                                            value: "Yes",
                                            className: `frame-4-5 ${selectedOptions["Does the work performed respect the legal framework of the statutes involved in the employment contract?"] === "Yes" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Does the work performed respect the legal framework of the statutes involved in the employment contract?"] === "No"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: ()=>clicked("Does the work performed respect the legal framework of the statutes involved in the employment contract?", "No"),
                                            type: "button",
                                            value: "No",
                                            className: `frame-4-6 ${selectedOptions["Does the work performed respect the legal framework of the statutes involved in the employment contract?"] === "No" ? "enabled" : ""}`,
                                            disabled: selectedOptions["Does the work performed respect the legal framework of the statutes involved in the employment contract?"] === "Yes"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-83",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle2Props.className,
                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Social2.css":"7g3pT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7g3pT":[function() {},{}],"hem2r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData3", ()=>s_allData3);
parcelHelpers.export(exports, "yes_Count3", ()=>yes_Count3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social3Css = require("./Social3.css");
let s_allData3 = [];
let yes_Count3 = 0;
function Social3(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount3, setYesCount3] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count3++;
            setYesCount3((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
            //return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        s_allData3 = s_allData3.concat(data); // Concatène les nouvelles données à allData
        console.log(s_allData3);
        console.log(yes_Count3);
        history.push("/social-4");
        return s_allData3;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "social-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-80",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-79",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-44",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count3,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "conditions-de-travai",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "conditions-de-travai-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-124",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-101",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle1Props.className,
                                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-listen-to-wor subtitel",
                                                    htmlFor: "doyoulistentoworkersintheorganisationofworkingtimerhythmanticipationarticulationtemporality",
                                                    children: "Do you listen to workers in the organisation of working time (rhythm, anticipation, articulation, temporality)?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you listen to workers in the organisation of working time (rhythm, anticipation, articulation, temporality)?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you listen to workers in the organisation of working time (rhythm, anticipation, articulation, temporality)?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you listen to workers in the organisation of working time (rhythm, anticipation, articulation, temporality)?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you listen to workers in the organisation of working time (rhythm, anticipation, articulation, temporality)?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you listen to workers in the organisation of working time (rhythm, anticipation, articulation, temporality)?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you listen to workers in the organisation of working time (rhythm, anticipation, articulation, temporality)?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-conduct-at-le subtitel",
                                                    htmlFor: "doyouconductatleastoneemployeesurveyperyear",
                                                    children: "Do you carry out at least one employee survey per year?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you carry out at least one employee survey per year?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you carry out at least one employee survey per year?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you carry out at least one employee survey per year?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you carry out at least one employee survey per year?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you carry out at least one employee survey per year?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you carry out at least one employee survey per year?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "conditions-de-travai-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-promote-stabi-1 subtitel",
                                            name: "doyoupromotestabilityofemploymentandthereforeofemploymentcontractsdoesthisobjectivealsoincludeanticipatingsituationsthatmayaffectemploymentinthecompany",
                                            children: "Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you promote stability of employment, and therefore of employment contracts? Does this objective also include anticipating situations that may affect employment in the company?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-offer-adapted subtitel",
                                            htmlFor: "doyouofferadaptedschedulestoyouremployeesinneed",
                                            children: "Do you offer adapted schedules to your employees in need?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you offer adapted schedules to your employees in need?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you offer adapted schedules to your employees in need?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you offer adapted schedules to your employees in need?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you offer adapted schedules to your employees in need?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you offer adapted schedules to your employees in need?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you offer adapted schedules to your employees in need?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-ensure-decent subtitel",
                                            htmlFor: "doyouensuredecentworkingconditionstakingintoaccountthespecificitiesoftheareaswherethecompanyislocatedgenerallevelofsalariesinthecountrieswherethecompanyislocatedcostoflivingadvantagesconferredbythesocialsecuritysystemsinplace",
                                            children: "Do you ensure decent working conditions, taking into account the specificities of the areas where the company is located (general level of salaries in the countries where the company is located, cost of living, advantages conferred by the social security systems in place...)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you ensure decent working conditions, taking into account the specificities of the areas where the company is located (general level of salaries in the countries where the company is located, cost of living, advantages conferred by the social security systems in place...)?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you ensure decent working conditions, taking into account the specificities of the areas where the company is located (general level of salaries in the countries where the company is located, cost of living, advantages conferred by the social security systems in place...)?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you ensure decent working conditions, taking into account the specificities of the areas where the company is located (general level of salaries in the countries where the company is located, cost of living, advantages conferred by the social security systems in place...)?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you ensure decent working conditions, taking into account the specificities of the areas where the company is located (general level of salaries in the countries where the company is located, cost of living, advantages conferred by the social security systems in place...)?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you ensure decent working conditions, taking into account the specificities of the areas where the company is located (general level of salaries in the countries where the company is located, cost of living, advantages conferred by the social security systems in place...)?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you ensure decent working conditions, taking into account the specificities of the areas where the company is located (general level of salaries in the countries where the company is located, cost of living, advantages conferred by the social security systems in place...)?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-145",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Social3.css":"8F5fB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8F5fB":[function() {},{}],"kzbDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s_allData4", ()=>s_allData4);
parcelHelpers.export(exports, "yes_Count4", ()=>yes_Count4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _social4Css = require("./Social4.css");
let s_allData4 = [];
let yes_Count4 = 0;
function Social4(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount4, setYesCount4] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count4++;
            setYesCount4((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        yes_Count4 = setYesCount4;
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
            //return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        s_allData4 = s_allData4.concat(data); // Concatène les nouvelles données à allData
        console.log(s_allData4);
        console.log(yes_Count4);
        history.push("/social-5");
        return s_allData4;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "social-4 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-51",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-81",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-47",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count4,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "dialogue-social-1-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "dialogue-social-1-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-107-2",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-102",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle1Props.className,
                                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-have-organisa subtitel",
                                                    htmlFor: "doyouhaveorganisationsthatlistentoemployeesinordertoanticipatetransformationsandchangesintheexpectationsofnewgenerationsincludingtheirrelationshipwithwork",
                                                    children: "Do you have organisations that listen to employees in order to anticipate transformations and changes in the expectations of new generations, including their relationship with work?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you have organisations that listen to employees in order to anticipate transformations and changes in the expectations of new generations, including their relationship with work?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you have organisations that listen to employees in order to anticipate transformations and changes in the expectations of new generations, including their relationship with work?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you have organisations that listen to employees in order to anticipate transformations and changes in the expectations of new generations, including their relationship with work?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you have organisations that listen to employees in order to anticipate transformations and changes in the expectations of new generations, including their relationship with work?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you have organisations that listen to employees in order to anticipate transformations and changes in the expectations of new generations, including their relationship with work?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you have organisations that listen to employees in order to anticipate transformations and changes in the expectations of new generations, including their relationship with work?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-have-employees-representatives subtitel",
                                                    htmlFor: "doyouhaveemployeesrepresentatives",
                                                    children: "Do you have employees' representatives?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you have employees' representatives?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you have employees' representatives?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you have employees' representatives?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you have employees' representatives?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you have employees' representatives?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you have employees' representatives?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "does-your-company-have-any-trade-unions subtitel",
                                                    htmlFor: "doesyourcompanyhaveanytradeunions",
                                                    children: "Does your company have any trade unions?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Does your company have any trade unions?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Does your company have any trade unions?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Does your company have any trade unions?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Does your company have any trade unions?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Does your company have any trade unions?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Does your company have any trade unions?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dialogue-social-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "dialogue-social-2-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle2Props.className,
                                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "are-employees-involv subtitel",
                                                    htmlFor: "areemployeesinvolvedinthediscussionsthatleadtodecisionsinthecompany",
                                                    children: "Are employees involved in the discussions that lead to in the company?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Are employees involved in the discussions that lead to in the company?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Are employees involved in the discussions that lead to in the company?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Are employees involved in the discussions that lead to in the company?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Are employees involved in the discussions that lead to in the company?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Are employees involved in the discussions that lead to in the company?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Are employees involved in the discussions that lead to in the company?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "are-employees-integr subtitel",
                                                    htmlFor: "areemployeesintegratedintothesocialdialogueinthecompany",
                                                    children: "Are employees integrated into the social dialogue in the company?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Are employees integrated into the social dialogue in the company?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Are employees integrated into the social dialogue in the company?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Are employees integrated into the social dialogue in the company?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Are employees integrated into the social dialogue in the company?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Are employees integrated into the social dialogue in the company?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Are employees integrated into the social dialogue in the company?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "dialogue-social-3-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle3Props.className,
                                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-promote-excha subtitel",
                                                    htmlFor: "doyoupromoteexchangesoneconomicandsocialissueswithinthecompanythroughnegotiationsconsultationsandinformationexchangebetweenemployersmanagersandemployees",
                                                    children: "Do you promote exchanges on economic and social issues within the company, through negotiations, consultations and information exchange between employers, managers and employees?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you promote exchanges on economic and social issues within the company, through negotiations, consultations and information exchange between employers, managers and employees?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you promote exchanges on economic and social issues within the company, through negotiations, consultations and information exchange between employers, managers and employees?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you promote exchanges on economic and social issues within the company, through negotiations, consultations and information exchange between employers, managers and employees?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you promote exchanges on economic and social issues within the company, through negotiations, consultations and information exchange between employers, managers and employees?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you promote exchanges on economic and social issues within the company, through negotiations, consultations and information exchange between employers, managers and employees?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you promote exchanges on economic and social issues within the company, through negotiations, consultations and information exchange between employers, managers and employees?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-148",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Social4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Social4.css":"4lEwY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4lEwY":[function() {},{}],"jhgCb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_sum", ()=>e_sum);
parcelHelpers.export(exports, "yes_Count5", ()=>yes_Count5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _environmental5Css = require("./Environmental5.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _environmental1 = require("../Environmental1");
var _environmental2 = require("../Environmental2");
var _environmental3 = require("../Environmental3");
var _environmental4 = require("../Environmental4");
let e_sum = 0;
let yes_Count5 = 0;
function Environmental5(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount5, setYesCount5] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20082, socialCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    //let e_yesCount5 = 0;
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count5++;
            setYesCount5((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let e_allData5 = [];
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        e_allData5 = e_allData5.concat(data); // Concatenate the new data to e_allData5
        const e_allData = (0, _environmental1.e_allData1).concat((0, _environmental2.e_allData2), (0, _environmental3.e_allData3), (0, _environmental4.e_allData4), e_allData5); // Update e_allData
        e_sum = (0, _environmental1.yes_Count1) + (0, _environmental2.yes_Count2) + (0, _environmental3.yes_Count3) + (0, _environmental4.yes_Count4) + yes_Count5;
        console.log(e_allData5);
        console.log(e_allData);
        generatePdf(e_allData); // Call the generatePdf function with the updated array
        history.push("/Social-1");
    }
    function generatePdf(e_allData) {
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 20;
        const pageHeight = doc.internal.pageSize.height - 40;
        let y = 20;
        // Parcourir les données dans e_allData et ajouter chaque question et réponse au document PDF
        e_allData.forEach((data, index)=>{
            const crit\u00e8re = "Environmental Criteria";
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `R\xe9ponse: ${data.answer}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + lineHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // // Ajouter la question et la réponse au document PDF
            // doc.text(question, 10, y);
            // y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
            // Séparer la question sur plusieurs lignes si elle est trop longue
            const splitQuestion = doc.splitTextToSize(question, doc.internal.pageSize.width - 20);
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
        });
        fetch("https://api.scgreenoptimizer.fr/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e_allData)
        }).then((response)=>{
            if (!response.ok) throw new Error("Error saving data to MongoDB");
            history.push("/social-1");
        }).catch((error)=>{
            console.error(error);
        // Gérer l'erreur
        });
        // Enregistrer le document PDF
        doc.save("Environement-Criteria.pdf");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-5 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-79",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-2",
                                src: x1200PxLogo_Icam__20082,
                                alt: "1200px-Logo_ICAM_-_2008 2"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-43",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count5,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-49",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-119",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "prparez-vous-ladapta subtitel",
                                            htmlFor: "pr\xe9parez-vousladaptationdevosactivit\xe9slogistiquesauxpotentiels\xe9venementsextr\xe8mesli\xe9saurechauffementclimatique",
                                            children: "Are you preparing to adapt your logistics activities to potential extreme events related to global warming?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are you preparing to adapt your logistics activities to potential extreme events related to global warming?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Are you preparing to adapt your logistics activities to potential extreme events related to global warming?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are you preparing to adapt your logistics activities to potential extreme events related to global warming?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are you preparing to adapt your logistics activities to potential extreme events related to global warming?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Are you preparing to adapt your logistics activities to potential extreme events related to global warming?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are you preparing to adapt your logistics activities to potential extreme events related to global warming?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-tabli-un-bilan-carbone subtitel",
                                            htmlFor: "avez-vous\xe9tabliunbilancarbone",
                                            children: "Have you established a carbon footprint?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have you established a carbon footprint?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Have you established a carbon footprint?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have you established a carbon footprint?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have you established a carbon footprint?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Have you established a carbon footprint?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have you established a carbon footprint?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-120",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "maitrisez-et-limitez-3 subtitel",
                                            htmlFor: "maitrisezetlimitez-vouslesautresnuissancessonoresolfactif\xe9clairagenocturneetleurimpactsurlespopulations",
                                            children: "Do you control and limit other nuisances (noise, smell, night lighting) and their impact on the population?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you control and limit other nuisances (noise, smell, night lighting) and their impact on the population?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you control and limit other nuisances (noise, smell, night lighting) and their impact on the population?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you control and limit other nuisances (noise, smell, night lighting) and their impact on the population?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you control and limit other nuisances (noise, smell, night lighting) and their impact on the population?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you control and limit other nuisances (noise, smell, night lighting) and their impact on the population?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you control and limit other nuisances (noise, smell, night lighting) and their impact on the population?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-dj-effectu subtitel",
                                            htmlFor: "avez-vousd\xe9j\xe0effectu\xe9desenqu\xeatesaupr\xe8sdesriverainsafindereccueillirleurressenticoncernantcesnuissances",
                                            children: "Have you ever conducted surveys of local residents to find out how they feel about the noise?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have you ever conducted surveys of local residents to find out how they feel about the noise?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Have you ever conducted surveys of local residents to find out how they feel about the noise?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have you ever conducted surveys of local residents to find out how they feel about the noise?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have you ever conducted surveys of local residents to find out how they feel about the noise?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Have you ever conducted surveys of local residents to find out how they feel about the noise?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have you ever conducted surveys of local residents to find out how they feel about the noise?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-dj-mesurer subtitel",
                                            htmlFor: "avez-vousd\xe9j\xe0mesurerleniveausonoredevotreflottedev\xe9hicule",
                                            children: "Have you ever measured the noise level of your vehicle fleet?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have you ever measured the noise level of your vehicle fleet?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Have you ever measured the noise level of your vehicle fleet?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have you ever measured the noise level of your vehicle fleet?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have you ever measured the noise level of your vehicle fleet?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Have you ever measured the noise level of your vehicle fleet?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have you ever measured the noise level of your vehicle fleet?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-144",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "social-criteria valign-text-middle inter-bold-mineral-green-18px",
                                children: socialCriteria
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental5;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Environmental5.css":"api4M","jspdf":"cU8oN","../Environmental1":"eHkL6","../Environmental2":"ex2EC","../Environmental3":"fuBbu","../Environmental4":"hDixB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"api4M":[function() {},{}],"ex2EC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData2", ()=>e_allData2);
parcelHelpers.export(exports, "yes_Count2", ()=>yes_Count2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _environmental2Css = require("./Environmental2.css");
let e_allData2 = [];
let yes_Count2 = 0;
function Environmental2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count2++;
            setYesCount2((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        setErrorMessage("");
        e_allData2 = e_allData2.concat(data); // Concatène les nouvelles données à allData
        console.log(e_allData2);
        console.log(yes_Count2);
        history.push("/environmental-3");
        return e_allData2;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "nav-items-container-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pollutions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-34",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pollution-de-leau-et-des-sols",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-137",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                className: toggle1Props.className,
                                                buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "maitrisez-et-limitez subtitel",
                                                    htmlFor: "maitrisezetlimitez-vousles\xe9missionsdepolluantsliquidesdansleauetlessolsli\xe9es\xe0vosactivit\xe9s",
                                                    children: "Maitrisez et limitez-vous les \xe9missions de polluants liquides dans l'eau et les sols li\xe9es \xe0 vos activit\xe9s ?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Maitrisez et limitez-vous les \xe9missions de polluants liquides dans l'eau et les sols li\xe9es \xe0 vos activit\xe9s ?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Maitrisez et limitez-vous les \xe9missions de polluants liquides dans l'eau et les sols li\xe9es \xe0 vos activit\xe9s ?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Maitrisez et limitez-vous les \xe9missions de polluants liquides dans l'eau et les sols li\xe9es \xe0 vos activit\xe9s ?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Maitrisez et limitez-vous les \xe9missions de polluants liquides dans l'eau et les sols li\xe9es \xe0 vos activit\xe9s ?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Maitrisez et limitez-vous les \xe9missions de polluants liquides dans l'eau et les sols li\xe9es \xe0 vos activit\xe9s ?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Maitrisez et limitez-vous les \xe9missions de polluants liquides dans l'eau et les sols li\xe9es \xe0 vos activit\xe9s ?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "suivez-vous-votre-volume-deau-consomm subtitel",
                                                    htmlFor: "suivezvousvotrevolumedeauconsomm\xe9",
                                                    children: "Suivez vous votre volume d'eau consomm\xe9 ?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Suivez vous votre volume d'eau consomm\xe9 ?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Suivez vous votre volume d'eau consomm\xe9 ?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Suivez vous votre volume d'eau consomm\xe9 ?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Suivez vous votre volume d'eau consomm\xe9 ?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Suivez vous votre volume d'eau consomm\xe9 ?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Suivez vous votre volume d'eau consomm\xe9 ?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "avez-vous-investis-d subtitel",
                                                    htmlFor: "avez-vousinvestisdansdestechnologiesder\xe9cup\xe9rationettraitementdeseaux",
                                                    children: "Avez-vous investis dans des technologies de r\xe9cup\xe9ration et traitement des eaux ?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Avez-vous investis dans des technologies de r\xe9cup\xe9ration et traitement des eaux ?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Avez-vous investis dans des technologies de r\xe9cup\xe9ration et traitement des eaux ?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Avez-vous investis dans des technologies de r\xe9cup\xe9ration et traitement des eaux ?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Avez-vous investis dans des technologies de r\xe9cup\xe9ration et traitement des eaux ?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Avez-vous investis dans des technologies de r\xe9cup\xe9ration et traitement des eaux ?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Avez-vous investis dans des technologies de r\xe9cup\xe9ration et traitement des eaux ?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            className: "question",
                                            style: {
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "avez-vous-un-budget-1 subtitel",
                                                    htmlFor: "avez-vousunbudgetpourluttercontrelapollutiondeseauxetdessols",
                                                    children: "Avez-vous un budget pour lutter contre la pollution des eaux et des sols ?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Avez-vous un budget pour lutter contre la pollution des eaux et des sols ?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Avez-vous un budget pour lutter contre la pollution des eaux et des sols ?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Avez-vous un budget pour lutter contre la pollution des eaux et des sols ?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Avez-vous un budget pour lutter contre la pollution des eaux et des sols ?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Avez-vous un budget pour lutter contre la pollution des eaux et des sols ?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Avez-vous un budget pour lutter contre la pollution des eaux et des sols ?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-130-4"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pollution-de-lair",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-138-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                        className: toggle2Props.className,
                                        buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "maitrisez-et-limitez-1 subtitel",
                                            htmlFor: "maitrisezetlimitezvousles\xe9missionsdepolluantsatmosph\xe9riquesli\xe9es\xe0vosactivit\xe9s",
                                            children: "Maitrisez et limitez vous les \xe9missions de polluants atmosph\xe9riques li\xe9es \xe0 vos activit\xe9s?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Maitrisez et limitez vous les \xe9missions de polluants atmosph\xe9riques li\xe9es \xe0 vos activit\xe9s?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Maitrisez et limitez vous les \xe9missions de polluants atmosph\xe9riques li\xe9es \xe0 vos activit\xe9s?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Maitrisez et limitez vous les \xe9missions de polluants atmosph\xe9riques li\xe9es \xe0 vos activit\xe9s?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Maitrisez et limitez vous les \xe9missions de polluants atmosph\xe9riques li\xe9es \xe0 vos activit\xe9s?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Maitrisez et limitez vous les \xe9missions de polluants atmosph\xe9riques li\xe9es \xe0 vos activit\xe9s?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Maitrisez et limitez vous les \xe9missions de polluants atmosph\xe9riques li\xe9es \xe0 vos activit\xe9s?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "suivez-vous-la-conso subtitel",
                                            htmlFor: "suivez-vouslaconsommationdecarburantdevotreflotterouti\xe8re",
                                            children: "Suivez-vous la consommation de carburant de votre flotte routi\xe8re ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Suivez-vous la consommation de carburant de votre flotte routi\xe8re ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Suivez-vous la consommation de carburant de votre flotte routi\xe8re ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Suivez-vous la consommation de carburant de votre flotte routi\xe8re ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Suivez-vous la consommation de carburant de votre flotte routi\xe8re ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Suivez-vous la consommation de carburant de votre flotte routi\xe8re ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Suivez-vous la consommation de carburant de votre flotte routi\xe8re ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-un-budget-2 subtitel",
                                            htmlFor: "avez-vousunbudgetpourr\xe9duireles\xe9missionsdepolluantsatmosph\xe9riques",
                                            children: "Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "suivez-vous-les-quan subtitel",
                                            htmlFor: "suivez-vouslesquantit\xe9sd\xe9missionsdespolluantsatmosph\xe9riques",
                                            children: "Suivez-vous les quantit\xe9s d'\xe9missions des polluants atmosph\xe9riques ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Suivez-vous les quantit\xe9s d'\xe9missions des polluants atmosph\xe9riques ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Suivez-vous les quantit\xe9s d'\xe9missions des polluants atmosph\xe9riques ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Suivez-vous les quantit\xe9s d'\xe9missions des polluants atmosph\xe9riques ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Suivez-vous les quantit\xe9s d'\xe9missions des polluants atmosph\xe9riques ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Suivez-vous les quantit\xe9s d'\xe9missions des polluants atmosph\xe9riques ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Suivez-vous les quantit\xe9s d'\xe9missions des polluants atmosph\xe9riques ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "formez-vous-les-chauffeurs-lcoconduite subtitel",
                                            htmlFor: "formezvousleschauffeurs\xe0l\xe9coconduite",
                                            children: "Formez vous les chauffeurs \xe0 l'\xe9coconduite ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Formez vous les chauffeurs \xe0 l'\xe9coconduite ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Formez vous les chauffeurs \xe0 l'\xe9coconduite ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Formez vous les chauffeurs \xe0 l'\xe9coconduite ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Formez vous les chauffeurs \xe0 l'\xe9coconduite ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Formez vous les chauffeurs \xe0 l'\xe9coconduite ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Formez vous les chauffeurs \xe0 l'\xe9coconduite ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    className: "question",
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-un-budget-3 subtitel",
                                            htmlFor: "avez-vousunbudgetpourr\xe9duireles\xe9missionsdepolluantsatmosph\xe9riques",
                                            children: "Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?e"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous un budget pour r\xe9duire les \xe9missions de polluants atmosph\xe9riques ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-81",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "yes-count",
                            children: [
                                "Score: ",
                                yes_Count2,
                                " / ",
                                totalQuestions
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-69",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Environmental2.css":"ja2JY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ja2JY":[function() {},{}],"fuBbu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData3", ()=>e_allData3);
parcelHelpers.export(exports, "yes_Count3", ()=>yes_Count3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _environmental3Css = require("./Environmental3.css");
let e_allData3 = [];
let yes_Count3 = 0;
function Environmental3(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount3, setYesCount3] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count3++;
            setYesCount3((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        e_allData3 = e_allData3.concat(data); // Concatène les nouvelles données à allData
        console.log(e_allData3);
        console.log(yes_Count3);
        history.push("/environmental-4");
        return e_allData3;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-35",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-34",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-13",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "yes",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "yes-count",
                        children: [
                            "Score: ",
                            yes_Count3,
                            " / ",
                            totalQuestions
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "energie-biodiversit",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "energie",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "maitrisez-et-limitez-2 subtitel",
                                            htmlFor: "maitrisezetlimitezvousvosconsommationsd\xe9nergies",
                                            children: "Maitrisez et limitez vous vos consommations d'\xe9nergies ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Maitrisez et limitez vous vos consommations d'\xe9nergies ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Maitrisez et limitez vous vos consommations d'\xe9nergies ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Maitrisez et limitez vous vos consommations d'\xe9nergies ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Maitrisez et limitez vous vos consommations d'\xe9nergies ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Maitrisez et limitez vous vos consommations d'\xe9nergies ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Maitrisez et limitez vous vos consommations d'\xe9nergies ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "mesurez-vous-votre-c subtitel",
                                            htmlFor: "mesurez-vousvotreconsommation\xe9nerg\xe9tiqueaum2",
                                            children: "Mesurez-vous votre consommation \xe9nerg\xe9tique au m\xe8tre carr\xe9 ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Mesurez-vous votre consommation \xe9nerg\xe9tique au m\xe8tre carr\xe9 ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Mesurez-vous votre consommation \xe9nerg\xe9tique au m\xe8tre carr\xe9 ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Mesurez-vous votre consommation \xe9nerg\xe9tique au m\xe8tre carr\xe9 ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Mesurez-vous votre consommation \xe9nerg\xe9tique au m\xe8tre carr\xe9 ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Mesurez-vous votre consommation \xe9nerg\xe9tique au m\xe8tre carr\xe9 ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Mesurez-vous votre consommation \xe9nerg\xe9tique au m\xe8tre carr\xe9 ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-pris-des-m subtitel",
                                            htmlFor: "avez-vousprisdesmesuresder\xe9ductiondevotreconsommation\xe9nerg\xe9tique",
                                            children: "Avez-vous pris des mesures de r\xe9duction de votre consommation \xe9nerg\xe9tique ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous pris des mesures de r\xe9duction de votre consommation \xe9nerg\xe9tique ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Avez-vous pris des mesures de r\xe9duction de votre consommation \xe9nerg\xe9tique ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous pris des mesures de r\xe9duction de votre consommation \xe9nerg\xe9tique ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous pris des mesures de r\xe9duction de votre consommation \xe9nerg\xe9tique ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Avez-vous pris des mesures de r\xe9duction de votre consommation \xe9nerg\xe9tique ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous pris des mesures de r\xe9duction de votre consommation \xe9nerg\xe9tique ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "biodiversit",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-des-sites subtitel",
                                            htmlFor: "avez-vousdessitesconcern\xe9sparlacompensation\xe9cologique",
                                            children: "Avez-vous des sites concern\xe9s par la compensation \xe9cologique ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des sites concern\xe9s par la compensation \xe9cologique ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Avez-vous des sites concern\xe9s par la compensation \xe9cologique ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des sites concern\xe9s par la compensation \xe9cologique ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Avez-vous des sites concern\xe9s par la compensation \xe9cologique ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Avez-vous des sites concern\xe9s par la compensation \xe9cologique ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Avez-vous des sites concern\xe9s par la compensation \xe9cologique ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "avez-vous-des-sites-1 subtitel",
                                            htmlFor: "avez-vousdessiteslab\xe9lis\xe9shqebreamleeds",
                                            children: "vez-vous des sites lab\xe9lis\xe9s (HQE, BREAM, LEEDS, ...) ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("vez-vous des sites lab\xe9lis\xe9s (HQE, BREAM, LEEDS, ...) ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["vez-vous des sites lab\xe9lis\xe9s (HQE, BREAM, LEEDS, ...) ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["vez-vous des sites lab\xe9lis\xe9s (HQE, BREAM, LEEDS, ...) ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("vez-vous des sites lab\xe9lis\xe9s (HQE, BREAM, LEEDS, ...) ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["vez-vous des sites lab\xe9lis\xe9s (HQE, BREAM, LEEDS, ...) ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["vez-vous des sites lab\xe9lis\xe9s (HQE, BREAM, LEEDS, ...) ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "favorisez-vous-les-a subtitel",
                                            htmlFor: "favorisezvouslesactionspermettantderestaurerlabiodiversit\xe9",
                                            children: "Favorisez vous les actions permettant de restaurer la biodiversit\xe9 ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Favorisez vous les actions permettant de restaurer la biodiversit\xe9 ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Favorisez vous les actions permettant de restaurer la biodiversit\xe9 ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Favorisez vous les actions permettant de restaurer la biodiversit\xe9 ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Favorisez vous les actions permettant de restaurer la biodiversit\xe9 ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Favorisez vous les actions permettant de restaurer la biodiversit\xe9 ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Favorisez vous les actions permettant de restaurer la biodiversit\xe9 ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-82",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-69",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Ouinon":"b3hbH","../Frame11732":"h8i4O","./Environmental3.css":"5b9rM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3hbH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ouinonCss = require("./Ouinon.css");
function Ouinon(props) {
    const { yes, place, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `ouinon-45 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-4-5",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "yes subtitel",
                    children: yes
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "frame-4-6",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "place-80 subtitel",
                    children: place
                })
            })
        ]
    });
}
exports.default = Ouinon;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Ouinon.css":"5QZdu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QZdu":[function() {},{}],"5b9rM":[function() {},{}],"hDixB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e_allData4", ()=>e_allData4);
parcelHelpers.export(exports, "yes_Count4", ()=>yes_Count4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon2 = require("../Ouinon2");
var _ouinon2Default = parcelHelpers.interopDefault(_ouinon2);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _environmental4Css = require("./Environmental4.css");
let e_allData4 = [];
let yes_Count4 = 0;
function Environmental4(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount4, setYesCount4] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20082, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, navItems3Props, toggle1Props, ouinon21Props, ouinon22Props, toggle2Props, ouinon23Props, ouinon24Props, toggle3Props, ouinon1Props, ouinon2Props, ouinon3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            yes_Count4++;
            setYesCount4((prevYesCount)=>prevYesCount + 1);
        }
    /*
    const button = event.target; // Récupère le bouton qui a été cliqué
    if (button.classList.contains("frame-4-5")) {
      // Vérifie si c'est un bouton 'oui'
      e_yesCount4++; // Incrémente le compteur de bouton 'Oui'
      console.log(`Number of yesButton selected: ${e_yesCount4}`); // Affiche le nombre de boutons 'Oui' sélectionnés
      button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
      button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
    } else if (button.classList.contains("frame-4-6")) {
      // Vérifie si c'est un bouton 'non'

      button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
      button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
    }
    */ }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        e_allData4 = e_allData4.concat(data); // Concatène les nouvelles données à allData
        console.log(e_allData4);
        console.log(yes_Count4);
        history.push("/environmental-5");
        return e_allData4;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "environmental-4 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-50",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-2-1",
                                src: x1200PxLogo_Icam__20082,
                                alt: "1200px-Logo_ICAM_-_2008 2"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-45",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yes_Count4,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-122-1",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "group-container-3",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-106",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-107-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle1Props.className,
                                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "essayez-vous-de-rdui subtitel",
                                                    htmlFor: "essayez-vousder\xe9duireaumaximumvotreg\xe9n\xe9rationded\xe9chets",
                                                    children: "Do you try to reduce your waste generation as much as possible?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you try to reduce your waste generation as much as possible?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you try to reduce your waste generation as much as possible?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you try to reduce your waste generation as much as possible?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you try to reduce your waste generation as much as possible?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you try to reduce your waste generation as much as possible?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you try to reduce your waste generation as much as possible?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "importez-exportez-ou subtitel",
                                                    htmlFor: "importezexportezoutraitez-vousdesd\xe9chetsconsid\xe9r\xe9scommedangereux",
                                                    children: "Do you import, export or treat waste that is considered hazardous?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you import, export or treat waste that is considered hazardous?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you import, export or treat waste that is considered hazardous?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you import, export or treat waste that is considered hazardous?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you import, export or treat waste that is considered hazardous?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you import, export or treat waste that is considered hazardous?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you import, export or treat waste that is considered hazardous?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group-108",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                        className: toggle2Props.className,
                                        buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "favorisez-vous-le-r subtitel",
                                                htmlFor: "favorisez-vousler\xe9-emploieauboiscarton",
                                                children: "Do you encourage re-use (water, wood, cardboard, etc.)?"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "ouinon-45 ouinon-1-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you encourage re-use (water, wood, cardboard, etc.)?", "Yes"),
                                                        type: "button",
                                                        value: "Yes",
                                                        className: `frame-4-5 ${selectedOptions["Do you encourage re-use (water, wood, cardboard, etc.)?"] === "Yes" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you encourage re-use (water, wood, cardboard, etc.)?"] === "No"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you encourage re-use (water, wood, cardboard, etc.)?", "No"),
                                                        type: "button",
                                                        value: "No",
                                                        className: `frame-4-6 ${selectedOptions["Do you encourage re-use (water, wood, cardboard, etc.)?"] === "No" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you encourage re-use (water, wood, cardboard, etc.)?"] === "Yes"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "quel-est-le-pourcent-1 subtitel",
                                                placeholder: inputPlaceholder4,
                                                type: inputType4,
                                                children: "What percentage of your packaging is reusable?"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "ouinon-45 ouinon-1-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("What percentage of your packaging is reusable?", "Yes"),
                                                        type: "button",
                                                        value: "Yes",
                                                        className: `frame-4-5 ${selectedOptions["What percentage of your packaging is reusable?"] === "Yes" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["What percentage of your packaging is reusable?"] === "No"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("What percentage of your packaging is reusable?", "No"),
                                                        type: "button",
                                                        value: "No",
                                                        className: `frame-4-6 ${selectedOptions["What percentage of your packaging is reusable?"] === "No" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["What percentage of your packaging is reusable?"] === "Yes"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group-109",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                        className: toggle3Props.className,
                                        buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "favorisez-vous-le-re subtitel",
                                                name: "favorisez-vouslerecyclagedevosd\xe9chets",
                                                placeholder: inputPlaceholder5,
                                                type: inputType5,
                                                children: "Do you promote the recycling of your waste?"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "ouinon-45 ouinon-1-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you promote the recycling of your waste?", "Yes"),
                                                        type: "button",
                                                        value: "Yes",
                                                        className: `frame-4-5 ${selectedOptions["Do you promote the recycling of your waste?"] === "Yes" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you promote the recycling of your waste?"] === "No"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you promote the recycling of your waste?", "No"),
                                                        type: "button",
                                                        value: "No",
                                                        className: `frame-4-6 ${selectedOptions["Do you promote the recycling of your waste?"] === "No" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you promote the recycling of your waste?"] === "Yes"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "vendez-vous-vos-dchets-valorisables subtitel",
                                                htmlFor: "vendez-vousvosd\xe9chetsvalorisables",
                                                placeholder: inputPlaceholder6,
                                                type: inputType6,
                                                children: "Do you sell your recyclable waste?"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "ouinon-45 ouinon-1-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you sell your recyclable waste?", "Yes"),
                                                        type: "button",
                                                        value: "Yes",
                                                        className: `frame-4-5 ${selectedOptions["Do you sell your recyclable waste?"] === "Yes" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you sell your recyclable waste?"] === "No"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you sell your recyclable waste?", "No"),
                                                        type: "button",
                                                        value: "No",
                                                        className: `frame-4-6 ${selectedOptions["Do you sell your recyclable waste?"] === "No" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you sell your recyclable waste?"] === "Yes"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                className: "avez-vous-des-parten subtitel",
                                                htmlFor: "avez-vousdespartenariatspermettantlasecondeviedevosproduits",
                                                children: "Do you have partnerships for the second life of your products?"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "ouinon-45 ouinon-1-1",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you have partnerships for the second life of your products?", "Yes"),
                                                        type: "button",
                                                        value: "Yes",
                                                        className: `frame-4-5 ${selectedOptions["DDo you have partnerships for the second life of your products?"] === "Yes" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you have partnerships for the second life of your products?"] === "No"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        onClick: ()=>clicked("Do you have partnerships for the second life of your products?", "No"),
                                                        type: "button",
                                                        value: "No",
                                                        className: `frame-4-6 ${selectedOptions["Do you have partnerships for the second life of your products?"] === "No" ? "enabled" : ""}`,
                                                        disabled: selectedOptions["Do you have partnerships for the second life of your products?"] === "Yes"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-146",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-69",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Environmental4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Ouinon2":"9zAK6","../Ouinon":"b3hbH","../Frame11732":"h8i4O","./Environmental4.css":"lFkog","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zAK6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame42 = require("../Frame42");
var _frame42Default = parcelHelpers.interopDefault(_frame42);
var _frame43 = require("../Frame43");
var _frame43Default = parcelHelpers.interopDefault(_frame43);
var _ouinon2Css = require("./Ouinon2.css");
function Ouinon2(props) {
    const { className, frame42Props, frame43Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `ouinon-48 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame42Default.default), {
                className: frame42Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame43Default.default), {
                className: frame43Props.className
            })
        ]
    });
}
exports.default = Ouinon2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame42":"7XDkF","../Frame43":"663q0","./Ouinon2.css":"bWCbg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7XDkF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame42Css = require("./Frame42.css");
function Frame42(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-4-52-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "yes-37 subtitel",
            children: "Yes"
        })
    });
}
exports.default = Frame42;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame42.css":"2zWss","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2zWss":[function() {},{}],"663q0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame43Css = require("./Frame43.css");
function Frame43(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-4-60 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "place-251 subtitel",
            children: "No"
        })
    });
}
exports.default = Frame43;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame43.css":"1iIHE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1iIHE":[function() {},{}],"bWCbg":[function() {},{}],"lFkog":[function() {},{}],"b543i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_sum", ()=>m_sum);
parcelHelpers.export(exports, "m_yesCount4", ()=>m_yesCount4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _modernization4Css = require("./Modernization4.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _modernization1 = require("../Modernization1");
var _modernization2 = require("../Modernization2");
var _modernization3 = require("../Modernization3");
let m_sum = 0;
let m_yesCount4 = 0;
function Modernization4(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount4, setYesCount4] = (0, _react.useState)(0); // Initialize yesCount state
    const [m_totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, inputType6, inputPlaceholder6, leadTimeCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            m_yesCount4++;
            setYesCount4((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let m_allData4 = [];
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        m_allData4 = m_allData4.concat(data); // Concatenate the new data to m_allData4
        const m_allData = (0, _modernization1.m_allData1).concat((0, _modernization2.m_allData2), (0, _modernization3.m_allData3), m_allData4); // Update m_allData
        m_sum = (0, _modernization1.m_yesCount1) + (0, _modernization2.m_yesCount2) + (0, _modernization3.m_yesCount3) + m_yesCount4;
        console.log(m_allData4);
        console.log(m_allData);
        console.log(m_sum);
        generatePdf(m_allData); // Call the generatePdf function with the updated array
        // connect();
        history.push("/lead-time-1");
    }
    function generatePdf(m_allData) {
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 20;
        const pageHeight = doc.internal.pageSize.height - 40;
        let y = 20;
        // Parcourir les données dans m_allData et ajouter chaque question et réponse au document PDF
        m_allData.forEach((data, index)=>{
            const crit\u00e8re = "Environmental Criteria";
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `R\xe9ponse: ${data.answer}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + lineHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // // Ajouter la question et la réponse au document PDF
            // doc.text(question, 10, y);
            // y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
            // Séparer la question sur plusieurs lignes si elle est trop longue
            const splitQuestion = doc.splitTextToSize(question, doc.internal.pageSize.width - 20);
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
        });
        fetch("https://api.scgreenoptimizer.fr/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(m_allData)
        }).then((response)=>{
            if (!response.ok) throw new Error("Error saving data to MongoDB");
            history.push("/lead-time-1");
        }).catch((error)=>{
            console.error(error);
        // Gérer l'erreur
        });
        // Enregistrer le document PDF
        doc.save("Modernization_Criteria.pdf");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "modernization-4 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-84",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-84",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-50",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        yesCount4,
                        " / ",
                        m_totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-14",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-11",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-your-different-s subtitel",
                                            htmlFor: "areyourdifferentsystemsabletocommunicatewitheachother",
                                            children: "Are your different systems able to communicate with each other?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are your different systems able to communicate with each other?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Are your different systems able to communicate with each other?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are your different systems able to communicate with each other?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are your different systems able to communicate with each other?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Are your different systems able to communicate with each other?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are your different systems able to communicate with each other?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-any-means-of-communication subtitel",
                                            htmlFor: "doyouhaveanymeansofcommunication",
                                            children: "Do you have any means of communication?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have any means of communication?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have any means of communication?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have any means of communication?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have any means of communication?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have any means of communication?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have any means of communication?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "emploi-relation-employeur-employ-1-item subtitel",
                                            htmlFor: "isttpaper",
                                            children: "Is it paper?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it paper?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Is it paper?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it paper?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it paper?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Is it paper?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it paper?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "emploi-relation-employeur-employ-1-item subtitel",
                                            htmlFor: "isitoral",
                                            children: "Is it Oral?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it Oral?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Is it Oral?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it Oral?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it Oral?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Is it Oral?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it Oral?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "emploi-relation-employeur-employ-1-item subtitel",
                                            htmlFor: "isitbymail",
                                            children: "Is it by mail?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it by mail?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Is it by mail?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it by mail?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it by mail?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Is it by mail?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it by mail?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "emploi-relation-employeur-employ-1-item subtitel",
                                            htmlFor: "isitanapplicationsuitelikegooglemicrosoft",
                                            placeholder: inputPlaceholder6,
                                            type: inputType6,
                                            children: "Is it an Application Suite like Google , microsoft ?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it an Application Suite like Google , microsoft ?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Is it an Application Suite like Google , microsoft ?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it an Application Suite like Google , microsoft ?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it an Application Suite like Google , microsoft ?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Is it an Application Suite like Google , microsoft ?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it an Application Suite like Google , microsoft ?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "emploi-relation-employeur-employ-1-item subtitel",
                                            htmlFor: "isthedataproducedusedtomakedecisions",
                                            children: "Is the data produced used to make decisions?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is the data produced used to make decisions?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Is the data produced used to make decisions?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is the data produced used to make decisions?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is the data produced used to make decisions?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Is the data produced used to make decisions?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is the data produced used to make decisions?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-operators-have-ac subtitel",
                                            htmlFor: "dooperatorshaveaccesstoanintelligentuserinterface",
                                            children: "Do operators have access to an intelligent user interface?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do operators have access to an intelligent user interface?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do operators have access to an intelligent user interface?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do operators have access to an intelligent user interface?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do operators have access to an intelligent user interface?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do operators have access to an intelligent user interface?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do operators have access to an intelligent user interface?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-151",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-9",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "lead-time-criteria valign-text-middle inter-bold-mineral-green-18px",
                                children: leadTimeCriteria
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Modernization4.css":"jPeZX","jspdf":"cU8oN","../Modernization1":"91YvI","../Modernization2":"eMELU","../Modernization3":"cX9bz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPeZX":[function() {},{}],"91YvI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData1", ()=>m_allData1);
parcelHelpers.export(exports, "m_yesCount1", ()=>m_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _modernization1Css = require("./Modernization1.css");
let m_allData1 = [];
let m_yesCount1 = 0;
function Modernization1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            m_yesCount1++;
            setYesCount1((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        m_allData1 = m_allData1.concat(data); // Concatène les nouvelles données à allData
        console.log(m_allData1);
        console.log(m_yesCount1);
        history.push("/modernization-2");
        return m_allData1;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "modernization-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-28",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-12"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-28",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-7 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        m_yesCount1,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-ai-model subtitel",
                                            htmlFor: "doyouhaveaimodelsthatcansolveproblems",
                                            children: "Do you have AI models that can solve problems?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have AI models that can solve problems?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have AI models that can solve problems?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have AI models that can solve problems?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have AI models that can solve problems?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have AI models that can solve problems?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have AI models that can solve problems?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-use-intellige subtitel",
                                            htmlFor: "doyouuseintelligentagentstosolvesimulationproblems",
                                            children: "Do you use intelligent agents to solve simulation problems?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you use intelligent agents to solve simulation problems?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you use intelligent agents to solve simulation problems?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have subtitel",
                                            htmlFor: "doyouhaveanymodelsforforecastingsales",
                                            children: "Do you have any models for forecasting sales?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have any models for forecasting sales?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have any models for forecasting sales?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have any models for forecasting sales?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have any models for forecasting sales?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have any models for forecasting sales?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have any models for forecasting sales?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have subtitel",
                                            htmlFor: "doyouhavemodelsforsalesforecasting",
                                            children: "Do you have models for sales forecasting?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have models for sales forecasting?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have models for sales forecasting?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have models for sales forecasting?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have models for sales forecasting?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Your Question Here"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have models for sales forecasting?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-models-f subtitel",
                                            htmlFor: "doyouhavemodelsforforecastingpurchases",
                                            children: "Do you have models for forecasting purchases?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have models for forecasting purchases?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have models for forecasting purchases?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have models for forecasting purchases?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have models for forecasting purchases?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have models for forecasting purchases?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have models for forecasting purchases?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-robots-t subtitel",
                                            htmlFor: "doyouhaverobotsthatcanbeautonomousoncomplextasks",
                                            children: "Do you have robots that can be autonomous on complex tasks?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have robots that can be autonomous on complex tasks?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have robots that can be autonomous on complex tasks?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-cybers subtitel",
                                            htmlFor: "doyouhaveacybersecuritysystemusingaimodels",
                                            children: "Do you have a cybersecurity system using AI models?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a cybersecurity system using AI models?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a cybersecurity system using AI models?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a cybersecurity system using AI models?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a cybersecurity system using AI models?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-75",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-7",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","./Modernization1.css":"etHL4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"etHL4":[function() {},{}],"eMELU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData2", ()=>m_allData2);
parcelHelpers.export(exports, "m_yesCount2", ()=>m_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _modernization2Css = require("./Modernization2.css");
let m_allData2 = [];
let m_yesCount2 = 0;
function Modernization2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            m_yesCount2++;
            setYesCount2((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        m_allData2 = m_allData2.concat(data); // Concatène les nouvelles données à allData
        console.log(m_allData2);
        console.log(m_yesCount2);
        history.push("/modernization-3");
        return m_allData2;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "modernization-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-37",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-36",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-15",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        m_yesCount2,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-database subtitel",
                                            htmlFor: "doyouhaveadatabase",
                                            children: "Do you have a database?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a database?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have a database?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a database?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a database?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have a database?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a database?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-it-physical-server-in-the-company subtitel",
                                            htmlFor: "isitphysicalserverinthecompany",
                                            children: "Is it physical (server in the company)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it physical (server in the company)?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Is it physical (server in the company)?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it physical (server in the company)?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it physical (server in the company)?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Is it physical (server in the company)?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it physical (server in the company)?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-the-cloud subtitel",
                                            htmlFor: "inthecloud",
                                            children: "In the Cloud?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("In the Cloud?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["In the Cloud?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["In the Cloud?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("In the Cloud?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["In the Cloud?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["In the Cloud?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-free-access-to-all-your-data subtitel",
                                            htmlFor: "doyouhavefreeaccesstoallyourdata",
                                            children: "Do you have free access to all your data?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have free access to all your data?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have free access to all your data?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have free access to all your data?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have free access to all your data?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have free access to all your data?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have free access to all your data?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "os-all-the-data-shared subtitel",
                                            htmlFor: "osallthedatashared",
                                            children: "Os all the data shared?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Os all the data shared?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Os all the data shared?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Os all the data shared?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Os all the data shared?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Os all the data shared?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Os all the data shared?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you-3 subtitel",
                                            htmlFor: "doyouuseservicessuchas_iaaspaassaas",
                                            children: "Do you use services such as: IaaS, Paas, Saas?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you use services such as: IaaS, Paas, Saas?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you use services such as: IaaS, Paas, Saas?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you use services such as: IaaS, Paas, Saas?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you use services such as: IaaS, Paas, Saas?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you use services such as: IaaS, Paas, Saas?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you use services such as: IaaS, Paas, Saas?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you-3 subtitel",
                                            htmlFor: "areyouabletostoreallthedataprovidedbyyourlotnetwork",
                                            children: "Are you able to store all the data provided by your lot network?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are you able to store all the data provided by your lot network?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Are you able to store all the data provided by your lot network?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are you able to store all the data provided by your lot network?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are you able to store all the data provided by your lot network?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Are you able to store all the data provided by your lot network?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are you able to store all the data provided by your lot network?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-84",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Modernization2.css":"7YH4I","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7YH4I":[function() {},{}],"cX9bz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m_allData3", ()=>m_allData3);
parcelHelpers.export(exports, "m_yesCount3", ()=>m_yesCount3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _modernization3Css = require("./Modernization3.css");
let m_allData3 = [];
let m_yesCount3 = 0;
function Modernization3(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount3, setYesCount3] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            m_yesCount3++;
            setYesCount3((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        m_allData3 = m_allData3.concat(data); // Concatène les nouvelles données à allData
        console.log(m_allData3);
        console.log(m_yesCount3);
        history.push("/modernization-4");
        return m_allData3;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "modernization-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-81",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-80",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-46",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        m_yesCount3,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-13",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-sensors subtitel",
                                            htmlFor: "doyouhavesensorsandactuatorsinstalledinthemachines",
                                            children: "Do you have sensors and actuators installed in the machines?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have sensors and actuators installed in the machines?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have sensors and actuators installed in the machines?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have sensors and actuators installed in the machines?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have sensors and actuators installed in the machines?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have sensors and actuators installed in the machines?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have sensors and actuators installed in the machines?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-they-connected-to-the-internet subtitel",
                                            htmlFor: "aretheyconnectedtotheinternet",
                                            children: "Are they connected to the internet?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are they connected to the internet?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Are they connected to the internet?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are they connected to the internet?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are they connected to the internet?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Are they connected to the internet?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are they connected to the internet?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-11",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-an-iot-network subtitel",
                                            htmlFor: "doyouhaveaniotnetwork",
                                            children: "Do you have an IOT network?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have an IOT network?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have an IOT network?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have an IOT network?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have an IOT network?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have an IOT network?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have an IOT network?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-know-in-real subtitel",
                                            htmlFor: "doyouknowinrealtimethestateoftheproductionline",
                                            children: "Do you know in real time the state of the production line?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you know in real time the state of the production line?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you know in real time the state of the production line?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you know in real time the state of the production line?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you know in real time the state of the production line?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you know in real time the state of the production line?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you know in real time the state of the production line?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-147",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-4",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Modernization3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./Modernization3.css":"4UHfR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4UHfR":[function() {},{}],"zBsDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "l_sum", ()=>l_sum);
parcelHelpers.export(exports, "l_yesCount2", ()=>l_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _leadTime2Css = require("./LeadTime2.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _leadTime1 = require("../LeadTime1");
let l_sum = 0;
let l_yesCount2 = 0;
function LeadTime2(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount2, setYesCount2] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Ical__20081, costCriteria, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            l_yesCount2++;
            setYesCount2((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let l_allData2 = [];
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        l_allData2 = l_allData2.concat(data); // Concatenate the new data to l_allData2
        const l_allData = (0, _leadTime1.l_allData1).concat(l_allData2); // Update l_allData
        l_sum = (0, _leadTime1.l_yesCount1) + l_yesCount2;
        console.log((0, _leadTime1.l_allData1));
        console.log(l_allData);
        console.log(l_sum);
        generatePdf(l_allData); // Call the generatePdf function with the updated array
    // connect();
    }
    function generatePdf(l_allData) {
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 20;
        const pageHeight = doc.internal.pageSize.height - 40;
        let y = 20;
        // Parcourir les données dans l_allData et ajouter chaque question et réponse au document PDF
        l_allData.forEach((data, index)=>{
            const crit\u00e8re = "Environmental Criteria";
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `R\xe9ponse: ${data.answer}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + lineHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // // Ajouter la question et la réponse au document PDF
            // doc.text(question, 10, y);
            // y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
            // Séparer la question sur plusieurs lignes si elle est trop longue
            const splitQuestion = doc.splitTextToSize(question, doc.internal.pageSize.width - 20);
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
        });
        fetch("https://api.scgreenoptimizer.fr/save-answers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(l_allData)
        }).then((response)=>{
            if (!response.ok) throw new Error("Error saving data to MongoDB");
            history.push("/cost-1");
        }).catch((error)=>{
            console.error(error);
        // Gérer l'erreur
        });
        // Enregistrer le document PDF
        doc.save("Lead time_Criteria.pdf");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lead-time-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-group-39",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "nav-items-container-17",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                className: navItems3Props.className,
                                frame1172Props: navItems3Props.frame1172Props,
                                frame1162Props: navItems3Props.frame1162Props,
                                frame1132Props: navItems3Props.frame1132Props
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        l_yesCount2,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-you-experiencing subtitel",
                                            htmlFor: "areyouexperiencingproductiondelaysduetotechnicalproblems",
                                            children: "Are you experiencing production delays due to technical problems?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are you experiencing production delays due to technical problems?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Are you experiencing production delays due to technical problems?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are you experiencing production delays due to technical problems?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Are you experiencing production delays due to technical problems?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Are you experiencing production delays due to technical problems?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Are you experiencing production delays due to technical problems?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-it-physical-serv subtitel",
                                            htmlFor: "isitphysicalservhavemeasuresbeenputinplacetoavoidtheseinconvenienceserinthecompany",
                                            children: "Is it physical (servHave measures been put in place to avoid these inconveniences?er in the company)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it physical (servHave measures been put in place to avoid these inconveniences?er in the company)?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Is it physical (servHave measures been put in place to avoid these inconveniences?er in the company)?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it physical (servHave measures been put in place to avoid these inconveniences?er in the company)?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Is it physical (servHave measures been put in place to avoid these inconveniences?er in the company)?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Is it physical (servHave measures been put in place to avoid these inconveniences?er in the company)?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Is it physical (servHave measures been put in place to avoid these inconveniences?er in the company)?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "have-value-added-and subtitel",
                                            htmlFor: "havevalueaddedandnon-valueaddeditemsbeenidentified",
                                            children: "Have value added and non-value added items been identified?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have value added and non-value added items been identified?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Have value added and non-value added items been identified?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have value added and non-value added items been identified?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Have value added and non-value added items been identified?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Have value added and non-value added items been identified?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Have value added and non-value added items been identified?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-3-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-unsold-products subtitel",
                                            htmlFor: "doyouhaveunsoldproducts",
                                            children: "Do you have unsold products?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have unsold products?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have unsold products?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have unsold products?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have unsold products?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have unsold products?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have unsold products?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "how-long-on-average subtitel",
                                            htmlFor: "howlongonaveragedoyoustoreaproduct",
                                            children: "How long, on average, do you store a product?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("How long, on average, do you store a product?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["How long, on average, do you store a product?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["How long, on average, do you store a product?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("How long, on average, do you store a product?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["How long, on average, do you store a product?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["How long, on average, do you store a product?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-the-clou-do-you-h subtitel",
                                            htmlFor: "inthecloudoyouhavestock-outshowoftend",
                                            children: "In the cloud, do you have stock-outs?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("In the cloud, do you have stock-outs?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["In the cloud, do you have stock-outs?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["In the cloud, do you have stock-outs?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("In the cloud, do you have stock-outs?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["In the cloud, do you have stock-outs?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["In the cloud, do you have stock-outs?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-7",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-international-customers subtitel",
                                            htmlFor: "doyouhaveinternationalcustomers",
                                            children: "Do you have international customers?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have international customers?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have international customers?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have international customers?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have international customers?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have international customers?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have international customers?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "if-so-do-you-have-bu subtitel",
                                            htmlFor: "ifsodoyouhavebufferstoragefacilities",
                                            children: "If so, do you have buffer storage facilities?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If so, do you have buffer storage facilities?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["If so, do you have buffer storage facilities?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If so, do you have buffer storage facilities?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If so, do you have buffer storage facilities?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["If so, do you have buffer storage facilities?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If so, do you have buffer storage facilities?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "emploi-relation-employeur-employ-2-item subtitel",
                                            htmlFor: "doyouhaveadelayrate",
                                            children: "Do you have a delay rate?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a delay rate?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have a delay rate?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a delay rate?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a delay rate?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have a delay rate?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a delay rate?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "emploi-relation-employeur-employ-2-item subtitel",
                                            htmlFor: "ifsohowmuchisit",
                                            children: "If so, how much is it?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If so, how much is it?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["If so, how much is it?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If so, how much is it?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If so, how much is it?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["If so, how much is it?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If so, how much is it?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-86",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "cost-criteria valign-text-middle inter-bold-mineral-green-18px",
                                children: costCriteria
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./LeadTime2.css":"4gRdd","jspdf":"cU8oN","../LeadTime1":"5CGgc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4gRdd":[function() {},{}],"5CGgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "l_allData1", ()=>l_allData1);
parcelHelpers.export(exports, "l_yesCount1", ()=>l_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _leadTime1Css = require("./LeadTime1.css");
let l_allData1 = [];
let l_yesCount1 = 0;
function LeadTime1(props) {
    const [selectedOptions, setSelectedOptions] = (0, _react.useState)({});
    const [errorMessage, setErrorMessage] = (0, _react.useState)("");
    const [yesCount1, setYesCount1] = (0, _react.useState)(0); // Initialize yesCount state
    const [totalQuestions, setTotalQuestions] = (0, _react.useState)(0);
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType2, inputPlaceholder2, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props } = props;
    (0, _react.useEffect)(()=>{
        // Calculate the total number of questions based on sections
        const sections = document.getElementsByTagName("section");
        setTotalQuestions(sections.length);
    }, []); // Run this effect only once when the component mounts
    function clicked(question, option) {
        setSelectedOptions((prevSelectedOptions)=>({
                ...prevSelectedOptions,
                [question]: option
            }));
        if (option === "Yes") {
            // Increment yesCount when "Yes" is selected
            l_yesCount1++;
            setYesCount1((prevYesCount)=>prevYesCount + 1);
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = selectedOptions[question] || ""; // Get the selected option
            if (enabledValue === "") {
                setErrorMessage(`R\xe9pondez \xe0 toutes les questions s'il vous plait`);
                window.alert(errorMessage);
                return; // Stop processing if an error occurs
            }
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        l_allData1 = l_allData1.concat(data); // Concatène les nouvelles données à allData
        console.log(l_allData1);
        console.log(l_yesCount1);
        history.push("/lead-time-2");
        return l_allData1;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lead-time-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-30",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-30",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "yes-count",
                    children: [
                        "Score: ",
                        l_yesCount1,
                        " / ",
                        totalQuestions
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "please-answer-the-following-questions-9 valign-text-middle bevan-normal-white-20px",
                    children: pleaseAnswerTheFollowingQuestions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "dialogue-social-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "dialogue-social-1-1",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-107",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle1Props.className,
                                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "do-you-have-a-delay-rate subtitel",
                                                    htmlFor: "doyouhaveadelayrate",
                                                    children: "Do you have a delay rate?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you have a delay rate?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["Do you have a delay rate?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you have a delay rate?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("Do you have a delay rate?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["Do you have a delay rate?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["Do you have a delay rate?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    className: "if-so-how-much-is-it subtitel",
                                                    htmlFor: "ifsohowmuchisit",
                                                    placeholder: inputPlaceholder2,
                                                    type: inputType2,
                                                    children: "If so, how much is it?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "ouinon-45 ouinon-1-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("If so, how much is it?", "Yes"),
                                                            type: "button",
                                                            value: "Yes",
                                                            className: `frame-4-5 ${selectedOptions["If so, how much is it?"] === "Yes" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["If so, how much is it?"] === "No"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            onClick: ()=>clicked("If so, how much is it?", "No"),
                                                            type: "button",
                                                            value: "No",
                                                            className: `frame-4-6 ${selectedOptions["If so, how much is it?"] === "No" ? "enabled" : ""}`,
                                                            disabled: selectedOptions["If so, how much is it?"] === "Yes"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dialogue-social-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "can-your-suppliers-b subtitel",
                                            htmlFor: "canyoursuppliersbeflexibletoyourdemand",
                                            children: "Can your suppliers be flexible to your demand?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Can your suppliers be flexible to your demand?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Can your suppliers be flexible to your demand?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Can your suppliers be flexible to your demand?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Can your suppliers be flexible to your demand?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Can your suppliers be flexible to your demand?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Can your suppliers be flexible to your demand?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "if-not-can-you-chang subtitel",
                                            htmlFor: "ifnotcanyouchangesuppliersquicklyifthesupplierdoesnotmeetyourexpectations",
                                            children: "If not, can you change suppliers quickly if the supplier does not meet your expectations?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If not, can you change suppliers quickly if the supplier does not meet your expectations?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If not, can you change suppliers quickly if the supplier does not meet your expectations?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If not, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dialogue-social-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "if-no-can-you-change subtitel",
                                            htmlFor: "ifnocanyouchangesuppliersquicklyifthesupplierdoesnotmeetyourexpectations",
                                            children: "If no, can you change suppliers quickly if the supplier does not meet your expectations?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If no, can you change suppliers quickly if the supplier does not meet your expectations?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("If no, can you change suppliers quickly if the supplier does not meet your expectations?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["If no, can you change suppliers quickly if the supplier does not meet your expectations?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-calculat subtitel",
                                            htmlFor: "doyouhavecalculationmethodsformakingpurchaseforecasts",
                                            children: "Do you have calculation methods for making purchase forecasts?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have calculation methods for making purchase forecasts?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have calculation methods for making purchase forecasts?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have calculation methods for making purchase forecasts?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-1 subtitel",
                                            htmlFor: "doyouhaveasafetystock",
                                            children: "Do you have a safety stock?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a safety stock?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have a safety stock?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a safety stock?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have a safety stock?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have a safety stock?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have a safety stock?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-1 subtitel",
                                            htmlFor: "doyouhavebufferstocks",
                                            children: "Do you have buffer stocks?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have buffer stocks?", "Yes"),
                                                    type: "button",
                                                    value: "Yes",
                                                    className: `frame-4-5 ${selectedOptions["Do you have buffer stocks?"] === "Yes" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have buffer stocks?"] === "No"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: ()=>clicked("Do you have buffer stocks?", "No"),
                                                    type: "button",
                                                    value: "No",
                                                    className: `frame-4-6 ${selectedOptions["Do you have buffer stocks?"] === "No" ? "enabled" : ""}`,
                                                    disabled: selectedOptions["Do you have buffer stocks?"] === "Yes"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-77",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-9",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./LeadTime1.css":"7x6oZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7x6oZ":[function() {},{}],"7QKHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_sum", ()=>c_sum);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _cost2Css = require("./Cost2.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _cost1 = require("../Cost1");
let c_sum = 0;
function Cost2(props) {
    const { x1200PxLogo_Icac__20081, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, qualityCriteria, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, frame1364Props, frame1365Props, toggle2Props, frame1366Props, frame1367Props, frame1368Props, frame1369Props, toggle3Props } = props;
    let c_yesCount2 = 0;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            c_yesCount2++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${c_yesCount2}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let c_allData2 = [];
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        c_allData2 = c_allData2.concat(data); // Concatenate the new data to c_allData2
        const c_allData = (0, _cost1.c_allData1).concat(c_allData2); // Update c_allData
        c_sum = (0, _cost1.c_yesCount1) + c_yesCount2;
        console.log(c_allData2);
        console.log(c_allData);
        generatePdf(c_allData); // Call the generatePdf function with the updated array
        // connect();
        history.push("/Quality-1");
    }
    function generatePdf(c_allData) {
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 20;
        const pageHeight = doc.internal.pageSize.height - 40;
        let y = 20;
        // Parcourir les données dans c_allData et ajouter chaque question et réponse au document PDF
        c_allData.forEach((data, index)=>{
            const crit\u00e8re = "Environmental Criteria";
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `R\xe9ponse: ${data.answer}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + lineHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // // Ajouter la question et la réponse au document PDF
            // doc.text(question, 10, y);
            // y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
            // Séparer la question sur plusieurs lignes si elle est trop longue
            const splitQuestion = doc.splitTextToSize(question, doc.internal.pageSize.width - 20);
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
        });
        // Enregistrer le document PDF
        doc.save("Cost_Criteria.pdf");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "cost-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-38",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icac_-_2008-1-37",
                                src: x1200PxLogo_Icac__20081,
                                alt: "1200px-Logo_ICAc_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-16",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-7",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-budget subtitel",
                                            htmlFor: "doyouhaveabudgetformachinemaintenance",
                                            children: "Do you have a budget for machine maintenance?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "have-you-defined-a-b subtitel",
                                            htmlFor: "haveyoudefinedabudgetforexternalservices",
                                            children: "Have you defined a budget for external services?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you-4 subtitel",
                                            htmlFor: "doyouhavedifferentsuppliers",
                                            children: "Do you have different suppliers?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you-4 subtitel",
                                            htmlFor: "areyouabletochangesuppliersdependingonprices",
                                            children: "Are you able to change suppliers depending on prices?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you-4 subtitel",
                                            htmlFor: "doyoucontrolyourtransportcosts",
                                            children: "Do you control your transport costs?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you-4 subtitel",
                                            htmlFor: "doyouknowthepriceoftheproductexcludingrawmaterials",
                                            children: "Do you know the price of the product excluding raw materials?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you-4 subtitel",
                                            htmlFor: "doyouknowtheeconomiclosseslinkedtothenon-conformingproductdisquality",
                                            children: "Do you know the economic losses linked to the non-conforming product (disquality)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-5 subtitel",
                                            htmlFor: "doyouplanabudgetfornon-voluntarybreakage",
                                            children: 'Do you plan a budget for non-voluntary "breakage"?'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-5 subtitel",
                                            htmlFor: "doyouknowyouroptimalquantityofproducttobeprofitable",
                                            children: "Do you know your optimal quantity of product to be profitable?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-85",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "frame-113-51",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: saveData,
                                className: "quality-criteria valign-text-middle inter-bold-mineral-green-18px",
                                children: qualityCriteria
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Cost2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Frame136":"hltgv","./Cost2.css":"8zPSX","jspdf":"cU8oN","../Cost1":"cvZJK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hltgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame136Css = require("./Frame136.css");
function Frame136(props) {
    const { className, ouinonProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-13-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
            yes: ouinonProps.yes,
            place: ouinonProps.place
        })
    });
}
exports.default = Frame136;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Ouinon":"b3hbH","./Frame136.css":"19vll","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"19vll":[function() {},{}],"8zPSX":[function() {},{}],"cvZJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c_allData1", ()=>c_allData1);
parcelHelpers.export(exports, "c_yesCount1", ()=>c_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _cost1Css = require("./Cost1.css");
let c_allData1 = [];
let c_yesCount1 = 0;
function Cost1(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, inputType11, inputPlaceholder11, inputType12, inputPlaceholder12, inputType13, inputPlaceholder13, navItems2Props, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, frame1364Props, toggle2Props, frame1365Props, frame1366Props, frame1367Props, frame1368Props, toggle3Props, frame1369Props, frame144Props, frame13610Props, frame13611Props, frame13612Props, toggle4Props } = props;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            c_yesCount1++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${c_yesCount1}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        c_allData1 = c_allData1.concat(data); // Concatène les nouvelles données à allData
        console.log(c_allData1);
        history.push("/cost-2");
        return c_allData1;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "cost-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-31",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-13"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-31",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-10 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-follow subtitel",
                                            htmlFor: "doyouhaveafollow-upofrawmaterialsstocksex_erp",
                                            children: "Do you have a follow-up of raw materials, stocks... (ex: ERP)?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-current-average-cost-price subtitel",
                                            htmlFor: "doyouhaveacurrentaveragecostprice",
                                            children: "Do you have a current average cost price?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you subtitel",
                                            htmlFor: "areyourrawmaterialcostsfixed",
                                            children: "Are your raw material costs fixed?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "x-you subtitel",
                                            htmlFor: "doyouusethefifomethod",
                                            children: "Do you use the FIFO method?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-analyse-stock-data-in-real-time subtitel",
                                            htmlFor: "doyouanalysestockdatainrealtime",
                                            children: "Do you analyse stock data in real time?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-roundi subtitel",
                                            htmlFor: "doyouhavearoundingstocksystemtomakethemostofthespace",
                                            children: "Do you have a rounding stock system? to make the most of the space"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-case-of-shortage subtitel",
                                            htmlFor: "incaseofshortagedoyouhaveasafetystock",
                                            children: "In case of shortage, do you have a safety stock?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "calculation-of-the-cost-of-the-stock subtitel",
                                            htmlFor: "calculationofthecostofthestock",
                                            children: "Calculation of the cost of the stock?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-know-your-market subtitel",
                                            htmlFor: "doyouknowyourmarket",
                                            children: "Do you know your market?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "have-you-defined-your-market-share subtitel",
                                            htmlFor: "haveyoudefinedyourmarketshare",
                                            children: "Have you defined your market share?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you subtitel",
                                            htmlFor: "doyouknowwhereyoustandinrelationtothecompetition",
                                            children: "Do you know where you stand in relation to the competition?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you subtitel",
                                            htmlFor: "doyouknowyourdirectcompetitor",
                                            children: "Do you know your direct competitor?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you subtitel",
                                            htmlFor: "doyouhaveanyanalysisoftheseasonalityofyourproducts",
                                            children: "Do you have any analysis of the seasonality of your products?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-78",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-112-5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Cost1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame136":"hltgv","../Frame144":"25TBH","../Frame11732":"h8i4O","./Cost1.css":"fYi67","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"25TBH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame133 = require("../Frame133");
var _frame133Default = parcelHelpers.interopDefault(_frame133);
var _frame144Css = require("./Frame144.css");
function Frame144(props) {
    const { frame133Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-144",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame133Default.default), {
            frame136Props: frame133Props.frame136Props
        })
    });
}
exports.default = Frame144;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame133":"grREs","./Frame144.css":"6wNmE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"grREs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame133Css = require("./Frame133.css");
function Frame133(props) {
    const { className, frame136Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-152 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
            className: frame136Props.className,
            ouinonProps: frame136Props.ouinonProps
        })
    });
}
exports.default = Frame133;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Frame136":"hltgv","./Frame133.css":"fq7WB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fq7WB":[function() {},{}],"6wNmE":[function() {},{}],"fYi67":[function() {},{}],"cQ4XY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_sum", ()=>q_sum);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _quality6Css = require("./Quality6.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _quality1 = require("../Quality1");
var _quality2 = require("../Quality2");
var _quality3 = require("../Quality3");
var _quality4 = require("../Quality4");
var _quality5 = require("../Quality5");
let q_sum = 0;
function Quality6(props) {
    const { x1200PxLogo_Icam__20081, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, inputType11, inputPlaceholder11, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, frame1364Props, toggle2Props, frame1365Props, frame1366Props, frame1367Props, frame1368Props, toggle3Props, frame1369Props, frame13610Props, frame13611Props, toggle4Props } = props;
    let q_yesCount6 = 0;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            0, _quality2.q_yesCount2++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${(0, _quality2.q_yesCount2)}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    let q_allData6 = [];
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        q_allData6 = q_allData6.concat(data); // Concatenate the new data to q_allData2
        const q_allData = (0, _quality1.q_allData1).concat((0, _quality2.q_allData2), (0, _quality3.q_allData3), (0, _quality4.q_allData4), (0, _quality5.q_allData5), q_allData6); // Update q_allData
        q_sum = (0, _quality1.q_yesCount1) + (0, _quality2.q_yesCount2) + (0, _quality3.q_yesCount3) + (0, _quality4.q_yesCount4) + (0, _quality5.q_yesCount5) + q_yesCount6;
        console.log(q_allData6);
        console.log(q_allData);
        generatePdf(q_allData); // Call the generatePdf function with the updated array
        // connect();
        history.push("/client-consommateur-1");
    }
    function generatePdf(q_allData) {
        // Créer un nouveau document PDF
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 20;
        const pageHeight = doc.internal.pageSize.height - 40;
        let y = 20;
        // Parcourir les données dans q_allData et ajouter chaque question et réponse au document PDF
        q_allData.forEach((data, index)=>{
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `R\xe9ponse: ${data.answer}`;
            // Vérifier si la position y actuelle plus la hauteur de la question dépasse la hauteur maximale de la page
            if (y + lineHeight > pageHeight) {
                // Ajouter une nouvelle page et réinitialiser la position y
                doc.addPage();
                y = 20;
            }
            // // Ajouter la question et la réponse au document PDF
            // doc.text(question, 10, y);
            // y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
            // Séparer la question sur plusieurs lignes si elle est trop longue
            const splitQuestion = doc.splitTextToSize(question, doc.internal.pageSize.width - 20);
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight; // Mettre à jour la position y pour la prochaine ligne
        });
        // Enregistrer le document PDF
        doc.save("Quality_Criteria.pdf");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-6 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-40",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-39",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-18",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-9",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-7",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-the-measuring-equ subtitel",
                                            htmlFor: "isthemeasuringequipmentcalibratedandorcheckedatspecifiedintervalsorbeforeuseagainstmeasuringstandardsthatcanbelinkedtointernationalornationalmeasuringstandards",
                                            children: "Is the measuring equipment calibrated and/or checked at specified intervals, or before use, against measuring standards that can be linked to international or national measuring standards?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "where-such-standards subtitel",
                                            htmlFor: "wheresuchstandardsdonotexististhereferenceusedforcalibrationorverificationkeptasdocumentedinformation",
                                            children: "Where such standards do not exist, is the reference used for calibration or verification kept as documented information?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-the-measuring-equ-1 subtitel",
                                            htmlFor: "isthemeasuringequipmentidentifiedtodeterminethevalidityofitscalibration",
                                            children: "Is the measuring equipment identified to determine the validity of its calibration?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-the-measuring-equ-2 subtitel",
                                            htmlFor: "isthemeasuringequipmentprotectedagainstadjustmentdamageordeteriorationthatcouldinvalidatethecalibration",
                                            children: "Is the measuring equipment protected against adjustment, damage or deterioration that could invalidate the calibration?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-the-quality-obje subtitel",
                                            htmlFor: "arethequalityobjectivesconsistentwiththequalitypolicy",
                                            children: "Are the quality objectives consistent with the quality policy?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-the-quality-objectives-measurable subtitel",
                                            htmlFor: "arethequalityobjectivesmeasurable",
                                            children: "Are the quality objectives measurable?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-the-quality-objec subtitel",
                                            htmlFor: "dothequalityobjectivestakeintoaccounttherequirements",
                                            children: "Do the quality objectives take into account the requirements?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-the-quality-obje-1 subtitel",
                                            htmlFor: "arethequalityobjectivesmonitoredandcommunicated",
                                            children: "Are the quality objectives monitored and communicated?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-react-to-non-compliance subtitel",
                                            htmlFor: "doyoureacttonon-compliance",
                                            children: "Do you react to non-compliance?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-take-action-t subtitel",
                                            htmlFor: "doyoutakeactiontocontrolandcorrectit",
                                            children: "Do you take action to control and correct it?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-take-responsi subtitel",
                                            htmlFor: "doyoutakeresponsibilityfortheconsequence",
                                            children: "Do you take responsibility for the consequence?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-87",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-67",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality6;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Frame136":"hltgv","../Frame11732":"h8i4O","./Quality6.css":"2tJ7J","jspdf":"cU8oN","../Quality1":"gtWhX","../Quality2":"83Ssi","../Quality3":"1NFJv","../Quality4":"jKbL3","../Quality5":"3sFO7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2tJ7J":[function() {},{}],"gtWhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData1", ()=>q_allData1);
parcelHelpers.export(exports, "q_yesCount1", ()=>q_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _quality1Css = require("./Quality1.css");
let q_allData1 = [];
let q_yesCount1 = 0;
function Quality1(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, navItems2Props, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, toggle2Props, frame1364Props, frame1365Props, frame1366Props, toggle3Props, frame1367Props, frame144Props, frame1368Props, toggle4Props } = props;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            q_yesCount1++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${q_yesCount1}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        q_allData1 = q_allData1.concat(data); // Concatène les nouvelles données à allData
        console.log(q_allData1);
        history.push("/Quality-2");
        return q_allData1;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-32",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-14"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-32",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-11 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-do-reviews subtitel",
                                            htmlFor: "doyoudoreviews",
                                            children: "Do you do reviews?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-paper-format subtitel",
                                            htmlFor: "inpaperformat",
                                            children: "In paper format?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-digital-format subtitel",
                                            htmlFor: "indigitalformat",
                                            children: "In digital format?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-3-1",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-review subtitel",
                                            htmlFor: "doyouhaveareviewspecifyingrequirementsnotformulatedbythecustomerbutnecessaryforthespecifieduse",
                                            children: "Do you have a review specifying requirements not formulated by the customer but necessary for the specified use?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-paper-format-1 subtitel",
                                            htmlFor: "inpaperformat",
                                            children: "In paper format?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-digital-format-1 subtitel",
                                            htmlFor: "indigitalformat",
                                            children: "In digital format?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-review-1 subtitel",
                                            htmlFor: "doyouhaveareviewspecifyingtherequirementsoftheorganisation",
                                            children: "Do you have a review specifying the requirements of the organisation?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-paper-format-2 subtitel",
                                            htmlFor: "inpaperformat",
                                            children: "in paper format?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "in-digital-format-2 subtitel",
                                            htmlFor: "indigitalformat",
                                            children: "In digital format?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-79",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-51",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame136":"hltgv","../Frame144":"25TBH","../Frame11732":"h8i4O","./Quality1.css":"llgU9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"llgU9":[function() {},{}],"83Ssi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData2", ()=>q_allData2);
parcelHelpers.export(exports, "q_yesCount2", ()=>q_yesCount2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _quality2Css = require("./Quality2.css");
let q_allData2 = [];
let q_yesCount2 = 0;
function Quality2(props) {
    const { x1200PxLogo_Icam__20081, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, toggle2Props, frame1364Props, frame1365Props, frame1366Props, toggle3Props, frame1367Props, toggle4Props } = props;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            q_yesCount2++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${q_yesCount2}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        q_allData2 = q_allData2.concat(data); // Concatène les nouvelles données à allData
        console.log(q_allData2);
        history.push("/Quality-3");
        return q_allData2;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-44",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-43",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-20",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-10",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-custom subtitel",
                                            htmlFor: "doyouhaveacustomersatisfactionpercentage",
                                            children: "Do you have a customer satisfaction percentage?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-it-below-30 subtitel",
                                            htmlFor: "isitbelow30",
                                            children: "Is it below 30%?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-it subtitel",
                                            htmlFor: "isitbetween30and60",
                                            children: "Is it between 30% and 60%?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-it subtitel",
                                            htmlFor: "isitbetween60and90",
                                            children: "Is it between 60% and 90%?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-it subtitel",
                                            htmlFor: "isithigherthan90",
                                            children: "Is it higher than 90%?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "does-the-manager-ens subtitel",
                                            htmlFor: "doesthemanagerensurethatcustomerrequirementsaremet",
                                            children: "Does the manager ensure that customer requirements are met?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-communicate-t subtitel",
                                            htmlFor: "doyoucommunicatetoemployeesthepointsofattentionwhereproductandservicecomplianceisatrisk",
                                            children: "Do you communicate to employees the points of attention where product and service compliance is at risk?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-90",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-51",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Frame136":"hltgv","../Frame11732":"h8i4O","./Quality2.css":"jaGRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jaGRg":[function() {},{}],"1NFJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData3", ()=>q_allData3);
parcelHelpers.export(exports, "q_yesCount3", ()=>q_yesCount3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _quality3Css = require("./Quality3.css");
let q_allData3 = [];
let q_yesCount3 = 0;
function Quality3(props) {
    const { x1200PxLogo_Icam__20081, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, next, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, frame1364Props, toggle2Props, frame1365Props, frame1366Props, frame1367Props, toggle3Props } = props;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            q_yesCount3++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${q_yesCount3}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        q_allData3 = q_allData3.concat(data); // Concatène les nouvelles données à allData
        console.log(q_allData3);
        history.push("/Quality-4");
        return q_allData3;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-75",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-75",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-40",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-communicate-t-1 subtitel",
                                            htmlFor: "doyoucommunicatetheimportanceofhavinganeffectivequalitymanagementsystem",
                                            children: "Do you communicate the importance of having an effective quality management system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-objectiv subtitel",
                                            htmlFor: "doyouhaveobjectivesintheformofkpisconcerningquality",
                                            children: "Do you have objectives in the form of KPIs concerning quality?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-7 subtitel",
                                            htmlFor: "doyouhavejobdescriptionsthattakeintoaccounttherequirementsofthequalitymanagementsystem",
                                            children: "Do you have job descriptions that take into account the requirements of the quality management system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-7 subtitel",
                                            htmlFor: "doyouensurethatthequalitymanagementsystemachievestheexpectedresults",
                                            children: "Do you ensure that the quality management system achieves the expected results?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-2 subtitel",
                                            htmlFor: "doyouhaveaqualitymanagementsystem",
                                            children: "Do you have a quality management system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-2 subtitel",
                                            htmlFor: "doyouhavethenecessaryresourcesavailableforthequalitymanagementsystem",
                                            children: "Do you have the necessary resources available for the quality management system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-organise-trai subtitel",
                                            htmlFor: "doyouorganisetrainingonthequalitymanagementsystem",
                                            children: "Do you organise training on the quality management system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-143",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "frame-113-67",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: saveData,
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Frame136":"hltgv","./Quality3.css":"jS70b","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jS70b":[function() {},{}],"jKbL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData4", ()=>q_allData4);
parcelHelpers.export(exports, "q_yesCount4", ()=>q_yesCount4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _quality4Css = require("./Quality4.css");
let q_allData4 = [];
let q_yesCount4 = 0;
function Quality4(props) {
    const { x1200PxLogo_Icam__20081, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, frame1364Props, toggle2Props, frame1365Props, frame1366Props, toggle3Props } = props;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            q_yesCount4++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${q_yesCount4}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        q_allData4 = q_allData4.concat(data); // Concatène les nouvelles données à allData
        console.log(q_allData4);
        history.push("/Quality-5");
        return q_allData4;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-4 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-62",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-61",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-31",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-11",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-a-quality-manager subtitel",
                                            htmlFor: "doyouhaveaqualitymanager",
                                            children: "Do you have a quality manager?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-the-necessary-co subtitel",
                                            htmlFor: "arethenecessarycompetencesofthepersonsworkingontheperformanceandeffectivenessofthequalitymanagementsystemdefined",
                                            children: "Are the necessary competences of the person(s) working on the performance and effectiveness of the quality management system defined?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-job-desc subtitel",
                                            htmlFor: "doyouhavejobdescriptionsthattakeintoaccounttherequirementsofthequalitymanagementsystem",
                                            children: "Do you have job descriptions that take into account the requirements of the quality management system?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-this-documentatio subtitel",
                                            htmlFor: "isthisdocumentationdigitisedandaccessibletoallstaff",
                                            children: "Is this documentation digitised and accessible to all staff?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "has-an-indicator-bee subtitel",
                                            htmlFor: "hasanindicatorbeensetuptoevaluatemeasuretheeffectivenessoftheactionsundertakeninthefieldofcompetencemanagementawarenesstraining",
                                            children: "Has an indicator been set up to evaluate/measure the effectiveness of the actions undertaken in the field of competence management, awareness, training?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "is-the-indicator-vis subtitel",
                                            htmlFor: "istheindicatorvisibletoallandeasilyaccessible",
                                            children: "Is the indicator visible to all and easily accessible?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-120",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-67",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Frame136":"hltgv","../Frame11732":"h8i4O","./Quality4.css":"9LCWL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9LCWL":[function() {},{}],"3sFO7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "q_allData5", ()=>q_allData5);
parcelHelpers.export(exports, "q_yesCount5", ()=>q_yesCount5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _quality5Css = require("./Quality5.css");
let q_allData5 = [];
let q_yesCount5 = 0;
function Quality5(props) {
    const { x1200PxLogo_Icam__20081, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, navItems3Props, toggle1Props, ouinon1Props, ouinon2Props, ouinon3Props, toggle2Props, ouinon4Props, ouinon5Props, ouinon6Props, toggle3Props } = props;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            q_yesCount5++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${q_yesCount5}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        q_allData5 = q_allData5.concat(data); // Concatène les nouvelles données à allData
        console.log(q_allData5);
        history.push("/Quality-6");
        return q_allData5;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-5 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-49",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-48",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-21",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "developpement-et-capital-humain-1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "developpement-et-capital-humain",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-carry-out-int subtitel",
                                            htmlFor: "doyoucarryoutinternalauditsatplannedintervalstodeterminewhethertheqmscomplieswiththeorganisationsrequirements",
                                            children: "Do you carry out internal audits at planned intervals to determine whether the QMS complies with the organisation's requirements?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-6 subtitel",
                                            htmlFor: "doyoucarryoutinternalauditstoverifythattheqmsiscompliant",
                                            children: "Do you carry out internal audits to verify that the QMS is compliant?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-6 subtitel",
                                            htmlFor: "doyoucarryoutatleast2peryear",
                                            children: "Do you carry out at least 2 per year?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "developpement-et-capital-humain",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-define-the-au subtitel",
                                            htmlFor: "doyoudefinetheauditcriteriaandthescopeofeachaudit",
                                            children: "Do you define the audit criteria and the scope of each audit?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-6 subtitel",
                                            htmlFor: "doyouhavespecificauditorstoensureimpartialityoftheaudits",
                                            children: "Do you have specific auditors to ensure impartiality of the audits?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-6 subtitel",
                                            htmlFor: "doyouensurethattheauditresultsarereportedtotherelevantmanagement",
                                            children: "Do you ensure that the audit results are reported to the relevant management?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-92",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-67",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality5;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Ouinon":"b3hbH","../Frame11732":"h8i4O","./Quality5.css":"6gEr1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6gEr1":[function() {},{}],"3ZD9U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_sum", ()=>cc_sum);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _clientConsommateur2Css = require("./ClientConsommateur2.css");
var _jspdf = require("jspdf");
var _jspdfDefault = parcelHelpers.interopDefault(_jspdf);
var _clientConsommateur1 = require("../ClientConsommateur1");
var _social6 = require("../Social6");
var _aquisition = require("../Aquisition");
var _environmental5 = require("../Environmental5");
var _modernization4 = require("../Modernization4");
var _leadTime2 = require("../LeadTime2");
var _cost2 = require("../Cost2");
var _quality6 = require("../Quality6");
let cc_sum = 0;
function ClientConsommateur2(props) {
    const { x1200PxLogo_Icam__20081, navItems3Props, toggle1Props, toggle2Props, toggle3Props } = props;
    let cc_yesCount2 = 0;
    function clicked(event) {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            cc_yesCount2++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${cc_yesCount2}`);
        }
        button.disabled = true; // Désactive le bouton cliqué
        button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton
    }
    const history = (0, _reactRouterDom.useHistory)();
    let cc_allData2 = [];
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for (let section of sections){
            const question = section.innerText.split("\n")[0];
            const enabledButton = section.querySelector(".enabled");
            if (enabledButton) {
                const enabledValue = enabledButton.value;
                data.push({
                    question,
                    answer: enabledValue
                });
            }
        }
        cc_allData2 = [
            ...cc_allData2,
            ...data
        ]; // Concaténer les nouvelles données
        const cc_allData = [
            ...(0, _clientConsommateur1.cc_allData1),
            ...cc_allData2
        ];
        cc_sum = (0, _clientConsommateur1.cc_yesCount1) + cc_yesCount2;
        console.log("Collected Data:", cc_allData2);
        console.log("Combined Data:", cc_allData);
        generatePdf(cc_allData); // Générer le PDF
    }
    function generatePdf(cc_allData) {
        const doc = new (0, _jspdfDefault.default)();
        const lineHeight = 10;
        const pageHeight = doc.internal.pageSize.height - 20;
        let y = 20;
        cc_allData.forEach((data, index)=>{
            const question = `Question ${index + 1}: ${data.question}`;
            const answer = `R\xe9ponse: ${data.answer}`;
            const splitQuestion = doc.splitTextToSize(question, doc.internal.pageSize.width - 20);
            if (y + splitQuestion.length * lineHeight > pageHeight) {
                doc.addPage();
                y = 20;
            }
            doc.text(splitQuestion, 10, y);
            y += splitQuestion.length * lineHeight;
            doc.text(answer, 10, y);
            y += lineHeight;
        });
        const data = {
            enterprise: (0, _aquisition.company_name),
            Social: {
                Total: (0, _social6.s_sum)
            },
            Environnement: {
                Total: (0, _environmental5.e_sum)
            },
            Quality: {
                Total: (0, _quality6.q_sum)
            },
            Cost: {
                Total: (0, _cost2.c_sum)
            },
            Lead_time: {
                Total: (0, _leadTime2.l_sum)
            },
            Modernisation: {
                Total: (0, _modernization4.m_sum)
            },
            ClientConsommateur: {
                Total: cc_sum
            }
        };
        fetch("https://api.scgreenoptimizer.fr/save-points", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then((response)=>{
            if (!response.ok) throw new Error("Error saving data to MongoDB");
            console.log("Data successfully saved!");
        }).catch((error)=>console.error("Save error:", error));
        doc.save("Client_Consommateur_Criteria.pdf");
        history.push("/cur-performances");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "client-consommateur-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-26",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-26",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-7",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    ...navItems3Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            ...toggle1Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    children: "Is your complaint rate above 75%?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: clicked,
                                            value: "Yes",
                                            className: "frame-4-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            onClick: clicked,
                                            value: "No",
                                            className: "frame-4-6"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "frame-113-69",
                    onClick: saveData,
                    children: "Go to results"
                })
            ]
        })
    });
}
exports.default = ClientConsommateur2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./ClientConsommateur2.css":"36dUa","jspdf":"cU8oN","../ClientConsommateur1":"hwfHw","../Social6":"hHc62","../Aquisition":"8nwJV","../Environmental5":"jhgCb","../Modernization4":"b543i","../LeadTime2":"zBsDr","../Cost2":"7QKHV","../Quality6":"cQ4XY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"36dUa":[function() {},{}],"hwfHw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cc_allData1", ()=>cc_allData1);
parcelHelpers.export(exports, "cc_yesCount1", ()=>cc_yesCount1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _clientConsommateur1Css = require("./ClientConsommateur1.css");
let cc_allData1 = [];
let cc_yesCount1 = 0;
function ClientConsommateur1(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, toggle2Props, frame1364Props, frame1365Props, frame1366Props, toggle3Props, frame1367Props, frame144Props, frame1368Props, toggle4Props } = props;
    function clicked() {
        const button = event.target; // Récupère le bouton qui a été cliqué
        if (button.classList.contains("frame-4-5")) {
            // Vérifie si c'est un bouton 'oui'
            cc_yesCount1++; // Incrémente le compteur de bouton 'Oui'
            console.log(`Number of yesButton selected: ${cc_yesCount1}`); // Affiche le nombre de boutons 'Oui' sélectionnés
            button.disabled = true; // Désactive le bouton 'oui' qui a été cliqué
            button.classList.add("enabled"); // Ajoute la classe 'enabled' au bouton 'oui'
        } else if (button.classList.contains("frame-4-6")) {
            // Vérifie si c'est un bouton 'non'
            button.disabled = true; // Désactive le bouton 'non' qui a été cliqué
            button.classList.add("enabled"); // Désactive le bouton 'non' qui a été cliqué
        }
    }
    const history = (0, _reactRouterDom.useHistory)();
    function saveData() {
        const sections = document.getElementsByTagName("section");
        const data = [];
        for(let i = 0; i < sections.length; i++){
            const section = sections[i];
            const question = section.innerText.split("\n")[0];
            const enabledValue = section.querySelector(".enabled").value;
            const questionObj = {
                question: question,
                answer: enabledValue
            };
            data.push(questionObj);
        }
        cc_allData1 = cc_allData1.concat(data); // Concatène les nouvelles données à allData
        console.log(cc_allData1);
        history.push("/client-consommateur-2");
        return cc_allData1;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "client-consommateur-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-29",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-29",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "please-answer-the-following-questions-8 valign-text-middle bevan-normal-white-20px",
                    children: pleaseAnswerTheFollowingQuestions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-3",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-pass-on-produ subtitel",
                                            htmlFor: "doyoupassonproductprogressinformationtoods",
                                            children: "Do you pass on product progress information to ODs?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "number-of-disputes-a subtitel",
                                            htmlFor: "numberofdisputesandorout-of-courtsettlementsconcerningthecompanydoyouhavedisputesandorout-of-courtsettlements",
                                            children: "Number of disputes and/or out-of-court settlements concerning the company (Do you have disputes and/or out-of-court settlements?)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-you-audited-by-b subtitel",
                                            htmlFor: "areyouauditedbybodiessuchasthecnil",
                                            children: "Are you audited by bodies such as the CNIL?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-154",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                        className: toggle2Props.className,
                                        buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-safety-notices subtitel",
                                            htmlFor: "doyouhavesafetynotices",
                                            children: "Do you have safety notices?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-one-or-m subtitel",
                                            htmlFor: "doyouhaveoneormorecustomerproductrecallproceduresinvolvinghealthandsafetyofthecustomerconsumer",
                                            children: "Do you have one or more customer product recall procedures involving health and safety of the customer/consumer?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-wms-ware subtitel",
                                            htmlFor: "doyouhavewmswarehousemanagementsoftwaretomanagethemovementandstorageofproducts",
                                            children: "Do you have WMS (warehouse management software) to manage the movement and storage of products?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-take-measures-for-data-protection subtitel",
                                            htmlFor: "doyoutakemeasuresfordataprotection",
                                            children: "Do you take measures for data protection?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "do-you-have-justifie subtitel",
                                            htmlFor: "doyouhavejustifiedcomplaintsaboutprivacyviolationsorlossofcustomerdata",
                                            children: "Do you have justified complaints about privacy violations or loss of customer data?"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "are-you-audited-by-b-1 subtitel",
                                            htmlFor: "areyouauditedbybodiessuchasthecnilverificationofdataregisters",
                                            children: "Are you audited by bodies such as the CNIL? (verification of data registers)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "ouinon-45 ouinon-1-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "Yes",
                                                    className: "frame-4-5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    onClick: clicked,
                                                    type: "button",
                                                    value: "No",
                                                    className: "frame-4-6"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-76",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: saveData,
                            className: "frame-113-67",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next valign-text-middle inter-bold-mineral-green-18px",
                                children: "Next"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Frame136":"hltgv","../Frame144":"25TBH","../Frame11732":"h8i4O","./ClientConsommateur1.css":"kVEZr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kVEZr":[function() {},{}],"2DKHi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame94 = require("../Frame94");
var _frame94Default = parcelHelpers.interopDefault(_frame94);
var _frame95 = require("../Frame95");
var _frame95Default = parcelHelpers.interopDefault(_frame95);
var _inscriptionCss = require("./Inscription.css");
function Inscription(props) {
    const { aerialViewContainerCargoShipSea1, subtract, polygon1, polygon2, login, x1200PxLogo_Icam__20081, polygon3, frame94Props, frame95Props } = props;
    function createUser(username, password) {
        const history = (0, _reactRouterDom.useHistory)();
        const userData = {
            username: username,
            password: password
        };
        fetch("https://api.scgreenoptimizer.fr/api/users", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userData)
        }).then((response)=>response.json()).then((responseData)=>{
            console.log(responseData); // Afficher la réponse JSON dans la console
            // Rediriger vers la page de connexion
            history.push('/connexion');
        }).catch((error)=>{
            console.error("Erreur lors de la cr\xe9ation de l'utilisateur:", error);
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "inscription screen",
            name: "form8",
            action: "form8",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-12",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "aerial-view-container-cargo-ship-sea-1-1",
                            src: aerialViewContainerCargoShipSea1,
                            alt: "aerial-view-container-cargo-ship-sea 1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame94Default.default), {
                            className: frame94Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame95Default.default), {
                            className: frame95Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ellipse-1-1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "ellipse-2-1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "subtract-1",
                            src: subtract,
                            alt: "Subtract"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "polygon-1-1",
                            src: polygon1,
                            alt: "Polygon 1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "polygon-2-1",
                            src: polygon2,
                            alt: "Polygon 2"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "javascript:SubmitForm('form8')",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-1-19"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: createUser,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "login-1 valign-text-middle inter-extra-bold-bone-13px",
                                children: login
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_20081",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_20081"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "polygon-3-1",
                    src: polygon3,
                    alt: "Polygon 3"
                })
            ]
        })
    });
}
exports.default = Inscription;

},{"react/jsx-runtime":"gaGEj","react-router-dom":"5fzqq","react":"6uln9","../Frame94":"6KgLy","../Frame95":"cfzHi","./Inscription.css":"1I68Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1I68Z":[function() {},{}],"lF3Z1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame111 = require("../Frame111");
var _frame111Default = parcelHelpers.interopDefault(_frame111);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _quality7Css = require("./Quality7.css");
function Quality7(props) {
    const { x1200PxLogo_Icam__20081, clientConsommateur, navItems3Props, frame111Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-7 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-33",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-33",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-11",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame111Default.default), {
                    ...frame111Props
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-80",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-112-3",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "client-consommateur valign-text-middle inter-bold-mineral-green-18px",
                                children: clientConsommateur
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Quality7;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Frame111":"2P542","../Toggle":"8ZCQM","./Quality7.css":"judIS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2P542":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _ouinon = require("../Ouinon");
var _ouinonDefault = parcelHelpers.interopDefault(_ouinon);
var _frame111Css = require("./Frame111.css");
function Frame111(props) {
    const { toggle1Props, ouinon1Props, ouinon2Props, ouinon3Props, toggle2Props, ouinon4Props, ouinon5Props, toggle3Props, ouinon6Props, ouinon7Props, ouinon8Props, ouinon9Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "frame-111",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "developpement-et-capital-humain-3",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggle1Props.className,
                        buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "do-you-1 subtitel",
                        name: "doyouensurethattheprocessesproductsandservicesprovidedbyexternalproviderscomplywiththeorganisationsrequirements",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon1Props.place,
                        yes: ouinon1Props.yes,
                        className: ouinon1Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "do-you-1 subtitel",
                        name: "doyouconsiderthepotentialimpactofexternalserviceprovidersontheorganisationsabilitytoconsistentlymeetcustomerlegalandregulatoryrequirements",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon2Props.place,
                        yes: ouinon2Props.yes,
                        className: ouinon2Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "do-you-1 subtitel",
                        name: "doyouevaluatetheservicesprovidedbyexternalproviders",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon3Props.place,
                        yes: ouinon3Props.yes,
                        className: ouinon3Props.className
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "developpement-et-capital-humain-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggle2Props.className,
                        buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "do-you-2 subtitel",
                        name: "doyouapplycriteriaforevaluatingselectingmonitoringtheperformanceofexternalproviders",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon4Props.place,
                        yes: ouinon4Props.yes,
                        className: ouinon4Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "do-you-2 subtitel",
                        name: "doyoukeepdocumentedinformationabouttheseactivitiesandanynecessaryactions",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon5Props.place,
                        yes: ouinon5Props.yes,
                        className: ouinon5Props.className
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "developpement-et-capital-humain-5",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggle3Props.className,
                        buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "have-you-determined subtitel",
                        name: "haveyoudeterminedtherequiredinputsandexpectedoutputsfortheseprocesses",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon6Props.place,
                        yes: ouinon6Props.yes,
                        className: ouinon6Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "x-you-1 subtitel",
                        name: "haveyouassignedresponsibilitiesandauthoritiesfortheseprocesses",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon7Props.place,
                        yes: ouinon7Props.yes,
                        className: ouinon7Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "x-you-1 subtitel",
                        name: "haveyoudeterminedtheresourcesneededfortheseprocessesandensuredtheiravailability",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon8Props.place,
                        yes: ouinon8Props.yes,
                        className: ouinon8Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "x-you-1 subtitel",
                        name: "doyoudetermineandapplythecriteriaandmethodsnecessarytoensuretheeffectiveoperationandcontroloftheseprocesses",
                        placeholder: "Connaissez vous votre bilan carbone?",
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ouinonDefault.default), {
                        place: ouinon9Props.place,
                        yes: ouinon9Props.yes,
                        className: ouinon9Props.className
                    })
                ]
            })
        ]
    });
}
exports.default = Frame111;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Ouinon":"b3hbH","./Frame111.css":"kSSCM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kSSCM":[function() {},{}],"judIS":[function() {},{}],"5bGvI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _informationalModel3Css = require("./InformationalModel3.css");
function InformationalModel3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "informational-model-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-41",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-15"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-40",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-12 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-88",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {})
                    ]
                })
            ]
        })
    });
}
exports.default = InformationalModel3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame11732":"h8i4O","./InformationalModel3.css":"i3LMp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3LMp":[function() {},{}],"cTZ96":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _informationalModel2Css = require("./InformationalModel2.css");
function InformationalModel2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, navItems3Props, toggle1Props, toggle2Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, frame97Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "informational-model-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-52",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-42",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-41",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-19",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                            className: navItems3Props.className,
                                            frame1172Props: navItems3Props.frame1172Props,
                                            frame1162Props: navItems3Props.frame1162Props,
                                            frame1132Props: navItems3Props.frame1132Props
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-13 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-89",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group1-33",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-96-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle2Props.className,
                                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "vos-employs-sont-ils subtitel",
                                            name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                                            placeholder: inputPlaceholder1,
                                            type: inputType1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1021Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "avez-vous-un-managem subtitel",
                                            name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                                            placeholder: inputPlaceholder2,
                                            type: inputType2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1022Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "sez-vous subtitel",
                                            name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                                            placeholder: inputPlaceholder3,
                                            type: inputType3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1023Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "sez-vous subtitel",
                                            name: "quelmanagementutilisezvous",
                                            placeholder: inputPlaceholder4,
                                            type: inputType4
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1024Props.line24
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            className: "est-ce-que-les-journ subtitel",
                                            name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                                            placeholder: inputPlaceholder5,
                                            type: inputType5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                            line24: group1025Props.line24
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-11",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                                    toggleProps: frame97Props.toggleProps,
                                    group1021Props: frame97Props.group1021Props,
                                    group1022Props: frame97Props.group1022Props,
                                    group1023Props: frame97Props.group1023Props,
                                    group1024Props: frame97Props.group1024Props,
                                    group1025Props: frame97Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = InformationalModel2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Group102":"3ieGn","../Frame97":"4qO2W","../Frame11732":"h8i4O","./InformationalModel2.css":"5i6ql","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4qO2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame97Css = require("./Frame97.css");
function Frame97(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-97-4 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "aprs-combien-de-temp subtitel",
                name: "apr\xe8scombiendetempsunemploy\xe9peutpr\xe9tendre\xe0uneaugmentation",
                placeholder: "Apr\xe8s combien de temps un employ\xe9 peut pr\xe9tendre \xe0 une augmentation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de subtitel",
                name: "queltypederecrutementprivil\xe9giezvousinterneouexterne",
                placeholder: "Quel type de recrutement privil\xe9giez vous? Interne ou externe",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de subtitel",
                name: "arbitrezvousdefa\xe7on\xe9quilibr\xe9eentrelesbesoinsdelorganisationetceuxdespartiesprenantes",
                placeholder: "Arbitrez vous de fa\xe7on \xe9quilibr\xe9e entre les besoins de l\u2019organisation et ceux des parties prenantes?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "accompagnez-vous-les subtitel",
                name: "accompagnezvouslestravailleursquiveulentmonterleurpropreorganisation",
                placeholder: "Accompagnez vous les travailleurs qui veulent monter leur propre organisation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel-est-le-turnover subtitel",
                name: "quelestleturnoverdelentreprisepluselleestgrandemoinslesemploy\xe9srestent",
                placeholder: "Quel est le turnover de l\u2019entreprise (plus elle est  grande moins les employ\xe9s restent)?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame97;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Group102":"3ieGn","./Frame97.css":"b1fhh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1fhh":[function() {},{}],"5i6ql":[function() {},{}],"5Rluw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame96 = require("../Frame96");
var _frame96Default = parcelHelpers.interopDefault(_frame96);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _processView2Css = require("./ProcessView2.css");
function ProcessView2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame96Props, frame97Props, frame11732Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "process-view-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-43",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-16"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-42",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-14 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame96Default.default), {
                            toggleProps: frame96Props.toggleProps,
                            group1021Props: frame96Props.group1021Props,
                            group1022Props: frame96Props.group1022Props,
                            group1023Props: frame96Props.group1023Props,
                            group1024Props: frame96Props.group1024Props,
                            group1025Props: frame96Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                            className: frame97Props.className,
                            toggleProps: frame97Props.toggleProps,
                            group1021Props: frame97Props.group1021Props,
                            group1022Props: frame97Props.group1022Props,
                            group1023Props: frame97Props.group1023Props,
                            group1024Props: frame97Props.group1024Props,
                            group1025Props: frame97Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                    className: toggleProps.className,
                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                })
            ]
        })
    });
}
exports.default = ProcessView2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Frame96":"i2de3","../Frame97":"4qO2W","../Frame11732":"h8i4O","../Toggle":"8ZCQM","./ProcessView2.css":"2uiMN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i2de3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame96Css = require("./Frame96.css");
function Frame96(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-96-4 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vos-employs-sont-ils-1 subtitel",
                name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                placeholder: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "avez-vous-un-managem-1 subtitel",
                name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                placeholder: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-1 subtitel",
                name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                placeholder: "Garantissez vous l\u2019\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-1 subtitel",
                name: "quelmanagementutilisezvous",
                placeholder: "Quel management utilisez vous?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "est-ce-que-les-journ-1 subtitel",
                name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                placeholder: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame96;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Group102":"3ieGn","./Frame96.css":"48uSc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"48uSc":[function() {},{}],"2uiMN":[function() {},{}],"hz86Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _processView3Css = require("./ProcessView3.css");
function ProcessView3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, informationalModel, navItems2Props, navItems3Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "process-view-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-45",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-17"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-44",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-15 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-91",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-113-55",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "informational-model-11 valign-text-middle inter-bold-mineral-green-18px",
                                children: informationalModel
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ProcessView3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","./ProcessView3.css":"haw3f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haw3f":[function() {},{}],"4uf0w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame96 = require("../Frame96");
var _frame96Default = parcelHelpers.interopDefault(_frame96);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _decisionalView2Css = require("./DecisionalView2.css");
function DecisionalView2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame11732Props, toggleProps, frame96Props, frame97Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "decisional-view-2 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-46",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-3-18"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                        className: navItems2Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                        className: navItems3Props.className,
                        frame1172Props: navItems3Props.frame1172Props,
                        frame1162Props: navItems3Props.frame1162Props,
                        frame1132Props: navItems3Props.frame1132Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                        className: frame11732Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-45",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "please-answer-the-following-questions-16 valign-text-middle bevan-normal-white-20px",
                        children: pleaseAnswerTheFollowingQuestions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggleProps.className,
                        buttonSecondaryProps: toggleProps.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame96Default.default), {
                        className: frame96Props.className,
                        toggleProps: frame96Props.toggleProps,
                        group1021Props: frame96Props.group1021Props,
                        group1022Props: frame96Props.group1022Props,
                        group1023Props: frame96Props.group1023Props,
                        group1024Props: frame96Props.group1024Props,
                        group1025Props: frame96Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                        className: frame97Props.className,
                        toggleProps: frame97Props.toggleProps,
                        group1021Props: frame97Props.group1021Props,
                        group1022Props: frame97Props.group1022Props,
                        group1023Props: frame97Props.group1023Props,
                        group1024Props: frame97Props.group1024Props,
                        group1025Props: frame97Props.group1025Props
                    })
                ]
            })
        })
    });
}
exports.default = DecisionalView2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Frame11732":"h8i4O","../Toggle":"8ZCQM","../Frame96":"i2de3","../Frame97":"4qO2W","./DecisionalView2.css":"jfoFV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfoFV":[function() {},{}],"i2zVv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame92 = require("../Frame92");
var _frame92Default = parcelHelpers.interopDefault(_frame92);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _frame97 = require("../Frame97");
var _frame97Default = parcelHelpers.interopDefault(_frame97);
var _physicalModel2Css = require("./PhysicalModel2.css");
function PhysicalModel2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame92Props, frame11732Props, frame97Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "physical-model-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-47",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-19"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-46",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-17 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame92Default.default), {
                            toggleProps: frame92Props.toggleProps,
                            group1021Props: frame92Props.group1021Props,
                            group1022Props: frame92Props.group1022Props,
                            group1023Props: frame92Props.group1023Props,
                            group1024Props: frame92Props.group1024Props,
                            group1025Props: frame92Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame97Default.default), {
                    className: frame97Props.className,
                    toggleProps: frame97Props.toggleProps,
                    group1021Props: frame97Props.group1021Props,
                    group1022Props: frame97Props.group1022Props,
                    group1023Props: frame97Props.group1023Props,
                    group1024Props: frame97Props.group1024Props,
                    group1025Props: frame97Props.group1025Props
                })
            ]
        })
    });
}
exports.default = PhysicalModel2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame92":"lajrd","../Frame11732":"h8i4O","../Frame97":"4qO2W","./PhysicalModel2.css":"gbnsa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lajrd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame92Css = require("./Frame92.css");
function Frame92(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-92 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vos-employs-sont-ils-3 subtitel",
                name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                placeholder: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "avez-vous-un-managem-3 subtitel",
                name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                placeholder: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-3 subtitel",
                name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                placeholder: "Garantissez vous l\u2019\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-3 subtitel",
                name: "quelmanagementutilisezvous",
                placeholder: "Quel management utilisez vous?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "est-ce-que-les-journ-3 subtitel",
                name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                placeholder: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame92;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Group102":"3ieGn","./Frame92.css":"a4wwD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a4wwD":[function() {},{}],"gbnsa":[function() {},{}],"eVo5s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame92 = require("../Frame92");
var _frame92Default = parcelHelpers.interopDefault(_frame92);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _decisionalView3Css = require("./DecisionalView3.css");
function DecisionalView3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, procesView, navItems2Props, navItems3Props, toggleProps, frame92Props, frame93Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "decisional-view-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-48",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-20"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-47",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-18 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame92Default.default), {
                            className: frame92Props.className,
                            toggleProps: frame92Props.toggleProps,
                            group1021Props: frame92Props.group1021Props,
                            group1022Props: frame92Props.group1022Props,
                            group1023Props: frame92Props.group1023Props,
                            group1024Props: frame92Props.group1024Props,
                            group1025Props: frame92Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-113-57",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "proces-view valign-text-middle inter-bold-mineral-green-18px",
                        children: procesView
                    })
                })
            ]
        })
    });
}
exports.default = DecisionalView3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame92":"lajrd","../Frame93":"eB0oG","./DecisionalView3.css":"9Td9L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eB0oG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame93Css = require("./Frame93.css");
function Frame93(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-93-1 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "aprs-combien-de-temp-4 subtitel",
                name: "apr\xe8scombiendetempsunemploy\xe9peutpr\xe9tendre\xe0uneaugmentation",
                placeholder: "Apr\xe8s combien de temps un employ\xe9 peut pr\xe9tendre \xe0 une augmentation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de-4 subtitel",
                name: "queltypederecrutementprivil\xe9giezvousinterneouexterne",
                placeholder: "Quel type de recrutement privil\xe9giez vous? Interne ou externe",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "x-de-4 subtitel",
                name: "arbitrezvousdefa\xe7on\xe9quilibr\xe9eentrelesbesoinsdelorganisationetceuxdespartiesprenantes",
                placeholder: "Arbitrez vous de fa\xe7on \xe9quilibr\xe9e entre les besoins de l\u2019organisation et ceux des parties prenantes?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "accompagnez-vous-les-4 subtitel",
                name: "accompagnezvouslestravailleursquiveulentmonterleurpropreorganisation",
                placeholder: "Accompagnez vous les travailleurs qui veulent monter leur propre organisation?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "quel-est-le-turnover-4 subtitel",
                name: "quelestleturnoverdelentreprisepluselleestgrandemoinslesemploy\xe9srestent",
                placeholder: "Quel est le turnover de l\u2019entreprise (plus elle est  grande moins les employ\xe9s restent)?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame93;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Group102":"3ieGn","./Frame93.css":"9UDOI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9UDOI":[function() {},{}],"9Td9L":[function() {},{}],"34aN5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame92 = require("../Frame92");
var _frame92Default = parcelHelpers.interopDefault(_frame92);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _physicalModel3Css = require("./PhysicalModel3.css");
function PhysicalModel3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, decisionalView, navItems2Props, navItems3Props, toggleProps, frame92Props, frame93Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "physical-model-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-50",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-21"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-49",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-19 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame92Default.default), {
                            className: frame92Props.className,
                            toggleProps: frame92Props.toggleProps,
                            group1021Props: frame92Props.group1021Props,
                            group1022Props: frame92Props.group1022Props,
                            group1023Props: frame92Props.group1023Props,
                            group1024Props: frame92Props.group1024Props,
                            group1025Props: frame92Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            className: frame93Props.className,
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-113-58",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "decisional-view valign-text-middle inter-bold-mineral-green-18px",
                        children: decisionalView
                    })
                })
            ]
        })
    });
}
exports.default = PhysicalModel3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame92":"lajrd","../Frame93":"eB0oG","./PhysicalModel3.css":"8LdhO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8LdhO":[function() {},{}],"b42NM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame922 = require("../Frame922");
var _frame922Default = parcelHelpers.interopDefault(_frame922);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _functionnalView2Css = require("./FunctionnalView2.css");
function FunctionnalView2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame922Props, frame93Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "functionnal-view-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-34",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-51",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-22"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                                    className: navItems2Props.className
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-50",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "please-answer-the-following-questions-20 valign-text-middle bevan-normal-white-20px",
                                    children: pleaseAnswerTheFollowingQuestions
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame922Default.default), {
                                    toggleProps: frame922Props.toggleProps,
                                    group1021Props: frame922Props.group1021Props,
                                    group1022Props: frame922Props.group1022Props,
                                    group1023Props: frame922Props.group1023Props,
                                    group1024Props: frame922Props.group1024Props,
                                    group1025Props: frame922Props.group1025Props
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            className: frame93Props.className,
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-93",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {})
                    ]
                })
            ]
        })
    });
}
exports.default = FunctionnalView2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Frame922":"9mCg8","../Frame93":"eB0oG","../Toggle":"8ZCQM","../Frame11732":"h8i4O","./FunctionnalView2.css":"f30z8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9mCg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame922Css = require("./Frame922.css");
function Frame922(props) {
    const { className, toggleProps, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `frame-92-2 ${className || ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                className: toggleProps.className,
                buttonSecondaryProps: toggleProps.buttonSecondaryProps
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "vos-employs-sont-ils-6 subtitel",
                name: "vosemploy\xe9ssont-ilsforcedepropositionsconcernantlesinnovations",
                placeholder: "Vos employ\xe9s sont-ils force de propositions concernant les innovations?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1021Props.line24,
                className: group1021Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "avez-vous-un-managem-6 subtitel",
                name: "avezvousunmanagementquifavoriselcr\xe9ativit\xe9dessalari\xe9s",
                placeholder: "Avez vous un management qui favorise l cr\xe9ativit\xe9 des salari\xe9s?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1022Props.line24,
                className: group1022Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-6 subtitel",
                name: "garantissezvousl\xe9galit\xe9deschancesdetouslestravailleurscomment",
                placeholder: "Garantissez vous l\u2019\xe9galit\xe9 des chances de tous les travailleurs? Comment?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1023Props.line24,
                className: group1023Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "sez-vous-6 subtitel",
                name: "quelmanagementutilisezvous",
                placeholder: "Quel management utilisez vous?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1024Props.line24,
                className: group1024Props.className
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: "est-ce-que-les-journ-6 subtitel",
                name: "est-cequelesjourn\xe9esdetravailsontadapt\xe9esauvolumedetravail",
                placeholder: "Est-ce que les journ\xe9es de travail sont adapt\xe9es au volume de travail?",
                type: "text"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                line24: group1025Props.line24,
                className: group1025Props.className
            })
        ]
    });
}
exports.default = Frame922;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../Toggle":"8ZCQM","../Group102":"3ieGn","./Frame922.css":"ejMnz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ejMnz":[function() {},{}],"f30z8":[function() {},{}],"iFO9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame922 = require("../Frame922");
var _frame922Default = parcelHelpers.interopDefault(_frame922);
var _frame93 = require("../Frame93");
var _frame93Default = parcelHelpers.interopDefault(_frame93);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _functionnalView3Css = require("./FunctionnalView3.css");
function FunctionnalView3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, frame922Props, frame93Props, frame11732Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "functionnal-view-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-52",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-23"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-51",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-21 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame922Default.default), {
                            className: frame922Props.className,
                            toggleProps: frame922Props.toggleProps,
                            group1021Props: frame922Props.group1021Props,
                            group1022Props: frame922Props.group1022Props,
                            group1023Props: frame922Props.group1023Props,
                            group1024Props: frame922Props.group1024Props,
                            group1025Props: frame922Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame93Default.default), {
                            className: frame93Props.className,
                            toggleProps: frame93Props.toggleProps,
                            group1021Props: frame93Props.group1021Props,
                            group1022Props: frame93Props.group1022Props,
                            group1023Props: frame93Props.group1023Props,
                            group1024Props: frame93Props.group1024Props,
                            group1025Props: frame93Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                    className: toggleProps.className,
                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                })
            ]
        })
    });
}
exports.default = FunctionnalView3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Frame922":"9mCg8","../Frame93":"eB0oG","../Frame11732":"h8i4O","../Toggle":"8ZCQM","./FunctionnalView3.css":"a4x5o","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a4x5o":[function() {},{}],"1oQKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _functionnalView4Css = require("./FunctionnalView4.css");
function FunctionnalView4(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, physicalModel, navItems3Props, toggle1Props, group1021Props, group1022Props, group1023Props, group1024Props, toggle2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "functionnal-view-4 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-53",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-52",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-22",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "please-answer-the-following-questions-22 valign-text-middle bevan-normal-white-20px",
                    children: pleaseAnswerTheFollowingQuestions
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-85-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle1Props.className,
                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "traitez-vous-vos-dchets subtitel",
                            name: "traitezvousvosd\xe9chets",
                            placeholder: inputPlaceholder1,
                            type: inputType1
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1021Props.line24,
                            className: group1021Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "quel-type-demballage-utilisez-vous subtitel",
                            name: "queltypedemballageutilisezvous",
                            placeholder: inputPlaceholder2,
                            type: inputType2
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1022Props.line24,
                            className: group1022Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "frame-85-item subtitel",
                            name: "lagestiondeseauxus\xe9esfaitellepartiedevotrepolitique",
                            placeholder: inputPlaceholder3,
                            type: inputType3
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1023Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "frame-85-item subtitel",
                            name: "yat-ilunetra\xe7abilit\xe9dutraitementdevosd\xe9chets",
                            placeholder: inputPlaceholder4,
                            type: inputType4
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1024Props.line24
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-94",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle2Props.className,
                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/physical-model-2",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-113-59",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "physical-model-11 valign-text-middle inter-bold-mineral-green-18px",
                                    children: physicalModel
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = FunctionnalView4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Group102":"3ieGn","./FunctionnalView4.css":"cMfXU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cMfXU":[function() {},{}],"iBxK1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame112 = require("../Frame112");
var _frame112Default = parcelHelpers.interopDefault(_frame112);
var _loadingPageCss = require("./LoadingPage.css");
function LoadingPage(props) {
    const { x1200PxLogo_Icam__20081, inViewOfTheAnswe, navItems3Props, frame112Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "loading-page screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-54",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-53",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-23",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "in-view-of-the-answe valign-text-middle bevan-normal-white-20px",
                    children: inViewOfTheAnswe
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame112Default.default), {
                    children: frame112Props.children
                })
            ]
        })
    });
}
exports.default = LoadingPage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Frame112":"hisir","./LoadingPage.css":"4gmdL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hisir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame112Css = require("./Frame112.css");
function Frame112(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-112-6 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "click-here valign-text-middle inter-bold-mineral-green-18px",
            children: children
        })
    });
}
exports.default = Frame112;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","./Frame112.css":"jYjQy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jYjQy":[function() {},{}],"4gmdL":[function() {},{}],"3WCWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1135 = require("../Frame1135");
var _frame1135Default = parcelHelpers.interopDefault(_frame1135);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1157 = require("../Frame1157");
var _frame1157Default = parcelHelpers.interopDefault(_frame1157);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _kaizen1Css = require("./Kaizen1.css");
function Kaizen1(props) {
    const { x1200PxLogo_Icam__20081, overlapGroup11, arrow9, overlapGroup4, arrow10, line4, line2, label1, label2, overlapGroup8, textFormat, label3, label4, overlapGroup17, line1, place, clickOnModeling, inputType1, inputPlaceholder1, arrow5, arrow1, inputType2, inputPlaceholder2, arrow3, arrow7, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, arrow4, arrow6, modeling, arrow2, arrow8, xcontinue, inputType6, inputPlaceholder6, frame118Props, headerMenuDefault1Props, headerMenuDefault2Props, headerMenuDefault3Props, headerMenuDefault4Props, headerMenuDefault5Props, headerMenuDefault6Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group7-2",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-54",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-24",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-36",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-68",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1135Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1157Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-95",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-53 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-container-7",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group11",
                                            style: {
                                                backgroundImage: `url(${overlapGroup11})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-9-8",
                                                src: arrow9,
                                                alt: "Arrow 9"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group4-10",
                                            style: {
                                                backgroundImage: `url(${overlapGroup4})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-10-3",
                                                src: arrow10,
                                                alt: "Arrow 10"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group2-13",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ellipse-85-9"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group13-2",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "rectangle-9-1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group9",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-5-14"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group5-8",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line",
                                            src: line4,
                                            alt: "Line 4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-130",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-130",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group8",
                                    style: {
                                        backgroundImage: `url(${overlapGroup8})`
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "text-format-13",
                                        src: textFormat,
                                        alt: "Text format"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-130",
                                            children: label3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-130",
                                            children: label4
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-96",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group17",
                                    style: {
                                        backgroundImage: `url(${overlapGroup17})`
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "line-1-13",
                                        src: line1,
                                        alt: "Line 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-54",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-97",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/5s-1",
                                                    className: "align-self-flex-end",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-13-2",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-252 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "click-on-modeling-11 valign-text-middle bevan-normal-white-20px",
                                                    children: clickOnModeling
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-98",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-55",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group1-35",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                className: "input inter-bold-mineral-green-20px",
                                                                name: "input",
                                                                placeholder: inputPlaceholder1,
                                                                type: inputType1
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                            className: headerMenuDefault1Props.className,
                                                            children: headerMenuDefault1Props.children
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-56",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-row-99",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-5-8",
                                                                    src: arrow5,
                                                                    alt: "Arrow 5"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-1-11",
                                                                    src: arrow1,
                                                                    alt: "Arrow 1"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex-col-57",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "overlap-group15-1",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                                className: "plan inter-bold-mineral-green-24px",
                                                                                name: "plan",
                                                                                placeholder: inputPlaceholder2,
                                                                                type: inputType2
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                            className: headerMenuDefault2Props.className,
                                                                            children: headerMenuDefault2Props.children
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-3-8",
                                                                    src: arrow3,
                                                                    alt: "Arrow 3"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-7-7",
                                                                    src: arrow7,
                                                                    alt: "Arrow 7"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-col-58",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group-container-8",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "overlap-group6-4",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                                className: "act inter-bold-mineral-green-24px",
                                                                                name: "act",
                                                                                placeholder: inputPlaceholder3,
                                                                                type: inputType3
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "overlap-group-55",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                                className: "do inter-bold-mineral-green-24px",
                                                                                name: "do",
                                                                                placeholder: inputPlaceholder4,
                                                                                type: inputType4
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex-row-100",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "flex-col-59",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "overlap-group-container-9",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                            className: "overlap-group16-2",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                                                    className: headerMenuDefault3Props.className,
                                                                                                    children: headerMenuDefault3Props.children
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                    className: "rectangle-6-4"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                                                    className: "check inter-bold-mineral-green-24px",
                                                                                                    name: "check",
                                                                                                    placeholder: inputPlaceholder5,
                                                                                                    type: inputType5
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                            className: "overlap-group12-2",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                                                    className: headerMenuDefault4Props.className,
                                                                                                    children: headerMenuDefault4Props.children
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                    className: "arrow-4-8",
                                                                                                    src: arrow4,
                                                                                                    alt: "Arrow 4"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                    className: "arrow-6-10",
                                                                                                    src: arrow6,
                                                                                                    alt: "Arrow 6"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "frame-13-3",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                                        href: "https://app.diagrams.net/",
                                                                                        target: "_blank",
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "modeling-101 valign-text-middle inter-bold-mineral-green-18px",
                                                                                            children: modeling
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "overlap-group3-12",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                                    className: headerMenuDefault5Props.className,
                                                                                    children: headerMenuDefault5Props.children
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    className: "arrow-2-10",
                                                                                    src: arrow2,
                                                                                    alt: "Arrow 2"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "flex-col-60",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    className: "arrow-8-9",
                                                                                    src: arrow8,
                                                                                    alt: "Arrow 8"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                                                    to: "/kaizen1-1",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "frame-2-19",
                                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "continue-12 valign-text-middle inter-bold-mineral-green-18px",
                                                                                            children: xcontinue
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-61",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group18",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                className: "output inter-bold-mineral-green-20px",
                                                                name: "output",
                                                                placeholder: inputPlaceholder6,
                                                                type: inputType6
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                            className: headerMenuDefault6Props.className,
                                                            children: headerMenuDefault6Props.children
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame1144":"cyPUr","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame1135":"4zAdk","../Frame1146":"ebdMs","../Frame1157":"eY2iM","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","../HeaderMenuDefault":"9P7JS","./Kaizen1.css":"nESu2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eY2iM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1157Css = require("./Frame1157.css");
function Frame1157() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-115-117",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kaizen-10 valign-text-middle inter-medium-white-18px",
            children: "Kaizen"
        })
    });
}
exports.default = Frame1157;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1157.css":"fqZpc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqZpc":[function() {},{}],"nESu2":[function() {},{}],"dW5Jc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _existingSystemsCss = require("./ExistingSystems.css");
function ExistingSystems(props) {
    const { ellipse116, x1200PxLogo_Icam__20081, existingSystems, graiMethodologyModels, x2SupplementaryModels, navItems3Props, toggle1Props, toggle2Props, toggle3Props, toggle4Props, toggle5Props, toggle6Props, toggle7Props, toggle8Props, toggle9Props, toggle10Props, toggle11Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "existing-systems-2 bevan-normal-white-20px screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "ellipse-116-2",
                    src: ellipse116,
                    alt: "Ellipse 116"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-56",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-55",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-25",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "existing-systems valign-text-middle",
                    children: existingSystems
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "y-models-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "y-models valign-text-middle",
                            children: graiMethodologyModels
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "y-models valign-text-middle",
                            children: x2SupplementaryModels
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "group-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "group-81",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-101",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "toggle-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle1Props.className,
                                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle2Props.className,
                                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "toggle-container-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle3Props.className,
                                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle4Props.className,
                                                    buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle5Props.className,
                                    buttonSecondaryProps: toggle5Props.buttonSecondaryProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "group-82",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "toggle-container-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle6Props.className,
                                            buttonSecondaryProps: toggle6Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle7Props.className,
                                            buttonSecondaryProps: toggle7Props.buttonSecondaryProps
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "toggle-container-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle8Props.className,
                                            buttonSecondaryProps: toggle8Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle9Props.className,
                                            buttonSecondaryProps: toggle9Props.buttonSecondaryProps
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "toggle-container-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle10Props.className,
                                            buttonSecondaryProps: toggle10Props.buttonSecondaryProps
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                            className: toggle11Props.className,
                                            buttonSecondaryProps: toggle11Props.buttonSecondaryProps
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ExistingSystems;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","./ExistingSystems.css":"iSQOH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iSQOH":[function() {},{}],"juQJU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1135 = require("../Frame1135");
var _frame1135Default = parcelHelpers.interopDefault(_frame1135);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame1175 = require("../Frame1175");
var _frame1175Default = parcelHelpers.interopDefault(_frame1175);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _kanban1Css = require("./Kanban1.css");
function Kanban1(props) {
    const { x1200PxLogo_Icam__20081, arrow9, arrow10, rectangle23, line2, label1, textFormat, label2, line22, place1, clickOnModeling, place2, arrow11, line4, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, line3, modeling, xcontinue, frame1135Props, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-14",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-56",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-26",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-37",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-69",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1135Default.default), {
                                            className: frame1135Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1175Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-102",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-63",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-64",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-14",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-9-9",
                                                    src: arrow9,
                                                    alt: "Arrow 9"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-10-4",
                                                    src: arrow10,
                                                    alt: "Arrow 10"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-10"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-9-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-5-15"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-103",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-62",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "rectangle-23",
                                                    src: rectangle23,
                                                    alt: "Rectangle 23"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-25"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-62",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-24"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-26"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-container-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group-84",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-57",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-2-13",
                                                            src: line2,
                                                            alt: "Line 2"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-86-13"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-131 inter-medium-rum-swizzle-18-1px",
                                                    children: label1
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group-83",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "text-format-14",
                                                    src: textFormat,
                                                    alt: "Text format"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-132 inter-medium-rum-swizzle-18-1px",
                                                    children: label2
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-104",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-22",
                                    src: line22,
                                    alt: "Line 22"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/smed-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-12-5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "place-254 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: place1
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-65",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-12 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group3-13",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "place-256 valign-text-middle inter-bold-mineral-green-24px",
                                                    children: place2
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-36",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-10"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-12"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-3",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-4-4",
                                                            src: line4,
                                                            alt: "Line 4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            className: "urgence inter-medium-dark-fern-15px",
                                                            name: "urgence",
                                                            placeholder: inputPlaceholder1,
                                                            type: inputType1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-17"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-15"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-19"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-21"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "to-do inter-medium-dark-fern-18-1px",
                                                    name: "todo",
                                                    placeholder: inputPlaceholder2,
                                                    type: inputType2
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "completed inter-medium-dark-fern-18-1px",
                                                    name: "completed",
                                                    placeholder: inputPlaceholder3,
                                                    type: inputType3
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "pending inter-medium-dark-fern-18-1px",
                                                    name: "pending",
                                                    placeholder: inputPlaceholder4,
                                                    type: inputType4
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "in-progress inter-medium-dark-fern-18-1px",
                                                    name: "inprogress",
                                                    placeholder: inputPlaceholder5,
                                                    type: inputType5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-3-6",
                                                    src: line3,
                                                    alt: "Line 3"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-12",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/existing-case",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-15",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                            href: "https://app.diagrams.net/",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "modeling-102 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                                children: modeling
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/visual-management-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-15",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-13 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kanban1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame1144":"cyPUr","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame1135":"4zAdk","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame1175":"g5CV0","../Frame118":"kfDbB","./Kanban1.css":"9jhRW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5CV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1175Css = require("./Frame1175.css");
function Frame1175() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-117-95",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kanban-12 valign-text-middle inter-medium-white-18px",
            children: "Kanban"
        })
    });
}
exports.default = Frame1175;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1175.css":"5LKt9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5LKt9":[function() {},{}],"9jhRW":[function() {},{}],"duzIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _headerMenuDefault4 = require("../HeaderMenuDefault4");
var _headerMenuDefault4Default = parcelHelpers.interopDefault(_headerMenuDefault4);
var _leanVSMCss = require("./LeanVSM.css");
function LeanVSM(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow4, arrow6, arrow5, rectangle7, xcontinue, arrow1, arrow2, rectangle6, line2, label1, textFormat, label2, line1, place, arrow3, modeling, clickOnModeling, frame118Props, headerMenuDefault41Props, headerMenuDefault42Props, headerMenuDefault43Props, headerMenuDefault44Props, headerMenuDefault45Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-8 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-57",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-27",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-39",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-97",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-78 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-70",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-60",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-9 valign-text-middle inter-medium-white-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-105",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "arrow-4-9",
                            src: arrow4,
                            alt: "Arrow 4"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "overlap-group3-14",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                children: headerMenuDefault41Props.children
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "arrow-6-11",
                            src: arrow6,
                            alt: "Arrow 6"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-66",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group1-37",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-5-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-5-9",
                                            src: arrow5,
                                            alt: "Arrow 5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "rectangle-7-4",
                                            src: rectangle7,
                                            alt: "Rectangle 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                            className: headerMenuDefault42Props.className,
                                            children: headerMenuDefault42Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                            className: headerMenuDefault43Props.className,
                                            children: headerMenuDefault43Props.children
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/5s",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-2-20",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "continue-14 valign-text-middle inter-bold-mineral-green-18px",
                                            children: xcontinue
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-106",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-67 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-1-12",
                                            src: arrow1,
                                            alt: "Arrow 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-2-11",
                                            src: arrow2,
                                            alt: "Arrow 2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-88-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-3-24"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "rectangle-6-5",
                                    src: rectangle6,
                                    alt: "Rectangle 6"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-58",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-14",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-14"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-133",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-15",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-134",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "line-1-14",
                            src: line1,
                            alt: "Line 1"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "overlap-group4-11",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                        className: headerMenuDefault44Props.className,
                        children: headerMenuDefault44Props.children
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-68",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/informational-model",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-6-9",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "place-257 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                    children: place
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group5-9",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "arrow-3-9",
                                    src: arrow3,
                                    alt: "Arrow 3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-87-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault4Default.default), {
                                    className: headerMenuDefault45Props.className,
                                    children: headerMenuDefault45Props.children
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-10-4",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://app.diagrams.net/",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modeling-103 valign-text-middle inter-bold-tropical-rain-forest-18px",
                            children: modeling
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "click-on-modeling-13 valign-text-middle bevan-normal-white-20px",
                    children: clickOnModeling
                })
            ]
        })
    });
}
exports.default = LeanVSM;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","../HeaderMenuDefault4":"8vlkW","./LeanVSM.css":"7TiUc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vlkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerMenuDefault4Css = require("./HeaderMenuDefault4.css");
function HeaderMenuDefault4(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default-23-1 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "label-135 inter-medium-dark-fern-14px",
            children: children
        })
    });
}
exports.default = HeaderMenuDefault4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./HeaderMenuDefault4.css":"5xNTM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xNTM":[function() {},{}],"7TiUc":[function() {},{}],"5dids":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1135 = require("../Frame1135");
var _frame1135Default = parcelHelpers.interopDefault(_frame1135);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1165 = require("../Frame1165");
var _frame1165Default = parcelHelpers.interopDefault(_frame1165);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame6 = require("../Frame6");
var _frame6Default = parcelHelpers.interopDefault(_frame6);
var _smed1Css = require("./SMED1.css");
function SMED1(props) {
    const { x1200PxLogo_Icam__20081, arrow9, arrow10, line2, label1, textFormat, label2, line1, place, clickOnModeling, label3, arrow5, label4, arrow15, arrow12, arrow13, dernierePieceBonneSerieA, changementOutillage, reglage, inputType1, inputPlaceholder1, arrow18, arrow17, arrow16, inputType2, inputPlaceholder2, arrow14, arrow11, modeling, xcontinue, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-38",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-58",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-28",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-43",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-71",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1135Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1165Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-107",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-69 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-16",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-9-10",
                                            src: arrow9,
                                            alt: "Arrow 9"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-10-5",
                                            src: arrow10,
                                            alt: "Arrow 10"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-85-11"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-9-3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-5-16"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group2-16",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-2-15",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-86-15"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-136",
                                    children: label1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "text-format-16",
                                    src: textFormat,
                                    alt: "Text format"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "label-137",
                                    children: label2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-108",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-1-15",
                                    src: line1,
                                    alt: "Line 1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-70",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-109",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/kaizen1-1",
                                                    className: "align-self-flex-end",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-11-9",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-258 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "click-on-modeling-14 valign-text-middle bevan-normal-white-20px",
                                                    children: clickOnModeling
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-10",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group3-15",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-138 inter-medium-cultured-pearl-18-1px",
                                                            children: label3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-5-10",
                                                            src: arrow5,
                                                            alt: "Arrow 5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group4-12",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-139 inter-medium-cultured-pearl-18-1px",
                                                            children: label4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-15-1",
                                                            src: arrow15,
                                                            alt: "Arrow 15"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-59 inter-medium-dark-fern-18-1px",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-8"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-12-1",
                                                            src: arrow12,
                                                            alt: "Arrow 12"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-1",
                                                            src: arrow13,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-10-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "derniere-piece-bonne-serie-a",
                                                            children: dernierePieceBonneSerieA
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-11-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "changement-outillage",
                                                            children: changementOutillage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "reglage",
                                                            children: reglage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            className: "nettoyage inter-medium-dark-fern-18-1px",
                                                            name: "nettoyage",
                                                            placeholder: inputPlaceholder1,
                                                            type: inputType1
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-18",
                                                            src: arrow18,
                                                            alt: "Arrow 18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-17",
                                                            src: arrow17,
                                                            alt: "Arrow 17"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-1",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                            className: "premiere-piece-bonne-serie-b inter-medium-dark-fern-18-1px",
                                                            name: "premierepiecebonneserieb",
                                                            placeholder: inputPlaceholder2,
                                                            type: inputType2
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-110",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-14-1",
                                                    src: arrow14,
                                                    alt: "Arrow 14"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group5-10",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame6Default.default), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-4",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-13",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-12-6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-104 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/kanban-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-21",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-15 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = SMED1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame1144":"cyPUr","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame117":"1Qy2K","../Frame11322":"lrJXI","../Frame1135":"4zAdk","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1165":"19F2e","../Frame11742":"1OJFF","../Frame118":"kfDbB","../Frame6":"3x8zF","./SMED1.css":"fZq2m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"19F2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame1165Css = require("./Frame1165.css");
function Frame1165() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-116-178",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "smed-13 valign-text-middle inter-medium-white-18px",
            children: "SMED"
        })
    });
}
exports.default = Frame1165;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame1165.css":"l17CG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l17CG":[function() {},{}],"3x8zF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame6Css = require("./Frame6.css");
function Frame6(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-6-10 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "machine-arretee inter-medium-dark-fern-18-1px",
            children: "MACHINE ARRETEE"
        })
    });
}
exports.default = Frame6;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame6.css":"6mv93","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6mv93":[function() {},{}],"fZq2m":[function() {},{}],"iG3Lu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1147 = require("../Frame1147");
var _frame1147Default = parcelHelpers.interopDefault(_frame1147);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _x5SCss = require("./X5S.css");
function X5S(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow12, arrow13, line2, label1, textFormat, label2, line23, place, seiri, arrow7, disposal, clickOnModeling, arrow3, seiton, arrow8, putAway, modeling, arrow4, seison, arrow9, clean, arrow6, seiketsu, shitsuke, arrow10, arrow11, arrow5, rectangle7, standardize, respect, xcontinue, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group3-16",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-59",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-29",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-45",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-98",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-79 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-72",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-61",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-10 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1147Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-111",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-71",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-17",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-12-2",
                                            src: arrow12,
                                            alt: "Arrow 12"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-13-2",
                                            src: arrow13,
                                            alt: "Arrow 13"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-86-16"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-23-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8-5"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-24-1"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-86",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-60",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-16",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-17"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-140 inter-medium-rum-swizzle-18-1px",
                                            children: label1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-85",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-17",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-141 inter-medium-rum-swizzle-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-112",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-23",
                                    src: line23,
                                    alt: "Line 23"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-72",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            className: "align-self-flex-start",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-5-17",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-259 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "seiri-1 inter-medium-white-18-1px",
                                            children: seiri
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-7-8",
                                            src: arrow7,
                                            alt: "Arrow 7"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group2-17",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-87-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-89-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "disposal-1 inter-medium-dark-fern-18-1px",
                                                    children: disposal
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-73",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-15 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-113",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-74",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-row-114",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-3-10",
                                                                    src: arrow3,
                                                                    alt: "Arrow 3"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex-col-75",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "seiton-1 inter-medium-white-18-1px",
                                                                            children: seiton
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-8-10",
                                                                            src: arrow8,
                                                                            alt: "Arrow 8"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "overlap-group5-11",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "put-away-1 inter-medium-dark-fern-18-1px",
                                                                                children: putAway
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-9-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-105 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-115",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-4-10",
                                                            src: arrow4,
                                                            alt: "Arrow 4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-col-76",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "seison-1 inter-medium-white-18-1px",
                                                                    children: seison
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-9-11",
                                                                    src: arrow9,
                                                                    alt: "Arrow 9"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "overlap-group4-13",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "clean inter-medium-dark-fern-18-1px",
                                                                        children: clean
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-12",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "flex-col-77",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "flex-row-116 inter-medium-white-18-1px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "seiketsu-1",
                                                                            children: seiketsu
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "shitsuke-1",
                                                                            children: shitsuke
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "arrow-container-18",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-1-13",
                                                                            src: arrow10,
                                                                            alt: "Arrow 10"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-1-13",
                                                                            src: arrow11,
                                                                            alt: "Arrow 11"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group1-39 inter-medium-dark-fern-18-1px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "rectangle-5-5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-5-11",
                                                                            src: arrow5,
                                                                            alt: "Arrow 5"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "rectangle-7-5",
                                                                            src: rectangle7,
                                                                            alt: "Rectangle 7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "standardize-1",
                                                                            children: standardize
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "respect-1",
                                                                            children: respect
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                                    to: "/kaizen",
                                                                    className: "align-self-flex-start",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "frame-2-22",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "continue-16 valign-text-middle inter-bold-mineral-green-18px",
                                                                            children: xcontinue
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = X5S;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1147":"lq7t9","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","./X5S.css":"3zls7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3zls7":[function() {},{}],"9uODK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1157 = require("../Frame1157");
var _frame1157Default = parcelHelpers.interopDefault(_frame1157);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame8 = require("../Frame8");
var _frame8Default = parcelHelpers.interopDefault(_frame8);
var _frame82 = require("../Frame82");
var _frame82Default = parcelHelpers.interopDefault(_frame82);
var _frame9 = require("../Frame9");
var _frame9Default = parcelHelpers.interopDefault(_frame9);
var _kaizen12Css = require("./Kaizen12.css");
function Kaizen12(props) {
    const { x1200PxLogo_Icam__20081, label1, leanVsm, label2, overlapGroup8, arrow9, overlapGroup5, arrow10, line4, line2, label3, label4, overlapGroup9, textFormat, label5, label6, overlapGroup4, line1, place, x1IdentificatonDuProblemeATraiter, x2EtudeDeLaSituation, arrow6, x6AuditDesContreMesures, arrow16, arrow13, arrow14, arrow15, arrow17, x7StandardisationDesBonnesMesures, modeling, xcontinue, frame11332Props, frame11322Props, frame118Props, frame8Props, frame82Props, frame9Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-78",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group1-40",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-60",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-30",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-2-47",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                                    className: frame11332Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/functional-view",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-143 inter-medium-sonic-silver-18-1px",
                                                        children: label1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                                    className: frame11322Props.className
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-3-73",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/lean-vsm",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-113-62",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "lean-vsm-11 valign-text-middle inter-medium-star-dust-18px",
                                                            children: leanVsm
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1157Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                                    className: frame118Props.className,
                                                    children: frame118Props.children
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "label-144 inter-medium-cultured-pearl-20px",
                            children: label2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-117",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-79 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-container-11",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group8-1",
                                            style: {
                                                backgroundImage: `url(${overlapGroup8})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-9-12",
                                                src: arrow9,
                                                alt: "Arrow 9"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group5-12",
                                            style: {
                                                backgroundImage: `url(${overlapGroup5})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-10-6",
                                                src: arrow10,
                                                alt: "Arrow 10"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ellipse-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-87-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-12"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-10-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group11-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-5-18"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group3-17",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-5",
                                            src: line4,
                                            alt: "Line 4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8-1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-5",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8-1"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label4
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group9-1",
                                    style: {
                                        backgroundImage: `url(${overlapGroup9})`
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "text-format-18",
                                        src: textFormat,
                                        alt: "Text format"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label5
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-142",
                                            children: label6
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-118",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-119",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group4-14",
                                            style: {
                                                backgroundImage: `url(${overlapGroup4})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "line-1-16",
                                                src: line1,
                                                alt: "Line 1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/kaizen",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-8-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-260 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-80",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group12-3 inter-medium-dark-fern-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-7-4",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "x1-identificaton-du-probleme-a-traiter inter-medium-dark-fern-18-1px",
                                                        children: x1IdentificatonDuProblemeATraiter
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group10",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-8-7",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "x2-etude-de-la-situation",
                                                                children: x2EtudeDeLaSituation
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-13",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-61",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-10-5",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "x6-audit-des-contre-mesures",
                                                                children: x6AuditDesContreMesures
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame8Default.default), {
                                                            children: frame8Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame82Default.default), {
                                                            children: frame82Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame9Default.default), {
                                                            children: frame9Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-2",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-3",
                                                            src: arrow13,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14-2",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-15-2",
                                                            src: arrow15,
                                                            alt: "Arrow 15"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-17-1",
                                            src: arrow17,
                                            alt: "Arrow 17"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-14",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-8",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "x7-standardisation-des-bonnes-mesures inter-medium-dark-fern-18-1px",
                                                        children: x7StandardisationDesBonnesMesures
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-10-6",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-106 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/smed",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-23",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-17 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen12;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1146":"ebdMs","../Frame1157":"eY2iM","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","../Frame8":"hZADe","../Frame82":"1lvHl","../Frame9":"5n4VD","./Kaizen12.css":"2p4hj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZADe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame8Css = require("./Frame8.css");
function Frame8(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-8-9",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            className: "x5-mise-en-action-des-contre-mesures",
            children: children
        })
    });
}
exports.default = Frame8;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame8.css":"8v4E5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8v4E5":[function() {},{}],"1lvHl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame82Css = require("./Frame82.css");
function Frame82(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-8-11",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x4-identification-des-contre-mesures",
            children: children
        })
    });
}
exports.default = Frame82;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame82.css":"6JgrV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6JgrV":[function() {},{}],"5n4VD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame9Css = require("./Frame9.css");
function Frame9(props) {
    const { children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "frame-9-6",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "x3-etude-des-causes",
            children: children
        })
    });
}
exports.default = Frame9;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame9.css":"1iUOr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1iUOr":[function() {},{}],"2p4hj":[function() {},{}],"7OkZe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1157 = require("../Frame1157");
var _frame1157Default = parcelHelpers.interopDefault(_frame1157);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _kaizenCss = require("./Kaizen.css");
function Kaizen(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow12, arrow13, line2, label1, textFormat, label2, line23, place1, input, clickOnModeling, arrow5, arrow1, place2, arrow3, arrow7, act, xdo, arrow4, arrow6, check, arrow2, arrow8, modeling, xcontinue, output, frame118Props, headerMenuDefault1Props, headerMenuDefault2Props, headerMenuDefault3Props, headerMenuDefault4Props, headerMenuDefault5Props, headerMenuDefault6Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen-14 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group4-15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-62",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-32",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-48",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-99",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-80 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-74",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-63",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-12 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1157Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-121",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-81",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-19",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-12-3",
                                            src: arrow12,
                                            alt: "Arrow 12"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-13-4",
                                            src: arrow13,
                                            alt: "Arrow 13"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-86-18"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-23-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8-13"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-24-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-86-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-63",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-17",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-19"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-145 inter-medium-rum-swizzle-18-1px",
                                            children: label1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-85-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-19",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-146 inter-medium-rum-swizzle-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-122",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-123",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-23-1",
                                            src: line23,
                                            alt: "Line 23"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-82",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/5s",
                                                    className: "align-self-flex-start",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-7-5",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-261 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place1
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group8-2",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "input-1 valign-text-middle inter-bold-mineral-green-20px",
                                                        children: input
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                    className: headerMenuDefault1Props.className,
                                                    children: headerMenuDefault1Props.children
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-83",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-16 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-124",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-5-12",
                                                    src: arrow5,
                                                    alt: "Arrow 5"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-1-14",
                                                    src: arrow1,
                                                    alt: "Arrow 1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-84",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group3-18",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                                className: "place-262 valign-text-middle inter-bold-mineral-green-24px",
                                                                children: place2
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                            className: headerMenuDefault2Props.className,
                                                            children: headerMenuDefault2Props.children
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-3-11",
                                                    src: arrow3,
                                                    alt: "Arrow 3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-7-9",
                                                    src: arrow7,
                                                    alt: "Arrow 7"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-85",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-container-12",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group9-2",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "act-1 valign-text-middle inter-bold-mineral-green-24px",
                                                                children: act
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group7-3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "do-1 valign-text-middle inter-bold-mineral-green-24px",
                                                                children: xdo
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-125",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group-container-13",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "overlap-group5-13",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                            className: headerMenuDefault3Props.className,
                                                                            children: headerMenuDefault3Props.children
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-4-11",
                                                                            src: arrow4,
                                                                            alt: "Arrow 4"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                            className: "arrow-6-14",
                                                                            src: arrow6,
                                                                            alt: "Arrow 6"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "overlap-group6-5",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "check-1 valign-text-middle inter-bold-mineral-green-24px",
                                                                        children: check
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group2-18",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                                    className: headerMenuDefault4Props.className,
                                                                    children: headerMenuDefault4Props.children
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "arrow-2-12",
                                                                    src: arrow2,
                                                                    alt: "Arrow 2"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-8-11",
                                                            src: arrow8,
                                                            alt: "Arrow 8"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-row-126",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-5-19",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-107 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                            className: headerMenuDefault5Props.className,
                                                            children: headerMenuDefault5Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                            to: "/kaizen1",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-2-24",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "continue-18 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: xcontinue
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-86",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group1-41",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "output-1 valign-text-middle inter-bold-mineral-green-20px",
                                                children: output
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                            className: headerMenuDefault6Props.className,
                                            children: headerMenuDefault6Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1146":"ebdMs","../Frame1157":"eY2iM","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","../HeaderMenuDefault":"9P7JS","./Kaizen.css":"aqAPK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqAPK":[function() {},{}],"8xDMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1165 = require("../Frame1165");
var _frame1165Default = parcelHelpers.interopDefault(_frame1165);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame6 = require("../Frame6");
var _frame6Default = parcelHelpers.interopDefault(_frame6);
var _smedCss = require("./SMED.css");
function SMED(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow121, arrow131, line2, label1, textFormat, label2, line23, place, clickOnModeling, label3, arrow5, label4, arrow15, arrow122, arrow132, dernierePieceBonneSerieA, changementOutillage, reglage, nettoyage, arrow18, arrow17, arrow16, premierePieceBonneSerieB, arrow14, modeling, arrow11, xcontinue, frame118Props, frame6Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "smed-15 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-19",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-63",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-33",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-49",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-100",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-81 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-75",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-64",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-13 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1165Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-127",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-87",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "arrow-container-20",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-12-4",
                                            src: arrow121,
                                            alt: "Arrow 12"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-13-5",
                                            src: arrow131,
                                            alt: "Arrow 13"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "ellipse-86-20"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-23-3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-8-14"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-24-3"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-86-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-64",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-18",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-21"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-147 inter-medium-rum-swizzle-18-1px",
                                            children: label1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-85-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-20",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-148 inter-medium-rum-swizzle-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-128",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-129",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-23-2",
                                            src: line23,
                                            alt: "Line 23"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/kaizen1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-7-6",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-263 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-88",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-17 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-14 inter-medium-cultured-pearl-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group4-16",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-149",
                                                            children: label3
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-5-13",
                                                            src: arrow5,
                                                            alt: "Arrow 5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group3-19",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "label-150",
                                                            children: label4
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-15-3",
                                                            src: arrow15,
                                                            alt: "Arrow 15"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-42 inter-medium-dark-fern-18-1px",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-8-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-12-5",
                                                            src: arrow122,
                                                            alt: "Arrow 12"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-6",
                                                            src: arrow132,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-10-3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "derniere-piece-bonne-serie-a-1",
                                                            children: dernierePieceBonneSerieA
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-11-2"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "changement-outillage-1",
                                                            children: changementOutillage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "reglage-1",
                                                            children: reglage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "nettoyage-1",
                                                            children: nettoyage
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-18-1",
                                                            src: arrow18,
                                                            alt: "Arrow 18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-17-2",
                                                            src: arrow17,
                                                            alt: "Arrow 17"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-3",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "premiere-piece-bonne-serie-b-1",
                                                            children: premierePieceBonneSerieB
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-130",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-89",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14-3",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-5-20",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                href: "https://app.diagrams.net/",
                                                                target: "_blank",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "modeling-108 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                                    children: modeling
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame6Default.default), {
                                                    className: frame6Props.className
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-90",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-5",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                            to: "/kanban",
                                                            className: "align-self-flex-end",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "frame-2-25",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "continue-19 valign-text-middle inter-bold-mineral-green-18px",
                                                                    children: xcontinue
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = SMED;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1165":"19F2e","../Frame11742":"1OJFF","../Frame118":"kfDbB","../Frame6":"3x8zF","./SMED.css":"93FnA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93FnA":[function() {},{}],"hmjNi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame1136 = require("../Frame1136");
var _frame1136Default = parcelHelpers.interopDefault(_frame1136);
var _visualManagementCss = require("./VisualManagement.css");
function VisualManagement(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow9, arrow10, line2, label1, textFormat, label2, line1, place, clickOnModeling, connaissancesCompetences, collaborateursEquipes, strategiesProjets, ideesInformations, tempsPriorites, arrow11, arrow16, arrow13, arrow14, mieuxManager, arrow12, arrow15, problemesDecision, modeling, analyzeTheFuturPerformances, frame1136Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "visual-management-15 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-43",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-64",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-34",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-50",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-101",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-82 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-76",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-65",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-14 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1136Default.default), {
                                            className: frame1136Props.className,
                                            children: frame1136Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-131",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-132",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-91 inter-medium-rum-swizzle-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-21",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-9-13",
                                                    src: arrow9,
                                                    alt: "Arrow 9"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-10-7",
                                                    src: arrow10,
                                                    alt: "Arrow 10"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-13"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-9-4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-5-21"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group2-20",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-2-19",
                                                    src: line2,
                                                    alt: "Line 2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "ellipse-86-22"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-151",
                                            children: label1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "text-format-21",
                                            src: textFormat,
                                            alt: "Text format"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-152",
                                            children: label2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-133",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-1-17",
                                            src: line1,
                                            alt: "Line 1"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/kanban",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-11-10",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "place-264 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: place
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-92",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "click-on-modeling-18 valign-text-middle bevan-normal-white-20px",
                                    children: clickOnModeling
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group3-20 inter-medium-dark-fern-18-1px",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group2-21",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-6-12",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "connaissances-competences",
                                                        children: connaissancesCompetences
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-7-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "collaborateurs-equipes",
                                                        children: collaborateursEquipes
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-10-7",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "strategies-projets",
                                                        children: strategiesProjets
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-15",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "idees-informations",
                                                        children: ideesInformations
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-65",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-6-13",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "temps-priorites",
                                                                children: tempsPriorites
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-6",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-4",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-7",
                                                            src: arrow13,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14-4",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-87-5"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "mieux-manager",
                                                            children: mieuxManager
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-12-6",
                                                    src: arrow12,
                                                    alt: "Arrow 12"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-15-4",
                                                    src: arrow15,
                                                    alt: "Arrow 15"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-9-8",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "problemes-decision",
                                                children: problemesDecision
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "frame-container-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-8-16",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                href: "https://app.diagrams.net/",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "modeling-109 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: modeling
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/environmental-1",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-2-26",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "analyze-the-futur-performances valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                    children: analyzeTheFuturPerformances
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = VisualManagement;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame1136":"8aQ7W","./VisualManagement.css":"dougE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dougE":[function() {},{}],"4GVOG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1154 = require("../Frame1154");
var _frame1154Default = parcelHelpers.interopDefault(_frame1154);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame1175 = require("../Frame1175");
var _frame1175Default = parcelHelpers.interopDefault(_frame1175);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _kanbanCss = require("./Kanban.css");
function Kanban(props) {
    const { x1200PxLogo_Icam__20081, design, leanVsm, arrow9, arrow10, rectangle23, line2, label1, textFormat, label2, line22, place1, clickOnModeling, place2, arrow11, line4, urgence, aFaire, termine, enAttente, enCours, line3, modeling, xcontinue, frame118Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-14 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-22",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-65",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-35",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-51",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-102",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-83 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-77",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/lean-vsm",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "frame-113-66",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "lean-vsm-15 valign-text-middle inter-medium-star-dust-18px",
                                                    children: leanVsm
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1154Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1175Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-134",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-94",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-95",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "arrow-container-22",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-9-14",
                                                    src: arrow9,
                                                    alt: "Arrow 9"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "arrow-10-8",
                                                    src: arrow10,
                                                    alt: "Arrow 10"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-14"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-9-5"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-5-22"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-row-135",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-93",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "rectangle-23-4",
                                                    src: rectangle23,
                                                    alt: "Rectangle 23"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-25-1"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-93",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-24-4"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "rectangle-26-1"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "group-container-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group-84-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-66",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-2-20",
                                                            src: line2,
                                                            alt: "Line 2"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ellipse-86-23"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-153 inter-medium-rum-swizzle-18-1px",
                                                    children: label1
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "group-83-1",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "text-format-22",
                                                    src: textFormat,
                                                    alt: "Text format"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-154 inter-medium-rum-swizzle-18-1px",
                                                    children: label2
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-136",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-22-1",
                                    src: line22,
                                    alt: "Line 22"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/smed",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-7-8",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "place-265 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                            children: place1
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-96",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "click-on-modeling-19 valign-text-middle bevan-normal-white-20px",
                                            children: clickOnModeling
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group3-21",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "place-266 valign-text-middle inter-bold-mineral-green-24px",
                                                    children: place2
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group1-44",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-10-4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-13-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-12-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-11-3"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-11-7",
                                                            src: arrow11,
                                                            alt: "Arrow 11"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "line-4-5",
                                                            src: line4,
                                                            alt: "Line 4"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "urgence-1 inter-medium-dark-fern-15px",
                                                            children: urgence
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-17-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-16-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-14-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-15-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-18-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-19-1"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "rectangle-21-1"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "a-faire inter-medium-dark-fern-18-1px",
                                                    children: aFaire
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "termine inter-medium-dark-fern-18-1px",
                                                    children: termine
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "en-attente inter-medium-dark-fern-18-1px",
                                                    children: enAttente
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "en-cours inter-medium-dark-fern-18-1px",
                                                    children: enCours
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    className: "line-3-7",
                                                    src: line3,
                                                    alt: "Line 3"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-16",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-17",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-110 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/visual-management",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-27",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-20 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kanban;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1146":"ebdMs","../Frame1154":"2tJ8O","../Frame1164":"9Ds6S","../Frame1175":"g5CV0","../Frame118":"kfDbB","./Kanban.css":"eNAKD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eNAKD":[function() {},{}],"e9OxE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _kaizen2Css = require("./Kaizen2.css");
function Kaizen2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "kaizen-2-1 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-67",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-3-25"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                        className: navItems2Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                        className: navItems3Props.className,
                        frame1172Props: navItems3Props.frame1172Props,
                        frame1162Props: navItems3Props.frame1162Props,
                        frame1132Props: navItems3Props.frame1132Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-66",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggleProps.className,
                        buttonSecondaryProps: toggleProps.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "please-answer-the-following-questions-23 valign-text-middle bevan-normal-white-20px",
                        children: pleaseAnswerTheFollowingQuestions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                        className: frame101Props.className,
                        toggleProps: frame101Props.toggleProps,
                        group1021Props: frame101Props.group1021Props,
                        group1022Props: frame101Props.group1022Props,
                        group1023Props: frame101Props.group1023Props,
                        group1024Props: frame101Props.group1024Props,
                        group1025Props: frame101Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                        className: frame102Props.className,
                        toggleProps: frame102Props.toggleProps,
                        group1021Props: frame102Props.group1021Props,
                        group1022Props: frame102Props.group1022Props,
                        group1023Props: frame102Props.group1023Props,
                        group1024Props: frame102Props.group1024Props,
                        group1025Props: frame102Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                        className: frame11732Props.className
                    })
                ]
            })
        })
    });
}
exports.default = Kaizen2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame101":"b9rYD","../Frame102":"lji9Q","../Frame11732":"h8i4O","./Kaizen2.css":"hDdKD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDdKD":[function() {},{}],"b3JmF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _kanban3Css = require("./Kanban3.css");
function Kanban3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, kaizen, navItems3Props, frame101Props, frame102Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-45",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-67",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-36",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-23",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-68",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "please-answer-the-following-questions-24 valign-text-middle bevan-normal-white-20px",
                                    children: pleaseAnswerTheFollowingQuestions
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    className: frame101Props.className,
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    className: frame102Props.className,
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-117-103",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "kaizen-15 valign-text-middle inter-bold-mineral-green-18px",
                                        children: kaizen
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kanban3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Frame101":"b9rYD","../Frame102":"lji9Q","../Toggle":"8ZCQM","./Kanban3.css":"5S1UY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5S1UY":[function() {},{}],"iD3FV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _headerMenuDefault2 = require("../HeaderMenuDefault2");
var _headerMenuDefault2Default = parcelHelpers.interopDefault(_headerMenuDefault2);
var _frame232 = require("../Frame232");
var _frame232Default = parcelHelpers.interopDefault(_frame232);
var _frame7 = require("../Frame7");
var _frame7Default = parcelHelpers.interopDefault(_frame7);
var _pricing3 = require("../Pricing3");
var _pricing3Default = parcelHelpers.interopDefault(_pricing3);
var _mesureDePerformancesFuturesCss = require("./MesureDePerformancesFutures.css");
function MesureDePerformancesFutures(props) {
    const { x1200PxLogo_Icam__20081, design, label1, label2, notesAtteintesPourChaqueCritre, place, inputType1, inputPlaceholder1, line211, leadTime, inputType2, inputPlaceholder2, line212, environment, inputType3, inputPlaceholder3, line213, xcontinue, headerMenuDefault5Props, headerMenuDefault21Props, headerMenuDefault22Props, frame232Props, pricing31Props, pricing32Props, pricing33Props, pricing34Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "mesure-de-performances-futures screen",
            name: "form9",
            action: "form9",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-col-97",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group-69",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-68",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-container-37",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items-2-52",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-117-104",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "design-84 valign-text-middle inter-medium-sonic-silver-18px",
                                                        children: design
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-items",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                                    children: headerMenuDefault5Props.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
                                                    className: headerMenuDefault21Props.className,
                                                    children: headerMenuDefault21Props.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault2Default.default), {
                                                    className: headerMenuDefault22Props.className,
                                                    children: headerMenuDefault22Props.children
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame232Default.default), {
                                                    headerMenuDefault2Props: frame232Props.headerMenuDefault2Props
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/functional-view",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "label-155 inter-medium-sonic-silver-18-1px",
                                                        children: label1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-156 inter-medium-gravel-18-1px",
                                                    children: label2
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-137",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame7Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "notes-atteintes-pour-chaque-critre valign-text-middle bevan-normal-white-20px",
                                    children: notesAtteintesPourChaqueCritre
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pricing-container-2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-1-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "place-267 inter-bold-mineral-green-24px",
                                            children: place
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-19 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder1,
                                            type: inputType1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-8",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing31Props.cost
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-2-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "lead-time-3 inter-bold-mineral-green-24px",
                                            children: leadTime
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-20 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder2,
                                            type: inputType2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-7",
                                            src: line212,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                                    cost: pricing32Props.cost,
                                    className: pricing32Props.className
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-138",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing33Props.cost,
                            className: pricing33Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-98",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-6-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "environment-2 inter-bold-mineral-green-24px",
                                            children: environment
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            className: "x25-21 inter-bold-mineral-green-56px",
                                            name: "25",
                                            placeholder: inputPlaceholder3,
                                            type: inputType3
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-7",
                                            src: line213,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/mesure-de-performances-futures-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-2-28",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "continue-21 valign-text-middle inter-bold-mineral-green-18px",
                                            children: xcontinue
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricing3Default.default), {
                            cost: pricing34Props.cost,
                            className: pricing34Props.className
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = MesureDePerformancesFutures;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../HeaderMenuDefault5":"7ZKma","../HeaderMenuDefault2":"8KBHC","../Frame232":"ki771","../Frame7":"NTAj2","../Pricing3":"apV5l","./MesureDePerformancesFutures.css":"Ez0Qt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ZKma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault5Css = require("./HeaderMenuDefault5.css");
function HeaderMenuDefault5(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/aquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `menu-item-default-30 ${className || ""}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label-161 inter-medium-sonic-silver-14px",
                children: children
            })
        })
    });
}
exports.default = HeaderMenuDefault5;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","./HeaderMenuDefault5.css":"l44Kl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l44Kl":[function() {},{}],"NTAj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _frame7Css = require("./Frame7.css");
function Frame7(props) {
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `frame-7-9 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "place-268 valign-text-middle inter-bold-tropical-rain-forest-18px",
            children: "Back"
        })
    });
}
exports.default = Frame7;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Frame7.css":"g9qwc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g9qwc":[function() {},{}],"Ez0Qt":[function() {},{}],"aH9TA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _x5S2Css = require("./X5s2.css");
function X5s2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s-2 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-70",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-26"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-69",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-25 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-139",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group1-46",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggleProps.className,
                                    buttonSecondaryProps: toggleProps.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                                    className: frame101Props.className,
                                    toggleProps: frame101Props.toggleProps,
                                    group1021Props: frame101Props.group1021Props,
                                    group1022Props: frame101Props.group1022Props,
                                    group1023Props: frame101Props.group1023Props,
                                    group1024Props: frame101Props.group1024Props,
                                    group1025Props: frame101Props.group1025Props
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-17",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                                    className: frame102Props.className,
                                    toggleProps: frame102Props.toggleProps,
                                    group1021Props: frame102Props.group1021Props,
                                    group1022Props: frame102Props.group1022Props,
                                    group1023Props: frame102Props.group1023Props,
                                    group1024Props: frame102Props.group1024Props,
                                    group1025Props: frame102Props.group1025Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = X5s2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame101":"b9rYD","../Frame102":"lji9Q","../Frame11732":"h8i4O","./X5s2.css":"izqdU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"izqdU":[function() {},{}],"2Vyda":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _kanban2Css = require("./Kanban2.css");
function Kanban2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kanban-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-71",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-27"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-70",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-26 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-47",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                            className: frame11732Props.className
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kanban2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame101":"b9rYD","../Frame102":"lji9Q","../Frame11732":"h8i4O","./Kanban2.css":"b3Gji","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b3Gji":[function() {},{}],"fjDfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame101 = require("../Frame101");
var _frame101Default = parcelHelpers.interopDefault(_frame101);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _x5S3Css = require("./X5s3.css");
function X5s3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, kanban, navItems2Props, navItems3Props, toggleProps, frame101Props, frame102Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "x5s-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-72",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-28"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-71",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-27 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame101Default.default), {
                            className: frame101Props.className,
                            toggleProps: frame101Props.toggleProps,
                            group1021Props: frame101Props.group1021Props,
                            group1022Props: frame101Props.group1022Props,
                            group1023Props: frame101Props.group1023Props,
                            group1024Props: frame101Props.group1024Props,
                            group1025Props: frame101Props.group1025Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                            className: frame102Props.className,
                            toggleProps: frame102Props.toggleProps,
                            group1021Props: frame102Props.group1021Props,
                            group1022Props: frame102Props.group1022Props,
                            group1023Props: frame102Props.group1023Props,
                            group1024Props: frame102Props.group1024Props,
                            group1025Props: frame102Props.group1025Props
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "frame-117-105",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "kanban-15 valign-text-middle inter-bold-mineral-green-18px",
                        children: kanban
                    })
                })
            ]
        })
    });
}
exports.default = X5s3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame101":"b9rYD","../Frame102":"lji9Q","./X5s3.css":"cng4i","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cng4i":[function() {},{}],"9Engt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _leanVSM3Css = require("./LeanVSM3.css");
function LeanVSM3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, navItems3Props, toggle1Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, toggle2Props, group1026Props, group1027Props, group1028Props, group1029Props, group10210Props, frame11732Props, toggle3Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-3-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-48",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-72",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-38",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group2-24",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group3-22",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-73",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "please-answer-the-following-questions-28 valign-text-middle bevan-normal-white-20px",
                                            children: pleaseAnswerTheFollowingQuestions
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-93-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle1Props.className,
                                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "a-quelle-frquence-re-9 subtitel",
                                                    name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                                                    placeholder: inputPlaceholder1,
                                                    type: inputType1
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1021Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "combien-de-temps-en-9 subtitel",
                                                    name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                                                    placeholder: inputPlaceholder2,
                                                    type: inputType2
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1022Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "vous-9 subtitel",
                                                    name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                                                    placeholder: inputPlaceholder3,
                                                    type: inputType3
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1023Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "vous-9 subtitel",
                                                    name: "avezvousmisenplacedemesuresdam\xe9lioration",
                                                    placeholder: inputPlaceholder4,
                                                    type: inputType4
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1024Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "x-19 subtitel",
                                                    name: "*******************************************",
                                                    placeholder: inputPlaceholder5,
                                                    type: inputType5
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1025Props.line24
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-94-3",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                                    className: toggle2Props.className,
                                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "dans-quel-rayon-se-situe-vos-clients-10 subtitel",
                                                    name: "dansquelrayonsesituevosclients",
                                                    placeholder: inputPlaceholder6,
                                                    type: inputType6
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1026Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "a-quelle-frquence-ef subtitel",
                                                    name: "aquellefr\xe9quenceeffectuezvousdeslivraisons",
                                                    placeholder: inputPlaceholder7,
                                                    type: inputType7
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1027Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "quel-est-votre-taux-de-service subtitel",
                                                    name: "quelestvotretauxdeservice",
                                                    placeholder: inputPlaceholder8,
                                                    type: inputType8
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1028Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "quel-est-votre-taux-de-retard-10 subtitel",
                                                    name: "quelestvotretauxderetard",
                                                    placeholder: inputPlaceholder9,
                                                    type: inputType9
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group1029Props.line24
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    className: "x-20 subtitel",
                                                    name: "*************************************",
                                                    placeholder: inputPlaceholder10,
                                                    type: inputType10
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                                    line24: group10210Props.line24
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                                    className: frame11732Props.className
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeanVSM3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Toggle":"8ZCQM","../Group102":"3ieGn","../Frame11732":"h8i4O","./LeanVSM3.css":"9AAuh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9AAuh":[function() {},{}],"aX9n9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _leanVSM2Css = require("./LeanVSM2.css");
function LeanVSM2(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, navItems2Props, navItems3Props, toggle1Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, toggle2Props, toggle3Props, group1026Props, group1027Props, group1028Props, group1029Props, group10210Props, frame11732Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "lean-vsm-2-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-74",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-29"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-73",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-29 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-89",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "a-quelle-frquence-re-10 subtitel",
                                    name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                                    placeholder: inputPlaceholder1,
                                    type: inputType1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1021Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "combien-de-temps-en-10 subtitel",
                                    name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                                    placeholder: inputPlaceholder2,
                                    type: inputType2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1022Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "vous-10 subtitel",
                                    name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                                    placeholder: inputPlaceholder3,
                                    type: inputType3
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1023Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "vous-10 subtitel",
                                    name: "avezvousmisenplacedemesuresdam\xe9lioration",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1024Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "x-21 subtitel",
                                    name: "*******************************************",
                                    placeholder: inputPlaceholder5,
                                    type: inputType5
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1025Props.line24
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                    className: toggle2Props.className,
                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "frame-90",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle3Props.className,
                            buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "dans-quel-rayon-se-situe-vos-clients-11 subtitel",
                            name: "dansquelrayonsesituevosclients",
                            placeholder: inputPlaceholder6,
                            type: inputType6
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1026Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "a-quelle-frquence-ef-1 subtitel",
                            name: "aquellefr\xe9quenceeffectuezvousdeslivraisons",
                            placeholder: inputPlaceholder7,
                            type: inputType7
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1027Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "quel-est-votre-taux-de-service-1 subtitel",
                            name: "quelestvotretauxdeservice",
                            placeholder: inputPlaceholder8,
                            type: inputType8
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1028Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "quel-est-votre-taux-de-retard-11 subtitel",
                            name: "quelestvotretauxderetard",
                            placeholder: inputPlaceholder9,
                            type: inputType9
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group1029Props.line24
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            className: "x-22 subtitel",
                            name: "*************************************",
                            placeholder: inputPlaceholder10,
                            type: inputType10
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                            line24: group10210Props.line24
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {
                    className: frame11732Props.className
                })
            ]
        })
    });
}
exports.default = LeanVSM2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Group102":"3ieGn","../Frame11732":"h8i4O","./LeanVSM2.css":"eCcLU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eCcLU":[function() {},{}],"enZ2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame1144 = require("../Frame1144");
var _frame1144Default = parcelHelpers.interopDefault(_frame1144);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _frame1135 = require("../Frame1135");
var _frame1135Default = parcelHelpers.interopDefault(_frame1135);
var _frame1146 = require("../Frame1146");
var _frame1146Default = parcelHelpers.interopDefault(_frame1146);
var _frame1157 = require("../Frame1157");
var _frame1157Default = parcelHelpers.interopDefault(_frame1157);
var _frame1164 = require("../Frame1164");
var _frame1164Default = parcelHelpers.interopDefault(_frame1164);
var _frame11742 = require("../Frame11742");
var _frame11742Default = parcelHelpers.interopDefault(_frame11742);
var _frame118 = require("../Frame118");
var _frame118Default = parcelHelpers.interopDefault(_frame118);
var _frame8 = require("../Frame8");
var _frame8Default = parcelHelpers.interopDefault(_frame8);
var _frame82 = require("../Frame82");
var _frame82Default = parcelHelpers.interopDefault(_frame82);
var _frame9 = require("../Frame9");
var _frame9Default = parcelHelpers.interopDefault(_frame9);
var _kaizen11Css = require("./Kaizen11.css");
function Kaizen11(props) {
    const { x1200PxLogo_Icam__20081, label1, overlapGroup11, arrow9, overlapGroup3, arrow10, line4, line2, label2, label3, overlapGroup2, textFormat, label4, label5, overlapGroup4, line1, place, label6, x1IdentificationOf, x2StudyOfTheSituation, arrow6, x6AuditOfCountermeasures, arrow16, arrow13, arrow14, arrow15, arrow17, x7StandardizationOfGoodMeasures, modeling, xcontinue, frame11332Props, frame11322Props, frame118Props, frame8Props, frame82Props, frame9Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "kaizen1-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group7-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-74",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-39",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-53",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                            className: frame11332Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1144Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/functional-view",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label-159 inter-medium-star-dust-18-1px",
                                                children: label1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                            className: frame11322Props.className
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-78",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1135Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1146Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1157Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1164Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11742Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame118Default.default), {
                                            className: frame118Props.className,
                                            children: frame118Props.children
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-140",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-col-99 inter-medium-rum-swizzle-18-1px",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group-container-15",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group11-2",
                                            style: {
                                                backgroundImage: `url(${overlapGroup11})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-9-15",
                                                src: arrow9,
                                                alt: "Arrow 9"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "overlap-group3-23",
                                            style: {
                                                backgroundImage: `url(${overlapGroup3})`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                className: "arrow-10-9",
                                                src: arrow10,
                                                alt: "Arrow 10"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "ellipse-container-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-87-6"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-85-15"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-10-5"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group10-1",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "frame-5-23"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group6-6",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-6",
                                            src: line4,
                                            alt: "Line 4"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8-2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-6",
                                            src: line2,
                                            alt: "Line 2"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "ellipse-8-2"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container-4",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-158",
                                            children: label2
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-158",
                                            children: label3
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group2-25",
                                    style: {
                                        backgroundImage: `url(${overlapGroup2})`
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "text-format-23",
                                        src: textFormat,
                                        alt: "Text format"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label-container-5",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-158",
                                            children: label4
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-158",
                                            children: label5
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "flex-row-141",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "overlap-group4-17",
                                    style: {
                                        backgroundImage: `url(${overlapGroup4})`
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "line-1-18",
                                        src: line1,
                                        alt: "Line 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "flex-col-100",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-row-142",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/kaizen-1",
                                                    className: "align-self-flex-end",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-12-7",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "place-270 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                                            children: place
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "label-160 inter-medium-cultured-pearl-20px",
                                                    children: label6
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group12-4 inter-medium-dark-fern-18-1px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-7-11",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "x1-identification-of inter-medium-dark-fern-18-1px",
                                                        children: x1IdentificationOf
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group9-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-8-18",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "x2-study-of-the-situation",
                                                                children: x2StudyOfTheSituation
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-6-15",
                                                            src: arrow6,
                                                            alt: "Arrow 6"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group5-14",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "frame-10-8",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "x6-audit-of-countermeasures",
                                                                children: x6AuditOfCountermeasures
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame8Default.default), {
                                                            children: frame8Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame82Default.default), {
                                                            children: frame82Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame9Default.default), {
                                                            children: frame9Props.children
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-16-5",
                                                            src: arrow16,
                                                            alt: "Arrow 16"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-13-8",
                                                            src: arrow13,
                                                            alt: "Arrow 13"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-14-5",
                                                            src: arrow14,
                                                            alt: "Arrow 14"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            className: "arrow-15-5",
                                                            src: arrow15,
                                                            alt: "Arrow 15"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "arrow-17-3",
                                            src: arrow17,
                                            alt: "Arrow 17"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "frame-container-18",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-8-19",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "x7-standardization-of-good-measures inter-medium-dark-fern-18-1px",
                                                        children: x7StandardizationOfGoodMeasures
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "frame-13-4",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        href: "https://app.diagrams.net/",
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "modeling-111 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: modeling
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                    to: "/smed-1",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "frame-2-29",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "continue-22 valign-text-middle inter-bold-mineral-green-18px",
                                                            children: xcontinue
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Kaizen11;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame1144":"cyPUr","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../Frame1135":"4zAdk","../Frame1146":"ebdMs","../Frame1157":"eY2iM","../Frame1164":"9Ds6S","../Frame11742":"1OJFF","../Frame118":"kfDbB","../Frame8":"hZADe","../Frame82":"1lvHl","../Frame9":"5n4VD","./Kaizen11.css":"tU0Zt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tU0Zt":[function() {},{}],"gMqKM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _frame102 = require("../Frame102");
var _frame102Default = parcelHelpers.interopDefault(_frame102);
var _leanVSM4Css = require("./LeanVSM4.css");
function LeanVSM4(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, x5S, navItems2Props, navItems3Props, toggle1Props, toggle2Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, frame102Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "lean-vsm-4-1 screen",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "overlap-group-76",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rectangle-3-30"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                        className: navItems2Props.className
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                        className: navItems3Props.className,
                        frame1172Props: navItems3Props.frame1172Props,
                        frame1162Props: navItems3Props.frame1162Props,
                        frame1132Props: navItems3Props.frame1132Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "/home",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "x1200px-logo_icam_-_2008-1-76",
                            src: x1200PxLogo_Icam__20081,
                            alt: "1200px-Logo_ICAM_-_2008 1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "please-answer-the-following-questions-30 valign-text-middle bevan-normal-white-20px",
                        children: pleaseAnswerTheFollowingQuestions
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                        className: toggle1Props.className,
                        buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "frame-95-5",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                className: toggle2Props.className,
                                buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "a-quelle-frquence-re-11 subtitel",
                                name: "aquellefr\xe9quencerenouvelezvousvotrestock",
                                placeholder: inputPlaceholder1,
                                type: inputType1
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1021Props.line24,
                                className: group1021Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "combien-de-temps-en-11 subtitel",
                                name: "combiendetempsenmoyenneunarticleeffectuedansvotremagazin",
                                placeholder: inputPlaceholder2,
                                type: inputType2
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1022Props.line24,
                                className: group1022Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "vous-11 subtitel",
                                name: "vousarrive-t-ildavoirdesrupturesdestocksioui\xe0quellefr\xe9quence",
                                placeholder: inputPlaceholder3,
                                type: inputType3
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1023Props.line24,
                                className: group1023Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "vous-11 subtitel",
                                name: "avezvousmisenplacedemesuresdam\xe9lioration",
                                placeholder: inputPlaceholder4,
                                type: inputType4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1024Props.line24,
                                className: group1024Props.className
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "x-23 subtitel",
                                name: "*******************************************",
                                placeholder: inputPlaceholder5,
                                type: inputType5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                line24: group1025Props.line24,
                                className: group1025Props.className
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame102Default.default), {
                        className: frame102Props.className,
                        toggleProps: frame102Props.toggleProps,
                        group1021Props: frame102Props.group1021Props,
                        group1022Props: frame102Props.group1022Props,
                        group1023Props: frame102Props.group1023Props,
                        group1024Props: frame102Props.group1024Props,
                        group1025Props: frame102Props.group1025Props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-117-106",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "x5-s-14 valign-text-middle inter-bold-mineral-green-18px",
                            children: x5S
                        })
                    })
                ]
            })
        })
    });
}
exports.default = LeanVSM4;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Group102":"3ieGn","../Frame102":"lji9Q","./LeanVSM4.css":"6LSCZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LSCZ":[function() {},{}],"1N3Vo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame116 = require("../Frame116");
var _frame116Default = parcelHelpers.interopDefault(_frame116);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _frame232 = require("../Frame232");
var _frame232Default = parcelHelpers.interopDefault(_frame232);
var _frame7 = require("../Frame7");
var _frame7Default = parcelHelpers.interopDefault(_frame7);
var _mesureDePerformancesFutures1Css = require("./MesureDePerformancesFutures1.css");
function MesureDePerformancesFutures1(props) {
    const { x1200PxLogo_Icam__20081, design, label1, label2, finish, headerMenuDefault51Props, headerMenuDefault52Props, headerMenuDefault53Props, frame232Props, frame7Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "mesure-de-performances-futures-1 screen",
            name: "form10",
            action: "form10",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-77",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-77",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-41",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-54",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame116Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-117-107",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "design-85 valign-text-middle inter-medium-sonic-silver-18px",
                                                children: design
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                            children: headerMenuDefault51Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                            className: headerMenuDefault52Props.className,
                                            children: headerMenuDefault52Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                            className: headerMenuDefault53Props.className,
                                            children: headerMenuDefault53Props.children
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame232Default.default), {
                                            headerMenuDefault2Props: frame232Props.headerMenuDefault2Props
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/functional-view",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label-162 inter-medium-sonic-silver-18-1px",
                                                children: label1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-166 inter-medium-gravel-18-1px",
                                            children: label2
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame7Default.default), {
                    className: frame7Props.className
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/existing-case",
                    className: "align-self-flex-end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-3-6",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "finish-1 valign-text-middle inter-bold-tropical-rain-forest-18px",
                            children: finish
                        })
                    })
                })
            ]
        })
    });
}
exports.default = MesureDePerformancesFutures1;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame116":"1obhZ","../Frame11322":"lrJXI","../HeaderMenuDefault5":"7ZKma","../Frame232":"ki771","../Frame7":"NTAj2","./MesureDePerformancesFutures1.css":"dXsz1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXsz1":[function() {},{}],"59mst":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame112 = require("../Frame112");
var _frame112Default = parcelHelpers.interopDefault(_frame112);
var _existingSystems2Css = require("./ExistingSystems2.css");
function ExistingSystems2(props) {
    const { x1200PxLogo_Icam__20081, existingSystems, x2SupplementaryModels, leanVsm, x4Kaizen, x25S, x5Smed, x6VisualManagement, ellipse116, navItems3Props, frame112Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "existing-systems-1 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-78",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-78",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-42",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "existing-systems-3 valign-text-middle bevan-normal-white-20px",
                    children: existingSystems
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "x2-supplementary-models valign-text-middle bevan-normal-white-20px",
                    children: x2SupplementaryModels
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "group-110",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-19",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "lean-vsm-16 valign-text-middle inter-bold-mineral-green-18px",
                                        children: leanVsm
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x4-kaizen valign-text-middle inter-bold-mineral-green-18px",
                                        children: x4Kaizen
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-20",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-113-68",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x2-5-s valign-text-middle inter-bold-mineral-green-18px",
                                        children: x25S
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x5-smed valign-text-middle inter-bold-mineral-green-18px",
                                        children: x5Smed
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-container-21",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame112Default.default), {
                                    className: frame112Props.className,
                                    children: frame112Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-11-11",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "x6-visual-management valign-text-middle inter-bold-mineral-green-18px",
                                        children: x6VisualManagement
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "ellipse-116-3",
                    src: ellipse116,
                    alt: "Ellipse 116"
                })
            ]
        })
    });
}
exports.default = ExistingSystems2;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Frame112":"hisir","./ExistingSystems2.css":"7yf72","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7yf72":[function() {},{}],"dwIXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _frame111 = require("../Frame111");
var _frame111Default = parcelHelpers.interopDefault(_frame111);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame11732 = require("../Frame11732");
var _frame11732Default = parcelHelpers.interopDefault(_frame11732);
var _quality8Css = require("./Quality8.css");
function Quality8(props) {
    const { x1200PxLogo_Icam__20081, navItems3Props, frame111Props, toggleProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "quality-8 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-85",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-85",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-51",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame111Default.default), {
                    ...frame111Props
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-152",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggleProps.className,
                            buttonSecondaryProps: toggleProps.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11732Default.default), {})
                    ]
                })
            ]
        })
    });
}
exports.default = Quality8;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../NavItems2":"54ILo","../Frame111":"2P542","../Toggle":"8ZCQM","../Frame11732":"h8i4O","./Quality8.css":"h45CO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h45CO":[function() {},{}],"iVOas":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems2 = require("../NavItems2");
var _navItems2Default = parcelHelpers.interopDefault(_navItems2);
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _frame136 = require("../Frame136");
var _frame136Default = parcelHelpers.interopDefault(_frame136);
var _frame144 = require("../Frame144");
var _frame144Default = parcelHelpers.interopDefault(_frame144);
var _clientConsommateur3Css = require("./ClientConsommateur3.css");
function ClientConsommateur3(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, goOnToTheNextStep, navItems2Props, navItems3Props, toggle1Props, frame1361Props, frame1362Props, frame1363Props, toggle2Props, frame1364Props, frame1365Props, frame1366Props, toggle3Props, frame1367Props, frame144Props, frame1368Props, toggle4Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "client-consommateur-3 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-86",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-31"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems2Default.default), {
                            className: navItems2Props.className
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                            className: navItems3Props.className,
                            frame1172Props: navItems3Props.frame1172Props,
                            frame1162Props: navItems3Props.frame1162Props,
                            frame1132Props: navItems3Props.frame1132Props
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-86",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-31 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "emploirelation-employeur-employ-15",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-1-12",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle1Props.className,
                                    buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "do-you-do-reviews-1 subtitel",
                                    name: "doyoudoreviews",
                                    placeholder: inputPlaceholder1,
                                    type: inputType1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1361Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-3 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder2,
                                    type: inputType2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1362Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-3 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder3,
                                    type: inputType3
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1363Props.ouinonProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-3-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    className: "do-you-have-a-review-2 subtitel",
                                    name: "doyouhaveareviewspecifyingrequirementsnotformulatedbythecustomerbutnecessaryforthespecifieduse",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1364Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-4 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder5,
                                    type: inputType5
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1365Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-4 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder6,
                                    type: inputType6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1366Props.ouinonProps
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "emploi-relation-employeur-employ-2-13",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "do-you-have-a-review-3 subtitel",
                                    name: "doyouhaveareviewspecifyingtherequirementsoftheorganisation",
                                    placeholder: inputPlaceholder7,
                                    type: inputType7
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1367Props.ouinonProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-paper-format-5 subtitel",
                                    name: "inpaperformat",
                                    placeholder: inputPlaceholder8,
                                    type: inputType8
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame144Default.default), {
                                    frame133Props: frame144Props.frame133Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "in-digital-format-5 subtitel",
                                    name: "indigitalformat",
                                    placeholder: inputPlaceholder9,
                                    type: inputType9
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame136Default.default), {
                                    ouinonProps: frame1368Props.ouinonProps
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-153",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle4Props.className,
                            buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-113-69",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "go-on-to-the-next-step-1 valign-text-middle inter-bold-mineral-green-18px",
                                children: goOnToTheNextStep
                            })
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = ClientConsommateur3;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems2":"54ILo","../NavItems3":"51Bj2","../Toggle":"8ZCQM","../Frame136":"hltgv","../Frame144":"25TBH","./ClientConsommateur3.css":"8FxiL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8FxiL":[function() {},{}],"fG7lc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _frame1142 = require("../Frame1142");
var _frame1142Default = parcelHelpers.interopDefault(_frame1142);
var _frame11532 = require("../Frame11532");
var _frame11532Default = parcelHelpers.interopDefault(_frame11532);
var _frame11322 = require("../Frame11322");
var _frame11322Default = parcelHelpers.interopDefault(_frame11322);
var _referencesCss = require("./References.css");
var _environmental5 = require("../Environmental5");
var _social6 = require("../Social6");
var _modernization4 = require("../Modernization4");
function References(props) {
    const { resultsPropositions, label1, label2, x1200PxLogo_Icam__20081, inputType1, inputPlaceholder1, tracbility, place1, vector371, vector372, vector38, product, validation, iso9001Isf, vector373, processValidation, line211, cost, inputType2, inputPlaceholder2, line212, vector374, vector375, vector376, vector377, transportCost, manufacturingCost, deliveryCost, exportCost, modernisation, inputType3, inputPlaceholder3, line213, vector378, vector379, vector3710, vector3711, supplyChain40, informationSystem, ergonomics, newTechnologiesAiRoboticsEtc, leadTime, inputType4, inputPlaceholder4, line214, vector3712, vector3713, vector3714, manufacturingTime, deliveryTime, storageTime, place2, propositions, frame11332Props, frame117Props, frame1142Props, frame11322Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "references screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group9-4",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group8-3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "rectangle-2-2"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-55",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                            className: frame11332Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-116-180",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "results-propositions valign-text-middle inter-medium-white-18px",
                                                children: resultsPropositions
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {
                                            className: frame117Props.className
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-3-79",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame1142Default.default), {
                                            className: frame1142Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11532Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/existing-case",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label-167 inter-medium-star-dust-18-1px",
                                                children: label1
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                            to: "/cur-performances",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label-167 inter-medium-sonic-silver-18-1px",
                                                children: label2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11322Default.default), {
                                            className: frame11322Props.className
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/home",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "x1200px-logo_icam_-_2008-1-87",
                                        src: x1200PxLogo_Icam__20081,
                                        alt: "1200px-Logo_ICAM_-_2008 1"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-3-7"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "overlap-group4-18",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "rectangle-4359"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "x25-22 inter-bold-mineral-green-56px",
                                            htmlFor: "25",
                                            children: [
                                                (0, _environmental5.e_sum),
                                                "/35"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "tracbility valign-text-middle inter-medium-black-14px",
                                            children: tracbility
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                            className: "place-271 inter-bold-mineral-green-24px",
                                            children: place1
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "pricing-features",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "overlap-group-container-16",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group1-52",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-3",
                                                                src: vector371,
                                                                alt: "Vector 37"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group2-26",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-3",
                                                                src: vector372,
                                                                alt: "Vector 37"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "overlap-group3-24",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                className: "vector-3",
                                                                src: vector38,
                                                                alt: "Vector 38"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "flex-col-105 inter-medium-black-14px",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "product valign-text-middle",
                                                            children: product
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "validation valign-text-middle",
                                                            children: validation
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "iso-9001-isf valign-text-middle",
                                                            children: iso9001Isf
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "overlap-group-90",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "vector-37",
                                                                    src: vector373,
                                                                    alt: "Vector 37"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "process-validation valign-text-middle inter-medium-black-14px",
                                                                    children: processValidation
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            className: "line-21-9",
                                            src: line211,
                                            alt: "Line 21"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-6-14"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group5-15",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "cost-3 inter-bold-rum-swizzle-24px",
                                    children: cost
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: "x25-23 inter-bold-rum-swizzle-56px",
                                    htmlFor: "25",
                                    children: [
                                        (0, _social6.s_sum),
                                        "/38"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-10",
                                    src: line212,
                                    alt: "Line 21"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-features-1",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-17",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector374,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector375,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector376,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector377,
                                                        alt: "Vector 37"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "cost-container inter-medium-rum-swizzle-14px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "transport-cost valign-text-middle",
                                                    children: transportCost
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "manufacturing-cost valign-text-middle",
                                                    children: manufacturingCost
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "delivery-cost valign-text-middle",
                                                    children: deliveryCost
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "export-cost valign-text-middle",
                                                    children: exportCost
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group6-7",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "modernisation inter-bold-rum-swizzle-24px",
                                    children: modernisation
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: "x25-24 inter-bold-rum-swizzle-56px",
                                    htmlFor: "25",
                                    children: [
                                        (0, _modernization4.m_sum),
                                        "/26"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-11",
                                    src: line213,
                                    alt: "Line 21"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-features-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-18",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector378,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector379,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-87",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3710,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-88",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3711,
                                                        alt: "Vector 37"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "flex-col-106 inter-medium-rum-swizzle-14px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "supply-chain-40 valign-text-middle",
                                                    children: supplyChain40
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-col-item valign-text-middle",
                                                    children: informationSystem
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-col-item valign-text-middle",
                                                    children: ergonomics
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "new-technologies-ai-robotics-etc valign-text-middle",
                                                    children: newTechnologiesAiRoboticsEtc
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "overlap-group7-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "lead-time-4 inter-bold-mineral-green-24px",
                                    children: leadTime
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    className: "x25-25 inter-bold-mineral-green-56px",
                                    name: "25",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "line-21-12",
                                    src: line214,
                                    alt: "Line 21"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pricing-features-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "overlap-group-container-19",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group2-27",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3712,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-89",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3713,
                                                        alt: "Vector 37"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "overlap-group-89",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        className: "vector-3",
                                                        src: vector3714,
                                                        alt: "Vector 37"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "time-container inter-medium-black-14px",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "manufacturing-time valign-text-middle",
                                                    children: manufacturingTime
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "delivery-time valign-text-middle",
                                                    children: deliveryTime
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "storage-time valign-text-middle",
                                                    children: storageTime
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-5-24",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "place-272 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                    children: place2
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/objectives",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "frame-2-30",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "propositions-1 valign-text-middle inter-bold-tropical-rain-forest-18px",
                            children: propositions
                        })
                    })
                })
            ]
        })
    });
}
exports.default = References;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame117":"1Qy2K","../Frame1142":"g5Omc","../Frame11532":"gxslB","../Frame11322":"lrJXI","./References.css":"9VFc9","../Environmental5":"jhgCb","../Social6":"hHc62","../Modernization4":"b543i","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VFc9":[function() {},{}],"RTx19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _navItems3 = require("../NavItems3");
var _navItems3Default = parcelHelpers.interopDefault(_navItems3);
var _frame11332 = require("../Frame11332");
var _frame11332Default = parcelHelpers.interopDefault(_frame11332);
var _frame114 = require("../Frame114");
var _frame114Default = parcelHelpers.interopDefault(_frame114);
var _frame115 = require("../Frame115");
var _frame115Default = parcelHelpers.interopDefault(_frame115);
var _frame117 = require("../Frame117");
var _frame117Default = parcelHelpers.interopDefault(_frame117);
var _curPerformanceCss = require("./CurPerformance.css");
function CurPerformance(props) {
    const { x1200PxLogo_Icam__20081, resultPropositions, place, formalismesEnFonct, navItems3Props, frame11332Props, currentResults, previousResults } = props;
    // Function to calculate improvement percentage
    const calculateAmeliorationPercentage = (current, previous)=>{
        if (previous === 0) return "N/A";
        return ((current - previous) / previous * 100).toFixed(2) + "%";
    };
    // Metrics names for display
    const metrics = [
        "Client/ Consomateur",
        "Environment",
        "Quality",
        "Social",
        "Modernization",
        "Lead Time",
        "Cost"
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "cur-performance-10 screen",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-91",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-88",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-container-52",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navItems3Default.default), {
                                    className: navItems3Props.className,
                                    frame1172Props: navItems3Props.frame1172Props,
                                    frame1162Props: navItems3Props.frame1162Props,
                                    frame1132Props: navItems3Props.frame1132Props
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "nav-items-2-56",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame11332Default.default), {
                                            className: frame11332Props.className
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame114Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame115Default.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-116-181",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "result-propositions valign-text-middle inter-medium-white-18px",
                                                children: resultPropositions
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _frame117Default.default), {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-row-154",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/analysis",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "frame-5-25",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "place-273 valign-text-middle inter-bold-tropical-rain-forest-18px",
                                    children: place
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "formalismes-en-fonct-1 valign-text-middle bevan-normal-white-20px",
                            children: formalismesEnFonct
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "container1",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "container2",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "Previous Results"
                                }),
                                metrics.map((metric, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        className: "x25-4 inter-bold-rum-swizzle-56px",
                                        children: [
                                            metric,
                                            ": ",
                                            previousResults[index]
                                        ]
                                    }, `prev-${metric}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "container3",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "Current Results"
                                }),
                                metrics.map((metric, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        className: "x25-4 inter-bold-rum-swizzle-56px",
                                        children: [
                                            metric,
                                            ": ",
                                            currentResults[index]
                                        ]
                                    }, `current-${metric}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "container4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "Amelioration Percentage"
                                }),
                                metrics.map((metric, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        className: "x25-4 inter-bold-rum-swizzle-56px",
                                        children: [
                                            metric,
                                            ":",
                                            " ",
                                            calculateAmeliorationPercentage(currentResults[index], previousResults[index])
                                        ]
                                    }, `amelioration-${metric}`))
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = CurPerformance;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../NavItems3":"51Bj2","../Frame11332":"5fizG","../Frame114":"7sM2x","../Frame115":"dirkn","../Frame117":"1Qy2K","./CurPerformance.css":"cbf5D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cbf5D":[function() {},{}],"lO3Td":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault6 = require("../HeaderMenuDefault6");
var _headerMenuDefault6Default = parcelHelpers.interopDefault(_headerMenuDefault6);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _headerMenuDefault7 = require("../HeaderMenuDefault7");
var _headerMenuDefault7Default = parcelHelpers.interopDefault(_headerMenuDefault7);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _leadTimeCss = require("./LeadTime.css");
function LeadTime(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, label1, label2, headerMenuDefault61Props, headerMenuDefault51Props, headerMenuDefault52Props, headerMenuDefaultProps, headerMenuDefault53Props, headerMenuDefault54Props, headerMenuDefault62Props, toggle1Props, toggle2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "lead-time-5 screen",
            name: "form13",
            action: "form13",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-92",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-32"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-89",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-32 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-2-31",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "nav-items-5",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "javascript:SubmitForm('form13')",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-168 inter-medium-sonic-silver-18-1px",
                                            children: label1
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault6Default.default), {
                                        children: headerMenuDefault61Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                        className: headerMenuDefault51Props.className,
                                        children: headerMenuDefault51Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                        className: headerMenuDefault52Props.className,
                                        children: headerMenuDefault52Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "javascript:SubmitForm('form13')",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-2-32",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                children: headerMenuDefaultProps.children
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-6",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault7Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                    className: headerMenuDefault53Props.className,
                                    children: headerMenuDefault53Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                    className: headerMenuDefault54Props.className,
                                    children: headerMenuDefault54Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-2-33",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault6Default.default), {
                                        className: headerMenuDefault62Props.className,
                                        children: headerMenuDefault62Props.children
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/functional-view",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label-169 inter-medium-sonic-silver-18-1px",
                                        children: label2
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toggle-container-5",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle1Props.className,
                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle2Props.className,
                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = LeadTime;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../HeaderMenuDefault6":"crtNp","../HeaderMenuDefault5":"7ZKma","../HeaderMenuDefault":"9P7JS","../HeaderMenuDefault7":"iL2Al","../Toggle":"8ZCQM","./LeadTime.css":"9tAvD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"crtNp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault6Css = require("./HeaderMenuDefault6.css");
function HeaderMenuDefault6(props) {
    const { children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `menu-item-default-37 ${className || ""}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/aquisition",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label-170 inter-medium-gravel-14px",
                children: children
            })
        })
    });
}
exports.default = HeaderMenuDefault6;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","./HeaderMenuDefault6.css":"krfkT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"krfkT":[function() {},{}],"iL2Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault7Css = require("./HeaderMenuDefault7.css");
function HeaderMenuDefault7() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: "/aquisition",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "menu-item-default-41",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label-171 inter-medium-wild-sand-14px",
                children: "Aquisition"
            })
        })
    });
}
exports.default = HeaderMenuDefault7;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","./HeaderMenuDefault7.css":"d0mn7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d0mn7":[function() {},{}],"9tAvD":[function() {},{}],"3LKzF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerMenuDefault6 = require("../HeaderMenuDefault6");
var _headerMenuDefault6Default = parcelHelpers.interopDefault(_headerMenuDefault6);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _headerMenuDefault7 = require("../HeaderMenuDefault7");
var _headerMenuDefault7Default = parcelHelpers.interopDefault(_headerMenuDefault7);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _costCss = require("./Cost.css");
function Cost(props) {
    const { x1200PxLogo_Icam__20081, pleaseAnswerTheFollowingQuestions, label1, label2, headerMenuDefault61Props, headerMenuDefault51Props, headerMenuDefault52Props, headerMenuDefaultProps, headerMenuDefault53Props, headerMenuDefault54Props, headerMenuDefault62Props, toggle1Props, toggle2Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "cost-4 screen",
            name: "form16",
            action: "form16",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group-93",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-33"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-90",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-33 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-2-34",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "nav-items-7",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "javascript:SubmitForm('form16')",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-176 inter-medium-sonic-silver-18-1px",
                                            children: label1
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault6Default.default), {
                                        children: headerMenuDefault61Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                        className: headerMenuDefault51Props.className,
                                        children: headerMenuDefault51Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                        className: headerMenuDefault52Props.className,
                                        children: headerMenuDefault52Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "javascript:SubmitForm('form16')",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-2-35",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                children: headerMenuDefaultProps.children
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-8",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault7Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                    className: headerMenuDefault53Props.className,
                                    children: headerMenuDefault53Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                    className: headerMenuDefault54Props.className,
                                    children: headerMenuDefault54Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-2-36",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault6Default.default), {
                                        className: headerMenuDefault62Props.className,
                                        children: headerMenuDefault62Props.children
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/functional-view",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label-177 inter-medium-sonic-silver-18-1px",
                                        children: label2
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toggle-container-6",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle1Props.className,
                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle2Props.className,
                            buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Cost;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../HeaderMenuDefault6":"crtNp","../HeaderMenuDefault5":"7ZKma","../HeaderMenuDefault":"9P7JS","../HeaderMenuDefault7":"iL2Al","../Toggle":"8ZCQM","./Cost.css":"5n2iw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5n2iw":[function() {},{}],"13Zmq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _avatars = require("../Avatars");
var _avatarsDefault = parcelHelpers.interopDefault(_avatars);
var _toggle = require("../Toggle");
var _toggleDefault = parcelHelpers.interopDefault(_toggle);
var _headerMenuDefault6 = require("../HeaderMenuDefault6");
var _headerMenuDefault6Default = parcelHelpers.interopDefault(_headerMenuDefault6);
var _headerMenuDefault5 = require("../HeaderMenuDefault5");
var _headerMenuDefault5Default = parcelHelpers.interopDefault(_headerMenuDefault5);
var _headerMenuDefault = require("../HeaderMenuDefault");
var _headerMenuDefaultDefault = parcelHelpers.interopDefault(_headerMenuDefault);
var _headerMenuDefault7 = require("../HeaderMenuDefault7");
var _headerMenuDefault7Default = parcelHelpers.interopDefault(_headerMenuDefault7);
var _group102 = require("../Group102");
var _group102Default = parcelHelpers.interopDefault(_group102);
var _modernizationCss = require("./Modernization.css");
function Modernization(props) {
    const { x1200PxLogo_Icam__20081, admin, pleaseAnswerTheFollowingQuestions, label1, label2, inputType1, inputPlaceholder1, inputType2, inputPlaceholder2, inputType3, inputPlaceholder3, inputType4, inputPlaceholder4, inputType5, inputPlaceholder5, inputType6, inputPlaceholder6, inputType7, inputPlaceholder7, inputType8, inputPlaceholder8, inputType9, inputPlaceholder9, inputType10, inputPlaceholder10, avatarsProps, toggle1Props, headerMenuDefault61Props, headerMenuDefault51Props, headerMenuDefault52Props, headerMenuDefaultProps, headerMenuDefault53Props, headerMenuDefault54Props, headerMenuDefault62Props, toggle2Props, group1021Props, group1022Props, group1023Props, group1024Props, group1025Props, toggle3Props, group1026Props, group1027Props, group1028Props, group1029Props, group10210Props, toggle4Props } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container-center-horizontal",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            className: "modernization-5 screen",
            name: "form19",
            action: "form19",
            method: "post",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "overlap-group1-53",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "rectangle-3-34"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/home",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: "x1200px-logo_icam_-_2008-1-91",
                                src: x1200PxLogo_Icam__20081,
                                alt: "1200px-Logo_ICAM_-_2008 1"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "admin",
                            children: admin
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarsDefault.default), {
                            ellipse83: avatarsProps.ellipse83,
                            ellipse81: avatarsProps.ellipse81
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                            className: toggle1Props.className,
                            buttonSecondaryProps: toggle1Props.buttonSecondaryProps
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "please-answer-the-following-questions-34 valign-text-middle bevan-normal-white-20px",
                            children: pleaseAnswerTheFollowingQuestions
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "frame-2-37",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "nav-items-9",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "javascript:SubmitForm('form19')",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "label-178 inter-medium-sonic-silver-18-1px",
                                            children: label1
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault6Default.default), {
                                        children: headerMenuDefault61Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                        className: headerMenuDefault51Props.className,
                                        children: headerMenuDefault51Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                        className: headerMenuDefault52Props.className,
                                        children: headerMenuDefault52Props.children
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        href: "javascript:SubmitForm('form19')",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "frame-2-38",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefaultDefault.default), {
                                                children: headerMenuDefaultProps.children
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "nav-items-10",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault7Default.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                    className: headerMenuDefault53Props.className,
                                    children: headerMenuDefault53Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault5Default.default), {
                                    className: headerMenuDefault54Props.className,
                                    children: headerMenuDefault54Props.children
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "frame-2-39",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerMenuDefault6Default.default), {
                                        className: headerMenuDefault62Props.className,
                                        children: headerMenuDefault62Props.children
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    to: "/functional-view",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label-179 inter-medium-sonic-silver-18-1px",
                                        children: label2
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-87",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle2Props.className,
                                    buttonSecondaryProps: toggle2Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "utilisez-vous-une-erp subtitel",
                                    name: "utilisezvousuneerp",
                                    placeholder: inputPlaceholder1,
                                    type: inputType1
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1021Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "lisez subtitel",
                                    name: "utilisezvouscetteerppourpasserlescommandes",
                                    placeholder: inputPlaceholder2,
                                    type: inputType2
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1022Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "quel-canal-utilisez subtitel",
                                    name: "quelcanalutilisezvouspourcommuniquerdanslentreprise",
                                    placeholder: inputPlaceholder3,
                                    type: inputType3
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1023Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "x-24 subtitel",
                                    name: "*******************************************",
                                    placeholder: inputPlaceholder4,
                                    type: inputType4
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1024Props.line24
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "x-25 subtitel",
                                    name: "*******************************************",
                                    placeholder: inputPlaceholder5,
                                    type: inputType5
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1025Props.line24
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "frame-88",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                                    className: toggle3Props.className,
                                    buttonSecondaryProps: toggle3Props.buttonSecondaryProps
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "utilisez-vous-des-robots subtitel",
                                    name: "utilisezvousdesrobots",
                                    placeholder: inputPlaceholder6,
                                    type: inputType6
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1026Props.line24,
                                    className: group1026Props.className
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "lisez subtitel",
                                    name: "utilisezdesrpa",
                                    placeholder: inputPlaceholder7,
                                    type: inputType7
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1027Props.line24,
                                    className: group1027Props.className
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "lisez subtitel",
                                    name: "mod\xe9lisezvousvosprocessus3dpourunemeilleurevisibilit\xe9",
                                    placeholder: inputPlaceholder8,
                                    type: inputType8
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1028Props.line24,
                                    className: group1028Props.className
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "x-26 subtitel",
                                    name: "***********************************************",
                                    placeholder: inputPlaceholder9,
                                    type: inputType9
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group1029Props.line24,
                                    className: group1029Props.className
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    className: "x-27 subtitel",
                                    name: "*************************************",
                                    placeholder: inputPlaceholder10,
                                    type: inputType10
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _group102Default.default), {
                                    line24: group10210Props.line24,
                                    className: group10210Props.className
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleDefault.default), {
                    className: toggle4Props.className,
                    buttonSecondaryProps: toggle4Props.buttonSecondaryProps
                })
            ]
        })
    });
}
exports.default = Modernization;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"5fzqq","../Avatars":"9C0f6","../Toggle":"8ZCQM","../HeaderMenuDefault6":"crtNp","../HeaderMenuDefault5":"7ZKma","../HeaderMenuDefault":"9P7JS","../HeaderMenuDefault7":"iL2Al","../Group102":"3ieGn","./Modernization.css":"ghUIT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9C0f6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _avatarsCss = require("./Avatars.css");
function Avatars(props) {
    const { ellipse83, ellipse81 } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "avatars",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overlap-group-94",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "mask-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "ellipse-83",
                            src: ellipse83,
                            alt: "Ellipse 83"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "ellipse-81",
                            src: ellipse81,
                            alt: "Ellipse 81"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "ellipse-82"
                })
            ]
        })
    });
}
exports.default = Avatars;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Avatars.css":"bfsTg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bfsTg":[function() {},{}],"ghUIT":[function() {},{}],"jvLqO":[function(require,module,exports,__globalThis) {
// src/Login.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loginCss = require("./Login.css");
var _reactRouterDom = require("react-router-dom");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
// this function serves both for registration and login
function Login() {
    const [username, setUsername] = (0, _react.useState)('');
    const [password, setPassword] = (0, _react.useState)('');
    const history = (0, _reactRouterDom.useHistory)();
    const handleLogin = async (e)=>{
        e.preventDefault();
        try {
            // esending data to server
            await (0, _axiosDefault.default).post("https://api.scgreenoptimizer.fr/login", {
                username: username,
                password: password
            });
            // redirecting users to home page
            history.push('/home');
        } catch (error) {
            alert('Mot de passe ou utilisateur incorrect', error);
        }
    };
    const handleRegister = async (e)=>{
        e.preventDefault();
        try {
            // sending data to server
            await (0, _axiosDefault.default).post('process.env.API_URL/register', {
                username: username,
                password: password
            });
            //redirecting registered users to home page 
            history.push('/home');
            //alert message to registered users
            alert("Utilisateur connect\xe9");
        } catch (error) {
            alert(' Echec d \'enregistrement ', error);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "form-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Login Portal "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "username",
                                    children: "Username:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    id: "username",
                                    value: username,
                                    onChange: (e)=>setUsername(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "password",
                                    children: "Password:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "password",
                                    id: "password",
                                    value: password,
                                    onChange: (e)=>setPassword(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: handleLogin,
                            className: "login-button",
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            onClick: handleRegister,
                            className: "register-button",
                            children: "Register"
                        })
                    ]
                })
            ]
        })
    });
}
exports.default = Login;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Login.css":"lv9Nu","react-router-dom":"5fzqq","axios":"gqqlV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lv9Nu":[function() {},{}],"gqqlV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"bpQHr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpQHr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"j4U5Z","./helpers/bind.js":"lsHw8","./core/Axios.js":"gSzLM","./core/mergeConfig.js":"hBFgb","./defaults/index.js":"5ajHU","./helpers/formDataToJSON.js":"lvQ77","./cancel/CanceledError.js":"2SXaM","./cancel/CancelToken.js":"d4MXP","./cancel/isCancel.js":"kQA2M","./env/data.js":"dV7xS","./helpers/toFormData.js":"SFWXV","./core/AxiosError.js":"e7UnU","./helpers/spread.js":"jQT5B","./helpers/isAxiosError.js":"2EXuU","./core/AxiosHeaders.js":"kmeTN","./adapters/adapters.js":"lFvV1","./helpers/HttpStatusCode.js":"8j5L4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j4U5Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
var process = require("a8d2c3349c87a903");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== 'object') return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const ALPHA = 'abcdefghijklmnopqrstuvwxyz';
const DIGIT = '0123456789';
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = '';
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest('AsyncFunction');
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const _setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        _global.addEventListener("message", ({ source, data })=>{
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            _global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : typeof process !== 'undefined' && process.nextTick || _setImmediate;
// *********************
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap
};

},{"a8d2c3349c87a903":"5QIF0","./helpers/bind.js":"lsHw8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QIF0":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"lsHw8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSzLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        (0, _validatorJsDefault.default).assertOptions(config, {
            baseUrl: validators.spelling('baseURL'),
            withXsrfToken: validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"j4U5Z","../helpers/buildURL.js":"hOGC1","./InterceptorManager.js":"g8bpG","./dispatchRequest.js":"98TLw","./mergeConfig.js":"hBFgb","./buildFullPath.js":"6MlRA","../helpers/validator.js":"ky4Bn","./AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hOGC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    if ((0, _utilsJsDefault.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"j4U5Z","../helpers/AxiosURLSearchParams.js":"9zMgc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zMgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"SFWXV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"SFWXV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"l5Twm","../utils.js":"j4U5Z","../core/AxiosError.js":"e7UnU","../platform/node/classes/FormData.js":"jlmg9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l5Twm":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6ifNR":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"e7UnU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlmg9":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8bpG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98TLw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"74rSt","../cancel/isCancel.js":"kQA2M","../defaults/index.js":"5ajHU","../cancel/CanceledError.js":"2SXaM","../core/AxiosHeaders.js":"kmeTN","../adapters/adapters.js":"lFvV1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74rSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"j4U5Z","../defaults/index.js":"5ajHU","../core/AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ajHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"j4U5Z","../core/AxiosError.js":"e7UnU","./transitional.js":"1sSt7","../helpers/toFormData.js":"SFWXV","../helpers/toURLEncodedForm.js":"f1oER","../platform/index.js":"Y0LSh","../helpers/formDataToJSON.js":"lvQ77","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1sSt7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f1oER":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"j4U5Z","./toFormData.js":"SFWXV","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Y0LSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"haxDI","./common/utils.js":"9bQaq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haxDI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"8vuBk","./classes/FormData.js":"bzfcl","./classes/Blob.js":"kfCzj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vuBk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"9zMgc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzfcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfCzj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9bQaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
parcelHelpers.export(exports, "navigator", ()=>_navigator);
parcelHelpers.export(exports, "origin", ()=>origin);
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvQ77":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kmeTN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
'use strict';
const $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"j4U5Z","../helpers/parseHeaders.js":"g7ZuC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g7ZuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQA2M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SXaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"e7UnU","../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lFvV1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _fetchJsDefault = parcelHelpers.interopDefault(_fetchJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: (0, _fetchJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"j4U5Z","./http.js":"jlmg9","./xhr.js":"hVrwR","./fetch.js":"ax7V6","../core/AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVrwR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, _resolveConfigJsDefault.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, _progressEventReducerJs.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"j4U5Z","./../core/settle.js":"jaZcJ","../defaults/transitional.js":"1sSt7","../core/AxiosError.js":"e7UnU","../cancel/CanceledError.js":"2SXaM","../helpers/parseProtocol.js":"lrlmI","../platform/index.js":"Y0LSh","../core/AxiosHeaders.js":"kmeTN","../helpers/progressEventReducer.js":"4sKYJ","../helpers/resolveConfig.js":"7sxHl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jaZcJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrlmI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
'use strict';
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4sKYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", ()=>progressEventReducer);
parcelHelpers.export(exports, "progressEventDecorator", ()=>progressEventDecorator);
parcelHelpers.export(exports, "asyncDecorator", ()=>asyncDecorator);
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable,
                total,
                loaded
            }),
        throttled[1]
    ];
};
const asyncDecorator = (fn)=>(...args)=>(0, _utilsJsDefault.default).asap(()=>fn(...args));

},{"./speedometer.js":"jDdfD","./throttle.js":"sQjz8","../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDdfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sQjz8":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7sxHl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
exports.default = (config)=>{
    const newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

},{"../platform/index.js":"Y0LSh","../utils.js":"j4U5Z","./isURLSameOrigin.js":"3QStk","./cookies.js":"eD59s","../core/buildFullPath.js":"6MlRA","../core/mergeConfig.js":"hBFgb","../core/AxiosHeaders.js":"kmeTN","./buildURL.js":"hOGC1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3QStk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, _indexJsDefault.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, _indexJsDefault.default).origin), (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent)) : ()=>true;

},{"../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eD59s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push('path=' + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"j4U5Z","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6MlRA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
'use strict';
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"02G4G","../helpers/combineURLs.js":"6BOaY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"02G4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6BOaY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
'use strict';
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBFgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"j4U5Z","./AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ax7V6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const supportsRequestStream = isReadableStreamSupported && test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, _indexJsDefault.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 65536;
const supportsResponseStream = isReadableStreamSupported && test(()=>(0, _utilsJsDefault.default).isReadableStream(new Response('').body));
const resolvers = {
    stream: supportsResponseStream && ((res)=>res.body)
};
isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !resolvers[type] && (resolvers[type] = (0, _utilsJsDefault.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, _axiosErrorJsDefault.default)(`Response type '${type}' is not supported`, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, _utilsJsDefault.default).isBlob(body)) return body.size;
    if ((0, _utilsJsDefault.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, _indexJsDefault.default).origin, {
            method: 'POST',
            body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
    if ((0, _utilsJsDefault.default).isString(body)) return (await encodeText(body)).byteLength;
};
const resolveBodyLength = async (headers, body)=>{
    const length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
    return length == null ? getBodyLength(body) : length;
};
exports.default = isFetchSupported && (async (config)=>{
    let { url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, withCredentials = 'same-origin', fetchOptions } = (0, _resolveConfigJsDefault.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, _composeSignalsJsDefault.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress)));
                data = (0, _trackStreamJs.trackStream)(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, _settleJsDefault.default)(resolve, reject, {
                data: responseData,
                headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config,
                request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request);
    }
});

},{"../platform/index.js":"Y0LSh","../utils.js":"j4U5Z","../core/AxiosError.js":"e7UnU","../helpers/composeSignals.js":"g789g","../helpers/trackStream.js":"hefss","../core/AxiosHeaders.js":"kmeTN","../helpers/progressEventReducer.js":"4sKYJ","../helpers/resolveConfig.js":"7sxHl","../core/settle.js":"jaZcJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g789g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const composeSignals = (signals, timeout)=>{
    const { length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, _axiosErrorJsDefault.default)(`timeout ${timeout} of ms exceeded`, (0, _axiosErrorJsDefault.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal } = controller;
        signal.unsubscribe = ()=>(0, _utilsJsDefault.default).asap(unsubscribe);
        return signal;
    }
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"2SXaM","../core/AxiosError.js":"e7UnU","../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hefss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", ()=>streamChunk);
parcelHelpers.export(exports, "readBytes", ()=>readBytes);
parcelHelpers.export(exports, "trackStream", ()=>trackStream);
const streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of readStream(iterable))yield* streamChunk(chunk, chunkSize);
};
const readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done, value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done, value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ky4Bn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
const validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"dV7xS","../core/AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dV7xS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.7.9";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d4MXP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"2SXaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jQT5B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2EXuU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8j5L4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dw0u4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _analysisCss = require("./Analysis.css"); // Import the corresponding CSS file
function BeautifulPage() {
    const [result, setResult] = (0, _react.useState)(null);
    function inference() {
        fetch("https://api.scgreenoptimizer.fr/inferences", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response)=>{
            if (!response.ok) throw new Error("Error performing inferences");
            return response.json();
        }).then((data)=>{
            console.log("Response from server:", data);
            setResult(data);
            alert("Successful Analysis");
        }).catch((error)=>{
            console.error(error);
        // Handle error
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "beautifulpage",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "navbar",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", {
                    className: "nav_links",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: "",
                                alt: "logo"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "#",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "#",
                                children: "Analysis"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "button",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    type: "submit",
                    onClick: inference,
                    children: [
                        " ",
                        "Results"
                    ]
                })
            }),
            result && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "body",
                children: result.reduce((acc, item)=>{
                    const documentIndex = item.DocumentIndex;
                    // const doc_name = item.doc_name;
                    const existingItem = acc.find((groupedItem)=>groupedItem.documentIndex === documentIndex);
                    if (existingItem) existingItem.results.push(item);
                    else acc.push({
                        documentIndex,
                        results: [
                            item
                        ]
                    });
                    return acc;
                }, []).map((group, groupIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "result-box",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                children: [
                                    "Document ",
                                    group.documentIndex + 1,
                                    " ",
                                    group.doc_name,
                                    " Results"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "scrollable-container",
                                children: group.results.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "result-item",
                                        children: [
                                            item.Element && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            "Analysis: ",
                                                            item.Analysis
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        children: [
                                                            "Element Info: Row ",
                                                            item.Element.row,
                                                            ", Column",
                                                            " ",
                                                            item.Element.column,
                                                            ", Heading",
                                                            " ",
                                                            item.Element.heading
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                                ]
                                            }),
                                            !item.Element && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                children: item.Analysis
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }, groupIndex))
            })
        ]
    });
}
exports.default = BeautifulPage;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Analysis.css":"iKrUf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iKrUf":[function() {},{}]},["yVOyt","g0GKl"], "g0GKl", "parcelRequire94c2")

//# sourceMappingURL=index.497a8f84.js.map
